import { SeshatCssClass, BlockTypes, urlMediaParser, uuidV1Interface, isYoutubeUrl, addQueryToYoutubeUrl, BlockAttrsParams, isTweetUrl, getYoutubeVideoThumbnail, CardClipStatus, getFaviconUrl, NodeViewTypes, generateRandomId, MarkTypes, SeshatNodeGroups, SeshatNodes, isUrlOfType, LAUNCHER_EDITOR_ID, keyboardEventToString, MarkAttrsParams, debounce, debug } from "@lazy-app/common";
import * as React from "react";
import React__default, { useRef, useEffect, useState, useCallback, useMemo, useLayoutEffect, forwardRef, useImperativeHandle } from "react";
import { styled, Popover, Autocomplete, TextField, ListItemButton, Box, Button, Typography, alpha, css, IconButton, Tabs, Tab, Tooltip as Tooltip$1, Menu, MenuItem, ListItemIcon, ListItemText, Skeleton, CircularProgress, Paper, ToggleButton, ToggleButtonGroup, List, Divider, ButtonGroup, createFilterOptions, ClickAwayListener, GlobalStyles } from "@mui/material";
import { Icon, Icons, Tooltip, Key, Avatar, EmojiPanel as EmojiPanel$1, Shortcut, theme, searchEmojis } from "@lazy-app/design-system";
import { codeBlockLanguages, SESHAT_SESSION_STORAGE_PREFIX, isSupportedCodeBlockLanguage, plainTextLanguage, PreviewFile, FileBlock, IFrameBlock, BLOCK_LINE_MAX_COLUMNS, ClipboardDOMSerializer, ClipboardTextSerializer, isEmptyHighlightsBlock, SESHAT_CONTENT_DEPTH, syncHighlightsBlocksAfterClipModificationTransaction, createJSONContentFromHTML, isLauncherEditor, IgnoreContentEditableFalse, clipObserverPluginKey, getSeshatBlockByBlockId, getConnectedHighlightsBlockByClipId, getCurrentBlock, getHighlightsFromClipContent, getHighlightsFromAttrs, isEmptyClip, getCardUuid, BlockSelection, getAsinUrl, ClipBookBlock, ClipBookmarkBlock, getHeadingForTableOfContents, TableOfContentsBlock, CardLinkBlock, seshatBlockAttributes, SeshatBlockGroup, SeshatBlockNodeConfig, SeshatWrappingBlockNodeConfig, ParagraphBlockConfig, BulletBlockConfig, NumberedBlockConfig, TaskBlockConfig, QuoteBlockConfig, CodeBlockConfig, DividerBlockConfig, EmbedBlockConfig, TableOfContentBlockConfig, AddNoteConfig, HighlightsConfig, ConnectionConfig, ClipBlockConfig, HeadingBlockConfig, FileBlockConfig, GroupColors, GroupHighlightColors, isBlockSelection, SelectionBoxSelector, EDITOR_CONTENT_DOM_ID, isCaretInEmptyClip, isCardTitleNode, FontColorExtension, shortcutConfig, MentionNode, PREVENT_EDITOR_INPUT_PLUGIN, ANALYTICS_META, MentionPlaceholderNodes, getLinkAttributes, getFromNToFromRange as getFromNToFromRange$1, isRangeTextSelected, getPluginStateValue, LinkMark, isHighlightMark, HighlightMark, YELLOW, editorNodeConfig as editorNodeConfig$1, SeshatBlockNode, SeshatWrappingBlockNode, editorMarkConfig as editorMarkConfig$1, editorExtensionConfig as editorExtensionConfig$1, getEditorExtensions, formatContentCorruptContent, getEditorApi } from "@lazy-app/seshat";
import { NodeViewWrapper, ReactNodeViewRenderer, NodeViewContent, getMarkAttributes, isNodeSelection, posToDOMRect, Extension, findChildren as findChildren$1, useEditor, EditorContent } from "@tiptap/react";
import Tippy from "@tippyjs/react";
import { styled as styled$1, alpha as alpha$1 } from "@mui/system";
import { Node, Fragment, Slice } from "prosemirror-model";
import { Timestamp, useHover } from "@lazy-app/shared-components";
import _ from "lodash";
import { findChildren, Extension as Extension$1 } from "@tiptap/core";
import { useHotkeys } from "reakeys";
import { flushSync } from "react-dom";
import { PluginKey, TextSelection, Plugin, NodeSelection } from "prosemirror-state";
import tippy from "tippy.js";
import Box$1 from "@mui/material/Box";
import Suggestion$1, { Suggestion as Suggestion$2 } from "@tiptap/suggestion";
import Typography$1 from "@mui/material/Typography";
import SimpleBar from "simplebar-react";
import { DecorationSet, Decoration } from "prosemirror-view";
import { find } from "linkifyjs";
const StyledPlaceholder = styled("div")(() => ({
  top: "100%",
  padding: "2px 4px 5px",
  zIndex: 1,
  marginTop: "8px",
  fontSize: "14px",
  flex: 1,
  color: "#b8b8b8",
  borderTop: "1px solid #393b3f",
  borderBottom: "1px solid #393b3f",
  span: {
    opacity: 0.4
  },
  code: {
    borderRadius: "2px",
    padding: "0.15em",
    fontFamily: "Menlo",
    fontSize: "12px",
    color: "rgb(253,220,152)",
    background: "rgb(72,69,78)"
  }
}));
const WrappingBlockPlaceholderContainer = (props) => {
  return /* @__PURE__ */ React__default.createElement(StyledPlaceholder, {
    className: "block_placeholder",
    contentEditable: false
  }, props.children);
};
const Blockquote = ({ node }) => {
  if (node.childCount !== 0)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  return /* @__PURE__ */ React__default.createElement(WrappingBlockPlaceholderContainer, null, "This blockquote is empty.");
};
const CodeBlockPopover = ({
  open,
  onChange,
  id,
  anchorEl,
  onClose,
  language
}) => {
  const inputPopper = useRef();
  const transitionDuration = 0;
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        var _a;
        (_a = inputPopper.current) == null ? void 0 : _a.select();
      }, transitionDuration);
    }
  }, [open, inputPopper]);
  return /* @__PURE__ */ React__default.createElement(Popover, {
    id,
    open,
    anchorEl,
    onClose,
    transitionDuration,
    PaperProps: { variant: "editor" }
  }, /* @__PURE__ */ React__default.createElement(Autocomplete, {
    id: "language-picker",
    sx: {
      width: 150,
      "& input:before, & input:after": { display: "none" },
      ".MuiFilledInput-root": {
        pt: 0,
        background: "none",
        "&:before, &:after": { display: "none" }
      }
    },
    value: language,
    options: codeBlockLanguages,
    disableClearable: true,
    autoSelect: true,
    autoHighlight: true,
    blurOnSelect: true,
    openOnFocus: true,
    popupIcon: /* @__PURE__ */ React__default.createElement(Icon, {
      icon: Icons.CHEVRON_DOWN
    }),
    onChange,
    renderInput: (params) => /* @__PURE__ */ React__default.createElement(TextField, {
      ...params,
      variant: "filled",
      inputRef: (input) => {
        inputPopper.current = input;
      }
    }),
    renderOption: (props, value) => /* @__PURE__ */ React__default.createElement(ListItemButton, {
      component: "li",
      ...props,
      key: value,
      variant: "menu"
    }, value)
  }));
};
const useLanguagePopoverHandlers = ({
  setSelectionPos,
  editor
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = useCallback(
    (event) => {
      setSelectionPos(editor.state.selection.from);
      setAnchorEl(anchorEl ? null : event.currentTarget);
    },
    [anchorEl, editor.state.selection.from, setSelectionPos]
  );
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const open = Boolean(anchorEl);
  const id = open ? "language-popper" : void 0;
  return {
    handleClick,
    handleClose,
    id,
    open,
    anchorEl
  };
};
const useResetUnknownLanguageOnMount = ({
  language,
  updateAttrs
}) => {
  useEffect(() => {
    if (language && !codeBlockLanguages.includes(language)) {
      updateAttrs({ language: void 0 });
    }
  }, []);
};
const makeSessionStorageInterface = () => ({
  get: (key) => {
    const value = sessionStorage.getItem(SESHAT_SESSION_STORAGE_PREFIX + key);
    try {
      if (!value)
        return void 0;
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
  set: (key, value) => {
    const wholeKey = SESHAT_SESSION_STORAGE_PREFIX + key;
    if (typeof value === "object") {
      sessionStorage.setItem(wholeKey, JSON.stringify(value));
    } else {
      sessionStorage.setItem(wholeKey, value);
    }
  }
});
const SessionStorageInterface = {
  ...makeSessionStorageInterface()
};
const useRestorePreviousLanguageOnMount = ({
  language,
  updateAttrs
}) => {
  useEffect(() => {
    const previousLanguageSet = SessionStorageInterface.get(
      "lastUsedCodeBlockLanguage"
    );
    if (!language && previousLanguageSet) {
      updateAttrs({ language: previousLanguageSet });
    }
  }, []);
};
const useStoreLanguageOnChange = ({
  language
}) => {
  useEffect(() => {
    if (language && isSupportedCodeBlockLanguage(language)) {
      SessionStorageInterface.set("lastUsedCodeBlockLanguage", language);
    }
  }, [language]);
};
const CodeBlock = ({
  updateAttributes: updateAttrs,
  node: {
    attrs: { language: languageAttrs }
  },
  editor
}) => {
  const [prevSelectionPos, setSelectionPos] = useState();
  useResetUnknownLanguageOnMount({ language: languageAttrs, updateAttrs });
  useRestorePreviousLanguageOnMount({ language: languageAttrs, updateAttrs });
  useStoreLanguageOnChange({ language: languageAttrs });
  const {
    handleClick,
    handleClose,
    id,
    open,
    anchorEl
  } = useLanguagePopoverHandlers({
    editor,
    setSelectionPos
  });
  const language = languageAttrs || plainTextLanguage;
  const onChange = useCallback(
    (_2, newValue) => {
      updateAttrs({
        language: newValue === plainTextLanguage ? void 0 : newValue
      });
      if (prevSelectionPos) {
        editor == null ? void 0 : editor.chain().focus().setTextSelection(prevSelectionPos).run();
      }
      handleClose();
    },
    [updateAttrs, editor, prevSelectionPos, handleClose]
  );
  return /* @__PURE__ */ React__default.createElement(Box, {
    contentEditable: false
  }, /* @__PURE__ */ React__default.createElement(Button, {
    sx: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      mb: 1
    },
    size: "small",
    color: "inherit",
    "aria-describedby": id,
    onClick: handleClick
  }, /* @__PURE__ */ React__default.createElement(Box, null, language), /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CHEVRON_DOWN
  })), /* @__PURE__ */ React__default.createElement(CodeBlockPopover, {
    id,
    language,
    open,
    onChange,
    anchorEl,
    onClose: handleClose
  }));
};
const sxCodeBlock = {
  [`& .${SeshatCssClass.BLOCK}[type="${BlockTypes.CODE}"]`]: {
    "pre code.hljs": { display: "block", overflowX: "auto", padding: "1em" },
    "code.hljs": { padding: "3px 5px" },
    ".hljs": { color: "#c9d1d9", background: "#0d1117" },
    ".hljs-doctag,.hljs-keyword,.hljs-meta .hljs-keyword,.hljs-template-tag,.hljs-template-variable,.hljs-type,.hljs-variable.language_": {
      color: "#ff7b72"
    },
    ".hljs-title,.hljs-title.class_,.hljs-title.class_.inherited__,.hljs-title.function_": {
      color: "#d2a8ff"
    },
    ".hljs-attr,.hljs-attribute,.hljs-literal,.hljs-meta,.hljs-number,.hljs-operator,.hljs-selector-attr,.hljs-selector-class,.hljs-selector-id,.hljs-variable": {
      color: "#79c0ff"
    },
    ".hljs-meta .hljs-string,.hljs-regexp,.hljs-string": { color: "#a5d6ff" },
    ".hljs-built_in,.hljs-symbol": { color: "#ffa657" },
    ".hljs-code,.hljs-comment,.hljs-formula": { color: "#8b949e" },
    ".hljs-name,.hljs-quote,.hljs-selector-pseudo,.hljs-selector-tag": {
      color: "#7ee787"
    },
    ".hljs-subst": { color: "#c9d1d9" },
    ".hljs-section": { color: "#1f6feb", fontWeight: 700 },
    ".hljs-bullet": { color: "#f2cc60" },
    ".hljs-emphasis": { color: "#c9d1d9", fontStyle: "italic" },
    ".hljs-strong": { color: "#c9d1d9", fontWeight: 700 },
    ".hljs-addition": { color: "#aff5b4", backgroundColor: "#033a16" }
  }
};
const FileRenderer = (props) => {
  const { fileUuid, previewType } = props.node.attrs;
  if (!fileUuid)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  const options2 = props.extension.options;
  const Comp = options2.stateManager;
  if (!Comp)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  const menuOptions = [
    {
      title: "Download",
      onClick: () => {
        var _a;
        (_a = options2.onDownloadFile) == null ? void 0 : _a.call(options2, fileUuid);
      }
    },
    {
      title: "Delete",
      onClick: () => {
        const pos = props.getPos();
        if (pos)
          props.editor.chain().setNodeSelection(pos).deleteBlock().run();
      }
    }
  ];
  return /* @__PURE__ */ React__default.createElement("div", null, props.node.attrs.fileUuid ? /* @__PURE__ */ React__default.createElement(Box, {
    onClick: () => {
      if (props.getPos())
        props.editor.chain().selectCurrentBlock().run();
    }
  }, /* @__PURE__ */ React__default.createElement(Comp, {
    fileUuid,
    previewType,
    menuOptions
  })) : /* @__PURE__ */ React__default.createElement("div", {
    contentEditable: false
  }, "Error"));
};
const getTippyInstance = (element) => {
  return element == null ? void 0 : element._tippy;
};
const useTippyHandler = ({
  containerRef
}) => {
  const popOverInstance = React__default.useCallback(() => {
    if (containerRef == null ? void 0 : containerRef.current) {
      return getTippyInstance(containerRef.current);
    }
    return void 0;
  }, [containerRef]);
  const closePopOver = React__default.useCallback(() => {
    var _a;
    (_a = popOverInstance()) == null ? void 0 : _a.hide();
  }, [popOverInstance]);
  const showPopOver = React__default.useCallback(() => {
    var _a;
    (_a = popOverInstance()) == null ? void 0 : _a.show();
  }, [popOverInstance]);
  const togglePopOver = React__default.useCallback(() => {
    var _a, _b;
    if ((_b = (_a = popOverInstance()) == null ? void 0 : _a.state) == null ? void 0 : _b.isVisible)
      closePopOver();
    else
      showPopOver();
  }, [closePopOver, popOverInstance, showPopOver]);
  return { closePopOver, showPopOver, togglePopOver };
};
const usePopover = () => {
  const ref = React__default.useRef();
  const popOverInterface = useTippyHandler({ containerRef: ref });
  return { ref, ...popOverInterface };
};
var useAvoidFocusOnEvent = () => {
  const avoidFocusOnEvent = React__default.useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
    },
    []
  );
  return { avoidFocusOnEvent };
};
const PopOver = styled$1("div")((prop) => ({
  maxHeight: prop.height ? prop.height : "min-content",
  fontSize: "16px",
  color: "rgba(255, 255, 255, 0.9)",
  borderRadius: prop.theme.shape.borderRadius + 4,
  background: "rgba(28, 29, 33, 0.72)",
  backdropFilter: "blur(10px)",
  border: "0.5px solid rgba(255, 255, 255, 0.24)",
  width: "245px!important",
  boxShadow: "0px 1px 18px #0000001f, 0px 6px 10px #00000024, 0px 3px 5px -1px #00000033",
  position: "relative",
  height: prop.height ? prop.height : "260px",
  ".popover-container": {
    boxSizing: "border-box",
    width: "100%",
    height: "240px",
    position: "absolute",
    top: 0,
    left: 0,
    ".simplebar-content > div": {
      padding: "0 8px"
    },
    "> div": {
      textAlign: "center",
      paddingTop: "8px",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      "p.button": {
        borderRadius: "2px",
        backgroundColor: prop.theme.palette.primary.main
      }
    }
  },
  "::-webkit-scrollbar": {
    display: "none"
  }
}));
const PopOverContainer = React__default.forwardRef(
  ({ children, height, ...props }, ref) => {
    return /* @__PURE__ */ React__default.createElement(PopOver, {
      ref,
      height,
      className: "popover",
      ...props
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "popover-container"
    }, children));
  }
);
const Content$1 = styled("div")`
  user-select: none;
`;
const WrapperFilePopOverContent = (Comp) => (props) => {
  return /* @__PURE__ */ React__default.createElement(FilePopOverContent, null, /* @__PURE__ */ React__default.createElement(Comp, {
    ...props
  }));
};
const FilePopOverContent = ({
  children
}) => {
  return /* @__PURE__ */ React__default.createElement(PopOverContainer, {
    height: 38
  }, /* @__PURE__ */ React__default.createElement(Content$1, null, children));
};
var FileInput = ({
  onChange
}) => {
  return /* @__PURE__ */ React__default.createElement(Box, {
    sx: { display: "flex", alignItems: "center", justifyContent: "center" }
  }, /* @__PURE__ */ React__default.createElement(Button, {
    component: "label",
    htmlFor: "file",
    color: "inherit",
    size: "small",
    sx: { py: 0 }
  }, "Choose a file ..."), /* @__PURE__ */ React__default.createElement("input", {
    type: "file",
    id: "file",
    hidden: true,
    onChange: (e) => onChange(e)
  }));
};
const FilePlaceholder = {
  content: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "You can upload a file"),
  popOver: ({ updateAttributes, onUpload }) => {
    const onChange = (e) => {
      var _a, _b;
      const file = (_b = (_a = e == null ? void 0 : e.target) == null ? void 0 : _a.files) == null ? void 0 : _b[0];
      if (file)
        onUpload == null ? void 0 : onUpload({ file, previewType: PreviewFile.FILE }).then((f) => {
          if (f)
            updateAttributes(f);
        });
    };
    return /* @__PURE__ */ React__default.createElement(FileInput, {
      onChange: (e) => onChange(e)
    });
  }
};
const ImagePlaceholder = {
  content: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "You can upload an image"),
  popOver: ({ onUpload, updateAttributes }) => {
    const onChange = (e) => {
      var _a, _b;
      const file = (_b = (_a = e == null ? void 0 : e.target) == null ? void 0 : _a.files) == null ? void 0 : _b[0];
      if (file && file.type.startsWith("image")) {
        onUpload == null ? void 0 : onUpload({ file, previewType: PreviewFile.IMAGE }).then((f) => {
          if (f)
            updateAttributes(f);
        });
      }
    };
    return /* @__PURE__ */ React__default.createElement(FileInput, {
      onChange: (e) => onChange(e)
    });
  }
};
const PdfPlaceholder = {
  content: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "You can upload your PDF"),
  popOver: ({ updateAttributes, onUpload }) => {
    const onChange = (e) => {
      var _a, _b;
      const file = (_b = (_a = e == null ? void 0 : e.target) == null ? void 0 : _a.files) == null ? void 0 : _b[0];
      if (file && file.type === "application/pdf") {
        onUpload == null ? void 0 : onUpload({ file, previewType: PreviewFile.PDF }).then((f) => {
          if (f)
            updateAttributes(f);
        });
      }
    };
    return /* @__PURE__ */ React__default.createElement(FileInput, {
      onChange: (e) => onChange(e)
    });
  }
};
const PlaceholderConfiguration = {
  [PreviewFile.FILE]: FilePlaceholder,
  [PreviewFile.IMAGE]: ImagePlaceholder,
  [PreviewFile.PDF]: PdfPlaceholder
};
const styleBox$1 = {
  padding: "12px 36px 12px 12px",
  margin: 0.25,
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  width: "calc(100% - 4px)",
  overflow: "hidden",
  borderRadius: "4px",
  bgcolor: "grey.500",
  cursor: "pointer",
  userSelect: "none",
  "& .MuiTypography-root": {
    color: "text.secondary"
  }
};
const Placeholder$2 = (props) => {
  const { ref } = usePopover();
  const { avoidFocusOnEvent } = useAvoidFocusOnEvent();
  const previewType = props.node.attrs.previewType;
  const PlaceholderPreview = PlaceholderConfiguration[previewType] || PlaceholderConfiguration[PreviewFile.FILE];
  const popOverContent = React__default.useMemo(() => {
    const Comp = WrapperFilePopOverContent(PlaceholderPreview.popOver);
    return /* @__PURE__ */ React__default.createElement(Comp, {
      onUpload: props.extension.options.onUpload,
      updateAttributes: props.updateAttributes
    });
  }, [
    PlaceholderPreview == null ? void 0 : PlaceholderPreview.popOver,
    props.extension.options.onUpload,
    props.updateAttributes
  ]);
  const onClickOutside = React__default.useCallback(
    (instance, e) => {
      avoidFocusOnEvent(e);
      instance.hide();
    },
    [avoidFocusOnEvent]
  );
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Tippy, {
    onClickOutside,
    interactive: true,
    content: popOverContent,
    ref,
    trigger: "click",
    hideOnClick: "toggle",
    placement: "bottom"
  }, /* @__PURE__ */ React__default.createElement(Box, {
    sx: styleBox$1,
    contentEditable: false
  }, /* @__PURE__ */ React__default.createElement(Typography, null, PlaceholderPreview == null ? void 0 : PlaceholderPreview.content, " ")))));
};
const WrapperFileRenderer = (props) => {
  var _a;
  const shouldRenderFile = Boolean((_a = props.node.attrs) == null ? void 0 : _a.fileUuid);
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, shouldRenderFile ? /* @__PURE__ */ React__default.createElement(FileRenderer, {
    ...props
  }) : /* @__PURE__ */ React__default.createElement(Placeholder$2, {
    ...props
  }));
};
const ExtendedFileBlock = (options2) => FileBlock(options2).extend({
  addNodeView() {
    return ReactNodeViewRenderer(WrapperFileRenderer);
  }
});
const IFramePopOverContent = ({
  updateIframeSrc
}) => {
  const [url, setUrl] = useState("");
  const updateIframe = useCallback(() => {
    if (url)
      updateIframeSrc(url);
  }, [url, updateIframeSrc]);
  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter")
        updateIframe();
    },
    [updateIframe]
  );
  return /* @__PURE__ */ React__default.createElement(Box, {
    sx: {
      position: "relative",
      display: "flex",
      p: "4px",
      borderRadius: "8px",
      backdropFilter: `blur(10px)`,
      background: ({ palette }) => alpha(palette.background.default, 0.7)
    }
  }, /* @__PURE__ */ React__default.createElement(TextField, {
    type: "url",
    value: url,
    onChange: ({ target }) => setUrl(target.value),
    onKeyDown,
    placeholder: "Insert HTTPS Link",
    sx: {
      ".MuiOutlinedInput-root": {
        ".MuiOutlinedInput-input": {
          color: "text.primary",
          height: "28px",
          border: ({ palette }) => `0.5px solid ${palette.grey["300"]}`,
          borderRightWidth: 0,
          borderTopLeftRadius: "4px",
          borderBottomLeftRadius: "4px",
          px: "5px",
          py: "2px"
        },
        "&.Mui-focusVisible, &.Mui-focused fieldset, &:hover fieldset, & fieldset": {
          outline: "none",
          border: ({ palette }) => `0.5px solid ${palette.grey["300"]}`,
          borderRightWidth: 0,
          borderTopLeftRadius: "4px",
          borderBottomLeftRadius: "4px"
        }
      }
    }
  }), /* @__PURE__ */ React__default.createElement(ListItemButton, {
    onClick: updateIframe,
    sx: {
      fontSize: "12px",
      lineHeight: "18px",
      color: "grey.200",
      px: 1,
      py: 0,
      minHeight: 28,
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
      border: ({ palette }) => `0.5px solid ${palette.grey["300"]}`,
      bgcolor: ({ palette }) => alpha(palette.background.default, 0.4),
      "&:hover, &.Mui-focusVisible": {
        color: "white",
        border: ({ palette }) => `0.5px solid ${palette.grey["300"]}`,
        filter: "brightness(101%)"
      }
    }
  }, /* @__PURE__ */ React__default.createElement(Typography, null, "Embed")));
};
const styleBox = {
  padding: "12px 36px 12px 12px",
  margin: 0.25,
  display: "flex",
  boxSizing: "border-box",
  alignItems: "center",
  textAlign: "left",
  width: "calc(100% - 4px)",
  overflow: "hidden",
  borderRadius: "4px",
  bgcolor: "grey.500",
  cursor: "pointer",
  userSelect: "none",
  "& .MuiTypography-root": {
    color: "text.secondary",
    span: { paddingLeft: "4px", opacity: 0.5 }
  }
};
const IFramePlaceholder = ({ updateAttributes }) => {
  const { ref } = usePopover();
  const { avoidFocusOnEvent } = useAvoidFocusOnEvent();
  const updateIframeSrc = useCallback(
    (url) => {
      var _a;
      const src = (_a = urlMediaParser(url)) != null ? _a : url;
      updateAttributes({ src });
    },
    [updateAttributes]
  );
  const popOverContent = useMemo(
    () => /* @__PURE__ */ React__default.createElement(IFramePopOverContent, {
      updateIframeSrc
    }),
    [updateIframeSrc]
  );
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Tippy, {
    onClickOutside: (instance, e) => {
      avoidFocusOnEvent(e);
      instance.hide();
    },
    interactive: true,
    content: popOverContent,
    ref,
    trigger: "click",
    hideOnClick: "toggle",
    placement: "bottom"
  }, /* @__PURE__ */ React__default.createElement(Box, {
    sx: styleBox,
    contentEditable: false
  }, /* @__PURE__ */ React__default.createElement(Typography, null, "Embed Web Content ", /* @__PURE__ */ React__default.createElement("span", null, "(YouTube, Spotify, Google Maps\u2026)"))))));
};
const Content = ({
  disabledThumbnail,
  selected,
  alt,
  ...props
}) => /* @__PURE__ */ React__default.createElement("div", {
  ...props
});
const IFrameWrapper = styled$1(Content)(
  (prop) => ({
    position: "relative",
    overflow: "hidden",
    minHeight: 300,
    display: "flex",
    border: prop.selected ? "2px rgba(114, 114, 115, .6) solid" : "0",
    ".thumbnail": {
      background: `url(${prop.alt})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: prop.disabledThumbnail === "true" ? "-1" : "1"
    },
    ".youtube_player": {
      position: "absolute",
      zIndex: "2",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    "&:hover .thumbnail": { zIndex: "-1" }
  })
);
const IFrame = styled$1("iframe")(() => ({
  width: "100%",
  minHeight: 300
}));
const IFrameRenderer = (props) => {
  var _a;
  const attrs = useMemo(() => {
    var _a2;
    return (_a2 = props == null ? void 0 : props.node) == null ? void 0 : _a2.attrs;
  }, [(_a = props == null ? void 0 : props.node) == null ? void 0 : _a.attrs]);
  const id = useMemo(() => uuidV1Interface(), []);
  const refIframe = useRef(null);
  const [disabledThumbnail, setDisabledThumbnail] = useState(false);
  const options2 = props.extension.options;
  const isReadLaterView = props.extensionVersion === "read_later_view";
  const shouldRenderIFrame = useMemo(() => (attrs == null ? void 0 : attrs.src) || (attrs == null ? void 0 : attrs.srcDoc), [
    attrs == null ? void 0 : attrs.src,
    attrs == null ? void 0 : attrs.srcDoc
  ]);
  const Render = useMemo(() => {
    return (options2 == null ? void 0 : options2.IFrameView) || IFrame;
  }, [options2 == null ? void 0 : options2.IFrameView]);
  useEffect(
    function initIframeFunctionality() {
      try {
        if (!YT || typeof YT === void 0 || !isYoutubeUrl((attrs == null ? void 0 : attrs.src) || (attrs == null ? void 0 : attrs.srcDoc) || "") || !refIframe.current)
          return;
        let player = new YT.get(refIframe.current.id);
        if (!player.getCurrentTime) {
          player = new YT.Player(refIframe.current);
        }
        refIframe.current.player = player;
        if (!player.addEventListener)
          return;
        const disabledThumbnail2 = (event) => {
          setDisabledThumbnail(event.data >= YT.PlayerState.ENDED);
        };
        player.addEventListener(
          "onStateChange",
          disabledThumbnail2
        );
        const togglePlayVideo = (e) => {
          if (e.code !== "Space" || !isReadLaterView)
            return;
          e.preventDefault();
          e.stopPropagation();
          if (player.getPlayerState() === YT.PlayerState.PLAYING) {
            setDisabledThumbnail(false);
            player.pauseVideo();
          } else {
            setDisabledThumbnail(true);
            player.playVideo();
          }
        };
        document.addEventListener("keydown", togglePlayVideo);
        return () => {
          document.removeEventListener("keydown", togglePlayVideo);
          if (!player.removeEventListener)
            return;
          player.removeEventListener(
            "onStateChange",
            disabledThumbnail2
          );
        };
      } catch {
        return;
      }
    },
    [attrs == null ? void 0 : attrs.src, attrs == null ? void 0 : attrs.srcDoc, isReadLaterView, refIframe]
  );
  if (shouldRenderIFrame)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(IFrameWrapper, {
      selected: props == null ? void 0 : props.selected,
      alt: attrs.alt,
      contentEditable: false,
      disabledThumbnail: disabledThumbnail.toString()
    }, attrs.alt && /* @__PURE__ */ React__default.createElement("div", {
      className: "thumbnail",
      contentEditable: false
    }, /* @__PURE__ */ React__default.createElement(Icon, {
      icon: Icons.YOUTUBE,
      className: "youtube_player",
      size: 70,
      color: "rgba(0, 0, 0, 0.4)"
    })), /* @__PURE__ */ React__default.createElement(Render, {
      ref: refIframe,
      id,
      contentEditable: false,
      ...attrs,
      src: addQueryToYoutubeUrl(`${(attrs == null ? void 0 : attrs.src) || (attrs == null ? void 0 : attrs.srcDoc)}`),
      sandbox: "allow-same-origin allow-scripts allow-popups allow-presentation"
    })));
  return /* @__PURE__ */ React__default.createElement(IFramePlaceholder, {
    ...props
  });
};
const WrapperIframeRenderer = (options2) => (props) => {
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, {
    contentEditable: false
  }, /* @__PURE__ */ React__default.createElement(IFrameRenderer, {
    ...props,
    ...options2
  }));
};
const ExtendedIFrameBlock = (options2) => IFrameBlock.extend({
  addOptions() {
    var _a;
    return (_a = options2 == null ? void 0 : options2.iFrame) != null ? _a : {};
  },
  addNodeView() {
    return ReactNodeViewRenderer(WrapperIframeRenderer(options2));
  }
});
const getInitialColumnWidth = (state, pos) => {
  const { childCount } = state.doc.resolve(pos).parent;
  if (childCount > BLOCK_LINE_MAX_COLUMNS / 2)
    return void 0;
  return BLOCK_LINE_MAX_COLUMNS / childCount;
};
const setWidthAttrOnAllColumnNodes = ({
  editor,
  pos,
  width
}) => {
  const { tr } = editor.state;
  const { parent, parentOffset } = editor.state.doc.resolve(pos);
  const parentPos = pos - parentOffset;
  parent.content.forEach((node, offset) => {
    tr.setNodeMarkup(parentPos + offset, void 0, {
      ...node.attrs,
      width
    });
  });
  editor.view.dispatch(tr);
};
const updateColumnWidthAttr = ({
  editor,
  pos,
  currentWidth,
  updatedWidth
}) => {
  const { nodeBefore } = editor.state.doc.resolve(pos);
  if (!nodeBefore)
    return;
  const newWidth = updatedWidth;
  const newWidthColumnBefore = newWidth < currentWidth ? nodeBefore.attrs.width + 1 : nodeBefore.attrs.width - 1;
  if (!isWidthWithinBoundaries({
    width: newWidth,
    adjacentColumnWidth: newWidthColumnBefore
  }))
    return;
  return editor.chain().updateBlockAttributesAt({
    pos,
    attrs: { type: BlockTypes.BLOCK_COLUMN, width: newWidth },
    scrollIntoView: false
  }).updateBlockAttributesAt({
    pos: pos - nodeBefore.nodeSize,
    attrs: { type: BlockTypes.BLOCK_COLUMN, width: newWidthColumnBefore },
    scrollIntoView: false
  }).run();
};
const isWidthWithinBoundaries = ({
  width,
  adjacentColumnWidth
}) => width !== 0 && width !== BLOCK_LINE_MAX_COLUMNS && adjacentColumnWidth !== 0 && adjacentColumnWidth !== BLOCK_LINE_MAX_COLUMNS;
const BlockColumn = ({
  getPos,
  node,
  editor
}) => {
  const width = useRef(node.attrs.width);
  const editorWidth = useRef(0);
  const resizeHandleX = useRef(0);
  React__default.useEffect(() => {
    width.current = node.attrs.width;
  }, [node.attrs.width]);
  const mouseMoveHandler = React__default.useCallback(
    (event) => {
      const isMouseUp = event.buttons === 0;
      if (isMouseUp || !width.current) {
        editor.view.setProps({ editable: () => true });
        document.removeEventListener("mousemove", mouseMoveHandler);
        return;
      }
      const colSizeInPx = editorWidth.current / BLOCK_LINE_MAX_COLUMNS;
      const dx = event.clientX - resizeHandleX.current;
      let updatedWidth;
      if (dx >= colSizeInPx / 2) {
        updatedWidth = width.current - 1;
        resizeHandleX.current += colSizeInPx;
      } else if (dx <= -(colSizeInPx / 2)) {
        updatedWidth = width.current + 1;
        resizeHandleX.current -= colSizeInPx;
      }
      if (!updatedWidth)
        return;
      updateColumnWidthAttr({
        editor,
        pos: getPos(),
        currentWidth: width.current,
        updatedWidth
      });
      width.current = updatedWidth;
    },
    [editor, getPos]
  );
  const mouseDownHandler = React__default.useCallback(
    (event) => {
      var _a;
      event.preventDefault();
      if (!width.current) {
        const pos = getPos();
        const initialWidth = getInitialColumnWidth(editor.state, pos);
        if (!initialWidth)
          return;
        width.current = initialWidth;
        setWidthAttrOnAllColumnNodes({
          editor,
          pos,
          width: initialWidth
        });
      }
      editorWidth.current = (_a = editor.view.dom.getBoundingClientRect()) == null ? void 0 : _a.width;
      resizeHandleX.current = event.clientX;
      editor.view.setProps({ editable: () => false });
      document.addEventListener("mousemove", mouseMoveHandler);
    },
    [editor, mouseMoveHandler, getPos]
  );
  return /* @__PURE__ */ React__default.createElement("div", {
    contentEditable: false,
    className: "resize_handle_wrapper"
  }, /* @__PURE__ */ React__default.createElement("div", {
    "data-resize-handle": true,
    onMouseDown: mouseDownHandler
  }, /* @__PURE__ */ React__default.createElement("div", null)));
};
const getCSSForColumnFixedWidths = ({ maxCount }) => {
  let css2 = `&[width] { flex: unset; }`;
  for (let i = 0; i <= maxCount; i++) {
    css2 += `&[width='${i}'] {
                width: calc(100% / ${maxCount} * ${i});
            }
        `;
  }
  return css2;
};
const blockColumnStyle = css`
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCK_COLUMN}'] {
    position: relative;
    display: flex;
    flex: 1; /** All columns should have the same width */
    margin-left: 46px; /** Add a margin where the resize handle can live */
    padding-top: 12px;
    padding-bottom: 12px;
    transition: width 0.2s ease-in-out;

    ${getCSSForColumnFixedWidths({ maxCount: BLOCK_LINE_MAX_COLUMNS })}

    > .${SeshatCssClass.BLOCK_WRAPPER} {
      width: 100%;
    }
    > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK} {
      margin-left: 0;
      padding-right: 40px;
    }
    > .resize_handle_wrapper {
      position: absolute;
      height: 100%;
      top: 0;
      left: -46px;
      width: 46px;

      &:hover > div[data-resize-handle] {
        display: block;
      }

      > div[data-resize-handle] {
        display: none;
        position: relative;
        width: 100%;
        height: 100%;
        cursor: col-resize;
        > div {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 21px;
          width: 4px;
          height: 100%;
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
    /** Don't display margin and resize handle for first column in line */
    &:first-of-type {
      margin-left: 0;
      > .resize_handle_wrapper {
        display: none;
      }
    }
  }
`;
const CardTitleRender = (props) => {
  var _a, _b, _c, _d, _e;
  const { getPos, node, updateAttributes } = props;
  const ref = useRef(null);
  const [placeholderLeft, setPlaceholderLeft] = useState(0);
  const isSeshatEditorTitle = useMemo(
    () => node.attrs.cardType !== "task" && getPos() === 0,
    [getPos, node.attrs.cardType]
  );
  const chevronMouseDownHandler = useCallback(
    (e) => {
      var _a2, _b2;
      e.stopPropagation();
      e.preventDefault();
      updateAttributes({ collapsed: !((_a2 = node.attrs) == null ? void 0 : _a2.collapsed) });
      return !((_b2 = node.attrs) == null ? void 0 : _b2.collapsed);
    },
    [node, updateAttributes]
  );
  const isEmpty = !((_c = (_b = (_a = node.content.content) == null ? void 0 : _a[0]) == null ? void 0 : _b.content.content) == null ? void 0 : _c[0].textContent);
  const setPlaceholderPositionOnTitleDecorationChange = useCallback(
    (element) => {
      const resizeObserver = new ResizeObserver((entries) => {
        window.requestAnimationFrame(() => {
          if (!entries || !Array.isArray(entries) || !entries.length) {
            return;
          }
          setPlaceholderLeft(element.offsetWidth);
        });
      });
      resizeObserver.observe(element);
      return () => {
        resizeObserver.unobserve(element);
      };
    },
    []
  );
  React__default.useEffect(() => {
    if (!ref.current || !isEmpty)
      return;
    const element = ref.current;
    const unobserveCallback = setPlaceholderPositionOnTitleDecorationChange(
      element
    );
    return unobserveCallback;
  }, [isEmpty, setPlaceholderPositionOnTitleDecorationChange]);
  const TitleComponent = (_e = (_d = props.options) == null ? void 0 : _d.card) == null ? void 0 : _e.CardTitleView;
  return TitleComponent ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, {
    ref
  }, /* @__PURE__ */ React__default.createElement(TitleComponent, {
    chevronMouseDownHandler,
    updateAttributes,
    nodeAttrs: node.attrs,
    isSeshatEditorTitle,
    cardUuid: node.attrs[BlockAttrsParams.BLOCK_UUID]
  })), isEmpty && /* @__PURE__ */ React__default.createElement(Box, {
    contentEditable: false,
    sx: {
      position: "absolute",
      left: `${placeholderLeft + 2}px`,
      fontSize: "36px",
      color: "text.hint",
      zIndex: "-1",
      padding: "3px 2px"
    }
  }, "Untitled")) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
};
const copyToClipboard = async ({
  content,
  editor
}) => {
  if (typeof content === "string")
    return navigator.clipboard.writeText(content);
  if (!editor)
    throw Error("editor is required when serializing Prosemirror content");
  const serializableContent = content instanceof Node ? Fragment.from(content) : content instanceof Slice ? content.content : content;
  const domSerializer = new ClipboardDOMSerializer(editor.schema);
  const domFragment = domSerializer.serializeFragment(serializableContent);
  const textSerializer = new ClipboardTextSerializer();
  const textContent = textSerializer.serializeFragment(serializableContent);
  const dom = document.createElement("div");
  dom.append(domFragment);
  return navigator.clipboard.write([
    new ClipboardItem({
      "text/html": new Blob([dom.innerHTML], {
        type: "text/html"
      }),
      "text/plain": new Blob([textContent], {
        type: "text/plain"
      })
    })
  ]);
};
const ClipboardInterface = {
  copy: copyToClipboard
};
const CopyButtonClass = "copy-button";
const CopyButtonTooltipText = "Copy highlights to clipboard";
const CopyButton = ({
  editor,
  highlights,
  isTooltipOpen,
  setTooltip
}) => {
  const handleClick = async (e) => {
    if (!highlights)
      return;
    e.preventDefault();
    e.stopPropagation();
    setTooltip("Copied!");
    setTimeout(() => {
      setTooltip(CopyButtonTooltipText);
    }, 1e3);
    await ClipboardInterface.copy({ editor, content: highlights });
  };
  return /* @__PURE__ */ React__default.createElement(Box, {
    className: CopyButtonClass,
    contentEditable: false
  }, /* @__PURE__ */ React__default.createElement(IconButton, {
    sx: {
      padding: "2px",
      visibility: isTooltipOpen ? "visible" : "hidden"
    },
    onClick: handleClick,
    contentEditable: false,
    onMouseEnter: () => setTooltip(CopyButtonTooltipText),
    onMouseLeave: () => setTooltip(void 0)
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.COPY,
    size: 18
  })));
};
const StyledLabelWrapper = styled("div")((prop) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "26px",
  color: prop.theme.palette.grey["200"],
  cursor: "pointer",
  width: "fit-content",
  paddingRight: "4px",
  "&:hover": {
    background: alpha(prop.theme.palette.grey["400"], 0.8),
    borderRadius: "0.125rem",
    color: prop.theme.palette.grey["100"]
  },
  'div[role="button"]': {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "26px",
    marginRight: "5px",
    "> div": {
      width: "1rem",
      marginRight: "5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      svg: {
        width: "0.5rem",
        height: "0.5rem",
        display: "block",
        fill: "currentColor",
        flexShrink: 0,
        transition: "transform 200ms ease-out 0s",
        transform: "rotateZ(90deg)",
        opacity: "0.5"
      }
    }
  },
  span: {
    color: "currentColor"
  }
}));
const HighlightsLabel = ({
  editor,
  node,
  className,
  mouseDownHandler,
  openTooltip,
  setOpenTooltip
}) => {
  const [copyTooltip, setCopyTooltip] = useState(void 0);
  const isCollapsed = node == null ? void 0 : node.attrs.collapsed;
  const tooltipTitle = copyTooltip != null ? copyTooltip : `Click to ${isCollapsed ? "show" : "hide"} highlights`;
  return /* @__PURE__ */ React__default.createElement(Tooltip, {
    classes: { tooltip: className },
    open: openTooltip,
    title: tooltipTitle,
    placement: "top-start"
  }, /* @__PURE__ */ React__default.createElement(StyledLabelWrapper, {
    "data-highlights-decoration": true,
    onMouseDown: mouseDownHandler,
    onMouseOver: () => setOpenTooltip(true),
    onMouseOut: () => setOpenTooltip(false)
  }, /* @__PURE__ */ React__default.createElement(Box, {
    role: "button",
    "data-collapsed": isCollapsed
  }, /* @__PURE__ */ React__default.createElement(Box, {
    style: { transform: `rotateZ(${isCollapsed ? 0 : 90}deg)` }
  }, /* @__PURE__ */ React__default.createElement("svg", {
    viewBox: "0 0 100 100"
  }, /* @__PURE__ */ React__default.createElement("polygon", {
    points: "5.9,88.2 50,11.8 94.1,88.2 "
  }))), /* @__PURE__ */ React__default.createElement(Typography, {
    component: "span",
    contentEditable: false,
    variant: "overline"
  }, "Highlights")), /* @__PURE__ */ React__default.createElement(CopyButton, {
    editor,
    highlights: node,
    isTooltipOpen: openTooltip,
    setTooltip: setCopyTooltip
  })));
};
const Placeholder$1 = () => {
  return /* @__PURE__ */ React__default.createElement(WrappingBlockPlaceholderContainer, null, "You haven't highlighted anything from a clip yet", " ", /* @__PURE__ */ React__default.createElement("span", null, "When you select text while you're reading, it'll appear here."));
};
const Highlights = ({
  updateAttributes,
  node,
  editor
}) => {
  var _a;
  const [openTooltip, setOpenTooltip] = useState(false);
  const isCollapsed = (_a = node.attrs) == null ? void 0 : _a.collapsed;
  const mouseDownHandler = useCallback(
    (event) => {
      var _a2;
      if ((_a2 = event.target) == null ? void 0 : _a2.closest(`.${CopyButtonClass}`))
        return;
      event.stopPropagation();
      event.preventDefault();
      updateAttributes({ collapsed: !isCollapsed });
    },
    [isCollapsed, updateAttributes]
  );
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(HighlightsLabel, {
    editor,
    node,
    mouseDownHandler,
    openTooltip,
    setOpenTooltip
  }), !node.attrs.collapsed && isEmptyHighlightsBlock(node) && /* @__PURE__ */ React__default.createElement(Placeholder$1, null));
};
const AddHighlightNoteButton = styled$1(Button)({
  position: "absolute",
  minWidth: "28px",
  maxWidth: "28px",
  minHeight: "28px",
  maxHeight: "28px",
  zIndex: 99,
  top: 0,
  right: -17,
  transition: "all 175ms"
});
const Highlight = ({ editor, getPos, node }) => {
  var _a;
  const deep = node.textContent ? SESHAT_CONTENT_DEPTH : 0;
  const onClick = useCallback(() => {
    editor.chain().focus(getPos() + 1 + deep + 1).insertHighlightNote().run();
  }, [deep, editor, getPos]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, node.attrs.timestamp && /* @__PURE__ */ React__default.createElement(Timestamp, {
    value: node.attrs.timestamp
  }), ((_a = node.lastChild) == null ? void 0 : _a.attrs.type) !== BlockTypes.HIGHLIGHT_NOTE && /* @__PURE__ */ React__default.createElement(Tooltip, {
    title: "Quick Note",
    shortcut: Key.RETURN,
    placement: "top"
  }, /* @__PURE__ */ React__default.createElement(AddHighlightNoteButton, {
    "data-add-highlight-note": true,
    onClick,
    contentEditable: false,
    disableRipple: true,
    size: "small"
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    sx: { color: "text.secondary" },
    icon: Icons.QUICK_NOTE
  }))));
};
const useHighlightsBlockSyncOnMount = (editor, block) => {
  var _a;
  const clipId = (_a = block == null ? void 0 : block.attrs) == null ? void 0 : _a[BlockAttrsParams.BLOCK_UUID];
  useEffect(() => {
    if (!clipId || isClipContent(block) && (block.attrs.fetched || !block.textContent))
      return;
    try {
      setTimeout(() => {
        var _a2, _b;
        (_b = (_a2 = editor.view).dispatch) == null ? void 0 : _b.call(
          _a2,
          syncHighlightsBlocksAfterClipModificationTransaction({
            state: editor.state,
            modifiedClips: [clipId]
          })
        );
      }, 0);
    } catch (e) {
      return;
    }
  }, []);
};
const isClipContent = (block) => block.attrs.type === BlockTypes.CLIP_CONTENT;
const CLIP_CONTENT_DEPTH = SESHAT_CONTENT_DEPTH + 1;
var useFetchContentOnEmptyBlockWithHref = ({
  node,
  fetchClip,
  fetchTwitterClip,
  editor,
  pos
}) => {
  const [fetching, setFetching] = useState(false);
  const blockId = node.attrs[BlockAttrsParams.BLOCK_UUID];
  const {
    attrs: { fetched, href, hrefBackup },
    textContent
  } = node;
  const fetchContent = useCallback(async () => {
    var _a, _b, _c, _d;
    let isPaywallContent;
    let content;
    let title;
    let trackedPos = pos;
    try {
      setFetching(true);
      if (isTweetUrl(href) && fetchTwitterClip) {
        try {
          const result = await fetchTwitterClip(href);
          trackedPos = getUpdatedClipPos({
            doc: editor.state.doc,
            clip: node,
            pos
          });
          if (!trackedPos)
            throw new Error("no clip in doc");
          editor.chain().updateBlockAttributesAt({
            pos: trackedPos,
            attrs: { fetched: true }
          }).setMeta("addToHistory", false).run();
          if (!result)
            throw new Error("no content returned when fetching tweet");
          const firstUser = result.includes.users[0];
          const twitter = {
            name: firstUser.name,
            username: firstUser.username,
            profile_image_url: firstUser.profile_image_url
          };
          editor.chain().updateBlockAttributesAt({
            pos: trackedPos,
            attrs: { twitter: JSON.stringify(twitter) }
          }).setMeta("addToHistory", false).run();
          content = result.content;
        } catch (e) {
          setFetching(false);
          throw new Error("no content returned when fetching tweet");
        }
      } else if (isYoutubeUrl(href)) {
        const video = { name: "", profile_image_url: "" };
        const iFrameSrc = urlMediaParser(href);
        const iFrameAlt = getYoutubeVideoThumbnail(href);
        editor.chain().updateBlockAttributesAt({
          pos,
          attrs: { video: JSON.stringify(video) }
        }).setMeta("addToHistory", false).run();
        title = node.attrs.title;
        content = `<iframe src="${iFrameSrc}" alt="${iFrameAlt}"></iframe>`;
      } else if (fetchClip) {
        try {
          const result = await fetchClip(href, hrefBackup);
          isPaywallContent = result == null ? void 0 : result.paywallDetected;
          trackedPos = getUpdatedClipPos({
            doc: editor.state.doc,
            clip: node,
            pos
          });
          if (!trackedPos)
            throw new Error("no clip in doc");
          editor.chain().updateBlockAttributesAt({
            pos: trackedPos,
            attrs: { fetched: true, isPaywallContent }
          }).setMeta("addToHistory", false).run();
          if (!isPaywallContent && !(result == null ? void 0 : result.content))
            throw new Error("no content returned when fetching article");
          title = result == null ? void 0 : result.title;
          content = result == null ? void 0 : result.content;
        } catch (e) {
          setFetching(false);
          throw new Error("no content returned when fetching article");
        }
      }
      const editorChain = editor.chain();
      if (content) {
        const { jsonContent } = createJSONContentFromHTML({
          HTMLContent: content,
          schema: editor.schema,
          options: {
            parseOptions: {
              preserveWhitespace: "full"
            }
          },
          config: {
            bidirectionalName: "reference_bracket"
          }
        });
        const finalContent = (_a = jsonContent == null ? void 0 : jsonContent[0]) == null ? void 0 : _a.content;
        if (finalContent) {
          editorChain.replaceWith({
            from: trackedPos + 1,
            to: trackedPos + node.nodeSize - CLIP_CONTENT_DEPTH,
            content: finalContent
          }).matchHighlightsWithClipContent();
        }
        if (title)
          editorChain.insertClipTitle({ clipUuid: blockId, title });
        editorChain.removeOrphanHighlightsBlock();
      }
      if (isPaywallContent) {
        editorChain.addHighlightsInHighlightsAttribute();
      }
      if (title && isCapture(editor.state.doc) && !isLauncherEditor(editor)) {
        editorChain.turnEditorIntoCard({
          cardType: "note",
          title
        });
      }
      setFetching(false);
      editorChain.setMeta(IgnoreContentEditableFalse, true).setMeta("addToHistory", false);
      editorChain.run();
    } catch (err) {
      setFetching(false);
      const chain = editor.chain();
      trackedPos = (_b = getUpdatedClipPos({
        doc: editor.state.doc,
        clip: node,
        pos
      })) != null ? _b : pos;
      chain.focus(trackedPos).insertClipBookmark({
        nodeViewAttrs: {
          href,
          hrefBackup,
          title: (_d = (_c = node.attrs.title) != null ? _c : title) != null ? _d : href,
          highlights: node.attrs.highlights,
          hasError: true
        },
        attrs: {
          ...node.attrs,
          type: BlockTypes.NODE_VIEW,
          fetched: void 0,
          isPaywallContent: void 0
        }
      });
      chain.focus(trackedPos).deleteBlock();
      chain.setMeta(clipObserverPluginKey, true).run();
    }
  }, [
    blockId,
    href,
    fetchTwitterClip,
    fetchClip,
    editor,
    pos,
    hrefBackup,
    node
  ]);
  useEffect(() => {
    const isNotEmptyBlock = !!textContent;
    if (!href || isNotEmptyBlock || fetched || fetching)
      return;
    fetchContent();
  }, [fetched, fetching, href, textContent]);
  return fetching;
};
const isCapture = (doc) => {
  var _a;
  return ((_a = doc.content.content[0]) == null ? void 0 : _a.attrs.type) === "capture";
};
const getUpdatedClipPos = ({
  doc,
  pos,
  clip
}) => {
  var _a, _b;
  if (((_a = doc.nodeAt(pos)) == null ? void 0 : _a.attrs.type) === BlockTypes.CLIP_CONTENT)
    return pos;
  const blockId = clip.attrs[BlockAttrsParams.BLOCK_UUID];
  return (_b = getSeshatBlockByBlockId(doc, blockId)) == null ? void 0 : _b.pos;
};
const selectedStyles = {
  opacity: 1
};
const createContainerStyles = ({
  emoji
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: (theme2) => theme2.spacing(2.6),
  width: (theme2) => theme2.spacing(4),
  height: (theme2) => theme2.spacing(4),
  borderRadius: "100%",
  cursor: "pointer",
  opacity: 0.6,
  ":focus, &:hover": {
    ...selectedStyles
  },
  transition: (theme2) => theme2.transitions.create(["opacity"]),
  position: "relative",
  overflow: "hidden",
  "&::before": {
    fontSize: (theme2) => theme2.spacing(4),
    content: `"${emoji}"`,
    position: "absolute",
    filter: (theme2) => `blur(${theme2.spacing(4)})`,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) scale(4)"
  }
});
const ClipFaviconEmoji = ({
  value,
  selected = false,
  ...props
}) => {
  const containerStyles = React.useMemo(
    () => createContainerStyles({ emoji: value.emoji }),
    [value.emoji]
  );
  return /* @__PURE__ */ React.createElement(Box, {
    component: "span",
    ...props,
    sx: [containerStyles, selected && selectedStyles]
  }, value.emoji);
};
const ClipFaviconFaviconContainer = styled(
  (props) => /* @__PURE__ */ React.createElement(Box, {
    component: "span",
    ...props
  }),
  {
    name: "ClipFaviconFaviconContainer"
  }
)(({ theme: theme2, selected }) => ({
  display: "inline-flex",
  position: "relative",
  width: theme2.spacing(4),
  height: theme2.spacing(4),
  cursor: "pointer",
  opacity: selected ? 1 : 0.6,
  ":focus, &:hover": {
    opacity: 1
  },
  transition: theme2.transitions.create(["opacity"])
}));
const Layer = styled(
  ({ layer, ...props }) => {
    var _a;
    return /* @__PURE__ */ React.createElement(Avatar, {
      ...props,
      src: layer.type === "avatar" || layer.type === "favicon" ? layer.picture : void 0,
      name: layer.type === "initials" ? (_a = layer.name) != null ? _a : "" : ""
    });
  },
  { name: "Layer" }
)({});
const BackgroundLayer = styled(
  (props) => /* @__PURE__ */ React.createElement(Layer, {
    ...props,
    size: "large"
  }),
  { name: "BackgroundLayer" }
)({
  width: "100% !important",
  height: "100% !important"
});
const ForegroundLayer = styled(
  (props) => /* @__PURE__ */ React.createElement(Layer, {
    ...props,
    size: "small"
  }),
  { name: "ForegroundLayer" }
)({
  position: "absolute",
  right: 0,
  bottom: 0,
  width: "50% !important",
  height: "50% !important"
});
const ClipFaviconFavicon = ({
  value,
  selected = false,
  onClick
}) => {
  return /* @__PURE__ */ React.createElement(ClipFaviconFaviconContainer, {
    onClick,
    selected
  }, /* @__PURE__ */ React.createElement(BackgroundLayer, {
    layer: value.background
  }), value.foreground && /* @__PURE__ */ React.createElement(ForegroundLayer, {
    layer: value.foreground
  }));
};
const ClipFavicon = ({ value, ...props }) => {
  switch (value.type) {
    case "emoji":
      return /* @__PURE__ */ React.createElement(ClipFaviconEmoji, {
        ...props,
        value
      });
    case "favicon":
    default:
      return /* @__PURE__ */ React.createElement(ClipFaviconFavicon, {
        ...props,
        value
      });
  }
};
const createLayers = ({
  authors,
  favicons
}) => {
  const layers = /* @__PURE__ */ new Map();
  authors.forEach((author) => {
    const layersForAuthor = [];
    if (author.picture) {
      layersForAuthor.push({ type: "avatar", picture: author.picture });
    }
    if (author.name) {
      layersForAuthor.push({ type: "initials", name: author.name });
    }
    layers.set(author, layersForAuthor);
  });
  favicons.forEach((favicon) => {
    layers.set(favicon, [{ type: "favicon", picture: favicon }]);
  });
  return layers;
};
const createFaviconsVariants = ({
  authors,
  favicons
}) => {
  const layers = createLayers({ authors, favicons });
  const variants = [];
  for (const [id, itemLayers] of layers.entries()) {
    for (const layer of itemLayers) {
      variants.push({
        type: "favicon",
        background: layer,
        foreground: void 0
      });
      for (const [otherId, otherItemLayers] of layers.entries()) {
        if (otherId === id) {
          continue;
        }
        for (const otherLayer of otherItemLayers) {
          variants.push({
            type: "favicon",
            background: layer,
            foreground: otherLayer
          });
        }
      }
    }
  }
  return variants;
};
const isEqualFaviconValue = (a, b) => {
  return _.isEqual(_.omitBy(a, _.isUndefined), _.omitBy(b, _.isUndefined));
};
const ClipFaviconPickerEmojiTab = {
  label: "Emoji",
  isEnabled: () => true,
  TabPanel: ({ onChange }) => /* @__PURE__ */ React__default.createElement(EmojiPanel$1, {
    onSelect: (emoji) => onChange({ type: "emoji", emoji: emoji.native })
  })
};
const ClipFaviconPickerPresetsTab = {
  label: "Presets",
  isEnabled: ({ favicons, authors }) => favicons.length > 0 || authors.length > 0,
  TabPanel: ({
    favicons,
    authors,
    value: currentValue,
    onChange
  }) => {
    const variants = createFaviconsVariants({ authors, favicons });
    return /* @__PURE__ */ React__default.createElement(Box, {
      display: "flex",
      gap: 1,
      p: 1
    }, variants.map((variant, index) => /* @__PURE__ */ React__default.createElement(ClipFavicon, {
      key: index,
      value: variant,
      onClick: () => onChange(variant),
      selected: isEqualFaviconValue(currentValue, variant)
    })));
  }
};
const TABS = [ClipFaviconPickerEmojiTab, ClipFaviconPickerPresetsTab];
const ClipFaviconPickerTabs = (props) => {
  const [currentTabLabel, setCurrentTabLabel] = React__default.useState(
    () => {
      var _a;
      if (((_a = props.value) == null ? void 0 : _a.type) && ["favicon", "initials"].includes(props.value.type)) {
        return ClipFaviconPickerPresetsTab.label;
      }
      return ClipFaviconPickerEmojiTab.label;
    }
  );
  const handleChange = (_2, newTabLabel) => {
    setCurrentTabLabel(newTabLabel);
  };
  const { TabPanel } = TABS.find((tab) => tab.label === currentTabLabel);
  return /* @__PURE__ */ React__default.createElement(Box, {
    sx: { width: "100%" }
  }, /* @__PURE__ */ React__default.createElement(Tabs, {
    value: currentTabLabel,
    onChange: handleChange
  }, TABS.filter(({ isEnabled }) => isEnabled(props)).map(({ label }) => /* @__PURE__ */ React__default.createElement(Tab, {
    key: label,
    value: label,
    label
  }))), /* @__PURE__ */ React__default.createElement(TabPanel, {
    ...props
  }));
};
const popperStyles = {
  ".MuiPopover-paper": {
    backgroundColor: "background.default",
    border: (theme2) => `1px solid ${theme2.palette.grey["300"]}`
  },
  ".MuiTabs-root": {
    px: (theme2) => theme2.spacing(2),
    borderBottom: (theme2) => `1px solid ${theme2.palette.grey["300"]}`
  }
};
const ClipFaviconPicker = ({
  authors,
  favicons,
  defaultBackground = "avatar",
  value: initialValue,
  onChange: initialOnChange
}) => {
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const defaultFavicon = useMemo(() => {
    var _a;
    const variants = createFaviconsVariants({ authors, favicons });
    if (variants.length > 0) {
      return (_a = variants.find(
        (variant) => variant.background.type === defaultBackground && variant.foreground
      )) != null ? _a : variants[0];
    }
    return {
      type: "emoji",
      emoji: "\u{1F4CC}"
    };
  }, [defaultBackground, authors, favicons]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const onChange = (newFaviconValue) => {
    initialOnChange(newFaviconValue);
    handleClose();
  };
  const value = useMemo(() => {
    if (initialValue == null) {
      return defaultFavicon;
    }
    if (initialValue.type === "favicon") {
      const variants = createFaviconsVariants({ authors, favicons });
      if (variants.some((variant) => isEqualFaviconValue(initialValue, variant))) {
        return initialValue;
      }
      return variants[0];
    }
    return initialValue;
  }, [initialValue, defaultFavicon, authors, favicons]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ClipFavicon, {
    value,
    onClick: handleClick,
    selected: true
  }), /* @__PURE__ */ React__default.createElement(Popover, {
    open,
    anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    sx: popperStyles
  }, /* @__PURE__ */ React__default.createElement(ClipFaviconPickerTabs, {
    value,
    onChange,
    favicons,
    authors
  })));
};
const highlightCountStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "text.secondary",
  fontSize: 12,
  padding: "4px",
  columnGap: "8px",
  ".highlightCount, .noteCount": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px"
  }
};
const HighlightCount = ({
  count,
  sx
}) => {
  return /* @__PURE__ */ React__default.createElement(Box, {
    sx: {
      ...highlightCountStyles,
      ...sx
    }
  }, /* @__PURE__ */ React__default.createElement(Box, {
    className: "highlightCount"
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.MARKER,
    size: 20
  }), /* @__PURE__ */ React__default.createElement("span", null, count.highlights)), /* @__PURE__ */ React__default.createElement(Box, {
    className: "noteCount"
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.ANNOTATION,
    size: 20
  }), /* @__PURE__ */ React__default.createElement("span", null, count.notes)));
};
const HighlightCountButton = ({
  onClick,
  count,
  sx
}) => {
  return /* @__PURE__ */ React__default.createElement(Button, {
    sx: {
      height: 32,
      ...sx
    },
    onClick,
    "aria-label": "Highlights Count",
    color: "inherit",
    size: "small"
  }, /* @__PURE__ */ React__default.createElement(HighlightCount, {
    count
  }));
};
const HighlightCountButtonClip = ({
  editor,
  node,
  count,
  sx
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [showOpenLabel, setShowOpenLabel] = useState(false);
  const [highlightsBlock, setHighlightsBlock] = useState(void 0);
  const onHighlightsCountClick = useCallback(() => {
    const clip = retrieveClipFromDoc({ doc: editor.state.doc, node });
    if (!clip)
      return;
    if (highlightsBlock === void 0)
      return editor.commands.insertHighlightsBlock({
        pos: clip.pos,
        collapsed: true
      });
    if (!highlightsBlock.collapsed)
      return editor.commands.scrollToBlock({ uuid: highlightsBlock.uuid });
    if (highlightsBlock.collapsed)
      return editor.chain().updateBlockAttributesAt({
        pos: highlightsBlock.pos,
        attrs: { type: BlockTypes.HIGHLIGHTS, collapsed: false }
      }).scrollToBlock({ uuid: highlightsBlock.uuid }).run();
    return;
  }, [editor, highlightsBlock, node]);
  const onHighlightsCountHover = useCallback(() => {
    var _a;
    const { doc } = editor.state;
    const clip = retrieveClipFromDoc({ doc, node });
    if (!clip)
      return;
    const clipId = (_a = clip.node) == null ? void 0 : _a.attrs[BlockAttrsParams.BLOCK_UUID];
    const highlightsBlock2 = getConnectedHighlightsBlockByClipId(doc, clipId);
    setShowOpenLabel == null ? void 0 : setShowOpenLabel(!!highlightsBlock2);
    setHighlightsBlock(
      highlightsBlock2 ? {
        pos: highlightsBlock2.pos,
        uuid: highlightsBlock2.node.attrs[BlockAttrsParams.BLOCK_UUID],
        collapsed: highlightsBlock2.node.attrs.collapsed
      } : void 0
    );
  }, [editor.state, node]);
  return /* @__PURE__ */ React__default.createElement(Tooltip$1, {
    placement: "top",
    open: showTooltip,
    disableHoverListener: true,
    onMouseEnter: () => {
      onHighlightsCountHover();
      setShowTooltip(true);
    },
    onMouseLeave: () => setShowTooltip(false),
    title: /* @__PURE__ */ React__default.createElement(Box, {
      display: "inline-flex",
      gap: 1,
      alignItems: "center"
    }, /* @__PURE__ */ React__default.createElement(Typography, {
      variant: "body2"
    }, showOpenLabel ? "Open" : "Insert"), /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: "/highlights"
    }), /* @__PURE__ */ React__default.createElement(Typography, {
      variant: "body2"
    }, "block"))
  }, /* @__PURE__ */ React__default.createElement(Button, {
    id: "highlight-count-button",
    sx: {
      height: 32,
      ...sx
    },
    onClick: () => {
      setShowTooltip(false);
      onHighlightsCountClick();
    },
    "aria-label": "Highlights Count",
    color: "inherit",
    size: "small"
  }, /* @__PURE__ */ React__default.createElement(HighlightCount, {
    count
  })));
};
const retrieveClipFromDoc = ({
  doc,
  node
}) => {
  var _a;
  if (!node.isAtom)
    return getSeshatBlockByBlockId(
      doc,
      node.attrs[BlockAttrsParams.BLOCK_UUID]
    );
  const nestedClipNode = (_a = findChildren(doc, (docNode) => docNode.eq(node))) == null ? void 0 : _a[0];
  if (!nestedClipNode)
    return void 0;
  const block = getCurrentBlock(doc, nestedClipNode.pos);
  if (!block)
    return void 0;
  return { node: block.node, pos: block.from };
};
const useHighlightsCount = (editor, node) => {
  const doc = editor.state.doc;
  return useMemo(() => {
    var _a;
    const highlights = getHighlightsFromClipContent({
      doc,
      clipId: node.attrs[BlockAttrsParams.BLOCK_UUID]
    });
    if (!(highlights == null ? void 0 : highlights.length))
      return getHighlightsFromAttrs((_a = node.attrs) == null ? void 0 : _a.highlights);
    return {
      highlights: highlights.length,
      notes: highlights.filter((highlight) => !!highlight.highlightNote).length
    };
  }, [JSON.stringify(doc)]);
};
const ClipReadLaterCountButton = ({ editor, node, isLauncher }) => {
  const shouldDisplayHighlights = !isLauncher && node.attrs.status === CardClipStatus.LATER;
  const count = useHighlightsCount(editor, node);
  if (!shouldDisplayHighlights)
    return null;
  return /* @__PURE__ */ React__default.createElement(Box, {
    sx: {
      position: "inherit",
      zIndex: 999,
      textAlign: "center",
      ...node.attrs.status === CardClipStatus.LATER && {
        position: "absolute",
        backgroundColor: (theme2) => alpha(theme2.palette.background.paper, 0.9),
        borderRadius: "4px",
        top: "20px",
        left: "50%",
        transform: "translateX(-55%)"
      }
    }
  }, /* @__PURE__ */ React__default.createElement(HighlightCountButtonClip, {
    editor,
    node,
    count
  }));
};
const Placeholder = ({
  isPaywallContent,
  shouldDisplayHighlights
}) => /* @__PURE__ */ React__default.createElement(Box, {
  sx: {
    display: shouldDisplayHighlights ? "none" : "initial",
    position: "absolute",
    top: 23,
    left: 65,
    marginRight: "50px",
    color: "text.hint",
    fontSize: "14px",
    lineHeight: "16px",
    a: {
      color: "inherit",
      cursor: "pointer"
    }
  }
}, isPaywallContent ? `This article is hidden behind a paywall and cannot be clipped. Please paste the content here.` : `Import new content, an existing source, or create your own`);
const ClipFaviconPickerContainer$2 = styled(Box)(({ theme: theme2 }) => ({
  position: "absolute",
  left: "13.5px",
  top: theme2.spacing(2)
}));
const ClipArticle = ({
  editor,
  node,
  children,
  isLauncher,
  favicon,
  onChangeFavicon,
  apiUrl
}) => {
  const shouldDisplayHighlights = !isLauncher && node.attrs.status === CardClipStatus.LATER;
  const favicons = useMemo(
    () => [getFaviconUrl({ url: node.attrs.href, apiUrl })],
    [node.attrs.href, apiUrl]
  );
  const authors = useMemo(() => {
    var _a, _b;
    if ((_a = node.attrs) == null ? void 0 : _a.email) {
      const email = JSON.parse(node.attrs.email);
      return [{ name: email.name }];
    }
    if ((_b = node.attrs) == null ? void 0 : _b.video) {
      const video = JSON.parse(node.attrs.video);
      return [{ name: video.name, picture: video.profile_image_url }];
    }
    return [];
  }, [node.attrs.email, node.attrs.video]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ClipReadLaterCountButton, {
    node,
    editor,
    isLauncher
  }), /* @__PURE__ */ React__default.createElement(ClipFaviconPickerContainer$2, null, /* @__PURE__ */ React__default.createElement(ClipFaviconPicker, {
    value: favicon,
    onChange: onChangeFavicon,
    favicons,
    authors,
    defaultBackground: node.attrs.video ? "favicon" : void 0
  })), isEmptyClip(node) && /* @__PURE__ */ React__default.createElement(Placeholder, {
    isPaywallContent: node.attrs.isPaywallContent,
    shouldDisplayHighlights
  }), children);
};
const ClipEditableIcon = () => /* @__PURE__ */ React__default.createElement(Icon, {
  icon: Icons.BOOKMARK_DEFAULT,
  className: "no_seshat_propagation",
  color: "text.secondary"
});
const ClipReadIcon = () => /* @__PURE__ */ React__default.createElement(Icon, {
  icon: Icons.BOOKMARK_READ,
  className: "no_seshat_propagation"
});
const ClipReadLaterIcon = () => /* @__PURE__ */ React__default.createElement(Icon, {
  icon: Icons.BOOKMARK_LATER,
  className: "no_seshat_propagation"
});
const readLaterStatusUnread = (type) => ({
  title: "Mark as not for later",
  shortcutLauncher: void 0,
  shortcutApp: "L",
  icon: /* @__PURE__ */ React__default.createElement(ClipEditableIcon, null),
  update: ({
    updateAttributes,
    markAsReadNotLater,
    isLauncher,
    type: type2
  }) => {
    if (type2 === "video")
      return updateAttributes({
        status: void 0,
        contentEditable: false
      });
    markAsReadNotLater == null ? void 0 : markAsReadNotLater();
    updateAttributes({
      status: void 0,
      contentEditable: !isLauncher
    });
  },
  next: () => readLaterStatusLater(type)
});
const readLaterStatusLaterTitle = {
  text: "Read later",
  video: "Watch later"
};
const readLaterStatusLater = (type) => ({
  title: readLaterStatusLaterTitle[type],
  shortcutLauncher: void 0,
  shortcutApp: "L",
  icon: /* @__PURE__ */ React__default.createElement(ClipReadLaterIcon, null),
  update: ({ updateAttributes, markAsReadLater }) => {
    markAsReadLater == null ? void 0 : markAsReadLater();
    updateAttributes({ status: CardClipStatus.LATER, contentEditable: false });
  },
  next: (isReadView = false) => isReadView ? readLaterStatusReadReadView(type) : readLaterStatusUnread(type)
});
const readLaterStatusReadTitle = {
  text: "Mark as read",
  video: "Mark as watched"
};
const readLaterStatusRead = (type) => ({
  title: readLaterStatusReadTitle[type],
  shortcutLauncher: void 0,
  shortcutApp: "R",
  icon: /* @__PURE__ */ React__default.createElement(ClipReadIcon, null),
  update: ({ updateAttributes, toggleRead, type: type2 }) => {
    toggleRead == null ? void 0 : toggleRead();
    updateAttributes({
      status: CardClipStatus.READ,
      contentEditable: type2 === "video" ? false : true
    });
  },
  next: (isReadView = false) => isReadView ? readLaterStatusUnreadReadView(type) : readLaterStatusUnread(type)
});
const readLaterStatusUnreadReadViewTitle = {
  text: "Mark as unread",
  video: "Mark as unwatched"
};
const readLaterStatusUnreadReadView = (type) => ({
  ...readLaterStatusLater(type),
  title: readLaterStatusUnreadReadViewTitle[type],
  shortcutApp: "R",
  update: ({ updateAttributes, toggleRead }) => {
    toggleRead == null ? void 0 : toggleRead();
    updateAttributes({ status: CardClipStatus.LATER, contentEditable: false });
  }
});
const readLaterStatusReadReadView = (type) => ({
  ...readLaterStatusRead(type),
  shortcutApp: "R"
});
const readLaterStatuses = (type = "text") => ({
  editable: readLaterStatusUnread(type),
  [CardClipStatus.LATER]: readLaterStatusLater(type),
  [CardClipStatus.READ]: readLaterStatusRead(type)
});
const readLaterStatusesRead = (type = "text") => ({
  editable: readLaterStatusUnread(type),
  [CardClipStatus.LATER]: readLaterStatusUnreadReadView(type),
  [CardClipStatus.READ]: readLaterStatusReadReadView(type)
});
const ReadLaterButton = ({
  updateAttributes,
  status,
  isReadView,
  isLauncher = false,
  toggleRead,
  markAsReadLater,
  type,
  markAsReadNotLater
}) => {
  const newState = useMemo(() => {
    const currentState = readLaterStatuses(type)[status || "editable"];
    return currentState == null ? void 0 : currentState.next(isReadView);
  }, [isReadView, status, type]);
  const handleClick = React__default.useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      newState == null ? void 0 : newState.update({
        updateAttributes,
        isLauncher,
        toggleRead,
        markAsReadLater,
        type,
        markAsReadNotLater
      });
    },
    [
      newState,
      updateAttributes,
      isLauncher,
      toggleRead,
      markAsReadLater,
      type,
      markAsReadNotLater
    ]
  );
  return /* @__PURE__ */ React__default.createElement(Box, {
    sx: { display: "flex", alignItems: "center" }
  }, /* @__PURE__ */ React__default.createElement(Tooltip, {
    placement: "bottom",
    title: newState == null ? void 0 : newState.title,
    shortcut: isLauncher ? newState == null ? void 0 : newState.shortcutLauncher : newState == null ? void 0 : newState.shortcutApp
  }, /* @__PURE__ */ React__default.createElement(IconButton, {
    onMouseDown: handleClick,
    contentEditable: false,
    size: "small",
    sx: { padding: 0 }
  }, status === CardClipStatus.LATER && /* @__PURE__ */ React__default.createElement(ClipReadLaterIcon, null), status === CardClipStatus.READ && /* @__PURE__ */ React__default.createElement(ClipReadIcon, null), status === void 0 && /* @__PURE__ */ React__default.createElement(ClipEditableIcon, null))));
};
const ReadLaterMenu = ({
  status,
  updateAttributes,
  isHovered,
  toggleRead,
  markAsReadLater,
  type,
  markAsReadNotLater
}) => {
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const statuses = status === CardClipStatus.READ ? readLaterStatusesRead(type) : readLaterStatuses(type);
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(IconButton, {
    onClick: handleClick,
    size: "small",
    sx: { padding: 0, opacity: isHovered || open ? 1 : 0 },
    "aria-controls": open ? "account-menu" : void 0,
    "aria-haspopup": "true",
    "aria-expanded": open ? "true" : void 0
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CHEVRON_DOWN,
    color: "text.hint",
    size: 20
  })), /* @__PURE__ */ React__default.createElement(Menu, {
    variant: "menu",
    anchorEl,
    id: "account-menu",
    open,
    onClose: handleClose,
    onClick: handleClose,
    transformOrigin: { horizontal: "right", vertical: "top" },
    anchorOrigin: { horizontal: "right", vertical: "bottom" }
  }, Object.entries(statuses).map(([key, itemStatus]) => {
    const selected = (status || "editable") === key;
    return /* @__PURE__ */ React__default.createElement(MenuItem, {
      key,
      selected,
      onClick: () => itemStatus.update({
        updateAttributes,
        toggleRead,
        markAsReadLater,
        markAsReadNotLater,
        isLauncher: false,
        type
      })
    }, /* @__PURE__ */ React__default.createElement(ListItemIcon, null, itemStatus.icon), /* @__PURE__ */ React__default.createElement(ListItemText, {
      sx: { mr: 1 }
    }, itemStatus.title), selected ? /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: ["\u2713"]
    }) : /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: [itemStatus.shortcutApp]
    }));
  })));
};
const ReadLaterButtonWithMenu = ({
  status,
  sx,
  updateAttributes,
  isReadView = false,
  isLauncher = false,
  options: options2,
  type,
  className
}) => {
  const { ref, isHovered } = useHover();
  return /* @__PURE__ */ React__default.createElement(Box, {
    ref,
    sx: { display: "flex", alignItems: "center", ...sx },
    className: "no_seshat_propagation " + className
  }, /* @__PURE__ */ React__default.createElement(ReadLaterButton, {
    status,
    updateAttributes,
    isReadView,
    isLauncher,
    toggleRead: options2 == null ? void 0 : options2.toggleRead,
    markAsReadLater: options2 == null ? void 0 : options2.markAsReadLater,
    type,
    markAsReadNotLater: options2 == null ? void 0 : options2.markAsReadNotLater
  }), !isLauncher && /* @__PURE__ */ React__default.createElement(ReadLaterMenu, {
    status,
    updateAttributes,
    isHovered,
    toggleRead: options2 == null ? void 0 : options2.toggleRead,
    markAsReadLater: options2 == null ? void 0 : options2.markAsReadLater,
    type,
    markAsReadNotLater: options2 == null ? void 0 : options2.markAsReadNotLater
  }));
};
const StyledContainer$3 = styled(Box)(({ fetching }) => ({
  top: 0,
  width: "100%",
  "& > .MuiBox-root:first-of-type": {
    overflow: "hidden",
    "& ~ .seshat_block_wrapper": {
      display: fetching === true ? "none" : "",
      overflow: "hidden",
      top: 0,
      '.seshat_block[type="clipContent"] > .MuiBox-root': {
        top: "15px",
        position: "static",
        overflow: "hidden"
      }
    }
  }
}));
const StyledReadLaterButtonWithMenu = styled(ReadLaterButtonWithMenu)(({ isLauncher }) => ({
  position: "fixed",
  top: "18px",
  right: isLauncher ? "12px" : "8px",
  borderRadius: "4px",
  zIndex: 999
}));
const StyledButton = styled(Button)(() => ({
  position: "fixed",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 999
}));
const LoadingPlaceholder = styled("div")(({ theme: theme2 }) => ({
  display: "flex",
  alignItems: "center",
  whiteSpace: "nowrap",
  fontWeight: 600,
  margin: "0",
  fontSize: "10px",
  "&, & .MuiTypography-root": {
    color: theme2.palette.text.disabled
  },
  "& .MuiCircularProgress-root": {
    width: "12px",
    height: "12px"
  }
}));
const ClipContentFetching = ({
  isClipTweet
}) => {
  const [wording, setWording] = useState(
    isClipTweet ? "GATHERING THE TWEET(S)..." : "SAVING YOUR CLIP..."
  );
  useEffect(() => {
    if (isClipTweet)
      setTimeout(() => {
        setWording("IT WILL BE WORTH THE WAIT...");
      }, 3e3);
  }, [isClipTweet]);
  return /* @__PURE__ */ React__default.createElement(Box, {
    p: isClipTweet ? "10px" : "0 10px 10px"
  }, /* @__PURE__ */ React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    mb: "8px"
  }, /* @__PURE__ */ React__default.createElement(Skeleton, {
    width: "40%",
    variant: "text",
    animation: "wave",
    height: 30
  }), /* @__PURE__ */ React__default.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ React__default.createElement(LoadingPlaceholder, null, /* @__PURE__ */ React__default.createElement(CircularProgress, {
    color: "inherit",
    size: 12,
    sx: { marginRight: 1 }
  }), /* @__PURE__ */ React__default.createElement(Typography, {
    variant: "overline"
  }, wording)))), /* @__PURE__ */ React__default.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 28,
    sx: { marginBottom: "-4px" }
  }), /* @__PURE__ */ React__default.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 28,
    sx: { marginBottom: "2px" }
  }));
};
const sxButton = {
  position: "absolute",
  zIndex: "5",
  bottom: "6px",
  left: "50%",
  transform: "translateX(-50%)",
  typography: "overline",
  color: "text.hint",
  px: 2,
  py: "3px",
  boxShadow: "0px 4px 4px rgba(4, 4, 7, 0.25)",
  mb: 0,
  backgroundColor: "transparent",
  background: "linear-gradient(138.16deg, #1A1B1F -14.83%, #1A1B1F 92.59%) padding-box, linear-gradient(180deg, #B8B8B8 -76.62%, #111213 131.05%) border-box",
  border: "1px solid transparent",
  display: "flex",
  alignItem: "center",
  borderRadius: 1
};
const ClipTwitterButton = ({ node, editor }) => {
  const tweetsNodeWithPos = useMemo(() => {
    const _tweetsNodeWithPos = [];
    node.descendants((node2, pos) => {
      if (node2.attrs.type === BlockTypes.TWEET) {
        _tweetsNodeWithPos.push({ node: node2, pos });
      }
    });
    return _tweetsNodeWithPos;
  }, [node]);
  const onClick = useCallback(() => {
    var _a, _b, _c;
    const secondTweetStartPos = (_a = tweetsNodeWithPos[1]) == null ? void 0 : _a.pos;
    const lastElement = tweetsNodeWithPos[tweetsNodeWithPos.length - 1];
    const lastTweetEndPos = (lastElement == null ? void 0 : lastElement.pos) + (lastElement == null ? void 0 : lastElement.node.nodeSize);
    if (secondTweetStartPos)
      (_c = editor == null ? void 0 : (_b = editor.commands).deleteRange) == null ? void 0 : _c.call(_b, {
        from: secondTweetStartPos,
        to: lastTweetEndPos
      });
  }, [editor == null ? void 0 : editor.commands, tweetsNodeWithPos]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, node.content.content.length > 1 && /* @__PURE__ */ React__default.createElement(Box, {
    className: "clipContent_buttonTwitter",
    sx: sxButton,
    gap: 1
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CLIPBOARD,
    size: 16
  }), "Thread (", node.content.content.length, ")", /* @__PURE__ */ React__default.createElement(Tooltip$1, {
    title: /* @__PURE__ */ React__default.createElement(Typography, {
      variant: "body2",
      sx: { color: "text.hint" }
    }, "Remove thread"),
    placement: "top"
  }, /* @__PURE__ */ React__default.createElement(IconButton, {
    size: "small",
    sx: { p: 0 },
    onClick
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CLOSE,
    size: 16
  })))));
};
const ClipFaviconPickerContainer$1 = styled(Box)(({ theme: theme2 }) => ({
  position: "absolute",
  left: theme2.spacing(1),
  top: theme2.spacing(2)
}));
const ClipTwitter = ({
  name,
  profile_image_url,
  username,
  children,
  node,
  isLauncher,
  editor,
  favicon,
  onChangeFavicon,
  apiUrl
}) => {
  const isReadLaterMode = (node == null ? void 0 : node.attrs.status) === CardClipStatus.LATER && !isLauncher;
  const favicons = useMemo(
    () => [getFaviconUrl({ url: node.attrs.href, apiUrl })],
    [node.attrs.href, apiUrl]
  );
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(ClipReadLaterCountButton, {
    node,
    editor,
    isLauncher
  }), /* @__PURE__ */ React__default.createElement(ClipFaviconPickerContainer$1, null, /* @__PURE__ */ React__default.createElement(ClipFaviconPicker, {
    value: favicon,
    onChange: onChangeFavicon,
    favicons,
    authors: [{ name: username, picture: profile_image_url }]
  })), /* @__PURE__ */ React__default.createElement(Typography, {
    sx: {
      mb: 1,
      ml: isReadLaterMode ? "34px" : 0,
      position: "absolute",
      zIndex: "4",
      top: "14px",
      left: "73px",
      color: "grey.100"
    },
    className: "clipContent_twitterUsername"
  }, name, " ", /* @__PURE__ */ React__default.createElement(Typography, {
    component: "a",
    href: `https://twitter.com/@${username}`,
    sx: {
      color: "grey.300",
      fontSize: "13px",
      textDecoration: "none",
      cursor: "pointer"
    },
    target: "_blank"
  }, "@", username)), /* @__PURE__ */ React__default.createElement(ClipTwitterButton, {
    editor,
    node
  }), children);
};
const ClipContent = ({
  updateAttributes,
  node,
  editor,
  options: options2,
  getPos
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const pos = getPos();
  const isFocused = editor.state.selection.from === pos;
  const isLauncher = (options2 == null ? void 0 : options2.extensionVersion) === "launcher";
  const fetching = useFetchContentOnEmptyBlockWithHref({
    node,
    fetchClip: (_b = (_a = options2 == null ? void 0 : options2.clip) == null ? void 0 : _a.content) == null ? void 0 : _b.fetchClip,
    fetchTwitterClip: (_d = (_c = options2 == null ? void 0 : options2.clip) == null ? void 0 : _c.content) == null ? void 0 : _d.fetchTwitterClip,
    editor,
    pos
  });
  const favicon = node.attrs.favicon;
  const onChangeFavicon = useCallback(
    (newFavicon) => {
      updateAttributes({ favicon: newFavicon });
    },
    [updateAttributes]
  );
  useHighlightsBlockSyncOnMount(editor, node);
  const isClipTweet = !!((_e = node.attrs) == null ? void 0 : _e.href) && !!isTweetUrl((_f = node.attrs) == null ? void 0 : _f.href);
  const isTwitterContent = isClipTweet && node.attrs.twitter;
  const { name = null, username = null, profile_image_url = null } = isTwitterContent && !!node.attrs.twitter ? JSON.parse(node.attrs.twitter) : {};
  return /* @__PURE__ */ React__default.createElement(StyledContainer$3, {
    fetching
  }, /* @__PURE__ */ React__default.createElement(Box, {
    contentEditable: false
  }, fetching && /* @__PURE__ */ React__default.createElement(ClipContentFetching, {
    isClipTweet
  }) || isTwitterContent && /* @__PURE__ */ React__default.createElement(ClipTwitter, {
    favicon,
    onChangeFavicon,
    name,
    username,
    profile_image_url,
    isLauncher,
    node,
    apiUrl: (_g = options2 == null ? void 0 : options2.apiUrl) != null ? _g : "",
    editor
  }, /* @__PURE__ */ React__default.createElement(ClipActions, {
    node,
    updateAttributes,
    isLauncher,
    options: options2 == null ? void 0 : options2.clip,
    className: "twitterClipButton"
  })) || /* @__PURE__ */ React__default.createElement(ClipArticle, {
    favicon,
    onChangeFavicon,
    node,
    editor,
    isLauncher,
    apiUrl: (_h = options2 == null ? void 0 : options2.apiUrl) != null ? _h : ""
  }, /* @__PURE__ */ React__default.createElement(ClipActions, {
    node,
    updateAttributes,
    isLauncher,
    isFocused,
    options: options2 == null ? void 0 : options2.clip
  }))));
};
const ClipActions = ({
  node,
  updateAttributes,
  isLauncher,
  isFocused,
  options: options2,
  className
}) => {
  const status = node.attrs.status;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StyledReadLaterButtonWithMenu, {
    isLauncher,
    status,
    updateAttributes,
    options: options2,
    type: node.attrs.video ? "video" : "text",
    className
  }), !isLauncher && status === CardClipStatus.LATER && /* @__PURE__ */ React__default.createElement(StyledButton, {
    variant: "chip",
    size: "small",
    endIcon: isFocused ? /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: ["\u21B5"]
    }) : void 0
  }, node.attrs.video ? "Watch" : "Read"));
};
const ClipContentLauncher = ({
  updateAttributes,
  node,
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement(ClipContent, {
    node,
    updateAttributes,
    ...props
  });
};
const ClipContentMainApp = ({
  updateAttributes,
  node,
  editor,
  options: options2,
  getPos,
  ...props
}) => {
  useEffect(() => {
    var _a, _b, _c;
    try {
      if (((_a = node.attrs) == null ? void 0 : _a.status) !== CardClipStatus.LATER)
        return;
      const nodeDOM = (_c = (_b = editor == null ? void 0 : editor.view) == null ? void 0 : _b.nodeDOM) == null ? void 0 : _c.call(_b, getPos());
      if (!nodeDOM)
        return;
      const goTo = (e) => {
        var _a2, _b2, _c2, _d, _e, _f;
        if ((_a2 = e.target) == null ? void 0 : _a2.closest(".no_seshat_propagation"))
          return;
        if ((_b2 = e.target) == null ? void 0 : _b2.closest("#highlight-count-button"))
          return;
        const blockId = (_c2 = node.attrs) == null ? void 0 : _c2[BlockAttrsParams.BLOCK_UUID];
        if (!blockId)
          return;
        e.preventDefault();
        e.stopPropagation();
        (_f = (_e = (_d = options2 == null ? void 0 : options2.clip) == null ? void 0 : _d.content) == null ? void 0 : _e.goToClip) == null ? void 0 : _f.call(_e, blockId);
      };
      nodeDOM.addEventListener("mousedown", goTo);
      return () => {
        nodeDOM.removeEventListener("mousedown", goTo);
      };
    } catch (e) {
      return;
    }
  }, [editor.view, getPos, node.attrs, options2 == null ? void 0 : options2.clip]);
  return /* @__PURE__ */ React__default.createElement(ClipContent, {
    node,
    updateAttributes,
    editor,
    options: options2,
    getPos,
    ...props
  });
};
const NUMBER_OF_WORD_READ_PRE_MINUTE = 296;
const getMin = (content) => {
  return Math.round(content.split(" ").length / NUMBER_OF_WORD_READ_PRE_MINUTE);
};
const ClipContentTitle = (props) => {
  var _a, _b;
  const { editor, options: options2 } = props;
  const AuthorView = (_b = (_a = options2 == null ? void 0 : options2.clip) == null ? void 0 : _a.book) == null ? void 0 : _b.AuthorReferenceComponent;
  const rootCardUuid = getCardUuid(
    editor,
    (options2 == null ? void 0 : options2.extensionVersion) === "read_later_view"
  );
  const min = getMin((editor == null ? void 0 : editor.state.doc.textContent) || "");
  if (!AuthorView)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  return /* @__PURE__ */ React__default.createElement(Box, {
    className: "clipContentTitle_author",
    sx: {
      position: "absolute",
      bottom: "-24px",
      left: "50%",
      transform: "translateX(-50%)",
      "& .author": {
        textOverflow: "ellipsis",
        maxWidth: "178px",
        display: "inline-block",
        whiteSpace: "pre",
        overflow: "hidden",
        verticalAlign: "bottom"
      }
    }
  }, /* @__PURE__ */ React__default.createElement(AuthorView, {
    cardUuid: rootCardUuid
  }, (linkAuthor) => {
    if (!linkAuthor)
      return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Typography, {
        component: "span",
        sx: { color: "grey['100']" }
      }, min, "min"));
    return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Typography, {
      component: "span",
      sx: {
        color: "grey['100']"
      }
    }, "By", " "), linkAuthor, /* @__PURE__ */ React__default.createElement(Typography, {
      component: "span",
      sx: {
        color: "grey['100']"
      }
    }, " ", "\u2022 ", min, "min"));
  }));
};
const getHighlightCountFromAttribute = (node) => {
  var _a;
  const highlights = (_a = node.attrs.highlights) == null ? void 0 : _a.content;
  const kindleHighlights = node.attrs.kindleHighlights;
  return {
    highlights: (highlights || kindleHighlights || []).length,
    notes: (highlights == null ? void 0 : highlights.filter(
      (highlight) => {
        var _a2;
        return ((_a2 = highlight == null ? void 0 : highlight.content) == null ? void 0 : _a2.length) === 2;
      }
    ).length) || (kindleHighlights == null ? void 0 : kindleHighlights.filter((highlight) => highlight == null ? void 0 : highlight.note).length) || 0
  };
};
const clipBookStyles = {
  position: "relative",
  height: "auto",
  minHeight: "170px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between"
};
const clipBookTitleStyles = {
  mx: "auto",
  maxWidth: "65%",
  textAlign: "center",
  fontFamily: "GT Super Text",
  fontSize: "24px",
  lineHeight: "32px"
};
const clipBookCoverStyles = {
  position: "absolute",
  top: "calc(50% - 42px)",
  left: "10%",
  width: "100%",
  maxWidth: "64px",
  height: "100%",
  maxHeight: "84px",
  "& img": {
    width: "100%",
    height: "100%"
  }
};
const ClipBook = ({
  node,
  editor,
  getPos,
  updateAttributes,
  options: options2
}) => {
  var _a;
  const { doc } = editor.state;
  const block = BlockSelection.createFromPosition(doc, getPos()).firstBlock();
  const cardUuid = getCardUuid(editor);
  const AuthorView = (_a = options2 == null ? void 0 : options2.book) == null ? void 0 : _a.AuthorReferenceComponent;
  const { asin, coverUrl, title, status } = node.attrs;
  const count = getHighlightCountFromAttribute(node);
  useHighlightsBlockSyncOnMount(editor, block.node);
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement(Box, {
    sx: clipBookStyles,
    className: NodeViewTypes.CLIP_BOOK
  }, /* @__PURE__ */ React__default.createElement(HighlightCountButtonClip, {
    editor,
    node,
    count
  }), /* @__PURE__ */ React__default.createElement(Box, {
    sx: { textAlign: "center" }
  }, /* @__PURE__ */ React__default.createElement(Typography, {
    sx: clipBookTitleStyles
  }, title), /* @__PURE__ */ React__default.createElement(Typography, null, AuthorView && /* @__PURE__ */ React__default.createElement(AuthorView, {
    cardUuid
  }, (linkAuthor) => {
    if (!linkAuthor)
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
    return /* @__PURE__ */ React__default.createElement(Box, {
      sx: { maxWidth: 300, margin: "0 auto" }
    }, "By ", linkAuthor);
  }))), asin && /* @__PURE__ */ React__default.createElement(Button, {
    href: getAsinUrl(asin),
    variant: "chip",
    size: "small",
    endIcon: /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: ["\u21B5"]
    }),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Read"), /* @__PURE__ */ React__default.createElement(Box, {
    component: "img",
    src: coverUrl,
    alt: title,
    sx: clipBookCoverStyles
  }), /* @__PURE__ */ React__default.createElement(ReadLaterButtonWithMenu, {
    sx: {
      position: "absolute",
      top: 10,
      right: "4px"
    },
    status,
    updateAttributes,
    options: options2
  })));
};
const WrapperClipBook = (options2) => (props) => {
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement(ClipBook, {
    options: options2,
    ...props
  }));
};
const ExtendedClipBookBlock = (options2) => ClipBookBlock(options2).extend({
  addNodeView() {
    return ReactNodeViewRenderer(WrapperClipBook(options2 == null ? void 0 : options2.clip));
  }
});
const StyledContainer$2 = styled(Box)(
  ({ theme: { palette, spacing } }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    overflow: "none",
    "& > .MuiButton-root": {
      display: "flex",
      alignItems: "center",
      minWidth: 0,
      "& .MuiTypography-root": {
        color: palette.grey["300"],
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    "& .MuiBox-root": {
      display: "flex",
      alignItems: "center",
      "& .MuiButton-root#clipBookmarkButton": {
        marginLeft: spacing(4)
      }
    }
  })
);
var ClipSourceButton = ({
  sx,
  onClick,
  error,
  type
}) => {
  const [showError, setShowError] = useState(error != null ? error : false);
  useHotkeys([
    {
      name: "Clip content",
      keys: "meta+shift+c",
      callback: onClick
    }
  ]);
  const wording = useMemo(() => {
    if (showError)
      return { text: "Try again", icon: Icons.ALERT };
    if (type === "video")
      return { text: "Clip video", icon: Icons.VIDEO };
    return { text: "Clip content", icon: Icons.CLIPBOARD };
  }, [showError, type]);
  return /* @__PURE__ */ React__default.createElement(Button, {
    onClick,
    onMouseEnter: () => {
      if (showError)
        setShowError(false);
    },
    onMouseLeave: () => {
      if (error)
        setShowError(true);
    },
    id: "clipBookmarkButton",
    "aria-label": "Clip Content from Source",
    sx: {
      display: "inline-flex",
      alignItems: "center",
      transition: theme.transitions.create("all", {
        duration: theme.transitions.duration.standard
      }),
      ...sx
    }
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: wording.icon,
    sx: { mr: 0.25, color: "text.secondary" }
  }), /* @__PURE__ */ React__default.createElement(Typography, {
    sx: { mr: 2, color: "text.secondary", minWidth: 70, textAlign: "left" },
    variant: "body2",
    noWrap: true
  }, wording.text), /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: ["\u2318", "\u21E7", "C"]
  }));
};
const ClipFaviconPickerContainer = styled(Box)(({ theme: theme2 }) => ({
  display: "flex",
  marginRight: theme2.spacing(1)
}));
const ClipBookmark = ({
  node,
  editor,
  updateAttributes,
  apiUrl
}) => {
  const { title, href } = node.attrs;
  const count = getHighlightCountFromAttribute(node);
  const favicon = node.attrs.favicon;
  const onChangeFavicon = useCallback(
    (newFavicon) => {
      updateAttributes({ favicon: newFavicon });
    },
    [updateAttributes]
  );
  const favicons = useMemo(
    () => [getFaviconUrl({ url: node.attrs.href, apiUrl: apiUrl != null ? apiUrl : "" })],
    [node.attrs.href, apiUrl]
  );
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement(StyledContainer$2, {
    className: NodeViewTypes.CLIP_BOOKMARK
  }, /* @__PURE__ */ React__default.createElement(Button, {
    color: "inherit",
    href,
    target: "_blank",
    rel: "noreferrer"
  }, /* @__PURE__ */ React__default.createElement(ClipFaviconPickerContainer, null, /* @__PURE__ */ React__default.createElement(ClipFaviconPicker, {
    value: favicon,
    onChange: onChangeFavicon,
    favicons,
    authors: [],
    defaultBackground: node.attrs.video ? "favicon" : void 0
  })), /* @__PURE__ */ React__default.createElement(Typography, {
    variant: "overline",
    component: "p",
    noWrap: true
  }, title)), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(HighlightCountButtonClip, {
    editor,
    node,
    count
  }), /* @__PURE__ */ React__default.createElement(ClipSourceButton, {
    error: node.attrs.hasError,
    type: isYoutubeUrl(href) ? "video" : "text",
    onClick: () => {
      editor.commands.replaceClipBookmarkByClipContent();
    }
  }))));
};
const WrapperClipBookmark = ({ apiUrl }) => (props) => {
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement(ClipBookmark, {
    ...props,
    apiUrl
  }));
};
const ExtendedClipBookmarkBlock = (options2) => ClipBookmarkBlock.extend({
  addNodeView() {
    return ReactNodeViewRenderer(
      WrapperClipBookmark({ apiUrl: options2 == null ? void 0 : options2.apiUrl })
    );
  }
});
const StyledContainer$1 = styled$1("div")(({ theme: { palette } }) => ({
  ul: {
    marginBlockStart: 0,
    paddingInlineStart: 0,
    listStyleType: "none",
    fontSize: "12px"
  },
  "li.placeholder": {
    color: palette.text.secondary
  },
  "li:not(.placeholder)": {
    width: "fit-content",
    fontSize: "12px",
    textDecoration: "underline",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer"
  },
  ".heading1 + .heading2": {
    paddingLeft: "30px"
  },
  ".heading2 + .heading3": {
    paddingLeft: "60px"
  }
}));
const TableOfContents = ({ editor }) => {
  const [content, setContent] = React__default.useState(
    getHeadingForTableOfContents({ editor })
  );
  const displayPlaceholder = React__default.useMemo(() => {
    return (content == null ? void 0 : content.length) === 0;
  }, [content]);
  const setHeadings = React__default.useCallback(() => {
    const allHeadings = getHeadingForTableOfContents({ editor });
    if (allHeadings !== content)
      setContent(allHeadings);
  }, [content, editor]);
  React__default.useEffect(() => {
    editor.on("update", setHeadings);
    return () => {
      editor.off("update", setHeadings);
    };
  }, [editor, setHeadings]);
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement(StyledContainer$1, null, /* @__PURE__ */ React__default.createElement("ul", {
    className: "table_of_content"
  }, !displayPlaceholder ? content == null ? void 0 : content.map((heading) => {
    var _a, _b;
    return /* @__PURE__ */ React__default.createElement("li", {
      key: (_a = heading.attrs) == null ? void 0 : _a["block-id"],
      className: `cursor ${(_b = heading.attrs) == null ? void 0 : _b.type}`,
      onClick: () => {
        var _a2;
        return editor.commands.scrollToBlock({
          uuid: (_a2 = heading.attrs) == null ? void 0 : _a2["block-id"]
        });
      }
    }, heading.text || "Untitled");
  }) : /* @__PURE__ */ React__default.createElement("li", {
    className: "placeholder"
  }, "Add headings to create a table of contents."))));
};
const ExtendedTableOfContentsBlock = TableOfContentsBlock.extend({
  addNodeView() {
    return ReactNodeViewRenderer(TableOfContents);
  }
});
const CardLinkRender = (props) => {
  var _a, _b;
  const { getPos, node, updateAttributes } = props;
  const block = React__default.useMemo(
    () => {
      var _a2;
      return (_a2 = getCurrentBlock(props.editor.state.doc, getPos())) == null ? void 0 : _a2.node;
    },
    [getPos, props.editor.state]
  );
  const LinkComponent = React__default.useMemo(
    () => {
      var _a2;
      return (_a2 = props.injectedProps) == null ? void 0 : _a2.NestedCardLink;
    },
    [(_a = props.injectedProps) == null ? void 0 : _a.NestedCardLink]
  );
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, LinkComponent ? /* @__PURE__ */ React__default.createElement(LinkComponent, {
    updateAttributes,
    nodeAttrs: node.attrs,
    cardUuid: (_b = block == null ? void 0 : block.attrs) == null ? void 0 : _b[BlockAttrsParams.BLOCK_UUID]
  }, /* @__PURE__ */ React__default.createElement(NodeViewContent, null)) : /* @__PURE__ */ React__default.createElement(NodeViewContent, null));
};
const WrapperCardLinkRenderer = (injectedProps) => (props) => {
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, null, /* @__PURE__ */ React__default.createElement(CardLinkRender, {
    injectedProps,
    ...props
  }));
};
const ExtendedCardLinkBlock = (options2) => CardLinkBlock.extend({
  addNodeView() {
    return ReactNodeViewRenderer(WrapperCardLinkRenderer(options2 == null ? void 0 : options2.card));
  }
});
const seshatBlockComponents = {
  [BlockTypes.CODE]: CodeBlock,
  [BlockTypes.CARD_CONTENT]: CardTitleRender,
  [BlockTypes.CLIP_CONTENT_TITLE]: ClipContentTitle
};
const seshatWrappingBlockComponents = {
  [BlockTypes.BLOCKQUOTE]: Blockquote,
  [BlockTypes.BLOCK_COLUMN]: BlockColumn,
  [BlockTypes.CLIP_CONTENT]: ClipContentMainApp,
  [BlockTypes.HIGHLIGHTS]: Highlights,
  [BlockTypes.HIGHLIGHT]: Highlight
};
const wrapperComponentOverrides = {
  launcher: {
    [BlockTypes.CLIP_CONTENT]: ClipContentLauncher
  }
};
const getWrapperComponentOverrides = (options2) => {
  var _a, _b;
  if (!options2)
    return wrapperComponentOverrides;
  const extensionVersion = (_a = options2.extensionVersion) != null ? _a : "main";
  return {
    ...options2.wrapperComponentOverrides,
    ...wrapperComponentOverrides,
    [extensionVersion]: {
      ...wrapperComponentOverrides[extensionVersion],
      ...(_b = options2.wrapperComponentOverrides) == null ? void 0 : _b[extensionVersion]
    }
  };
};
class SeshatBlockRenderer {
  constructor(component, dom, {
    editor,
    props
  }) {
    this.ref = null;
    this.id = Math.floor(Math.random() * 4294967295).toString();
    this.component = component;
    this.editor = editor;
    this.props = props;
    this.element = dom;
    this.render();
  }
  render() {
    var _a;
    this.reactElement = /* @__PURE__ */ React__default.createElement(this.component, {
      ...this.props
    });
    if (this.editor.options.useFlushSync) {
      flushSync(() => {
        var _a2;
        (_a2 = this.editor.contentComponent) == null ? void 0 : _a2.setState({
          renderers: this.editor.contentComponent.state.renderers.set(
            this.id,
            this
          )
        });
      });
    } else {
      (_a = this.editor.contentComponent) == null ? void 0 : _a.setState({
        renderers: this.editor.contentComponent.state.renderers.set(
          this.id,
          this
        )
      });
    }
  }
  updateProps(props = {}) {
    this.props = {
      ...this.props,
      ...props
    };
    this.render();
  }
  destroy() {
    var _a;
    if (this.editor.options.useFlushSync) {
      flushSync(() => {
        var _a2;
        if ((_a2 = this.editor) == null ? void 0 : _a2.contentComponent) {
          const { renderers } = this.editor.contentComponent.state;
          renderers.delete(this.id);
          this.editor.contentComponent.setState({
            renderers
          });
        }
      });
    } else {
      if ((_a = this.editor) == null ? void 0 : _a.contentComponent) {
        const { renderers } = this.editor.contentComponent.state;
        renderers.delete(this.id);
        this.editor.contentComponent.setState({
          renderers
        });
      }
    }
  }
}
class SeshatBlockViewComponent extends React__default.Component {
  componentDidMount() {
    this.maybeMoveContentDOM();
  }
  maybeMoveContentDOM() {
    if (this.props.contentDOMElement && this.props.viewDomElement) {
      if (!this.props.contentDOMElement.isSameNode(
        this.props.viewDomElement.lastElementChild
      )) {
        this.props.viewDomElement.append(this.props.contentDOMElement);
      }
    }
  }
  componentDidUpdate() {
    this.maybeMoveContentDOM();
  }
  render() {
    return this.props.children;
  }
}
class SeshatBlockView {
  constructor(Component, props, rendererOptions) {
    this.contentDOMElement = null;
    this.viewDomElement = null;
    this.selected = false;
    this.deleteNode = () => {
      const from = this.props.getPos();
      const to = from + this.props.node.nodeSize;
      this.props.editor.commands.deleteRange({ from, to });
    };
    this.updateAttributes = (attributes) => {
      this.props.editor.commands.command(({ tr }) => {
        const pos = this.props.getPos();
        tr.setNodeMarkup(pos, void 0, {
          ...this.props.node.attrs,
          ...attributes
        });
        return true;
      });
    };
    this.Component = Component;
    this.editor = props.editor;
    this.rendererOptions = rendererOptions;
    this.props = {
      ...props,
      editor: this.editor,
      selected: false,
      extension: {},
      getPos: typeof props.getPos === "function" ? props.getPos : () => -1,
      updateAttributes: (attributes = {}) => this.updateAttributes(attributes),
      deleteNode: () => this.deleteNode()
    };
    this.init();
  }
  init() {
    this.viewDomElement = document.createElement("div");
    this.viewDomElement.classList.add(this.rendererOptions.viewDomClass);
    this.updateDomAttributes();
    this.contentDOMElement = document.createElement("div");
    this.contentDOMElement.classList.add(this.rendererOptions.contentDomClass);
    const Component = () => /* @__PURE__ */ React__default.createElement(SeshatBlockViewComponent, {
      updateAttributes: this.updateAttributes,
      viewDomElement: this.viewDomElement,
      contentDOMElement: this.contentDOMElement
    }, /* @__PURE__ */ React__default.createElement(this.Component, {
      ...this.props,
      editor: this.editor
    }));
    this.renderer = new SeshatBlockRenderer(Component, this.viewDomElement, {
      editor: this.editor,
      props: this.props
    });
  }
  get dom() {
    return this.viewDomElement;
  }
  get contentDOM() {
    return this.contentDOMElement;
  }
  updateDomAttributes() {
    Object.keys(this.props.node.attrs).forEach((attributeName) => {
      var _a, _b, _c;
      if (this.props.node.attrs[attributeName] !== void 0 && this.props.node.attrs[attributeName] !== null && ((_a = seshatBlockAttributes[attributeName]) == null ? void 0 : _a.rendered) !== false) {
        (_b = this.viewDomElement) == null ? void 0 : _b.setAttribute(
          attributeName,
          this.props.node.attrs[attributeName]
        );
      } else {
        (_c = this.viewDomElement) == null ? void 0 : _c.removeAttribute(attributeName);
      }
    });
  }
  update(node) {
    var _a;
    if (!node.attrs[BlockAttrsParams.BLOCK_UUID]) {
      return false;
    }
    this.props = { ...this.props, node };
    (_a = this.renderer) == null ? void 0 : _a.updateProps(this.props);
    this.updateDomAttributes();
    return true;
  }
  ignoreMutation(mutation) {
    if (!this.dom || !this.contentDOM) {
      return true;
    }
    if (this.props.node.isLeaf || this.props.node.isAtom) {
      return true;
    }
    if (mutation.type === "selection") {
      return false;
    }
    if (this.dom.contains(mutation.target) && mutation.type === "childList" && isiOS()) {
      const changedNodes = [
        ...Array.from(mutation.addedNodes),
        ...Array.from(mutation.removedNodes)
      ];
      if (changedNodes.every((node) => node.isContentEditable)) {
        return false;
      }
    }
    if (this.contentDOM === mutation.target && mutation.type === "attributes") {
      return true;
    }
    return !this.contentDOM.contains(mutation.target);
  }
  selectNode() {
    var _a;
    (_a = this.renderer) == null ? void 0 : _a.updateProps({
      selected: true
    });
  }
  deselectNode() {
    var _a;
    (_a = this.renderer) == null ? void 0 : _a.updateProps({
      selected: false
    });
  }
  destroy() {
    var _a;
    (_a = this.renderer) == null ? void 0 : _a.destroy();
    this.contentDOMElement = null;
  }
}
function isiOS() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const createSeshatBlockView = (Component, rendererOptions) => {
  return (props) => {
    if (!props.editor.contentComponent) {
      return {};
    }
    return new SeshatBlockView(Component, props, {
      viewDomClass: SeshatCssClass.BLOCK,
      contentDomClass: SeshatCssClass.BLOCK_WRAPPER,
      ...rendererOptions
    });
  };
};
const SeshatBlockComponents = (components, options2) => (props) => {
  var _a, _b, _c;
  const blockType = props.node.attrs.type;
  if (!blockType)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  const overrides = (_b = options2 == null ? void 0 : options2.wrapperComponentOverrides) == null ? void 0 : _b[(_a = options2 == null ? void 0 : options2.extensionVersion) != null ? _a : "main"];
  const Component = (_c = overrides == null ? void 0 : overrides[blockType]) != null ? _c : components[blockType];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, Component && /* @__PURE__ */ React__default.createElement(Component, {
    ...props,
    options: options2
  }));
};
const ExtendedSeshatBlockGroup = (options2) => SeshatBlockGroup(options2).extend({
  addNodeView() {
    return createSeshatBlockView(
      SeshatBlockComponents(
        { ...seshatBlockComponents, ...seshatWrappingBlockComponents },
        options2
      )
    );
  }
});
const ExtendedSeshatBlockNode = (options2) => ExtendedSeshatBlockGroup(options2).extend(SeshatBlockNodeConfig);
const ExtendedSeshatWrappingBlockNode = (options2) => ExtendedSeshatBlockGroup(options2).extend(SeshatWrappingBlockNodeConfig);
function isClassComponent(Component) {
  return !!(typeof Component === "function" && Component.prototype && Component.prototype.isReactComponent);
}
function isForwardRefComponent(Component) {
  var _a;
  return !!(typeof Component === "object" && ((_a = Component.$$typeof) == null ? void 0 : _a.toString()) === "Symbol(react.forward_ref)");
}
class PluginViewRenderer {
  constructor(component, { editor, props = {}, as = "div", wrapper }) {
    this.ref = null;
    this.id = generateRandomId();
    this.component = component;
    this.editor = editor;
    this.props = props;
    this.element = document.createElement(as);
    this.element.classList.add("react-renderer");
    wrapper == null ? void 0 : wrapper.append(this.element);
    this.render();
  }
  render() {
    var _a;
    const Component = this.component;
    const props = this.props;
    if (isClassComponent(Component) || isForwardRefComponent(Component)) {
      props.ref = (ref) => {
        this.ref = ref;
      };
    }
    this.reactElement = /* @__PURE__ */ React__default.createElement(Component, {
      ...props
    });
    if (this.editor.options.useFlushSync) {
      flushSync(() => {
        var _a2;
        if ((_a2 = this.editor) == null ? void 0 : _a2.contentComponent) {
          this.editor.contentComponent.setState({
            renderers: this.editor.contentComponent.state.renderers.set(
              this.id,
              this
            )
          });
        }
      });
    } else {
      if ((_a = this.editor) == null ? void 0 : _a.contentComponent) {
        this.editor.contentComponent.setState({
          renderers: this.editor.contentComponent.state.renderers.set(
            this.id,
            this
          )
        });
      }
    }
  }
  updateProps(props = {}) {
    this.props = {
      ...this.props,
      ...props
    };
    this.render();
  }
  destroy() {
    var _a, _b;
    if (this.editor.options.useFlushSync) {
      flushSync(() => {
        var _a2;
        if ((_a2 = this.editor) == null ? void 0 : _a2.contentComponent) {
          const { renderers } = this.editor.contentComponent.state;
          renderers.delete(this.id);
          this.editor.contentComponent.setState({
            renderers
          });
        }
      });
    } else {
      if ((_a = this.editor) == null ? void 0 : _a.contentComponent) {
        const { renderers } = this.editor.contentComponent.state;
        renderers.delete(this.id);
        this.editor.contentComponent.setState({
          renderers
        });
      }
    }
    (_b = this.element.parentElement) == null ? void 0 : _b.removeChild(this.element);
  }
}
const getColorSelection = (editor) => {
  var _a, _b;
  if (!editor)
    return void 0;
  const fontColor = (_a = editor.getAttributes("textStyle")) == null ? void 0 : _a.fontColor;
  const highlightColor = (_b = editor.getAttributes(MarkTypes.HIGHLIGHT)) == null ? void 0 : _b.color;
  if (!fontColor && !highlightColor)
    return void 0;
  const type = fontColor ? "text" : "background";
  return {
    type,
    color: type === "text" ? fontColor : highlightColor
  };
};
const PRE_TAG_REGEX = /(?:^|<\/pre>)[^]*?(?:<pre>|$)/g;
const NEW_LINE_REGEX = /[\n\t]+/g;
const options = {
  parseOptions: {
    preserveWhitespace: false
  }
};
const insertContent = (editorApi, content, at) => {
  if (typeof content === "string") {
    content = content.replace(PRE_TAG_REGEX, function(m) {
      return m.replace(NEW_LINE_REGEX, "");
    });
  }
  if (at) {
    return editorApi.commands.insertContentAt(at, content, options);
  }
  return editorApi.commands.insertContent(content, options);
};
const headingIcon = (level) => {
  switch (level) {
    case 1:
      return /* @__PURE__ */ React__default.createElement(Icon, {
        icon: Icons.H1,
        height: 20
      });
    case 2:
      return /* @__PURE__ */ React__default.createElement(Icon, {
        icon: Icons.H2,
        height: 20
      });
    case 3:
      return /* @__PURE__ */ React__default.createElement(Icon, {
        icon: Icons.H3,
        height: 20
      });
    default:
      return /* @__PURE__ */ React__default.createElement(Icon, {
        icon: Icons.H1,
        height: 20
      });
  }
};
const ParagraphBlockConfigWithIcon = {
  ...ParagraphBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.TEXT2,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, "0"]
  })
};
const HeadingBlockConfigWithIcon = (level) => ({
  ...HeadingBlockConfig(level),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, `${level}`]
  }),
  icon: headingIcon(level)
});
const BulletBlockConfigWithIcon = {
  ...BulletBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.UNORDERED_LIST,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, "5"]
  })
};
const NumberedBlockConfigWithIcon = {
  ...NumberedBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.ORDERED_LIST,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, "6"]
  })
};
const TaskBlockConfigWithIcon = {
  ...TaskBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.TODOLIST,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, "4"]
  })
};
const QuoteBlockConfigWithIcon = {
  ...QuoteBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.QUOTE,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, "8"]
  })
};
const CodeBlockConfigWithIcon = {
  ...CodeBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CODE,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, "7"]
  })
};
const DividerBlockConfigWithIcon = {
  ...DividerBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.DIVIDER_VERTICAL,
    height: 20
  })
};
const EmbedBlockConfigWithIcon = {
  ...EmbedBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.PLAY,
    height: 20
  })
};
const TableOfContentBlockConfigWithIcon = {
  ...TableOfContentBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.ALIGN_LEFT
  })
};
const AddNoteConfigWithIcon = {
  ...AddNoteConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CARD_FILLED,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: [Key.COMMAND, Key.OPTION, "9"]
  })
};
const HighlightsConfigWithIcon = {
  ...HighlightsConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.MARKER,
    height: 20
  })
};
const ConnectionConfigWithIcon = {
  ...ConnectionConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CONNECTION,
    height: 20
  }),
  shortcut: /* @__PURE__ */ React__default.createElement(Shortcut, {
    keys: ["[", "["]
  })
};
const FileBlockConfigWithIcon = (previewType) => ({
  ...FileBlockConfig(previewType),
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.DOWNLOAD,
    height: 20,
    style: { transform: "rotate(180deg)" }
  })
});
const ClipBlockConfigWithIcon = {
  ...ClipBlockConfig,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.ALIGNED
  })
};
const ALL_BLOCK_COMMANDS = [
  ParagraphBlockConfigWithIcon,
  HeadingBlockConfigWithIcon(1),
  HeadingBlockConfigWithIcon(2),
  HeadingBlockConfigWithIcon(3),
  TaskBlockConfigWithIcon,
  BulletBlockConfigWithIcon,
  NumberedBlockConfigWithIcon,
  CodeBlockConfigWithIcon,
  QuoteBlockConfigWithIcon,
  AddNoteConfigWithIcon,
  ConnectionConfigWithIcon,
  DividerBlockConfigWithIcon,
  EmbedBlockConfigWithIcon,
  ClipBlockConfigWithIcon,
  FileBlockConfigWithIcon(PreviewFile.IMAGE),
  FileBlockConfigWithIcon(PreviewFile.PDF),
  FileBlockConfigWithIcon(PreviewFile.FILE),
  TableOfContentBlockConfigWithIcon,
  HighlightsConfigWithIcon
];
const turnBlockInto = (editorApi, command) => {
  const { state } = editorApi;
  const wrappingBlock = getCurrentBlock(state.doc, state.selection.from);
  const toggleCommand = ALL_BLOCK_COMMANDS.find(
    (r) => r.schemaType === (wrappingBlock == null ? void 0 : wrappingBlock.node.type.name)
  );
  if (toggleCommand == null ? void 0 : toggleCommand.unsetNodeToParagraph)
    toggleCommand == null ? void 0 : toggleCommand.unsetNodeToParagraph(editorApi);
  command.runCommand(editorApi);
};
const runCommand = (editorApi, commandType, commandConfig) => {
  const command = COMMANDS[commandType];
  command == null ? void 0 : command(editorApi, commandConfig);
};
const COMMANDS = {
  "basic-content": (editorApi, command) => basicCommand(editorApi, command),
  "basic-node-view-content": (editorApi, command) => command.runCommand(editorApi),
  "turn-into": (editorApi, command) => turnBlockInto(editorApi, command),
  mark: (editorApi, command) => command.runCommand(editorApi)
};
const basicCommand = (editorApi, command) => {
  var _a;
  const block = getCurrentBlock(
    editorApi.state.doc,
    editorApi.state.selection.anchor
  );
  const shouldCreateNewParagraph = (block == null ? void 0 : block.node.type.spec.group) !== SeshatNodeGroups.BLOCK || ((_a = block == null ? void 0 : block.node.attrs) == null ? void 0 : _a.type) !== BlockTypes.PARAGRAPH || (block == null ? void 0 : block.node.textContent) !== "";
  if (shouldCreateNewParagraph)
    editorApi.commands.insertBlock();
  command.runCommand(editorApi);
};
const toggleColorSelection = (editorApi, type, color) => {
  const storeKey = type === "text" ? "lastUsedColor" : "lastUsedBackgroundColor";
  SessionStorageInterface.set(storeKey, { type, color });
  const current = getColorSelection(editorApi);
  const shouldUnsetColor = (current == null ? void 0 : current.type) === type && (current == null ? void 0 : current.color) === color;
  if (type === "text") {
    const chain = editorApi == null ? void 0 : editorApi.chain().focus().unsetHighlight();
    if (shouldUnsetColor)
      return chain.unsetFontColor().run();
    return chain.setFontColor(color).run();
  }
  if (type === "background") {
    const chain = editorApi == null ? void 0 : editorApi.chain().focus().unsetFontColor();
    if (shouldUnsetColor)
      return chain.unsetHighlight().run();
    return chain.setHighlight({ color }).run();
  }
  return false;
};
const EditorQueries = {
  insertContent,
  getColorSelection,
  toggleColorSelection,
  runCommand,
  turnBlockInto
};
const getFromNToFromRange = (ranges) => {
  const from = Math.min(...ranges.map((range) => range.$from.pos));
  const to = Math.max(...ranges.map((range) => range.$to.pos));
  return { from, to };
};
const BALLOON_MENU_HEIGHT = 32;
const COLOR_SHORTCUT = [Key.COMMAND, Key.SHIFT, "C"];
const HIGHLIGHT_SHORTCUT = [Key.COMMAND, Key.SHIFT, "H"];
const textStylesValues = [
  {
    value: "bold",
    label: "Bold",
    icon: Icons.BOLD,
    shortcut: [Key.COMMAND, "B"],
    runCommand: (editorApi) => {
      editorApi == null ? void 0 : editorApi.commands.toggleBold();
    }
  },
  {
    value: "underline",
    label: "Underline",
    icon: Icons.UNDERLINE,
    shortcut: [Key.COMMAND, "U"],
    runCommand: (editorApi) => {
      editorApi == null ? void 0 : editorApi.commands.toggleUnderline();
    }
  },
  {
    value: "italic",
    label: "Italic",
    icon: Icons.ITALIC,
    shortcut: [Key.COMMAND, "I"],
    runCommand: (editorApi) => {
      editorApi == null ? void 0 : editorApi.commands.toggleItalic();
    }
  },
  {
    value: "strike",
    label: "Strikethrough",
    shortcut: [Key.COMMAND, Key.SHIFT, "S"],
    icon: Icons.STRIKETHROUGH,
    runCommand: (editorApi) => {
      editorApi == null ? void 0 : editorApi.chain().focus().toggleStrike().run();
    }
  },
  {
    value: "code",
    label: "Code",
    icon: Icons.CODE,
    shortcut: [Key.COMMAND, "E"],
    runCommand: (editorApi) => {
      editorApi == null ? void 0 : editorApi.chain().focus().toggleCode().run();
    }
  },
  {
    value: "link",
    label: "Link",
    icon: Icons.LINK,
    shortcut: [Key.COMMAND, "K"],
    runCommand: (editorApi) => {
      editorApi == null ? void 0 : editorApi.chain().focus().toggleEditLinkMenu().run();
    }
  },
  {
    value: "bidirectionalLink",
    label: "Bidirectional link",
    icon: Icons.BIDIRECTIONAL_LINK,
    shortcut: ["[", "["],
    runCommand: (editorApi) => {
      editorApi == null ? void 0 : editorApi.chain().insertMentionPlaceholderOnTextSelection({}).closeBalloonMenu().run();
    }
  }
];
const textColorsValues = [
  ...GroupColors.sort((a, b) => {
    if (a.order && b.order)
      return a.order - b.order;
    return a.order;
  }).map(
    (item) => {
      return {
        value: item.title,
        colors: { color: item.color },
        label: item.title,
        icon: Icons.TEXT_COLOR
      };
    }
  )
];
const textHighlightValues = [
  ...GroupHighlightColors.map(
    (item) => {
      return {
        value: item.title,
        colors: { color: item.color },
        colorForIcon: item.colorForIcon,
        label: item.title,
        icon: Icons.MARKER2
      };
    }
  )
];
const textTypeValues = [
  {
    icon: Icons.TEXT1,
    value: BlockTypes.PARAGRAPH,
    label: "Text",
    shortcut: [Key.COMMAND, Key.SHIFT, "0"]
  },
  {
    icon: Icons.H1,
    value: BlockTypes.HEADING_1,
    label: "Heading 1",
    shortcut: [Key.COMMAND, Key.SHIFT, "1"]
  },
  {
    icon: Icons.H2,
    value: BlockTypes.HEADING_2,
    label: "Heading 2",
    shortcut: [Key.COMMAND, Key.SHIFT, "2"]
  },
  {
    icon: Icons.H3,
    value: BlockTypes.HEADING_3,
    label: "Heading 3",
    shortcut: [Key.COMMAND, Key.SHIFT, "3"]
  },
  {
    icon: Icons.UNORDERED_LIST,
    value: BlockTypes.BULLETED_LIST,
    label: "Bullet List",
    shortcut: [Key.COMMAND, Key.SHIFT, "4"]
  },
  {
    icon: Icons.ORDERED_LIST,
    value: BlockTypes.NUMBERED_LIST,
    label: "Numbered List",
    shortcut: [Key.COMMAND, Key.SHIFT, "5"]
  },
  {
    icon: Icons.CODE,
    value: BlockTypes.CODE,
    label: "Code",
    shortcut: [Key.COMMAND, Key.SHIFT, "6"]
  },
  {
    icon: Icons.QUOTE,
    value: BlockTypes.BLOCKQUOTE,
    label: "Quote",
    shortcut: [Key.COMMAND, Key.SHIFT, "7"]
  }
];
const textJustifyValues = [
  {
    icon: Icons.ALIGN_LEFT,
    value: "left",
    label: "Left"
  },
  {
    icon: Icons.ALIGNED,
    value: "center",
    label: "Center"
  },
  {
    icon: Icons.ALIGNED,
    value: "right",
    label: "Right"
  },
  {
    icon: Icons.ALIGNED,
    value: "justify",
    label: "Justify"
  }
];
const useCurrentSelectionValuesOnMount = (editor) => {
  const [
    selectionValues,
    setSelectionValues
  ] = useState({});
  useEffect(() => {
    const { state } = editor;
    const node = state.selection.$anchor.parent;
    if (!node)
      return;
    const parentNode = getCurrentBlock(state.doc, state.selection.from);
    const type = textTypeValues.find(
      (textType) => {
        var _a;
        return textType.value === ((_a = parentNode == null ? void 0 : parentNode.node) == null ? void 0 : _a.attrs.type);
      }
    );
    const color = textColorsValues.find(
      (textColor) => {
        var _a;
        return ((_a = textColor.colors) == null ? void 0 : _a.color) === getMarkAttributes(editor.view.state, "textStyle").fontColor;
      }
    );
    const highlightColor = textHighlightValues.find((textColor) => {
      var _a;
      return ((_a = textColor.colors) == null ? void 0 : _a.color) === getMarkAttributes(editor.view.state, "highlight").color;
    });
    setSelectionValues({
      type,
      color,
      highlightColor
    });
  }, []);
  return selectionValues;
};
const balloonMenuWrapperStyles = ({
  palette: { grey },
  transitions,
  zIndex
}) => ({
  height: BALLOON_MENU_HEIGHT,
  width: "fit-content",
  zIndex: zIndex.tooltip,
  position: "relative",
  display: "flex",
  background: "none",
  "& .MuiDivider-root": {
    height: 12,
    alignSelf: "center"
  },
  "& .MuiSelect-select": {
    pl: 1,
    display: "flex",
    alignItems: "center",
    minHeight: "unset !important",
    "&.Mui-selected.last-used, &.active.last-used": {
      bgcolor: "initial",
      color: "primary.main",
      border: "none"
    }
  },
  "& .MuiSelect-icon, .MuiBox-root > .MuiSvgIcon-root": {
    transition: transitions.create("all", {
      duration: transitions.duration.shortest
    })
  },
  "& .MuiToggleButtonGroup-root, & .MuiButtonGroup-root": {
    alignItems: "center",
    gap: "2px",
    px: "2px",
    "& .MuiToggleButton-root": {
      borderRadius: "4px !important",
      border: "unset",
      ml: "1 !important",
      p: "4px",
      color: grey["200"],
      bgcolor: "initial",
      "&:hover": {
        color: "#fff"
      },
      "&.Mui-selected, &.active": {
        bgcolor: "initial",
        color: "primary.main"
      }
    }
  },
  "& .MuiInput-root:first-of-type, & .MuiInput-root:last-of-type": {
    borderRadius: "8px"
  }
});
const BalloonMenuWrapper = ({
  children
}) => /* @__PURE__ */ React__default.createElement(Paper, {
  id: "ballon_seshat",
  elevation: 4,
  sx: {
    width: "fit-content",
    background: ({ palette }) => alpha(palette.background.default, 0.7),
    "& .MuiPaper-root": {
      background: "none"
    },
    "&:before": {
      content: '" "',
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: 2,
      backdropFilter: `blur(10px)`
    }
  }
}, /* @__PURE__ */ React__default.createElement(Paper, {
  sx: balloonMenuWrapperStyles,
  elevation: 8
}, children));
const tooltipStyles$1 = ({ palette }) => ({
  color: "grey.50",
  width: "100%",
  padding: "0px 11px 0px 14px",
  "& .MuiTypography-root": {
    color: "grey.50",
    bgcolor: alpha(palette.background.default, 0.7),
    backdropFilter: `blur(8px)`
  }
});
const BalloonToggleButton = ({ tooltipTitle, title, children, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(Tooltip$1, {
    title: tooltipTitle,
    componentsProps: { tooltip: { sx: tooltipStyles$1 } },
    PopperProps: { disablePortal: true }
  }, /* @__PURE__ */ React__default.createElement(ToggleButton, {
    ...props,
    disableRipple: true
  }, children));
};
const OpenLauncherButton = ({
  openLauncher,
  openTooltip,
  openLauncherShortcut
}) => {
  const handleMouseDown = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      openLauncher == null ? void 0 : openLauncher();
    },
    [openLauncher]
  );
  return /* @__PURE__ */ React__default.createElement(ToggleButtonGroup, null, /* @__PURE__ */ React__default.createElement(BalloonToggleButton, {
    title: "note",
    tooltipTitle: openTooltip === false ? "" : /* @__PURE__ */ React__default.createElement(Box, {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }, "Note", " ", /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: (openLauncherShortcut || "\u2318+L").split("+")
    })),
    value: "",
    onMouseDown: handleMouseDown
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.QUICK_NOTE,
    size: 22
  })));
};
const tooltipStyles = {
  "&&, .MuiTypography-root": {
    color: "grey.100"
  }
};
const selectStylesTextType = (open) => ({
  transitions,
  palette: { text }
}) => ({
  whiteSpace: "nowrap",
  color: open ? "text.primary" : "grey.200",
  "* .MuiTypography-root, .MuiSelect-iconStandard": {
    color: open ? "text.primary" : "grey.100"
  },
  "& .MuiSelect-icon, .MuiBox-root > .MuiSvgIcon-root": {
    transition: transitions.create("all", {
      duration: transitions.duration.shortest
    })
  },
  "&.MuiButtonBase-root.MuiToggleButton-root, .MuiTypography-root, .MuiSelect-iconStandard": {
    color: open ? "text.primary" : "grey.200"
  },
  "&:hover > .MuiTypography-root": {
    color: "text.primary"
  },
  "& .MuiList-root": {
    "& .MuiMenuItem-root": {
      ".MuiBox-root > .MuiTypography-root": {
        color: text.secondary
      },
      ".MuiBox-root > .MuiSvgIcon-root path": {
        stroke: text.disabled
      }
    }
  }
});
const selectStyles = (open) => ({
  ...selectStylesTextType(open),
  '[aria-expanded="true"] > svg': {
    stroke: "text.primary"
  }
});
const balloonSelectMenuStyles = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  },
  disableAutoFocus: true,
  disableEnforceFocus: true,
  PaperProps: {
    sx: ({ palette: { grey, background } }) => ({
      mt: 0.5,
      background: alpha(background.default, 0.7),
      backdropFilter: `blur(10px)`,
      width: 221,
      boxSizing: "border-box",
      pl: 0.5,
      color: "text.primary",
      "& .MuiList-root": {
        maxHeight: 150,
        py: 1,
        overflowY: "auto",
        scrollBehavior: "smooth",
        scrollSnapType: "y mandatory",
        pr: 0.25,
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        background: "none",
        "&::-webkit-scrollbar": {
          display: "initial",
          width: 12
        },
        "&::-webkit-scrollbar-track": {
          borderRadius: "9999px",
          bgcolor: grey["400"],
          border: "4px solid rgba(0, 0, 0, 0)",
          backgroundClip: "padding-box"
        },
        "&::-webkit-scrollbar-thumb": {
          bgcolor: grey["200"],
          borderRadius: "9999px",
          border: "4px solid rgba(0, 0, 0, 0)",
          backgroundClip: "padding-box"
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: grey["300"],
          borderRadius: "9999px",
          border: "4px solid rgba(0, 0, 0, 0)",
          backgroundClip: "padding-box"
        },
        "& .MuiMenuItem-root": {
          display: "flex",
          justifyContent: "space-between",
          scrollSnapAlign: "center",
          px: 0.5,
          py: 0,
          minHeight: 28,
          borderRadius: 2,
          border: "1px solid transparent",
          "&:hover": {
            border: `1px solid ${grey["200"]}`,
            bgcolor: alpha(background.default, 0.7)
          },
          "&.Mui-focusVisible": {
            border: `1px solid ${grey["200"]}`,
            bgcolor: alpha(background.paper, 0.7)
          },
          "&.Mui-selected": {
            border: `1px solid ${grey["200"]}`
          }
        }
      }
    })
  }
};
const DEFAULT_LABEL = "Default";
const BalloonSelect = ({
  name,
  options: options2,
  value,
  onChange,
  renderValue,
  shortcut,
  lastUsedColor,
  lastUsedBackgroundColor,
  openPopoverRef,
  setOpenPopoverRef,
  isTextType
}) => {
  var _a;
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const ref = useRef(null);
  const openTooltip = useCallback(() => setIsTooltipOpen(true), [
    setIsTooltipOpen
  ]);
  const closeTooltip = useCallback(() => setIsTooltipOpen(false), [
    setIsTooltipOpen
  ]);
  const lastUsedItem = React__default.useMemo(() => {
    if (!lastUsedColor && !lastUsedBackgroundColor)
      return;
    if (name === "Highlight") {
      const highlightItem = options2.find(
        (textColor) => {
          var _a2;
          return ((_a2 = textColor.colors) == null ? void 0 : _a2.color) === (lastUsedBackgroundColor == null ? void 0 : lastUsedBackgroundColor.color);
        }
      );
      return (highlightItem == null ? void 0 : highlightItem.label) === DEFAULT_LABEL ? void 0 : highlightItem;
    }
    const colorItem = options2.find(
      (textColor) => {
        var _a2;
        return ((_a2 = textColor.colors) == null ? void 0 : _a2.color) === (lastUsedColor == null ? void 0 : lastUsedColor.color);
      }
    );
    return (colorItem == null ? void 0 : colorItem.label) === DEFAULT_LABEL ? void 0 : colorItem;
  }, [lastUsedBackgroundColor, lastUsedColor, name, options2]);
  const isDefaultItem = useCallback(
    (v) => v.label !== DEFAULT_LABEL || value.label !== DEFAULT_LABEL,
    [value.label]
  );
  const TooltipShortcut = useMemo(() => {
    if (!shortcut)
      return name;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, {
      sx: { pr: 1 }
    }, name), /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: shortcut
    }));
  }, [name, shortcut]);
  React__default.useEffect(
    () => () => {
      if (isTooltipOpen)
        closeTooltip();
    },
    []
  );
  const handleClick = useCallback(
    (event) => {
      event.preventDefault();
      setOpenPopoverRef(
        event.currentTarget !== openPopoverRef ? event.currentTarget : null
      );
    },
    [openPopoverRef, setOpenPopoverRef]
  );
  const handleClickItem = useCallback(
    (event, value2) => {
      event.preventDefault();
      event.stopPropagation();
      onChange == null ? void 0 : onChange(event, value2);
      setOpenPopoverRef(null);
    },
    [onChange, setOpenPopoverRef]
  );
  const handleClose = useCallback(() => {
    setOpenPopoverRef(null);
    closeTooltip();
  }, [closeTooltip, setOpenPopoverRef]);
  const open = Boolean(ref.current && ref.current === openPopoverRef);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Tooltip$1, {
    title: TooltipShortcut,
    open: isTooltipOpen,
    componentsProps: { tooltip: { sx: tooltipStyles } },
    PopperProps: { disablePortal: true }
  }, /* @__PURE__ */ React__default.createElement(ToggleButton, {
    disableRipple: true,
    value: 1,
    ref,
    onMouseDown: handleClick,
    onMouseEnter: openTooltip,
    onMouseLeave: closeTooltip,
    sx: selectStylesTextType(open)
  }, renderValue(value), isTextType && /* @__PURE__ */ React__default.createElement(Icon, {
    icon: open ? Icons.CHEVRON_UP : Icons.CHEVRON_DOWN
  }))), /* @__PURE__ */ React__default.createElement(Popover, {
    sx: isTextType ? selectStylesTextType(open) : selectStyles(open),
    open,
    anchorEl: ref.current,
    onClose: handleClose,
    onMouseDown: (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleClose();
    },
    ...balloonSelectMenuStyles
  }, /* @__PURE__ */ React__default.createElement(List, null, lastUsedItem && [
    /* @__PURE__ */ React__default.createElement(MenuItem, {
      value: lastUsedItem,
      key: "lastUsed",
      className: "last-used",
      onMouseDown: (e) => handleClickItem(e, lastUsedItem)
    }, /* @__PURE__ */ React__default.createElement(Box, {
      sx: { display: "flex", gap: 1 }
    }, /* @__PURE__ */ React__default.createElement(Icon, {
      color: "text.secondary",
      icon: value.icon,
      sx: {
        color: lastUsedItem.colorForIcon || ((_a = lastUsedItem.colors) == null ? void 0 : _a.color) || "currentColor",
        "& path": { stroke: "currentColor" }
      }
    }), /* @__PURE__ */ React__default.createElement(Box, {
      sx: { display: "flex", gap: 4 }
    }, /* @__PURE__ */ React__default.createElement(Typography, {
      variant: "body2",
      alignSelf: "center"
    }, "Last used"), /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: shortcut || [""]
    })))),
    /* @__PURE__ */ React__default.createElement(Divider, {
      orientation: "horizontal",
      key: "horizontal",
      sx: { ".Mui-Divider": { marginTop: "4px" } }
    })
  ], options2.map((v) => {
    var _a2;
    if (isDefaultItem(v))
      return /* @__PURE__ */ React__default.createElement(MenuItem, {
        value: v,
        key: v.label,
        onMouseDown: (e) => handleClickItem(e, v),
        selected: value === v
      }, /* @__PURE__ */ React__default.createElement(Box, {
        sx: { display: "flex", gap: 1 }
      }, /* @__PURE__ */ React__default.createElement(Icon, {
        color: "text.secondary",
        icon: v.icon,
        sx: {
          color: v.colorForIcon || ((_a2 = v.colors) == null ? void 0 : _a2.color) || "currentColor",
          "& path": { stroke: "currentColor" }
        }
      }), /* @__PURE__ */ React__default.createElement(Typography, {
        variant: "body2",
        alignSelf: "center"
      }, v.label)), v.shortcut && /* @__PURE__ */ React__default.createElement(Shortcut, {
        keys: v.shortcut
      }));
    return false;
  }))));
};
const BalloonMenuMainEditor = ({
  editor,
  textStyles,
  currentSelection,
  onTextTypeChange,
  onTextStylesChange,
  onTextColorChange,
  onHighlightColorChange,
  openLauncher,
  lastUsedColor,
  lastUsedBackgroundColor,
  openLauncherShortcut
}) => {
  const [
    openPopoverRef,
    setOpenPopoverRef
  ] = useState(null);
  const onTextTypeSelectChange = useCallback(
    (_e, { value }) => onTextTypeChange(value),
    [onTextTypeChange]
  );
  const handleColor = useCallback(
    (_e, value) => onTextColorChange(value.colors.color),
    [onTextColorChange]
  );
  const handleHighlight = useCallback(
    (_e, value) => onHighlightColorChange(value.colors.color),
    [onHighlightColorChange]
  );
  const shouldDisplayCaptureOnClip = useMemo(() => {
    var _a, _b;
    const $from = (_b = (_a = editor == null ? void 0 : editor.state) == null ? void 0 : _a.selection) == null ? void 0 : _b.$from;
    const parentNode = $from.node(SESHAT_CONTENT_DEPTH);
    return openLauncher && (parentNode == null ? void 0 : parentNode.attrs.type) === BlockTypes.CLIP_CONTENT;
  }, [editor, openLauncher]);
  return /* @__PURE__ */ React__default.createElement(BalloonMenuWrapper, null, /* @__PURE__ */ React__default.createElement(ButtonGroup, null, /* @__PURE__ */ React__default.createElement(BalloonSelect, {
    name: "Text type",
    options: textTypeValues,
    value: (currentSelection == null ? void 0 : currentSelection.type) || textTypeValues[0],
    onChange: onTextTypeSelectChange,
    renderValue: (value) => /* @__PURE__ */ React__default.createElement(Typography, null, value.label),
    openPopoverRef,
    setOpenPopoverRef,
    isTextType: true
  })), /* @__PURE__ */ React__default.createElement(Divider, {
    orientation: "vertical",
    flexItem: true
  }), /* @__PURE__ */ React__default.createElement(ToggleButtonGroup, {
    value: textStyles
  }, textStylesValues.map((selectionAction) => /* @__PURE__ */ React__default.createElement(BalloonToggleButton, {
    title: selectionAction.label,
    tooltipTitle: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, {
      sx: { pr: 1 }
    }, selectionAction.label), selectionAction.shortcut && /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: selectionAction.shortcut
    })),
    value: selectionAction.value,
    key: selectionAction.label,
    onMouseDown: (e) => {
      e.preventDefault();
      onTextStylesChange(selectionAction);
      setOpenPopoverRef(null);
    },
    className: editor.isActive(selectionAction.value) ? "active" : ""
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: selectionAction.icon,
    size: 20
  })))), /* @__PURE__ */ React__default.createElement(ButtonGroup, null, /* @__PURE__ */ React__default.createElement(BalloonSelect, {
    name: "Text colors",
    options: textColorsValues,
    value: (currentSelection == null ? void 0 : currentSelection.color) || textColorsValues[0],
    onChange: handleColor,
    lastUsedColor,
    shortcut: COLOR_SHORTCUT,
    renderValue: (value) => {
      var _a, _b;
      return /* @__PURE__ */ React__default.createElement(Icon, {
        size: 20,
        icon: value.icon,
        sx: {
          color: (_b = value.colorForIcon) != null ? _b : ((_a = value.colors) == null ? void 0 : _a.color) || "currentColor",
          "& path": { stroke: "currentColor" }
        }
      });
    },
    openPopoverRef,
    setOpenPopoverRef
  }), /* @__PURE__ */ React__default.createElement(BalloonSelect, {
    name: "Highlight",
    options: textHighlightValues,
    value: (currentSelection == null ? void 0 : currentSelection.highlightColor) || textHighlightValues[0],
    onChange: handleHighlight,
    lastUsedBackgroundColor,
    shortcut: HIGHLIGHT_SHORTCUT,
    renderValue: (value) => {
      var _a;
      return /* @__PURE__ */ React__default.createElement(Icon, {
        size: 20,
        icon: value.icon,
        sx: {
          color: value.colorForIcon || ((_a = value.colors) == null ? void 0 : _a.color) || "currentColor",
          "& path": { stroke: "currentColor" }
        }
      });
    },
    openPopoverRef,
    setOpenPopoverRef
  }), shouldDisplayCaptureOnClip && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Divider, {
    orientation: "vertical",
    flexItem: true
  }), /* @__PURE__ */ React__default.createElement(OpenLauncherButton, {
    openLauncher,
    openLauncherShortcut
  }))));
};
const getCurrentSelectionColor = (currentSelection) => {
  var _a, _b, _c, _d, _e;
  if (!!((_b = (_a = currentSelection == null ? void 0 : currentSelection.highlightColor) == null ? void 0 : _a.colors) == null ? void 0 : _b.color) && ((_d = (_c = currentSelection == null ? void 0 : currentSelection.highlightColor) == null ? void 0 : _c.colors) == null ? void 0 : _d.color) !== "inherit")
    return "inherit";
  return (_e = GroupHighlightColors.find((c) => c.title === "Yellow")) == null ? void 0 : _e.color;
};
const BalloonMenuReadLater = ({
  editor,
  currentSelection,
  openLauncher,
  openLauncherShortcut
}) => {
  var _a, _b, _c;
  const [open, setOpen] = useState(false);
  const color = getCurrentSelectionColor(currentSelection);
  const removeHighlight = useCallback(() => {
    editor.chain().focus().unsetHighlight().focusAtSelectionEnd().run();
  }, [editor]);
  const onHighlightColorChange = useCallback(
    (color2) => {
      if (color2 === "inherit")
        return removeHighlight();
      editor.chain().focus().setHighlight({ color: color2 }).focusAtSelectionEnd().run();
    },
    [editor, removeHighlight]
  );
  return /* @__PURE__ */ React__default.createElement(BalloonMenuWrapper, null, /* @__PURE__ */ React__default.createElement(ToggleButtonGroup, null, (currentSelection == null ? void 0 : currentSelection.highlightColor) ? /* @__PURE__ */ React__default.createElement(BalloonToggleButton, {
    title: "Remove Highlight",
    tooltipTitle: open === "removeHighlight" ? /* @__PURE__ */ React__default.createElement(Box, {
      sx: { whiteSpace: "nowrap" }
    }, "Remove Highlight") : "",
    value: "",
    onMouseEnter: () => setOpen("removeHighlight"),
    onMouseDown: () => {
      setOpen(false);
      removeHighlight();
    }
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.TRASH,
    size: 22
  })) : /* @__PURE__ */ React__default.createElement(BalloonToggleButton, {
    title: "Highlight",
    value: "",
    tooltipTitle: open === "highlight" ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, {
      sx: { pr: 1 }
    }, "Highlight"), /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: HIGHLIGHT_SHORTCUT
    })) : "",
    onMouseOver: () => setOpen("highlight"),
    onMouseDown: (e) => {
      if (typeof color !== "string")
        return;
      e.preventDefault();
      setOpen(false);
      onHighlightColorChange(color);
    }
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.MARKER2,
    size: 22,
    sx: {
      color: (_c = (_b = (_a = currentSelection == null ? void 0 : currentSelection.highlightColor) == null ? void 0 : _a.colors) == null ? void 0 : _b.color) != null ? _c : "currentColor",
      "& path": { stroke: "currentColor" }
    }
  }))), /* @__PURE__ */ React__default.createElement(Divider, {
    orientation: "vertical",
    flexItem: true
  }), /* @__PURE__ */ React__default.createElement(Box, {
    onMouseDown: () => setOpen(false),
    onMouseOver: () => setOpen("note")
  }, /* @__PURE__ */ React__default.createElement(OpenLauncherButton, {
    openLauncher,
    openTooltip: open === "note",
    openLauncherShortcut
  })));
};
const BalloonMenu = ({ editor, options: options2 }) => {
  const [lastUsedColor, setLastUsedColor] = useState(
    SessionStorageInterface.get("lastUsedColor")
  );
  const [lastUsedBackgroundColor, setLastUsedBackgroundColor] = useState(
    SessionStorageInterface.get("lastUsedBackgroundColor")
  );
  const getRect = useCallback(() => {
    const { ranges } = editor.state.selection;
    const { from, to } = getFromNToFromRange(ranges);
    if (isNodeSelection(editor.state.selection)) {
      const node = editor.view.nodeDOM(from);
      if (node)
        return node.getBoundingClientRect();
    }
    return posToDOMRect(editor.view, from, to);
  }, [editor]);
  const currentSelectionValues = useCurrentSelectionValuesOnMount(editor);
  const mainEditorMenu = /* @__PURE__ */ React__default.createElement(BalloonMenuMainEditor, {
    editor,
    openLauncherShortcut: options2 == null ? void 0 : options2.openLauncherShortcut,
    textType: textTypeValues[0],
    textStyles: [textStylesValues[0].toString()],
    textColors: textColorsValues[0],
    textJustify: textJustifyValues[0],
    openLauncher: options2 == null ? void 0 : options2.openLauncher,
    currentSelection: currentSelectionValues,
    inputError: "Error",
    lastUsedColor,
    lastUsedBackgroundColor,
    onTextTypeChange: (value) => editor.chain().focus().updateBlockAttributes({ type: value }).run(),
    onTextStylesChange: (format) => {
      if (format.runCommand)
        format.runCommand(editor);
    },
    onTextColorChange: (value) => {
      if (value === "inherit") {
        editor.commands.unsetFontColor();
        return;
      }
      EditorQueries.toggleColorSelection(editor, "text", value);
      setLastUsedColor({ color: value, type: "text" });
    },
    onHighlightColorChange: (value) => {
      if (value === "inherit") {
        editor.commands.unsetHighlight();
        return;
      } else {
        EditorQueries.toggleColorSelection(editor, "background", value);
        setLastUsedBackgroundColor({ color: value, type: "background" });
      }
    },
    onTextJustifyChange: (value) => editor.chain().focus().setAlign(value).run()
  });
  const readLaterMenu = /* @__PURE__ */ React__default.createElement(BalloonMenuReadLater, {
    editor,
    openLauncher: options2 == null ? void 0 : options2.openLauncher,
    currentSelection: currentSelectionValues,
    openLauncherShortcut: options2 == null ? void 0 : options2.openLauncherShortcut
  });
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Tippy, {
    interactive: true,
    showOnCreate: true,
    trigger: "manual",
    getReferenceClientRect: getRect,
    content: (options2 == null ? void 0 : options2.extensionVersion) === "read_later_view" ? readLaterMenu : mainEditorMenu,
    appendTo: () => {
      var _a, _b;
      return ((_b = (_a = editor == null ? void 0 : editor.view) == null ? void 0 : _a.dom) == null ? void 0 : _b.parentElement) || document.body;
    }
  }));
};
const balloonMenuRenderer = () => {
  let reactRenderer;
  return {
    onStart: ({ editor, ...props }) => {
      reactRenderer = new PluginViewRenderer(BalloonMenu, {
        editor,
        props: { editor, ...props }
      });
    },
    onUpdate({ editor, ...props }) {
      reactRenderer == null ? void 0 : reactRenderer.updateProps({ editor, ...props });
    },
    onExit() {
      const oldRenderer = reactRenderer;
      setTimeout(() => {
        oldRenderer == null ? void 0 : oldRenderer.destroy();
      }, 0);
      reactRenderer = void 0;
    }
  };
};
const BalloonMenuPluginKey = new PluginKey("balloonMenuPlugin");
const closeBalloonMenu = () => ({ dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(closeBalloonMenuTransaction(tr));
  return true;
};
const closeBalloonMenuTransaction = (tr) => {
  return tr.setMeta(BalloonMenuPluginKey, { isOpen: false });
};
const openBalloonMenu = () => ({ dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(openBalloonMenuTransaction(tr));
  return true;
};
const openBalloonMenuTransaction = (tr) => {
  return tr.setMeta(BalloonMenuPluginKey, { isOpen: true });
};
const shouldShowBalloonMenu = (view) => {
  var _a;
  const { state, composing } = view;
  const { doc, selection } = state;
  if (composing || !view.hasFocus())
    return false;
  if (isBlockSelection(state.selection))
    return false;
  const { ranges, $anchor } = selection;
  const from = Math.min(...ranges.map((range) => range.$from.pos));
  const to = Math.max(...ranges.map((range) => range.$to.pos));
  const isEmptyTextBlock = doc.textBetween(from, to).length === 0 && selection instanceof TextSelection;
  if (selection.empty || isEmptyTextBlock)
    return false;
  const node = $anchor.parent;
  const isReactComponent = node.type.name === SeshatNodes.CONTENT_NODE_VIEW;
  if (isReactComponent)
    return false;
  const parentNode = getCurrentBlock(doc, selection.from);
  if (((_a = parentNode == null ? void 0 : parentNode.node) == null ? void 0 : _a.attrs.type) === BlockTypes.CARD_CONTENT)
    return false;
  if ((parentNode == null ? void 0 : parentNode.node.attrs.type) === BlockTypes.CLIP_CONTENT_TITLE)
    return false;
  const isReadLaterDecoration = node.content.content[0] && node.content.content[0].type.name === NodeViewTypes.READ_LATER_DECORATION;
  if (isReadLaterDecoration)
    return false;
  return true;
};
const balloonMenuPlugin = (editor) => (options2) => {
  const render = balloonMenuRenderer();
  return new Plugin({
    key: BalloonMenuPluginKey,
    state: {
      init() {
        return { isOpen: false };
      },
      apply(tr, pluginState) {
        const action = tr.getMeta(BalloonMenuPluginKey);
        return action ? { isOpen: action.isOpen } : pluginState;
      }
    },
    props: {
      handleDOMEvents: {
        mousedown: (view) => {
          const onMouseUp = () => {
            var _a;
            if (shouldShowBalloonMenu(view))
              (_a = view.dispatch) == null ? void 0 : _a.call(view, openBalloonMenuTransaction(view.state.tr));
            document.removeEventListener("mouseup", onMouseUp);
          };
          document.addEventListener("mouseup", onMouseUp);
          return false;
        },
        keyup: (view) => {
          var _a;
          if (shouldShowBalloonMenu(view))
            (_a = view.dispatch) == null ? void 0 : _a.call(view, openBalloonMenuTransaction(view.state.tr));
          return false;
        }
      }
    },
    appendTransaction(trs, _2, state) {
      if (shouldCloseBalloonMenu(trs, state))
        return closeBalloonMenuTransaction(state.tr);
      else
        return;
    },
    view() {
      return {
        update: ({ state }, prevState) => {
          var _a, _b, _c, _d, _e;
          const prev = (_a = this.key) == null ? void 0 : _a.getState(prevState);
          const next = (_b = this.key) == null ? void 0 : _b.getState(state);
          const createRender = !(prev == null ? void 0 : prev.isOpen) && (next == null ? void 0 : next.isOpen);
          const updateRender = (prev == null ? void 0 : prev.isOpen) && (next == null ? void 0 : next.isOpen);
          const destroyRender = (prev == null ? void 0 : prev.isOpen) && !(next == null ? void 0 : next.isOpen);
          if (createRender)
            (_c = render == null ? void 0 : render.onStart) == null ? void 0 : _c.call(render, { editor, options: options2 });
          if (updateRender)
            (_d = render == null ? void 0 : render.onUpdate) == null ? void 0 : _d.call(render, { editor, options: options2 });
          if (destroyRender)
            (_e = render == null ? void 0 : render.onExit) == null ? void 0 : _e.call(render);
        }
      };
    }
  });
};
const shouldCloseBalloonMenu = (trs, state) => {
  var _a;
  return ((_a = BalloonMenuPluginKey.getState(state)) == null ? void 0 : _a.isOpen) && trs.some((tr) => tr.selectionSet && !tr.getMeta(BalloonMenuPluginKey));
};
const toggleBalloonMenu = () => ({ dispatch, tr, state }) => {
  dispatch == null ? void 0 : dispatch(toggleBalloonMenuTransaction(state, tr));
  return true;
};
const toggleBalloonMenuTransaction = (state, tr) => {
  var _a;
  const isOpen = (_a = BalloonMenuPluginKey.getState(state)) == null ? void 0 : _a.isOpen;
  return tr.setMeta(BalloonMenuPluginKey, { isOpen: !isOpen });
};
const BalloonMenuExtension = (options2) => Extension.create({
  name: "BalloonMenuExtension",
  addCommands() {
    return {
      closeBalloonMenu,
      openBalloonMenu,
      toggleBalloonMenu
    };
  },
  addProseMirrorPlugins() {
    return [balloonMenuPlugin(this.editor)(options2)];
  }
});
const BLOCK_HANDLES_EXTENSION = "BlockHandlesExtension";
const BLOCK_HANDLES_WIDTH = 32;
const AddBlockHandle = (props) => {
  const clickHandler = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      const buttonHeight = e.currentTarget.clientHeight;
      const view = props.editor.view;
      const position = view.posAtCoords({
        top: e.clientY - buttonHeight,
        left: e.clientX + BLOCK_HANDLES_WIDTH + 50
      });
      if (position) {
        props.editor.chain().setTextSelection(position.pos).insertBlock({ type: BlockTypes.PARAGRAPH }).run();
      }
    },
    [props.editor]
  );
  const onMouseDownHandle = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  return /* @__PURE__ */ React__default.createElement(IconButton, {
    contentEditable: false,
    onClick: clickHandler,
    onMouseDown: onMouseDownHandle,
    size: "small",
    sx: { padding: 0, color: "text.secondary" }
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.ADD,
    size: 24
  }));
};
const getBlockNextToHandle = (view, coords) => {
  var _a;
  if (document.querySelector(`[${SelectionBoxSelector}]`))
    return void 0;
  const pos = (_a = view.posAtCoords({
    left: coords.x + BLOCK_HANDLES_WIDTH + 50,
    top: coords.y
  })) == null ? void 0 : _a.pos;
  let $block = pos && getCurrentBlock(view.state.doc, pos);
  if (!$block)
    return void 0;
  if ($block.node.attrs.type === BlockTypes.HIGHLIGHT)
    $block = getCurrentBlock(view.state.doc, $block.from - 1);
  if (!$block)
    return void 0;
  const block = { ...$block, dom: view.nodeDOM($block.from) };
  return shouldShow(block) ? block : void 0;
};
const shouldShow = (block) => {
  var _a, _b;
  if (block.from === 0)
    return false;
  if (!((_a = block.dom) == null ? void 0 : _a.isContentEditable) && !isClipElement(block.dom))
    return false;
  return !((_b = block.dom) == null ? void 0 : _b.matches(`
  [type="${BlockTypes.BLOCK_COLUMN}"],
  [type="${BlockTypes.CLIP_CONTENT_TITLE}"],
  [type="${BlockTypes.BLOCK_LINE}"],
  [type="${BlockTypes.HIGHLIGHT}"],
  [type="${BlockTypes.HIGHLIGHT}"] *
  `));
};
const isClipElement = (block) => {
  const type = block == null ? void 0 : block.getAttribute("type");
  if (!type)
    return false;
  return [
    BlockTypes.CLIP_CONTENT,
    NodeViewTypes.CLIP_BOOK
  ].includes(type);
};
const DRAG_HANDLE_SELECTOR = "[data-drag-handle]";
const DragHandle = (props) => {
  const editor = props.editor;
  const view = editor.view;
  const mouseUpHandler = useCallback(
    (e) => {
      const coords = { x: e.clientX, y: e.clientY };
      const block = getBlockNextToHandle(view, coords);
      if (!block)
        return;
      editor.chain().focus(block.from).selectCurrentBlock().run();
    },
    [editor, view]
  );
  const dragStartHandler = useCallback(
    (e) => {
      const coords = { x: e.clientX, y: e.clientY };
      const block = getBlockNextToHandle(view, coords);
      if (!block)
        return;
      const { doc } = view.state;
      const selection = BlockSelection.createFromPosition(doc, block.from);
      const slice = new Slice(selection.getFragment(), 0, 0);
      view.dragging = { slice, block, move: true };
      e.dataTransfer.dropEffect = "move";
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setDragImage(block.dom, 0, 0);
    },
    [view]
  );
  const dragEndHandler = useCallback(
    (e) => {
      e.dataTransfer.dropEffect = "move";
      e.dataTransfer.effectAllowed = "move";
      editor.commands.focus();
    },
    [editor]
  );
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(IconButton, {
    "data-drag-handle": true,
    draggable: true,
    contentEditable: false,
    onDragStart: dragStartHandler,
    onDragEnd: dragEndHandler,
    onMouseUp: mouseUpHandler,
    size: "small",
    sx: {
      padding: 0,
      color: "text.secondary",
      cursor: "grab",
      userSelect: "none",
      "&:active": {
        cursor: "grabbing"
      }
    }
  }, /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.DRAG,
    style: { fill: "currentColor" },
    size: 24
  })));
};
const style$1 = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  position: "absolute",
  width: `${BLOCK_HANDLES_WIDTH}px`,
  transition: "opacity 350ms ease-out",
  opacity: 0,
  flexDirection: "column"
};
const BlockHandles = ({
  targetElement,
  editor,
  visible = true
}) => {
  const refDiv = React__default.useRef(null);
  const setOpacity = (visible2) => {
    if (!refDiv.current) {
      return;
    }
    refDiv.current.style.opacity = visible2 ? "0.5" : "0";
  };
  useLayoutEffect(() => {
    const timeout = setTimeout(() => setOpacity(visible), 30);
    return () => clearTimeout(timeout);
  }, [visible]);
  if (targetElement && refDiv.current) {
    setPosition({ element: refDiv.current, block: targetElement });
  }
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Box, {
    sx: style$1,
    ref: refDiv,
    "data-block-handles": true
  }, /* @__PURE__ */ React__default.createElement(DragHandle, {
    editor
  }), /* @__PURE__ */ React__default.createElement(AddBlockHandle, {
    editor
  })));
};
const setPosition = ({
  element,
  block
}) => {
  var _a;
  const offsetParent = (_a = element.offsetParent) != null ? _a : document.body;
  const offsetRect = offsetParent == null ? void 0 : offsetParent.getBoundingClientRect();
  const targetRect = block.getBoundingClientRect();
  element.style.top = `${getTop({
    block,
    targetRect,
    offsetRect
  })}px`;
  element.style.right = `${getRight({
    block,
    targetRect,
    offsetRect
  })}px`;
};
const getRight = ({
  block,
  targetRect,
  offsetRect
}) => {
  const offsetLeft = isFirstBlockOfHighlightNote(block) ? offsetRect.width - targetRect.right : targetRect.left;
  const extraLeftPadding = block.offsetLeft < 20 ? block.offsetLeft : 0;
  return offsetRect.right - offsetLeft + extraLeftPadding;
};
const getTop = ({
  block,
  targetRect,
  offsetRect
}) => {
  var _a;
  const content = (_a = block.querySelector(`.${SeshatCssClass.CONTENT}`)) != null ? _a : block;
  const blockContentCSS = getComputedStyle(content);
  const paddingTop = parseInt(blockContentCSS.paddingTop);
  let lineHeight = parseInt(blockContentCSS.lineHeight);
  lineHeight = !isNaN(lineHeight) ? lineHeight : 19;
  return targetRect.top - ((offsetRect == null ? void 0 : offsetRect.top) || 0) + (lineHeight - 24) / 2 + paddingTop;
};
const isFirstBlockOfHighlightNote = (block) => {
  var _a, _b;
  return ((_a = block.parentElement) == null ? void 0 : _a.firstElementChild) === block && ((_b = block.parentElement.parentElement) == null ? void 0 : _b.getAttribute("type")) === BlockTypes.HIGHLIGHT_NOTE;
};
const blockHandlesRenderer = (options2) => {
  let reactRenderer;
  return {
    isMounted: () => !!reactRenderer,
    onStart: ({ editor, ...props }) => {
      var _a;
      reactRenderer = new PluginViewRenderer(BlockHandles, {
        editor,
        props: { editor, ...props, ...options2 },
        wrapper: (_a = document.getElementById(EDITOR_CONTENT_DOM_ID)) != null ? _a : document.body
      });
    },
    onUpdate({ editor, ...props }) {
      reactRenderer == null ? void 0 : reactRenderer.updateProps({ editor, ...props, ...options2 });
    },
    onExit() {
      const oldRenderer = reactRenderer;
      setTimeout(() => {
        oldRenderer == null ? void 0 : oldRenderer.destroy();
      }, 0);
      reactRenderer = void 0;
    }
  };
};
const BlockHandlesPluginKey = new PluginKey("BlockHandlesPlugin");
const BlockHandlesPlugin = ({
  editor,
  options: options2
}) => {
  var _a;
  const render = blockHandlesRenderer(options2);
  let currentTarget;
  const wrapper = (_a = document.getElementById(EDITOR_CONTENT_DOM_ID)) != null ? _a : document.body;
  const hideRender = () => {
    var _a2;
    (_a2 = render.onUpdate) == null ? void 0 : _a2.call(render, {
      editor,
      visible: false,
      position: void 0,
      targetElement: void 0
    });
    currentTarget = void 0;
  };
  const destroyRender = () => {
    var _a2;
    (_a2 = render.onExit) == null ? void 0 : _a2.call(render);
  };
  return new Plugin({
    key: BlockHandlesPluginKey,
    view: () => {
      wrapper == null ? void 0 : wrapper.addEventListener("mouseleave", destroyRender);
      return {
        update() {
          var _a2;
          if (!currentTarget || !((_a2 = render.isMounted) == null ? void 0 : _a2.call(render)) || !render.onUpdate) {
            return;
          }
          const props = {
            editor,
            visible: true,
            position: currentTarget.from,
            targetElement: currentTarget.dom
          };
          render.onUpdate(props);
        },
        destroy() {
          destroyRender();
          wrapper == null ? void 0 : wrapper.removeEventListener("mouseleave", destroyRender);
        }
      };
    },
    props: {
      handleDOMEvents: {
        mousemove(view, e) {
          var _a2, _b, _c, _d;
          if (!(e instanceof MouseEvent))
            return;
          const block = getBlockNextToHandle(view, {
            x: e.clientX,
            y: e.clientY
          });
          if (!block) {
            hideRender();
            return false;
          }
          if (block === currentTarget)
            return false;
          const props = {
            editor,
            visible: true,
            position: block.from,
            targetElement: block.dom
          };
          if ((_a2 = render.isMounted) == null ? void 0 : _a2.call(render)) {
            (_b = render.onUpdate) == null ? void 0 : _b.call(render, props);
          } else {
            const oldHandles = document.querySelector("[data-block-handles]");
            if (oldHandles)
              (_c = oldHandles.parentNode) == null ? void 0 : _c.removeChild(oldHandles);
            (_d = render.onStart) == null ? void 0 : _d.call(render, props);
          }
          currentTarget = block;
          return false;
        },
        keyup() {
          hideRender();
          return false;
        }
      }
    }
  });
};
const BlockHandlesExtension = (options2) => Extension.create({
  name: BLOCK_HANDLES_EXTENSION,
  addProseMirrorPlugins() {
    return [
      BlockHandlesPlugin({
        editor: this.editor,
        options: options2 == null ? void 0 : options2.blockHandle
      }),
      PreventDraggingPlugin()
    ];
  }
});
const PreventDraggingPlugin = () => {
  return new Plugin({
    props: {
      handleDOMEvents: {
        dragstart: (_2, event) => {
          event.preventDefault();
          return true;
        }
      }
    }
  });
};
class PlaceholderBallonView {
  constructor({
    editor,
    element,
    view,
    tippyOptions,
    shouldShow: shouldShow2
  }) {
    this.preventHide = false;
    this.shouldShow = ({ state }) => {
      const { selection } = state;
      const { $anchor, empty } = selection;
      const isRootDepth = $anchor.depth === 1;
      const isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent;
      if (!empty || !isRootDepth || !isEmptyTextBlock) {
        return false;
      }
      return true;
    };
    this.mousedownHandler = () => {
      this.preventHide = true;
    };
    this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    };
    this.blurHandler = ({ event }) => {
      var _a;
      if (this.preventHide) {
        this.preventHide = false;
        return;
      }
      if ((event == null ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) == null ? void 0 : _a.contains(event.relatedTarget))) {
        return;
      }
      if (this.editor.getText().length !== 0) {
        const activeElement = window.document.activeElement;
        this.hide();
        if (activeElement === this.view.dom) {
          setTimeout(() => activeElement.focus());
        }
      }
    };
    this.editor = editor;
    this.element = element;
    this.view = view;
    if (shouldShow2) {
      this.shouldShow = shouldShow2;
    }
    this.element.addEventListener("mousedown", this.mousedownHandler, {
      capture: true
    });
    this.editor.on("focus", this.focusHandler);
    this.editor.on("blur", this.blurHandler);
    this.createTooltip(tippyOptions);
    this.element.style.visibility = "visible";
  }
  createTooltip(options2 = {}) {
    this.tippy = tippy(this.view.dom, {
      duration: 0,
      maxWidth: "100%",
      getReferenceClientRect: null,
      content: this.element,
      trigger: "manual",
      appendTo: "parent",
      placement: "right",
      hideOnClick: "toggle",
      popperOptions: {
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              mainAxis: false
            }
          }
        ]
      },
      ...options2
    });
  }
  update(view, oldState) {
    const { state } = view;
    if (!this.editor.isFocused)
      return;
    if (isBlockSelection(state.selection)) {
      this.hide();
      return;
    }
    const shouldShow2 = this.shouldShow({
      editor: this.editor,
      view,
      state,
      oldState
    });
    if (!shouldShow2) {
      this.hide();
      return;
    }
    const { doc, selection } = state;
    const { from, to } = selection;
    const isSame = (oldState == null ? void 0 : oldState.doc.eq(doc)) && oldState.selection.$anchor.pos === selection.$anchor.pos;
    if (isSame) {
      return;
    }
    this.show(view, from, to);
  }
  show(view, from, to) {
    const docSize = view.state.doc.nodeSize;
    const isWithinDoc = from < docSize && to < docSize;
    if (!isWithinDoc)
      return;
    this.tippy.setProps({
      getReferenceClientRect: () => {
        try {
          return posToDOMRect(view, from, to);
        } catch (err) {
          return new DOMRect();
        }
      }
    });
    this.tippy.show();
  }
  hide() {
    this.tippy.hide();
  }
  destroy() {
    this.tippy.destroy();
    this.element.removeEventListener("mousedown", this.mousedownHandler);
    this.editor.off("focus", this.focusHandler);
    this.editor.off("blur", this.blurHandler);
  }
}
const PlaceholderBallonPlugin = (options2) => {
  return new Plugin({
    key: typeof options2.pluginKey === "string" ? new PluginKey(options2.pluginKey) : options2.pluginKey,
    view: (view) => new PlaceholderBallonView({ view, ...options2 })
  });
};
const placeholders = {
  title: {
    tag: "h1",
    content: "Undefined"
  },
  [BlockTypes.HEADING_1]: {
    tag: "h1",
    content: "Heading 1"
  },
  [BlockTypes.HEADING_2]: {
    tag: "h2",
    content: "Heading 2"
  },
  [BlockTypes.HEADING_3]: {
    tag: "h3",
    content: "Heading 3"
  },
  [BlockTypes.HEADING_4]: {
    tag: "h4",
    content: "Heading 4"
  },
  [BlockTypes.BLOCKQUOTE]: {
    tag: "div",
    content: "Quote"
  },
  [BlockTypes.BULLETED_LIST]: {
    tag: "div",
    content: "Bullet List"
  },
  [BlockTypes.NUMBERED_LIST]: {
    tag: "div",
    content: "Ordered List"
  },
  [BlockTypes.TOGGLE_LIST]: {
    tag: "div",
    content: "Toggle List"
  },
  [BlockTypes.NODE_VIEW]: false,
  [BlockTypes.HIGHLIGHT_NOTE]: {
    tag: "div",
    content: /* @__PURE__ */ React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden"
      },
      gap: 0.5
    }, "Add a note or hit", /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: "/"
    }), /* @__PURE__ */ React__default.createElement(Box, {
      component: "span",
      sx: {
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }, "for lazy commands"))
  },
  [BlockTypes.PARAGRAPH]: {
    tag: "div",
    content: /* @__PURE__ */ React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden"
      },
      gap: 0.5
    }, "Hit", /* @__PURE__ */ React__default.createElement(Shortcut, {
      keys: "/"
    }), /* @__PURE__ */ React__default.createElement(Box, {
      component: "span",
      sx: {
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }, "for lazy commands"))
  }
};
const getDefaultFontSize = () => "var(--font-size-text-editor)";
const POSITION_CARET_FIRST_LINE = 4;
const TAKE_PARENT_TYPE_FOR_PLACEHOLDER = [BlockTypes.HIGHLIGHT_NOTE];
const getPlaceholderForCurrentBlock = (editor) => {
  var _a;
  const element = getCurrentBlock(
    editor.state.doc,
    editor.state.selection.from
  );
  const node = element == null ? void 0 : element.node;
  const typeAttr = (node == null ? void 0 : node.attrs.type) || (node == null ? void 0 : node.type.name);
  const type = (node == null ? void 0 : node.type) + ((node == null ? void 0 : node.attrs.level) || "");
  const parentType = (_a = element == null ? void 0 : element.$from.node(element.depth - 1)) == null ? void 0 : _a.attrs.type;
  if (TAKE_PARENT_TYPE_FOR_PLACEHOLDER.includes(parentType))
    return placeholders[parentType];
  return placeholders[typeAttr || type];
};
const getCurrentSelectionStyle = () => {
  var _a, _b, _c;
  const selectedDomElement = (_c = (_b = (_a = document.getSelection()) == null ? void 0 : _a.anchorNode) == null ? void 0 : _b.parentElement) == null ? void 0 : _c.children[0];
  if (selectedDomElement) {
    const computeStyle = window.getComputedStyle(selectedDomElement);
    return {
      lineHeight: computeStyle.lineHeight,
      fontSize: computeStyle.fontSize,
      padding: computeStyle.padding,
      height: computeStyle.height,
      width: computeStyle.width
    };
  }
  return { fontSize: getDefaultFontSize() };
};
const isNodeEmpty = (state) => {
  const { selection } = state;
  return !selection.$anchor.parent.textContent && !selection.$anchor.parent.childCount;
};
const getPlaceholderContent = (editor) => {
  if (!isNodeEmpty(editor.state))
    return;
  const placeholderForCurrentBlock = getPlaceholderForCurrentBlock(editor);
  return placeholderForCurrentBlock;
};
const isFirstLineEmpty = (editor) => {
  var _a;
  const { doc, selection } = editor.state;
  const { from } = selection;
  if (from !== POSITION_CARET_FIRST_LINE)
    return false;
  if (!isNodeEmpty(editor.state))
    return false;
  return ((_a = getCurrentBlock(doc, from)) == null ? void 0 : _a.node.attrs.type) === BlockTypes.PARAGRAPH;
};
const PlaceholderBallonHandler = (props) => {
  const element = useRef(null);
  useEffect(
    () => {
      const { pluginKey, editor, tippyOptions, shouldShow: shouldShow2 } = props;
      editor.registerPlugin(
        PlaceholderBallonPlugin({
          pluginKey,
          editor,
          element: element.current,
          tippyOptions,
          shouldShow: shouldShow2
        })
      );
      return () => {
        editor.unregisterPlugin(pluginKey);
      };
    },
    []
  );
  return /* @__PURE__ */ React__default.createElement("div", {
    id: props.tippyElementId,
    ref: element,
    className: props.className,
    style: { visibility: "hidden" }
  }, props.children);
};
const PLACEHOLDER_PLUGIN_KEY = "floating-placeholder";
const PlaceholderBallon = ({
  editor,
  firstLinePlaceholder
}) => {
  const [displayContent, setDisplayContent] = useState(false);
  const [selectionStyle, setSelectionStyle] = useState({
    fontSize: getDefaultFontSize()
  });
  const [placeholder, setPlaceholder] = useState(
    placeholders.paragraph
  );
  const showPlaceholder = (placeholder2) => {
    setDisplayContent(true);
    setPlaceholder(placeholder2);
    setSelectionStyle(getCurrentSelectionStyle());
    return true;
  };
  const shouldShowHandle = ({
    editor: editor2,
    state
  }) => {
    if (firstLinePlaceholder && isFirstLineEmpty(editor2)) {
      return showPlaceholder(firstLinePlaceholder);
    }
    const placeholderContent = getPlaceholderContent(editor2);
    if (!placeholderContent || isCaretInEmptyClip(state)) {
      setDisplayContent(false);
      return false;
    }
    return showPlaceholder(placeholderContent);
  };
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(PlaceholderBallonHandler, {
    pluginKey: PLACEHOLDER_PLUGIN_KEY,
    tippyElementId: PLACEHOLDER_PLUGIN_KEY,
    editor,
    shouldShow: shouldShowHandle,
    tippyOptions: {
      zIndex: 0
    }
  }, displayContent && placeholder && /* @__PURE__ */ React__default.createElement(Box$1, {
    component: placeholder.tag,
    sx: {
      ...selectionStyle,
      color: "text.hint",
      userSelect: "none",
      marginLeft: "-9.5px",
      display: "flex"
    },
    contentEditable: false
  }, placeholder.content)));
};
const Container$1 = styled$1("div")((prop) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  lineHeight: "120%",
  userSelect: "none",
  minHeight: "28px",
  maxHeight: "28px",
  fontSize: "12px",
  cursor: "pointer",
  paddingRight: "14px",
  backgroundColor: "inherit",
  border: `0.5px solid transparent`,
  borderRadius: prop.theme.shape.borderRadius + 4,
  color: prop.theme.palette.grey["100"],
  marginBottom: "1px",
  "& .MuiTypography-root": {
    color: "currentColor"
  },
  "&:hover": {
    backgroundColor: prop.theme.palette.grey["500"],
    border: `0.5px solid #545454`,
    color: prop.theme.palette.grey["50"]
  },
  "&.isSelected": {
    backgroundColor: "rgba(38, 39, 44, 0.64)",
    border: `0.5px solid #545454`,
    color: prop.theme.palette.grey["50"]
  }
}));
const PopoverItem = React__default.forwardRef(
  ({ onMouseDown, children, isSelected }, ref) => {
    return /* @__PURE__ */ React__default.createElement(Container$1, {
      ref,
      className: isSelected ? "isSelected" : "",
      onMouseDown
    }, children);
  }
);
const OFFSET = 100;
const getItemScrollPosition = (containerDiv, itemDiv) => {
  const itemRect = itemDiv.getBoundingClientRect();
  const parentRect = containerDiv.getBoundingClientRect();
  const itemTopPosition = itemRect.top - parentRect.top + containerDiv.scrollTop;
  const isItemOverflowAtBottomOfContainer = itemTopPosition < (containerDiv == null ? void 0 : containerDiv.scrollTop) + OFFSET;
  const isItemOverflowAtTopOfContainer = itemTopPosition + OFFSET > parentRect.height + containerDiv.scrollTop;
  const shouldScroll = isItemOverflowAtBottomOfContainer || isItemOverflowAtTopOfContainer;
  const isFirstItem = itemRect.top + containerDiv.scrollTop - parentRect.top < itemRect.height;
  const isLastItem = itemRect.top - itemRect.height + containerDiv.scrollTop > containerDiv.scrollHeight;
  const behavior = isFirstItem || isLastItem ? "auto" : "smooth";
  return {
    shouldScroll,
    behavior,
    top: itemTopPosition - parentRect.height + OFFSET
  };
};
const useContainerScrollToItemPosition = ({
  itemRef,
  isSelectedItem,
  containerRef
}) => {
  React__default.useEffect(() => {
    if (!isSelectedItem)
      return;
    if (!(itemRef == null ? void 0 : itemRef.current) || !(containerRef == null ? void 0 : containerRef.current))
      return;
    var { shouldScroll, behavior, top } = getItemScrollPosition(
      containerRef == null ? void 0 : containerRef.current,
      itemRef.current
    );
    if (shouldScroll)
      containerRef.current.scrollTo({
        behavior,
        top
      });
  }, [containerRef, isSelectedItem, itemRef]);
};
const StyledIconContainer = styled$1("div")({
  width: "20px",
  height: "20px",
  borderRadius: "4px",
  fontWeight: 700,
  padding: "8px",
  margin: "8px 5px 8px 0",
  overflow: "hidden"
});
const TrailingMenuItem = ({
  popOverRef,
  onMouseDown,
  item,
  isActive
}) => {
  const itemRef = React__default.useRef(null);
  useContainerScrollToItemPosition({
    itemRef,
    containerRef: popOverRef,
    isSelectedItem: isActive != null ? isActive : false
  });
  return /* @__PURE__ */ React__default.createElement(PopoverItem, {
    ref: itemRef,
    isSelected: isActive,
    onMouseDown: () => onMouseDown == null ? void 0 : onMouseDown(item)
  }, item.icon && /* @__PURE__ */ React__default.createElement(StyledIconContainer, {
    className: "flex_column align_center justify_center",
    itemType: item.schemaType
  }, item.icon), /* @__PURE__ */ React__default.createElement(Typography$1, null, item.title), /* @__PURE__ */ React__default.createElement(Box$1, {
    sx: { position: "absolute", right: "5px" }
  }, item.shortcut && item.shortcut));
};
const shouldHide = (editor, item) => {
  var _a, _b;
  return (_b = (_a = item.shouldBeHidden) == null ? void 0 : _a.call(item, editor)) != null ? _b : false;
};
const Container = styled$1("div")(() => ({
  display: "flex",
  flexDirection: "column",
  paddingBottom: "6px"
}));
const Title = ({ typography }) => ({
  ...typography.overline,
  display: "flex",
  marginBottom: "8px",
  paddingLeft: "3px",
  color: "text.hint",
  bgcolor: "transparent"
});
const PopoverGroup = ({ title, children }) => {
  return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement(Box, {
    sx: Title
  }, title), children);
};
const TrailingMenuItemGroup$1 = ({
  editor,
  group,
  popOverRef,
  onMouseDown,
  isItemSelected
}) => {
  var _a, _b;
  const shouldDisplayGroup = React__default.useMemo(
    () => {
      var _a2, _b2;
      return (_b2 = (_a2 = group == null ? void 0 : group.items) == null ? void 0 : _a2.filter((item) => !shouldHide(editor, item))) == null ? void 0 : _b2.length;
    },
    [group, editor]
  );
  return shouldDisplayGroup ? /* @__PURE__ */ React__default.createElement(PopoverGroup, {
    title: group.groupTitle
  }, (_b = (_a = group == null ? void 0 : group.items) == null ? void 0 : _a.filter((item) => !shouldHide(editor, item))) == null ? void 0 : _b.map((item, index) => /* @__PURE__ */ React__default.createElement(TrailingMenuItem, {
    popOverRef,
    key: index,
    isActive: isItemSelected(index),
    onMouseDown,
    item
  }))) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
};
const useSelectItem = ({ editor, range, items }) => {
  return React__default.useCallback(
    ({
      selectedIndex,
      selectedItem
    }) => {
      const item = selectedIndex !== void 0 && selectedIndex !== null ? items[selectedIndex] : selectedItem;
      if (item) {
        if (range)
          editor.chain().focus().deleteRange(range).run();
        EditorQueries.runCommand(editor, item.currentCommandType, item);
      }
    },
    [editor, items, range]
  );
};
const COMMANDS_POPOVER_HEIGHT = 254;
const TrailingMenuItemGroups = forwardRef(
  (props, ref) => {
    const popOverRef = useRef(null);
    const { items: groups, editor, range } = props;
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [finalItems, setFinalItems] = useState(
      deriveItemsFromGroups(editor, groups)
    );
    const selectItem = useSelectItem({ editor, range, items: finalItems });
    useEffect(() => {
      setSelectedIndex(0);
      setFinalItems(deriveItemsFromGroups(editor, groups));
    }, [editor, groups, setFinalItems]);
    const upHandler = useCallback(() => {
      setSelectedIndex(
        (selectedIndex + finalItems.length - 1) % finalItems.length
      );
    }, [finalItems.length, selectedIndex]);
    const downHandler = useCallback(() => {
      setSelectedIndex((selectedIndex + 1) % finalItems.length);
    }, [finalItems.length, selectedIndex]);
    const enterHandler = useCallback(() => {
      selectItem({ selectedIndex });
    }, [selectItem, selectedIndex]);
    const onKeyPress = useCallback(
      ({ event, destroyHandler }) => {
        if (event.key === "ArrowUp") {
          upHandler();
          return true;
        }
        if (event.key === "ArrowDown") {
          downHandler();
          return true;
        }
        if (event.key === "Enter") {
          enterHandler();
          return true;
        }
        if (event.key === "Escape" && destroyHandler) {
          destroyHandler();
          return true;
        }
        return false;
      },
      [upHandler, downHandler, enterHandler]
    );
    useImperativeHandle(ref, () => ({
      onKeyPress
    }));
    const isItemSelected = useCallback(
      (thresholdGroup) => (index) => {
        return thresholdGroup + index === selectedIndex;
      },
      [selectedIndex]
    );
    let groupIndexThreshold = 0;
    return /* @__PURE__ */ React__default.createElement(PopOverContainer, {
      id: "trailing-menu-popover",
      height: COMMANDS_POPOVER_HEIGHT
    }, /* @__PURE__ */ React__default.createElement(SimpleBar, {
      tabIndex: -1,
      scrollableNodeProps: { ref: popOverRef },
      style: { height: `${COMMANDS_POPOVER_HEIGHT - 8}px` }
    }, finalItems.length <= 0 && /* @__PURE__ */ React__default.createElement(Typography$1, {
      m: 2,
      sx: { color: theme.palette.grey["200"] }
    }, "No results found"), groups.map((group) => {
      var _a, _b;
      const comp = /* @__PURE__ */ React__default.createElement(TrailingMenuItemGroup$1, {
        popOverRef,
        key: `${group.groupTitle}`,
        group,
        editor,
        onMouseDown: (selectedItem) => selectItem({ selectedItem }),
        isItemSelected: isItemSelected(groupIndexThreshold)
      });
      groupIndexThreshold += (_b = (_a = group == null ? void 0 : group.items) == null ? void 0 : _a.length) != null ? _b : 0;
      return comp;
    })));
  }
);
const deriveItemsFromGroups = (editor, groups) => {
  var _a;
  return (_a = groups == null ? void 0 : groups.flatMap((group) => group == null ? void 0 : group.items)) == null ? void 0 : _a.filter((item) => !shouldHide(editor, item));
};
const TrailingMenuItemsRenderer = () => {
  let reactRenderer;
  let popup;
  return {
    onStart: (props) => {
      reactRenderer = new PluginViewRenderer(TrailingMenuItemGroups, {
        editor: props.editor,
        props
      });
      popup = tippy("body", {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.getElementById(EDITOR_CONTENT_DOM_ID) || document.body,
        content: reactRenderer.element,
        showOnCreate: true,
        interactive: true,
        trigger: "manual",
        placement: "bottom-start"
      });
    },
    onUpdate(props) {
      reactRenderer == null ? void 0 : reactRenderer.updateProps(props);
      popup == null ? void 0 : popup[0].setProps({
        getReferenceClientRect: props.clientRect
      });
    },
    onKeyDown(props) {
      var _a;
      return (_a = reactRenderer == null ? void 0 : reactRenderer.ref) == null ? void 0 : _a.onKeyPress({
        ...props,
        destroyHandler: () => this.onExit()
      });
    },
    onExit() {
      popup == null ? void 0 : popup[0].destroy();
      reactRenderer == null ? void 0 : reactRenderer.destroy();
    }
  };
};
const EditLinkMenuPluginKey = new PluginKey("EditLinkMenuPlugin");
const colorsCommands = (type) => GroupColors.map((color) => ({
  type: `${type}-${color.title}`,
  title: type === "text" ? color.title : `${color.title} Background`,
  schemaType: type === "text" ? "fontColor" : MarkTypes.HIGHLIGHT,
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    color: "text.secondary",
    icon: type === "text" ? Icons.COLOR_NONE : Icons.MARKER2,
    sx: {
      color: color.color || "currentColor",
      "& path": { stroke: "currentColor" }
    }
  }),
  search: [type, `${type} ${color.title}`, color.title, "color"],
  commandsType: ["mark"],
  runCommand: (editorApi) => EditorQueries.toggleColorSelection(editorApi, type, color.color)
}));
({
  type: `code`,
  title: "Code",
  schemaType: "code",
  search: ["code"],
  commandsType: ["mark"],
  icon: /* @__PURE__ */ React__default.createElement(Icon, {
    icon: Icons.CODE,
    height: 12,
    color: "white"
  }),
  runCommand: (editorApi) => {
    return editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.CODE }).run();
  }
});
const TrailingMenuItemGroup = [
  {
    groupTitle: "Blocks",
    items: ALL_BLOCK_COMMANDS.map((command) => ({
      ...command,
      currentCommandType: command.commandsType.includes(
        "basic-node-view-content"
      ) ? "basic-node-view-content" : "basic-content",
      runCommand: (editor) => {
        return command == null ? void 0 : command.runCommand(editor);
      }
    }))
  },
  {
    groupTitle: "Colors",
    items: colorsCommands("text").map((item) => ({
      ...item,
      currentCommandType: "mark",
      runCommand: (editor) => {
        return item.runCommand(editor);
      }
    }))
  },
  {
    groupTitle: "Turn block into",
    items: ALL_BLOCK_COMMANDS.filter(
      (r) => r.commandsType.includes("turn-into")
    ).map((c) => ({
      ...c,
      currentCommandType: "turn-into",
      search: c.search.map((r) => `turn into ${r}`),
      runCommand: (editor) => {
        return c == null ? void 0 : c.runCommand(editor);
      }
    }))
  },
  {
    groupTitle: "Highlight",
    items: colorsCommands("background").map((item) => ({
      ...item,
      currentCommandType: "mark",
      runCommand: (editor) => {
        return item == null ? void 0 : item.runCommand(editor);
      }
    }))
  }
];
const searchItemsCommand = ({
  query
}) => TrailingMenuItemGroup.map((group) => {
  return {
    ...group,
    items: group.items.filter(
      (item) => item.search.some(
        (search) => search.toLowerCase().indexOf(query.toLowerCase()) > -1
      )
    )
  };
});
const TrailingMenuPluginKey = new PluginKey("trailing-menu");
const TrailingMenuExtension = Extension$1.create({
  name: "TrailingMenuExtension",
  addOptions() {
    return {
      suggestion: {
        char: "/",
        items: searchItemsCommand,
        render: TrailingMenuItemsRenderer,
        startOfLine: false,
        command: ({ editor, range, props }) => {
          props.command({ editor, range });
        },
        allow: ({ editor, range }) => {
          const resolvedPos = editor.state.doc.resolve(range.from);
          return !isCardTitleNode(resolvedPos);
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion$1({
        ...this.options.suggestion,
        pluginKey: TrailingMenuPluginKey,
        editor: this.editor
      })
    ];
  }
});
function findSuggestionMatch(config) {
  const { char, allowSpaces, prefixSpace, startOfLine, $position } = config;
  const escapedChar = char.split("").map((c) => `\\${c}`).join("");
  const suffix = new RegExp(`\\s${escapedChar}$`);
  const prefix = startOfLine ? "^" : "";
  const regexp = allowSpaces ? new RegExp(`${prefix}${escapedChar}.*?(?=\\s${escapedChar}|$)`, "gm") : new RegExp(`${prefix}(?:^)?${escapedChar}[^\\s${escapedChar}]*`, "gm");
  const isTopLevelNode = $position.depth <= 0;
  const textFrom = isTopLevelNode ? 0 : $position.before();
  const textTo = $position.pos;
  const text = $position.doc.textBetween(textFrom, textTo, "\0", "\0");
  const match = Array.from(text.matchAll(regexp)).pop();
  if (!match || match.input === void 0 || match.index === void 0) {
    return null;
  }
  const matchPrefix = match.input.slice(
    Math.max(0, match.index - 1),
    match.index
  );
  const matchPrefixIsSpace = /^[\s\0]?$/.test(matchPrefix);
  if (prefixSpace && !matchPrefixIsSpace) {
    return null;
  }
  const from = match.index + $position.start();
  let to = from + match[0].length;
  if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
    match[0] += " ";
    to += 1;
  }
  if (from < $position.pos && to >= $position.pos) {
    return {
      range: {
        from,
        to
      },
      query: match[0].slice(char.length),
      text: match[0]
    };
  }
  return null;
}
const SuggestionPluginKey$1 = new PluginKey("seshatSuggestion");
function Suggestion({
  pluginKey = SuggestionPluginKey$1,
  editor,
  char = "@",
  allowSpaces = false,
  prefixSpace = true,
  startOfLine = false,
  decorationTag = "span",
  decorationClass = "suggestion",
  command = () => null,
  items = () => [],
  render = () => ({}),
  allow = () => true
}) {
  let props;
  const renderer = render == null ? void 0 : render();
  const plugin = new Plugin({
    key: pluginKey,
    view() {
      return {
        update: async (view, prevState) => {
          var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
          const prev = (_a = this.key) == null ? void 0 : _a.getState(prevState);
          const next = (_b = this.key) == null ? void 0 : _b.getState(view.state);
          const moved = (prev == null ? void 0 : prev.active) && (next == null ? void 0 : next.active) && ((_c = prev.range) == null ? void 0 : _c.from) !== ((_d = next.range) == null ? void 0 : _d.from);
          const started = !(prev == null ? void 0 : prev.active) && (next == null ? void 0 : next.active);
          const stopped = (prev == null ? void 0 : prev.active) && !(next == null ? void 0 : next.active);
          const changed = !started && !stopped && (prev == null ? void 0 : prev.query) !== (next == null ? void 0 : next.query);
          const handleStart = started || moved;
          const handleChange = changed && !moved;
          const handleExit = stopped || moved;
          if (!handleStart && !handleChange && !handleExit || (next == null ? void 0 : next.escape)) {
            return;
          }
          const state = handleExit && !handleStart ? prev : next;
          if (!state)
            return;
          const decorationNode = document.querySelector(
            `[data-decoration-id="${state.decorationId}"]`
          );
          props = {
            editor,
            range: state.range,
            query: (_e = state.query) != null ? _e : "",
            text: (_f = state.text) != null ? _f : "",
            items: handleChange || handleStart ? await items({
              editor,
              query: (_g = state.query) != null ? _g : ""
            }) : [],
            command: (commandProps) => {
              command({
                editor,
                range: state.range,
                props: commandProps
              });
            },
            decorationNode,
            clientRect: decorationNode ? () => {
              var _a2, _b2;
              const { decorationId } = (_b2 = (_a2 = this.key) == null ? void 0 : _a2.getState(editor.state)) != null ? _b2 : {};
              if (!decorationId)
                return new DOMRect();
              const currentDecorationNode = document.querySelector(
                `[data-decoration-id="${decorationId}"]`
              );
              return (currentDecorationNode == null ? void 0 : currentDecorationNode.getBoundingClientRect()) || new DOMRect();
            } : null
          };
          if (handleExit) {
            (_h = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _h.call(renderer, { ...props, escape: true });
          }
          if (handleChange) {
            (_i = renderer == null ? void 0 : renderer.onUpdate) == null ? void 0 : _i.call(renderer, props);
          }
          if (handleStart) {
            (_j = renderer == null ? void 0 : renderer.onStart) == null ? void 0 : _j.call(renderer, props);
          }
        },
        destroy: () => {
          var _a;
          if (!props) {
            return;
          }
          (_a = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _a.call(renderer, props);
        }
      };
    },
    state: {
      init() {
        return {
          active: false,
          range: { from: 0, to: 0 },
          query: null,
          text: null,
          composing: false,
          escape: false
        };
      },
      apply(transaction, prev, state) {
        var _a;
        const { composing } = editor.view;
        const { selection } = transaction;
        const { empty, from } = selection;
        const next = (_a = transaction.getMeta(pluginKey)) != null ? _a : { ...prev };
        next.composing = composing;
        if (empty || editor.view.composing) {
          if ((from < prev.range.from || from > prev.range.to) && !composing && !prev.composing) {
            next.active = false;
          }
          const match = findSuggestionMatch({
            char,
            allowSpaces,
            prefixSpace,
            startOfLine,
            $position: selection.$from
          });
          const decorationId = `id_${Math.floor(Math.random() * 4294967295)}`;
          if (match && allow({ editor, state, range: match.range })) {
            next.active = true;
            next.decorationId = prev.decorationId ? prev.decorationId : decorationId;
            next.range = match.range;
            next.query = match.query;
            next.text = match.text;
            next.escape = prev.decorationId ? next.escape : false;
          } else {
            next.active = false;
          }
        } else {
          next.active = false;
        }
        if (!(next == null ? void 0 : next.active)) {
          next.decorationId = null;
          next.range = {};
          next.query = null;
          next.text = null;
        }
        return next;
      }
    },
    props: {
      handleDOMEvents: {
        keydown(view, event) {
          var _a, _b;
          if (!(event instanceof KeyboardEvent))
            return false;
          const state = plugin.getState(view.state);
          if (!state)
            return false;
          const { active, range } = state;
          if (!active) {
            return false;
          }
          if (event.key === "Escape") {
            view.dispatch(
              view.state.tr.setMeta(pluginKey, { ...state, escape: true })
            );
            (_a = renderer == null ? void 0 : renderer.onExit) == null ? void 0 : _a.call(renderer, state);
            if (!state.escape && state.text)
              return true;
          }
          if (state.escape)
            return false;
          const result = (_b = renderer == null ? void 0 : renderer.onKeyDown) == null ? void 0 : _b.call(renderer, { view, event, range });
          return result || false;
        }
      },
      decorations(state) {
        var _a;
        const { active, range, decorationId } = (_a = plugin.getState(state)) != null ? _a : {};
        if (!active || !range) {
          return null;
        }
        return DecorationSet.create(state.doc, [
          Decoration.inline(range.from, range.to, {
            nodeName: decorationTag,
            class: decorationClass,
            "data-decoration-id": decorationId
          })
        ]);
      }
    }
  });
  return plugin;
}
const SuggestionPluginKey = ({ char }) => new PluginKey(`trailing-menu-fixed-${char}`);
const SuggestionPlugin = ({
  render,
  editor,
  char
}) => {
  return Suggestion({
    char,
    prefixSpace: false,
    items: () => [],
    render,
    command: ({ editor: editor2, range }) => {
      editor2.commands.deleteRange(range);
    },
    pluginKey: SuggestionPluginKey({ char }),
    editor
  });
};
const registerSuggestion = ({
  editor,
  onStart,
  onUpdate,
  onExit,
  chars,
  onKeyDown
}) => {
  if (!editor)
    return;
  chars.forEach((char) => {
    editor.registerPlugin(
      SuggestionPlugin({
        char,
        editor,
        render: () => ({
          onStart: (props) => onStart == null ? void 0 : onStart({ ...props, char }),
          onUpdate: (props) => onUpdate == null ? void 0 : onUpdate({ ...props, char }),
          onExit: (props) => onExit == null ? void 0 : onExit({ ...props, char }),
          onKeyDown: onKeyDown ? (props) => onKeyDown == null ? void 0 : onKeyDown({ ...props, char }) : void 0
        })
      })
    );
  });
};
const ExtendedFontColorExtension = FontColorExtension.extend({
  addKeyboardShortcuts() {
    return {
      [shortcutConfig.lastUsedColor]: ({ editor }) => {
        const lastColor = SessionStorageInterface.get("lastUsedColor");
        if (!lastColor)
          return true;
        EditorQueries.toggleColorSelection(
          editor,
          lastColor.type,
          lastColor.color
        );
        return true;
      }
    };
  }
});
const apple = {
  compressed: true,
  categories: [
    {
      id: "people",
      name: "Smileys & People",
      emojis: [
        "grinning",
        "smiley",
        "smile",
        "grin",
        "laughing",
        "sweat_smile",
        "rolling_on_the_floor_laughing",
        "joy",
        "slightly_smiling_face",
        "upside_down_face",
        "wink",
        "blush",
        "innocent",
        "smiling_face_with_3_hearts",
        "heart_eyes",
        "star-struck",
        "kissing_heart",
        "kissing",
        "relaxed",
        "kissing_closed_eyes",
        "kissing_smiling_eyes",
        "yum",
        "stuck_out_tongue",
        "stuck_out_tongue_winking_eye",
        "zany_face",
        "stuck_out_tongue_closed_eyes",
        "money_mouth_face",
        "hugging_face",
        "face_with_hand_over_mouth",
        "shushing_face",
        "thinking_face",
        "zipper_mouth_face",
        "face_with_raised_eyebrow",
        "neutral_face",
        "expressionless",
        "no_mouth",
        "smirk",
        "unamused",
        "face_with_rolling_eyes",
        "grimacing",
        "lying_face",
        "relieved",
        "pensive",
        "sleepy",
        "drooling_face",
        "sleeping",
        "mask",
        "face_with_thermometer",
        "face_with_head_bandage",
        "nauseated_face",
        "face_vomiting",
        "sneezing_face",
        "hot_face",
        "cold_face",
        "woozy_face",
        "dizzy_face",
        "exploding_head",
        "face_with_cowboy_hat",
        "partying_face",
        "sunglasses",
        "nerd_face",
        "face_with_monocle",
        "confused",
        "worried",
        "slightly_frowning_face",
        "white_frowning_face",
        "open_mouth",
        "hushed",
        "astonished",
        "flushed",
        "pleading_face",
        "frowning",
        "anguished",
        "fearful",
        "cold_sweat",
        "disappointed_relieved",
        "cry",
        "sob",
        "scream",
        "confounded",
        "persevere",
        "disappointed",
        "sweat",
        "weary",
        "tired_face",
        "yawning_face",
        "triumph",
        "rage",
        "angry",
        "face_with_symbols_on_mouth",
        "smiling_imp",
        "imp",
        "skull",
        "skull_and_crossbones",
        "hankey",
        "clown_face",
        "japanese_ogre",
        "japanese_goblin",
        "ghost",
        "alien",
        "space_invader",
        "robot_face",
        "smiley_cat",
        "smile_cat",
        "joy_cat",
        "heart_eyes_cat",
        "smirk_cat",
        "kissing_cat",
        "scream_cat",
        "crying_cat_face",
        "pouting_cat",
        "see_no_evil",
        "hear_no_evil",
        "speak_no_evil",
        "wave",
        "raised_back_of_hand",
        "raised_hand_with_fingers_splayed",
        "hand",
        "spock-hand",
        "ok_hand",
        "pinching_hand",
        "v",
        "crossed_fingers",
        "i_love_you_hand_sign",
        "the_horns",
        "call_me_hand",
        "point_left",
        "point_right",
        "point_up_2",
        "middle_finger",
        "point_down",
        "point_up",
        "+1",
        "-1",
        "fist",
        "facepunch",
        "left-facing_fist",
        "right-facing_fist",
        "clap",
        "raised_hands",
        "open_hands",
        "palms_up_together",
        "handshake",
        "pray",
        "writing_hand",
        "nail_care",
        "selfie",
        "muscle",
        "mechanical_arm",
        "mechanical_leg",
        "leg",
        "foot",
        "ear",
        "ear_with_hearing_aid",
        "nose",
        "brain",
        "tooth",
        "bone",
        "eyes",
        "eye",
        "tongue",
        "lips",
        "baby",
        "child",
        "boy",
        "girl",
        "adult",
        "person_with_blond_hair",
        "man",
        "bearded_person",
        "red_haired_man",
        "curly_haired_man",
        "white_haired_man",
        "bald_man",
        "woman",
        "red_haired_woman",
        "red_haired_person",
        "curly_haired_woman",
        "curly_haired_person",
        "white_haired_woman",
        "white_haired_person",
        "bald_woman",
        "bald_person",
        "blond-haired-woman",
        "blond-haired-man",
        "older_adult",
        "older_man",
        "older_woman",
        "person_frowning",
        "man-frowning",
        "woman-frowning",
        "person_with_pouting_face",
        "man-pouting",
        "woman-pouting",
        "no_good",
        "man-gesturing-no",
        "woman-gesturing-no",
        "ok_woman",
        "man-gesturing-ok",
        "woman-gesturing-ok",
        "information_desk_person",
        "man-tipping-hand",
        "woman-tipping-hand",
        "raising_hand",
        "man-raising-hand",
        "woman-raising-hand",
        "deaf_person",
        "deaf_man",
        "deaf_woman",
        "bow",
        "man-bowing",
        "woman-bowing",
        "face_palm",
        "man-facepalming",
        "woman-facepalming",
        "shrug",
        "man-shrugging",
        "woman-shrugging",
        "health_worker",
        "male-doctor",
        "female-doctor",
        "student",
        "male-student",
        "female-student",
        "teacher",
        "male-teacher",
        "female-teacher",
        "judge",
        "male-judge",
        "female-judge",
        "farmer",
        "male-farmer",
        "female-farmer",
        "cook",
        "male-cook",
        "female-cook",
        "mechanic",
        "male-mechanic",
        "female-mechanic",
        "factory_worker",
        "male-factory-worker",
        "female-factory-worker",
        "office_worker",
        "male-office-worker",
        "female-office-worker",
        "scientist",
        "male-scientist",
        "female-scientist",
        "technologist",
        "male-technologist",
        "female-technologist",
        "singer",
        "male-singer",
        "female-singer",
        "artist",
        "male-artist",
        "female-artist",
        "pilot",
        "male-pilot",
        "female-pilot",
        "astronaut",
        "male-astronaut",
        "female-astronaut",
        "firefighter",
        "male-firefighter",
        "female-firefighter",
        "cop",
        "male-police-officer",
        "female-police-officer",
        "sleuth_or_spy",
        "male-detective",
        "female-detective",
        "guardsman",
        "male-guard",
        "female-guard",
        "construction_worker",
        "male-construction-worker",
        "female-construction-worker",
        "prince",
        "princess",
        "man_with_turban",
        "man-wearing-turban",
        "woman-wearing-turban",
        "man_with_gua_pi_mao",
        "person_with_headscarf",
        "man_in_tuxedo",
        "bride_with_veil",
        "pregnant_woman",
        "breast-feeding",
        "angel",
        "santa",
        "mrs_claus",
        "superhero",
        "male_superhero",
        "female_superhero",
        "supervillain",
        "male_supervillain",
        "female_supervillain",
        "mage",
        "male_mage",
        "female_mage",
        "fairy",
        "male_fairy",
        "female_fairy",
        "vampire",
        "male_vampire",
        "female_vampire",
        "merperson",
        "merman",
        "mermaid",
        "elf",
        "male_elf",
        "female_elf",
        "genie",
        "male_genie",
        "female_genie",
        "zombie",
        "male_zombie",
        "female_zombie",
        "massage",
        "man-getting-massage",
        "woman-getting-massage",
        "haircut",
        "man-getting-haircut",
        "woman-getting-haircut",
        "walking",
        "man-walking",
        "woman-walking",
        "standing_person",
        "man_standing",
        "woman_standing",
        "kneeling_person",
        "man_kneeling",
        "woman_kneeling",
        "person_with_probing_cane",
        "man_with_probing_cane",
        "woman_with_probing_cane",
        "person_in_motorized_wheelchair",
        "man_in_motorized_wheelchair",
        "woman_in_motorized_wheelchair",
        "person_in_manual_wheelchair",
        "man_in_manual_wheelchair",
        "woman_in_manual_wheelchair",
        "runner",
        "man-running",
        "woman-running",
        "dancer",
        "man_dancing",
        "man_in_business_suit_levitating",
        "dancers",
        "man-with-bunny-ears-partying",
        "woman-with-bunny-ears-partying",
        "person_in_steamy_room",
        "man_in_steamy_room",
        "woman_in_steamy_room",
        "person_climbing",
        "man_climbing",
        "woman_climbing",
        "fencer",
        "horse_racing",
        "skier",
        "snowboarder",
        "golfer",
        "man-golfing",
        "woman-golfing",
        "surfer",
        "man-surfing",
        "woman-surfing",
        "rowboat",
        "man-rowing-boat",
        "woman-rowing-boat",
        "swimmer",
        "man-swimming",
        "woman-swimming",
        "person_with_ball",
        "man-bouncing-ball",
        "woman-bouncing-ball",
        "weight_lifter",
        "man-lifting-weights",
        "woman-lifting-weights",
        "bicyclist",
        "man-biking",
        "woman-biking",
        "mountain_bicyclist",
        "man-mountain-biking",
        "woman-mountain-biking",
        "person_doing_cartwheel",
        "man-cartwheeling",
        "woman-cartwheeling",
        "wrestlers",
        "man-wrestling",
        "woman-wrestling",
        "water_polo",
        "man-playing-water-polo",
        "woman-playing-water-polo",
        "handball",
        "man-playing-handball",
        "woman-playing-handball",
        "juggling",
        "man-juggling",
        "woman-juggling",
        "person_in_lotus_position",
        "man_in_lotus_position",
        "woman_in_lotus_position",
        "bath",
        "sleeping_accommodation",
        "people_holding_hands",
        "two_women_holding_hands",
        "couple",
        "two_men_holding_hands",
        "couplekiss",
        "woman-kiss-man",
        "man-kiss-man",
        "woman-kiss-woman",
        "couple_with_heart",
        "woman-heart-man",
        "man-heart-man",
        "woman-heart-woman",
        "family",
        "man-woman-boy",
        "man-woman-girl",
        "man-woman-girl-boy",
        "man-woman-boy-boy",
        "man-woman-girl-girl",
        "man-man-boy",
        "man-man-girl",
        "man-man-girl-boy",
        "man-man-boy-boy",
        "man-man-girl-girl",
        "woman-woman-boy",
        "woman-woman-girl",
        "woman-woman-girl-boy",
        "woman-woman-boy-boy",
        "woman-woman-girl-girl",
        "man-boy",
        "man-boy-boy",
        "man-girl",
        "man-girl-boy",
        "man-girl-girl",
        "woman-boy",
        "woman-boy-boy",
        "woman-girl",
        "woman-girl-boy",
        "woman-girl-girl",
        "speaking_head_in_silhouette",
        "bust_in_silhouette",
        "busts_in_silhouette",
        "footprints",
        "kiss",
        "love_letter",
        "cupid",
        "gift_heart",
        "sparkling_heart",
        "heartpulse",
        "heartbeat",
        "revolving_hearts",
        "two_hearts",
        "heart_decoration",
        "heavy_heart_exclamation_mark_ornament",
        "broken_heart",
        "heart",
        "orange_heart",
        "yellow_heart",
        "green_heart",
        "blue_heart",
        "purple_heart",
        "brown_heart",
        "black_heart",
        "white_heart",
        "100",
        "anger",
        "boom",
        "dizzy",
        "sweat_drops",
        "dash",
        "hole",
        "bomb",
        "speech_balloon",
        "eye-in-speech-bubble",
        "left_speech_bubble",
        "right_anger_bubble",
        "thought_balloon",
        "zzz"
      ]
    },
    {
      id: "nature",
      name: "Animals & Nature",
      emojis: [
        "monkey_face",
        "monkey",
        "gorilla",
        "orangutan",
        "dog",
        "dog2",
        "guide_dog",
        "service_dog",
        "poodle",
        "wolf",
        "fox_face",
        "raccoon",
        "cat",
        "cat2",
        "lion_face",
        "tiger",
        "tiger2",
        "leopard",
        "horse",
        "racehorse",
        "unicorn_face",
        "zebra_face",
        "deer",
        "cow",
        "ox",
        "water_buffalo",
        "cow2",
        "pig",
        "pig2",
        "boar",
        "pig_nose",
        "ram",
        "sheep",
        "goat",
        "dromedary_camel",
        "camel",
        "llama",
        "giraffe_face",
        "elephant",
        "rhinoceros",
        "hippopotamus",
        "mouse",
        "mouse2",
        "rat",
        "hamster",
        "rabbit",
        "rabbit2",
        "chipmunk",
        "hedgehog",
        "bat",
        "bear",
        "koala",
        "panda_face",
        "sloth",
        "otter",
        "skunk",
        "kangaroo",
        "badger",
        "feet",
        "turkey",
        "chicken",
        "rooster",
        "hatching_chick",
        "baby_chick",
        "hatched_chick",
        "bird",
        "penguin",
        "dove_of_peace",
        "eagle",
        "duck",
        "swan",
        "owl",
        "flamingo",
        "peacock",
        "parrot",
        "frog",
        "crocodile",
        "turtle",
        "lizard",
        "snake",
        "dragon_face",
        "dragon",
        "sauropod",
        "t-rex",
        "whale",
        "whale2",
        "dolphin",
        "fish",
        "tropical_fish",
        "blowfish",
        "shark",
        "octopus",
        "shell",
        "snail",
        "butterfly",
        "bug",
        "ant",
        "bee",
        "beetle",
        "cricket",
        "spider",
        "spider_web",
        "scorpion",
        "mosquito",
        "microbe",
        "bouquet",
        "cherry_blossom",
        "white_flower",
        "rosette",
        "rose",
        "wilted_flower",
        "hibiscus",
        "sunflower",
        "blossom",
        "tulip",
        "seedling",
        "evergreen_tree",
        "deciduous_tree",
        "palm_tree",
        "cactus",
        "ear_of_rice",
        "herb",
        "shamrock",
        "four_leaf_clover",
        "maple_leaf",
        "fallen_leaf",
        "leaves"
      ]
    },
    {
      id: "foods",
      name: "Food & Drink",
      emojis: [
        "grapes",
        "melon",
        "watermelon",
        "tangerine",
        "lemon",
        "banana",
        "pineapple",
        "mango",
        "apple",
        "green_apple",
        "pear",
        "peach",
        "cherries",
        "strawberry",
        "kiwifruit",
        "tomato",
        "coconut",
        "avocado",
        "eggplant",
        "potato",
        "carrot",
        "corn",
        "hot_pepper",
        "cucumber",
        "leafy_green",
        "broccoli",
        "garlic",
        "onion",
        "mushroom",
        "peanuts",
        "chestnut",
        "bread",
        "croissant",
        "baguette_bread",
        "pretzel",
        "bagel",
        "pancakes",
        "waffle",
        "cheese_wedge",
        "meat_on_bone",
        "poultry_leg",
        "cut_of_meat",
        "bacon",
        "hamburger",
        "fries",
        "pizza",
        "hotdog",
        "sandwich",
        "taco",
        "burrito",
        "stuffed_flatbread",
        "falafel",
        "egg",
        "fried_egg",
        "shallow_pan_of_food",
        "stew",
        "bowl_with_spoon",
        "green_salad",
        "popcorn",
        "butter",
        "salt",
        "canned_food",
        "bento",
        "rice_cracker",
        "rice_ball",
        "rice",
        "curry",
        "ramen",
        "spaghetti",
        "sweet_potato",
        "oden",
        "sushi",
        "fried_shrimp",
        "fish_cake",
        "moon_cake",
        "dango",
        "dumpling",
        "fortune_cookie",
        "takeout_box",
        "crab",
        "lobster",
        "shrimp",
        "squid",
        "oyster",
        "icecream",
        "shaved_ice",
        "ice_cream",
        "doughnut",
        "cookie",
        "birthday",
        "cake",
        "cupcake",
        "pie",
        "chocolate_bar",
        "candy",
        "lollipop",
        "custard",
        "honey_pot",
        "baby_bottle",
        "glass_of_milk",
        "coffee",
        "tea",
        "sake",
        "champagne",
        "wine_glass",
        "cocktail",
        "tropical_drink",
        "beer",
        "beers",
        "clinking_glasses",
        "tumbler_glass",
        "cup_with_straw",
        "beverage_box",
        "mate_drink",
        "ice_cube",
        "chopsticks",
        "knife_fork_plate",
        "fork_and_knife",
        "spoon",
        "hocho",
        "amphora"
      ]
    },
    {
      id: "activity",
      name: "Activities",
      emojis: [
        "jack_o_lantern",
        "christmas_tree",
        "fireworks",
        "sparkler",
        "firecracker",
        "sparkles",
        "balloon",
        "tada",
        "confetti_ball",
        "tanabata_tree",
        "bamboo",
        "dolls",
        "flags",
        "wind_chime",
        "rice_scene",
        "red_envelope",
        "ribbon",
        "gift",
        "reminder_ribbon",
        "admission_tickets",
        "ticket",
        "medal",
        "trophy",
        "sports_medal",
        "first_place_medal",
        "second_place_medal",
        "third_place_medal",
        "soccer",
        "baseball",
        "softball",
        "basketball",
        "volleyball",
        "football",
        "rugby_football",
        "tennis",
        "flying_disc",
        "bowling",
        "cricket_bat_and_ball",
        "field_hockey_stick_and_ball",
        "ice_hockey_stick_and_puck",
        "lacrosse",
        "table_tennis_paddle_and_ball",
        "badminton_racquet_and_shuttlecock",
        "boxing_glove",
        "martial_arts_uniform",
        "goal_net",
        "golf",
        "ice_skate",
        "fishing_pole_and_fish",
        "diving_mask",
        "running_shirt_with_sash",
        "ski",
        "sled",
        "curling_stone",
        "dart",
        "yo-yo",
        "kite",
        "8ball",
        "crystal_ball",
        "nazar_amulet",
        "video_game",
        "joystick",
        "slot_machine",
        "game_die",
        "jigsaw",
        "teddy_bear",
        "spades",
        "hearts",
        "diamonds",
        "clubs",
        "chess_pawn",
        "black_joker",
        "mahjong",
        "flower_playing_cards",
        "performing_arts",
        "frame_with_picture",
        "art",
        "thread",
        "yarn"
      ]
    },
    {
      id: "places",
      name: "Travel & Places",
      emojis: [
        "earth_africa",
        "earth_americas",
        "earth_asia",
        "globe_with_meridians",
        "world_map",
        "japan",
        "compass",
        "snow_capped_mountain",
        "mountain",
        "volcano",
        "mount_fuji",
        "camping",
        "beach_with_umbrella",
        "desert",
        "desert_island",
        "national_park",
        "stadium",
        "classical_building",
        "building_construction",
        "bricks",
        "house_buildings",
        "derelict_house_building",
        "house",
        "house_with_garden",
        "office",
        "post_office",
        "european_post_office",
        "hospital",
        "bank",
        "hotel",
        "love_hotel",
        "convenience_store",
        "school",
        "department_store",
        "factory",
        "japanese_castle",
        "european_castle",
        "wedding",
        "tokyo_tower",
        "statue_of_liberty",
        "church",
        "mosque",
        "hindu_temple",
        "synagogue",
        "shinto_shrine",
        "kaaba",
        "fountain",
        "tent",
        "foggy",
        "night_with_stars",
        "cityscape",
        "sunrise_over_mountains",
        "sunrise",
        "city_sunset",
        "city_sunrise",
        "bridge_at_night",
        "hotsprings",
        "carousel_horse",
        "ferris_wheel",
        "roller_coaster",
        "barber",
        "circus_tent",
        "steam_locomotive",
        "railway_car",
        "bullettrain_side",
        "bullettrain_front",
        "train2",
        "metro",
        "light_rail",
        "station",
        "tram",
        "monorail",
        "mountain_railway",
        "train",
        "bus",
        "oncoming_bus",
        "trolleybus",
        "minibus",
        "ambulance",
        "fire_engine",
        "police_car",
        "oncoming_police_car",
        "taxi",
        "oncoming_taxi",
        "car",
        "oncoming_automobile",
        "blue_car",
        "truck",
        "articulated_lorry",
        "tractor",
        "racing_car",
        "racing_motorcycle",
        "motor_scooter",
        "manual_wheelchair",
        "motorized_wheelchair",
        "auto_rickshaw",
        "bike",
        "scooter",
        "skateboard",
        "busstop",
        "motorway",
        "railway_track",
        "oil_drum",
        "fuelpump",
        "rotating_light",
        "traffic_light",
        "vertical_traffic_light",
        "octagonal_sign",
        "construction",
        "anchor",
        "boat",
        "canoe",
        "speedboat",
        "passenger_ship",
        "ferry",
        "motor_boat",
        "ship",
        "airplane",
        "small_airplane",
        "airplane_departure",
        "airplane_arriving",
        "parachute",
        "seat",
        "helicopter",
        "suspension_railway",
        "mountain_cableway",
        "aerial_tramway",
        "satellite",
        "rocket",
        "flying_saucer",
        "bellhop_bell",
        "luggage",
        "hourglass",
        "hourglass_flowing_sand",
        "watch",
        "alarm_clock",
        "stopwatch",
        "timer_clock",
        "mantelpiece_clock",
        "clock12",
        "clock1230",
        "clock1",
        "clock130",
        "clock2",
        "clock230",
        "clock3",
        "clock330",
        "clock4",
        "clock430",
        "clock5",
        "clock530",
        "clock6",
        "clock630",
        "clock7",
        "clock730",
        "clock8",
        "clock830",
        "clock9",
        "clock930",
        "clock10",
        "clock1030",
        "clock11",
        "clock1130",
        "new_moon",
        "waxing_crescent_moon",
        "first_quarter_moon",
        "moon",
        "full_moon",
        "waning_gibbous_moon",
        "last_quarter_moon",
        "waning_crescent_moon",
        "crescent_moon",
        "new_moon_with_face",
        "first_quarter_moon_with_face",
        "last_quarter_moon_with_face",
        "thermometer",
        "sunny",
        "full_moon_with_face",
        "sun_with_face",
        "ringed_planet",
        "star",
        "star2",
        "stars",
        "milky_way",
        "cloud",
        "partly_sunny",
        "thunder_cloud_and_rain",
        "mostly_sunny",
        "barely_sunny",
        "partly_sunny_rain",
        "rain_cloud",
        "snow_cloud",
        "lightning",
        "tornado",
        "fog",
        "wind_blowing_face",
        "cyclone",
        "rainbow",
        "closed_umbrella",
        "umbrella",
        "umbrella_with_rain_drops",
        "umbrella_on_ground",
        "zap",
        "snowflake",
        "snowman",
        "snowman_without_snow",
        "comet",
        "fire",
        "droplet",
        "ocean"
      ]
    },
    {
      id: "objects",
      name: "Objects",
      emojis: [
        "eyeglasses",
        "dark_sunglasses",
        "goggles",
        "lab_coat",
        "safety_vest",
        "necktie",
        "shirt",
        "jeans",
        "scarf",
        "gloves",
        "coat",
        "socks",
        "dress",
        "kimono",
        "sari",
        "one-piece_swimsuit",
        "briefs",
        "shorts",
        "bikini",
        "womans_clothes",
        "purse",
        "handbag",
        "pouch",
        "shopping_bags",
        "school_satchel",
        "mans_shoe",
        "athletic_shoe",
        "hiking_boot",
        "womans_flat_shoe",
        "high_heel",
        "sandal",
        "ballet_shoes",
        "boot",
        "crown",
        "womans_hat",
        "tophat",
        "mortar_board",
        "billed_cap",
        "helmet_with_white_cross",
        "prayer_beads",
        "lipstick",
        "ring",
        "gem",
        "mute",
        "speaker",
        "sound",
        "loud_sound",
        "loudspeaker",
        "mega",
        "postal_horn",
        "bell",
        "no_bell",
        "musical_score",
        "musical_note",
        "notes",
        "studio_microphone",
        "level_slider",
        "control_knobs",
        "microphone",
        "headphones",
        "radio",
        "saxophone",
        "guitar",
        "musical_keyboard",
        "trumpet",
        "violin",
        "banjo",
        "drum_with_drumsticks",
        "iphone",
        "calling",
        "phone",
        "telephone_receiver",
        "pager",
        "fax",
        "battery",
        "electric_plug",
        "computer",
        "desktop_computer",
        "printer",
        "keyboard",
        "three_button_mouse",
        "trackball",
        "minidisc",
        "floppy_disk",
        "cd",
        "dvd",
        "abacus",
        "movie_camera",
        "film_frames",
        "film_projector",
        "clapper",
        "tv",
        "camera",
        "camera_with_flash",
        "video_camera",
        "vhs",
        "mag",
        "mag_right",
        "candle",
        "bulb",
        "flashlight",
        "izakaya_lantern",
        "diya_lamp",
        "notebook_with_decorative_cover",
        "closed_book",
        "book",
        "green_book",
        "blue_book",
        "orange_book",
        "books",
        "notebook",
        "ledger",
        "page_with_curl",
        "scroll",
        "page_facing_up",
        "newspaper",
        "rolled_up_newspaper",
        "bookmark_tabs",
        "bookmark",
        "label",
        "moneybag",
        "yen",
        "dollar",
        "euro",
        "pound",
        "money_with_wings",
        "credit_card",
        "receipt",
        "chart",
        "currency_exchange",
        "heavy_dollar_sign",
        "email",
        "e-mail",
        "incoming_envelope",
        "envelope_with_arrow",
        "outbox_tray",
        "inbox_tray",
        "package",
        "mailbox",
        "mailbox_closed",
        "mailbox_with_mail",
        "mailbox_with_no_mail",
        "postbox",
        "ballot_box_with_ballot",
        "pencil2",
        "black_nib",
        "lower_left_fountain_pen",
        "lower_left_ballpoint_pen",
        "lower_left_paintbrush",
        "lower_left_crayon",
        "memo",
        "briefcase",
        "file_folder",
        "open_file_folder",
        "card_index_dividers",
        "date",
        "calendar",
        "spiral_note_pad",
        "spiral_calendar_pad",
        "card_index",
        "chart_with_upwards_trend",
        "chart_with_downwards_trend",
        "bar_chart",
        "clipboard",
        "pushpin",
        "round_pushpin",
        "paperclip",
        "linked_paperclips",
        "straight_ruler",
        "triangular_ruler",
        "scissors",
        "card_file_box",
        "file_cabinet",
        "wastebasket",
        "lock",
        "unlock",
        "lock_with_ink_pen",
        "closed_lock_with_key",
        "key",
        "old_key",
        "hammer",
        "axe",
        "pick",
        "hammer_and_pick",
        "hammer_and_wrench",
        "dagger_knife",
        "crossed_swords",
        "gun",
        "bow_and_arrow",
        "shield",
        "wrench",
        "nut_and_bolt",
        "gear",
        "compression",
        "scales",
        "probing_cane",
        "link",
        "chains",
        "toolbox",
        "magnet",
        "alembic",
        "test_tube",
        "petri_dish",
        "dna",
        "microscope",
        "telescope",
        "satellite_antenna",
        "syringe",
        "drop_of_blood",
        "pill",
        "adhesive_bandage",
        "stethoscope",
        "door",
        "bed",
        "couch_and_lamp",
        "chair",
        "toilet",
        "shower",
        "bathtub",
        "razor",
        "lotion_bottle",
        "safety_pin",
        "broom",
        "basket",
        "roll_of_paper",
        "soap",
        "sponge",
        "fire_extinguisher",
        "shopping_trolley",
        "smoking",
        "coffin",
        "funeral_urn",
        "moyai"
      ]
    },
    {
      id: "symbols",
      name: "Symbols",
      emojis: [
        "atm",
        "put_litter_in_its_place",
        "potable_water",
        "wheelchair",
        "mens",
        "womens",
        "restroom",
        "baby_symbol",
        "wc",
        "passport_control",
        "customs",
        "baggage_claim",
        "left_luggage",
        "warning",
        "children_crossing",
        "no_entry",
        "no_entry_sign",
        "no_bicycles",
        "no_smoking",
        "do_not_litter",
        "non-potable_water",
        "no_pedestrians",
        "no_mobile_phones",
        "underage",
        "radioactive_sign",
        "biohazard_sign",
        "arrow_up",
        "arrow_upper_right",
        "arrow_right",
        "arrow_lower_right",
        "arrow_down",
        "arrow_lower_left",
        "arrow_left",
        "arrow_upper_left",
        "arrow_up_down",
        "left_right_arrow",
        "leftwards_arrow_with_hook",
        "arrow_right_hook",
        "arrow_heading_up",
        "arrow_heading_down",
        "arrows_clockwise",
        "arrows_counterclockwise",
        "back",
        "end",
        "on",
        "soon",
        "top",
        "place_of_worship",
        "atom_symbol",
        "om_symbol",
        "star_of_david",
        "wheel_of_dharma",
        "yin_yang",
        "latin_cross",
        "orthodox_cross",
        "star_and_crescent",
        "peace_symbol",
        "menorah_with_nine_branches",
        "six_pointed_star",
        "aries",
        "taurus",
        "gemini",
        "cancer",
        "leo",
        "virgo",
        "libra",
        "scorpius",
        "sagittarius",
        "capricorn",
        "aquarius",
        "pisces",
        "ophiuchus",
        "twisted_rightwards_arrows",
        "repeat",
        "repeat_one",
        "arrow_forward",
        "fast_forward",
        "black_right_pointing_double_triangle_with_vertical_bar",
        "black_right_pointing_triangle_with_double_vertical_bar",
        "arrow_backward",
        "rewind",
        "black_left_pointing_double_triangle_with_vertical_bar",
        "arrow_up_small",
        "arrow_double_up",
        "arrow_down_small",
        "arrow_double_down",
        "double_vertical_bar",
        "black_square_for_stop",
        "black_circle_for_record",
        "eject",
        "cinema",
        "low_brightness",
        "high_brightness",
        "signal_strength",
        "vibration_mode",
        "mobile_phone_off",
        "infinity",
        "recycle",
        "fleur_de_lis",
        "trident",
        "name_badge",
        "beginner",
        "o",
        "white_check_mark",
        "ballot_box_with_check",
        "heavy_check_mark",
        "heavy_multiplication_x",
        "x",
        "negative_squared_cross_mark",
        "heavy_plus_sign",
        "heavy_minus_sign",
        "heavy_division_sign",
        "curly_loop",
        "loop",
        "part_alternation_mark",
        "eight_spoked_asterisk",
        "eight_pointed_black_star",
        "sparkle",
        "bangbang",
        "interrobang",
        "question",
        "grey_question",
        "grey_exclamation",
        "exclamation",
        "wavy_dash",
        "copyright",
        "registered",
        "tm",
        "hash",
        "keycap_star",
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "keycap_ten",
        "capital_abcd",
        "abcd",
        "1234",
        "symbols",
        "abc",
        "a",
        "ab",
        "b",
        "cl",
        "cool",
        "free",
        "information_source",
        "id",
        "m",
        "new",
        "ng",
        "o2",
        "ok",
        "parking",
        "sos",
        "up",
        "vs",
        "koko",
        "sa",
        "u6708",
        "u6709",
        "u6307",
        "ideograph_advantage",
        "u5272",
        "u7121",
        "u7981",
        "accept",
        "u7533",
        "u5408",
        "u7a7a",
        "congratulations",
        "secret",
        "u55b6",
        "u6e80",
        "red_circle",
        "large_orange_circle",
        "large_yellow_circle",
        "large_green_circle",
        "large_blue_circle",
        "large_purple_circle",
        "large_brown_circle",
        "black_circle",
        "white_circle",
        "large_red_square",
        "large_orange_square",
        "large_yellow_square",
        "large_green_square",
        "large_blue_square",
        "large_purple_square",
        "large_brown_square",
        "black_large_square",
        "white_large_square",
        "black_medium_square",
        "white_medium_square",
        "black_medium_small_square",
        "white_medium_small_square",
        "black_small_square",
        "white_small_square",
        "large_orange_diamond",
        "large_blue_diamond",
        "small_orange_diamond",
        "small_blue_diamond",
        "small_red_triangle",
        "small_red_triangle_down",
        "diamond_shape_with_a_dot_inside",
        "radio_button",
        "white_square_button",
        "black_square_button"
      ]
    },
    {
      id: "flags",
      name: "Flags",
      emojis: [
        "checkered_flag",
        "cn",
        "crossed_flags",
        "de",
        "es",
        "flag-ac",
        "flag-ad",
        "flag-ae",
        "flag-af",
        "flag-ag",
        "flag-ai",
        "flag-al",
        "flag-am",
        "flag-ao",
        "flag-aq",
        "flag-ar",
        "flag-as",
        "flag-at",
        "flag-au",
        "flag-aw",
        "flag-ax",
        "flag-az",
        "flag-ba",
        "flag-bb",
        "flag-bd",
        "flag-be",
        "flag-bf",
        "flag-bg",
        "flag-bh",
        "flag-bi",
        "flag-bj",
        "flag-bl",
        "flag-bm",
        "flag-bn",
        "flag-bo",
        "flag-bq",
        "flag-br",
        "flag-bs",
        "flag-bt",
        "flag-bv",
        "flag-bw",
        "flag-by",
        "flag-bz",
        "flag-ca",
        "flag-cc",
        "flag-cd",
        "flag-cf",
        "flag-cg",
        "flag-ch",
        "flag-ci",
        "flag-ck",
        "flag-cl",
        "flag-cm",
        "flag-co",
        "flag-cp",
        "flag-cr",
        "flag-cu",
        "flag-cv",
        "flag-cw",
        "flag-cx",
        "flag-cy",
        "flag-cz",
        "flag-dg",
        "flag-dj",
        "flag-dk",
        "flag-dm",
        "flag-do",
        "flag-dz",
        "flag-ea",
        "flag-ec",
        "flag-ee",
        "flag-eg",
        "flag-eh",
        "flag-england",
        "flag-er",
        "flag-et",
        "flag-eu",
        "flag-fi",
        "flag-fj",
        "flag-fk",
        "flag-fm",
        "flag-fo",
        "flag-ga",
        "flag-gd",
        "flag-ge",
        "flag-gf",
        "flag-gg",
        "flag-gh",
        "flag-gi",
        "flag-gl",
        "flag-gm",
        "flag-gn",
        "flag-gp",
        "flag-gq",
        "flag-gr",
        "flag-gs",
        "flag-gt",
        "flag-gu",
        "flag-gw",
        "flag-gy",
        "flag-hk",
        "flag-hm",
        "flag-hn",
        "flag-hr",
        "flag-ht",
        "flag-hu",
        "flag-ic",
        "flag-id",
        "flag-ie",
        "flag-il",
        "flag-im",
        "flag-in",
        "flag-io",
        "flag-iq",
        "flag-ir",
        "flag-is",
        "flag-je",
        "flag-jm",
        "flag-jo",
        "flag-ke",
        "flag-kg",
        "flag-kh",
        "flag-ki",
        "flag-km",
        "flag-kn",
        "flag-kp",
        "flag-kw",
        "flag-ky",
        "flag-kz",
        "flag-la",
        "flag-lb",
        "flag-lc",
        "flag-li",
        "flag-lk",
        "flag-lr",
        "flag-ls",
        "flag-lt",
        "flag-lu",
        "flag-lv",
        "flag-ly",
        "flag-ma",
        "flag-mc",
        "flag-md",
        "flag-me",
        "flag-mf",
        "flag-mg",
        "flag-mh",
        "flag-mk",
        "flag-ml",
        "flag-mm",
        "flag-mn",
        "flag-mo",
        "flag-mp",
        "flag-mq",
        "flag-mr",
        "flag-ms",
        "flag-mt",
        "flag-mu",
        "flag-mv",
        "flag-mw",
        "flag-mx",
        "flag-my",
        "flag-mz",
        "flag-na",
        "flag-nc",
        "flag-ne",
        "flag-nf",
        "flag-ng",
        "flag-ni",
        "flag-nl",
        "flag-no",
        "flag-np",
        "flag-nr",
        "flag-nu",
        "flag-nz",
        "flag-om",
        "flag-pa",
        "flag-pe",
        "flag-pf",
        "flag-pg",
        "flag-ph",
        "flag-pk",
        "flag-pl",
        "flag-pm",
        "flag-pn",
        "flag-pr",
        "flag-ps",
        "flag-pt",
        "flag-pw",
        "flag-py",
        "flag-qa",
        "flag-re",
        "flag-ro",
        "flag-rs",
        "flag-rw",
        "flag-sa",
        "flag-sb",
        "flag-sc",
        "flag-scotland",
        "flag-sd",
        "flag-se",
        "flag-sg",
        "flag-sh",
        "flag-si",
        "flag-sj",
        "flag-sk",
        "flag-sl",
        "flag-sm",
        "flag-sn",
        "flag-so",
        "flag-sr",
        "flag-ss",
        "flag-st",
        "flag-sv",
        "flag-sx",
        "flag-sy",
        "flag-sz",
        "flag-ta",
        "flag-tc",
        "flag-td",
        "flag-tf",
        "flag-tg",
        "flag-th",
        "flag-tj",
        "flag-tk",
        "flag-tl",
        "flag-tm",
        "flag-tn",
        "flag-to",
        "flag-tr",
        "flag-tt",
        "flag-tv",
        "flag-tw",
        "flag-tz",
        "flag-ua",
        "flag-ug",
        "flag-um",
        "flag-uy",
        "flag-uz",
        "flag-va",
        "flag-vc",
        "flag-ve",
        "flag-vg",
        "flag-vi",
        "flag-vn",
        "flag-vu",
        "flag-wales",
        "flag-wf",
        "flag-ws",
        "flag-xk",
        "flag-ye",
        "flag-yt",
        "flag-za",
        "flag-zm",
        "flag-zw",
        "fr",
        "gb",
        "it",
        "jp",
        "kr",
        "pirate_flag",
        "rainbow-flag",
        "ru",
        "triangular_flag_on_post",
        "us",
        "waving_black_flag",
        "waving_white_flag"
      ]
    }
  ],
  emojis: {
    "100": {
      a: "Hundred Points Symbol",
      b: "1F4AF",
      j: [
        "score",
        "perfect",
        "numbers",
        "century",
        "exam",
        "quiz",
        "test",
        "pass",
        "hundred"
      ],
      k: [26, 5],
      o: 2
    },
    "1234": {
      a: "Input Symbol for Numbers",
      b: "1F522",
      j: ["numbers", "blue-square"],
      k: [28, 5],
      o: 2
    },
    grinning: {
      a: "Grinning Face",
      b: "1F600",
      j: ["face", "smile", "happy", "joy", ":D", "grin"],
      k: [30, 35],
      m: ":D",
      o: 2
    },
    monkey_face: {
      a: "Monkey Face",
      b: "1F435",
      j: ["animal", "nature", "circus"],
      k: [12, 25],
      l: [":o)"],
      o: 2
    },
    grapes: {
      a: "Grapes",
      b: "1F347",
      j: ["fruit", "food", "wine"],
      k: [6, 31],
      o: 2
    },
    eyeglasses: {
      a: "Eyeglasses",
      b: "1F453",
      j: ["fashion", "accessories", "eyesight", "nerdy", "dork", "geek"],
      k: [14, 7],
      o: 2
    },
    checkered_flag: {
      a: "Chequered Flag",
      b: "1F3C1",
      j: ["contest", "finishline", "race", "gokart"],
      k: [8, 39],
      o: 2
    },
    jack_o_lantern: {
      a: "Jack-O-Lantern",
      b: "1F383",
      j: ["halloween", "light", "pumpkin", "creepy", "fall"],
      k: [7, 34],
      o: 2
    },
    wave: {
      skin_variations: {
        "1F3FB": {
          unified: "1F44B-1F3FB",
          non_qualified: null,
          image: "1f44b-1f3fb.png",
          sheet_x: 13,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F44B-1F3FC",
          non_qualified: null,
          image: "1f44b-1f3fc.png",
          sheet_x: 13,
          sheet_y: 28,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F44B-1F3FD",
          non_qualified: null,
          image: "1f44b-1f3fd.png",
          sheet_x: 13,
          sheet_y: 29,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F44B-1F3FE",
          non_qualified: null,
          image: "1f44b-1f3fe.png",
          sheet_x: 13,
          sheet_y: 30,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F44B-1F3FF",
          non_qualified: null,
          image: "1f44b-1f3ff.png",
          sheet_x: 13,
          sheet_y: 31,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Waving Hand Sign",
      b: "1F44B",
      j: [
        "hands",
        "gesture",
        "goodbye",
        "solong",
        "farewell",
        "hello",
        "hi",
        "palm"
      ],
      k: [13, 26],
      o: 2
    },
    earth_africa: {
      a: "Earth Globe Europe-Africa",
      b: "1F30D",
      j: ["globe", "world", "international"],
      k: [5, 32],
      o: 2
    },
    atm: {
      a: "Automated Teller Machine",
      b: "1F3E7",
      j: ["money", "sales", "cash", "blue-square", "payment", "bank"],
      k: [11, 1],
      o: 2
    },
    melon: {
      a: "Melon",
      b: "1F348",
      j: ["fruit", "nature", "food"],
      k: [6, 32],
      o: 2
    },
    triangular_flag_on_post: {
      a: "Triangular Flag on Post",
      b: "1F6A9",
      j: ["mark", "milestone", "place"],
      k: [35, 0],
      o: 2
    },
    put_litter_in_its_place: {
      a: "Put Litter in Its Place Symbol",
      b: "1F6AE",
      j: ["blue-square", "sign", "human", "info"],
      k: [35, 5],
      o: 2
    },
    christmas_tree: {
      a: "Christmas Tree",
      b: "1F384",
      j: ["festival", "vacation", "december", "xmas", "celebration"],
      k: [7, 35],
      o: 2
    },
    monkey: {
      a: "Monkey",
      b: "1F412",
      j: ["animal", "nature", "banana", "circus"],
      k: [11, 46],
      o: 2
    },
    earth_americas: {
      a: "Earth Globe Americas",
      b: "1F30E",
      j: ["globe", "world", "USA", "international"],
      k: [5, 33],
      o: 2
    },
    dark_sunglasses: {
      a: "Dark Sunglasses",
      b: "1F576-FE0F",
      c: "1F576",
      j: ["face", "cool", "accessories"],
      k: [29, 33],
      o: 2
    },
    raised_back_of_hand: {
      skin_variations: {
        "1F3FB": {
          unified: "1F91A-1F3FB",
          non_qualified: null,
          image: "1f91a-1f3fb.png",
          sheet_x: 37,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F91A-1F3FC",
          non_qualified: null,
          image: "1f91a-1f3fc.png",
          sheet_x: 37,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F91A-1F3FD",
          non_qualified: null,
          image: "1f91a-1f3fd.png",
          sheet_x: 37,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F91A-1F3FE",
          non_qualified: null,
          image: "1f91a-1f3fe.png",
          sheet_x: 37,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F91A-1F3FF",
          non_qualified: null,
          image: "1f91a-1f3ff.png",
          sheet_x: 37,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Raised Back of Hand",
      b: "1F91A",
      j: ["fingers", "raised", "backhand"],
      k: [37, 43],
      o: 4
    },
    smiley: {
      a: "Smiling Face with Open Mouth",
      b: "1F603",
      j: ["face", "happy", "joy", "haha", ":D", ":)", "smile", "funny"],
      k: [30, 38],
      l: ["=)", "=-)"],
      m: ":)",
      o: 2
    },
    earth_asia: {
      a: "Earth Globe Asia-Australia",
      b: "1F30F",
      j: ["globe", "world", "east", "international"],
      k: [5, 34],
      o: 2
    },
    crossed_flags: {
      a: "Crossed Flags",
      b: "1F38C",
      j: ["japanese", "nation", "country", "border"],
      k: [7, 48],
      o: 2
    },
    watermelon: {
      a: "Watermelon",
      b: "1F349",
      j: ["fruit", "food", "picnic", "summer"],
      k: [6, 33],
      o: 2
    },
    goggles: { a: "Goggles", b: "1F97D", k: [42, 15], o: 11 },
    raised_hand_with_fingers_splayed: {
      skin_variations: {
        "1F3FB": {
          unified: "1F590-1F3FB",
          non_qualified: null,
          image: "1f590-1f3fb.png",
          sheet_x: 29,
          sheet_y: 49,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F590-1F3FC",
          non_qualified: null,
          image: "1f590-1f3fc.png",
          sheet_x: 29,
          sheet_y: 50,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F590-1F3FD",
          non_qualified: null,
          image: "1f590-1f3fd.png",
          sheet_x: 29,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F590-1F3FE",
          non_qualified: null,
          image: "1f590-1f3fe.png",
          sheet_x: 29,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F590-1F3FF",
          non_qualified: null,
          image: "1f590-1f3ff.png",
          sheet_x: 29,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Raised Hand with Fingers Splayed",
      b: "1F590-FE0F",
      c: "1F590",
      j: ["hand", "fingers", "palm"],
      k: [29, 48],
      o: 2
    },
    smile: {
      a: "Smiling Face with Open Mouth and Smiling Eyes",
      b: "1F604",
      j: ["face", "happy", "joy", "funny", "haha", "laugh", "like", ":D", ":)"],
      k: [30, 39],
      l: ["C:", "c:", ":D", ":-D"],
      m: ":)",
      o: 2
    },
    potable_water: {
      a: "Potable Water Symbol",
      b: "1F6B0",
      j: ["blue-square", "liquid", "restroom", "cleaning", "faucet"],
      k: [35, 7],
      o: 2
    },
    fireworks: {
      a: "Fireworks",
      b: "1F386",
      j: ["photo", "festival", "carnival", "congratulations"],
      k: [7, 42],
      o: 2
    },
    gorilla: {
      a: "Gorilla",
      b: "1F98D",
      j: ["animal", "nature", "circus"],
      k: [42, 31],
      o: 4
    },
    lab_coat: { a: "Lab Coat", b: "1F97C", k: [42, 14], o: 11 },
    tangerine: {
      a: "Tangerine",
      b: "1F34A",
      j: ["food", "fruit", "nature", "orange"],
      k: [6, 34],
      o: 2
    },
    wheelchair: {
      a: "Wheelchair Symbol",
      b: "267F",
      j: ["blue-square", "disabled", "a11y", "accessibility"],
      k: [53, 40],
      o: 2
    },
    waving_black_flag: {
      a: "Waving Black Flag",
      b: "1F3F4",
      k: [11, 17],
      o: 2
    },
    orangutan: { a: "Orangutan", b: "1F9A7", k: [42, 55], o: 12 },
    sparkler: {
      a: "Firework Sparkler",
      b: "1F387",
      j: ["stars", "night", "shine"],
      k: [7, 43],
      o: 2
    },
    globe_with_meridians: {
      a: "Globe with Meridians",
      b: "1F310",
      j: ["earth", "international", "world", "internet", "interweb", "i18n"],
      k: [5, 35],
      o: 2
    },
    grin: {
      a: "Grinning Face with Smiling Eyes",
      b: "1F601",
      j: ["face", "happy", "smile", "joy", "kawaii"],
      k: [30, 36],
      o: 2
    },
    hand: {
      skin_variations: {
        "1F3FB": {
          unified: "270B-1F3FB",
          non_qualified: null,
          image: "270b-1f3fb.png",
          sheet_x: 54,
          sheet_y: 50,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "270B-1F3FC",
          non_qualified: null,
          image: "270b-1f3fc.png",
          sheet_x: 54,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "270B-1F3FD",
          non_qualified: null,
          image: "270b-1f3fd.png",
          sheet_x: 54,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "270B-1F3FE",
          non_qualified: null,
          image: "270b-1f3fe.png",
          sheet_x: 54,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "270B-1F3FF",
          non_qualified: null,
          image: "270b-1f3ff.png",
          sheet_x: 54,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Raised Hand",
      b: "270B",
      k: [54, 49],
      n: ["raised_hand"],
      o: 2
    },
    firecracker: { a: "Firecracker", b: "1F9E8", k: [51, 27], o: 11 },
    lemon: { a: "Lemon", b: "1F34B", j: ["fruit", "nature"], k: [6, 35], o: 2 },
    dog: {
      a: "Dog Face",
      b: "1F436",
      j: ["animal", "friend", "nature", "woof", "puppy", "pet", "faithful"],
      k: [12, 26],
      o: 2
    },
    mens: {
      a: "Mens Symbol",
      b: "1F6B9",
      j: ["toilet", "restroom", "wc", "blue-square", "gender", "male"],
      k: [36, 10],
      o: 2
    },
    "spock-hand": {
      skin_variations: {
        "1F3FB": {
          unified: "1F596-1F3FB",
          non_qualified: null,
          image: "1f596-1f3fb.png",
          sheet_x: 30,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F596-1F3FC",
          non_qualified: null,
          image: "1f596-1f3fc.png",
          sheet_x: 30,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F596-1F3FD",
          non_qualified: null,
          image: "1f596-1f3fd.png",
          sheet_x: 30,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F596-1F3FE",
          non_qualified: null,
          image: "1f596-1f3fe.png",
          sheet_x: 30,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F596-1F3FF",
          non_qualified: null,
          image: "1f596-1f3ff.png",
          sheet_x: 30,
          sheet_y: 8,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Raised Hand with Part Between Middle and Ring Fingers",
      b: "1F596",
      k: [30, 3],
      o: 2
    },
    world_map: {
      a: "World Map",
      b: "1F5FA-FE0F",
      c: "1F5FA",
      j: ["location", "direction"],
      k: [30, 29],
      o: 2
    },
    laughing: {
      a: "Smiling Face with Open Mouth and Tightly-Closed Eyes",
      b: "1F606",
      j: [
        "happy",
        "joy",
        "lol",
        "satisfied",
        "haha",
        "face",
        "glad",
        "XD",
        "laugh"
      ],
      k: [30, 41],
      l: [":>", ":->"],
      n: ["satisfied"],
      o: 2
    },
    waving_white_flag: {
      a: "Waving White Flag",
      b: "1F3F3-FE0F",
      c: "1F3F3",
      k: [11, 12],
      o: 2
    },
    safety_vest: { a: "Safety Vest", b: "1F9BA", k: [43, 54], o: 12 },
    sweat_smile: {
      a: "Smiling Face with Open Mouth and Cold Sweat",
      b: "1F605",
      j: ["face", "hot", "happy", "laugh", "sweat", "smile", "relief"],
      k: [30, 40],
      o: 2
    },
    sparkles: {
      a: "Sparkles",
      b: "2728",
      j: ["stars", "shine", "shiny", "cool", "awesome", "good", "magic"],
      k: [55, 16],
      o: 2
    },
    banana: {
      a: "Banana",
      b: "1F34C",
      j: ["fruit", "food", "monkey"],
      k: [6, 36],
      o: 2
    },
    "rainbow-flag": {
      a: "Rainbow Flag",
      b: "1F3F3-FE0F-200D-1F308",
      c: "1F3F3-200D-1F308",
      k: [11, 11],
      o: 4
    },
    ok_hand: {
      skin_variations: {
        "1F3FB": {
          unified: "1F44C-1F3FB",
          non_qualified: null,
          image: "1f44c-1f3fb.png",
          sheet_x: 13,
          sheet_y: 33,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F44C-1F3FC",
          non_qualified: null,
          image: "1f44c-1f3fc.png",
          sheet_x: 13,
          sheet_y: 34,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F44C-1F3FD",
          non_qualified: null,
          image: "1f44c-1f3fd.png",
          sheet_x: 13,
          sheet_y: 35,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F44C-1F3FE",
          non_qualified: null,
          image: "1f44c-1f3fe.png",
          sheet_x: 13,
          sheet_y: 36,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F44C-1F3FF",
          non_qualified: null,
          image: "1f44c-1f3ff.png",
          sheet_x: 13,
          sheet_y: 37,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Ok Hand Sign",
      b: "1F44C",
      j: ["fingers", "limbs", "perfect", "ok", "okay"],
      k: [13, 32],
      o: 2
    },
    japan: {
      a: "Silhouette of Japan",
      b: "1F5FE",
      j: ["nation", "country", "japanese", "asia"],
      k: [30, 33],
      o: 2
    },
    dog2: {
      a: "Dog",
      b: "1F415",
      j: ["animal", "nature", "friend", "doge", "pet", "faithful"],
      k: [11, 50],
      o: 2
    },
    womens: {
      a: "Womens Symbol",
      b: "1F6BA",
      j: [
        "purple-square",
        "woman",
        "female",
        "toilet",
        "loo",
        "restroom",
        "gender"
      ],
      k: [36, 11],
      o: 2
    },
    necktie: {
      a: "Necktie",
      b: "1F454",
      j: ["shirt", "suitup", "formal", "fashion", "cloth", "business"],
      k: [14, 8],
      o: 2
    },
    pirate_flag: {
      a: "Pirate Flag",
      b: "1F3F4-200D-2620-FE0F",
      c: "1F3F4-200D-2620",
      k: [11, 13],
      o: 11
    },
    guide_dog: { a: "Guide Dog", b: "1F9AE", k: [43, 2], o: 12 },
    restroom: {
      a: "Restroom",
      b: "1F6BB",
      j: ["blue-square", "toilet", "refresh", "wc", "gender"],
      k: [36, 12],
      o: 2
    },
    compass: { a: "Compass", b: "1F9ED", k: [51, 32], o: 11 },
    rolling_on_the_floor_laughing: {
      a: "Rolling on the Floor Laughing",
      b: "1F923",
      k: [38, 20],
      o: 4
    },
    balloon: {
      a: "Balloon",
      b: "1F388",
      j: ["party", "celebration", "birthday", "circus"],
      k: [7, 44],
      o: 2
    },
    pinching_hand: {
      skin_variations: {
        "1F3FB": {
          unified: "1F90F-1F3FB",
          non_qualified: null,
          image: "1f90f-1f3fb.png",
          sheet_x: 37,
          sheet_y: 18,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F90F-1F3FC",
          non_qualified: null,
          image: "1f90f-1f3fc.png",
          sheet_x: 37,
          sheet_y: 19,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F90F-1F3FD",
          non_qualified: null,
          image: "1f90f-1f3fd.png",
          sheet_x: 37,
          sheet_y: 20,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F90F-1F3FE",
          non_qualified: null,
          image: "1f90f-1f3fe.png",
          sheet_x: 37,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F90F-1F3FF",
          non_qualified: null,
          image: "1f90f-1f3ff.png",
          sheet_x: 37,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Pinching Hand",
      b: "1F90F",
      k: [37, 17],
      o: 12
    },
    pineapple: {
      a: "Pineapple",
      b: "1F34D",
      j: ["fruit", "nature", "food"],
      k: [6, 37],
      o: 2
    },
    shirt: { a: "T-Shirt", b: "1F455", k: [14, 9], n: ["tshirt"], o: 2 },
    service_dog: {
      a: "Service Dog",
      b: "1F415-200D-1F9BA",
      k: [11, 49],
      o: 12
    },
    baby_symbol: {
      a: "Baby Symbol",
      b: "1F6BC",
      j: ["orange-square", "child"],
      k: [36, 13],
      o: 2
    },
    joy: {
      a: "Face with Tears of Joy",
      b: "1F602",
      j: ["face", "cry", "tears", "weep", "happy", "happytears", "haha"],
      k: [30, 37],
      o: 2
    },
    tada: {
      a: "Party Popper",
      b: "1F389",
      j: [
        "party",
        "congratulations",
        "birthday",
        "magic",
        "circus",
        "celebration"
      ],
      k: [7, 45],
      o: 2
    },
    mango: { a: "Mango", b: "1F96D", k: [42, 3], o: 11 },
    v: {
      skin_variations: {
        "1F3FB": {
          unified: "270C-1F3FB",
          non_qualified: null,
          image: "270c-1f3fb.png",
          sheet_x: 54,
          sheet_y: 56,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "270C-1F3FC",
          non_qualified: null,
          image: "270c-1f3fc.png",
          sheet_x: 55,
          sheet_y: 0,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "270C-1F3FD",
          non_qualified: null,
          image: "270c-1f3fd.png",
          sheet_x: 55,
          sheet_y: 1,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "270C-1F3FE",
          non_qualified: null,
          image: "270c-1f3fe.png",
          sheet_x: 55,
          sheet_y: 2,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "270C-1F3FF",
          non_qualified: null,
          image: "270c-1f3ff.png",
          sheet_x: 55,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Victory Hand",
      b: "270C-FE0F",
      c: "270C",
      j: ["fingers", "ohyeah", "hand", "peace", "victory", "two"],
      k: [54, 55],
      o: 2
    },
    snow_capped_mountain: {
      a: "Snow Capped Mountain",
      b: "1F3D4-FE0F",
      c: "1F3D4",
      k: [10, 39],
      o: 2
    },
    "flag-ac": {
      a: "Ascension Island Flag",
      b: "1F1E6-1F1E8",
      k: [0, 31],
      o: 2
    },
    jeans: {
      a: "Jeans",
      b: "1F456",
      j: ["fashion", "shopping"],
      k: [14, 10],
      o: 2
    },
    poodle: {
      a: "Poodle",
      b: "1F429",
      j: ["dog", "animal", "101", "nature", "pet"],
      k: [12, 13],
      o: 2
    },
    crossed_fingers: {
      skin_variations: {
        "1F3FB": {
          unified: "1F91E-1F3FB",
          non_qualified: null,
          image: "1f91e-1f3fb.png",
          sheet_x: 38,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F91E-1F3FC",
          non_qualified: null,
          image: "1f91e-1f3fc.png",
          sheet_x: 38,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F91E-1F3FD",
          non_qualified: null,
          image: "1f91e-1f3fd.png",
          sheet_x: 38,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F91E-1F3FE",
          non_qualified: null,
          image: "1f91e-1f3fe.png",
          sheet_x: 38,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F91E-1F3FF",
          non_qualified: null,
          image: "1f91e-1f3ff.png",
          sheet_x: 38,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Hand with Index and Middle Fingers Crossed",
      b: "1F91E",
      j: ["good", "lucky"],
      k: [38, 5],
      n: ["hand_with_index_and_middle_fingers_crossed"],
      o: 4
    },
    "flag-ad": { a: "Andorra Flag", b: "1F1E6-1F1E9", k: [0, 32], o: 2 },
    slightly_smiling_face: {
      a: "Slightly Smiling Face",
      b: "1F642",
      j: ["face", "smile"],
      k: [31, 44],
      l: [":)", "(:", ":-)"],
      o: 2
    },
    apple: {
      a: "Red Apple",
      b: "1F34E",
      j: ["fruit", "mac", "school"],
      k: [6, 38],
      o: 2
    },
    wc: {
      a: "Water Closet",
      b: "1F6BE",
      j: ["toilet", "restroom", "blue-square"],
      k: [36, 15],
      o: 2
    },
    scarf: { a: "Scarf", b: "1F9E3", k: [51, 22], o: 5 },
    mountain: {
      a: "Mountain",
      b: "26F0-FE0F",
      c: "26F0",
      j: ["photo", "nature", "environment"],
      k: [54, 11],
      o: 2
    },
    confetti_ball: {
      a: "Confetti Ball",
      b: "1F38A",
      j: ["festival", "party", "birthday", "circus"],
      k: [7, 46],
      o: 2
    },
    i_love_you_hand_sign: {
      skin_variations: {
        "1F3FB": {
          unified: "1F91F-1F3FB",
          non_qualified: null,
          image: "1f91f-1f3fb.png",
          sheet_x: 38,
          sheet_y: 12,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F91F-1F3FC",
          non_qualified: null,
          image: "1f91f-1f3fc.png",
          sheet_x: 38,
          sheet_y: 13,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F91F-1F3FD",
          non_qualified: null,
          image: "1f91f-1f3fd.png",
          sheet_x: 38,
          sheet_y: 14,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F91F-1F3FE",
          non_qualified: null,
          image: "1f91f-1f3fe.png",
          sheet_x: 38,
          sheet_y: 15,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F91F-1F3FF",
          non_qualified: null,
          image: "1f91f-1f3ff.png",
          sheet_x: 38,
          sheet_y: 16,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "I Love You Hand Sign",
      b: "1F91F",
      k: [38, 11],
      o: 5
    },
    wolf: {
      a: "Wolf Face",
      b: "1F43A",
      j: ["animal", "nature", "wild"],
      k: [12, 30],
      o: 2
    },
    gloves: { a: "Gloves", b: "1F9E4", k: [51, 23], o: 5 },
    "flag-ae": {
      a: "United Arab Emirates Flag",
      b: "1F1E6-1F1EA",
      k: [0, 33],
      o: 2
    },
    upside_down_face: {
      a: "Upside-Down Face",
      b: "1F643",
      j: ["face", "flipped", "silly", "smile"],
      k: [31, 45],
      o: 2
    },
    green_apple: {
      a: "Green Apple",
      b: "1F34F",
      j: ["fruit", "nature"],
      k: [6, 39],
      o: 2
    },
    passport_control: {
      a: "Passport Control",
      b: "1F6C2",
      j: ["custom", "blue-square"],
      k: [36, 24],
      o: 2
    },
    volcano: {
      a: "Volcano",
      b: "1F30B",
      j: ["photo", "nature", "disaster"],
      k: [5, 30],
      o: 2
    },
    tanabata_tree: {
      a: "Tanabata Tree",
      b: "1F38B",
      j: ["plant", "nature", "branch", "summer"],
      k: [7, 47],
      o: 2
    },
    customs: {
      a: "Customs",
      b: "1F6C3",
      j: ["passport", "border", "blue-square"],
      k: [36, 25],
      o: 2
    },
    coat: { a: "Coat", b: "1F9E5", k: [51, 24], o: 5 },
    wink: {
      a: "Winking Face",
      b: "1F609",
      j: ["face", "happy", "mischievous", "secret", ";)", "smile", "eye"],
      k: [30, 44],
      l: [";)", ";-)"],
      m: ";)",
      o: 2
    },
    bamboo: {
      a: "Pine Decoration",
      b: "1F38D",
      j: ["plant", "nature", "vegetable", "panda", "pine_decoration"],
      k: [7, 49],
      o: 2
    },
    "flag-af": { a: "Afghanistan Flag", b: "1F1E6-1F1EB", k: [0, 34], o: 2 },
    fox_face: {
      a: "Fox Face",
      b: "1F98A",
      j: ["animal", "nature", "face"],
      k: [42, 28],
      o: 4
    },
    pear: {
      a: "Pear",
      b: "1F350",
      j: ["fruit", "nature", "food"],
      k: [6, 40],
      o: 2
    },
    mount_fuji: {
      a: "Mount Fuji",
      b: "1F5FB",
      j: ["photo", "mountain", "nature", "japanese"],
      k: [30, 30],
      o: 2
    },
    the_horns: {
      skin_variations: {
        "1F3FB": {
          unified: "1F918-1F3FB",
          non_qualified: null,
          image: "1f918-1f3fb.png",
          sheet_x: 37,
          sheet_y: 32,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F918-1F3FC",
          non_qualified: null,
          image: "1f918-1f3fc.png",
          sheet_x: 37,
          sheet_y: 33,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F918-1F3FD",
          non_qualified: null,
          image: "1f918-1f3fd.png",
          sheet_x: 37,
          sheet_y: 34,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F918-1F3FE",
          non_qualified: null,
          image: "1f918-1f3fe.png",
          sheet_x: 37,
          sheet_y: 35,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F918-1F3FF",
          non_qualified: null,
          image: "1f918-1f3ff.png",
          sheet_x: 37,
          sheet_y: 36,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Sign of the Horns",
      b: "1F918",
      k: [37, 31],
      n: ["sign_of_the_horns"],
      o: 2
    },
    call_me_hand: {
      skin_variations: {
        "1F3FB": {
          unified: "1F919-1F3FB",
          non_qualified: null,
          image: "1f919-1f3fb.png",
          sheet_x: 37,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F919-1F3FC",
          non_qualified: null,
          image: "1f919-1f3fc.png",
          sheet_x: 37,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F919-1F3FD",
          non_qualified: null,
          image: "1f919-1f3fd.png",
          sheet_x: 37,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F919-1F3FE",
          non_qualified: null,
          image: "1f919-1f3fe.png",
          sheet_x: 37,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F919-1F3FF",
          non_qualified: null,
          image: "1f919-1f3ff.png",
          sheet_x: 37,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Call Me Hand",
      b: "1F919",
      j: ["hands", "gesture"],
      k: [37, 37],
      o: 4
    },
    "flag-ag": {
      a: "Antigua & Barbuda Flag",
      b: "1F1E6-1F1EC",
      k: [0, 35],
      o: 2
    },
    raccoon: { a: "Raccoon", b: "1F99D", k: [42, 47], o: 11 },
    dolls: {
      a: "Japanese Dolls",
      b: "1F38E",
      j: ["japanese", "toy", "kimono"],
      k: [7, 50],
      o: 2
    },
    blush: {
      a: "Smiling Face with Smiling Eyes",
      b: "1F60A",
      j: [
        "face",
        "smile",
        "happy",
        "flushed",
        "crush",
        "embarrassed",
        "shy",
        "joy"
      ],
      k: [30, 45],
      m: ":)",
      o: 2
    },
    peach: {
      a: "Peach",
      b: "1F351",
      j: ["fruit", "nature", "food"],
      k: [6, 41],
      o: 2
    },
    baggage_claim: {
      a: "Baggage Claim",
      b: "1F6C4",
      j: ["blue-square", "airport", "transport"],
      k: [36, 26],
      o: 2
    },
    socks: { a: "Socks", b: "1F9E6", k: [51, 25], o: 5 },
    camping: {
      a: "Camping",
      b: "1F3D5-FE0F",
      c: "1F3D5",
      j: ["photo", "outdoors", "tent"],
      k: [10, 40],
      o: 2
    },
    dress: {
      a: "Dress",
      b: "1F457",
      j: ["clothes", "fashion", "shopping"],
      k: [14, 11],
      o: 2
    },
    beach_with_umbrella: {
      a: "Beach with Umbrella",
      b: "1F3D6-FE0F",
      c: "1F3D6",
      k: [10, 41],
      o: 2
    },
    cherries: {
      a: "Cherries",
      b: "1F352",
      j: ["food", "fruit"],
      k: [6, 42],
      o: 2
    },
    cat: {
      a: "Cat Face",
      b: "1F431",
      j: ["animal", "meow", "nature", "pet", "kitten"],
      k: [12, 21],
      o: 2
    },
    point_left: {
      skin_variations: {
        "1F3FB": {
          unified: "1F448-1F3FB",
          non_qualified: null,
          image: "1f448-1f3fb.png",
          sheet_x: 13,
          sheet_y: 9,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F448-1F3FC",
          non_qualified: null,
          image: "1f448-1f3fc.png",
          sheet_x: 13,
          sheet_y: 10,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F448-1F3FD",
          non_qualified: null,
          image: "1f448-1f3fd.png",
          sheet_x: 13,
          sheet_y: 11,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F448-1F3FE",
          non_qualified: null,
          image: "1f448-1f3fe.png",
          sheet_x: 13,
          sheet_y: 12,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F448-1F3FF",
          non_qualified: null,
          image: "1f448-1f3ff.png",
          sheet_x: 13,
          sheet_y: 13,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "White Left Pointing Backhand Index",
      b: "1F448",
      j: ["direction", "fingers", "hand", "left"],
      k: [13, 8],
      o: 2
    },
    left_luggage: {
      a: "Left Luggage",
      b: "1F6C5",
      j: ["blue-square", "travel"],
      k: [36, 27],
      o: 2
    },
    "flag-ai": { a: "Anguilla Flag", b: "1F1E6-1F1EE", k: [0, 36], o: 2 },
    innocent: {
      a: "Smiling Face with Halo",
      b: "1F607",
      j: ["face", "angel", "heaven", "halo"],
      k: [30, 42],
      o: 2
    },
    flags: {
      a: "Carp Streamer",
      b: "1F38F",
      j: ["fish", "japanese", "koinobori", "carp", "banner"],
      k: [7, 51],
      o: 2
    },
    warning: {
      a: "Warning Sign",
      b: "26A0-FE0F",
      c: "26A0",
      j: ["exclamation", "wip", "alert", "error", "problem", "issue"],
      k: [53, 50],
      o: 2
    },
    strawberry: {
      a: "Strawberry",
      b: "1F353",
      j: ["fruit", "food", "nature"],
      k: [6, 43],
      o: 2
    },
    point_right: {
      skin_variations: {
        "1F3FB": {
          unified: "1F449-1F3FB",
          non_qualified: null,
          image: "1f449-1f3fb.png",
          sheet_x: 13,
          sheet_y: 15,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F449-1F3FC",
          non_qualified: null,
          image: "1f449-1f3fc.png",
          sheet_x: 13,
          sheet_y: 16,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F449-1F3FD",
          non_qualified: null,
          image: "1f449-1f3fd.png",
          sheet_x: 13,
          sheet_y: 17,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F449-1F3FE",
          non_qualified: null,
          image: "1f449-1f3fe.png",
          sheet_x: 13,
          sheet_y: 18,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F449-1F3FF",
          non_qualified: null,
          image: "1f449-1f3ff.png",
          sheet_x: 13,
          sheet_y: 19,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "White Right Pointing Backhand Index",
      b: "1F449",
      j: ["fingers", "hand", "direction", "right"],
      k: [13, 14],
      o: 2
    },
    desert: {
      a: "Desert",
      b: "1F3DC-FE0F",
      c: "1F3DC",
      j: ["photo", "warm", "saharah"],
      k: [10, 47],
      o: 2
    },
    kimono: {
      a: "Kimono",
      b: "1F458",
      j: ["dress", "fashion", "women", "female", "japanese"],
      k: [14, 12],
      o: 2
    },
    "flag-al": { a: "Albania Flag", b: "1F1E6-1F1F1", k: [0, 37], o: 2 },
    wind_chime: {
      a: "Wind Chime",
      b: "1F390",
      j: ["nature", "ding", "spring", "bell"],
      k: [7, 52],
      o: 2
    },
    smiling_face_with_3_hearts: {
      a: "Smiling Face with Smiling Eyes and Three Hearts",
      b: "1F970",
      k: [42, 6],
      o: 11
    },
    cat2: {
      a: "Cat",
      b: "1F408",
      j: ["animal", "meow", "pet", "cats"],
      k: [11, 36],
      o: 2
    },
    rice_scene: {
      a: "Moon Viewing Ceremony",
      b: "1F391",
      j: ["photo", "japan", "asia", "tsukimi"],
      k: [7, 53],
      o: 2
    },
    heart_eyes: {
      a: "Smiling Face with Heart-Shaped Eyes",
      b: "1F60D",
      j: [
        "face",
        "love",
        "like",
        "affection",
        "valentines",
        "infatuation",
        "crush",
        "heart"
      ],
      k: [30, 48],
      o: 2
    },
    sari: { a: "Sari", b: "1F97B", k: [42, 13], o: 12 },
    "flag-am": { a: "Armenia Flag", b: "1F1E6-1F1F2", k: [0, 38], o: 2 },
    lion_face: { a: "Lion Face", b: "1F981", k: [42, 19], o: 2 },
    desert_island: {
      a: "Desert Island",
      b: "1F3DD-FE0F",
      c: "1F3DD",
      j: ["photo", "tropical", "mojito"],
      k: [10, 48],
      o: 2
    },
    point_up_2: {
      skin_variations: {
        "1F3FB": {
          unified: "1F446-1F3FB",
          non_qualified: null,
          image: "1f446-1f3fb.png",
          sheet_x: 12,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F446-1F3FC",
          non_qualified: null,
          image: "1f446-1f3fc.png",
          sheet_x: 12,
          sheet_y: 55,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F446-1F3FD",
          non_qualified: null,
          image: "1f446-1f3fd.png",
          sheet_x: 12,
          sheet_y: 56,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F446-1F3FE",
          non_qualified: null,
          image: "1f446-1f3fe.png",
          sheet_x: 13,
          sheet_y: 0,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F446-1F3FF",
          non_qualified: null,
          image: "1f446-1f3ff.png",
          sheet_x: 13,
          sheet_y: 1,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "White Up Pointing Backhand Index",
      b: "1F446",
      j: ["fingers", "hand", "direction", "up"],
      k: [12, 53],
      o: 2
    },
    kiwifruit: { a: "Kiwifruit", b: "1F95D", k: [41, 44], o: 4 },
    children_crossing: {
      a: "Children Crossing",
      b: "1F6B8",
      j: ["school", "warning", "danger", "sign", "driving", "yellow-diamond"],
      k: [36, 9],
      o: 2
    },
    national_park: {
      a: "National Park",
      b: "1F3DE-FE0F",
      c: "1F3DE",
      j: ["photo", "environment", "nature"],
      k: [10, 49],
      o: 2
    },
    no_entry: {
      a: "No Entry",
      b: "26D4",
      j: ["limit", "security", "privacy", "bad", "denied", "stop", "circle"],
      k: [54, 8],
      o: 2
    },
    "one-piece_swimsuit": {
      a: "One-Piece Swimsuit",
      b: "1FA71",
      k: [51, 52],
      o: 12
    },
    tiger: {
      a: "Tiger Face",
      b: "1F42F",
      j: ["animal", "cat", "danger", "wild", "nature", "roar"],
      k: [12, 19],
      o: 2
    },
    red_envelope: { a: "Red Gift Envelope", b: "1F9E7", k: [51, 26], o: 11 },
    "star-struck": {
      a: "Grinning Face with Star Eyes",
      b: "1F929",
      k: [38, 43],
      n: ["grinning_face_with_star_eyes"],
      o: 5
    },
    middle_finger: {
      skin_variations: {
        "1F3FB": {
          unified: "1F595-1F3FB",
          non_qualified: null,
          image: "1f595-1f3fb.png",
          sheet_x: 29,
          sheet_y: 55,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F595-1F3FC",
          non_qualified: null,
          image: "1f595-1f3fc.png",
          sheet_x: 29,
          sheet_y: 56,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F595-1F3FD",
          non_qualified: null,
          image: "1f595-1f3fd.png",
          sheet_x: 30,
          sheet_y: 0,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F595-1F3FE",
          non_qualified: null,
          image: "1f595-1f3fe.png",
          sheet_x: 30,
          sheet_y: 1,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F595-1F3FF",
          non_qualified: null,
          image: "1f595-1f3ff.png",
          sheet_x: 30,
          sheet_y: 2,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Reversed Hand with Middle Finger Extended",
      b: "1F595",
      k: [29, 54],
      n: ["reversed_hand_with_middle_finger_extended"],
      o: 2
    },
    "flag-ao": { a: "Angola Flag", b: "1F1E6-1F1F4", k: [0, 39], o: 2 },
    tomato: {
      a: "Tomato",
      b: "1F345",
      j: ["fruit", "vegetable", "nature", "food"],
      k: [6, 29],
      o: 2
    },
    coconut: { a: "Coconut", b: "1F965", k: [41, 52], o: 5 },
    ribbon: {
      a: "Ribbon",
      b: "1F380",
      j: ["decoration", "pink", "girl", "bowtie"],
      k: [7, 31],
      o: 2
    },
    no_entry_sign: {
      a: "No Entry Sign",
      b: "1F6AB",
      j: ["forbid", "stop", "limit", "denied", "disallow", "circle"],
      k: [35, 2],
      o: 2
    },
    point_down: {
      skin_variations: {
        "1F3FB": {
          unified: "1F447-1F3FB",
          non_qualified: null,
          image: "1f447-1f3fb.png",
          sheet_x: 13,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F447-1F3FC",
          non_qualified: null,
          image: "1f447-1f3fc.png",
          sheet_x: 13,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F447-1F3FD",
          non_qualified: null,
          image: "1f447-1f3fd.png",
          sheet_x: 13,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F447-1F3FE",
          non_qualified: null,
          image: "1f447-1f3fe.png",
          sheet_x: 13,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F447-1F3FF",
          non_qualified: null,
          image: "1f447-1f3ff.png",
          sheet_x: 13,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "White Down Pointing Backhand Index",
      b: "1F447",
      j: ["fingers", "hand", "direction", "down"],
      k: [13, 2],
      o: 2
    },
    "flag-aq": { a: "Antarctica Flag", b: "1F1E6-1F1F6", k: [0, 40], o: 2 },
    briefs: { a: "Briefs", b: "1FA72", k: [51, 53], o: 12 },
    kissing_heart: {
      a: "Face Throwing a Kiss",
      b: "1F618",
      j: [
        "face",
        "love",
        "like",
        "affection",
        "valentines",
        "infatuation",
        "kiss"
      ],
      k: [31, 2],
      l: [":*", ":-*"],
      o: 2
    },
    tiger2: {
      a: "Tiger",
      b: "1F405",
      j: ["animal", "nature", "roar"],
      k: [11, 33],
      o: 2
    },
    stadium: {
      a: "Stadium",
      b: "1F3DF-FE0F",
      c: "1F3DF",
      j: ["photo", "place", "sports", "concert", "venue"],
      k: [10, 50],
      o: 2
    },
    leopard: {
      a: "Leopard",
      b: "1F406",
      j: ["animal", "nature"],
      k: [11, 34],
      o: 2
    },
    no_bicycles: {
      a: "No Bicycles",
      b: "1F6B3",
      j: ["cyclist", "prohibited", "circle"],
      k: [35, 10],
      o: 2
    },
    kissing: {
      a: "Kissing Face",
      b: "1F617",
      j: ["love", "like", "face", "3", "valentines", "infatuation", "kiss"],
      k: [31, 1],
      o: 2
    },
    "flag-ar": { a: "Argentina Flag", b: "1F1E6-1F1F7", k: [0, 41], o: 2 },
    avocado: {
      a: "Avocado",
      b: "1F951",
      j: ["fruit", "food"],
      k: [41, 32],
      o: 4
    },
    point_up: {
      skin_variations: {
        "1F3FB": {
          unified: "261D-1F3FB",
          non_qualified: null,
          image: "261d-1f3fb.png",
          sheet_x: 53,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "261D-1F3FC",
          non_qualified: null,
          image: "261d-1f3fc.png",
          sheet_x: 53,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "261D-1F3FD",
          non_qualified: null,
          image: "261d-1f3fd.png",
          sheet_x: 53,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "261D-1F3FE",
          non_qualified: null,
          image: "261d-1f3fe.png",
          sheet_x: 53,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "261D-1F3FF",
          non_qualified: null,
          image: "261d-1f3ff.png",
          sheet_x: 53,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "White Up Pointing Index",
      b: "261D-FE0F",
      c: "261D",
      j: ["hand", "fingers", "direction", "up"],
      k: [53, 2],
      o: 2
    },
    gift: {
      a: "Wrapped Present",
      b: "1F381",
      j: ["present", "birthday", "christmas", "xmas"],
      k: [7, 32],
      o: 2
    },
    classical_building: {
      a: "Classical Building",
      b: "1F3DB-FE0F",
      c: "1F3DB",
      j: ["art", "culture", "history"],
      k: [10, 46],
      o: 2
    },
    shorts: { a: "Shorts", b: "1FA73", k: [51, 54], o: 12 },
    "+1": {
      skin_variations: {
        "1F3FB": {
          unified: "1F44D-1F3FB",
          non_qualified: null,
          image: "1f44d-1f3fb.png",
          sheet_x: 13,
          sheet_y: 39,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F44D-1F3FC",
          non_qualified: null,
          image: "1f44d-1f3fc.png",
          sheet_x: 13,
          sheet_y: 40,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F44D-1F3FD",
          non_qualified: null,
          image: "1f44d-1f3fd.png",
          sheet_x: 13,
          sheet_y: 41,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F44D-1F3FE",
          non_qualified: null,
          image: "1f44d-1f3fe.png",
          sheet_x: 13,
          sheet_y: 42,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F44D-1F3FF",
          non_qualified: null,
          image: "1f44d-1f3ff.png",
          sheet_x: 13,
          sheet_y: 43,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Thumbs Up Sign",
      b: "1F44D",
      j: [
        "thumbsup",
        "yes",
        "awesome",
        "good",
        "agree",
        "accept",
        "cool",
        "hand",
        "like"
      ],
      k: [13, 38],
      n: ["thumbsup"],
      o: 2
    },
    horse: {
      a: "Horse Face",
      b: "1F434",
      j: ["animal", "brown", "nature"],
      k: [12, 24],
      o: 2
    },
    bikini: {
      a: "Bikini",
      b: "1F459",
      j: ["swimming", "female", "woman", "girl", "fashion", "beach", "summer"],
      k: [14, 13],
      o: 2
    },
    no_smoking: {
      a: "No Smoking Symbol",
      b: "1F6AD",
      j: ["cigarette", "blue-square", "smell", "smoke"],
      k: [35, 4],
      o: 2
    },
    eggplant: {
      a: "Aubergine",
      b: "1F346",
      j: ["vegetable", "nature", "food", "aubergine"],
      k: [6, 30],
      o: 2
    },
    "flag-as": { a: "American Samoa Flag", b: "1F1E6-1F1F8", k: [0, 42], o: 2 },
    reminder_ribbon: {
      a: "Reminder Ribbon",
      b: "1F397-FE0F",
      c: "1F397",
      j: ["sports", "cause", "support", "awareness"],
      k: [8, 0],
      o: 2
    },
    building_construction: {
      a: "Building Construction",
      b: "1F3D7-FE0F",
      c: "1F3D7",
      j: ["wip", "working", "progress"],
      k: [10, 42],
      o: 2
    },
    relaxed: {
      a: "White Smiling Face",
      b: "263A-FE0F",
      c: "263A",
      j: ["face", "blush", "massage", "happiness"],
      k: [53, 17],
      o: 2
    },
    kissing_closed_eyes: {
      a: "Kissing Face with Closed Eyes",
      b: "1F61A",
      j: [
        "face",
        "love",
        "like",
        "affection",
        "valentines",
        "infatuation",
        "kiss"
      ],
      k: [31, 4],
      o: 2
    },
    "-1": {
      skin_variations: {
        "1F3FB": {
          unified: "1F44E-1F3FB",
          non_qualified: null,
          image: "1f44e-1f3fb.png",
          sheet_x: 13,
          sheet_y: 45,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F44E-1F3FC",
          non_qualified: null,
          image: "1f44e-1f3fc.png",
          sheet_x: 13,
          sheet_y: 46,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F44E-1F3FD",
          non_qualified: null,
          image: "1f44e-1f3fd.png",
          sheet_x: 13,
          sheet_y: 47,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F44E-1F3FE",
          non_qualified: null,
          image: "1f44e-1f3fe.png",
          sheet_x: 13,
          sheet_y: 48,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F44E-1F3FF",
          non_qualified: null,
          image: "1f44e-1f3ff.png",
          sheet_x: 13,
          sheet_y: 49,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Thumbs Down Sign",
      b: "1F44E",
      j: ["thumbsdown", "no", "dislike", "hand"],
      k: [13, 44],
      n: ["thumbsdown"],
      o: 2
    },
    admission_tickets: {
      a: "Admission Tickets",
      b: "1F39F-FE0F",
      c: "1F39F",
      k: [8, 5],
      o: 2
    },
    "flag-at": { a: "Austria Flag", b: "1F1E6-1F1F9", k: [0, 43], o: 2 },
    womans_clothes: {
      a: "Womans Clothes",
      b: "1F45A",
      j: ["fashion", "shopping_bags", "female"],
      k: [14, 14],
      o: 2
    },
    do_not_litter: {
      a: "Do Not Litter Symbol",
      b: "1F6AF",
      j: ["trash", "bin", "garbage", "circle"],
      k: [35, 6],
      o: 2
    },
    potato: {
      a: "Potato",
      b: "1F954",
      j: ["food", "tuber", "vegatable", "starch"],
      k: [41, 35],
      o: 4
    },
    racehorse: {
      a: "Horse",
      b: "1F40E",
      j: ["animal", "gamble", "luck"],
      k: [11, 42],
      o: 2
    },
    bricks: { a: "Brick", b: "1F9F1", k: [51, 36], o: 11 },
    fist: {
      skin_variations: {
        "1F3FB": {
          unified: "270A-1F3FB",
          non_qualified: null,
          image: "270a-1f3fb.png",
          sheet_x: 54,
          sheet_y: 44,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "270A-1F3FC",
          non_qualified: null,
          image: "270a-1f3fc.png",
          sheet_x: 54,
          sheet_y: 45,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "270A-1F3FD",
          non_qualified: null,
          image: "270a-1f3fd.png",
          sheet_x: 54,
          sheet_y: 46,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "270A-1F3FE",
          non_qualified: null,
          image: "270a-1f3fe.png",
          sheet_x: 54,
          sheet_y: 47,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "270A-1F3FF",
          non_qualified: null,
          image: "270a-1f3ff.png",
          sheet_x: 54,
          sheet_y: 48,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Raised Fist",
      b: "270A",
      j: ["fingers", "hand", "grasp"],
      k: [54, 43],
      o: 2
    },
    house_buildings: {
      a: "House Buildings",
      b: "1F3D8-FE0F",
      c: "1F3D8",
      k: [10, 43],
      o: 2
    },
    carrot: {
      a: "Carrot",
      b: "1F955",
      j: ["vegetable", "food", "orange"],
      k: [41, 36],
      o: 4
    },
    ticket: {
      a: "Ticket",
      b: "1F3AB",
      j: ["event", "concert", "pass"],
      k: [8, 17],
      o: 2
    },
    "flag-au": { a: "Australia Flag", b: "1F1E6-1F1FA", k: [0, 44], o: 2 },
    "non-potable_water": {
      a: "Non-Potable Water Symbol",
      b: "1F6B1",
      j: ["drink", "faucet", "tap", "circle"],
      k: [35, 8],
      o: 2
    },
    purse: {
      a: "Purse",
      b: "1F45B",
      j: ["fashion", "accessories", "money", "sales", "shopping"],
      k: [14, 15],
      o: 2
    },
    unicorn_face: { a: "Unicorn Face", b: "1F984", k: [42, 22], o: 2 },
    kissing_smiling_eyes: {
      a: "Kissing Face with Smiling Eyes",
      b: "1F619",
      j: ["face", "affection", "valentines", "infatuation", "kiss"],
      k: [31, 3],
      o: 2
    },
    facepunch: {
      skin_variations: {
        "1F3FB": {
          unified: "1F44A-1F3FB",
          non_qualified: null,
          image: "1f44a-1f3fb.png",
          sheet_x: 13,
          sheet_y: 21,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F44A-1F3FC",
          non_qualified: null,
          image: "1f44a-1f3fc.png",
          sheet_x: 13,
          sheet_y: 22,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F44A-1F3FD",
          non_qualified: null,
          image: "1f44a-1f3fd.png",
          sheet_x: 13,
          sheet_y: 23,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F44A-1F3FE",
          non_qualified: null,
          image: "1f44a-1f3fe.png",
          sheet_x: 13,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F44A-1F3FF",
          non_qualified: null,
          image: "1f44a-1f3ff.png",
          sheet_x: 13,
          sheet_y: 25,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Fisted Hand Sign",
      b: "1F44A",
      j: ["angry", "violence", "fist", "hit", "attack", "hand"],
      k: [13, 20],
      n: ["punch"],
      o: 2
    },
    medal: { a: "Medal", b: "1F396-FE0F", c: "1F396", k: [7, 56], o: 2 },
    zebra_face: { a: "Zebra Face", b: "1F993", k: [42, 37], o: 5 },
    handbag: {
      a: "Handbag",
      b: "1F45C",
      j: ["fashion", "accessory", "accessories", "shopping"],
      k: [14, 16],
      o: 2
    },
    derelict_house_building: {
      a: "Derelict House Building",
      b: "1F3DA-FE0F",
      c: "1F3DA",
      k: [10, 45],
      o: 2
    },
    yum: {
      a: "Face Savouring Delicious Food",
      b: "1F60B",
      j: [
        "happy",
        "joy",
        "tongue",
        "smile",
        "face",
        "silly",
        "yummy",
        "nom",
        "delicious",
        "savouring"
      ],
      k: [30, 46],
      o: 2
    },
    corn: {
      a: "Ear of Maize",
      b: "1F33D",
      j: ["food", "vegetable", "plant"],
      k: [6, 21],
      o: 2
    },
    "flag-aw": { a: "Aruba Flag", b: "1F1E6-1F1FC", k: [0, 45], o: 2 },
    no_pedestrians: {
      a: "No Pedestrians",
      b: "1F6B7",
      j: ["rules", "crossing", "walking", "circle"],
      k: [36, 8],
      o: 2
    },
    house: {
      a: "House Building",
      b: "1F3E0",
      j: ["building", "home"],
      k: [10, 51],
      o: 2
    },
    hot_pepper: {
      a: "Hot Pepper",
      b: "1F336-FE0F",
      c: "1F336",
      j: ["food", "spicy", "chilli", "chili"],
      k: [6, 14],
      o: 2
    },
    "flag-ax": { a: "\xC5land Islands Flag", b: "1F1E6-1F1FD", k: [0, 46], o: 2 },
    trophy: {
      a: "Trophy",
      b: "1F3C6",
      j: ["win", "award", "contest", "place", "ftw", "ceremony"],
      k: [9, 26],
      o: 2
    },
    deer: {
      a: "Deer",
      b: "1F98C",
      j: ["animal", "nature", "horns", "venison"],
      k: [42, 30],
      o: 4
    },
    "left-facing_fist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F91B-1F3FB",
          non_qualified: null,
          image: "1f91b-1f3fb.png",
          sheet_x: 37,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F91B-1F3FC",
          non_qualified: null,
          image: "1f91b-1f3fc.png",
          sheet_x: 37,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F91B-1F3FD",
          non_qualified: null,
          image: "1f91b-1f3fd.png",
          sheet_x: 37,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F91B-1F3FE",
          non_qualified: null,
          image: "1f91b-1f3fe.png",
          sheet_x: 37,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F91B-1F3FF",
          non_qualified: null,
          image: "1f91b-1f3ff.png",
          sheet_x: 37,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Left-Facing Fist",
      b: "1F91B",
      k: [37, 49],
      o: 4
    },
    stuck_out_tongue: {
      a: "Face with Stuck-out Tongue",
      b: "1F61B",
      j: [
        "face",
        "prank",
        "childish",
        "playful",
        "mischievous",
        "smile",
        "tongue"
      ],
      k: [31, 5],
      l: [":p", ":-p", ":P", ":-P", ":b", ":-b"],
      m: ":p",
      o: 2
    },
    pouch: {
      a: "Pouch",
      b: "1F45D",
      j: ["bag", "accessories", "shopping"],
      k: [14, 17],
      o: 2
    },
    no_mobile_phones: {
      a: "No Mobile Phones",
      b: "1F4F5",
      j: ["iphone", "mute", "circle"],
      k: [27, 18],
      o: 2
    },
    stuck_out_tongue_winking_eye: {
      a: "Face with Stuck-out Tongue and Winking Eye",
      b: "1F61C",
      j: [
        "face",
        "prank",
        "childish",
        "playful",
        "mischievous",
        "smile",
        "wink",
        "tongue"
      ],
      k: [31, 6],
      l: [";p", ";-p", ";b", ";-b", ";P", ";-P"],
      m: ";p",
      o: 2
    },
    sports_medal: { a: "Sports Medal", b: "1F3C5", k: [9, 25], o: 2 },
    cucumber: {
      a: "Cucumber",
      b: "1F952",
      j: ["fruit", "food", "pickle"],
      k: [41, 33],
      o: 4
    },
    cow: {
      a: "Cow Face",
      b: "1F42E",
      j: ["beef", "ox", "animal", "nature", "moo", "milk"],
      k: [12, 18],
      o: 2
    },
    underage: {
      a: "No One Under Eighteen Symbol",
      b: "1F51E",
      j: ["18", "drink", "pub", "night", "minor", "circle"],
      k: [28, 1],
      o: 2
    },
    "flag-az": { a: "Azerbaijan Flag", b: "1F1E6-1F1FF", k: [0, 47], o: 2 },
    shopping_bags: {
      a: "Shopping Bags",
      b: "1F6CD-FE0F",
      c: "1F6CD",
      k: [36, 35],
      o: 2
    },
    "right-facing_fist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F91C-1F3FB",
          non_qualified: null,
          image: "1f91c-1f3fb.png",
          sheet_x: 37,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F91C-1F3FC",
          non_qualified: null,
          image: "1f91c-1f3fc.png",
          sheet_x: 38,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F91C-1F3FD",
          non_qualified: null,
          image: "1f91c-1f3fd.png",
          sheet_x: 38,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F91C-1F3FE",
          non_qualified: null,
          image: "1f91c-1f3fe.png",
          sheet_x: 38,
          sheet_y: 2,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F91C-1F3FF",
          non_qualified: null,
          image: "1f91c-1f3ff.png",
          sheet_x: 38,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Right-Facing Fist",
      b: "1F91C",
      k: [37, 55],
      o: 4
    },
    house_with_garden: {
      a: "House with Garden",
      b: "1F3E1",
      j: ["home", "plant", "nature"],
      k: [10, 52],
      o: 2
    },
    clap: {
      skin_variations: {
        "1F3FB": {
          unified: "1F44F-1F3FB",
          non_qualified: null,
          image: "1f44f-1f3fb.png",
          sheet_x: 13,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F44F-1F3FC",
          non_qualified: null,
          image: "1f44f-1f3fc.png",
          sheet_x: 13,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F44F-1F3FD",
          non_qualified: null,
          image: "1f44f-1f3fd.png",
          sheet_x: 13,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F44F-1F3FE",
          non_qualified: null,
          image: "1f44f-1f3fe.png",
          sheet_x: 13,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F44F-1F3FF",
          non_qualified: null,
          image: "1f44f-1f3ff.png",
          sheet_x: 13,
          sheet_y: 55,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Clapping Hands Sign",
      b: "1F44F",
      j: ["hands", "praise", "applause", "congrats", "yay"],
      k: [13, 50],
      o: 2
    },
    leafy_green: { a: "Leafy Green", b: "1F96C", k: [42, 2], o: 11 },
    office: {
      a: "Office Building",
      b: "1F3E2",
      j: ["building", "bureau", "work"],
      k: [10, 53],
      o: 2
    },
    "flag-ba": {
      a: "Bosnia & Herzegovina Flag",
      b: "1F1E7-1F1E6",
      k: [0, 48],
      o: 2
    },
    zany_face: {
      a: "Grinning Face with One Large and One Small Eye",
      b: "1F92A",
      k: [38, 44],
      n: ["grinning_face_with_one_large_and_one_small_eye"],
      o: 5
    },
    first_place_medal: {
      a: "First Place Medal",
      b: "1F947",
      k: [41, 22],
      o: 4
    },
    ox: {
      a: "Ox",
      b: "1F402",
      j: ["animal", "cow", "beef"],
      k: [11, 30],
      o: 2
    },
    school_satchel: {
      a: "School Satchel",
      b: "1F392",
      j: ["student", "education", "bag", "backpack"],
      k: [7, 54],
      o: 2
    },
    radioactive_sign: {
      a: "Radioactive Sign",
      b: "2622-FE0F",
      c: "2622",
      k: [53, 9],
      o: 2
    },
    second_place_medal: {
      a: "Second Place Medal",
      b: "1F948",
      k: [41, 23],
      o: 4
    },
    stuck_out_tongue_closed_eyes: {
      a: "Face with Stuck-out Tongue and Tightly-Closed Eyes",
      b: "1F61D",
      j: ["face", "prank", "playful", "mischievous", "smile", "tongue"],
      k: [31, 7],
      o: 2
    },
    broccoli: { a: "Broccoli", b: "1F966", k: [41, 53], o: 5 },
    biohazard_sign: {
      a: "Biohazard Sign",
      b: "2623-FE0F",
      c: "2623",
      k: [53, 10],
      o: 2
    },
    mans_shoe: {
      a: "Mans Shoe",
      b: "1F45E",
      j: ["fashion", "male"],
      k: [14, 18],
      n: ["shoe"],
      o: 2
    },
    raised_hands: {
      skin_variations: {
        "1F3FB": {
          unified: "1F64C-1F3FB",
          non_qualified: null,
          image: "1f64c-1f3fb.png",
          sheet_x: 33,
          sheet_y: 9,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64C-1F3FC",
          non_qualified: null,
          image: "1f64c-1f3fc.png",
          sheet_x: 33,
          sheet_y: 10,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64C-1F3FD",
          non_qualified: null,
          image: "1f64c-1f3fd.png",
          sheet_x: 33,
          sheet_y: 11,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64C-1F3FE",
          non_qualified: null,
          image: "1f64c-1f3fe.png",
          sheet_x: 33,
          sheet_y: 12,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64C-1F3FF",
          non_qualified: null,
          image: "1f64c-1f3ff.png",
          sheet_x: 33,
          sheet_y: 13,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Person Raising Both Hands in Celebration",
      b: "1F64C",
      j: ["gesture", "hooray", "yea", "celebration", "hands"],
      k: [33, 8],
      o: 2
    },
    post_office: {
      a: "Japanese Post Office",
      b: "1F3E3",
      j: ["building", "envelope", "communication"],
      k: [10, 54],
      o: 2
    },
    "flag-bb": { a: "Barbados Flag", b: "1F1E7-1F1E7", k: [0, 49], o: 2 },
    water_buffalo: {
      a: "Water Buffalo",
      b: "1F403",
      j: ["animal", "nature", "ox", "cow"],
      k: [11, 31],
      o: 2
    },
    third_place_medal: {
      a: "Third Place Medal",
      b: "1F949",
      k: [41, 24],
      o: 4
    },
    european_post_office: {
      a: "European Post Office",
      b: "1F3E4",
      j: ["building", "email"],
      k: [10, 55],
      o: 2
    },
    athletic_shoe: {
      a: "Athletic Shoe",
      b: "1F45F",
      j: ["shoes", "sports", "sneakers"],
      k: [14, 19],
      o: 2
    },
    arrow_up: {
      a: "Upwards Black Arrow",
      b: "2B06-FE0F",
      c: "2B06",
      j: ["blue-square", "continue", "top", "direction"],
      k: [55, 38],
      o: 2
    },
    cow2: {
      a: "Cow",
      b: "1F404",
      j: ["beef", "ox", "animal", "nature", "moo", "milk"],
      k: [11, 32],
      o: 2
    },
    open_hands: {
      skin_variations: {
        "1F3FB": {
          unified: "1F450-1F3FB",
          non_qualified: null,
          image: "1f450-1f3fb.png",
          sheet_x: 14,
          sheet_y: 0,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F450-1F3FC",
          non_qualified: null,
          image: "1f450-1f3fc.png",
          sheet_x: 14,
          sheet_y: 1,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F450-1F3FD",
          non_qualified: null,
          image: "1f450-1f3fd.png",
          sheet_x: 14,
          sheet_y: 2,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F450-1F3FE",
          non_qualified: null,
          image: "1f450-1f3fe.png",
          sheet_x: 14,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F450-1F3FF",
          non_qualified: null,
          image: "1f450-1f3ff.png",
          sheet_x: 14,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Open Hands Sign",
      b: "1F450",
      j: ["fingers", "butterfly", "hands", "open"],
      k: [13, 56],
      o: 2
    },
    garlic: { a: "Garlic", b: "1F9C4", k: [44, 12], o: 12 },
    money_mouth_face: {
      a: "Money-Mouth Face",
      b: "1F911",
      j: ["face", "rich", "dollar", "money"],
      k: [37, 24],
      o: 2
    },
    "flag-bd": { a: "Bangladesh Flag", b: "1F1E7-1F1E9", k: [0, 50], o: 2 },
    soccer: {
      a: "Soccer Ball",
      b: "26BD",
      j: ["sports", "football"],
      k: [53, 56],
      o: 2
    },
    hugging_face: { a: "Hugging Face", b: "1F917", k: [37, 30], o: 2 },
    onion: { a: "Onion", b: "1F9C5", k: [44, 13], o: 12 },
    arrow_upper_right: {
      a: "North East Arrow",
      b: "2197-FE0F",
      c: "2197",
      j: ["blue-square", "point", "direction", "diagonal", "northeast"],
      k: [52, 17],
      o: 2
    },
    palms_up_together: {
      skin_variations: {
        "1F3FB": {
          unified: "1F932-1F3FB",
          non_qualified: null,
          image: "1f932-1f3fb.png",
          sheet_x: 39,
          sheet_y: 6,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F932-1F3FC",
          non_qualified: null,
          image: "1f932-1f3fc.png",
          sheet_x: 39,
          sheet_y: 7,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F932-1F3FD",
          non_qualified: null,
          image: "1f932-1f3fd.png",
          sheet_x: 39,
          sheet_y: 8,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F932-1F3FE",
          non_qualified: null,
          image: "1f932-1f3fe.png",
          sheet_x: 39,
          sheet_y: 9,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F932-1F3FF",
          non_qualified: null,
          image: "1f932-1f3ff.png",
          sheet_x: 39,
          sheet_y: 10,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Palms Up Together",
      b: "1F932",
      k: [39, 5],
      o: 5
    },
    pig: {
      a: "Pig Face",
      b: "1F437",
      j: ["animal", "oink", "nature"],
      k: [12, 27],
      o: 2
    },
    hospital: {
      a: "Hospital",
      b: "1F3E5",
      j: ["building", "health", "surgery", "doctor"],
      k: [10, 56],
      o: 2
    },
    hiking_boot: { a: "Hiking Boot", b: "1F97E", k: [42, 16], o: 11 },
    "flag-be": { a: "Belgium Flag", b: "1F1E7-1F1EA", k: [0, 51], o: 2 },
    "flag-bf": { a: "Burkina Faso Flag", b: "1F1E7-1F1EB", k: [0, 52], o: 2 },
    mushroom: {
      a: "Mushroom",
      b: "1F344",
      j: ["plant", "vegetable"],
      k: [6, 28],
      o: 2
    },
    pig2: { a: "Pig", b: "1F416", j: ["animal", "nature"], k: [11, 51], o: 2 },
    baseball: {
      a: "Baseball",
      b: "26BE",
      j: ["sports", "balls"],
      k: [54, 0],
      o: 2
    },
    face_with_hand_over_mouth: {
      a: "Smiling Face with Smiling Eyes and Hand Covering Mouth",
      b: "1F92D",
      k: [38, 47],
      n: ["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],
      o: 5
    },
    handshake: {
      a: "Handshake",
      b: "1F91D",
      j: ["agreement", "shake"],
      k: [38, 4],
      o: 4
    },
    womans_flat_shoe: { a: "Flat Shoe", b: "1F97F", k: [42, 17], o: 11 },
    bank: {
      a: "Bank",
      b: "1F3E6",
      j: ["building", "money", "sales", "cash", "business", "enterprise"],
      k: [11, 0],
      o: 2
    },
    arrow_right: {
      a: "Black Rightwards Arrow",
      b: "27A1-FE0F",
      c: "27A1",
      j: ["blue-square", "next"],
      k: [55, 32],
      o: 2
    },
    peanuts: {
      a: "Peanuts",
      b: "1F95C",
      j: ["food", "nut"],
      k: [41, 43],
      o: 4
    },
    shushing_face: {
      a: "Face with Finger Covering Closed Lips",
      b: "1F92B",
      k: [38, 45],
      n: ["face_with_finger_covering_closed_lips"],
      o: 5
    },
    pray: {
      skin_variations: {
        "1F3FB": {
          unified: "1F64F-1F3FB",
          non_qualified: null,
          image: "1f64f-1f3fb.png",
          sheet_x: 33,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64F-1F3FC",
          non_qualified: null,
          image: "1f64f-1f3fc.png",
          sheet_x: 33,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64F-1F3FD",
          non_qualified: null,
          image: "1f64f-1f3fd.png",
          sheet_x: 33,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64F-1F3FE",
          non_qualified: null,
          image: "1f64f-1f3fe.png",
          sheet_x: 33,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64F-1F3FF",
          non_qualified: null,
          image: "1f64f-1f3ff.png",
          sheet_x: 33,
          sheet_y: 55,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Person with Folded Hands",
      b: "1F64F",
      j: ["please", "hope", "wish", "namaste", "highfive"],
      k: [33, 50],
      o: 2
    },
    softball: { a: "Softball", b: "1F94E", k: [41, 29], o: 11 },
    high_heel: {
      a: "High-Heeled Shoe",
      b: "1F460",
      j: ["fashion", "shoes", "female", "pumps", "stiletto"],
      k: [14, 20],
      o: 2
    },
    "flag-bg": { a: "Bulgaria Flag", b: "1F1E7-1F1EC", k: [0, 53], o: 2 },
    arrow_lower_right: {
      a: "South East Arrow",
      b: "2198-FE0F",
      c: "2198",
      j: ["blue-square", "direction", "diagonal", "southeast"],
      k: [52, 18],
      o: 2
    },
    hotel: {
      a: "Hotel",
      b: "1F3E8",
      j: ["building", "accomodation", "checkin"],
      k: [11, 2],
      o: 2
    },
    boar: { a: "Boar", b: "1F417", j: ["animal", "nature"], k: [11, 52], o: 2 },
    sandal: {
      a: "Womans Sandal",
      b: "1F461",
      j: ["shoes", "fashion", "flip flops"],
      k: [14, 21],
      o: 2
    },
    "flag-bh": { a: "Bahrain Flag", b: "1F1E7-1F1ED", k: [0, 54], o: 2 },
    arrow_down: {
      a: "Downwards Black Arrow",
      b: "2B07-FE0F",
      c: "2B07",
      j: ["blue-square", "direction", "bottom"],
      k: [55, 39],
      o: 2
    },
    thinking_face: { a: "Thinking Face", b: "1F914", k: [37, 27], o: 2 },
    writing_hand: {
      skin_variations: {
        "1F3FB": {
          unified: "270D-1F3FB",
          non_qualified: null,
          image: "270d-1f3fb.png",
          sheet_x: 55,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "270D-1F3FC",
          non_qualified: null,
          image: "270d-1f3fc.png",
          sheet_x: 55,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "270D-1F3FD",
          non_qualified: null,
          image: "270d-1f3fd.png",
          sheet_x: 55,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "270D-1F3FE",
          non_qualified: null,
          image: "270d-1f3fe.png",
          sheet_x: 55,
          sheet_y: 8,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "270D-1F3FF",
          non_qualified: null,
          image: "270d-1f3ff.png",
          sheet_x: 55,
          sheet_y: 9,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Writing Hand",
      b: "270D-FE0F",
      c: "270D",
      j: ["lower_left_ballpoint_pen", "stationery", "write", "compose"],
      k: [55, 4],
      o: 2
    },
    chestnut: {
      a: "Chestnut",
      b: "1F330",
      j: ["food", "squirrel"],
      k: [6, 8],
      o: 2
    },
    basketball: {
      a: "Basketball and Hoop",
      b: "1F3C0",
      j: ["sports", "balls", "NBA"],
      k: [8, 38],
      o: 2
    },
    pig_nose: {
      a: "Pig Nose",
      b: "1F43D",
      j: ["animal", "oink"],
      k: [12, 33],
      o: 2
    },
    love_hotel: {
      a: "Love Hotel",
      b: "1F3E9",
      j: ["like", "affection", "dating"],
      k: [11, 3],
      o: 2
    },
    nail_care: {
      skin_variations: {
        "1F3FB": {
          unified: "1F485-1F3FB",
          non_qualified: null,
          image: "1f485-1f3fb.png",
          sheet_x: 24,
          sheet_y: 34,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F485-1F3FC",
          non_qualified: null,
          image: "1f485-1f3fc.png",
          sheet_x: 24,
          sheet_y: 35,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F485-1F3FD",
          non_qualified: null,
          image: "1f485-1f3fd.png",
          sheet_x: 24,
          sheet_y: 36,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F485-1F3FE",
          non_qualified: null,
          image: "1f485-1f3fe.png",
          sheet_x: 24,
          sheet_y: 37,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F485-1F3FF",
          non_qualified: null,
          image: "1f485-1f3ff.png",
          sheet_x: 24,
          sheet_y: 38,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Nail Polish",
      b: "1F485",
      j: ["beauty", "manicure", "finger", "fashion", "nail"],
      k: [24, 33],
      o: 2
    },
    volleyball: {
      a: "Volleyball",
      b: "1F3D0",
      j: ["sports", "balls"],
      k: [10, 35],
      o: 2
    },
    "flag-bi": { a: "Burundi Flag", b: "1F1E7-1F1EE", k: [0, 55], o: 2 },
    arrow_lower_left: {
      a: "South West Arrow",
      b: "2199-FE0F",
      c: "2199",
      j: ["blue-square", "direction", "diagonal", "southwest"],
      k: [52, 19],
      o: 2
    },
    ram: {
      a: "Ram",
      b: "1F40F",
      j: ["animal", "sheep", "nature"],
      k: [11, 43],
      o: 2
    },
    ballet_shoes: { a: "Ballet Shoes", b: "1FA70", k: [51, 51], o: 12 },
    zipper_mouth_face: {
      a: "Zipper-Mouth Face",
      b: "1F910",
      j: ["face", "sealed", "zipper", "secret"],
      k: [37, 23],
      o: 2
    },
    bread: {
      a: "Bread",
      b: "1F35E",
      j: ["food", "wheat", "breakfast", "toast"],
      k: [6, 54],
      o: 2
    },
    convenience_store: {
      a: "Convenience Store",
      b: "1F3EA",
      j: ["building", "shopping", "groceries"],
      k: [11, 4],
      o: 2
    },
    boot: {
      a: "Womans Boots",
      b: "1F462",
      j: ["shoes", "fashion"],
      k: [14, 22],
      o: 2
    },
    sheep: {
      a: "Sheep",
      b: "1F411",
      j: ["animal", "nature", "wool", "shipit"],
      k: [11, 45],
      o: 2
    },
    face_with_raised_eyebrow: {
      a: "Face with One Eyebrow Raised",
      b: "1F928",
      k: [38, 42],
      n: ["face_with_one_eyebrow_raised"],
      o: 5
    },
    "flag-bj": { a: "Benin Flag", b: "1F1E7-1F1EF", k: [0, 56], o: 2 },
    arrow_left: {
      a: "Leftwards Black Arrow",
      b: "2B05-FE0F",
      c: "2B05",
      j: ["blue-square", "previous", "back"],
      k: [55, 37],
      o: 2
    },
    selfie: {
      skin_variations: {
        "1F3FB": {
          unified: "1F933-1F3FB",
          non_qualified: null,
          image: "1f933-1f3fb.png",
          sheet_x: 39,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F933-1F3FC",
          non_qualified: null,
          image: "1f933-1f3fc.png",
          sheet_x: 39,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F933-1F3FD",
          non_qualified: null,
          image: "1f933-1f3fd.png",
          sheet_x: 39,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F933-1F3FE",
          non_qualified: null,
          image: "1f933-1f3fe.png",
          sheet_x: 39,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F933-1F3FF",
          non_qualified: null,
          image: "1f933-1f3ff.png",
          sheet_x: 39,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Selfie",
      b: "1F933",
      j: ["camera", "phone"],
      k: [39, 11],
      o: 4
    },
    croissant: {
      a: "Croissant",
      b: "1F950",
      j: ["food", "bread", "french"],
      k: [41, 31],
      o: 4
    },
    school: {
      a: "School",
      b: "1F3EB",
      j: ["building", "student", "education", "learn", "teach"],
      k: [11, 5],
      o: 2
    },
    football: {
      a: "American Football",
      b: "1F3C8",
      j: ["sports", "balls", "NFL"],
      k: [9, 33],
      o: 2
    },
    goat: { a: "Goat", b: "1F410", j: ["animal", "nature"], k: [11, 44], o: 2 },
    department_store: {
      a: "Department Store",
      b: "1F3EC",
      j: ["building", "shopping", "mall"],
      k: [11, 6],
      o: 2
    },
    "flag-bl": { a: "St. Barth\xE9lemy Flag", b: "1F1E7-1F1F1", k: [1, 0], o: 2 },
    crown: {
      a: "Crown",
      b: "1F451",
      j: ["king", "kod", "leader", "royalty", "lord"],
      k: [14, 5],
      o: 2
    },
    arrow_upper_left: {
      a: "North West Arrow",
      b: "2196-FE0F",
      c: "2196",
      j: ["blue-square", "point", "direction", "diagonal", "northwest"],
      k: [52, 16],
      o: 2
    },
    neutral_face: {
      a: "Neutral Face",
      b: "1F610",
      j: ["indifference", "meh", ":|", "neutral"],
      k: [30, 51],
      l: [":|", ":-|"],
      o: 2
    },
    rugby_football: {
      a: "Rugby Football",
      b: "1F3C9",
      j: ["sports", "team"],
      k: [9, 34],
      o: 2
    },
    muscle: {
      skin_variations: {
        "1F3FB": {
          unified: "1F4AA-1F3FB",
          non_qualified: null,
          image: "1f4aa-1f3fb.png",
          sheet_x: 25,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F4AA-1F3FC",
          non_qualified: null,
          image: "1f4aa-1f3fc.png",
          sheet_x: 25,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F4AA-1F3FD",
          non_qualified: null,
          image: "1f4aa-1f3fd.png",
          sheet_x: 25,
          sheet_y: 55,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F4AA-1F3FE",
          non_qualified: null,
          image: "1f4aa-1f3fe.png",
          sheet_x: 25,
          sheet_y: 56,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F4AA-1F3FF",
          non_qualified: null,
          image: "1f4aa-1f3ff.png",
          sheet_x: 26,
          sheet_y: 0,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Flexed Biceps",
      b: "1F4AA",
      j: ["arm", "flex", "hand", "summer", "strong", "biceps"],
      k: [25, 52],
      o: 2
    },
    baguette_bread: {
      a: "Baguette Bread",
      b: "1F956",
      j: ["food", "bread", "french"],
      k: [41, 37],
      o: 4
    },
    expressionless: {
      a: "Expressionless Face",
      b: "1F611",
      j: ["face", "indifferent", "-_-", "meh", "deadpan"],
      k: [30, 52],
      o: 2
    },
    womans_hat: {
      a: "Womans Hat",
      b: "1F452",
      j: ["fashion", "accessories", "female", "lady", "spring"],
      k: [14, 6],
      o: 2
    },
    pretzel: { a: "Pretzel", b: "1F968", k: [41, 55], o: 5 },
    mechanical_arm: { a: "Mechanical Arm", b: "1F9BE", k: [44, 6], o: 12 },
    arrow_up_down: {
      a: "Up Down Arrow",
      b: "2195-FE0F",
      c: "2195",
      j: ["blue-square", "direction", "way", "vertical"],
      k: [52, 15],
      o: 2
    },
    dromedary_camel: {
      a: "Dromedary Camel",
      b: "1F42A",
      j: ["animal", "hot", "desert", "hump"],
      k: [12, 14],
      o: 2
    },
    tennis: {
      a: "Tennis Racquet and Ball",
      b: "1F3BE",
      j: ["sports", "balls", "green"],
      k: [8, 36],
      o: 2
    },
    "flag-bm": { a: "Bermuda Flag", b: "1F1E7-1F1F2", k: [1, 1], o: 2 },
    factory: {
      a: "Factory",
      b: "1F3ED",
      j: ["building", "industry", "pollution", "smoke"],
      k: [11, 7],
      o: 2
    },
    japanese_castle: {
      a: "Japanese Castle",
      b: "1F3EF",
      j: ["photo", "building"],
      k: [11, 9],
      o: 2
    },
    no_mouth: {
      a: "Face Without Mouth",
      b: "1F636",
      j: ["face", "hellokitty"],
      k: [31, 32],
      o: 2
    },
    mechanical_leg: { a: "Mechanical Leg", b: "1F9BF", k: [44, 7], o: 12 },
    bagel: { a: "Bagel", b: "1F96F", k: [42, 5], o: 11 },
    camel: {
      a: "Bactrian Camel",
      b: "1F42B",
      j: ["animal", "nature", "hot", "desert", "hump"],
      k: [12, 15],
      o: 2
    },
    tophat: {
      a: "Top Hat",
      b: "1F3A9",
      j: ["magic", "gentleman", "classy", "circus"],
      k: [8, 15],
      o: 2
    },
    left_right_arrow: {
      a: "Left Right Arrow",
      b: "2194-FE0F",
      c: "2194",
      j: ["shape", "direction", "horizontal", "sideways"],
      k: [52, 14],
      o: 2
    },
    "flag-bn": { a: "Brunei Flag", b: "1F1E7-1F1F3", k: [1, 2], o: 2 },
    flying_disc: { a: "Flying Disc", b: "1F94F", k: [41, 30], o: 11 },
    smirk: {
      a: "Smirking Face",
      b: "1F60F",
      j: ["face", "smile", "mean", "prank", "smug", "sarcasm"],
      k: [30, 50],
      o: 2
    },
    mortar_board: {
      a: "Graduation Cap",
      b: "1F393",
      j: [
        "school",
        "college",
        "degree",
        "university",
        "graduation",
        "cap",
        "hat",
        "legal",
        "learn",
        "education"
      ],
      k: [7, 55],
      o: 2
    },
    european_castle: {
      a: "European Castle",
      b: "1F3F0",
      j: ["building", "royalty", "history"],
      k: [11, 10],
      o: 2
    },
    leg: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B5-1F3FB",
          non_qualified: null,
          image: "1f9b5-1f3fb.png",
          sheet_x: 43,
          sheet_y: 6,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B5-1F3FC",
          non_qualified: null,
          image: "1f9b5-1f3fc.png",
          sheet_x: 43,
          sheet_y: 7,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B5-1F3FD",
          non_qualified: null,
          image: "1f9b5-1f3fd.png",
          sheet_x: 43,
          sheet_y: 8,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B5-1F3FE",
          non_qualified: null,
          image: "1f9b5-1f3fe.png",
          sheet_x: 43,
          sheet_y: 9,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B5-1F3FF",
          non_qualified: null,
          image: "1f9b5-1f3ff.png",
          sheet_x: 43,
          sheet_y: 10,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Leg",
      b: "1F9B5",
      k: [43, 5],
      o: 11
    },
    pancakes: {
      a: "Pancakes",
      b: "1F95E",
      j: ["food", "breakfast", "flapjacks", "hotcakes"],
      k: [41, 45],
      o: 4
    },
    leftwards_arrow_with_hook: {
      a: "Leftwards Arrow with Hook",
      b: "21A9-FE0F",
      c: "21A9",
      j: ["back", "return", "blue-square", "undo", "enter"],
      k: [52, 20],
      o: 2
    },
    "flag-bo": { a: "Bolivia Flag", b: "1F1E7-1F1F4", k: [1, 3], o: 2 },
    bowling: {
      a: "Bowling",
      b: "1F3B3",
      j: ["sports", "fun", "play"],
      k: [8, 25],
      o: 2
    },
    llama: { a: "Llama", b: "1F999", k: [42, 43], o: 11 },
    arrow_right_hook: {
      a: "Rightwards Arrow with Hook",
      b: "21AA-FE0F",
      c: "21AA",
      j: ["blue-square", "return", "rotate", "direction"],
      k: [52, 21],
      o: 2
    },
    wedding: {
      a: "Wedding",
      b: "1F492",
      j: ["love", "like", "affection", "couple", "marriage", "bride", "groom"],
      k: [25, 28],
      o: 2
    },
    "flag-bq": {
      a: "Caribbean Netherlands Flag",
      b: "1F1E7-1F1F6",
      k: [1, 4],
      o: 2
    },
    foot: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B6-1F3FB",
          non_qualified: null,
          image: "1f9b6-1f3fb.png",
          sheet_x: 43,
          sheet_y: 12,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B6-1F3FC",
          non_qualified: null,
          image: "1f9b6-1f3fc.png",
          sheet_x: 43,
          sheet_y: 13,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B6-1F3FD",
          non_qualified: null,
          image: "1f9b6-1f3fd.png",
          sheet_x: 43,
          sheet_y: 14,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B6-1F3FE",
          non_qualified: null,
          image: "1f9b6-1f3fe.png",
          sheet_x: 43,
          sheet_y: 15,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B6-1F3FF",
          non_qualified: null,
          image: "1f9b6-1f3ff.png",
          sheet_x: 43,
          sheet_y: 16,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Foot",
      b: "1F9B6",
      k: [43, 11],
      o: 11
    },
    giraffe_face: { a: "Giraffe Face", b: "1F992", k: [42, 36], o: 5 },
    unamused: {
      a: "Unamused Face",
      b: "1F612",
      j: ["indifference", "bored", "straight face", "serious", "sarcasm"],
      k: [30, 53],
      m: ":(",
      o: 2
    },
    billed_cap: { a: "Billed Cap", b: "1F9E2", k: [51, 21], o: 5 },
    waffle: { a: "Waffle", b: "1F9C7", k: [44, 15], o: 12 },
    cricket_bat_and_ball: {
      a: "Cricket Bat and Ball",
      b: "1F3CF",
      k: [10, 34],
      o: 2
    },
    helmet_with_white_cross: {
      a: "Helmet with White Cross",
      b: "26D1-FE0F",
      c: "26D1",
      k: [54, 6],
      o: 2
    },
    ear: {
      skin_variations: {
        "1F3FB": {
          unified: "1F442-1F3FB",
          non_qualified: null,
          image: "1f442-1f3fb.png",
          sheet_x: 12,
          sheet_y: 40,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F442-1F3FC",
          non_qualified: null,
          image: "1f442-1f3fc.png",
          sheet_x: 12,
          sheet_y: 41,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F442-1F3FD",
          non_qualified: null,
          image: "1f442-1f3fd.png",
          sheet_x: 12,
          sheet_y: 42,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F442-1F3FE",
          non_qualified: null,
          image: "1f442-1f3fe.png",
          sheet_x: 12,
          sheet_y: 43,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F442-1F3FF",
          non_qualified: null,
          image: "1f442-1f3ff.png",
          sheet_x: 12,
          sheet_y: 44,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Ear",
      b: "1F442",
      j: ["face", "hear", "sound", "listen"],
      k: [12, 39],
      o: 2
    },
    elephant: {
      a: "Elephant",
      b: "1F418",
      j: ["animal", "nature", "nose", "th", "circus"],
      k: [11, 53],
      o: 2
    },
    cheese_wedge: { a: "Cheese Wedge", b: "1F9C0", k: [44, 8], o: 2 },
    tokyo_tower: {
      a: "Tokyo Tower",
      b: "1F5FC",
      j: ["photo", "japanese"],
      k: [30, 31],
      o: 2
    },
    arrow_heading_up: {
      a: "Arrow Pointing Rightwards Then Curving Upwards",
      b: "2934-FE0F",
      c: "2934",
      j: ["blue-square", "direction", "top"],
      k: [55, 35],
      o: 2
    },
    field_hockey_stick_and_ball: {
      a: "Field Hockey Stick and Ball",
      b: "1F3D1",
      k: [10, 36],
      o: 2
    },
    "flag-br": { a: "Brazil Flag", b: "1F1E7-1F1F7", k: [1, 5], o: 2 },
    face_with_rolling_eyes: {
      a: "Face with Rolling Eyes",
      b: "1F644",
      k: [31, 46],
      o: 2
    },
    ear_with_hearing_aid: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9BB-1F3FB",
          non_qualified: null,
          image: "1f9bb-1f3fb.png",
          sheet_x: 43,
          sheet_y: 56,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9BB-1F3FC",
          non_qualified: null,
          image: "1f9bb-1f3fc.png",
          sheet_x: 44,
          sheet_y: 0,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9BB-1F3FD",
          non_qualified: null,
          image: "1f9bb-1f3fd.png",
          sheet_x: 44,
          sheet_y: 1,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9BB-1F3FE",
          non_qualified: null,
          image: "1f9bb-1f3fe.png",
          sheet_x: 44,
          sheet_y: 2,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9BB-1F3FF",
          non_qualified: null,
          image: "1f9bb-1f3ff.png",
          sheet_x: 44,
          sheet_y: 3,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Ear with Hearing Aid",
      b: "1F9BB",
      k: [43, 55],
      o: 12
    },
    arrow_heading_down: {
      a: "Arrow Pointing Rightwards Then Curving Downwards",
      b: "2935-FE0F",
      c: "2935",
      j: ["blue-square", "direction", "bottom"],
      k: [55, 36],
      o: 2
    },
    ice_hockey_stick_and_puck: {
      a: "Ice Hockey Stick and Puck",
      b: "1F3D2",
      k: [10, 37],
      o: 2
    },
    meat_on_bone: {
      a: "Meat on Bone",
      b: "1F356",
      j: ["good", "food", "drumstick"],
      k: [6, 46],
      o: 2
    },
    prayer_beads: {
      a: "Prayer Beads",
      b: "1F4FF",
      j: ["dhikr", "religious"],
      k: [27, 27],
      o: 2
    },
    statue_of_liberty: {
      a: "Statue of Liberty",
      b: "1F5FD",
      j: ["american", "newyork"],
      k: [30, 32],
      o: 2
    },
    grimacing: {
      a: "Grimacing Face",
      b: "1F62C",
      j: ["face", "grimace", "teeth"],
      k: [31, 22],
      o: 2
    },
    "flag-bs": { a: "Bahamas Flag", b: "1F1E7-1F1F8", k: [1, 6], o: 2 },
    rhinoceros: {
      a: "Rhinoceros",
      b: "1F98F",
      j: ["animal", "nature", "horn"],
      k: [42, 33],
      o: 4
    },
    lacrosse: { a: "Lacrosse Stick and Ball", b: "1F94D", k: [41, 28], o: 11 },
    poultry_leg: {
      a: "Poultry Leg",
      b: "1F357",
      j: ["food", "meat", "drumstick", "bird", "chicken", "turkey"],
      k: [6, 47],
      o: 2
    },
    hippopotamus: { a: "Hippopotamus", b: "1F99B", k: [42, 45], o: 11 },
    nose: {
      skin_variations: {
        "1F3FB": {
          unified: "1F443-1F3FB",
          non_qualified: null,
          image: "1f443-1f3fb.png",
          sheet_x: 12,
          sheet_y: 46,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F443-1F3FC",
          non_qualified: null,
          image: "1f443-1f3fc.png",
          sheet_x: 12,
          sheet_y: 47,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F443-1F3FD",
          non_qualified: null,
          image: "1f443-1f3fd.png",
          sheet_x: 12,
          sheet_y: 48,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F443-1F3FE",
          non_qualified: null,
          image: "1f443-1f3fe.png",
          sheet_x: 12,
          sheet_y: 49,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F443-1F3FF",
          non_qualified: null,
          image: "1f443-1f3ff.png",
          sheet_x: 12,
          sheet_y: 50,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Nose",
      b: "1F443",
      j: ["smell", "sniff"],
      k: [12, 45],
      o: 2
    },
    arrows_clockwise: {
      a: "Clockwise Downwards and Upwards Open Circle Arrows",
      b: "1F503",
      j: ["sync", "cycle", "round", "repeat"],
      k: [27, 31],
      o: 2
    },
    "flag-bt": { a: "Bhutan Flag", b: "1F1E7-1F1F9", k: [1, 7], o: 2 },
    church: {
      a: "Church",
      b: "26EA",
      j: ["building", "religion", "christ"],
      k: [54, 10],
      o: 2
    },
    lipstick: {
      a: "Lipstick",
      b: "1F484",
      j: ["female", "girl", "fashion", "woman"],
      k: [24, 32],
      o: 2
    },
    lying_face: {
      a: "Lying Face",
      b: "1F925",
      j: ["face", "lie", "pinocchio"],
      k: [38, 22],
      o: 4
    },
    arrows_counterclockwise: {
      a: "Anticlockwise Downwards and Upwards Open Circle Arrows",
      b: "1F504",
      j: ["blue-square", "sync", "cycle"],
      k: [27, 32],
      o: 2
    },
    "flag-bv": { a: "Bouvet Island Flag", b: "1F1E7-1F1FB", k: [1, 8], o: 2 },
    cut_of_meat: { a: "Cut of Meat", b: "1F969", k: [41, 56], o: 5 },
    mosque: {
      a: "Mosque",
      b: "1F54C",
      j: ["islam", "worship", "minaret"],
      k: [28, 36],
      o: 2
    },
    ring: {
      a: "Ring",
      b: "1F48D",
      j: [
        "wedding",
        "propose",
        "marriage",
        "valentines",
        "diamond",
        "fashion",
        "jewelry",
        "gem",
        "engagement"
      ],
      k: [25, 23],
      o: 2
    },
    brain: { a: "Brain", b: "1F9E0", k: [51, 19], o: 5 },
    table_tennis_paddle_and_ball: {
      a: "Table Tennis Paddle and Ball",
      b: "1F3D3",
      k: [10, 38],
      o: 2
    },
    relieved: {
      a: "Relieved Face",
      b: "1F60C",
      j: ["face", "relaxed", "phew", "massage", "happiness"],
      k: [30, 47],
      o: 2
    },
    mouse: {
      a: "Mouse Face",
      b: "1F42D",
      j: ["animal", "nature", "cheese_wedge", "rodent"],
      k: [12, 17],
      o: 2
    },
    hindu_temple: { a: "Hindu Temple", b: "1F6D5", k: [36, 41], o: 12 },
    back: {
      a: "Back with Leftwards Arrow Above",
      b: "1F519",
      j: ["arrow", "words", "return"],
      k: [27, 53],
      o: 2
    },
    gem: {
      a: "Gem Stone",
      b: "1F48E",
      j: ["blue", "ruby", "diamond", "jewelry"],
      k: [25, 24],
      o: 2
    },
    pensive: {
      a: "Pensive Face",
      b: "1F614",
      j: ["face", "sad", "depressed", "upset"],
      k: [30, 55],
      o: 2
    },
    "flag-bw": { a: "Botswana Flag", b: "1F1E7-1F1FC", k: [1, 9], o: 2 },
    mouse2: {
      a: "Mouse",
      b: "1F401",
      j: ["animal", "nature", "rodent"],
      k: [11, 29],
      o: 2
    },
    bacon: {
      a: "Bacon",
      b: "1F953",
      j: ["food", "breakfast", "pork", "pig", "meat"],
      k: [41, 34],
      o: 4
    },
    tooth: { a: "Tooth", b: "1F9B7", k: [43, 17], o: 11 },
    badminton_racquet_and_shuttlecock: {
      a: "Badminton Racquet and Shuttlecock",
      b: "1F3F8",
      k: [11, 20],
      o: 2
    },
    rat: {
      a: "Rat",
      b: "1F400",
      j: ["animal", "mouse", "rodent"],
      k: [11, 28],
      o: 2
    },
    synagogue: {
      a: "Synagogue",
      b: "1F54D",
      j: ["judaism", "worship", "temple", "jewish"],
      k: [28, 37],
      o: 2
    },
    end: {
      a: "End with Leftwards Arrow Above",
      b: "1F51A",
      j: ["words", "arrow"],
      k: [27, 54],
      o: 2
    },
    bone: { a: "Bone", b: "1F9B4", k: [43, 4], o: 11 },
    boxing_glove: {
      a: "Boxing Glove",
      b: "1F94A",
      j: ["sports", "fighting"],
      k: [41, 25],
      o: 4
    },
    mute: {
      a: "Speaker with Cancellation Stroke",
      b: "1F507",
      j: ["sound", "volume", "silence", "quiet"],
      k: [27, 35],
      o: 2
    },
    hamburger: {
      a: "Hamburger",
      b: "1F354",
      j: [
        "meat",
        "fast food",
        "beef",
        "cheeseburger",
        "mcdonalds",
        "burger king"
      ],
      k: [6, 44],
      o: 2
    },
    "flag-by": { a: "Belarus Flag", b: "1F1E7-1F1FE", k: [1, 10], o: 2 },
    sleepy: {
      a: "Sleepy Face",
      b: "1F62A",
      j: ["face", "tired", "rest", "nap"],
      k: [31, 20],
      o: 2
    },
    on: {
      a: "On with Exclamation Mark with Left Right Arrow Above",
      b: "1F51B",
      j: ["arrow", "words"],
      k: [27, 55],
      o: 2
    },
    martial_arts_uniform: {
      a: "Martial Arts Uniform",
      b: "1F94B",
      j: ["judo", "karate", "taekwondo"],
      k: [41, 26],
      o: 4
    },
    speaker: {
      a: "Speaker",
      b: "1F508",
      j: ["sound", "volume", "silence", "broadcast"],
      k: [27, 36],
      o: 2
    },
    drooling_face: {
      a: "Drooling Face",
      b: "1F924",
      j: ["face"],
      k: [38, 21],
      o: 4
    },
    eyes: {
      a: "Eyes",
      b: "1F440",
      j: ["look", "watch", "stalk", "peek", "see"],
      k: [12, 36],
      o: 2
    },
    "flag-bz": { a: "Belize Flag", b: "1F1E7-1F1FF", k: [1, 11], o: 2 },
    hamster: {
      a: "Hamster Face",
      b: "1F439",
      j: ["animal", "nature"],
      k: [12, 29],
      o: 2
    },
    shinto_shrine: {
      a: "Shinto Shrine",
      b: "26E9-FE0F",
      c: "26E9",
      j: ["temple", "japan", "kyoto"],
      k: [54, 9],
      o: 2
    },
    fries: {
      a: "French Fries",
      b: "1F35F",
      j: ["chips", "snack", "fast food"],
      k: [6, 55],
      o: 2
    },
    goal_net: { a: "Goal Net", b: "1F945", j: ["sports"], k: [41, 21], o: 4 },
    kaaba: {
      a: "Kaaba",
      b: "1F54B",
      j: ["mecca", "mosque", "islam"],
      k: [28, 35],
      o: 2
    },
    soon: {
      a: "Soon with Rightwards Arrow Above",
      b: "1F51C",
      j: ["arrow", "words"],
      k: [27, 56],
      o: 2
    },
    "flag-ca": { a: "Canada Flag", b: "1F1E8-1F1E6", k: [1, 12], o: 2 },
    rabbit: {
      a: "Rabbit Face",
      b: "1F430",
      j: ["animal", "nature", "pet", "spring", "magic", "bunny"],
      k: [12, 20],
      o: 2
    },
    eye: {
      a: "Eye",
      b: "1F441-FE0F",
      c: "1F441",
      j: ["face", "look", "see", "watch", "stare"],
      k: [12, 38],
      o: 2
    },
    sleeping: {
      a: "Sleeping Face",
      b: "1F634",
      j: ["face", "tired", "sleepy", "night", "zzz"],
      k: [31, 30],
      o: 2
    },
    pizza: {
      a: "Slice of Pizza",
      b: "1F355",
      j: ["food", "party"],
      k: [6, 45],
      o: 2
    },
    sound: {
      a: "Speaker with One Sound Wave",
      b: "1F509",
      j: ["volume", "speaker", "broadcast"],
      k: [27, 37],
      o: 2
    },
    rabbit2: {
      a: "Rabbit",
      b: "1F407",
      j: ["animal", "nature", "pet", "magic", "spring"],
      k: [11, 35],
      o: 2
    },
    fountain: {
      a: "Fountain",
      b: "26F2",
      j: ["photo", "summer", "water", "fresh"],
      k: [54, 13],
      o: 2
    },
    golf: {
      a: "Flag in Hole",
      b: "26F3",
      j: ["sports", "business", "flag", "hole", "summer"],
      k: [54, 14],
      o: 2
    },
    top: {
      a: "Top with Upwards Arrow Above",
      b: "1F51D",
      j: ["words", "blue-square"],
      k: [28, 0],
      o: 2
    },
    mask: {
      a: "Face with Medical Mask",
      b: "1F637",
      j: ["face", "sick", "ill", "disease"],
      k: [31, 33],
      o: 2
    },
    "flag-cc": {
      a: "Cocos (keeling) Islands Flag",
      b: "1F1E8-1F1E8",
      k: [1, 13],
      o: 2
    },
    hotdog: {
      a: "Hot Dog",
      b: "1F32D",
      j: ["food", "frankfurter"],
      k: [6, 5],
      o: 2
    },
    loud_sound: {
      a: "Speaker with Three Sound Waves",
      b: "1F50A",
      j: ["volume", "noise", "noisy", "speaker", "broadcast"],
      k: [27, 38],
      o: 2
    },
    tongue: {
      a: "Tongue",
      b: "1F445",
      j: ["mouth", "playful"],
      k: [12, 52],
      o: 2
    },
    place_of_worship: {
      a: "Place of Worship",
      b: "1F6D0",
      j: ["religion", "church", "temple", "prayer"],
      k: [36, 38],
      o: 2
    },
    ice_skate: {
      a: "Ice Skate",
      b: "26F8-FE0F",
      c: "26F8",
      j: ["sports"],
      k: [54, 18],
      o: 2
    },
    sandwich: { a: "Sandwich", b: "1F96A", k: [42, 0], o: 5 },
    chipmunk: {
      a: "Chipmunk",
      b: "1F43F-FE0F",
      c: "1F43F",
      j: ["animal", "nature", "rodent", "squirrel"],
      k: [12, 35],
      o: 2
    },
    loudspeaker: {
      a: "Public Address Loudspeaker",
      b: "1F4E2",
      j: ["volume", "sound"],
      k: [26, 56],
      o: 2
    },
    lips: { a: "Mouth", b: "1F444", j: ["mouth", "kiss"], k: [12, 51], o: 2 },
    "flag-cd": {
      a: "Congo - Kinshasa Flag",
      b: "1F1E8-1F1E9",
      k: [1, 14],
      o: 2
    },
    tent: {
      a: "Tent",
      b: "26FA",
      j: ["photo", "camping", "outdoors"],
      k: [54, 37],
      o: 2
    },
    face_with_thermometer: {
      a: "Face with Thermometer",
      b: "1F912",
      j: ["sick", "temperature", "thermometer", "cold", "fever"],
      k: [37, 25],
      o: 2
    },
    taco: { a: "Taco", b: "1F32E", j: ["food", "mexican"], k: [6, 6], o: 2 },
    foggy: {
      a: "Foggy",
      b: "1F301",
      j: ["photo", "mountain"],
      k: [5, 20],
      o: 2
    },
    "flag-cf": {
      a: "Central African Republic Flag",
      b: "1F1E8-1F1EB",
      k: [1, 15],
      o: 2
    },
    baby: {
      skin_variations: {
        "1F3FB": {
          unified: "1F476-1F3FB",
          non_qualified: null,
          image: "1f476-1f3fb.png",
          sheet_x: 23,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F476-1F3FC",
          non_qualified: null,
          image: "1f476-1f3fc.png",
          sheet_x: 23,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F476-1F3FD",
          non_qualified: null,
          image: "1f476-1f3fd.png",
          sheet_x: 23,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F476-1F3FE",
          non_qualified: null,
          image: "1f476-1f3fe.png",
          sheet_x: 23,
          sheet_y: 8,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F476-1F3FF",
          non_qualified: null,
          image: "1f476-1f3ff.png",
          sheet_x: 23,
          sheet_y: 9,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Baby",
      b: "1F476",
      j: ["child", "boy", "girl", "toddler"],
      k: [23, 4],
      o: 2
    },
    atom_symbol: {
      a: "Atom Symbol",
      b: "269B-FE0F",
      c: "269B",
      j: ["science", "physics", "chemistry"],
      k: [53, 48],
      o: 2
    },
    fishing_pole_and_fish: {
      a: "Fishing Pole and Fish",
      b: "1F3A3",
      j: ["food", "hobby", "summer"],
      k: [8, 9],
      o: 2
    },
    hedgehog: { a: "Hedgehog", b: "1F994", k: [42, 38], o: 5 },
    face_with_head_bandage: {
      a: "Face with Head-Bandage",
      b: "1F915",
      j: ["injured", "clumsy", "bandage", "hurt"],
      k: [37, 28],
      o: 2
    },
    mega: {
      a: "Cheering Megaphone",
      b: "1F4E3",
      j: ["sound", "speaker", "volume"],
      k: [27, 0],
      o: 2
    },
    nauseated_face: {
      a: "Nauseated Face",
      b: "1F922",
      j: ["face", "vomit", "gross", "green", "sick", "throw up", "ill"],
      k: [38, 19],
      o: 4
    },
    child: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D2-1F3FB",
          non_qualified: null,
          image: "1f9d2-1f3fb.png",
          sheet_x: 48,
          sheet_y: 17,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D2-1F3FC",
          non_qualified: null,
          image: "1f9d2-1f3fc.png",
          sheet_x: 48,
          sheet_y: 18,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D2-1F3FD",
          non_qualified: null,
          image: "1f9d2-1f3fd.png",
          sheet_x: 48,
          sheet_y: 19,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D2-1F3FE",
          non_qualified: null,
          image: "1f9d2-1f3fe.png",
          sheet_x: 48,
          sheet_y: 20,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D2-1F3FF",
          non_qualified: null,
          image: "1f9d2-1f3ff.png",
          sheet_x: 48,
          sheet_y: 21,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Child",
      b: "1F9D2",
      k: [48, 16],
      o: 5
    },
    "flag-cg": {
      a: "Congo - Brazzaville Flag",
      b: "1F1E8-1F1EC",
      k: [1, 16],
      o: 2
    },
    bat: {
      a: "Bat",
      b: "1F987",
      j: ["animal", "nature", "blind", "vampire"],
      k: [42, 25],
      o: 4
    },
    diving_mask: { a: "Diving Mask", b: "1F93F", k: [41, 15], o: 12 },
    burrito: {
      a: "Burrito",
      b: "1F32F",
      j: ["food", "mexican"],
      k: [6, 7],
      o: 2
    },
    postal_horn: {
      a: "Postal Horn",
      b: "1F4EF",
      j: ["instrument", "music"],
      k: [27, 12],
      o: 2
    },
    night_with_stars: {
      a: "Night with Stars",
      b: "1F303",
      j: ["evening", "city", "downtown"],
      k: [5, 22],
      o: 2
    },
    om_symbol: {
      a: "Om Symbol",
      b: "1F549-FE0F",
      c: "1F549",
      k: [28, 33],
      o: 2
    },
    star_of_david: {
      a: "Star of David",
      b: "2721-FE0F",
      c: "2721",
      j: ["judaism"],
      k: [55, 15],
      o: 2
    },
    boy: {
      skin_variations: {
        "1F3FB": {
          unified: "1F466-1F3FB",
          non_qualified: null,
          image: "1f466-1f3fb.png",
          sheet_x: 14,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F466-1F3FC",
          non_qualified: null,
          image: "1f466-1f3fc.png",
          sheet_x: 14,
          sheet_y: 28,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F466-1F3FD",
          non_qualified: null,
          image: "1f466-1f3fd.png",
          sheet_x: 14,
          sheet_y: 29,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F466-1F3FE",
          non_qualified: null,
          image: "1f466-1f3fe.png",
          sheet_x: 14,
          sheet_y: 30,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F466-1F3FF",
          non_qualified: null,
          image: "1f466-1f3ff.png",
          sheet_x: 14,
          sheet_y: 31,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Boy",
      b: "1F466",
      j: ["man", "male", "guy", "teenager"],
      k: [14, 26],
      o: 2
    },
    bell: {
      a: "Bell",
      b: "1F514",
      j: ["sound", "notification", "christmas", "xmas", "chime"],
      k: [27, 48],
      o: 2
    },
    "flag-ch": { a: "Switzerland Flag", b: "1F1E8-1F1ED", k: [1, 17], o: 2 },
    running_shirt_with_sash: {
      a: "Running Shirt with Sash",
      b: "1F3BD",
      j: ["play", "pageant"],
      k: [8, 35],
      o: 2
    },
    stuffed_flatbread: {
      a: "Stuffed Flatbread",
      b: "1F959",
      j: ["food", "flatbread", "stuffed", "gyro"],
      k: [41, 40],
      o: 4
    },
    bear: {
      a: "Bear Face",
      b: "1F43B",
      j: ["animal", "nature", "wild"],
      k: [12, 31],
      o: 2
    },
    cityscape: {
      a: "Cityscape",
      b: "1F3D9-FE0F",
      c: "1F3D9",
      j: ["photo", "night life", "urban"],
      k: [10, 44],
      o: 2
    },
    face_vomiting: {
      a: "Face with Open Mouth Vomiting",
      b: "1F92E",
      k: [38, 48],
      n: ["face_with_open_mouth_vomiting"],
      o: 5
    },
    wheel_of_dharma: {
      a: "Wheel of Dharma",
      b: "2638-FE0F",
      c: "2638",
      j: ["hinduism", "buddhism", "sikhism", "jainism"],
      k: [53, 15],
      o: 2
    },
    ski: {
      a: "Ski and Ski Boot",
      b: "1F3BF",
      j: ["sports", "winter", "cold", "snow"],
      k: [8, 37],
      o: 2
    },
    girl: {
      skin_variations: {
        "1F3FB": {
          unified: "1F467-1F3FB",
          non_qualified: null,
          image: "1f467-1f3fb.png",
          sheet_x: 14,
          sheet_y: 33,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F467-1F3FC",
          non_qualified: null,
          image: "1f467-1f3fc.png",
          sheet_x: 14,
          sheet_y: 34,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F467-1F3FD",
          non_qualified: null,
          image: "1f467-1f3fd.png",
          sheet_x: 14,
          sheet_y: 35,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F467-1F3FE",
          non_qualified: null,
          image: "1f467-1f3fe.png",
          sheet_x: 14,
          sheet_y: 36,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F467-1F3FF",
          non_qualified: null,
          image: "1f467-1f3ff.png",
          sheet_x: 14,
          sheet_y: 37,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Girl",
      b: "1F467",
      j: ["female", "woman", "teenager"],
      k: [14, 32],
      o: 2
    },
    falafel: { a: "Falafel", b: "1F9C6", k: [44, 14], o: 12 },
    sneezing_face: {
      a: "Sneezing Face",
      b: "1F927",
      j: ["face", "gesundheit", "sneeze", "sick", "allergy"],
      k: [38, 41],
      o: 4
    },
    no_bell: {
      a: "Bell with Cancellation Stroke",
      b: "1F515",
      j: ["sound", "volume", "mute", "quiet", "silent"],
      k: [27, 49],
      o: 2
    },
    koala: {
      a: "Koala",
      b: "1F428",
      j: ["animal", "nature"],
      k: [12, 12],
      o: 2
    },
    sunrise_over_mountains: {
      a: "Sunrise over Mountains",
      b: "1F304",
      j: ["view", "vacation", "photo"],
      k: [5, 23],
      o: 2
    },
    "flag-ci": { a: "C\xF4te D\u2019ivoire Flag", b: "1F1E8-1F1EE", k: [1, 18], o: 2 },
    sunrise: {
      a: "Sunrise",
      b: "1F305",
      j: ["morning", "view", "vacation", "photo"],
      k: [5, 24],
      o: 2
    },
    yin_yang: {
      a: "Yin Yang",
      b: "262F-FE0F",
      c: "262F",
      j: ["balance"],
      k: [53, 14],
      o: 2
    },
    adult: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB",
          non_qualified: null,
          image: "1f9d1-1f3fb.png",
          sheet_x: 48,
          sheet_y: 11,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC",
          non_qualified: null,
          image: "1f9d1-1f3fc.png",
          sheet_x: 48,
          sheet_y: 12,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD",
          non_qualified: null,
          image: "1f9d1-1f3fd.png",
          sheet_x: 48,
          sheet_y: 13,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE",
          non_qualified: null,
          image: "1f9d1-1f3fe.png",
          sheet_x: 48,
          sheet_y: 14,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF",
          non_qualified: null,
          image: "1f9d1-1f3ff.png",
          sheet_x: 48,
          sheet_y: 15,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Adult",
      b: "1F9D1",
      k: [48, 10],
      o: 5
    },
    hot_face: { a: "Overheated Face", b: "1F975", k: [42, 10], o: 11 },
    musical_score: {
      a: "Musical Score",
      b: "1F3BC",
      j: ["treble", "clef", "compose"],
      k: [8, 34],
      o: 2
    },
    sled: { a: "Sled", b: "1F6F7", k: [36, 56], o: 5 },
    egg: {
      a: "Egg",
      b: "1F95A",
      j: ["food", "chicken", "breakfast"],
      k: [41, 41],
      o: 4
    },
    panda_face: {
      a: "Panda Face",
      b: "1F43C",
      j: ["animal", "nature", "panda"],
      k: [12, 32],
      o: 2
    },
    "flag-ck": { a: "Cook Islands Flag", b: "1F1E8-1F1F0", k: [1, 19], o: 2 },
    "flag-cl": { a: "Chile Flag", b: "1F1E8-1F1F1", k: [1, 20], o: 2 },
    person_with_blond_hair: {
      skin_variations: {
        "1F3FB": {
          unified: "1F471-1F3FB",
          non_qualified: null,
          image: "1f471-1f3fb.png",
          sheet_x: 22,
          sheet_y: 20,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F471-1F3FC",
          non_qualified: null,
          image: "1f471-1f3fc.png",
          sheet_x: 22,
          sheet_y: 21,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F471-1F3FD",
          non_qualified: null,
          image: "1f471-1f3fd.png",
          sheet_x: 22,
          sheet_y: 22,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F471-1F3FE",
          non_qualified: null,
          image: "1f471-1f3fe.png",
          sheet_x: 22,
          sheet_y: 23,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F471-1F3FF",
          non_qualified: null,
          image: "1f471-1f3ff.png",
          sheet_x: 22,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F471-200D-2642-FE0F",
      a: "Person with Blond Hair",
      b: "1F471",
      k: [22, 19],
      o: 2
    },
    sloth: { a: "Sloth", b: "1F9A5", k: [42, 53], o: 12 },
    latin_cross: {
      a: "Latin Cross",
      b: "271D-FE0F",
      c: "271D",
      j: ["christianity"],
      k: [55, 14],
      o: 2
    },
    curling_stone: { a: "Curling Stone", b: "1F94C", k: [41, 27], o: 5 },
    cold_face: { a: "Freezing Face", b: "1F976", k: [42, 11], o: 11 },
    fried_egg: {
      a: "Cooking",
      b: "1F373",
      j: ["food", "breakfast", "kitchen", "egg"],
      k: [7, 18],
      n: ["cooking"],
      o: 2
    },
    city_sunset: {
      a: "Cityscape at Dusk",
      b: "1F306",
      j: ["photo", "evening", "sky", "buildings"],
      k: [5, 25],
      o: 2
    },
    musical_note: {
      a: "Musical Note",
      b: "1F3B5",
      j: ["score", "tone", "sound"],
      k: [8, 27],
      o: 2
    },
    "flag-cm": { a: "Cameroon Flag", b: "1F1E8-1F1F2", k: [1, 21], o: 2 },
    notes: {
      a: "Multiple Musical Notes",
      b: "1F3B6",
      j: ["music", "score"],
      k: [8, 28],
      o: 2
    },
    woozy_face: {
      a: "Face with Uneven Eyes and Wavy Mouth",
      b: "1F974",
      k: [42, 9],
      o: 11
    },
    dart: {
      a: "Direct Hit",
      b: "1F3AF",
      j: ["game", "play", "bar"],
      k: [8, 21],
      o: 2
    },
    orthodox_cross: {
      a: "Orthodox Cross",
      b: "2626-FE0F",
      c: "2626",
      j: ["suppedaneum", "religion"],
      k: [53, 11],
      o: 2
    },
    shallow_pan_of_food: {
      a: "Shallow Pan of Food",
      b: "1F958",
      j: ["food", "cooking", "casserole", "paella"],
      k: [41, 39],
      o: 4
    },
    otter: { a: "Otter", b: "1F9A6", k: [42, 54], o: 12 },
    man: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB",
          non_qualified: null,
          image: "1f468-1f3fb.png",
          sheet_x: 17,
          sheet_y: 23,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC",
          non_qualified: null,
          image: "1f468-1f3fc.png",
          sheet_x: 17,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD",
          non_qualified: null,
          image: "1f468-1f3fd.png",
          sheet_x: 17,
          sheet_y: 25,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE",
          non_qualified: null,
          image: "1f468-1f3fe.png",
          sheet_x: 17,
          sheet_y: 26,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF",
          non_qualified: null,
          image: "1f468-1f3ff.png",
          sheet_x: 17,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man",
      b: "1F468",
      j: ["mustache", "father", "dad", "guy", "classy", "sir", "moustache"],
      k: [17, 22],
      o: 2
    },
    city_sunrise: {
      a: "Sunset over Buildings",
      b: "1F307",
      j: ["photo", "good morning", "dawn"],
      k: [5, 26],
      o: 2
    },
    bearded_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D4-1F3FB",
          non_qualified: null,
          image: "1f9d4-1f3fb.png",
          sheet_x: 48,
          sheet_y: 29,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D4-1F3FC",
          non_qualified: null,
          image: "1f9d4-1f3fc.png",
          sheet_x: 48,
          sheet_y: 30,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D4-1F3FD",
          non_qualified: null,
          image: "1f9d4-1f3fd.png",
          sheet_x: 48,
          sheet_y: 31,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D4-1F3FE",
          non_qualified: null,
          image: "1f9d4-1f3fe.png",
          sheet_x: 48,
          sheet_y: 32,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D4-1F3FF",
          non_qualified: null,
          image: "1f9d4-1f3ff.png",
          sheet_x: 48,
          sheet_y: 33,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Bearded Person",
      b: "1F9D4",
      k: [48, 28],
      o: 5
    },
    skunk: { a: "Skunk", b: "1F9A8", k: [42, 56], o: 12 },
    stew: {
      a: "Pot of Food",
      b: "1F372",
      j: ["food", "meat", "soup"],
      k: [7, 17],
      o: 2
    },
    cn: {
      a: "China Flag",
      b: "1F1E8-1F1F3",
      j: ["china", "chinese", "prc", "flag", "country", "nation", "banner"],
      k: [1, 22],
      n: ["flag-cn"],
      o: 2
    },
    studio_microphone: {
      a: "Studio Microphone",
      b: "1F399-FE0F",
      c: "1F399",
      j: ["sing", "recording", "artist", "talkshow"],
      k: [8, 1],
      o: 2
    },
    star_and_crescent: {
      a: "Star and Crescent",
      b: "262A-FE0F",
      c: "262A",
      j: ["islam"],
      k: [53, 12],
      o: 2
    },
    "yo-yo": { a: "Yo-Yo", b: "1FA80", k: [52, 1], o: 12 },
    bridge_at_night: {
      a: "Bridge at Night",
      b: "1F309",
      j: ["photo", "sanfrancisco"],
      k: [5, 28],
      o: 2
    },
    dizzy_face: {
      a: "Dizzy Face",
      b: "1F635",
      j: ["spent", "unconscious", "xox", "dizzy"],
      k: [31, 31],
      o: 2
    },
    red_haired_man: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F9B0",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f9b0.png",
          sheet_x: 16,
          sheet_y: 24,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F9B0",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f9b0.png",
          sheet_x: 16,
          sheet_y: 25,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F9B0",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f9b0.png",
          sheet_x: 16,
          sheet_y: 26,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F9B0",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f9b0.png",
          sheet_x: 16,
          sheet_y: 27,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F9B0",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f9b0.png",
          sheet_x: 16,
          sheet_y: 28,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Red Haired Man",
      b: "1F468-200D-1F9B0",
      k: [16, 23],
      o: 11
    },
    kite: { a: "Kite", b: "1FA81", k: [52, 2], o: 12 },
    bowl_with_spoon: { a: "Bowl with Spoon", b: "1F963", k: [41, 50], o: 5 },
    "flag-co": { a: "Colombia Flag", b: "1F1E8-1F1F4", k: [1, 23], o: 2 },
    peace_symbol: {
      a: "Peace Symbol",
      b: "262E-FE0F",
      c: "262E",
      j: ["hippie"],
      k: [53, 13],
      o: 2
    },
    kangaroo: { a: "Kangaroo", b: "1F998", k: [42, 42], o: 11 },
    hotsprings: {
      a: "Hot Springs",
      b: "2668-FE0F",
      c: "2668",
      j: ["bath", "warm", "relax"],
      k: [53, 37],
      o: 2
    },
    exploding_head: {
      a: "Shocked Face with Exploding Head",
      b: "1F92F",
      k: [38, 49],
      n: ["shocked_face_with_exploding_head"],
      o: 5
    },
    level_slider: {
      a: "Level Slider",
      b: "1F39A-FE0F",
      c: "1F39A",
      j: ["scale"],
      k: [8, 2],
      o: 2
    },
    badger: { a: "Badger", b: "1F9A1", k: [42, 51], o: 11 },
    "8ball": {
      a: "Billiards",
      b: "1F3B1",
      j: ["pool", "hobby", "game", "luck", "magic"],
      k: [8, 23],
      o: 2
    },
    curly_haired_man: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F9B1",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f9b1.png",
          sheet_x: 16,
          sheet_y: 30,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F9B1",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f9b1.png",
          sheet_x: 16,
          sheet_y: 31,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F9B1",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f9b1.png",
          sheet_x: 16,
          sheet_y: 32,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F9B1",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f9b1.png",
          sheet_x: 16,
          sheet_y: 33,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F9B1",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f9b1.png",
          sheet_x: 16,
          sheet_y: 34,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Curly Haired Man",
      b: "1F468-200D-1F9B1",
      k: [16, 29],
      o: 11
    },
    "flag-cp": {
      a: "Clipperton Island Flag",
      b: "1F1E8-1F1F5",
      k: [1, 24],
      o: 2
    },
    carousel_horse: {
      a: "Carousel Horse",
      b: "1F3A0",
      j: ["photo", "carnival"],
      k: [8, 6],
      o: 2
    },
    face_with_cowboy_hat: {
      a: "Face with Cowboy Hat",
      b: "1F920",
      k: [38, 17],
      o: 4
    },
    menorah_with_nine_branches: {
      a: "Menorah with Nine Branches",
      b: "1F54E",
      k: [28, 38],
      o: 2
    },
    green_salad: {
      a: "Green Salad",
      b: "1F957",
      j: ["food", "healthy", "lettuce"],
      k: [41, 38],
      o: 4
    },
    control_knobs: {
      a: "Control Knobs",
      b: "1F39B-FE0F",
      c: "1F39B",
      j: ["dial"],
      k: [8, 3],
      o: 2
    },
    popcorn: {
      a: "Popcorn",
      b: "1F37F",
      j: ["food", "movie theater", "films", "snack"],
      k: [7, 30],
      o: 2
    },
    six_pointed_star: {
      a: "Six Pointed Star with Middle Dot",
      b: "1F52F",
      j: ["purple-square", "religion", "jewish", "hexagram"],
      k: [28, 18],
      o: 2
    },
    feet: { a: "Paw Prints", b: "1F43E", k: [12, 34], n: ["paw_prints"], o: 2 },
    ferris_wheel: {
      a: "Ferris Wheel",
      b: "1F3A1",
      j: ["photo", "carnival", "londoneye"],
      k: [8, 7],
      o: 2
    },
    microphone: {
      a: "Microphone",
      b: "1F3A4",
      j: ["sound", "music", "PA", "sing", "talkshow"],
      k: [8, 10],
      o: 2
    },
    crystal_ball: {
      a: "Crystal Ball",
      b: "1F52E",
      j: ["disco", "party", "magic", "circus", "fortune_teller"],
      k: [28, 17],
      o: 2
    },
    partying_face: {
      a: "Face with Party Horn and Party Hat",
      b: "1F973",
      k: [42, 8],
      o: 11
    },
    "flag-cr": { a: "Costa Rica Flag", b: "1F1E8-1F1F7", k: [1, 25], o: 2 },
    white_haired_man: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F9B3",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f9b3.png",
          sheet_x: 16,
          sheet_y: 42,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F9B3",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f9b3.png",
          sheet_x: 16,
          sheet_y: 43,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F9B3",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f9b3.png",
          sheet_x: 16,
          sheet_y: 44,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F9B3",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f9b3.png",
          sheet_x: 16,
          sheet_y: 45,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F9B3",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f9b3.png",
          sheet_x: 16,
          sheet_y: 46,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "White Haired Man",
      b: "1F468-200D-1F9B3",
      k: [16, 41],
      o: 11
    },
    headphones: {
      a: "Headphone",
      b: "1F3A7",
      j: ["music", "score", "gadgets"],
      k: [8, 13],
      o: 2
    },
    bald_man: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F9B2",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f9b2.png",
          sheet_x: 16,
          sheet_y: 36,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F9B2",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f9b2.png",
          sheet_x: 16,
          sheet_y: 37,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F9B2",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f9b2.png",
          sheet_x: 16,
          sheet_y: 38,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F9B2",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f9b2.png",
          sheet_x: 16,
          sheet_y: 39,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F9B2",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f9b2.png",
          sheet_x: 16,
          sheet_y: 40,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Bald Man",
      b: "1F468-200D-1F9B2",
      k: [16, 35],
      o: 11
    },
    sunglasses: {
      a: "Smiling Face with Sunglasses",
      b: "1F60E",
      j: ["face", "cool", "smile", "summer", "beach", "sunglass"],
      k: [30, 49],
      l: ["8)"],
      o: 2
    },
    butter: { a: "Butter", b: "1F9C8", k: [44, 16], o: 12 },
    roller_coaster: {
      a: "Roller Coaster",
      b: "1F3A2",
      j: ["carnival", "playground", "photo", "fun"],
      k: [8, 8],
      o: 2
    },
    turkey: {
      a: "Turkey",
      b: "1F983",
      j: ["animal", "bird"],
      k: [42, 21],
      o: 2
    },
    nazar_amulet: { a: "Nazar Amulet", b: "1F9FF", k: [51, 50], o: 11 },
    "flag-cu": { a: "Cuba Flag", b: "1F1E8-1F1FA", k: [1, 26], o: 2 },
    aries: {
      a: "Aries",
      b: "2648",
      j: ["sign", "purple-square", "zodiac", "astrology"],
      k: [53, 20],
      o: 2
    },
    "flag-cv": { a: "Cape Verde Flag", b: "1F1E8-1F1FB", k: [1, 27], o: 2 },
    barber: {
      a: "Barber Pole",
      b: "1F488",
      j: ["hair", "salon", "style"],
      k: [25, 18],
      o: 2
    },
    taurus: {
      a: "Taurus",
      b: "2649",
      j: ["purple-square", "sign", "zodiac", "astrology"],
      k: [53, 21],
      o: 2
    },
    salt: { a: "Salt Shaker", b: "1F9C2", k: [44, 10], o: 11 },
    woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB",
          non_qualified: null,
          image: "1f469-1f3fb.png",
          sheet_x: 20,
          sheet_y: 10,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC",
          non_qualified: null,
          image: "1f469-1f3fc.png",
          sheet_x: 20,
          sheet_y: 11,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD",
          non_qualified: null,
          image: "1f469-1f3fd.png",
          sheet_x: 20,
          sheet_y: 12,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE",
          non_qualified: null,
          image: "1f469-1f3fe.png",
          sheet_x: 20,
          sheet_y: 13,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF",
          non_qualified: null,
          image: "1f469-1f3ff.png",
          sheet_x: 20,
          sheet_y: 14,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman",
      b: "1F469",
      j: ["female", "girls", "lady"],
      k: [20, 9],
      o: 2
    },
    video_game: {
      a: "Video Game",
      b: "1F3AE",
      j: ["play", "console", "PS4", "controller"],
      k: [8, 20],
      o: 2
    },
    chicken: {
      a: "Chicken",
      b: "1F414",
      j: ["animal", "cluck", "nature", "bird"],
      k: [11, 48],
      o: 2
    },
    radio: {
      a: "Radio",
      b: "1F4FB",
      j: ["communication", "music", "podcast", "program"],
      k: [27, 24],
      o: 2
    },
    nerd_face: {
      a: "Nerd Face",
      b: "1F913",
      j: ["face", "nerdy", "geek", "dork"],
      k: [37, 26],
      o: 2
    },
    red_haired_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F9B0",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f9b0.png",
          sheet_x: 19,
          sheet_y: 9,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F9B0",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f9b0.png",
          sheet_x: 19,
          sheet_y: 10,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F9B0",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f9b0.png",
          sheet_x: 19,
          sheet_y: 11,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F9B0",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f9b0.png",
          sheet_x: 19,
          sheet_y: 12,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F9B0",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f9b0.png",
          sheet_x: 19,
          sheet_y: 13,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Red Haired Woman",
      b: "1F469-200D-1F9B0",
      k: [19, 8],
      o: 11
    },
    circus_tent: {
      a: "Circus Tent",
      b: "1F3AA",
      j: ["festival", "carnival", "party"],
      k: [8, 16],
      o: 2
    },
    face_with_monocle: {
      a: "Face with Monocle",
      b: "1F9D0",
      k: [45, 16],
      o: 5
    },
    canned_food: { a: "Canned Food", b: "1F96B", k: [42, 1], o: 5 },
    "flag-cw": { a: "Cura\xE7ao Flag", b: "1F1E8-1F1FC", k: [1, 28], o: 2 },
    gemini: {
      a: "Gemini",
      b: "264A",
      j: ["sign", "zodiac", "purple-square", "astrology"],
      k: [53, 22],
      o: 2
    },
    saxophone: {
      a: "Saxophone",
      b: "1F3B7",
      j: ["music", "instrument", "jazz", "blues"],
      k: [8, 29],
      o: 2
    },
    rooster: {
      a: "Rooster",
      b: "1F413",
      j: ["animal", "nature", "chicken"],
      k: [11, 47],
      o: 2
    },
    joystick: {
      a: "Joystick",
      b: "1F579-FE0F",
      c: "1F579",
      j: ["game", "play"],
      k: [29, 36],
      o: 2
    },
    guitar: {
      a: "Guitar",
      b: "1F3B8",
      j: ["music", "instrument"],
      k: [8, 30],
      o: 2
    },
    slot_machine: {
      a: "Slot Machine",
      b: "1F3B0",
      j: ["bet", "gamble", "vegas", "fruit machine", "luck", "casino"],
      k: [8, 22],
      o: 2
    },
    bento: {
      a: "Bento Box",
      b: "1F371",
      j: ["food", "japanese", "box"],
      k: [7, 16],
      o: 2
    },
    steam_locomotive: {
      a: "Steam Locomotive",
      b: "1F682",
      j: ["transportation", "vehicle", "train"],
      k: [34, 1],
      o: 2
    },
    confused: {
      a: "Confused Face",
      b: "1F615",
      j: ["face", "indifference", "huh", "weird", "hmmm", ":/"],
      k: [30, 56],
      l: [":\\", ":-\\", ":/", ":-/"],
      o: 2
    },
    "flag-cx": {
      a: "Christmas Island Flag",
      b: "1F1E8-1F1FD",
      k: [1, 29],
      o: 2
    },
    hatching_chick: {
      a: "Hatching Chick",
      b: "1F423",
      j: ["animal", "chicken", "egg", "born", "baby", "bird"],
      k: [12, 7],
      o: 2
    },
    cancer: {
      a: "Cancer",
      b: "264B",
      j: ["sign", "zodiac", "purple-square", "astrology"],
      k: [53, 23],
      o: 2
    },
    red_haired_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F9B0",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f9b0.png",
          sheet_x: 47,
          sheet_y: 14,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F9B0",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f9b0.png",
          sheet_x: 47,
          sheet_y: 15,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F9B0",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f9b0.png",
          sheet_x: 47,
          sheet_y: 16,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F9B0",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f9b0.png",
          sheet_x: 47,
          sheet_y: 17,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F9B0",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f9b0.png",
          sheet_x: 47,
          sheet_y: 18,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Red Haired Person",
      b: "1F9D1-200D-1F9B0",
      k: [47, 13],
      o: 12
    },
    "flag-cy": { a: "Cyprus Flag", b: "1F1E8-1F1FE", k: [1, 30], o: 2 },
    worried: {
      a: "Worried Face",
      b: "1F61F",
      j: ["face", "concern", "nervous", ":("],
      k: [31, 9],
      o: 2
    },
    railway_car: {
      a: "Railway Car",
      b: "1F683",
      j: ["transportation", "vehicle"],
      k: [34, 2],
      o: 2
    },
    leo: {
      a: "Leo",
      b: "264C",
      j: ["sign", "purple-square", "zodiac", "astrology"],
      k: [53, 24],
      o: 2
    },
    curly_haired_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F9B1",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f9b1.png",
          sheet_x: 19,
          sheet_y: 15,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F9B1",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f9b1.png",
          sheet_x: 19,
          sheet_y: 16,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F9B1",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f9b1.png",
          sheet_x: 19,
          sheet_y: 17,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F9B1",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f9b1.png",
          sheet_x: 19,
          sheet_y: 18,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F9B1",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f9b1.png",
          sheet_x: 19,
          sheet_y: 19,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Curly Haired Woman",
      b: "1F469-200D-1F9B1",
      k: [19, 14],
      o: 11
    },
    baby_chick: {
      a: "Baby Chick",
      b: "1F424",
      j: ["animal", "chicken", "bird"],
      k: [12, 8],
      o: 2
    },
    musical_keyboard: {
      a: "Musical Keyboard",
      b: "1F3B9",
      j: ["piano", "instrument", "compose"],
      k: [8, 31],
      o: 2
    },
    game_die: {
      a: "Game Die",
      b: "1F3B2",
      j: ["dice", "random", "tabletop", "play", "luck"],
      k: [8, 24],
      o: 2
    },
    rice_cracker: {
      a: "Rice Cracker",
      b: "1F358",
      j: ["food", "japanese"],
      k: [6, 48],
      o: 2
    },
    virgo: {
      a: "Virgo",
      b: "264D",
      j: ["sign", "zodiac", "purple-square", "astrology"],
      k: [53, 25],
      o: 2
    },
    "flag-cz": { a: "Czechia Flag", b: "1F1E8-1F1FF", k: [1, 31], o: 2 },
    curly_haired_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F9B1",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f9b1.png",
          sheet_x: 47,
          sheet_y: 20,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F9B1",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f9b1.png",
          sheet_x: 47,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F9B1",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f9b1.png",
          sheet_x: 47,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F9B1",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f9b1.png",
          sheet_x: 47,
          sheet_y: 23,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F9B1",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f9b1.png",
          sheet_x: 47,
          sheet_y: 24,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Curly Haired Person",
      b: "1F9D1-200D-1F9B1",
      k: [47, 19],
      o: 12
    },
    rice_ball: {
      a: "Rice Ball",
      b: "1F359",
      j: ["food", "japanese"],
      k: [6, 49],
      o: 2
    },
    hatched_chick: {
      a: "Front-Facing Baby Chick",
      b: "1F425",
      j: ["animal", "chicken", "baby", "bird"],
      k: [12, 9],
      o: 2
    },
    jigsaw: { a: "Jigsaw Puzzle Piece", b: "1F9E9", k: [51, 28], o: 11 },
    trumpet: {
      a: "Trumpet",
      b: "1F3BA",
      j: ["music", "brass"],
      k: [8, 32],
      o: 2
    },
    slightly_frowning_face: {
      a: "Slightly Frowning Face",
      b: "1F641",
      j: ["face", "frowning", "disappointed", "sad", "upset"],
      k: [31, 43],
      o: 2
    },
    bullettrain_side: {
      a: "High-Speed Train",
      b: "1F684",
      j: ["transportation", "vehicle"],
      k: [34, 3],
      o: 2
    },
    libra: {
      a: "Libra",
      b: "264E",
      j: ["sign", "purple-square", "zodiac", "astrology"],
      k: [53, 26],
      o: 2
    },
    de: {
      a: "Germany Flag",
      b: "1F1E9-1F1EA",
      j: ["german", "nation", "flag", "country", "banner"],
      k: [1, 32],
      n: ["flag-de"],
      o: 2
    },
    rice: {
      a: "Cooked Rice",
      b: "1F35A",
      j: ["food", "china", "asian"],
      k: [6, 50],
      o: 2
    },
    violin: {
      a: "Violin",
      b: "1F3BB",
      j: ["music", "instrument", "orchestra", "symphony"],
      k: [8, 33],
      o: 2
    },
    white_haired_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F9B3",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f9b3.png",
          sheet_x: 19,
          sheet_y: 27,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F9B3",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f9b3.png",
          sheet_x: 19,
          sheet_y: 28,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F9B3",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f9b3.png",
          sheet_x: 19,
          sheet_y: 29,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F9B3",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f9b3.png",
          sheet_x: 19,
          sheet_y: 30,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F9B3",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f9b3.png",
          sheet_x: 19,
          sheet_y: 31,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "White Haired Woman",
      b: "1F469-200D-1F9B3",
      k: [19, 26],
      o: 11
    },
    bird: {
      a: "Bird",
      b: "1F426",
      j: ["animal", "nature", "fly", "tweet", "spring"],
      k: [12, 10],
      o: 2
    },
    white_frowning_face: {
      a: "White Frowning Face",
      b: "2639-FE0F",
      c: "2639",
      k: [53, 16],
      o: 2
    },
    bullettrain_front: {
      a: "High-Speed Train with Bullet Nose",
      b: "1F685",
      j: ["transportation", "vehicle", "speed", "fast", "public", "travel"],
      k: [34, 4],
      o: 2
    },
    teddy_bear: { a: "Teddy Bear", b: "1F9F8", k: [51, 43], o: 11 },
    white_haired_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F9B3",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f9b3.png",
          sheet_x: 47,
          sheet_y: 32,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F9B3",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f9b3.png",
          sheet_x: 47,
          sheet_y: 33,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F9B3",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f9b3.png",
          sheet_x: 47,
          sheet_y: 34,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F9B3",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f9b3.png",
          sheet_x: 47,
          sheet_y: 35,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F9B3",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f9b3.png",
          sheet_x: 47,
          sheet_y: 36,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "White Haired Person",
      b: "1F9D1-200D-1F9B3",
      k: [47, 31],
      o: 12
    },
    spades: {
      a: "Black Spade Suit",
      b: "2660-FE0F",
      c: "2660",
      j: ["poker", "cards", "suits", "magic"],
      k: [53, 33],
      o: 2
    },
    banjo: { a: "Banjo", b: "1FA95", k: [52, 9], o: 12 },
    train2: {
      a: "Train",
      b: "1F686",
      j: ["transportation", "vehicle"],
      k: [34, 5],
      o: 2
    },
    scorpius: {
      a: "Scorpius",
      b: "264F",
      j: ["sign", "zodiac", "purple-square", "astrology", "scorpio"],
      k: [53, 27],
      o: 2
    },
    curry: {
      a: "Curry and Rice",
      b: "1F35B",
      j: ["food", "spicy", "hot", "indian"],
      k: [6, 51],
      o: 2
    },
    open_mouth: {
      a: "Face with Open Mouth",
      b: "1F62E",
      j: ["face", "surprise", "impressed", "wow", "whoa", ":O"],
      k: [31, 24],
      l: [":o", ":-o", ":O", ":-O"],
      o: 2
    },
    "flag-dg": { a: "Diego Garcia Flag", b: "1F1E9-1F1EC", k: [1, 33], o: 2 },
    penguin: {
      a: "Penguin",
      b: "1F427",
      j: ["animal", "nature"],
      k: [12, 11],
      o: 2
    },
    hearts: {
      a: "Black Heart Suit",
      b: "2665-FE0F",
      c: "2665",
      j: ["poker", "cards", "magic", "suits"],
      k: [53, 35],
      o: 2
    },
    ramen: {
      a: "Steaming Bowl",
      b: "1F35C",
      j: ["food", "japanese", "noodle", "chopsticks"],
      k: [6, 52],
      o: 2
    },
    sagittarius: {
      a: "Sagittarius",
      b: "2650",
      j: ["sign", "zodiac", "purple-square", "astrology"],
      k: [53, 28],
      o: 2
    },
    bald_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F9B2",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f9b2.png",
          sheet_x: 19,
          sheet_y: 21,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F9B2",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f9b2.png",
          sheet_x: 19,
          sheet_y: 22,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F9B2",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f9b2.png",
          sheet_x: 19,
          sheet_y: 23,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F9B2",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f9b2.png",
          sheet_x: 19,
          sheet_y: 24,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F9B2",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f9b2.png",
          sheet_x: 19,
          sheet_y: 25,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Bald Woman",
      b: "1F469-200D-1F9B2",
      k: [19, 20],
      o: 11
    },
    dove_of_peace: {
      a: "Dove of Peace",
      b: "1F54A-FE0F",
      c: "1F54A",
      k: [28, 34],
      o: 2
    },
    hushed: {
      a: "Hushed Face",
      b: "1F62F",
      j: ["face", "woo", "shh"],
      k: [31, 25],
      o: 2
    },
    metro: {
      a: "Metro",
      b: "1F687",
      j: ["transportation", "blue-square", "mrt", "underground", "tube"],
      k: [34, 6],
      o: 2
    },
    "flag-dj": { a: "Djibouti Flag", b: "1F1E9-1F1EF", k: [1, 34], o: 2 },
    drum_with_drumsticks: {
      a: "Drum with Drumsticks",
      b: "1F941",
      k: [41, 17],
      o: 4
    },
    spaghetti: {
      a: "Spaghetti",
      b: "1F35D",
      j: ["food", "italian", "noodle"],
      k: [6, 53],
      o: 2
    },
    eagle: {
      a: "Eagle",
      b: "1F985",
      j: ["animal", "nature", "bird"],
      k: [42, 23],
      o: 4
    },
    astonished: {
      a: "Astonished Face",
      b: "1F632",
      j: ["face", "xox", "surprised", "poisoned"],
      k: [31, 28],
      o: 2
    },
    capricorn: {
      a: "Capricorn",
      b: "2651",
      j: ["sign", "zodiac", "purple-square", "astrology"],
      k: [53, 29],
      o: 2
    },
    light_rail: {
      a: "Light Rail",
      b: "1F688",
      j: ["transportation", "vehicle"],
      k: [34, 7],
      o: 2
    },
    "flag-dk": { a: "Denmark Flag", b: "1F1E9-1F1F0", k: [1, 35], o: 2 },
    iphone: {
      a: "Mobile Phone",
      b: "1F4F1",
      j: ["technology", "apple", "gadgets", "dial"],
      k: [27, 14],
      o: 2
    },
    bald_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F9B2",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f9b2.png",
          sheet_x: 47,
          sheet_y: 26,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F9B2",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f9b2.png",
          sheet_x: 47,
          sheet_y: 27,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F9B2",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f9b2.png",
          sheet_x: 47,
          sheet_y: 28,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F9B2",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f9b2.png",
          sheet_x: 47,
          sheet_y: 29,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F9B2",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f9b2.png",
          sheet_x: 47,
          sheet_y: 30,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Bald Person",
      b: "1F9D1-200D-1F9B2",
      k: [47, 25],
      o: 12
    },
    diamonds: {
      a: "Black Diamond Suit",
      b: "2666-FE0F",
      c: "2666",
      j: ["poker", "cards", "magic", "suits"],
      k: [53, 36],
      o: 2
    },
    clubs: {
      a: "Black Club Suit",
      b: "2663-FE0F",
      c: "2663",
      j: ["poker", "cards", "magic", "suits"],
      k: [53, 34],
      o: 2
    },
    aquarius: {
      a: "Aquarius",
      b: "2652",
      j: ["sign", "purple-square", "zodiac", "astrology"],
      k: [53, 30],
      o: 2
    },
    sweet_potato: {
      a: "Roasted Sweet Potato",
      b: "1F360",
      j: ["food", "nature"],
      k: [6, 56],
      o: 2
    },
    "flag-dm": { a: "Dominica Flag", b: "1F1E9-1F1F2", k: [1, 36], o: 2 },
    duck: {
      a: "Duck",
      b: "1F986",
      j: ["animal", "nature", "bird", "mallard"],
      k: [42, 24],
      o: 4
    },
    calling: {
      a: "Mobile Phone with Rightwards Arrow at Left",
      b: "1F4F2",
      j: ["iphone", "incoming"],
      k: [27, 15],
      o: 2
    },
    station: {
      a: "Station",
      b: "1F689",
      j: ["transportation", "vehicle", "public"],
      k: [34, 8],
      o: 2
    },
    "blond-haired-woman": {
      skin_variations: {
        "1F3FB": {
          unified: "1F471-1F3FB-200D-2640-FE0F",
          non_qualified: "1F471-1F3FB-200D-2640",
          image: "1f471-1f3fb-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F471-1F3FC-200D-2640-FE0F",
          non_qualified: "1F471-1F3FC-200D-2640",
          image: "1f471-1f3fc-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F471-1F3FD-200D-2640-FE0F",
          non_qualified: "1F471-1F3FD-200D-2640",
          image: "1f471-1f3fd-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F471-1F3FE-200D-2640-FE0F",
          non_qualified: "1F471-1F3FE-200D-2640",
          image: "1f471-1f3fe-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F471-1F3FF-200D-2640-FE0F",
          non_qualified: "1F471-1F3FF-200D-2640",
          image: "1f471-1f3ff-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Blond Haired Woman",
      b: "1F471-200D-2640-FE0F",
      c: "1F471-200D-2640",
      k: [22, 7],
      o: 4
    },
    flushed: {
      a: "Flushed Face",
      b: "1F633",
      j: ["face", "blush", "shy", "flattered"],
      k: [31, 29],
      o: 2
    },
    pisces: {
      a: "Pisces",
      b: "2653",
      j: ["purple-square", "sign", "zodiac", "astrology"],
      k: [53, 31],
      o: 2
    },
    chess_pawn: {
      a: "Chess Pawn",
      b: "265F-FE0F",
      c: "265F",
      k: [53, 32],
      o: 11
    },
    "blond-haired-man": {
      skin_variations: {
        "1F3FB": {
          unified: "1F471-1F3FB-200D-2642-FE0F",
          non_qualified: "1F471-1F3FB-200D-2642",
          image: "1f471-1f3fb-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F471-1F3FC-200D-2642-FE0F",
          non_qualified: "1F471-1F3FC-200D-2642",
          image: "1f471-1f3fc-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F471-1F3FD-200D-2642-FE0F",
          non_qualified: "1F471-1F3FD-200D-2642",
          image: "1f471-1f3fd-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F471-1F3FE-200D-2642-FE0F",
          non_qualified: "1F471-1F3FE-200D-2642",
          image: "1f471-1f3fe-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F471-1F3FF-200D-2642-FE0F",
          non_qualified: "1F471-1F3FF-200D-2642",
          image: "1f471-1f3ff-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F471",
      a: "Blond Haired Man",
      b: "1F471-200D-2642-FE0F",
      c: "1F471-200D-2642",
      k: [22, 13],
      o: 4
    },
    phone: {
      a: "Black Telephone",
      b: "260E-FE0F",
      c: "260E",
      j: ["technology", "communication", "dial", "telephone"],
      k: [52, 54],
      n: ["telephone"],
      o: 2
    },
    oden: { a: "Oden", b: "1F362", j: ["food", "japanese"], k: [7, 1], o: 2 },
    "flag-do": {
      a: "Dominican Republic Flag",
      b: "1F1E9-1F1F4",
      k: [1, 37],
      o: 2
    },
    tram: {
      a: "Tram",
      b: "1F68A",
      j: ["transportation", "vehicle"],
      k: [34, 9],
      o: 2
    },
    swan: { a: "Swan", b: "1F9A2", k: [42, 52], o: 11 },
    pleading_face: {
      a: "Face with Pleading Eyes",
      b: "1F97A",
      k: [42, 12],
      o: 11
    },
    "flag-dz": { a: "Algeria Flag", b: "1F1E9-1F1FF", k: [1, 38], o: 2 },
    monorail: {
      a: "Monorail",
      b: "1F69D",
      j: ["transportation", "vehicle"],
      k: [34, 28],
      o: 2
    },
    owl: {
      a: "Owl",
      b: "1F989",
      j: ["animal", "nature", "bird", "hoot"],
      k: [42, 27],
      o: 4
    },
    sushi: {
      a: "Sushi",
      b: "1F363",
      j: ["food", "fish", "japanese", "rice"],
      k: [7, 2],
      o: 2
    },
    telephone_receiver: {
      a: "Telephone Receiver",
      b: "1F4DE",
      j: ["technology", "communication", "dial"],
      k: [26, 52],
      o: 2
    },
    black_joker: {
      a: "Playing Card Black Joker",
      b: "1F0CF",
      j: ["poker", "cards", "game", "play", "magic"],
      k: [0, 15],
      o: 2
    },
    ophiuchus: {
      a: "Ophiuchus",
      b: "26CE",
      j: ["sign", "purple-square", "constellation", "astrology"],
      k: [54, 4],
      o: 2
    },
    frowning: {
      a: "Frowning Face with Open Mouth",
      b: "1F626",
      j: ["face", "aw", "what"],
      k: [31, 16],
      o: 2
    },
    older_adult: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D3-1F3FB",
          non_qualified: null,
          image: "1f9d3-1f3fb.png",
          sheet_x: 48,
          sheet_y: 23,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D3-1F3FC",
          non_qualified: null,
          image: "1f9d3-1f3fc.png",
          sheet_x: 48,
          sheet_y: 24,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D3-1F3FD",
          non_qualified: null,
          image: "1f9d3-1f3fd.png",
          sheet_x: 48,
          sheet_y: 25,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D3-1F3FE",
          non_qualified: null,
          image: "1f9d3-1f3fe.png",
          sheet_x: 48,
          sheet_y: 26,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D3-1F3FF",
          non_qualified: null,
          image: "1f9d3-1f3ff.png",
          sheet_x: 48,
          sheet_y: 27,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Older Adult",
      b: "1F9D3",
      k: [48, 22],
      o: 5
    },
    "flag-ea": {
      a: "Ceuta & Melilla Flag",
      b: "1F1EA-1F1E6",
      k: [1, 39],
      o: 2
    },
    flamingo: { a: "Flamingo", b: "1F9A9", k: [43, 0], o: 12 },
    pager: {
      a: "Pager",
      b: "1F4DF",
      j: ["bbcall", "oldschool", "90s"],
      k: [26, 53],
      o: 2
    },
    mountain_railway: {
      a: "Mountain Railway",
      b: "1F69E",
      j: ["transportation", "vehicle"],
      k: [34, 29],
      o: 2
    },
    mahjong: {
      a: "Mahjong Tile Red Dragon",
      b: "1F004",
      j: ["game", "play", "chinese", "kanji"],
      k: [0, 14],
      o: 2
    },
    older_man: {
      skin_variations: {
        "1F3FB": {
          unified: "1F474-1F3FB",
          non_qualified: null,
          image: "1f474-1f3fb.png",
          sheet_x: 22,
          sheet_y: 50,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F474-1F3FC",
          non_qualified: null,
          image: "1f474-1f3fc.png",
          sheet_x: 22,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F474-1F3FD",
          non_qualified: null,
          image: "1f474-1f3fd.png",
          sheet_x: 22,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F474-1F3FE",
          non_qualified: null,
          image: "1f474-1f3fe.png",
          sheet_x: 22,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F474-1F3FF",
          non_qualified: null,
          image: "1f474-1f3ff.png",
          sheet_x: 22,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Older Man",
      b: "1F474",
      j: ["human", "male", "men", "old", "elder", "senior"],
      k: [22, 49],
      o: 2
    },
    twisted_rightwards_arrows: {
      a: "Twisted Rightwards Arrows",
      b: "1F500",
      j: ["blue-square", "shuffle", "music", "random"],
      k: [27, 28],
      o: 2
    },
    fried_shrimp: {
      a: "Fried Shrimp",
      b: "1F364",
      j: ["food", "animal", "appetizer", "summer"],
      k: [7, 3],
      o: 2
    },
    anguished: {
      a: "Anguished Face",
      b: "1F627",
      j: ["face", "stunned", "nervous"],
      k: [31, 17],
      l: ["D:"],
      o: 2
    },
    repeat: {
      a: "Clockwise Rightwards and Leftwards Open Circle Arrows",
      b: "1F501",
      j: ["loop", "record"],
      k: [27, 29],
      o: 2
    },
    fish_cake: {
      a: "Fish Cake with Swirl Design",
      b: "1F365",
      j: [
        "food",
        "japan",
        "sea",
        "beach",
        "narutomaki",
        "pink",
        "swirl",
        "kamaboko",
        "surimi",
        "ramen"
      ],
      k: [7, 4],
      o: 2
    },
    fax: {
      a: "Fax Machine",
      b: "1F4E0",
      j: ["communication", "technology"],
      k: [26, 54],
      o: 2
    },
    older_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F475-1F3FB",
          non_qualified: null,
          image: "1f475-1f3fb.png",
          sheet_x: 22,
          sheet_y: 56,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F475-1F3FC",
          non_qualified: null,
          image: "1f475-1f3fc.png",
          sheet_x: 23,
          sheet_y: 0,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F475-1F3FD",
          non_qualified: null,
          image: "1f475-1f3fd.png",
          sheet_x: 23,
          sheet_y: 1,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F475-1F3FE",
          non_qualified: null,
          image: "1f475-1f3fe.png",
          sheet_x: 23,
          sheet_y: 2,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F475-1F3FF",
          non_qualified: null,
          image: "1f475-1f3ff.png",
          sheet_x: 23,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Older Woman",
      b: "1F475",
      j: ["human", "female", "women", "lady", "old", "elder", "senior"],
      k: [22, 55],
      o: 2
    },
    "flag-ec": { a: "Ecuador Flag", b: "1F1EA-1F1E8", k: [1, 40], o: 2 },
    peacock: { a: "Peacock", b: "1F99A", k: [42, 44], o: 11 },
    fearful: {
      a: "Fearful Face",
      b: "1F628",
      j: ["face", "scared", "terrified", "nervous", "oops", "huh"],
      k: [31, 18],
      o: 2
    },
    train: {
      a: "Tram Car",
      b: "1F68B",
      j: ["transportation", "vehicle", "carriage", "public", "travel"],
      k: [34, 10],
      o: 2
    },
    flower_playing_cards: {
      a: "Flower Playing Cards",
      b: "1F3B4",
      j: ["game", "sunset", "red"],
      k: [8, 26],
      o: 2
    },
    repeat_one: {
      a: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",
      b: "1F502",
      j: ["blue-square", "loop"],
      k: [27, 30],
      o: 2
    },
    moon_cake: { a: "Moon Cake", b: "1F96E", k: [42, 4], o: 11 },
    performing_arts: {
      a: "Performing Arts",
      b: "1F3AD",
      j: ["acting", "theater", "drama"],
      k: [8, 19],
      o: 2
    },
    cold_sweat: {
      a: "Face with Open Mouth and Cold Sweat",
      b: "1F630",
      j: ["face", "nervous", "sweat"],
      k: [31, 26],
      o: 2
    },
    person_frowning: {
      skin_variations: {
        "1F3FB": {
          unified: "1F64D-1F3FB",
          non_qualified: null,
          image: "1f64d-1f3fb.png",
          sheet_x: 33,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F64D-1F3FC",
          non_qualified: null,
          image: "1f64d-1f3fc.png",
          sheet_x: 33,
          sheet_y: 28,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F64D-1F3FD",
          non_qualified: null,
          image: "1f64d-1f3fd.png",
          sheet_x: 33,
          sheet_y: 29,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F64D-1F3FE",
          non_qualified: null,
          image: "1f64d-1f3fe.png",
          sheet_x: 33,
          sheet_y: 30,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F64D-1F3FF",
          non_qualified: null,
          image: "1f64d-1f3ff.png",
          sheet_x: 33,
          sheet_y: 31,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F64D-200D-2640-FE0F",
      a: "Person Frowning",
      b: "1F64D",
      k: [33, 26],
      o: 2
    },
    "flag-ee": { a: "Estonia Flag", b: "1F1EA-1F1EA", k: [1, 41], o: 2 },
    battery: {
      a: "Battery",
      b: "1F50B",
      j: ["power", "energy", "sustain"],
      k: [27, 39],
      o: 2
    },
    parrot: { a: "Parrot", b: "1F99C", k: [42, 46], o: 11 },
    bus: {
      a: "Bus",
      b: "1F68C",
      j: ["car", "vehicle", "transportation"],
      k: [34, 11],
      o: 2
    },
    "flag-eg": { a: "Egypt Flag", b: "1F1EA-1F1EC", k: [1, 42], o: 2 },
    arrow_forward: {
      a: "Black Right-Pointing Triangle",
      b: "25B6-FE0F",
      c: "25B6",
      j: ["blue-square", "right", "direction", "play"],
      k: [52, 43],
      o: 2
    },
    "man-frowning": {
      skin_variations: {
        "1F3FB": {
          unified: "1F64D-1F3FB-200D-2642-FE0F",
          non_qualified: "1F64D-1F3FB-200D-2642",
          image: "1f64d-1f3fb-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64D-1F3FC-200D-2642-FE0F",
          non_qualified: "1F64D-1F3FC-200D-2642",
          image: "1f64d-1f3fc-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64D-1F3FD-200D-2642-FE0F",
          non_qualified: "1F64D-1F3FD-200D-2642",
          image: "1f64d-1f3fd-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 23,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64D-1F3FE-200D-2642-FE0F",
          non_qualified: "1F64D-1F3FE-200D-2642",
          image: "1f64d-1f3fe-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64D-1F3FF-200D-2642-FE0F",
          non_qualified: "1F64D-1F3FF-200D-2642",
          image: "1f64d-1f3ff-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 25,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Frowning",
      b: "1F64D-200D-2642-FE0F",
      c: "1F64D-200D-2642",
      k: [33, 20],
      o: 4
    },
    disappointed_relieved: {
      a: "Disappointed but Relieved Face",
      b: "1F625",
      j: ["face", "phew", "sweat", "nervous"],
      k: [31, 15],
      o: 2
    },
    electric_plug: {
      a: "Electric Plug",
      b: "1F50C",
      j: ["charger", "power"],
      k: [27, 40],
      o: 2
    },
    frame_with_picture: {
      a: "Frame with Picture",
      b: "1F5BC-FE0F",
      c: "1F5BC",
      k: [30, 14],
      o: 2
    },
    oncoming_bus: {
      a: "Oncoming Bus",
      b: "1F68D",
      j: ["vehicle", "transportation"],
      k: [34, 12],
      o: 2
    },
    dango: {
      a: "Dango",
      b: "1F361",
      j: ["food", "dessert", "sweet", "japanese", "barbecue", "meat"],
      k: [7, 0],
      o: 2
    },
    frog: {
      a: "Frog Face",
      b: "1F438",
      j: ["animal", "nature", "croak", "toad"],
      k: [12, 28],
      o: 2
    },
    computer: {
      a: "Personal Computer",
      b: "1F4BB",
      j: ["technology", "laptop", "screen", "display", "monitor"],
      k: [26, 17],
      o: 2
    },
    art: {
      a: "Artist Palette",
      b: "1F3A8",
      j: ["design", "paint", "draw", "colors"],
      k: [8, 14],
      o: 2
    },
    "flag-eh": { a: "Western Sahara Flag", b: "1F1EA-1F1ED", k: [1, 43], o: 2 },
    fast_forward: {
      a: "Black Right-Pointing Double Triangle",
      b: "23E9",
      j: ["blue-square", "play", "speed", "continue"],
      k: [52, 26],
      o: 2
    },
    cry: {
      a: "Crying Face",
      b: "1F622",
      j: ["face", "tears", "sad", "depressed", "upset", ":'("],
      k: [31, 12],
      l: [":'("],
      m: ":'(",
      o: 2
    },
    "woman-frowning": {
      skin_variations: {
        "1F3FB": {
          unified: "1F64D-1F3FB-200D-2640-FE0F",
          non_qualified: "1F64D-1F3FB-200D-2640",
          image: "1f64d-1f3fb-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64D-1F3FC-200D-2640-FE0F",
          non_qualified: "1F64D-1F3FC-200D-2640",
          image: "1f64d-1f3fc-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64D-1F3FD-200D-2640-FE0F",
          non_qualified: "1F64D-1F3FD-200D-2640",
          image: "1f64d-1f3fd-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64D-1F3FE-200D-2640-FE0F",
          non_qualified: "1F64D-1F3FE-200D-2640",
          image: "1f64d-1f3fe-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64D-1F3FF-200D-2640-FE0F",
          non_qualified: "1F64D-1F3FF-200D-2640",
          image: "1f64d-1f3ff-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F64D",
      a: "Woman Frowning",
      b: "1F64D-200D-2640-FE0F",
      c: "1F64D-200D-2640",
      k: [33, 14],
      o: 4
    },
    trolleybus: {
      a: "Trolleybus",
      b: "1F68E",
      j: ["bart", "transportation", "vehicle"],
      k: [34, 13],
      o: 2
    },
    crocodile: {
      a: "Crocodile",
      b: "1F40A",
      j: ["animal", "nature", "reptile", "lizard", "alligator"],
      k: [11, 38],
      o: 2
    },
    dumpling: { a: "Dumpling", b: "1F95F", k: [41, 46], o: 5 },
    black_right_pointing_double_triangle_with_vertical_bar: {
      a: "Black Right Pointing Double Triangle with Vertical Bar",
      b: "23ED-FE0F",
      c: "23ED",
      k: [52, 30],
      o: 2
    },
    desktop_computer: {
      a: "Desktop Computer",
      b: "1F5A5-FE0F",
      c: "1F5A5",
      j: ["technology", "computing", "screen"],
      k: [30, 10],
      o: 2
    },
    person_with_pouting_face: {
      skin_variations: {
        "1F3FB": {
          unified: "1F64E-1F3FB",
          non_qualified: null,
          image: "1f64e-1f3fb.png",
          sheet_x: 33,
          sheet_y: 45,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F64E-1F3FC",
          non_qualified: null,
          image: "1f64e-1f3fc.png",
          sheet_x: 33,
          sheet_y: 46,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F64E-1F3FD",
          non_qualified: null,
          image: "1f64e-1f3fd.png",
          sheet_x: 33,
          sheet_y: 47,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F64E-1F3FE",
          non_qualified: null,
          image: "1f64e-1f3fe.png",
          sheet_x: 33,
          sheet_y: 48,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F64E-1F3FF",
          non_qualified: null,
          image: "1f64e-1f3ff.png",
          sheet_x: 33,
          sheet_y: 49,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F64E-200D-2640-FE0F",
      a: "Person with Pouting Face",
      b: "1F64E",
      k: [33, 44],
      o: 2
    },
    turtle: {
      a: "Turtle",
      b: "1F422",
      j: ["animal", "slow", "nature", "tortoise"],
      k: [12, 6],
      o: 2
    },
    sob: {
      a: "Loudly Crying Face",
      b: "1F62D",
      j: ["face", "cry", "tears", "sad", "upset", "depressed"],
      k: [31, 23],
      m: ":'(",
      o: 2
    },
    "flag-er": { a: "Eritrea Flag", b: "1F1EA-1F1F7", k: [1, 44], o: 2 },
    thread: { a: "Spool of Thread", b: "1F9F5", k: [51, 40], o: 11 },
    minibus: {
      a: "Minibus",
      b: "1F690",
      j: ["vehicle", "car", "transportation"],
      k: [34, 15],
      o: 2
    },
    fortune_cookie: { a: "Fortune Cookie", b: "1F960", k: [41, 47], o: 5 },
    yarn: { a: "Ball of Yarn", b: "1F9F6", k: [51, 41], o: 11 },
    takeout_box: { a: "Takeout Box", b: "1F961", k: [41, 48], o: 5 },
    "man-pouting": {
      skin_variations: {
        "1F3FB": {
          unified: "1F64E-1F3FB-200D-2642-FE0F",
          non_qualified: "1F64E-1F3FB-200D-2642",
          image: "1f64e-1f3fb-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64E-1F3FC-200D-2642-FE0F",
          non_qualified: "1F64E-1F3FC-200D-2642",
          image: "1f64e-1f3fc-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64E-1F3FD-200D-2642-FE0F",
          non_qualified: "1F64E-1F3FD-200D-2642",
          image: "1f64e-1f3fd-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64E-1F3FE-200D-2642-FE0F",
          non_qualified: "1F64E-1F3FE-200D-2642",
          image: "1f64e-1f3fe-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64E-1F3FF-200D-2642-FE0F",
          non_qualified: "1F64E-1F3FF-200D-2642",
          image: "1f64e-1f3ff-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Pouting",
      b: "1F64E-200D-2642-FE0F",
      c: "1F64E-200D-2642",
      k: [33, 38],
      o: 4
    },
    printer: {
      a: "Printer",
      b: "1F5A8-FE0F",
      c: "1F5A8",
      j: ["paper", "ink"],
      k: [30, 11],
      o: 2
    },
    scream: {
      a: "Face Screaming in Fear",
      b: "1F631",
      j: ["face", "munch", "scared", "omg"],
      k: [31, 27],
      o: 2
    },
    es: {
      a: "Spain Flag",
      b: "1F1EA-1F1F8",
      j: ["spain", "flag", "nation", "country", "banner"],
      k: [1, 45],
      n: ["flag-es"],
      o: 2
    },
    ambulance: {
      a: "Ambulance",
      b: "1F691",
      j: ["health", "911", "hospital"],
      k: [34, 16],
      o: 2
    },
    black_right_pointing_triangle_with_double_vertical_bar: {
      a: "Black Right Pointing Triangle with Double Vertical Bar",
      b: "23EF-FE0F",
      c: "23EF",
      k: [52, 32],
      o: 2
    },
    lizard: {
      a: "Lizard",
      b: "1F98E",
      j: ["animal", "nature", "reptile"],
      k: [42, 32],
      o: 4
    },
    "flag-et": { a: "Ethiopia Flag", b: "1F1EA-1F1F9", k: [1, 46], o: 2 },
    keyboard: {
      a: "Keyboard",
      b: "2328-FE0F",
      c: "2328",
      j: ["technology", "computer", "type", "input", "text"],
      k: [52, 24],
      o: 2
    },
    crab: {
      a: "Crab",
      b: "1F980",
      j: ["animal", "crustacean"],
      k: [42, 18],
      o: 2
    },
    confounded: {
      a: "Confounded Face",
      b: "1F616",
      j: ["face", "confused", "sick", "unwell", "oops", ":S"],
      k: [31, 0],
      o: 2
    },
    snake: {
      a: "Snake",
      b: "1F40D",
      j: ["animal", "evil", "nature", "hiss", "python"],
      k: [11, 41],
      o: 2
    },
    "woman-pouting": {
      skin_variations: {
        "1F3FB": {
          unified: "1F64E-1F3FB-200D-2640-FE0F",
          non_qualified: "1F64E-1F3FB-200D-2640",
          image: "1f64e-1f3fb-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64E-1F3FC-200D-2640-FE0F",
          non_qualified: "1F64E-1F3FC-200D-2640",
          image: "1f64e-1f3fc-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64E-1F3FD-200D-2640-FE0F",
          non_qualified: "1F64E-1F3FD-200D-2640",
          image: "1f64e-1f3fd-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 35,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64E-1F3FE-200D-2640-FE0F",
          non_qualified: "1F64E-1F3FE-200D-2640",
          image: "1f64e-1f3fe-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64E-1F3FF-200D-2640-FE0F",
          non_qualified: "1F64E-1F3FF-200D-2640",
          image: "1f64e-1f3ff-200d-2640-fe0f.png",
          sheet_x: 33,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F64E",
      a: "Woman Pouting",
      b: "1F64E-200D-2640-FE0F",
      c: "1F64E-200D-2640",
      k: [33, 32],
      o: 4
    },
    arrow_backward: {
      a: "Black Left-Pointing Triangle",
      b: "25C0-FE0F",
      c: "25C0",
      j: ["blue-square", "left", "direction"],
      k: [52, 44],
      o: 2
    },
    fire_engine: {
      a: "Fire Engine",
      b: "1F692",
      j: ["transportation", "cars", "vehicle"],
      k: [34, 17],
      o: 2
    },
    rewind: {
      a: "Black Left-Pointing Double Triangle",
      b: "23EA",
      j: ["play", "blue-square"],
      k: [52, 27],
      o: 2
    },
    three_button_mouse: {
      a: "Three Button Mouse",
      b: "1F5B1-FE0F",
      c: "1F5B1",
      k: [30, 12],
      o: 2
    },
    no_good: {
      skin_variations: {
        "1F3FB": {
          unified: "1F645-1F3FB",
          non_qualified: null,
          image: "1f645-1f3fb.png",
          sheet_x: 32,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F645-1F3FC",
          non_qualified: null,
          image: "1f645-1f3fc.png",
          sheet_x: 32,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F645-1F3FD",
          non_qualified: null,
          image: "1f645-1f3fd.png",
          sheet_x: 32,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F645-1F3FE",
          non_qualified: null,
          image: "1f645-1f3fe.png",
          sheet_x: 32,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F645-1F3FF",
          non_qualified: null,
          image: "1f645-1f3ff.png",
          sheet_x: 32,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F645-200D-2640-FE0F",
      a: "Face with No Good Gesture",
      b: "1F645",
      k: [32, 2],
      o: 2
    },
    police_car: {
      a: "Police Car",
      b: "1F693",
      j: ["vehicle", "cars", "transportation", "law", "legal", "enforcement"],
      k: [34, 18],
      o: 2
    },
    dragon_face: {
      a: "Dragon Face",
      b: "1F432",
      j: ["animal", "myth", "nature", "chinese", "green"],
      k: [12, 22],
      o: 2
    },
    persevere: {
      a: "Persevering Face",
      b: "1F623",
      j: ["face", "sick", "no", "upset", "oops"],
      k: [31, 13],
      o: 2
    },
    lobster: { a: "Lobster", b: "1F99E", k: [42, 48], o: 11 },
    "flag-eu": { a: "European Union Flag", b: "1F1EA-1F1FA", k: [1, 47], o: 2 },
    disappointed: {
      a: "Disappointed Face",
      b: "1F61E",
      j: ["face", "sad", "upset", "depressed", ":("],
      k: [31, 8],
      l: ["):", ":(", ":-("],
      m: ":(",
      o: 2
    },
    shrimp: {
      a: "Shrimp",
      b: "1F990",
      j: ["animal", "ocean", "nature", "seafood"],
      k: [42, 34],
      o: 4
    },
    dragon: {
      a: "Dragon",
      b: "1F409",
      j: ["animal", "myth", "nature", "chinese", "green"],
      k: [11, 37],
      o: 2
    },
    "man-gesturing-no": {
      skin_variations: {
        "1F3FB": {
          unified: "1F645-1F3FB-200D-2642-FE0F",
          non_qualified: "1F645-1F3FB-200D-2642",
          image: "1f645-1f3fb-200d-2642-fe0f.png",
          sheet_x: 31,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F645-1F3FC-200D-2642-FE0F",
          non_qualified: "1F645-1F3FC-200D-2642",
          image: "1f645-1f3fc-200d-2642-fe0f.png",
          sheet_x: 31,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F645-1F3FD-200D-2642-FE0F",
          non_qualified: "1F645-1F3FD-200D-2642",
          image: "1f645-1f3fd-200d-2642-fe0f.png",
          sheet_x: 31,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F645-1F3FE-200D-2642-FE0F",
          non_qualified: "1F645-1F3FE-200D-2642",
          image: "1f645-1f3fe-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F645-1F3FF-200D-2642-FE0F",
          non_qualified: "1F645-1F3FF-200D-2642",
          image: "1f645-1f3ff-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Gesturing No",
      b: "1F645-200D-2642-FE0F",
      c: "1F645-200D-2642",
      k: [31, 53],
      o: 4
    },
    "flag-fi": { a: "Finland Flag", b: "1F1EB-1F1EE", k: [1, 48], o: 2 },
    trackball: {
      a: "Trackball",
      b: "1F5B2-FE0F",
      c: "1F5B2",
      j: ["technology", "trackpad"],
      k: [30, 13],
      o: 2
    },
    black_left_pointing_double_triangle_with_vertical_bar: {
      a: "Black Left Pointing Double Triangle with Vertical Bar",
      b: "23EE-FE0F",
      c: "23EE",
      k: [52, 31],
      o: 2
    },
    oncoming_police_car: {
      a: "Oncoming Police Car",
      b: "1F694",
      j: ["vehicle", "law", "legal", "enforcement", "911"],
      k: [34, 19],
      o: 2
    },
    minidisc: {
      a: "Minidisc",
      b: "1F4BD",
      j: ["technology", "record", "data", "disk", "90s"],
      k: [26, 19],
      o: 2
    },
    sweat: {
      a: "Face with Cold Sweat",
      b: "1F613",
      j: ["face", "hot", "sad", "tired", "exercise"],
      k: [30, 54],
      o: 2
    },
    squid: {
      a: "Squid",
      b: "1F991",
      j: ["animal", "nature", "ocean", "sea"],
      k: [42, 35],
      o: 4
    },
    sauropod: { a: "Sauropod", b: "1F995", k: [42, 39], o: 5 },
    arrow_up_small: {
      a: "Up-Pointing Small Red Triangle",
      b: "1F53C",
      j: ["blue-square", "triangle", "direction", "point", "forward", "top"],
      k: [28, 31],
      o: 2
    },
    "flag-fj": { a: "Fiji Flag", b: "1F1EB-1F1EF", k: [1, 49], o: 2 },
    "woman-gesturing-no": {
      skin_variations: {
        "1F3FB": {
          unified: "1F645-1F3FB-200D-2640-FE0F",
          non_qualified: "1F645-1F3FB-200D-2640",
          image: "1f645-1f3fb-200d-2640-fe0f.png",
          sheet_x: 31,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F645-1F3FC-200D-2640-FE0F",
          non_qualified: "1F645-1F3FC-200D-2640",
          image: "1f645-1f3fc-200d-2640-fe0f.png",
          sheet_x: 31,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F645-1F3FD-200D-2640-FE0F",
          non_qualified: "1F645-1F3FD-200D-2640",
          image: "1f645-1f3fd-200d-2640-fe0f.png",
          sheet_x: 31,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F645-1F3FE-200D-2640-FE0F",
          non_qualified: "1F645-1F3FE-200D-2640",
          image: "1f645-1f3fe-200d-2640-fe0f.png",
          sheet_x: 31,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F645-1F3FF-200D-2640-FE0F",
          non_qualified: "1F645-1F3FF-200D-2640",
          image: "1f645-1f3ff-200d-2640-fe0f.png",
          sheet_x: 31,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F645",
      a: "Woman Gesturing No",
      b: "1F645-200D-2640-FE0F",
      c: "1F645-200D-2640",
      k: [31, 47],
      o: 4
    },
    taxi: {
      a: "Taxi",
      b: "1F695",
      j: ["uber", "vehicle", "cars", "transportation"],
      k: [34, 20],
      o: 2
    },
    "flag-fk": {
      a: "Falkland Islands Flag",
      b: "1F1EB-1F1F0",
      k: [1, 50],
      o: 2
    },
    floppy_disk: {
      a: "Floppy Disk",
      b: "1F4BE",
      j: ["oldschool", "technology", "save", "90s", "80s"],
      k: [26, 20],
      o: 2
    },
    "t-rex": { a: "T-Rex", b: "1F996", k: [42, 40], o: 5 },
    oyster: { a: "Oyster", b: "1F9AA", k: [43, 1], o: 12 },
    arrow_double_up: {
      a: "Black Up-Pointing Double Triangle",
      b: "23EB",
      j: ["blue-square", "direction", "top"],
      k: [52, 28],
      o: 2
    },
    oncoming_taxi: {
      a: "Oncoming Taxi",
      b: "1F696",
      j: ["vehicle", "cars", "uber"],
      k: [34, 21],
      o: 2
    },
    ok_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F646-1F3FB",
          non_qualified: null,
          image: "1f646-1f3fb.png",
          sheet_x: 32,
          sheet_y: 21,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F646-1F3FC",
          non_qualified: null,
          image: "1f646-1f3fc.png",
          sheet_x: 32,
          sheet_y: 22,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F646-1F3FD",
          non_qualified: null,
          image: "1f646-1f3fd.png",
          sheet_x: 32,
          sheet_y: 23,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F646-1F3FE",
          non_qualified: null,
          image: "1f646-1f3fe.png",
          sheet_x: 32,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F646-1F3FF",
          non_qualified: null,
          image: "1f646-1f3ff.png",
          sheet_x: 32,
          sheet_y: 25,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F646-200D-2640-FE0F",
      a: "Face with Ok Gesture",
      b: "1F646",
      j: ["women", "girl", "female", "pink", "human", "woman"],
      k: [32, 20],
      o: 2
    },
    weary: {
      a: "Weary Face",
      b: "1F629",
      j: ["face", "tired", "sleepy", "sad", "frustrated", "upset"],
      k: [31, 19],
      o: 2
    },
    "man-gesturing-ok": {
      skin_variations: {
        "1F3FB": {
          unified: "1F646-1F3FB-200D-2642-FE0F",
          non_qualified: "1F646-1F3FB-200D-2642",
          image: "1f646-1f3fb-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F646-1F3FC-200D-2642-FE0F",
          non_qualified: "1F646-1F3FC-200D-2642",
          image: "1f646-1f3fc-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F646-1F3FD-200D-2642-FE0F",
          non_qualified: "1F646-1F3FD-200D-2642",
          image: "1f646-1f3fd-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F646-1F3FE-200D-2642-FE0F",
          non_qualified: "1F646-1F3FE-200D-2642",
          image: "1f646-1f3fe-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F646-1F3FF-200D-2642-FE0F",
          non_qualified: "1F646-1F3FF-200D-2642",
          image: "1f646-1f3ff-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Gesturing Ok",
      b: "1F646-200D-2642-FE0F",
      c: "1F646-200D-2642",
      k: [32, 14],
      o: 4
    },
    arrow_down_small: {
      a: "Down-Pointing Small Red Triangle",
      b: "1F53D",
      j: ["blue-square", "direction", "bottom"],
      k: [28, 32],
      o: 2
    },
    tired_face: {
      a: "Tired Face",
      b: "1F62B",
      j: ["sick", "whine", "upset", "frustrated"],
      k: [31, 21],
      o: 2
    },
    car: { a: "Automobile", b: "1F697", k: [34, 22], n: ["red_car"], o: 2 },
    icecream: {
      a: "Soft Ice Cream",
      b: "1F366",
      j: ["food", "hot", "dessert", "summer"],
      k: [7, 5],
      o: 2
    },
    cd: {
      a: "Optical Disc",
      b: "1F4BF",
      j: ["technology", "dvd", "disk", "disc", "90s"],
      k: [26, 21],
      o: 2
    },
    whale: {
      a: "Spouting Whale",
      b: "1F433",
      j: ["animal", "nature", "sea", "ocean"],
      k: [12, 23],
      o: 2
    },
    "flag-fm": { a: "Micronesia Flag", b: "1F1EB-1F1F2", k: [1, 51], o: 2 },
    oncoming_automobile: {
      a: "Oncoming Automobile",
      b: "1F698",
      j: ["car", "vehicle", "transportation"],
      k: [34, 23],
      o: 2
    },
    arrow_double_down: {
      a: "Black Down-Pointing Double Triangle",
      b: "23EC",
      j: ["blue-square", "direction", "bottom"],
      k: [52, 29],
      o: 2
    },
    "woman-gesturing-ok": {
      skin_variations: {
        "1F3FB": {
          unified: "1F646-1F3FB-200D-2640-FE0F",
          non_qualified: "1F646-1F3FB-200D-2640",
          image: "1f646-1f3fb-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F646-1F3FC-200D-2640-FE0F",
          non_qualified: "1F646-1F3FC-200D-2640",
          image: "1f646-1f3fc-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F646-1F3FD-200D-2640-FE0F",
          non_qualified: "1F646-1F3FD-200D-2640",
          image: "1f646-1f3fd-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F646-1F3FE-200D-2640-FE0F",
          non_qualified: "1F646-1F3FE-200D-2640",
          image: "1f646-1f3fe-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F646-1F3FF-200D-2640-FE0F",
          non_qualified: "1F646-1F3FF-200D-2640",
          image: "1f646-1f3ff-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F646",
      a: "Woman Gesturing Ok",
      b: "1F646-200D-2640-FE0F",
      c: "1F646-200D-2640",
      k: [32, 8],
      o: 4
    },
    yawning_face: { a: "Yawning Face", b: "1F971", k: [42, 7], o: 12 },
    dvd: { a: "Dvd", b: "1F4C0", j: ["cd", "disk", "disc"], k: [26, 22], o: 2 },
    whale2: {
      a: "Whale",
      b: "1F40B",
      j: ["animal", "nature", "sea", "ocean"],
      k: [11, 39],
      o: 2
    },
    "flag-fo": { a: "Faroe Islands Flag", b: "1F1EB-1F1F4", k: [1, 52], o: 2 },
    shaved_ice: {
      a: "Shaved Ice",
      b: "1F367",
      j: ["hot", "dessert", "summer"],
      k: [7, 6],
      o: 2
    },
    double_vertical_bar: {
      a: "Double Vertical Bar",
      b: "23F8-FE0F",
      c: "23F8",
      k: [52, 37],
      o: 2
    },
    information_desk_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F481-1F3FB",
          non_qualified: null,
          image: "1f481-1f3fb.png",
          sheet_x: 24,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F481-1F3FC",
          non_qualified: null,
          image: "1f481-1f3fc.png",
          sheet_x: 24,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F481-1F3FD",
          non_qualified: null,
          image: "1f481-1f3fd.png",
          sheet_x: 24,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F481-1F3FE",
          non_qualified: null,
          image: "1f481-1f3fe.png",
          sheet_x: 24,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F481-1F3FF",
          non_qualified: null,
          image: "1f481-1f3ff.png",
          sheet_x: 24,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F481-200D-2640-FE0F",
      a: "Information Desk Person",
      b: "1F481",
      k: [24, 2],
      o: 2
    },
    dolphin: {
      a: "Dolphin",
      b: "1F42C",
      j: [
        "animal",
        "nature",
        "fish",
        "sea",
        "ocean",
        "flipper",
        "fins",
        "beach"
      ],
      k: [12, 16],
      n: ["flipper"],
      o: 2
    },
    blue_car: {
      a: "Recreational Vehicle",
      b: "1F699",
      j: ["transportation", "vehicle"],
      k: [34, 24],
      o: 2
    },
    ice_cream: {
      a: "Ice Cream",
      b: "1F368",
      j: ["food", "hot", "dessert"],
      k: [7, 7],
      o: 2
    },
    fr: {
      a: "France Flag",
      b: "1F1EB-1F1F7",
      j: ["banner", "flag", "nation", "france", "french", "country"],
      k: [1, 53],
      n: ["flag-fr"],
      o: 2
    },
    triumph: {
      a: "Face with Look of Triumph",
      b: "1F624",
      j: ["face", "gas", "phew", "proud", "pride"],
      k: [31, 14],
      o: 2
    },
    abacus: { a: "Abacus", b: "1F9EE", k: [51, 33], o: 11 },
    "man-tipping-hand": {
      skin_variations: {
        "1F3FB": {
          unified: "1F481-1F3FB-200D-2642-FE0F",
          non_qualified: "1F481-1F3FB-200D-2642",
          image: "1f481-1f3fb-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F481-1F3FC-200D-2642-FE0F",
          non_qualified: "1F481-1F3FC-200D-2642",
          image: "1f481-1f3fc-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F481-1F3FD-200D-2642-FE0F",
          non_qualified: "1F481-1F3FD-200D-2642",
          image: "1f481-1f3fd-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F481-1F3FE-200D-2642-FE0F",
          non_qualified: "1F481-1F3FE-200D-2642",
          image: "1f481-1f3fe-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F481-1F3FF-200D-2642-FE0F",
          non_qualified: "1F481-1F3FF-200D-2642",
          image: "1f481-1f3ff-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Tipping Hand",
      b: "1F481-200D-2642-FE0F",
      c: "1F481-200D-2642",
      k: [23, 53],
      o: 4
    },
    doughnut: {
      a: "Doughnut",
      b: "1F369",
      j: ["food", "dessert", "snack", "sweet", "donut"],
      k: [7, 8],
      o: 2
    },
    fish: {
      a: "Fish",
      b: "1F41F",
      j: ["animal", "food", "nature"],
      k: [12, 3],
      o: 2
    },
    truck: {
      a: "Delivery Truck",
      b: "1F69A",
      j: ["cars", "transportation"],
      k: [34, 25],
      o: 2
    },
    movie_camera: {
      a: "Movie Camera",
      b: "1F3A5",
      j: ["film", "record"],
      k: [8, 11],
      o: 2
    },
    "flag-ga": { a: "Gabon Flag", b: "1F1EC-1F1E6", k: [1, 54], o: 2 },
    rage: {
      a: "Pouting Face",
      b: "1F621",
      j: ["angry", "mad", "hate", "despise"],
      k: [31, 11],
      o: 2
    },
    black_square_for_stop: {
      a: "Black Square for Stop",
      b: "23F9-FE0F",
      c: "23F9",
      k: [52, 38],
      o: 2
    },
    articulated_lorry: {
      a: "Articulated Lorry",
      b: "1F69B",
      j: ["vehicle", "cars", "transportation", "express"],
      k: [34, 26],
      o: 2
    },
    angry: {
      a: "Angry Face",
      b: "1F620",
      j: ["mad", "face", "annoyed", "frustrated"],
      k: [31, 10],
      l: [">:(", ">:-("],
      o: 2
    },
    cookie: {
      a: "Cookie",
      b: "1F36A",
      j: ["food", "snack", "oreo", "chocolate", "sweet", "dessert"],
      k: [7, 9],
      o: 2
    },
    gb: {
      a: "United Kingdom Flag",
      b: "1F1EC-1F1E7",
      k: [1, 55],
      n: ["uk", "flag-gb"],
      o: 2
    },
    tropical_fish: {
      a: "Tropical Fish",
      b: "1F420",
      j: ["animal", "swim", "ocean", "beach", "nemo"],
      k: [12, 4],
      o: 2
    },
    "woman-tipping-hand": {
      skin_variations: {
        "1F3FB": {
          unified: "1F481-1F3FB-200D-2640-FE0F",
          non_qualified: "1F481-1F3FB-200D-2640",
          image: "1f481-1f3fb-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F481-1F3FC-200D-2640-FE0F",
          non_qualified: "1F481-1F3FC-200D-2640",
          image: "1f481-1f3fc-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F481-1F3FD-200D-2640-FE0F",
          non_qualified: "1F481-1F3FD-200D-2640",
          image: "1f481-1f3fd-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F481-1F3FE-200D-2640-FE0F",
          non_qualified: "1F481-1F3FE-200D-2640",
          image: "1f481-1f3fe-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F481-1F3FF-200D-2640-FE0F",
          non_qualified: "1F481-1F3FF-200D-2640",
          image: "1f481-1f3ff-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F481",
      a: "Woman Tipping Hand",
      b: "1F481-200D-2640-FE0F",
      c: "1F481-200D-2640",
      k: [23, 47],
      o: 4
    },
    black_circle_for_record: {
      a: "Black Circle for Record",
      b: "23FA-FE0F",
      c: "23FA",
      k: [52, 39],
      o: 2
    },
    film_frames: {
      a: "Film Frames",
      b: "1F39E-FE0F",
      c: "1F39E",
      k: [8, 4],
      o: 2
    },
    film_projector: {
      a: "Film Projector",
      b: "1F4FD-FE0F",
      c: "1F4FD",
      j: ["video", "tape", "record", "movie"],
      k: [27, 26],
      o: 2
    },
    "flag-gd": { a: "Grenada Flag", b: "1F1EC-1F1E9", k: [1, 56], o: 2 },
    blowfish: {
      a: "Blowfish",
      b: "1F421",
      j: ["animal", "nature", "food", "sea", "ocean"],
      k: [12, 5],
      o: 2
    },
    face_with_symbols_on_mouth: {
      a: "Serious Face with Symbols Covering Mouth",
      b: "1F92C",
      k: [38, 46],
      n: ["serious_face_with_symbols_covering_mouth"],
      o: 5
    },
    birthday: {
      a: "Birthday Cake",
      b: "1F382",
      j: ["food", "dessert", "cake"],
      k: [7, 33],
      o: 2
    },
    eject: { a: "Eject", b: "23CF-FE0F", c: "23CF", k: [52, 25], o: 2 },
    raising_hand: {
      skin_variations: {
        "1F3FB": {
          unified: "1F64B-1F3FB",
          non_qualified: null,
          image: "1f64b-1f3fb.png",
          sheet_x: 33,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F64B-1F3FC",
          non_qualified: null,
          image: "1f64b-1f3fc.png",
          sheet_x: 33,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F64B-1F3FD",
          non_qualified: null,
          image: "1f64b-1f3fd.png",
          sheet_x: 33,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F64B-1F3FE",
          non_qualified: null,
          image: "1f64b-1f3fe.png",
          sheet_x: 33,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F64B-1F3FF",
          non_qualified: null,
          image: "1f64b-1f3ff.png",
          sheet_x: 33,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F64B-200D-2640-FE0F",
      a: "Happy Person Raising One Hand",
      b: "1F64B",
      k: [33, 2],
      o: 2
    },
    tractor: {
      a: "Tractor",
      b: "1F69C",
      j: ["vehicle", "car", "farming", "agriculture"],
      k: [34, 27],
      o: 2
    },
    "flag-ge": { a: "Georgia Flag", b: "1F1EC-1F1EA", k: [2, 0], o: 2 },
    smiling_imp: {
      a: "Smiling Face with Horns",
      b: "1F608",
      j: ["devil", "horns"],
      k: [30, 43],
      o: 2
    },
    racing_car: {
      a: "Racing Car",
      b: "1F3CE-FE0F",
      c: "1F3CE",
      j: ["sports", "race", "fast", "formula", "f1"],
      k: [10, 33],
      o: 2
    },
    cinema: {
      a: "Cinema",
      b: "1F3A6",
      j: [
        "blue-square",
        "record",
        "film",
        "movie",
        "curtain",
        "stage",
        "theater"
      ],
      k: [8, 12],
      o: 2
    },
    clapper: {
      a: "Clapper Board",
      b: "1F3AC",
      j: ["movie", "film", "record"],
      k: [8, 18],
      o: 2
    },
    shark: {
      a: "Shark",
      b: "1F988",
      j: ["animal", "nature", "fish", "sea", "ocean", "jaws", "fins", "beach"],
      k: [42, 26],
      o: 4
    },
    cake: {
      a: "Shortcake",
      b: "1F370",
      j: ["food", "dessert"],
      k: [7, 15],
      o: 2
    },
    "man-raising-hand": {
      skin_variations: {
        "1F3FB": {
          unified: "1F64B-1F3FB-200D-2642-FE0F",
          non_qualified: "1F64B-1F3FB-200D-2642",
          image: "1f64b-1f3fb-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64B-1F3FC-200D-2642-FE0F",
          non_qualified: "1F64B-1F3FC-200D-2642",
          image: "1f64b-1f3fc-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64B-1F3FD-200D-2642-FE0F",
          non_qualified: "1F64B-1F3FD-200D-2642",
          image: "1f64b-1f3fd-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64B-1F3FE-200D-2642-FE0F",
          non_qualified: "1F64B-1F3FE-200D-2642",
          image: "1f64b-1f3fe-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64B-1F3FF-200D-2642-FE0F",
          non_qualified: "1F64B-1F3FF-200D-2642",
          image: "1f64b-1f3ff-200d-2642-fe0f.png",
          sheet_x: 33,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Raising Hand",
      b: "1F64B-200D-2642-FE0F",
      c: "1F64B-200D-2642",
      k: [32, 53],
      o: 4
    },
    octopus: {
      a: "Octopus",
      b: "1F419",
      j: ["animal", "creature", "ocean", "sea", "nature", "beach"],
      k: [11, 54],
      o: 2
    },
    "woman-raising-hand": {
      skin_variations: {
        "1F3FB": {
          unified: "1F64B-1F3FB-200D-2640-FE0F",
          non_qualified: "1F64B-1F3FB-200D-2640",
          image: "1f64b-1f3fb-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F64B-1F3FC-200D-2640-FE0F",
          non_qualified: "1F64B-1F3FC-200D-2640",
          image: "1f64b-1f3fc-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F64B-1F3FD-200D-2640-FE0F",
          non_qualified: "1F64B-1F3FD-200D-2640",
          image: "1f64b-1f3fd-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F64B-1F3FE-200D-2640-FE0F",
          non_qualified: "1F64B-1F3FE-200D-2640",
          image: "1f64b-1f3fe-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F64B-1F3FF-200D-2640-FE0F",
          non_qualified: "1F64B-1F3FF-200D-2640",
          image: "1f64b-1f3ff-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F64B",
      a: "Woman Raising Hand",
      b: "1F64B-200D-2640-FE0F",
      c: "1F64B-200D-2640",
      k: [32, 47],
      o: 4
    },
    "flag-gf": { a: "French Guiana Flag", b: "1F1EC-1F1EB", k: [2, 1], o: 2 },
    tv: {
      a: "Television",
      b: "1F4FA",
      j: ["technology", "program", "oldschool", "show", "television"],
      k: [27, 23],
      o: 2
    },
    imp: {
      a: "Imp",
      b: "1F47F",
      j: ["devil", "angry", "horns"],
      k: [23, 45],
      o: 2
    },
    cupcake: { a: "Cupcake", b: "1F9C1", k: [44, 9], o: 11 },
    racing_motorcycle: {
      a: "Racing Motorcycle",
      b: "1F3CD-FE0F",
      c: "1F3CD",
      k: [10, 32],
      o: 2
    },
    low_brightness: {
      a: "Low Brightness Symbol",
      b: "1F505",
      j: ["sun", "afternoon", "warm", "summer"],
      k: [27, 33],
      o: 2
    },
    shell: {
      a: "Spiral Shell",
      b: "1F41A",
      j: ["nature", "sea", "beach"],
      k: [11, 55],
      o: 2
    },
    "flag-gg": { a: "Guernsey Flag", b: "1F1EC-1F1EC", k: [2, 2], o: 2 },
    high_brightness: {
      a: "High Brightness Symbol",
      b: "1F506",
      j: ["sun", "light"],
      k: [27, 34],
      o: 2
    },
    deaf_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CF-1F3FB",
          non_qualified: null,
          image: "1f9cf-1f3fb.png",
          sheet_x: 45,
          sheet_y: 11,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CF-1F3FC",
          non_qualified: null,
          image: "1f9cf-1f3fc.png",
          sheet_x: 45,
          sheet_y: 12,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CF-1F3FD",
          non_qualified: null,
          image: "1f9cf-1f3fd.png",
          sheet_x: 45,
          sheet_y: 13,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CF-1F3FE",
          non_qualified: null,
          image: "1f9cf-1f3fe.png",
          sheet_x: 45,
          sheet_y: 14,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CF-1F3FF",
          non_qualified: null,
          image: "1f9cf-1f3ff.png",
          sheet_x: 45,
          sheet_y: 15,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Deaf Person",
      b: "1F9CF",
      k: [45, 10],
      o: 12
    },
    skull: {
      a: "Skull",
      b: "1F480",
      j: ["dead", "skeleton", "creepy", "death"],
      k: [23, 46],
      o: 2
    },
    motor_scooter: {
      a: "Motor Scooter",
      b: "1F6F5",
      j: ["vehicle", "vespa", "sasha"],
      k: [36, 54],
      o: 4
    },
    camera: {
      a: "Camera",
      b: "1F4F7",
      j: ["gadgets", "photography"],
      k: [27, 20],
      o: 2
    },
    pie: { a: "Pie", b: "1F967", k: [41, 54], o: 5 },
    "flag-gh": { a: "Ghana Flag", b: "1F1EC-1F1ED", k: [2, 3], o: 2 },
    deaf_man: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CF-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9CF-1F3FB-200D-2642",
          image: "1f9cf-1f3fb-200d-2642-fe0f.png",
          sheet_x: 45,
          sheet_y: 5,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CF-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9CF-1F3FC-200D-2642",
          image: "1f9cf-1f3fc-200d-2642-fe0f.png",
          sheet_x: 45,
          sheet_y: 6,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CF-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9CF-1F3FD-200D-2642",
          image: "1f9cf-1f3fd-200d-2642-fe0f.png",
          sheet_x: 45,
          sheet_y: 7,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CF-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9CF-1F3FE-200D-2642",
          image: "1f9cf-1f3fe-200d-2642-fe0f.png",
          sheet_x: 45,
          sheet_y: 8,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CF-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9CF-1F3FF-200D-2642",
          image: "1f9cf-1f3ff-200d-2642-fe0f.png",
          sheet_x: 45,
          sheet_y: 9,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Deaf Man",
      b: "1F9CF-200D-2642-FE0F",
      c: "1F9CF-200D-2642",
      k: [45, 4],
      o: 12
    },
    skull_and_crossbones: {
      a: "Skull and Crossbones",
      b: "2620-FE0F",
      c: "2620",
      j: ["poison", "danger", "deadly", "scary", "death", "pirate", "evil"],
      k: [53, 8],
      o: 2
    },
    camera_with_flash: {
      a: "Camera with Flash",
      b: "1F4F8",
      k: [27, 21],
      o: 2
    },
    signal_strength: {
      a: "Antenna with Bars",
      b: "1F4F6",
      j: [
        "blue-square",
        "reception",
        "phone",
        "internet",
        "connection",
        "wifi",
        "bluetooth",
        "bars"
      ],
      k: [27, 19],
      o: 2
    },
    chocolate_bar: {
      a: "Chocolate Bar",
      b: "1F36B",
      j: ["food", "snack", "dessert", "sweet"],
      k: [7, 10],
      o: 2
    },
    manual_wheelchair: {
      a: "Manual Wheelchair",
      b: "1F9BD",
      k: [44, 5],
      o: 12
    },
    snail: {
      a: "Snail",
      b: "1F40C",
      j: ["slow", "animal", "shell"],
      k: [11, 40],
      o: 2
    },
    motorized_wheelchair: {
      a: "Motorized Wheelchair",
      b: "1F9BC",
      k: [44, 4],
      o: 12
    },
    "flag-gi": { a: "Gibraltar Flag", b: "1F1EC-1F1EE", k: [2, 4], o: 2 },
    hankey: {
      a: "Pile of Poo",
      b: "1F4A9",
      k: [25, 51],
      n: ["poop", "shit"],
      o: 2
    },
    vibration_mode: {
      a: "Vibration Mode",
      b: "1F4F3",
      j: ["orange-square", "phone"],
      k: [27, 16],
      o: 2
    },
    deaf_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CF-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9CF-1F3FB-200D-2640",
          image: "1f9cf-1f3fb-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 56,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CF-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9CF-1F3FC-200D-2640",
          image: "1f9cf-1f3fc-200d-2640-fe0f.png",
          sheet_x: 45,
          sheet_y: 0,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CF-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9CF-1F3FD-200D-2640",
          image: "1f9cf-1f3fd-200d-2640-fe0f.png",
          sheet_x: 45,
          sheet_y: 1,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CF-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9CF-1F3FE-200D-2640",
          image: "1f9cf-1f3fe-200d-2640-fe0f.png",
          sheet_x: 45,
          sheet_y: 2,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CF-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9CF-1F3FF-200D-2640",
          image: "1f9cf-1f3ff-200d-2640-fe0f.png",
          sheet_x: 45,
          sheet_y: 3,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Deaf Woman",
      b: "1F9CF-200D-2640-FE0F",
      c: "1F9CF-200D-2640",
      k: [44, 55],
      o: 12
    },
    butterfly: {
      a: "Butterfly",
      b: "1F98B",
      j: ["animal", "insect", "nature", "caterpillar"],
      k: [42, 29],
      o: 4
    },
    video_camera: {
      a: "Video Camera",
      b: "1F4F9",
      j: ["film", "record"],
      k: [27, 22],
      o: 2
    },
    candy: {
      a: "Candy",
      b: "1F36C",
      j: ["snack", "dessert", "sweet", "lolly"],
      k: [7, 11],
      o: 2
    },
    auto_rickshaw: { a: "Auto Rickshaw", b: "1F6FA", k: [37, 2], o: 12 },
    bow: {
      skin_variations: {
        "1F3FB": {
          unified: "1F647-1F3FB",
          non_qualified: null,
          image: "1f647-1f3fb.png",
          sheet_x: 32,
          sheet_y: 39,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F647-1F3FC",
          non_qualified: null,
          image: "1f647-1f3fc.png",
          sheet_x: 32,
          sheet_y: 40,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F647-1F3FD",
          non_qualified: null,
          image: "1f647-1f3fd.png",
          sheet_x: 32,
          sheet_y: 41,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F647-1F3FE",
          non_qualified: null,
          image: "1f647-1f3fe.png",
          sheet_x: 32,
          sheet_y: 42,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F647-1F3FF",
          non_qualified: null,
          image: "1f647-1f3ff.png",
          sheet_x: 32,
          sheet_y: 43,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F647-200D-2642-FE0F",
      a: "Person Bowing Deeply",
      b: "1F647",
      k: [32, 38],
      o: 2
    },
    mobile_phone_off: {
      a: "Mobile Phone off",
      b: "1F4F4",
      j: ["mute", "orange-square", "silence", "quiet"],
      k: [27, 17],
      o: 2
    },
    clown_face: { a: "Clown Face", b: "1F921", j: ["face"], k: [38, 18], o: 4 },
    lollipop: {
      a: "Lollipop",
      b: "1F36D",
      j: ["food", "snack", "candy", "sweet"],
      k: [7, 12],
      o: 2
    },
    "flag-gl": { a: "Greenland Flag", b: "1F1EC-1F1F1", k: [2, 5], o: 2 },
    vhs: {
      a: "Videocassette",
      b: "1F4FC",
      j: ["record", "video", "oldschool", "90s", "80s"],
      k: [27, 25],
      o: 2
    },
    bug: {
      a: "Bug",
      b: "1F41B",
      j: ["animal", "insect", "nature", "worm"],
      k: [11, 56],
      o: 2
    },
    bike: {
      a: "Bicycle",
      b: "1F6B2",
      j: ["sports", "bicycle", "exercise", "hipster"],
      k: [35, 9],
      o: 2
    },
    "man-bowing": {
      skin_variations: {
        "1F3FB": {
          unified: "1F647-1F3FB-200D-2642-FE0F",
          non_qualified: "1F647-1F3FB-200D-2642",
          image: "1f647-1f3fb-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F647-1F3FC-200D-2642-FE0F",
          non_qualified: "1F647-1F3FC-200D-2642",
          image: "1f647-1f3fc-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F647-1F3FD-200D-2642-FE0F",
          non_qualified: "1F647-1F3FD-200D-2642",
          image: "1f647-1f3fd-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 35,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F647-1F3FE-200D-2642-FE0F",
          non_qualified: "1F647-1F3FE-200D-2642",
          image: "1f647-1f3fe-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F647-1F3FF-200D-2642-FE0F",
          non_qualified: "1F647-1F3FF-200D-2642",
          image: "1f647-1f3ff-200d-2642-fe0f.png",
          sheet_x: 32,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F647",
      a: "Man Bowing",
      b: "1F647-200D-2642-FE0F",
      c: "1F647-200D-2642",
      k: [32, 32],
      o: 4
    },
    japanese_ogre: {
      a: "Japanese Ogre",
      b: "1F479",
      j: [
        "monster",
        "red",
        "mask",
        "halloween",
        "scary",
        "creepy",
        "devil",
        "demon",
        "japanese",
        "ogre"
      ],
      k: [23, 34],
      o: 2
    },
    custard: {
      a: "Custard",
      b: "1F36E",
      j: ["dessert", "food"],
      k: [7, 13],
      o: 2
    },
    ant: {
      a: "Ant",
      b: "1F41C",
      j: ["animal", "insect", "nature", "bug"],
      k: [12, 0],
      o: 2
    },
    mag: {
      a: "Left-Pointing Magnifying Glass",
      b: "1F50D",
      j: ["search", "zoom", "find", "detective"],
      k: [27, 41],
      o: 2
    },
    "flag-gm": { a: "Gambia Flag", b: "1F1EC-1F1F2", k: [2, 6], o: 2 },
    honey_pot: {
      a: "Honey Pot",
      b: "1F36F",
      j: ["bees", "sweet", "kitchen"],
      k: [7, 14],
      o: 2
    },
    "woman-bowing": {
      skin_variations: {
        "1F3FB": {
          unified: "1F647-1F3FB-200D-2640-FE0F",
          non_qualified: "1F647-1F3FB-200D-2640",
          image: "1f647-1f3fb-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 27,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F647-1F3FC-200D-2640-FE0F",
          non_qualified: "1F647-1F3FC-200D-2640",
          image: "1f647-1f3fc-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F647-1F3FD-200D-2640-FE0F",
          non_qualified: "1F647-1F3FD-200D-2640",
          image: "1f647-1f3fd-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 29,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F647-1F3FE-200D-2640-FE0F",
          non_qualified: "1F647-1F3FE-200D-2640",
          image: "1f647-1f3fe-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F647-1F3FF-200D-2640-FE0F",
          non_qualified: "1F647-1F3FF-200D-2640",
          image: "1f647-1f3ff-200d-2640-fe0f.png",
          sheet_x: 32,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Bowing",
      b: "1F647-200D-2640-FE0F",
      c: "1F647-200D-2640",
      k: [32, 26],
      o: 4
    },
    mag_right: {
      a: "Right-Pointing Magnifying Glass",
      b: "1F50E",
      j: ["search", "zoom", "find", "detective"],
      k: [27, 42],
      o: 2
    },
    japanese_goblin: {
      a: "Japanese Goblin",
      b: "1F47A",
      j: [
        "red",
        "evil",
        "mask",
        "monster",
        "scary",
        "creepy",
        "japanese",
        "goblin"
      ],
      k: [23, 35],
      o: 2
    },
    scooter: { a: "Scooter", b: "1F6F4", k: [36, 53], o: 4 },
    bee: { a: "Honeybee", b: "1F41D", k: [12, 1], n: ["honeybee"], o: 2 },
    "flag-gn": { a: "Guinea Flag", b: "1F1EC-1F1F3", k: [2, 7], o: 2 },
    candle: {
      a: "Candle",
      b: "1F56F-FE0F",
      c: "1F56F",
      j: ["fire", "wax"],
      k: [29, 6],
      o: 2
    },
    skateboard: { a: "Skateboard", b: "1F6F9", k: [37, 1], o: 11 },
    ghost: {
      a: "Ghost",
      b: "1F47B",
      j: ["halloween", "spooky", "scary"],
      k: [23, 36],
      o: 2
    },
    beetle: {
      a: "Lady Beetle",
      b: "1F41E",
      j: ["animal", "insect", "nature", "ladybug"],
      k: [12, 2],
      o: 2
    },
    face_palm: {
      skin_variations: {
        "1F3FB": {
          unified: "1F926-1F3FB",
          non_qualified: null,
          image: "1f926-1f3fb.png",
          sheet_x: 38,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F926-1F3FC",
          non_qualified: null,
          image: "1f926-1f3fc.png",
          sheet_x: 38,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F926-1F3FD",
          non_qualified: null,
          image: "1f926-1f3fd.png",
          sheet_x: 38,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F926-1F3FE",
          non_qualified: null,
          image: "1f926-1f3fe.png",
          sheet_x: 38,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F926-1F3FF",
          non_qualified: null,
          image: "1f926-1f3ff.png",
          sheet_x: 38,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      a: "Face Palm",
      b: "1F926",
      k: [38, 35],
      o: 4
    },
    "flag-gp": { a: "Guadeloupe Flag", b: "1F1EC-1F1F5", k: [2, 8], o: 2 },
    baby_bottle: {
      a: "Baby Bottle",
      b: "1F37C",
      j: ["food", "container", "milk"],
      k: [7, 27],
      o: 2
    },
    infinity: { a: "Infinity", b: "267E-FE0F", c: "267E", k: [53, 39], o: 11 },
    glass_of_milk: { a: "Glass of Milk", b: "1F95B", k: [41, 42], o: 4 },
    "man-facepalming": {
      skin_variations: {
        "1F3FB": {
          unified: "1F926-1F3FB-200D-2642-FE0F",
          non_qualified: "1F926-1F3FB-200D-2642",
          image: "1f926-1f3fb-200d-2642-fe0f.png",
          sheet_x: 38,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F926-1F3FC-200D-2642-FE0F",
          non_qualified: "1F926-1F3FC-200D-2642",
          image: "1f926-1f3fc-200d-2642-fe0f.png",
          sheet_x: 38,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F926-1F3FD-200D-2642-FE0F",
          non_qualified: "1F926-1F3FD-200D-2642",
          image: "1f926-1f3fd-200d-2642-fe0f.png",
          sheet_x: 38,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F926-1F3FE-200D-2642-FE0F",
          non_qualified: "1F926-1F3FE-200D-2642",
          image: "1f926-1f3fe-200d-2642-fe0f.png",
          sheet_x: 38,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F926-1F3FF-200D-2642-FE0F",
          non_qualified: "1F926-1F3FF-200D-2642",
          image: "1f926-1f3ff-200d-2642-fe0f.png",
          sheet_x: 38,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Facepalming",
      b: "1F926-200D-2642-FE0F",
      c: "1F926-200D-2642",
      k: [38, 29],
      o: 4
    },
    cricket: { a: "Cricket", b: "1F997", j: ["sports"], k: [42, 41], o: 5 },
    busstop: {
      a: "Bus Stop",
      b: "1F68F",
      j: ["transportation", "wait"],
      k: [34, 14],
      o: 2
    },
    "flag-gq": {
      a: "Equatorial Guinea Flag",
      b: "1F1EC-1F1F6",
      k: [2, 9],
      o: 2
    },
    alien: {
      a: "Extraterrestrial Alien",
      b: "1F47D",
      j: ["UFO", "paul", "weird", "outer_space"],
      k: [23, 43],
      o: 2
    },
    bulb: {
      a: "Electric Light Bulb",
      b: "1F4A1",
      j: ["light", "electricity", "idea"],
      k: [25, 43],
      o: 2
    },
    "woman-facepalming": {
      skin_variations: {
        "1F3FB": {
          unified: "1F926-1F3FB-200D-2640-FE0F",
          non_qualified: "1F926-1F3FB-200D-2640",
          image: "1f926-1f3fb-200d-2640-fe0f.png",
          sheet_x: 38,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F926-1F3FC-200D-2640-FE0F",
          non_qualified: "1F926-1F3FC-200D-2640",
          image: "1f926-1f3fc-200d-2640-fe0f.png",
          sheet_x: 38,
          sheet_y: 25,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F926-1F3FD-200D-2640-FE0F",
          non_qualified: "1F926-1F3FD-200D-2640",
          image: "1f926-1f3fd-200d-2640-fe0f.png",
          sheet_x: 38,
          sheet_y: 26,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F926-1F3FE-200D-2640-FE0F",
          non_qualified: "1F926-1F3FE-200D-2640",
          image: "1f926-1f3fe-200d-2640-fe0f.png",
          sheet_x: 38,
          sheet_y: 27,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F926-1F3FF-200D-2640-FE0F",
          non_qualified: "1F926-1F3FF-200D-2640",
          image: "1f926-1f3ff-200d-2640-fe0f.png",
          sheet_x: 38,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Facepalming",
      b: "1F926-200D-2640-FE0F",
      c: "1F926-200D-2640",
      k: [38, 23],
      o: 4
    },
    spider: {
      a: "Spider",
      b: "1F577-FE0F",
      c: "1F577",
      j: ["animal", "arachnid"],
      k: [29, 34],
      o: 2
    },
    space_invader: {
      a: "Alien Monster",
      b: "1F47E",
      j: ["game", "arcade", "play"],
      k: [23, 44],
      o: 2
    },
    motorway: {
      a: "Motorway",
      b: "1F6E3-FE0F",
      c: "1F6E3",
      j: ["road", "cupertino", "interstate", "highway"],
      k: [36, 45],
      o: 2
    },
    "flag-gr": { a: "Greece Flag", b: "1F1EC-1F1F7", k: [2, 10], o: 2 },
    recycle: {
      a: "Black Universal Recycling Symbol",
      b: "267B-FE0F",
      c: "267B",
      j: ["arrow", "environment", "garbage", "trash"],
      k: [53, 38],
      o: 2
    },
    coffee: {
      a: "Hot Beverage",
      b: "2615",
      j: ["beverage", "caffeine", "latte", "espresso"],
      k: [53, 0],
      o: 2
    },
    flashlight: {
      a: "Electric Torch",
      b: "1F526",
      j: ["dark", "camping", "sight", "night"],
      k: [28, 9],
      o: 2
    },
    spider_web: {
      a: "Spider Web",
      b: "1F578-FE0F",
      c: "1F578",
      j: ["animal", "insect", "arachnid", "silk"],
      k: [29, 35],
      o: 2
    },
    izakaya_lantern: {
      a: "Izakaya Lantern",
      b: "1F3EE",
      j: ["light", "paper", "halloween", "spooky"],
      k: [11, 8],
      n: ["lantern"],
      o: 2
    },
    "flag-gs": {
      a: "South Georgia & South Sandwich Islands Flag",
      b: "1F1EC-1F1F8",
      k: [2, 11],
      o: 2
    },
    shrug: {
      skin_variations: {
        "1F3FB": {
          unified: "1F937-1F3FB",
          non_qualified: null,
          image: "1f937-1f3fb.png",
          sheet_x: 39,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F937-1F3FC",
          non_qualified: null,
          image: "1f937-1f3fc.png",
          sheet_x: 39,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F937-1F3FD",
          non_qualified: null,
          image: "1f937-1f3fd.png",
          sheet_x: 39,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F937-1F3FE",
          non_qualified: null,
          image: "1f937-1f3fe.png",
          sheet_x: 39,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F937-1F3FF",
          non_qualified: null,
          image: "1f937-1f3ff.png",
          sheet_x: 39,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      a: "Shrug",
      b: "1F937",
      k: [39, 47],
      o: 4
    },
    fleur_de_lis: {
      a: "Fleur De Lis",
      b: "269C-FE0F",
      c: "269C",
      j: ["decorative", "scout"],
      k: [53, 49],
      o: 2
    },
    robot_face: { a: "Robot Face", b: "1F916", k: [37, 29], o: 2 },
    railway_track: {
      a: "Railway Track",
      b: "1F6E4-FE0F",
      c: "1F6E4",
      j: ["train", "transportation"],
      k: [36, 46],
      o: 2
    },
    tea: {
      a: "Teacup Without Handle",
      b: "1F375",
      j: ["drink", "bowl", "breakfast", "green", "british"],
      k: [7, 20],
      o: 2
    },
    "flag-gt": { a: "Guatemala Flag", b: "1F1EC-1F1F9", k: [2, 12], o: 2 },
    oil_drum: {
      a: "Oil Drum",
      b: "1F6E2-FE0F",
      c: "1F6E2",
      j: ["barrell"],
      k: [36, 44],
      o: 2
    },
    diya_lamp: { a: "Diya Lamp", b: "1FA94", k: [52, 8], o: 12 },
    sake: {
      a: "Sake Bottle and Cup",
      b: "1F376",
      j: ["wine", "drink", "drunk", "beverage", "japanese", "alcohol", "booze"],
      k: [7, 21],
      o: 2
    },
    trident: {
      a: "Trident Emblem",
      b: "1F531",
      j: ["weapon", "spear"],
      k: [28, 20],
      o: 2
    },
    "man-shrugging": {
      skin_variations: {
        "1F3FB": {
          unified: "1F937-1F3FB-200D-2642-FE0F",
          non_qualified: "1F937-1F3FB-200D-2642",
          image: "1f937-1f3fb-200d-2642-fe0f.png",
          sheet_x: 39,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F937-1F3FC-200D-2642-FE0F",
          non_qualified: "1F937-1F3FC-200D-2642",
          image: "1f937-1f3fc-200d-2642-fe0f.png",
          sheet_x: 39,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F937-1F3FD-200D-2642-FE0F",
          non_qualified: "1F937-1F3FD-200D-2642",
          image: "1f937-1f3fd-200d-2642-fe0f.png",
          sheet_x: 39,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F937-1F3FE-200D-2642-FE0F",
          non_qualified: "1F937-1F3FE-200D-2642",
          image: "1f937-1f3fe-200d-2642-fe0f.png",
          sheet_x: 39,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F937-1F3FF-200D-2642-FE0F",
          non_qualified: "1F937-1F3FF-200D-2642",
          image: "1f937-1f3ff-200d-2642-fe0f.png",
          sheet_x: 39,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Shrugging",
      b: "1F937-200D-2642-FE0F",
      c: "1F937-200D-2642",
      k: [39, 41],
      o: 4
    },
    smiley_cat: {
      a: "Smiling Cat Face with Open Mouth",
      b: "1F63A",
      j: ["animal", "cats", "happy", "smile"],
      k: [31, 36],
      o: 2
    },
    scorpion: {
      a: "Scorpion",
      b: "1F982",
      j: ["animal", "arachnid"],
      k: [42, 20],
      o: 2
    },
    "woman-shrugging": {
      skin_variations: {
        "1F3FB": {
          unified: "1F937-1F3FB-200D-2640-FE0F",
          non_qualified: "1F937-1F3FB-200D-2640",
          image: "1f937-1f3fb-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F937-1F3FC-200D-2640-FE0F",
          non_qualified: "1F937-1F3FC-200D-2640",
          image: "1f937-1f3fc-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F937-1F3FD-200D-2640-FE0F",
          non_qualified: "1F937-1F3FD-200D-2640",
          image: "1f937-1f3fd-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F937-1F3FE-200D-2640-FE0F",
          non_qualified: "1F937-1F3FE-200D-2640",
          image: "1f937-1f3fe-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F937-1F3FF-200D-2640-FE0F",
          non_qualified: "1F937-1F3FF-200D-2640",
          image: "1f937-1f3ff-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Shrugging",
      b: "1F937-200D-2640-FE0F",
      c: "1F937-200D-2640",
      k: [39, 35],
      o: 4
    },
    notebook_with_decorative_cover: {
      a: "Notebook with Decorative Cover",
      b: "1F4D4",
      j: ["classroom", "notes", "record", "paper", "study"],
      k: [26, 42],
      o: 2
    },
    fuelpump: {
      a: "Fuel Pump",
      b: "26FD",
      j: ["gas station", "petroleum"],
      k: [54, 38],
      o: 2
    },
    name_badge: {
      a: "Name Badge",
      b: "1F4DB",
      j: ["fire", "forbid"],
      k: [26, 49],
      o: 2
    },
    mosquito: { a: "Mosquito", b: "1F99F", k: [42, 49], o: 11 },
    "flag-gu": { a: "Guam Flag", b: "1F1EC-1F1FA", k: [2, 13], o: 2 },
    smile_cat: {
      a: "Grinning Cat Face with Smiling Eyes",
      b: "1F638",
      j: ["animal", "cats", "smile"],
      k: [31, 34],
      o: 2
    },
    champagne: {
      a: "Bottle with Popping Cork",
      b: "1F37E",
      j: ["drink", "wine", "bottle", "celebration"],
      k: [7, 29],
      o: 2
    },
    joy_cat: {
      a: "Cat Face with Tears of Joy",
      b: "1F639",
      j: ["animal", "cats", "haha", "happy", "tears"],
      k: [31, 35],
      o: 2
    },
    closed_book: {
      a: "Closed Book",
      b: "1F4D5",
      j: ["read", "library", "knowledge", "textbook", "learn"],
      k: [26, 43],
      o: 2
    },
    health_worker: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-2695-FE0F",
          non_qualified: "1F9D1-1F3FB-200D-2695",
          image: "1f9d1-1f3fb-200d-2695-fe0f.png",
          sheet_x: 47,
          sheet_y: 50,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-2695-FE0F",
          non_qualified: "1F9D1-1F3FC-200D-2695",
          image: "1f9d1-1f3fc-200d-2695-fe0f.png",
          sheet_x: 47,
          sheet_y: 51,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-2695-FE0F",
          non_qualified: "1F9D1-1F3FD-200D-2695",
          image: "1f9d1-1f3fd-200d-2695-fe0f.png",
          sheet_x: 47,
          sheet_y: 52,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-2695-FE0F",
          non_qualified: "1F9D1-1F3FE-200D-2695",
          image: "1f9d1-1f3fe-200d-2695-fe0f.png",
          sheet_x: 47,
          sheet_y: 53,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-2695-FE0F",
          non_qualified: "1F9D1-1F3FF-200D-2695",
          image: "1f9d1-1f3ff-200d-2695-fe0f.png",
          sheet_x: 47,
          sheet_y: 54,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Health Worker",
      b: "1F9D1-200D-2695-FE0F",
      c: "1F9D1-200D-2695",
      k: [47, 49],
      o: 12
    },
    rotating_light: {
      a: "Police Cars Revolving Light",
      b: "1F6A8",
      j: [
        "police",
        "ambulance",
        "911",
        "emergency",
        "alert",
        "error",
        "pinged",
        "law",
        "legal"
      ],
      k: [34, 56],
      o: 2
    },
    microbe: { a: "Microbe", b: "1F9A0", k: [42, 50], o: 11 },
    "flag-gw": { a: "Guinea-Bissau Flag", b: "1F1EC-1F1FC", k: [2, 14], o: 2 },
    wine_glass: {
      a: "Wine Glass",
      b: "1F377",
      j: ["drink", "beverage", "drunk", "alcohol", "booze"],
      k: [7, 22],
      o: 2
    },
    beginner: {
      a: "Japanese Symbol for Beginner",
      b: "1F530",
      j: ["badge", "shield"],
      k: [28, 19],
      o: 2
    },
    bouquet: {
      a: "Bouquet",
      b: "1F490",
      j: ["flowers", "nature", "spring"],
      k: [25, 26],
      o: 2
    },
    heart_eyes_cat: {
      a: "Smiling Cat Face with Heart-Shaped Eyes",
      b: "1F63B",
      j: ["animal", "love", "like", "affection", "cats", "valentines", "heart"],
      k: [31, 37],
      o: 2
    },
    "male-doctor": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-2695-FE0F",
          non_qualified: "1F468-1F3FB-200D-2695",
          image: "1f468-1f3fb-200d-2695-fe0f.png",
          sheet_x: 17,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-2695-FE0F",
          non_qualified: "1F468-1F3FC-200D-2695",
          image: "1f468-1f3fc-200d-2695-fe0f.png",
          sheet_x: 17,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-2695-FE0F",
          non_qualified: "1F468-1F3FD-200D-2695",
          image: "1f468-1f3fd-200d-2695-fe0f.png",
          sheet_x: 17,
          sheet_y: 5,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-2695-FE0F",
          non_qualified: "1F468-1F3FE-200D-2695",
          image: "1f468-1f3fe-200d-2695-fe0f.png",
          sheet_x: 17,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-2695-FE0F",
          non_qualified: "1F468-1F3FF-200D-2695",
          image: "1f468-1f3ff-200d-2695-fe0f.png",
          sheet_x: 17,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Doctor",
      b: "1F468-200D-2695-FE0F",
      c: "1F468-200D-2695",
      k: [17, 2],
      o: 4
    },
    book: { a: "Open Book", b: "1F4D6", k: [26, 44], n: ["open_book"], o: 2 },
    traffic_light: {
      a: "Horizontal Traffic Light",
      b: "1F6A5",
      j: ["transportation", "signal"],
      k: [34, 53],
      o: 2
    },
    cocktail: {
      a: "Cocktail Glass",
      b: "1F378",
      j: ["drink", "drunk", "alcohol", "beverage", "booze", "mojito"],
      k: [7, 23],
      o: 2
    },
    o: {
      a: "Heavy Large Circle",
      b: "2B55",
      j: ["circle", "round"],
      k: [55, 43],
      o: 2
    },
    "flag-gy": { a: "Guyana Flag", b: "1F1EC-1F1FE", k: [2, 15], o: 2 },
    "female-doctor": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-2695-FE0F",
          non_qualified: "1F469-1F3FB-200D-2695",
          image: "1f469-1f3fb-200d-2695-fe0f.png",
          sheet_x: 19,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-2695-FE0F",
          non_qualified: "1F469-1F3FC-200D-2695",
          image: "1f469-1f3fc-200d-2695-fe0f.png",
          sheet_x: 19,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-2695-FE0F",
          non_qualified: "1F469-1F3FD-200D-2695",
          image: "1f469-1f3fd-200d-2695-fe0f.png",
          sheet_x: 19,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-2695-FE0F",
          non_qualified: "1F469-1F3FE-200D-2695",
          image: "1f469-1f3fe-200d-2695-fe0f.png",
          sheet_x: 19,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-2695-FE0F",
          non_qualified: "1F469-1F3FF-200D-2695",
          image: "1f469-1f3ff-200d-2695-fe0f.png",
          sheet_x: 19,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Doctor",
      b: "1F469-200D-2695-FE0F",
      c: "1F469-200D-2695",
      k: [19, 44],
      o: 4
    },
    smirk_cat: {
      a: "Cat Face with Wry Smile",
      b: "1F63C",
      j: ["animal", "cats", "smirk"],
      k: [31, 38],
      o: 2
    },
    green_book: {
      a: "Green Book",
      b: "1F4D7",
      j: ["read", "library", "knowledge", "study"],
      k: [26, 45],
      o: 2
    },
    cherry_blossom: {
      a: "Cherry Blossom",
      b: "1F338",
      j: ["nature", "plant", "spring", "flower"],
      k: [6, 16],
      o: 2
    },
    "flag-hk": {
      a: "Hong Kong Sar China Flag",
      b: "1F1ED-1F1F0",
      k: [2, 16],
      o: 2
    },
    vertical_traffic_light: {
      a: "Vertical Traffic Light",
      b: "1F6A6",
      j: ["transportation", "driving"],
      k: [34, 54],
      o: 2
    },
    white_check_mark: {
      a: "White Heavy Check Mark",
      b: "2705",
      j: ["green-square", "ok", "agree", "vote", "election", "answer", "tick"],
      k: [54, 40],
      o: 2
    },
    tropical_drink: {
      a: "Tropical Drink",
      b: "1F379",
      j: [
        "beverage",
        "cocktail",
        "summer",
        "beach",
        "alcohol",
        "booze",
        "mojito"
      ],
      k: [7, 24],
      o: 2
    },
    kissing_cat: {
      a: "Kissing Cat Face with Closed Eyes",
      b: "1F63D",
      j: ["animal", "cats", "kiss"],
      k: [31, 39],
      o: 2
    },
    "flag-hm": {
      a: "Heard & Mcdonald Islands Flag",
      b: "1F1ED-1F1F2",
      k: [2, 17],
      o: 2
    },
    octagonal_sign: { a: "Octagonal Sign", b: "1F6D1", k: [36, 39], o: 4 },
    white_flower: {
      a: "White Flower",
      b: "1F4AE",
      j: ["japanese", "spring"],
      k: [26, 4],
      o: 2
    },
    ballot_box_with_check: {
      a: "Ballot Box with Check",
      b: "2611-FE0F",
      c: "2611",
      j: [
        "ok",
        "agree",
        "confirm",
        "black-square",
        "vote",
        "election",
        "yes",
        "tick"
      ],
      k: [52, 55],
      o: 2
    },
    student: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F393",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f393.png",
          sheet_x: 45,
          sheet_y: 30,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F393",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f393.png",
          sheet_x: 45,
          sheet_y: 31,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F393",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f393.png",
          sheet_x: 45,
          sheet_y: 32,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F393",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f393.png",
          sheet_x: 45,
          sheet_y: 33,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F393",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f393.png",
          sheet_x: 45,
          sheet_y: 34,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Student",
      b: "1F9D1-200D-1F393",
      k: [45, 29],
      o: 12
    },
    blue_book: {
      a: "Blue Book",
      b: "1F4D8",
      j: ["read", "library", "knowledge", "learn", "study"],
      k: [26, 46],
      o: 2
    },
    beer: {
      a: "Beer Mug",
      b: "1F37A",
      j: [
        "relax",
        "beverage",
        "drink",
        "drunk",
        "party",
        "pub",
        "summer",
        "alcohol",
        "booze"
      ],
      k: [7, 25],
      o: 2
    },
    construction: {
      a: "Construction Sign",
      b: "1F6A7",
      j: ["wip", "progress", "caution", "warning"],
      k: [34, 55],
      o: 2
    },
    rosette: {
      a: "Rosette",
      b: "1F3F5-FE0F",
      c: "1F3F5",
      j: ["flower", "decoration", "military"],
      k: [11, 18],
      o: 2
    },
    heavy_check_mark: {
      a: "Heavy Check Mark",
      b: "2714-FE0F",
      c: "2714",
      j: ["ok", "nike", "answer", "yes", "tick"],
      k: [55, 12],
      o: 2
    },
    scream_cat: {
      a: "Weary Cat Face",
      b: "1F640",
      j: ["animal", "cats", "munch", "scared", "scream"],
      k: [31, 42],
      o: 2
    },
    orange_book: {
      a: "Orange Book",
      b: "1F4D9",
      j: ["read", "library", "knowledge", "textbook", "study"],
      k: [26, 47],
      o: 2
    },
    beers: {
      a: "Clinking Beer Mugs",
      b: "1F37B",
      j: [
        "relax",
        "beverage",
        "drink",
        "drunk",
        "party",
        "pub",
        "summer",
        "alcohol",
        "booze"
      ],
      k: [7, 26],
      o: 2
    },
    "male-student": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F393",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f393.png",
          sheet_x: 14,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F393",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f393.png",
          sheet_x: 14,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F393",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f393.png",
          sheet_x: 14,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F393",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f393.png",
          sheet_x: 14,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F393",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f393.png",
          sheet_x: 14,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Student",
      b: "1F468-200D-1F393",
      k: [14, 50],
      o: 4
    },
    "flag-hn": { a: "Honduras Flag", b: "1F1ED-1F1F3", k: [2, 18], o: 2 },
    crying_cat_face: {
      a: "Crying Cat Face",
      b: "1F63F",
      j: ["animal", "tears", "weep", "sad", "cats", "upset", "cry"],
      k: [31, 41],
      o: 2
    },
    anchor: {
      a: "Anchor",
      b: "2693",
      j: ["ship", "ferry", "sea", "boat"],
      k: [53, 42],
      o: 2
    },
    "flag-hr": { a: "Croatia Flag", b: "1F1ED-1F1F7", k: [2, 19], o: 2 },
    heavy_multiplication_x: {
      a: "Heavy Multiplication X",
      b: "2716-FE0F",
      c: "2716",
      j: ["math", "calculation"],
      k: [55, 13],
      o: 2
    },
    "female-student": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F393",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f393.png",
          sheet_x: 17,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F393",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f393.png",
          sheet_x: 17,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F393",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f393.png",
          sheet_x: 17,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F393",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f393.png",
          sheet_x: 17,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F393",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f393.png",
          sheet_x: 17,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Student",
      b: "1F469-200D-1F393",
      k: [17, 40],
      o: 4
    },
    rose: {
      a: "Rose",
      b: "1F339",
      j: ["flowers", "valentines", "love", "spring"],
      k: [6, 17],
      o: 2
    },
    books: {
      a: "Books",
      b: "1F4DA",
      j: ["literature", "library", "study"],
      k: [26, 48],
      o: 2
    },
    clinking_glasses: {
      a: "Clinking Glasses",
      b: "1F942",
      j: ["beverage", "drink", "party", "alcohol", "celebrate", "cheers"],
      k: [41, 18],
      o: 4
    },
    teacher: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F3EB",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f3eb.png",
          sheet_x: 45,
          sheet_y: 48,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F3EB",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f3eb.png",
          sheet_x: 45,
          sheet_y: 49,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F3EB",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f3eb.png",
          sheet_x: 45,
          sheet_y: 50,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F3EB",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f3eb.png",
          sheet_x: 45,
          sheet_y: 51,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F3EB",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f3eb.png",
          sheet_x: 45,
          sheet_y: 52,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Teacher",
      b: "1F9D1-200D-1F3EB",
      k: [45, 47],
      o: 12
    },
    x: {
      a: "Cross Mark",
      b: "274C",
      j: ["no", "delete", "remove", "cancel"],
      k: [55, 21],
      o: 2
    },
    pouting_cat: {
      a: "Pouting Cat Face",
      b: "1F63E",
      j: ["animal", "cats"],
      k: [31, 40],
      o: 2
    },
    wilted_flower: {
      a: "Wilted Flower",
      b: "1F940",
      j: ["plant", "nature", "flower"],
      k: [41, 16],
      o: 4
    },
    boat: { a: "Sailboat", b: "26F5", k: [54, 16], n: ["sailboat"], o: 2 },
    "flag-ht": { a: "Haiti Flag", b: "1F1ED-1F1F9", k: [2, 20], o: 2 },
    tumbler_glass: {
      a: "Tumbler Glass",
      b: "1F943",
      j: [
        "drink",
        "beverage",
        "drunk",
        "alcohol",
        "liquor",
        "booze",
        "bourbon",
        "scotch",
        "whisky",
        "glass",
        "shot"
      ],
      k: [41, 19],
      o: 4
    },
    notebook: {
      a: "Notebook",
      b: "1F4D3",
      j: ["stationery", "record", "notes", "paper", "study"],
      k: [26, 41],
      o: 2
    },
    "male-teacher": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F3EB",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f3eb.png",
          sheet_x: 15,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F3EB",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f3eb.png",
          sheet_x: 15,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F3EB",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f3eb.png",
          sheet_x: 15,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F3EB",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f3eb.png",
          sheet_x: 15,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F3EB",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f3eb.png",
          sheet_x: 15,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Teacher",
      b: "1F468-200D-1F3EB",
      k: [15, 11],
      o: 4
    },
    ledger: {
      a: "Ledger",
      b: "1F4D2",
      j: ["notes", "paper"],
      k: [26, 40],
      o: 2
    },
    "flag-hu": { a: "Hungary Flag", b: "1F1ED-1F1FA", k: [2, 21], o: 2 },
    cup_with_straw: { a: "Cup with Straw", b: "1F964", k: [41, 51], o: 5 },
    hibiscus: {
      a: "Hibiscus",
      b: "1F33A",
      j: ["plant", "vegetable", "flowers", "beach"],
      k: [6, 18],
      o: 2
    },
    see_no_evil: {
      a: "See-No-Evil Monkey",
      b: "1F648",
      j: ["monkey", "animal", "nature", "haha"],
      k: [32, 44],
      o: 2
    },
    canoe: {
      a: "Canoe",
      b: "1F6F6",
      j: ["boat", "paddle", "water", "ship"],
      k: [36, 55],
      o: 4
    },
    negative_squared_cross_mark: {
      a: "Negative Squared Cross Mark",
      b: "274E",
      j: ["x", "green-square", "no", "deny"],
      k: [55, 22],
      o: 2
    },
    "flag-ic": { a: "Canary Islands Flag", b: "1F1EE-1F1E8", k: [2, 22], o: 2 },
    beverage_box: { a: "Beverage Box", b: "1F9C3", k: [44, 11], o: 12 },
    speedboat: {
      a: "Speedboat",
      b: "1F6A4",
      j: ["ship", "transportation", "vehicle", "summer"],
      k: [34, 52],
      o: 2
    },
    heavy_plus_sign: {
      a: "Heavy Plus Sign",
      b: "2795",
      j: ["math", "calculation", "addition", "more", "increase"],
      k: [55, 29],
      o: 2
    },
    sunflower: {
      a: "Sunflower",
      b: "1F33B",
      j: ["nature", "plant", "fall"],
      k: [6, 19],
      o: 2
    },
    page_with_curl: {
      a: "Page with Curl",
      b: "1F4C3",
      j: ["documents", "office", "paper"],
      k: [26, 25],
      o: 2
    },
    "female-teacher": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F3EB",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f3eb.png",
          sheet_x: 18,
          sheet_y: 2,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F3EB",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f3eb.png",
          sheet_x: 18,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F3EB",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f3eb.png",
          sheet_x: 18,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F3EB",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f3eb.png",
          sheet_x: 18,
          sheet_y: 5,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F3EB",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f3eb.png",
          sheet_x: 18,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Teacher",
      b: "1F469-200D-1F3EB",
      k: [18, 1],
      o: 4
    },
    hear_no_evil: {
      a: "Hear-No-Evil Monkey",
      b: "1F649",
      j: ["animal", "monkey", "nature"],
      k: [32, 45],
      o: 2
    },
    mate_drink: { a: "Mate Drink", b: "1F9C9", k: [44, 17], o: 12 },
    passenger_ship: {
      a: "Passenger Ship",
      b: "1F6F3-FE0F",
      c: "1F6F3",
      j: ["yacht", "cruise", "ferry"],
      k: [36, 52],
      o: 2
    },
    judge: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-2696-FE0F",
          non_qualified: "1F9D1-1F3FB-200D-2696",
          image: "1f9d1-1f3fb-200d-2696-fe0f.png",
          sheet_x: 47,
          sheet_y: 56,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-2696-FE0F",
          non_qualified: "1F9D1-1F3FC-200D-2696",
          image: "1f9d1-1f3fc-200d-2696-fe0f.png",
          sheet_x: 48,
          sheet_y: 0,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-2696-FE0F",
          non_qualified: "1F9D1-1F3FD-200D-2696",
          image: "1f9d1-1f3fd-200d-2696-fe0f.png",
          sheet_x: 48,
          sheet_y: 1,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-2696-FE0F",
          non_qualified: "1F9D1-1F3FE-200D-2696",
          image: "1f9d1-1f3fe-200d-2696-fe0f.png",
          sheet_x: 48,
          sheet_y: 2,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-2696-FE0F",
          non_qualified: "1F9D1-1F3FF-200D-2696",
          image: "1f9d1-1f3ff-200d-2696-fe0f.png",
          sheet_x: 48,
          sheet_y: 3,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Judge",
      b: "1F9D1-200D-2696-FE0F",
      c: "1F9D1-200D-2696",
      k: [47, 55],
      o: 12
    },
    scroll: {
      a: "Scroll",
      b: "1F4DC",
      j: ["documents", "ancient", "history", "paper"],
      k: [26, 50],
      o: 2
    },
    blossom: {
      a: "Blossom",
      b: "1F33C",
      j: ["nature", "flowers", "yellow"],
      k: [6, 20],
      o: 2
    },
    "flag-id": { a: "Indonesia Flag", b: "1F1EE-1F1E9", k: [2, 23], o: 2 },
    speak_no_evil: {
      a: "Speak-No-Evil Monkey",
      b: "1F64A",
      j: ["monkey", "animal", "nature", "omg"],
      k: [32, 46],
      o: 2
    },
    heavy_minus_sign: {
      a: "Heavy Minus Sign",
      b: "2796",
      j: ["math", "calculation", "subtract", "less"],
      k: [55, 30],
      o: 2
    },
    "flag-ie": { a: "Ireland Flag", b: "1F1EE-1F1EA", k: [2, 24], o: 2 },
    ice_cube: { a: "Ice Cube", b: "1F9CA", k: [44, 18], o: 12 },
    page_facing_up: {
      a: "Page Facing Up",
      b: "1F4C4",
      j: ["documents", "office", "paper", "information"],
      k: [26, 26],
      o: 2
    },
    "male-judge": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-2696-FE0F",
          non_qualified: "1F468-1F3FB-200D-2696",
          image: "1f468-1f3fb-200d-2696-fe0f.png",
          sheet_x: 17,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-2696-FE0F",
          non_qualified: "1F468-1F3FC-200D-2696",
          image: "1f468-1f3fc-200d-2696-fe0f.png",
          sheet_x: 17,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-2696-FE0F",
          non_qualified: "1F468-1F3FD-200D-2696",
          image: "1f468-1f3fd-200d-2696-fe0f.png",
          sheet_x: 17,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-2696-FE0F",
          non_qualified: "1F468-1F3FE-200D-2696",
          image: "1f468-1f3fe-200d-2696-fe0f.png",
          sheet_x: 17,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-2696-FE0F",
          non_qualified: "1F468-1F3FF-200D-2696",
          image: "1f468-1f3ff-200d-2696-fe0f.png",
          sheet_x: 17,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Judge",
      b: "1F468-200D-2696-FE0F",
      c: "1F468-200D-2696",
      k: [17, 8],
      o: 4
    },
    tulip: {
      a: "Tulip",
      b: "1F337",
      j: ["flowers", "plant", "nature", "summer", "spring"],
      k: [6, 15],
      o: 2
    },
    ferry: {
      a: "Ferry",
      b: "26F4-FE0F",
      c: "26F4",
      j: ["boat", "ship", "yacht"],
      k: [54, 15],
      o: 2
    },
    kiss: {
      a: "Kiss Mark",
      b: "1F48B",
      j: ["face", "lips", "love", "like", "affection", "valentines"],
      k: [25, 21],
      o: 2
    },
    heavy_division_sign: {
      a: "Heavy Division Sign",
      b: "2797",
      j: ["divide", "math", "calculation"],
      k: [55, 31],
      o: 2
    },
    newspaper: {
      a: "Newspaper",
      b: "1F4F0",
      j: ["press", "headline"],
      k: [27, 13],
      o: 2
    },
    "female-judge": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-2696-FE0F",
          non_qualified: "1F469-1F3FB-200D-2696",
          image: "1f469-1f3fb-200d-2696-fe0f.png",
          sheet_x: 19,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-2696-FE0F",
          non_qualified: "1F469-1F3FC-200D-2696",
          image: "1f469-1f3fc-200d-2696-fe0f.png",
          sheet_x: 19,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-2696-FE0F",
          non_qualified: "1F469-1F3FD-200D-2696",
          image: "1f469-1f3fd-200d-2696-fe0f.png",
          sheet_x: 19,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-2696-FE0F",
          non_qualified: "1F469-1F3FE-200D-2696",
          image: "1f469-1f3fe-200d-2696-fe0f.png",
          sheet_x: 19,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-2696-FE0F",
          non_qualified: "1F469-1F3FF-200D-2696",
          image: "1f469-1f3ff-200d-2696-fe0f.png",
          sheet_x: 19,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Judge",
      b: "1F469-200D-2696-FE0F",
      c: "1F469-200D-2696",
      k: [19, 50],
      o: 4
    },
    seedling: {
      a: "Seedling",
      b: "1F331",
      j: ["plant", "nature", "grass", "lawn", "spring"],
      k: [6, 9],
      o: 2
    },
    love_letter: {
      a: "Love Letter",
      b: "1F48C",
      j: ["email", "like", "affection", "envelope", "valentines"],
      k: [25, 22],
      o: 2
    },
    chopsticks: { a: "Chopsticks", b: "1F962", k: [41, 49], o: 5 },
    motor_boat: {
      a: "Motor Boat",
      b: "1F6E5-FE0F",
      c: "1F6E5",
      j: ["ship"],
      k: [36, 47],
      o: 2
    },
    "flag-il": { a: "Israel Flag", b: "1F1EE-1F1F1", k: [2, 25], o: 2 },
    curly_loop: {
      a: "Curly Loop",
      b: "27B0",
      j: ["scribble", "draw", "shape", "squiggle"],
      k: [55, 33],
      o: 2
    },
    "flag-im": { a: "Isle of Man Flag", b: "1F1EE-1F1F2", k: [2, 26], o: 2 },
    evergreen_tree: {
      a: "Evergreen Tree",
      b: "1F332",
      j: ["plant", "nature"],
      k: [6, 10],
      o: 2
    },
    cupid: {
      a: "Heart with Arrow",
      b: "1F498",
      j: ["love", "like", "heart", "affection", "valentines"],
      k: [25, 34],
      o: 2
    },
    loop: {
      a: "Double Curly Loop",
      b: "27BF",
      j: ["tape", "cassette"],
      k: [55, 34],
      o: 2
    },
    ship: {
      a: "Ship",
      b: "1F6A2",
      j: ["transportation", "titanic", "deploy"],
      k: [34, 33],
      o: 2
    },
    farmer: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F33E",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f33e.png",
          sheet_x: 45,
          sheet_y: 18,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F33E",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f33e.png",
          sheet_x: 45,
          sheet_y: 19,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F33E",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f33e.png",
          sheet_x: 45,
          sheet_y: 20,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F33E",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f33e.png",
          sheet_x: 45,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F33E",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f33e.png",
          sheet_x: 45,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Farmer",
      b: "1F9D1-200D-1F33E",
      k: [45, 17],
      o: 12
    },
    rolled_up_newspaper: {
      a: "Rolled Up Newspaper",
      b: "1F5DE-FE0F",
      c: "1F5DE",
      k: [30, 23],
      o: 2
    },
    knife_fork_plate: {
      a: "Knife Fork Plate",
      b: "1F37D-FE0F",
      c: "1F37D",
      k: [7, 28],
      o: 2
    },
    fork_and_knife: {
      a: "Fork and Knife",
      b: "1F374",
      j: ["cutlery", "kitchen"],
      k: [7, 19],
      o: 2
    },
    "male-farmer": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F33E",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f33e.png",
          sheet_x: 14,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F33E",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f33e.png",
          sheet_x: 14,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F33E",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f33e.png",
          sheet_x: 14,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F33E",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f33e.png",
          sheet_x: 14,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F33E",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f33e.png",
          sheet_x: 14,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Farmer",
      b: "1F468-200D-1F33E",
      k: [14, 38],
      o: 4
    },
    bookmark_tabs: {
      a: "Bookmark Tabs",
      b: "1F4D1",
      j: ["favorite", "save", "order", "tidy"],
      k: [26, 39],
      o: 2
    },
    part_alternation_mark: {
      a: "Part Alternation Mark",
      b: "303D-FE0F",
      c: "303D",
      j: ["graph", "presentation", "stats", "business", "economics", "bad"],
      k: [55, 45],
      o: 2
    },
    "flag-in": { a: "India Flag", b: "1F1EE-1F1F3", k: [2, 27], o: 2 },
    gift_heart: {
      a: "Heart with Ribbon",
      b: "1F49D",
      j: ["love", "valentines"],
      k: [25, 39],
      o: 2
    },
    airplane: {
      a: "Airplane",
      b: "2708-FE0F",
      c: "2708",
      j: ["vehicle", "transportation", "flight", "fly"],
      k: [54, 41],
      o: 2
    },
    deciduous_tree: {
      a: "Deciduous Tree",
      b: "1F333",
      j: ["plant", "nature"],
      k: [6, 11],
      o: 2
    },
    spoon: {
      a: "Spoon",
      b: "1F944",
      j: ["cutlery", "kitchen", "tableware"],
      k: [41, 20],
      o: 4
    },
    "flag-io": {
      a: "British Indian Ocean Territory Flag",
      b: "1F1EE-1F1F4",
      k: [2, 28],
      o: 2
    },
    palm_tree: {
      a: "Palm Tree",
      b: "1F334",
      j: [
        "plant",
        "vegetable",
        "nature",
        "summer",
        "beach",
        "mojito",
        "tropical"
      ],
      k: [6, 12],
      o: 2
    },
    sparkling_heart: {
      a: "Sparkling Heart",
      b: "1F496",
      j: ["love", "like", "affection", "valentines"],
      k: [25, 32],
      o: 2
    },
    "female-farmer": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F33E",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f33e.png",
          sheet_x: 17,
          sheet_y: 29,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F33E",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f33e.png",
          sheet_x: 17,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F33E",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f33e.png",
          sheet_x: 17,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F33E",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f33e.png",
          sheet_x: 17,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F33E",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f33e.png",
          sheet_x: 17,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Farmer",
      b: "1F469-200D-1F33E",
      k: [17, 28],
      o: 4
    },
    eight_spoked_asterisk: {
      a: "Eight Spoked Asterisk",
      b: "2733-FE0F",
      c: "2733",
      j: ["star", "sparkle", "green-square"],
      k: [55, 17],
      o: 2
    },
    small_airplane: {
      a: "Small Airplane",
      b: "1F6E9-FE0F",
      c: "1F6E9",
      j: ["flight", "transportation", "fly", "vehicle"],
      k: [36, 48],
      o: 2
    },
    bookmark: {
      a: "Bookmark",
      b: "1F516",
      j: ["favorite", "label", "save"],
      k: [27, 50],
      o: 2
    },
    cook: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F373",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f373.png",
          sheet_x: 45,
          sheet_y: 24,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F373",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f373.png",
          sheet_x: 45,
          sheet_y: 25,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F373",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f373.png",
          sheet_x: 45,
          sheet_y: 26,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F373",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f373.png",
          sheet_x: 45,
          sheet_y: 27,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F373",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f373.png",
          sheet_x: 45,
          sheet_y: 28,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Cook",
      b: "1F9D1-200D-1F373",
      k: [45, 23],
      o: 12
    },
    eight_pointed_black_star: {
      a: "Eight Pointed Black Star",
      b: "2734-FE0F",
      c: "2734",
      j: ["orange-square", "shape", "polygon"],
      k: [55, 18],
      o: 2
    },
    heartpulse: {
      a: "Growing Heart",
      b: "1F497",
      j: ["like", "love", "affection", "valentines", "pink"],
      k: [25, 33],
      o: 2
    },
    label: {
      a: "Label",
      b: "1F3F7-FE0F",
      c: "1F3F7",
      j: ["sale", "tag"],
      k: [11, 19],
      o: 2
    },
    "flag-iq": { a: "Iraq Flag", b: "1F1EE-1F1F6", k: [2, 29], o: 2 },
    hocho: {
      a: "Hocho",
      b: "1F52A",
      j: ["knife", "blade", "cutlery", "kitchen", "weapon"],
      k: [28, 13],
      n: ["knife"],
      o: 2
    },
    cactus: {
      a: "Cactus",
      b: "1F335",
      j: ["vegetable", "plant", "nature"],
      k: [6, 13],
      o: 2
    },
    airplane_departure: {
      a: "Airplane Departure",
      b: "1F6EB",
      k: [36, 49],
      o: 2
    },
    airplane_arriving: {
      a: "Airplane Arriving",
      b: "1F6EC",
      k: [36, 50],
      o: 2
    },
    ear_of_rice: {
      a: "Ear of Rice",
      b: "1F33E",
      j: ["nature", "plant"],
      k: [6, 22],
      o: 2
    },
    "flag-ir": { a: "Iran Flag", b: "1F1EE-1F1F7", k: [2, 30], o: 2 },
    moneybag: {
      a: "Money Bag",
      b: "1F4B0",
      j: ["dollar", "payment", "coins", "sale"],
      k: [26, 6],
      o: 2
    },
    "male-cook": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F373",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f373.png",
          sheet_x: 14,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F373",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f373.png",
          sheet_x: 14,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F373",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f373.png",
          sheet_x: 14,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F373",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f373.png",
          sheet_x: 14,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F373",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f373.png",
          sheet_x: 14,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Cook",
      b: "1F468-200D-1F373",
      k: [14, 44],
      o: 4
    },
    heartbeat: {
      a: "Beating Heart",
      b: "1F493",
      j: ["love", "like", "affection", "valentines", "pink", "heart"],
      k: [25, 29],
      o: 2
    },
    sparkle: {
      a: "Sparkle",
      b: "2747-FE0F",
      c: "2747",
      j: ["stars", "green-square", "awesome", "good", "fireworks"],
      k: [55, 20],
      o: 2
    },
    amphora: {
      a: "Amphora",
      b: "1F3FA",
      j: ["vase", "jar"],
      k: [11, 22],
      o: 2
    },
    yen: {
      a: "Banknote with Yen Sign",
      b: "1F4B4",
      j: ["money", "sales", "japanese", "dollar", "currency"],
      k: [26, 10],
      o: 2
    },
    revolving_hearts: {
      a: "Revolving Hearts",
      b: "1F49E",
      j: ["love", "like", "affection", "valentines"],
      k: [25, 40],
      o: 2
    },
    bangbang: {
      a: "Double Exclamation Mark",
      b: "203C-FE0F",
      c: "203C",
      j: ["exclamation", "surprise"],
      k: [52, 10],
      o: 2
    },
    parachute: { a: "Parachute", b: "1FA82", k: [52, 3], o: 12 },
    herb: {
      a: "Herb",
      b: "1F33F",
      j: ["vegetable", "plant", "medicine", "weed", "grass", "lawn"],
      k: [6, 23],
      o: 2
    },
    "flag-is": { a: "Iceland Flag", b: "1F1EE-1F1F8", k: [2, 31], o: 2 },
    "female-cook": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F373",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f373.png",
          sheet_x: 17,
          sheet_y: 35,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F373",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f373.png",
          sheet_x: 17,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F373",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f373.png",
          sheet_x: 17,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F373",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f373.png",
          sheet_x: 17,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F373",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f373.png",
          sheet_x: 17,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Cook",
      b: "1F469-200D-1F373",
      k: [17, 34],
      o: 4
    },
    mechanic: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F527",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f527.png",
          sheet_x: 46,
          sheet_y: 15,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F527",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f527.png",
          sheet_x: 46,
          sheet_y: 16,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F527",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f527.png",
          sheet_x: 46,
          sheet_y: 17,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F527",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f527.png",
          sheet_x: 46,
          sheet_y: 18,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F527",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f527.png",
          sheet_x: 46,
          sheet_y: 19,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Mechanic",
      b: "1F9D1-200D-1F527",
      k: [46, 14],
      o: 12
    },
    interrobang: {
      a: "Exclamation Question Mark",
      b: "2049-FE0F",
      c: "2049",
      j: ["wat", "punctuation", "surprise"],
      k: [52, 11],
      o: 2
    },
    seat: {
      a: "Seat",
      b: "1F4BA",
      j: ["sit", "airplane", "transport", "bus", "flight", "fly"],
      k: [26, 16],
      o: 2
    },
    dollar: {
      a: "Banknote with Dollar Sign",
      b: "1F4B5",
      j: ["money", "sales", "bill", "currency"],
      k: [26, 11],
      o: 2
    },
    two_hearts: {
      a: "Two Hearts",
      b: "1F495",
      j: ["love", "like", "affection", "valentines", "heart"],
      k: [25, 31],
      o: 2
    },
    it: {
      a: "Italy Flag",
      b: "1F1EE-1F1F9",
      j: ["italy", "flag", "nation", "country", "banner"],
      k: [2, 32],
      n: ["flag-it"],
      o: 2
    },
    shamrock: {
      a: "Shamrock",
      b: "2618-FE0F",
      c: "2618",
      j: ["vegetable", "plant", "nature", "irish", "clover"],
      k: [53, 1],
      o: 2
    },
    four_leaf_clover: {
      a: "Four Leaf Clover",
      b: "1F340",
      j: ["vegetable", "plant", "nature", "lucky", "irish"],
      k: [6, 24],
      o: 2
    },
    euro: {
      a: "Banknote with Euro Sign",
      b: "1F4B6",
      j: ["money", "sales", "dollar", "currency"],
      k: [26, 12],
      o: 2
    },
    question: {
      a: "Black Question Mark Ornament",
      b: "2753",
      j: ["doubt", "confused"],
      k: [55, 23],
      o: 2
    },
    helicopter: {
      a: "Helicopter",
      b: "1F681",
      j: ["transportation", "vehicle", "fly"],
      k: [34, 0],
      o: 2
    },
    heart_decoration: {
      a: "Heart Decoration",
      b: "1F49F",
      j: ["purple-square", "love", "like"],
      k: [25, 41],
      o: 2
    },
    "flag-je": { a: "Jersey Flag", b: "1F1EF-1F1EA", k: [2, 33], o: 2 },
    "male-mechanic": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F527",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f527.png",
          sheet_x: 15,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F527",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f527.png",
          sheet_x: 15,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F527",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f527.png",
          sheet_x: 15,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F527",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f527.png",
          sheet_x: 15,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F527",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f527.png",
          sheet_x: 15,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Mechanic",
      b: "1F468-200D-1F527",
      k: [15, 50],
      o: 4
    },
    suspension_railway: {
      a: "Suspension Railway",
      b: "1F69F",
      j: ["vehicle", "transportation"],
      k: [34, 30],
      o: 2
    },
    heavy_heart_exclamation_mark_ornament: {
      a: "Heavy Heart Exclamation Mark Ornament",
      b: "2763-FE0F",
      c: "2763",
      k: [55, 27],
      o: 2
    },
    "female-mechanic": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F527",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f527.png",
          sheet_x: 18,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F527",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f527.png",
          sheet_x: 18,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F527",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f527.png",
          sheet_x: 18,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F527",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f527.png",
          sheet_x: 18,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F527",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f527.png",
          sheet_x: 18,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Mechanic",
      b: "1F469-200D-1F527",
      k: [18, 35],
      o: 4
    },
    "flag-jm": { a: "Jamaica Flag", b: "1F1EF-1F1F2", k: [2, 34], o: 2 },
    grey_question: {
      a: "White Question Mark Ornament",
      b: "2754",
      j: ["doubts", "gray", "huh", "confused"],
      k: [55, 24],
      o: 2
    },
    maple_leaf: {
      a: "Maple Leaf",
      b: "1F341",
      j: ["nature", "plant", "vegetable", "ca", "fall"],
      k: [6, 25],
      o: 2
    },
    pound: {
      a: "Banknote with Pound Sign",
      b: "1F4B7",
      j: [
        "british",
        "sterling",
        "money",
        "sales",
        "bills",
        "uk",
        "england",
        "currency"
      ],
      k: [26, 13],
      o: 2
    },
    money_with_wings: {
      a: "Money with Wings",
      b: "1F4B8",
      j: ["dollar", "bills", "payment", "sale"],
      k: [26, 14],
      o: 2
    },
    "flag-jo": { a: "Jordan Flag", b: "1F1EF-1F1F4", k: [2, 35], o: 2 },
    fallen_leaf: {
      a: "Fallen Leaf",
      b: "1F342",
      j: ["nature", "plant", "vegetable", "leaves"],
      k: [6, 26],
      o: 2
    },
    factory_worker: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F3ED",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f3ed.png",
          sheet_x: 45,
          sheet_y: 54,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F3ED",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f3ed.png",
          sheet_x: 45,
          sheet_y: 55,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F3ED",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f3ed.png",
          sheet_x: 45,
          sheet_y: 56,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F3ED",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f3ed.png",
          sheet_x: 46,
          sheet_y: 0,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F3ED",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f3ed.png",
          sheet_x: 46,
          sheet_y: 1,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Factory Worker",
      b: "1F9D1-200D-1F3ED",
      k: [45, 53],
      o: 12
    },
    broken_heart: {
      a: "Broken Heart",
      b: "1F494",
      j: ["sad", "sorry", "break", "heart", "heartbreak"],
      k: [25, 30],
      l: ["</3"],
      m: "</3",
      o: 2
    },
    grey_exclamation: {
      a: "White Exclamation Mark Ornament",
      b: "2755",
      j: ["surprise", "punctuation", "gray", "wow", "warning"],
      k: [55, 25],
      o: 2
    },
    mountain_cableway: {
      a: "Mountain Cableway",
      b: "1F6A0",
      j: ["transportation", "vehicle", "ski"],
      k: [34, 31],
      o: 2
    },
    exclamation: {
      a: "Heavy Exclamation Mark Symbol",
      b: "2757",
      j: [
        "heavy_exclamation_mark",
        "danger",
        "surprise",
        "punctuation",
        "wow",
        "warning"
      ],
      k: [55, 26],
      n: ["heavy_exclamation_mark"],
      o: 2
    },
    leaves: {
      a: "Leaf Fluttering in Wind",
      b: "1F343",
      j: ["nature", "plant", "tree", "vegetable", "grass", "lawn", "spring"],
      k: [6, 27],
      o: 2
    },
    heart: {
      a: "Heavy Black Heart",
      b: "2764-FE0F",
      c: "2764",
      j: ["love", "like", "valentines"],
      k: [55, 28],
      l: ["<3"],
      m: "<3",
      o: 2
    },
    jp: {
      a: "Japan Flag",
      b: "1F1EF-1F1F5",
      j: ["japanese", "nation", "flag", "country", "banner"],
      k: [2, 36],
      n: ["flag-jp"],
      o: 2
    },
    "male-factory-worker": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F3ED",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f3ed.png",
          sheet_x: 15,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F3ED",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f3ed.png",
          sheet_x: 15,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F3ED",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f3ed.png",
          sheet_x: 15,
          sheet_y: 20,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F3ED",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f3ed.png",
          sheet_x: 15,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F3ED",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f3ed.png",
          sheet_x: 15,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Factory Worker",
      b: "1F468-200D-1F3ED",
      k: [15, 17],
      o: 4
    },
    credit_card: {
      a: "Credit Card",
      b: "1F4B3",
      j: ["money", "sales", "dollar", "bill", "payment", "shopping"],
      k: [26, 9],
      o: 2
    },
    aerial_tramway: {
      a: "Aerial Tramway",
      b: "1F6A1",
      j: ["transportation", "vehicle", "ski"],
      k: [34, 32],
      o: 2
    },
    "female-factory-worker": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F3ED",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f3ed.png",
          sheet_x: 18,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F3ED",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f3ed.png",
          sheet_x: 18,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F3ED",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f3ed.png",
          sheet_x: 18,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F3ED",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f3ed.png",
          sheet_x: 18,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F3ED",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f3ed.png",
          sheet_x: 18,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Factory Worker",
      b: "1F469-200D-1F3ED",
      k: [18, 7],
      o: 4
    },
    receipt: { a: "Receipt", b: "1F9FE", k: [51, 49], o: 11 },
    wavy_dash: {
      a: "Wavy Dash",
      b: "3030-FE0F",
      c: "3030",
      j: ["draw", "line", "moustache", "mustache", "squiggle", "scribble"],
      k: [55, 44],
      o: 2
    },
    "flag-ke": { a: "Kenya Flag", b: "1F1F0-1F1EA", k: [2, 37], o: 2 },
    satellite: {
      a: "Satellite",
      b: "1F6F0-FE0F",
      c: "1F6F0",
      j: ["communication", "future", "radio", "space"],
      k: [36, 51],
      o: 2
    },
    orange_heart: { a: "Orange Heart", b: "1F9E1", k: [51, 20], o: 5 },
    yellow_heart: {
      a: "Yellow Heart",
      b: "1F49B",
      j: ["love", "like", "affection", "valentines"],
      k: [25, 37],
      m: "<3",
      o: 2
    },
    copyright: {
      a: "Copyright Sign",
      b: "00A9-FE0F",
      c: "00A9",
      j: ["ip", "license", "circle", "law", "legal"],
      k: [0, 12],
      o: 2
    },
    rocket: {
      a: "Rocket",
      b: "1F680",
      j: [
        "launch",
        "ship",
        "staffmode",
        "NASA",
        "outer space",
        "outer_space",
        "fly"
      ],
      k: [33, 56],
      o: 2
    },
    chart: {
      a: "Chart with Upwards Trend and Yen Sign",
      b: "1F4B9",
      j: ["green-square", "graph", "presentation", "stats"],
      k: [26, 15],
      o: 2
    },
    "flag-kg": { a: "Kyrgyzstan Flag", b: "1F1F0-1F1EC", k: [2, 38], o: 2 },
    office_worker: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F4BC",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f4bc.png",
          sheet_x: 46,
          sheet_y: 9,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F4BC",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f4bc.png",
          sheet_x: 46,
          sheet_y: 10,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F4BC",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f4bc.png",
          sheet_x: 46,
          sheet_y: 11,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F4BC",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f4bc.png",
          sheet_x: 46,
          sheet_y: 12,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F4BC",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f4bc.png",
          sheet_x: 46,
          sheet_y: 13,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Office Worker",
      b: "1F9D1-200D-1F4BC",
      k: [46, 8],
      o: 12
    },
    currency_exchange: {
      a: "Currency Exchange",
      b: "1F4B1",
      j: ["money", "sales", "dollar", "travel"],
      k: [26, 7],
      o: 2
    },
    registered: {
      a: "Registered Sign",
      b: "00AE-FE0F",
      c: "00AE",
      j: ["alphabet", "circle"],
      k: [0, 13],
      o: 2
    },
    green_heart: {
      a: "Green Heart",
      b: "1F49A",
      j: ["love", "like", "affection", "valentines"],
      k: [25, 36],
      m: "<3",
      o: 2
    },
    flying_saucer: { a: "Flying Saucer", b: "1F6F8", k: [37, 0], o: 5 },
    "flag-kh": { a: "Cambodia Flag", b: "1F1F0-1F1ED", k: [2, 39], o: 2 },
    "male-office-worker": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F4BC",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f4bc.png",
          sheet_x: 15,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F4BC",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f4bc.png",
          sheet_x: 15,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F4BC",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f4bc.png",
          sheet_x: 15,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F4BC",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f4bc.png",
          sheet_x: 15,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F4BC",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f4bc.png",
          sheet_x: 15,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Office Worker",
      b: "1F468-200D-1F4BC",
      k: [15, 44],
      o: 4
    },
    tm: {
      a: "Trade Mark Sign",
      b: "2122-FE0F",
      c: "2122",
      j: ["trademark", "brand", "law", "legal"],
      k: [52, 12],
      o: 2
    },
    bellhop_bell: {
      a: "Bellhop Bell",
      b: "1F6CE-FE0F",
      c: "1F6CE",
      j: ["service"],
      k: [36, 36],
      o: 2
    },
    blue_heart: {
      a: "Blue Heart",
      b: "1F499",
      j: ["love", "like", "affection", "valentines"],
      k: [25, 35],
      m: "<3",
      o: 2
    },
    "flag-ki": { a: "Kiribati Flag", b: "1F1F0-1F1EE", k: [2, 40], o: 2 },
    heavy_dollar_sign: {
      a: "Heavy Dollar Sign",
      b: "1F4B2",
      j: ["money", "sales", "payment", "currency", "buck"],
      k: [26, 8],
      o: 2
    },
    "female-office-worker": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F4BC",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f4bc.png",
          sheet_x: 18,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F4BC",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f4bc.png",
          sheet_x: 18,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F4BC",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f4bc.png",
          sheet_x: 18,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F4BC",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f4bc.png",
          sheet_x: 18,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F4BC",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f4bc.png",
          sheet_x: 18,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Office Worker",
      b: "1F469-200D-1F4BC",
      k: [18, 29],
      o: 4
    },
    purple_heart: {
      a: "Purple Heart",
      b: "1F49C",
      j: ["love", "like", "affection", "valentines"],
      k: [25, 38],
      m: "<3",
      o: 2
    },
    scientist: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F52C",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f52c.png",
          sheet_x: 46,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F52C",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f52c.png",
          sheet_x: 46,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F52C",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f52c.png",
          sheet_x: 46,
          sheet_y: 23,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F52C",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f52c.png",
          sheet_x: 46,
          sheet_y: 24,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F52C",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f52c.png",
          sheet_x: 46,
          sheet_y: 25,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Scientist",
      b: "1F9D1-200D-1F52C",
      k: [46, 20],
      o: 12
    },
    luggage: { a: "Luggage", b: "1F9F3", k: [51, 38], o: 11 },
    hash: {
      a: "Hash Key",
      b: "0023-FE0F-20E3",
      c: "0023-20E3",
      j: ["symbol", "blue-square", "twitter"],
      k: [0, 0],
      o: 0
    },
    "flag-km": { a: "Comoros Flag", b: "1F1F0-1F1F2", k: [2, 41], o: 2 },
    email: {
      a: "Envelope",
      b: "2709-FE0F",
      c: "2709",
      j: ["letter", "postal", "inbox", "communication"],
      k: [54, 42],
      n: ["envelope"],
      o: 2
    },
    "e-mail": {
      a: "E-Mail Symbol",
      b: "1F4E7",
      j: ["communication", "inbox"],
      k: [27, 4],
      o: 2
    },
    keycap_star: {
      a: "Keycap Star",
      b: "002A-FE0F-20E3",
      c: "002A-20E3",
      k: [0, 1],
      o: 0
    },
    "flag-kn": {
      a: "St. Kitts & Nevis Flag",
      b: "1F1F0-1F1F3",
      k: [2, 42],
      o: 2
    },
    hourglass: {
      a: "Hourglass",
      b: "231B",
      j: ["time", "clock", "oldschool", "limit", "exam", "quiz", "test"],
      k: [52, 23],
      o: 2
    },
    brown_heart: { a: "Brown Heart", b: "1F90E", k: [37, 16], o: 12 },
    "male-scientist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F52C",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f52c.png",
          sheet_x: 16,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F52C",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f52c.png",
          sheet_x: 16,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F52C",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f52c.png",
          sheet_x: 16,
          sheet_y: 2,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F52C",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f52c.png",
          sheet_x: 16,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F52C",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f52c.png",
          sheet_x: 16,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Scientist",
      b: "1F468-200D-1F52C",
      k: [15, 56],
      o: 4
    },
    hourglass_flowing_sand: {
      a: "Hourglass with Flowing Sand",
      b: "23F3",
      j: ["oldschool", "time", "countdown"],
      k: [52, 36],
      o: 2
    },
    black_heart: {
      a: "Black Heart",
      b: "1F5A4",
      j: ["evil"],
      k: [30, 9],
      o: 4
    },
    zero: {
      a: "Keycap 0",
      b: "0030-FE0F-20E3",
      c: "0030-20E3",
      j: ["0", "numbers", "blue-square", "null"],
      k: [0, 2],
      o: 0
    },
    incoming_envelope: {
      a: "Incoming Envelope",
      b: "1F4E8",
      j: ["email", "inbox"],
      k: [27, 5],
      o: 2
    },
    "flag-kp": { a: "North Korea Flag", b: "1F1F0-1F1F5", k: [2, 43], o: 2 },
    "female-scientist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F52C",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f52c.png",
          sheet_x: 18,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F52C",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f52c.png",
          sheet_x: 18,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F52C",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f52c.png",
          sheet_x: 18,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F52C",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f52c.png",
          sheet_x: 18,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F52C",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f52c.png",
          sheet_x: 18,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Scientist",
      b: "1F469-200D-1F52C",
      k: [18, 41],
      o: 4
    },
    watch: {
      a: "Watch",
      b: "231A",
      j: ["time", "accessories"],
      k: [52, 22],
      o: 2
    },
    white_heart: { a: "White Heart", b: "1F90D", k: [37, 15], o: 12 },
    one: {
      a: "Keycap 1",
      b: "0031-FE0F-20E3",
      c: "0031-20E3",
      j: ["blue-square", "numbers", "1"],
      k: [0, 3],
      o: 0
    },
    kr: {
      a: "South Korea Flag",
      b: "1F1F0-1F1F7",
      j: ["south", "korea", "nation", "flag", "country", "banner"],
      k: [2, 44],
      n: ["flag-kr"],
      o: 2
    },
    envelope_with_arrow: {
      a: "Envelope with Downwards Arrow Above",
      b: "1F4E9",
      j: ["email", "communication"],
      k: [27, 6],
      o: 2
    },
    technologist: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F4BB",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f4bb.png",
          sheet_x: 46,
          sheet_y: 3,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F4BB",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f4bb.png",
          sheet_x: 46,
          sheet_y: 4,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F4BB",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f4bb.png",
          sheet_x: 46,
          sheet_y: 5,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F4BB",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f4bb.png",
          sheet_x: 46,
          sheet_y: 6,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F4BB",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f4bb.png",
          sheet_x: 46,
          sheet_y: 7,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Technologist",
      b: "1F9D1-200D-1F4BB",
      k: [46, 2],
      o: 12
    },
    outbox_tray: {
      a: "Outbox Tray",
      b: "1F4E4",
      j: ["inbox", "email"],
      k: [27, 1],
      o: 2
    },
    "male-technologist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F4BB",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f4bb.png",
          sheet_x: 15,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F4BB",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f4bb.png",
          sheet_x: 15,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F4BB",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f4bb.png",
          sheet_x: 15,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F4BB",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f4bb.png",
          sheet_x: 15,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F4BB",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f4bb.png",
          sheet_x: 15,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Technologist",
      b: "1F468-200D-1F4BB",
      k: [15, 38],
      o: 4
    },
    alarm_clock: {
      a: "Alarm Clock",
      b: "23F0",
      j: ["time", "wake"],
      k: [52, 33],
      o: 2
    },
    "flag-kw": { a: "Kuwait Flag", b: "1F1F0-1F1FC", k: [2, 45], o: 2 },
    two: {
      a: "Keycap 2",
      b: "0032-FE0F-20E3",
      c: "0032-20E3",
      j: ["numbers", "2", "prime", "blue-square"],
      k: [0, 4],
      o: 0
    },
    anger: {
      a: "Anger Symbol",
      b: "1F4A2",
      j: ["angry", "mad"],
      k: [25, 44],
      o: 2
    },
    inbox_tray: {
      a: "Inbox Tray",
      b: "1F4E5",
      j: ["email", "documents"],
      k: [27, 2],
      o: 2
    },
    three: {
      a: "Keycap 3",
      b: "0033-FE0F-20E3",
      c: "0033-20E3",
      j: ["3", "numbers", "prime", "blue-square"],
      k: [0, 5],
      o: 0
    },
    "flag-ky": { a: "Cayman Islands Flag", b: "1F1F0-1F1FE", k: [2, 46], o: 2 },
    stopwatch: {
      a: "Stopwatch",
      b: "23F1-FE0F",
      c: "23F1",
      j: ["time", "deadline"],
      k: [52, 34],
      o: 2
    },
    "female-technologist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F4BB",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f4bb.png",
          sheet_x: 18,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F4BB",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f4bb.png",
          sheet_x: 18,
          sheet_y: 25,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F4BB",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f4bb.png",
          sheet_x: 18,
          sheet_y: 26,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F4BB",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f4bb.png",
          sheet_x: 18,
          sheet_y: 27,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F4BB",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f4bb.png",
          sheet_x: 18,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Technologist",
      b: "1F469-200D-1F4BB",
      k: [18, 23],
      o: 4
    },
    boom: {
      a: "Collision Symbol",
      b: "1F4A5",
      j: ["bomb", "explode", "explosion", "collision", "blown"],
      k: [25, 47],
      n: ["collision"],
      o: 2
    },
    "flag-kz": { a: "Kazakhstan Flag", b: "1F1F0-1F1FF", k: [2, 47], o: 2 },
    four: {
      a: "Keycap 4",
      b: "0034-FE0F-20E3",
      c: "0034-20E3",
      j: ["4", "numbers", "blue-square"],
      k: [0, 6],
      o: 0
    },
    timer_clock: {
      a: "Timer Clock",
      b: "23F2-FE0F",
      c: "23F2",
      j: ["alarm"],
      k: [52, 35],
      o: 2
    },
    singer: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F3A4",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f3a4.png",
          sheet_x: 45,
          sheet_y: 36,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F3A4",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f3a4.png",
          sheet_x: 45,
          sheet_y: 37,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F3A4",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f3a4.png",
          sheet_x: 45,
          sheet_y: 38,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F3A4",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f3a4.png",
          sheet_x: 45,
          sheet_y: 39,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F3A4",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f3a4.png",
          sheet_x: 45,
          sheet_y: 40,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Singer",
      b: "1F9D1-200D-1F3A4",
      k: [45, 35],
      o: 12
    },
    package: {
      a: "Package",
      b: "1F4E6",
      j: ["mail", "gift", "cardboard", "box", "moving"],
      k: [27, 3],
      o: 2
    },
    mailbox: {
      a: "Closed Mailbox with Raised Flag",
      b: "1F4EB",
      j: ["email", "inbox", "communication"],
      k: [27, 8],
      o: 2
    },
    "flag-la": { a: "Laos Flag", b: "1F1F1-1F1E6", k: [2, 48], o: 2 },
    dizzy: {
      a: "Dizzy Symbol",
      b: "1F4AB",
      j: ["star", "sparkle", "shoot", "magic"],
      k: [26, 1],
      o: 2
    },
    five: {
      a: "Keycap 5",
      b: "0035-FE0F-20E3",
      c: "0035-20E3",
      j: ["5", "numbers", "blue-square", "prime"],
      k: [0, 7],
      o: 0
    },
    "male-singer": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F3A4",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f3a4.png",
          sheet_x: 15,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F3A4",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f3a4.png",
          sheet_x: 15,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F3A4",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f3a4.png",
          sheet_x: 15,
          sheet_y: 2,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F3A4",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f3a4.png",
          sheet_x: 15,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F3A4",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f3a4.png",
          sheet_x: 15,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Singer",
      b: "1F468-200D-1F3A4",
      k: [14, 56],
      o: 4
    },
    mantelpiece_clock: {
      a: "Mantelpiece Clock",
      b: "1F570-FE0F",
      c: "1F570",
      j: ["time"],
      k: [29, 7],
      o: 2
    },
    "female-singer": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F3A4",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f3a4.png",
          sheet_x: 17,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F3A4",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f3a4.png",
          sheet_x: 17,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F3A4",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f3a4.png",
          sheet_x: 17,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F3A4",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f3a4.png",
          sheet_x: 17,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F3A4",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f3a4.png",
          sheet_x: 17,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Singer",
      b: "1F469-200D-1F3A4",
      k: [17, 46],
      o: 4
    },
    "flag-lb": { a: "Lebanon Flag", b: "1F1F1-1F1E7", k: [2, 49], o: 2 },
    six: {
      a: "Keycap 6",
      b: "0036-FE0F-20E3",
      c: "0036-20E3",
      j: ["6", "numbers", "blue-square"],
      k: [0, 8],
      o: 0
    },
    mailbox_closed: {
      a: "Closed Mailbox with Lowered Flag",
      b: "1F4EA",
      j: ["email", "communication", "inbox"],
      k: [27, 7],
      o: 2
    },
    sweat_drops: {
      a: "Splashing Sweat Symbol",
      b: "1F4A6",
      j: ["water", "drip", "oops"],
      k: [25, 48],
      o: 2
    },
    clock12: {
      a: "Clock Face Twelve Oclock",
      b: "1F55B",
      j: ["time", "noon", "midnight", "midday", "late", "early", "schedule"],
      k: [28, 50],
      o: 2
    },
    seven: {
      a: "Keycap 7",
      b: "0037-FE0F-20E3",
      c: "0037-20E3",
      j: ["7", "numbers", "blue-square", "prime"],
      k: [0, 9],
      o: 0
    },
    mailbox_with_mail: {
      a: "Open Mailbox with Raised Flag",
      b: "1F4EC",
      j: ["email", "inbox", "communication"],
      k: [27, 9],
      o: 2
    },
    clock1230: {
      a: "Clock Face Twelve-Thirty",
      b: "1F567",
      j: ["time", "late", "early", "schedule"],
      k: [29, 5],
      o: 2
    },
    dash: {
      a: "Dash Symbol",
      b: "1F4A8",
      j: ["wind", "air", "fast", "shoo", "fart", "smoke", "puff"],
      k: [25, 50],
      o: 2
    },
    artist: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F3A8",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f3a8.png",
          sheet_x: 45,
          sheet_y: 42,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F3A8",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f3a8.png",
          sheet_x: 45,
          sheet_y: 43,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F3A8",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f3a8.png",
          sheet_x: 45,
          sheet_y: 44,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F3A8",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f3a8.png",
          sheet_x: 45,
          sheet_y: 45,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F3A8",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f3a8.png",
          sheet_x: 45,
          sheet_y: 46,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Artist",
      b: "1F9D1-200D-1F3A8",
      k: [45, 41],
      o: 12
    },
    "flag-lc": { a: "St. Lucia Flag", b: "1F1F1-1F1E8", k: [2, 50], o: 2 },
    hole: {
      a: "Hole",
      b: "1F573-FE0F",
      c: "1F573",
      j: ["embarrassing"],
      k: [29, 8],
      o: 2
    },
    "male-artist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F3A8",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f3a8.png",
          sheet_x: 15,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F3A8",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f3a8.png",
          sheet_x: 15,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F3A8",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f3a8.png",
          sheet_x: 15,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F3A8",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f3a8.png",
          sheet_x: 15,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F3A8",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f3a8.png",
          sheet_x: 15,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Artist",
      b: "1F468-200D-1F3A8",
      k: [15, 5],
      o: 4
    },
    clock1: {
      a: "Clock Face One Oclock",
      b: "1F550",
      j: ["time", "late", "early", "schedule"],
      k: [28, 39],
      o: 2
    },
    eight: {
      a: "Keycap 8",
      b: "0038-FE0F-20E3",
      c: "0038-20E3",
      j: ["8", "blue-square", "numbers"],
      k: [0, 10],
      o: 0
    },
    mailbox_with_no_mail: {
      a: "Open Mailbox with Lowered Flag",
      b: "1F4ED",
      j: ["email", "inbox"],
      k: [27, 10],
      o: 2
    },
    "flag-li": { a: "Liechtenstein Flag", b: "1F1F1-1F1EE", k: [2, 51], o: 2 },
    bomb: {
      a: "Bomb",
      b: "1F4A3",
      j: ["boom", "explode", "explosion", "terrorism"],
      k: [25, 45],
      o: 2
    },
    nine: {
      a: "Keycap 9",
      b: "0039-FE0F-20E3",
      c: "0039-20E3",
      j: ["blue-square", "numbers", "9"],
      k: [0, 11],
      o: 0
    },
    postbox: {
      a: "Postbox",
      b: "1F4EE",
      j: ["email", "letter", "envelope"],
      k: [27, 11],
      o: 2
    },
    "female-artist": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F3A8",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f3a8.png",
          sheet_x: 17,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F3A8",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f3a8.png",
          sheet_x: 17,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F3A8",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f3a8.png",
          sheet_x: 17,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F3A8",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f3a8.png",
          sheet_x: 17,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F3A8",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f3a8.png",
          sheet_x: 18,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Artist",
      b: "1F469-200D-1F3A8",
      k: [17, 52],
      o: 4
    },
    clock130: {
      a: "Clock Face One-Thirty",
      b: "1F55C",
      j: ["time", "late", "early", "schedule"],
      k: [28, 51],
      o: 2
    },
    "flag-lk": { a: "Sri Lanka Flag", b: "1F1F1-1F1F0", k: [2, 52], o: 2 },
    ballot_box_with_ballot: {
      a: "Ballot Box with Ballot",
      b: "1F5F3-FE0F",
      c: "1F5F3",
      k: [30, 28],
      o: 2
    },
    pilot: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-2708-FE0F",
          non_qualified: "1F9D1-1F3FB-200D-2708",
          image: "1f9d1-1f3fb-200d-2708-fe0f.png",
          sheet_x: 48,
          sheet_y: 5,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-2708-FE0F",
          non_qualified: "1F9D1-1F3FC-200D-2708",
          image: "1f9d1-1f3fc-200d-2708-fe0f.png",
          sheet_x: 48,
          sheet_y: 6,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-2708-FE0F",
          non_qualified: "1F9D1-1F3FD-200D-2708",
          image: "1f9d1-1f3fd-200d-2708-fe0f.png",
          sheet_x: 48,
          sheet_y: 7,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-2708-FE0F",
          non_qualified: "1F9D1-1F3FE-200D-2708",
          image: "1f9d1-1f3fe-200d-2708-fe0f.png",
          sheet_x: 48,
          sheet_y: 8,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-2708-FE0F",
          non_qualified: "1F9D1-1F3FF-200D-2708",
          image: "1f9d1-1f3ff-200d-2708-fe0f.png",
          sheet_x: 48,
          sheet_y: 9,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Pilot",
      b: "1F9D1-200D-2708-FE0F",
      c: "1F9D1-200D-2708",
      k: [48, 4],
      o: 12
    },
    keycap_ten: {
      a: "Keycap Ten",
      b: "1F51F",
      j: ["numbers", "10", "blue-square"],
      k: [28, 2],
      o: 2
    },
    clock2: {
      a: "Clock Face Two Oclock",
      b: "1F551",
      j: ["time", "late", "early", "schedule"],
      k: [28, 40],
      o: 2
    },
    "flag-lr": { a: "Liberia Flag", b: "1F1F1-1F1F7", k: [2, 53], o: 2 },
    speech_balloon: {
      a: "Speech Balloon",
      b: "1F4AC",
      j: ["bubble", "words", "message", "talk", "chatting"],
      k: [26, 2],
      o: 2
    },
    "eye-in-speech-bubble": {
      a: "Eye in Speech Bubble",
      b: "1F441-FE0F-200D-1F5E8-FE0F",
      k: [12, 37],
      o: 2
    },
    "flag-ls": { a: "Lesotho Flag", b: "1F1F1-1F1F8", k: [2, 54], o: 2 },
    clock230: {
      a: "Clock Face Two-Thirty",
      b: "1F55D",
      j: ["time", "late", "early", "schedule"],
      k: [28, 52],
      o: 2
    },
    "male-pilot": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-2708-FE0F",
          non_qualified: "1F468-1F3FB-200D-2708",
          image: "1f468-1f3fb-200d-2708-fe0f.png",
          sheet_x: 17,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-2708-FE0F",
          non_qualified: "1F468-1F3FC-200D-2708",
          image: "1f468-1f3fc-200d-2708-fe0f.png",
          sheet_x: 17,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-2708-FE0F",
          non_qualified: "1F468-1F3FD-200D-2708",
          image: "1f468-1f3fd-200d-2708-fe0f.png",
          sheet_x: 17,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-2708-FE0F",
          non_qualified: "1F468-1F3FE-200D-2708",
          image: "1f468-1f3fe-200d-2708-fe0f.png",
          sheet_x: 17,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-2708-FE0F",
          non_qualified: "1F468-1F3FF-200D-2708",
          image: "1f468-1f3ff-200d-2708-fe0f.png",
          sheet_x: 17,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Pilot",
      b: "1F468-200D-2708-FE0F",
      c: "1F468-200D-2708",
      k: [17, 14],
      o: 4
    },
    capital_abcd: {
      a: "Input Symbol for Latin Capital Letters",
      b: "1F520",
      j: ["alphabet", "words", "blue-square"],
      k: [28, 3],
      o: 2
    },
    pencil2: {
      a: "Pencil",
      b: "270F-FE0F",
      c: "270F",
      j: ["stationery", "write", "paper", "writing", "school", "study"],
      k: [55, 10],
      o: 2
    },
    "female-pilot": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-2708-FE0F",
          non_qualified: "1F469-1F3FB-200D-2708",
          image: "1f469-1f3fb-200d-2708-fe0f.png",
          sheet_x: 20,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-2708-FE0F",
          non_qualified: "1F469-1F3FC-200D-2708",
          image: "1f469-1f3fc-200d-2708-fe0f.png",
          sheet_x: 20,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-2708-FE0F",
          non_qualified: "1F469-1F3FD-200D-2708",
          image: "1f469-1f3fd-200d-2708-fe0f.png",
          sheet_x: 20,
          sheet_y: 2,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-2708-FE0F",
          non_qualified: "1F469-1F3FE-200D-2708",
          image: "1f469-1f3fe-200d-2708-fe0f.png",
          sheet_x: 20,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-2708-FE0F",
          non_qualified: "1F469-1F3FF-200D-2708",
          image: "1f469-1f3ff-200d-2708-fe0f.png",
          sheet_x: 20,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Pilot",
      b: "1F469-200D-2708-FE0F",
      c: "1F469-200D-2708",
      k: [19, 56],
      o: 4
    },
    black_nib: {
      a: "Black Nib",
      b: "2712-FE0F",
      c: "2712",
      j: ["pen", "stationery", "writing", "write"],
      k: [55, 11],
      o: 2
    },
    left_speech_bubble: {
      a: "Left Speech Bubble",
      b: "1F5E8-FE0F",
      c: "1F5E8",
      j: ["words", "message", "talk", "chatting"],
      k: [30, 26],
      o: 2
    },
    clock3: {
      a: "Clock Face Three Oclock",
      b: "1F552",
      j: ["time", "late", "early", "schedule"],
      k: [28, 41],
      o: 2
    },
    abcd: {
      a: "Input Symbol for Latin Small Letters",
      b: "1F521",
      j: ["blue-square", "alphabet"],
      k: [28, 4],
      o: 2
    },
    "flag-lt": { a: "Lithuania Flag", b: "1F1F1-1F1F9", k: [2, 55], o: 2 },
    clock330: {
      a: "Clock Face Three-Thirty",
      b: "1F55E",
      j: ["time", "late", "early", "schedule"],
      k: [28, 53],
      o: 2
    },
    astronaut: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F680",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f680.png",
          sheet_x: 46,
          sheet_y: 27,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F680",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f680.png",
          sheet_x: 46,
          sheet_y: 28,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F680",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f680.png",
          sheet_x: 46,
          sheet_y: 29,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F680",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f680.png",
          sheet_x: 46,
          sheet_y: 30,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F680",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f680.png",
          sheet_x: 46,
          sheet_y: 31,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Astronaut",
      b: "1F9D1-200D-1F680",
      k: [46, 26],
      o: 12
    },
    "flag-lu": { a: "Luxembourg Flag", b: "1F1F1-1F1FA", k: [2, 56], o: 2 },
    right_anger_bubble: {
      a: "Right Anger Bubble",
      b: "1F5EF-FE0F",
      c: "1F5EF",
      j: ["caption", "speech", "thinking", "mad"],
      k: [30, 27],
      o: 2
    },
    lower_left_fountain_pen: {
      a: "Lower Left Fountain Pen",
      b: "1F58B-FE0F",
      c: "1F58B",
      k: [29, 45],
      o: 2
    },
    "male-astronaut": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F680",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f680.png",
          sheet_x: 16,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F680",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f680.png",
          sheet_x: 16,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F680",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f680.png",
          sheet_x: 16,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F680",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f680.png",
          sheet_x: 16,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F680",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f680.png",
          sheet_x: 16,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Astronaut",
      b: "1F468-200D-1F680",
      k: [16, 5],
      o: 4
    },
    thought_balloon: {
      a: "Thought Balloon",
      b: "1F4AD",
      j: ["bubble", "cloud", "speech", "thinking", "dream"],
      k: [26, 3],
      o: 2
    },
    symbols: {
      a: "Input Symbol for Symbols",
      b: "1F523",
      j: [
        "blue-square",
        "music",
        "note",
        "ampersand",
        "percent",
        "glyphs",
        "characters"
      ],
      k: [28, 6],
      o: 2
    },
    clock4: {
      a: "Clock Face Four Oclock",
      b: "1F553",
      j: ["time", "late", "early", "schedule"],
      k: [28, 42],
      o: 2
    },
    "flag-lv": { a: "Latvia Flag", b: "1F1F1-1F1FB", k: [3, 0], o: 2 },
    lower_left_ballpoint_pen: {
      a: "Lower Left Ballpoint Pen",
      b: "1F58A-FE0F",
      c: "1F58A",
      k: [29, 44],
      o: 2
    },
    abc: {
      a: "Input Symbol for Latin Letters",
      b: "1F524",
      j: ["blue-square", "alphabet"],
      k: [28, 7],
      o: 2
    },
    zzz: {
      a: "Sleeping Symbol",
      b: "1F4A4",
      j: ["sleepy", "tired", "dream"],
      k: [25, 46],
      o: 2
    },
    lower_left_paintbrush: {
      a: "Lower Left Paintbrush",
      b: "1F58C-FE0F",
      c: "1F58C",
      k: [29, 46],
      o: 2
    },
    "female-astronaut": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F680",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f680.png",
          sheet_x: 18,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F680",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f680.png",
          sheet_x: 18,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F680",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f680.png",
          sheet_x: 18,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F680",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f680.png",
          sheet_x: 18,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F680",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f680.png",
          sheet_x: 18,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Astronaut",
      b: "1F469-200D-1F680",
      k: [18, 47],
      o: 4
    },
    "flag-ly": { a: "Libya Flag", b: "1F1F1-1F1FE", k: [3, 1], o: 2 },
    clock430: {
      a: "Clock Face Four-Thirty",
      b: "1F55F",
      j: ["time", "late", "early", "schedule"],
      k: [28, 54],
      o: 2
    },
    "flag-ma": { a: "Morocco Flag", b: "1F1F2-1F1E6", k: [3, 2], o: 2 },
    a: {
      a: "Negative Squared Latin Capital Letter a",
      b: "1F170-FE0F",
      c: "1F170",
      j: ["red-square", "alphabet", "letter"],
      k: [0, 16],
      o: 2
    },
    clock5: {
      a: "Clock Face Five Oclock",
      b: "1F554",
      j: ["time", "late", "early", "schedule"],
      k: [28, 43],
      o: 2
    },
    lower_left_crayon: {
      a: "Lower Left Crayon",
      b: "1F58D-FE0F",
      c: "1F58D",
      k: [29, 47],
      o: 2
    },
    firefighter: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F692",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f692.png",
          sheet_x: 46,
          sheet_y: 33,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F692",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f692.png",
          sheet_x: 46,
          sheet_y: 34,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F692",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f692.png",
          sheet_x: 46,
          sheet_y: 35,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F692",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f692.png",
          sheet_x: 46,
          sheet_y: 36,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F692",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f692.png",
          sheet_x: 46,
          sheet_y: 37,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Firefighter",
      b: "1F9D1-200D-1F692",
      k: [46, 32],
      o: 12
    },
    "male-firefighter": {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F692",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f692.png",
          sheet_x: 16,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F692",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f692.png",
          sheet_x: 16,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F692",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f692.png",
          sheet_x: 16,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F692",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f692.png",
          sheet_x: 16,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F692",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f692.png",
          sheet_x: 16,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Firefighter",
      b: "1F468-200D-1F692",
      k: [16, 11],
      o: 4
    },
    memo: {
      a: "Memo",
      b: "1F4DD",
      j: [
        "write",
        "documents",
        "stationery",
        "pencil",
        "paper",
        "writing",
        "legal",
        "exam",
        "quiz",
        "test",
        "study",
        "compose"
      ],
      k: [26, 51],
      n: ["pencil"],
      o: 2
    },
    ab: {
      a: "Negative Squared Ab",
      b: "1F18E",
      j: ["red-square", "alphabet"],
      k: [0, 20],
      o: 2
    },
    "flag-mc": { a: "Monaco Flag", b: "1F1F2-1F1E8", k: [3, 3], o: 2 },
    clock530: {
      a: "Clock Face Five-Thirty",
      b: "1F560",
      j: ["time", "late", "early", "schedule"],
      k: [28, 55],
      o: 2
    },
    briefcase: {
      a: "Briefcase",
      b: "1F4BC",
      j: ["business", "documents", "work", "law", "legal", "job", "career"],
      k: [26, 18],
      o: 2
    },
    "female-firefighter": {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F692",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f692.png",
          sheet_x: 18,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F692",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f692.png",
          sheet_x: 18,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F692",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f692.png",
          sheet_x: 18,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F692",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f692.png",
          sheet_x: 19,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F692",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f692.png",
          sheet_x: 19,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Firefighter",
      b: "1F469-200D-1F692",
      k: [18, 53],
      o: 4
    },
    clock6: {
      a: "Clock Face Six Oclock",
      b: "1F555",
      j: ["time", "late", "early", "schedule", "dawn", "dusk"],
      k: [28, 44],
      o: 2
    },
    b: {
      a: "Negative Squared Latin Capital Letter B",
      b: "1F171-FE0F",
      c: "1F171",
      j: ["red-square", "alphabet", "letter"],
      k: [0, 17],
      o: 2
    },
    "flag-md": { a: "Moldova Flag", b: "1F1F2-1F1E9", k: [3, 4], o: 2 },
    clock630: {
      a: "Clock Face Six-Thirty",
      b: "1F561",
      j: ["time", "late", "early", "schedule"],
      k: [28, 56],
      o: 2
    },
    cl: {
      a: "Squared Cl",
      b: "1F191",
      j: ["alphabet", "words", "red-square"],
      k: [0, 21],
      o: 2
    },
    "flag-me": { a: "Montenegro Flag", b: "1F1F2-1F1EA", k: [3, 5], o: 2 },
    file_folder: {
      a: "File Folder",
      b: "1F4C1",
      j: ["documents", "business", "office"],
      k: [26, 23],
      o: 2
    },
    cop: {
      skin_variations: {
        "1F3FB": {
          unified: "1F46E-1F3FB",
          non_qualified: null,
          image: "1f46e-1f3fb.png",
          sheet_x: 21,
          sheet_y: 50,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F46E-1F3FC",
          non_qualified: null,
          image: "1f46e-1f3fc.png",
          sheet_x: 21,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F46E-1F3FD",
          non_qualified: null,
          image: "1f46e-1f3fd.png",
          sheet_x: 21,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F46E-1F3FE",
          non_qualified: null,
          image: "1f46e-1f3fe.png",
          sheet_x: 21,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F46E-1F3FF",
          non_qualified: null,
          image: "1f46e-1f3ff.png",
          sheet_x: 21,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F46E-200D-2642-FE0F",
      a: "Police Officer",
      b: "1F46E",
      k: [21, 49],
      o: 2
    },
    "male-police-officer": {
      skin_variations: {
        "1F3FB": {
          unified: "1F46E-1F3FB-200D-2642-FE0F",
          non_qualified: "1F46E-1F3FB-200D-2642",
          image: "1f46e-1f3fb-200d-2642-fe0f.png",
          sheet_x: 21,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F46E-1F3FC-200D-2642-FE0F",
          non_qualified: "1F46E-1F3FC-200D-2642",
          image: "1f46e-1f3fc-200d-2642-fe0f.png",
          sheet_x: 21,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F46E-1F3FD-200D-2642-FE0F",
          non_qualified: "1F46E-1F3FD-200D-2642",
          image: "1f46e-1f3fd-200d-2642-fe0f.png",
          sheet_x: 21,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F46E-1F3FE-200D-2642-FE0F",
          non_qualified: "1F46E-1F3FE-200D-2642",
          image: "1f46e-1f3fe-200d-2642-fe0f.png",
          sheet_x: 21,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F46E-1F3FF-200D-2642-FE0F",
          non_qualified: "1F46E-1F3FF-200D-2642",
          image: "1f46e-1f3ff-200d-2642-fe0f.png",
          sheet_x: 21,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F46E",
      a: "Male Police Officer",
      b: "1F46E-200D-2642-FE0F",
      c: "1F46E-200D-2642",
      k: [21, 43],
      o: 4
    },
    cool: {
      a: "Squared Cool",
      b: "1F192",
      j: ["words", "blue-square"],
      k: [0, 22],
      o: 2
    },
    clock7: {
      a: "Clock Face Seven Oclock",
      b: "1F556",
      j: ["time", "late", "early", "schedule"],
      k: [28, 45],
      o: 2
    },
    "flag-mf": { a: "St. Martin Flag", b: "1F1F2-1F1EB", k: [3, 6], o: 2 },
    open_file_folder: {
      a: "Open File Folder",
      b: "1F4C2",
      j: ["documents", "load"],
      k: [26, 24],
      o: 2
    },
    card_index_dividers: {
      a: "Card Index Dividers",
      b: "1F5C2-FE0F",
      c: "1F5C2",
      j: ["organizing", "business", "stationery"],
      k: [30, 15],
      o: 2
    },
    "flag-mg": { a: "Madagascar Flag", b: "1F1F2-1F1EC", k: [3, 7], o: 2 },
    free: {
      a: "Squared Free",
      b: "1F193",
      j: ["blue-square", "words"],
      k: [0, 23],
      o: 2
    },
    "female-police-officer": {
      skin_variations: {
        "1F3FB": {
          unified: "1F46E-1F3FB-200D-2640-FE0F",
          non_qualified: "1F46E-1F3FB-200D-2640",
          image: "1f46e-1f3fb-200d-2640-fe0f.png",
          sheet_x: 21,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F46E-1F3FC-200D-2640-FE0F",
          non_qualified: "1F46E-1F3FC-200D-2640",
          image: "1f46e-1f3fc-200d-2640-fe0f.png",
          sheet_x: 21,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F46E-1F3FD-200D-2640-FE0F",
          non_qualified: "1F46E-1F3FD-200D-2640",
          image: "1f46e-1f3fd-200d-2640-fe0f.png",
          sheet_x: 21,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F46E-1F3FE-200D-2640-FE0F",
          non_qualified: "1F46E-1F3FE-200D-2640",
          image: "1f46e-1f3fe-200d-2640-fe0f.png",
          sheet_x: 21,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F46E-1F3FF-200D-2640-FE0F",
          non_qualified: "1F46E-1F3FF-200D-2640",
          image: "1f46e-1f3ff-200d-2640-fe0f.png",
          sheet_x: 21,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Police Officer",
      b: "1F46E-200D-2640-FE0F",
      c: "1F46E-200D-2640",
      k: [21, 37],
      o: 4
    },
    clock730: {
      a: "Clock Face Seven-Thirty",
      b: "1F562",
      j: ["time", "late", "early", "schedule"],
      k: [29, 0],
      o: 2
    },
    date: {
      a: "Calendar",
      b: "1F4C5",
      j: ["calendar", "schedule"],
      k: [26, 27],
      o: 2
    },
    clock8: {
      a: "Clock Face Eight Oclock",
      b: "1F557",
      j: ["time", "late", "early", "schedule"],
      k: [28, 46],
      o: 2
    },
    information_source: {
      a: "Information Source",
      b: "2139-FE0F",
      c: "2139",
      j: ["blue-square", "alphabet", "letter"],
      k: [52, 13],
      o: 2
    },
    sleuth_or_spy: {
      skin_variations: {
        "1F3FB": {
          unified: "1F575-1F3FB",
          non_qualified: null,
          image: "1f575-1f3fb.png",
          sheet_x: 29,
          sheet_y: 28,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F575-1F3FC",
          non_qualified: null,
          image: "1f575-1f3fc.png",
          sheet_x: 29,
          sheet_y: 29,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F575-1F3FD",
          non_qualified: null,
          image: "1f575-1f3fd.png",
          sheet_x: 29,
          sheet_y: 30,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F575-1F3FE",
          non_qualified: null,
          image: "1f575-1f3fe.png",
          sheet_x: 29,
          sheet_y: 31,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F575-1F3FF",
          non_qualified: null,
          image: "1f575-1f3ff.png",
          sheet_x: 29,
          sheet_y: 32,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F575-FE0F-200D-2642-FE0F",
      a: "Sleuth or Spy",
      b: "1F575-FE0F",
      c: "1F575",
      k: [29, 27],
      o: 2
    },
    "flag-mh": {
      a: "Marshall Islands Flag",
      b: "1F1F2-1F1ED",
      k: [3, 8],
      o: 2
    },
    clock830: {
      a: "Clock Face Eight-Thirty",
      b: "1F563",
      j: ["time", "late", "early", "schedule"],
      k: [29, 1],
      o: 2
    },
    calendar: {
      a: "Tear-off Calendar",
      b: "1F4C6",
      j: ["schedule", "date", "planning"],
      k: [26, 28],
      o: 2
    },
    "male-detective": {
      skin_variations: {
        "1F3FB": {
          unified: "1F575-1F3FB-200D-2642-FE0F",
          non_qualified: "1F575-1F3FB-200D-2642",
          image: "1f575-1f3fb-200d-2642-fe0f.png",
          sheet_x: 29,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F575-1F3FC-200D-2642-FE0F",
          non_qualified: "1F575-1F3FC-200D-2642",
          image: "1f575-1f3fc-200d-2642-fe0f.png",
          sheet_x: 29,
          sheet_y: 23,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F575-1F3FD-200D-2642-FE0F",
          non_qualified: "1F575-1F3FD-200D-2642",
          image: "1f575-1f3fd-200d-2642-fe0f.png",
          sheet_x: 29,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F575-1F3FE-200D-2642-FE0F",
          non_qualified: "1F575-1F3FE-200D-2642",
          image: "1f575-1f3fe-200d-2642-fe0f.png",
          sheet_x: 29,
          sheet_y: 25,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F575-1F3FF-200D-2642-FE0F",
          non_qualified: "1F575-1F3FF-200D-2642",
          image: "1f575-1f3ff-200d-2642-fe0f.png",
          sheet_x: 29,
          sheet_y: 26,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F575-FE0F",
      a: "Male Detective",
      b: "1F575-FE0F-200D-2642-FE0F",
      k: [29, 21],
      o: 4
    },
    "flag-mk": { a: "North Macedonia Flag", b: "1F1F2-1F1F0", k: [3, 9], o: 2 },
    id: {
      a: "Squared Id",
      b: "1F194",
      j: ["purple-square", "words"],
      k: [0, 24],
      o: 2
    },
    spiral_note_pad: {
      a: "Spiral Note Pad",
      b: "1F5D2-FE0F",
      c: "1F5D2",
      k: [30, 19],
      o: 2
    },
    "female-detective": {
      skin_variations: {
        "1F3FB": {
          unified: "1F575-1F3FB-200D-2640-FE0F",
          non_qualified: "1F575-1F3FB-200D-2640",
          image: "1f575-1f3fb-200d-2640-fe0f.png",
          sheet_x: 29,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F575-1F3FC-200D-2640-FE0F",
          non_qualified: "1F575-1F3FC-200D-2640",
          image: "1f575-1f3fc-200d-2640-fe0f.png",
          sheet_x: 29,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F575-1F3FD-200D-2640-FE0F",
          non_qualified: "1F575-1F3FD-200D-2640",
          image: "1f575-1f3fd-200d-2640-fe0f.png",
          sheet_x: 29,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F575-1F3FE-200D-2640-FE0F",
          non_qualified: "1F575-1F3FE-200D-2640",
          image: "1f575-1f3fe-200d-2640-fe0f.png",
          sheet_x: 29,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F575-1F3FF-200D-2640-FE0F",
          non_qualified: "1F575-1F3FF-200D-2640",
          image: "1f575-1f3ff-200d-2640-fe0f.png",
          sheet_x: 29,
          sheet_y: 20,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Detective",
      b: "1F575-FE0F-200D-2640-FE0F",
      k: [29, 15],
      o: 4
    },
    clock9: {
      a: "Clock Face Nine Oclock",
      b: "1F558",
      j: ["time", "late", "early", "schedule"],
      k: [28, 47],
      o: 2
    },
    "flag-ml": { a: "Mali Flag", b: "1F1F2-1F1F1", k: [3, 10], o: 2 },
    m: {
      a: "Circled Latin Capital Letter M",
      b: "24C2-FE0F",
      c: "24C2",
      j: ["alphabet", "blue-circle", "letter"],
      k: [52, 40],
      o: 2
    },
    "flag-mm": {
      a: "Myanmar (burma) Flag",
      b: "1F1F2-1F1F2",
      k: [3, 11],
      o: 2
    },
    clock930: {
      a: "Clock Face Nine-Thirty",
      b: "1F564",
      j: ["time", "late", "early", "schedule"],
      k: [29, 2],
      o: 2
    },
    guardsman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F482-1F3FB",
          non_qualified: null,
          image: "1f482-1f3fb.png",
          sheet_x: 24,
          sheet_y: 21,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F482-1F3FC",
          non_qualified: null,
          image: "1f482-1f3fc.png",
          sheet_x: 24,
          sheet_y: 22,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F482-1F3FD",
          non_qualified: null,
          image: "1f482-1f3fd.png",
          sheet_x: 24,
          sheet_y: 23,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F482-1F3FE",
          non_qualified: null,
          image: "1f482-1f3fe.png",
          sheet_x: 24,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F482-1F3FF",
          non_qualified: null,
          image: "1f482-1f3ff.png",
          sheet_x: 24,
          sheet_y: 25,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F482-200D-2642-FE0F",
      a: "Guardsman",
      b: "1F482",
      j: ["uk", "gb", "british", "male", "guy", "royal"],
      k: [24, 20],
      o: 2
    },
    new: {
      a: "Squared New",
      b: "1F195",
      j: ["blue-square", "words", "start"],
      k: [0, 25],
      o: 2
    },
    spiral_calendar_pad: {
      a: "Spiral Calendar Pad",
      b: "1F5D3-FE0F",
      c: "1F5D3",
      k: [30, 20],
      o: 2
    },
    ng: {
      a: "Squared Ng",
      b: "1F196",
      j: ["blue-square", "words", "shape", "icon"],
      k: [0, 26],
      o: 2
    },
    card_index: {
      a: "Card Index",
      b: "1F4C7",
      j: ["business", "stationery"],
      k: [26, 29],
      o: 2
    },
    clock10: {
      a: "Clock Face Ten Oclock",
      b: "1F559",
      j: ["time", "late", "early", "schedule"],
      k: [28, 48],
      o: 2
    },
    "flag-mn": { a: "Mongolia Flag", b: "1F1F2-1F1F3", k: [3, 12], o: 2 },
    "male-guard": {
      skin_variations: {
        "1F3FB": {
          unified: "1F482-1F3FB-200D-2642-FE0F",
          non_qualified: "1F482-1F3FB-200D-2642",
          image: "1f482-1f3fb-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F482-1F3FC-200D-2642-FE0F",
          non_qualified: "1F482-1F3FC-200D-2642",
          image: "1f482-1f3fc-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F482-1F3FD-200D-2642-FE0F",
          non_qualified: "1F482-1F3FD-200D-2642",
          image: "1f482-1f3fd-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F482-1F3FE-200D-2642-FE0F",
          non_qualified: "1F482-1F3FE-200D-2642",
          image: "1f482-1f3fe-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F482-1F3FF-200D-2642-FE0F",
          non_qualified: "1F482-1F3FF-200D-2642",
          image: "1f482-1f3ff-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F482",
      a: "Male Guard",
      b: "1F482-200D-2642-FE0F",
      c: "1F482-200D-2642",
      k: [24, 14],
      o: 4
    },
    "flag-mo": {
      a: "Macao Sar China Flag",
      b: "1F1F2-1F1F4",
      k: [3, 13],
      o: 2
    },
    clock1030: {
      a: "Clock Face Ten-Thirty",
      b: "1F565",
      j: ["time", "late", "early", "schedule"],
      k: [29, 3],
      o: 2
    },
    chart_with_upwards_trend: {
      a: "Chart with Upwards Trend",
      b: "1F4C8",
      j: [
        "graph",
        "presentation",
        "stats",
        "recovery",
        "business",
        "economics",
        "money",
        "sales",
        "good",
        "success"
      ],
      k: [26, 30],
      o: 2
    },
    o2: {
      a: "Negative Squared Latin Capital Letter O",
      b: "1F17E-FE0F",
      c: "1F17E",
      j: ["alphabet", "red-square", "letter"],
      k: [0, 18],
      o: 2
    },
    "female-guard": {
      skin_variations: {
        "1F3FB": {
          unified: "1F482-1F3FB-200D-2640-FE0F",
          non_qualified: "1F482-1F3FB-200D-2640",
          image: "1f482-1f3fb-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F482-1F3FC-200D-2640-FE0F",
          non_qualified: "1F482-1F3FC-200D-2640",
          image: "1f482-1f3fc-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F482-1F3FD-200D-2640-FE0F",
          non_qualified: "1F482-1F3FD-200D-2640",
          image: "1f482-1f3fd-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F482-1F3FE-200D-2640-FE0F",
          non_qualified: "1F482-1F3FE-200D-2640",
          image: "1f482-1f3fe-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F482-1F3FF-200D-2640-FE0F",
          non_qualified: "1F482-1F3FF-200D-2640",
          image: "1f482-1f3ff-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Guard",
      b: "1F482-200D-2640-FE0F",
      c: "1F482-200D-2640",
      k: [24, 8],
      o: 4
    },
    chart_with_downwards_trend: {
      a: "Chart with Downwards Trend",
      b: "1F4C9",
      j: [
        "graph",
        "presentation",
        "stats",
        "recession",
        "business",
        "economics",
        "money",
        "sales",
        "bad",
        "failure"
      ],
      k: [26, 31],
      o: 2
    },
    "flag-mp": {
      a: "Northern Mariana Islands Flag",
      b: "1F1F2-1F1F5",
      k: [3, 14],
      o: 2
    },
    ok: {
      a: "Squared Ok",
      b: "1F197",
      j: ["good", "agree", "yes", "blue-square"],
      k: [0, 27],
      o: 2
    },
    clock11: {
      a: "Clock Face Eleven Oclock",
      b: "1F55A",
      j: ["time", "late", "early", "schedule"],
      k: [28, 49],
      o: 2
    },
    construction_worker: {
      skin_variations: {
        "1F3FB": {
          unified: "1F477-1F3FB",
          non_qualified: null,
          image: "1f477-1f3fb.png",
          sheet_x: 23,
          sheet_y: 23,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F477-1F3FC",
          non_qualified: null,
          image: "1f477-1f3fc.png",
          sheet_x: 23,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F477-1F3FD",
          non_qualified: null,
          image: "1f477-1f3fd.png",
          sheet_x: 23,
          sheet_y: 25,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F477-1F3FE",
          non_qualified: null,
          image: "1f477-1f3fe.png",
          sheet_x: 23,
          sheet_y: 26,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F477-1F3FF",
          non_qualified: null,
          image: "1f477-1f3ff.png",
          sheet_x: 23,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F477-200D-2642-FE0F",
      a: "Construction Worker",
      b: "1F477",
      k: [23, 22],
      o: 2
    },
    "male-construction-worker": {
      skin_variations: {
        "1F3FB": {
          unified: "1F477-1F3FB-200D-2642-FE0F",
          non_qualified: "1F477-1F3FB-200D-2642",
          image: "1f477-1f3fb-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F477-1F3FC-200D-2642-FE0F",
          non_qualified: "1F477-1F3FC-200D-2642",
          image: "1f477-1f3fc-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F477-1F3FD-200D-2642-FE0F",
          non_qualified: "1F477-1F3FD-200D-2642",
          image: "1f477-1f3fd-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F477-1F3FE-200D-2642-FE0F",
          non_qualified: "1F477-1F3FE-200D-2642",
          image: "1f477-1f3fe-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 20,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F477-1F3FF-200D-2642-FE0F",
          non_qualified: "1F477-1F3FF-200D-2642",
          image: "1f477-1f3ff-200d-2642-fe0f.png",
          sheet_x: 23,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F477",
      a: "Male Construction Worker",
      b: "1F477-200D-2642-FE0F",
      c: "1F477-200D-2642",
      k: [23, 16],
      o: 4
    },
    clock1130: {
      a: "Clock Face Eleven-Thirty",
      b: "1F566",
      j: ["time", "late", "early", "schedule"],
      k: [29, 4],
      o: 2
    },
    "flag-mq": { a: "Martinique Flag", b: "1F1F2-1F1F6", k: [3, 15], o: 2 },
    bar_chart: {
      a: "Bar Chart",
      b: "1F4CA",
      j: ["graph", "presentation", "stats"],
      k: [26, 32],
      o: 2
    },
    parking: {
      a: "Negative Squared Latin Capital Letter P",
      b: "1F17F-FE0F",
      c: "1F17F",
      j: ["cars", "blue-square", "alphabet", "letter"],
      k: [0, 19],
      o: 2
    },
    new_moon: {
      a: "New Moon Symbol",
      b: "1F311",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 36],
      o: 2
    },
    "female-construction-worker": {
      skin_variations: {
        "1F3FB": {
          unified: "1F477-1F3FB-200D-2640-FE0F",
          non_qualified: "1F477-1F3FB-200D-2640",
          image: "1f477-1f3fb-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F477-1F3FC-200D-2640-FE0F",
          non_qualified: "1F477-1F3FC-200D-2640",
          image: "1f477-1f3fc-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F477-1F3FD-200D-2640-FE0F",
          non_qualified: "1F477-1F3FD-200D-2640",
          image: "1f477-1f3fd-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F477-1F3FE-200D-2640-FE0F",
          non_qualified: "1F477-1F3FE-200D-2640",
          image: "1f477-1f3fe-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F477-1F3FF-200D-2640-FE0F",
          non_qualified: "1F477-1F3FF-200D-2640",
          image: "1f477-1f3ff-200d-2640-fe0f.png",
          sheet_x: 23,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Construction Worker",
      b: "1F477-200D-2640-FE0F",
      c: "1F477-200D-2640",
      k: [23, 10],
      o: 4
    },
    sos: {
      a: "Squared Sos",
      b: "1F198",
      j: ["help", "red-square", "words", "emergency", "911"],
      k: [0, 28],
      o: 2
    },
    clipboard: {
      a: "Clipboard",
      b: "1F4CB",
      j: ["stationery", "documents"],
      k: [26, 33],
      o: 2
    },
    "flag-mr": { a: "Mauritania Flag", b: "1F1F2-1F1F7", k: [3, 16], o: 2 },
    prince: {
      skin_variations: {
        "1F3FB": {
          unified: "1F934-1F3FB",
          non_qualified: null,
          image: "1f934-1f3fb.png",
          sheet_x: 39,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F934-1F3FC",
          non_qualified: null,
          image: "1f934-1f3fc.png",
          sheet_x: 39,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F934-1F3FD",
          non_qualified: null,
          image: "1f934-1f3fd.png",
          sheet_x: 39,
          sheet_y: 20,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F934-1F3FE",
          non_qualified: null,
          image: "1f934-1f3fe.png",
          sheet_x: 39,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F934-1F3FF",
          non_qualified: null,
          image: "1f934-1f3ff.png",
          sheet_x: 39,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Prince",
      b: "1F934",
      j: ["boy", "man", "male", "crown", "royal", "king"],
      k: [39, 17],
      o: 4
    },
    waxing_crescent_moon: {
      a: "Waxing Crescent Moon Symbol",
      b: "1F312",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 37],
      o: 2
    },
    "flag-ms": { a: "Montserrat Flag", b: "1F1F2-1F1F8", k: [3, 17], o: 2 },
    pushpin: {
      a: "Pushpin",
      b: "1F4CC",
      j: ["stationery", "mark", "here"],
      k: [26, 34],
      o: 2
    },
    up: {
      a: "Squared Up with Exclamation Mark",
      b: "1F199",
      j: ["blue-square", "above", "high"],
      k: [0, 29],
      o: 2
    },
    "flag-mt": { a: "Malta Flag", b: "1F1F2-1F1F9", k: [3, 18], o: 2 },
    princess: {
      skin_variations: {
        "1F3FB": {
          unified: "1F478-1F3FB",
          non_qualified: null,
          image: "1f478-1f3fb.png",
          sheet_x: 23,
          sheet_y: 29,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F478-1F3FC",
          non_qualified: null,
          image: "1f478-1f3fc.png",
          sheet_x: 23,
          sheet_y: 30,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F478-1F3FD",
          non_qualified: null,
          image: "1f478-1f3fd.png",
          sheet_x: 23,
          sheet_y: 31,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F478-1F3FE",
          non_qualified: null,
          image: "1f478-1f3fe.png",
          sheet_x: 23,
          sheet_y: 32,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F478-1F3FF",
          non_qualified: null,
          image: "1f478-1f3ff.png",
          sheet_x: 23,
          sheet_y: 33,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Princess",
      b: "1F478",
      j: ["girl", "woman", "female", "blond", "crown", "royal", "queen"],
      k: [23, 28],
      o: 2
    },
    round_pushpin: {
      a: "Round Pushpin",
      b: "1F4CD",
      j: ["stationery", "location", "map", "here"],
      k: [26, 35],
      o: 2
    },
    first_quarter_moon: {
      a: "First Quarter Moon Symbol",
      b: "1F313",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 38],
      o: 2
    },
    vs: {
      a: "Squared Vs",
      b: "1F19A",
      j: ["words", "orange-square"],
      k: [0, 30],
      o: 2
    },
    "flag-mu": { a: "Mauritius Flag", b: "1F1F2-1F1FA", k: [3, 19], o: 2 },
    koko: {
      a: "Squared Katakana Koko",
      b: "1F201",
      j: ["blue-square", "here", "katakana", "japanese", "destination"],
      k: [5, 4],
      o: 2
    },
    man_with_turban: {
      skin_variations: {
        "1F3FB": {
          unified: "1F473-1F3FB",
          non_qualified: null,
          image: "1f473-1f3fb.png",
          sheet_x: 22,
          sheet_y: 44,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F473-1F3FC",
          non_qualified: null,
          image: "1f473-1f3fc.png",
          sheet_x: 22,
          sheet_y: 45,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F473-1F3FD",
          non_qualified: null,
          image: "1f473-1f3fd.png",
          sheet_x: 22,
          sheet_y: 46,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F473-1F3FE",
          non_qualified: null,
          image: "1f473-1f3fe.png",
          sheet_x: 22,
          sheet_y: 47,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F473-1F3FF",
          non_qualified: null,
          image: "1f473-1f3ff.png",
          sheet_x: 22,
          sheet_y: 48,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F473-200D-2642-FE0F",
      a: "Man with Turban",
      b: "1F473",
      j: ["male", "indian", "hinduism", "arabs"],
      k: [22, 43],
      o: 2
    },
    moon: {
      a: "Waxing Gibbous Moon Symbol",
      b: "1F314",
      k: [5, 39],
      n: ["waxing_gibbous_moon"],
      o: 2
    },
    paperclip: {
      a: "Paperclip",
      b: "1F4CE",
      j: ["documents", "stationery"],
      k: [26, 36],
      o: 2
    },
    linked_paperclips: {
      a: "Linked Paperclips",
      b: "1F587-FE0F",
      c: "1F587",
      k: [29, 43],
      o: 2
    },
    "man-wearing-turban": {
      skin_variations: {
        "1F3FB": {
          unified: "1F473-1F3FB-200D-2642-FE0F",
          non_qualified: "1F473-1F3FB-200D-2642",
          image: "1f473-1f3fb-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F473-1F3FC-200D-2642-FE0F",
          non_qualified: "1F473-1F3FC-200D-2642",
          image: "1f473-1f3fc-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F473-1F3FD-200D-2642-FE0F",
          non_qualified: "1F473-1F3FD-200D-2642",
          image: "1f473-1f3fd-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F473-1F3FE-200D-2642-FE0F",
          non_qualified: "1F473-1F3FE-200D-2642",
          image: "1f473-1f3fe-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F473-1F3FF-200D-2642-FE0F",
          non_qualified: "1F473-1F3FF-200D-2642",
          image: "1f473-1f3ff-200d-2642-fe0f.png",
          sheet_x: 22,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F473",
      a: "Man Wearing Turban",
      b: "1F473-200D-2642-FE0F",
      c: "1F473-200D-2642",
      k: [22, 37],
      o: 4
    },
    sa: {
      a: "Squared Katakana Sa",
      b: "1F202-FE0F",
      c: "1F202",
      j: ["japanese", "blue-square", "katakana"],
      k: [5, 5],
      o: 2
    },
    full_moon: {
      a: "Full Moon Symbol",
      b: "1F315",
      j: [
        "nature",
        "yellow",
        "twilight",
        "planet",
        "space",
        "night",
        "evening",
        "sleep"
      ],
      k: [5, 40],
      o: 2
    },
    "flag-mv": { a: "Maldives Flag", b: "1F1F2-1F1FB", k: [3, 20], o: 2 },
    "flag-mw": { a: "Malawi Flag", b: "1F1F2-1F1FC", k: [3, 21], o: 2 },
    waning_gibbous_moon: {
      a: "Waning Gibbous Moon Symbol",
      b: "1F316",
      j: [
        "nature",
        "twilight",
        "planet",
        "space",
        "night",
        "evening",
        "sleep",
        "waxing_gibbous_moon"
      ],
      k: [5, 41],
      o: 2
    },
    "woman-wearing-turban": {
      skin_variations: {
        "1F3FB": {
          unified: "1F473-1F3FB-200D-2640-FE0F",
          non_qualified: "1F473-1F3FB-200D-2640",
          image: "1f473-1f3fb-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F473-1F3FC-200D-2640-FE0F",
          non_qualified: "1F473-1F3FC-200D-2640",
          image: "1f473-1f3fc-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F473-1F3FD-200D-2640-FE0F",
          non_qualified: "1F473-1F3FD-200D-2640",
          image: "1f473-1f3fd-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F473-1F3FE-200D-2640-FE0F",
          non_qualified: "1F473-1F3FE-200D-2640",
          image: "1f473-1f3fe-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 35,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F473-1F3FF-200D-2640-FE0F",
          non_qualified: "1F473-1F3FF-200D-2640",
          image: "1f473-1f3ff-200d-2640-fe0f.png",
          sheet_x: 22,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Wearing Turban",
      b: "1F473-200D-2640-FE0F",
      c: "1F473-200D-2640",
      k: [22, 31],
      o: 4
    },
    u6708: {
      a: "Squared Cjk Unified Ideograph-6708",
      b: "1F237-FE0F",
      c: "1F237",
      j: ["chinese", "month", "moon", "japanese", "orange-square", "kanji"],
      k: [5, 13],
      o: 2
    },
    straight_ruler: {
      a: "Straight Ruler",
      b: "1F4CF",
      j: [
        "stationery",
        "calculate",
        "length",
        "math",
        "school",
        "drawing",
        "architect",
        "sketch"
      ],
      k: [26, 37],
      o: 2
    },
    u6709: {
      a: "Squared Cjk Unified Ideograph-6709",
      b: "1F236",
      j: ["orange-square", "chinese", "have", "kanji"],
      k: [5, 12],
      o: 2
    },
    triangular_ruler: {
      a: "Triangular Ruler",
      b: "1F4D0",
      j: ["stationery", "math", "architect", "sketch"],
      k: [26, 38],
      o: 2
    },
    man_with_gua_pi_mao: {
      skin_variations: {
        "1F3FB": {
          unified: "1F472-1F3FB",
          non_qualified: null,
          image: "1f472-1f3fb.png",
          sheet_x: 22,
          sheet_y: 26,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F472-1F3FC",
          non_qualified: null,
          image: "1f472-1f3fc.png",
          sheet_x: 22,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F472-1F3FD",
          non_qualified: null,
          image: "1f472-1f3fd.png",
          sheet_x: 22,
          sheet_y: 28,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F472-1F3FE",
          non_qualified: null,
          image: "1f472-1f3fe.png",
          sheet_x: 22,
          sheet_y: 29,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F472-1F3FF",
          non_qualified: null,
          image: "1f472-1f3ff.png",
          sheet_x: 22,
          sheet_y: 30,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man with Gua Pi Mao",
      b: "1F472",
      j: ["male", "boy", "chinese"],
      k: [22, 25],
      o: 2
    },
    "flag-mx": { a: "Mexico Flag", b: "1F1F2-1F1FD", k: [3, 22], o: 2 },
    last_quarter_moon: {
      a: "Last Quarter Moon Symbol",
      b: "1F317",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 42],
      o: 2
    },
    person_with_headscarf: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D5-1F3FB",
          non_qualified: null,
          image: "1f9d5-1f3fb.png",
          sheet_x: 48,
          sheet_y: 35,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D5-1F3FC",
          non_qualified: null,
          image: "1f9d5-1f3fc.png",
          sheet_x: 48,
          sheet_y: 36,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D5-1F3FD",
          non_qualified: null,
          image: "1f9d5-1f3fd.png",
          sheet_x: 48,
          sheet_y: 37,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D5-1F3FE",
          non_qualified: null,
          image: "1f9d5-1f3fe.png",
          sheet_x: 48,
          sheet_y: 38,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D5-1F3FF",
          non_qualified: null,
          image: "1f9d5-1f3ff.png",
          sheet_x: 48,
          sheet_y: 39,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Person with Headscarf",
      b: "1F9D5",
      k: [48, 34],
      o: 5
    },
    waning_crescent_moon: {
      a: "Waning Crescent Moon Symbol",
      b: "1F318",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 43],
      o: 2
    },
    u6307: {
      a: "Squared Cjk Unified Ideograph-6307",
      b: "1F22F",
      j: ["chinese", "point", "green-square", "kanji"],
      k: [5, 7],
      o: 2
    },
    scissors: {
      a: "Black Scissors",
      b: "2702-FE0F",
      c: "2702",
      j: ["stationery", "cut"],
      k: [54, 39],
      o: 2
    },
    "flag-my": { a: "Malaysia Flag", b: "1F1F2-1F1FE", k: [3, 23], o: 2 },
    ideograph_advantage: {
      a: "Circled Ideograph Advantage",
      b: "1F250",
      j: ["chinese", "kanji", "obtain", "get", "circle"],
      k: [5, 17],
      o: 2
    },
    man_in_tuxedo: {
      skin_variations: {
        "1F3FB": {
          unified: "1F935-1F3FB",
          non_qualified: null,
          image: "1f935-1f3fb.png",
          sheet_x: 39,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F935-1F3FC",
          non_qualified: null,
          image: "1f935-1f3fc.png",
          sheet_x: 39,
          sheet_y: 25,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F935-1F3FD",
          non_qualified: null,
          image: "1f935-1f3fd.png",
          sheet_x: 39,
          sheet_y: 26,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F935-1F3FE",
          non_qualified: null,
          image: "1f935-1f3fe.png",
          sheet_x: 39,
          sheet_y: 27,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F935-1F3FF",
          non_qualified: null,
          image: "1f935-1f3ff.png",
          sheet_x: 39,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man in Tuxedo",
      b: "1F935",
      j: ["couple", "marriage", "wedding", "groom"],
      k: [39, 23],
      o: 4
    },
    "flag-mz": { a: "Mozambique Flag", b: "1F1F2-1F1FF", k: [3, 24], o: 2 },
    card_file_box: {
      a: "Card File Box",
      b: "1F5C3-FE0F",
      c: "1F5C3",
      j: ["business", "stationery"],
      k: [30, 16],
      o: 2
    },
    crescent_moon: {
      a: "Crescent Moon",
      b: "1F319",
      j: ["night", "sleep", "sky", "evening", "magic"],
      k: [5, 44],
      o: 2
    },
    "flag-na": { a: "Namibia Flag", b: "1F1F3-1F1E6", k: [3, 25], o: 2 },
    bride_with_veil: {
      skin_variations: {
        "1F3FB": {
          unified: "1F470-1F3FB",
          non_qualified: null,
          image: "1f470-1f3fb.png",
          sheet_x: 22,
          sheet_y: 2,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F470-1F3FC",
          non_qualified: null,
          image: "1f470-1f3fc.png",
          sheet_x: 22,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F470-1F3FD",
          non_qualified: null,
          image: "1f470-1f3fd.png",
          sheet_x: 22,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F470-1F3FE",
          non_qualified: null,
          image: "1f470-1f3fe.png",
          sheet_x: 22,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F470-1F3FF",
          non_qualified: null,
          image: "1f470-1f3ff.png",
          sheet_x: 22,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Bride with Veil",
      b: "1F470",
      j: ["couple", "marriage", "wedding", "woman", "bride"],
      k: [22, 1],
      o: 2
    },
    new_moon_with_face: {
      a: "New Moon with Face",
      b: "1F31A",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 45],
      o: 2
    },
    file_cabinet: {
      a: "File Cabinet",
      b: "1F5C4-FE0F",
      c: "1F5C4",
      j: ["filing", "organizing"],
      k: [30, 17],
      o: 2
    },
    u5272: {
      a: "Squared Cjk Unified Ideograph-5272",
      b: "1F239",
      j: ["cut", "divide", "chinese", "kanji", "pink-square"],
      k: [5, 15],
      o: 2
    },
    wastebasket: {
      a: "Wastebasket",
      b: "1F5D1-FE0F",
      c: "1F5D1",
      j: ["bin", "trash", "rubbish", "garbage", "toss"],
      k: [30, 18],
      o: 2
    },
    pregnant_woman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F930-1F3FB",
          non_qualified: null,
          image: "1f930-1f3fb.png",
          sheet_x: 38,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F930-1F3FC",
          non_qualified: null,
          image: "1f930-1f3fc.png",
          sheet_x: 38,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F930-1F3FD",
          non_qualified: null,
          image: "1f930-1f3fd.png",
          sheet_x: 38,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F930-1F3FE",
          non_qualified: null,
          image: "1f930-1f3fe.png",
          sheet_x: 38,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F930-1F3FF",
          non_qualified: null,
          image: "1f930-1f3ff.png",
          sheet_x: 38,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Pregnant Woman",
      b: "1F930",
      j: ["baby"],
      k: [38, 50],
      o: 4
    },
    first_quarter_moon_with_face: {
      a: "First Quarter Moon with Face",
      b: "1F31B",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 46],
      o: 2
    },
    "flag-nc": { a: "New Caledonia Flag", b: "1F1F3-1F1E8", k: [3, 26], o: 2 },
    u7121: {
      a: "Squared Cjk Unified Ideograph-7121",
      b: "1F21A",
      j: ["nothing", "chinese", "kanji", "japanese", "orange-square"],
      k: [5, 6],
      o: 2
    },
    lock: {
      a: "Lock",
      b: "1F512",
      j: ["security", "password", "padlock"],
      k: [27, 46],
      o: 2
    },
    "flag-ne": { a: "Niger Flag", b: "1F1F3-1F1EA", k: [3, 27], o: 2 },
    last_quarter_moon_with_face: {
      a: "Last Quarter Moon with Face",
      b: "1F31C",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 47],
      o: 2
    },
    "breast-feeding": {
      skin_variations: {
        "1F3FB": {
          unified: "1F931-1F3FB",
          non_qualified: null,
          image: "1f931-1f3fb.png",
          sheet_x: 39,
          sheet_y: 0,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F931-1F3FC",
          non_qualified: null,
          image: "1f931-1f3fc.png",
          sheet_x: 39,
          sheet_y: 1,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F931-1F3FD",
          non_qualified: null,
          image: "1f931-1f3fd.png",
          sheet_x: 39,
          sheet_y: 2,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F931-1F3FE",
          non_qualified: null,
          image: "1f931-1f3fe.png",
          sheet_x: 39,
          sheet_y: 3,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F931-1F3FF",
          non_qualified: null,
          image: "1f931-1f3ff.png",
          sheet_x: 39,
          sheet_y: 4,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Breast-Feeding",
      b: "1F931",
      k: [38, 56],
      o: 5
    },
    u7981: {
      a: "Squared Cjk Unified Ideograph-7981",
      b: "1F232",
      j: [
        "kanji",
        "japanese",
        "chinese",
        "forbidden",
        "limit",
        "restricted",
        "red-square"
      ],
      k: [5, 8],
      o: 2
    },
    accept: {
      a: "Circled Ideograph Accept",
      b: "1F251",
      j: ["ok", "good", "chinese", "kanji", "agree", "yes", "orange-circle"],
      k: [5, 18],
      o: 2
    },
    angel: {
      skin_variations: {
        "1F3FB": {
          unified: "1F47C-1F3FB",
          non_qualified: null,
          image: "1f47c-1f3fb.png",
          sheet_x: 23,
          sheet_y: 38,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F47C-1F3FC",
          non_qualified: null,
          image: "1f47c-1f3fc.png",
          sheet_x: 23,
          sheet_y: 39,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F47C-1F3FD",
          non_qualified: null,
          image: "1f47c-1f3fd.png",
          sheet_x: 23,
          sheet_y: 40,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F47C-1F3FE",
          non_qualified: null,
          image: "1f47c-1f3fe.png",
          sheet_x: 23,
          sheet_y: 41,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F47C-1F3FF",
          non_qualified: null,
          image: "1f47c-1f3ff.png",
          sheet_x: 23,
          sheet_y: 42,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Baby Angel",
      b: "1F47C",
      j: ["heaven", "wings", "halo"],
      k: [23, 37],
      o: 2
    },
    unlock: {
      a: "Open Lock",
      b: "1F513",
      j: ["privacy", "security"],
      k: [27, 47],
      o: 2
    },
    "flag-nf": { a: "Norfolk Island Flag", b: "1F1F3-1F1EB", k: [3, 28], o: 2 },
    thermometer: {
      a: "Thermometer",
      b: "1F321-FE0F",
      c: "1F321",
      j: ["weather", "temperature", "hot", "cold"],
      k: [5, 52],
      o: 2
    },
    "flag-ng": { a: "Nigeria Flag", b: "1F1F3-1F1EC", k: [3, 29], o: 2 },
    u7533: {
      a: "Squared Cjk Unified Ideograph-7533",
      b: "1F238",
      j: ["chinese", "japanese", "kanji", "orange-square"],
      k: [5, 14],
      o: 2
    },
    sunny: {
      a: "Black Sun with Rays",
      b: "2600-FE0F",
      c: "2600",
      j: ["weather", "nature", "brightness", "summer", "beach", "spring"],
      k: [52, 49],
      o: 2
    },
    lock_with_ink_pen: {
      a: "Lock with Ink Pen",
      b: "1F50F",
      j: ["security", "secret"],
      k: [27, 43],
      o: 2
    },
    santa: {
      skin_variations: {
        "1F3FB": {
          unified: "1F385-1F3FB",
          non_qualified: null,
          image: "1f385-1f3fb.png",
          sheet_x: 7,
          sheet_y: 37,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F385-1F3FC",
          non_qualified: null,
          image: "1f385-1f3fc.png",
          sheet_x: 7,
          sheet_y: 38,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F385-1F3FD",
          non_qualified: null,
          image: "1f385-1f3fd.png",
          sheet_x: 7,
          sheet_y: 39,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F385-1F3FE",
          non_qualified: null,
          image: "1f385-1f3fe.png",
          sheet_x: 7,
          sheet_y: 40,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F385-1F3FF",
          non_qualified: null,
          image: "1f385-1f3ff.png",
          sheet_x: 7,
          sheet_y: 41,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Father Christmas",
      b: "1F385",
      j: ["festival", "man", "male", "xmas", "father christmas"],
      k: [7, 36],
      o: 2
    },
    closed_lock_with_key: {
      a: "Closed Lock with Key",
      b: "1F510",
      j: ["security", "privacy"],
      k: [27, 44],
      o: 2
    },
    u5408: {
      a: "Squared Cjk Unified Ideograph-5408",
      b: "1F234",
      j: ["japanese", "chinese", "join", "kanji", "red-square"],
      k: [5, 10],
      o: 2
    },
    "flag-ni": { a: "Nicaragua Flag", b: "1F1F3-1F1EE", k: [3, 30], o: 2 },
    mrs_claus: {
      skin_variations: {
        "1F3FB": {
          unified: "1F936-1F3FB",
          non_qualified: null,
          image: "1f936-1f3fb.png",
          sheet_x: 39,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F936-1F3FC",
          non_qualified: null,
          image: "1f936-1f3fc.png",
          sheet_x: 39,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F936-1F3FD",
          non_qualified: null,
          image: "1f936-1f3fd.png",
          sheet_x: 39,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F936-1F3FE",
          non_qualified: null,
          image: "1f936-1f3fe.png",
          sheet_x: 39,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F936-1F3FF",
          non_qualified: null,
          image: "1f936-1f3ff.png",
          sheet_x: 39,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Mother Christmas",
      b: "1F936",
      j: ["woman", "female", "xmas", "mother christmas"],
      k: [39, 29],
      n: ["mother_christmas"],
      o: 4
    },
    full_moon_with_face: {
      a: "Full Moon with Face",
      b: "1F31D",
      j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
      k: [5, 48],
      o: 2
    },
    key: {
      a: "Key",
      b: "1F511",
      j: ["lock", "door", "password"],
      k: [27, 45],
      o: 2
    },
    superhero: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B8-1F3FB",
          non_qualified: null,
          image: "1f9b8-1f3fb.png",
          sheet_x: 43,
          sheet_y: 31,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B8-1F3FC",
          non_qualified: null,
          image: "1f9b8-1f3fc.png",
          sheet_x: 43,
          sheet_y: 32,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B8-1F3FD",
          non_qualified: null,
          image: "1f9b8-1f3fd.png",
          sheet_x: 43,
          sheet_y: 33,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B8-1F3FE",
          non_qualified: null,
          image: "1f9b8-1f3fe.png",
          sheet_x: 43,
          sheet_y: 34,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B8-1F3FF",
          non_qualified: null,
          image: "1f9b8-1f3ff.png",
          sheet_x: 43,
          sheet_y: 35,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Superhero",
      b: "1F9B8",
      k: [43, 30],
      o: 11
    },
    "flag-nl": { a: "Netherlands Flag", b: "1F1F3-1F1F1", k: [3, 31], o: 2 },
    u7a7a: {
      a: "Squared Cjk Unified Ideograph-7a7a",
      b: "1F233",
      j: ["kanji", "japanese", "chinese", "empty", "sky", "blue-square"],
      k: [5, 9],
      o: 2
    },
    sun_with_face: {
      a: "Sun with Face",
      b: "1F31E",
      j: ["nature", "morning", "sky"],
      k: [5, 49],
      o: 2
    },
    male_superhero: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B8-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9B8-1F3FB-200D-2642",
          image: "1f9b8-1f3fb-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 25,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B8-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9B8-1F3FC-200D-2642",
          image: "1f9b8-1f3fc-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 26,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B8-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9B8-1F3FD-200D-2642",
          image: "1f9b8-1f3fd-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 27,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B8-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9B8-1F3FE-200D-2642",
          image: "1f9b8-1f3fe-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 28,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B8-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9B8-1F3FF-200D-2642",
          image: "1f9b8-1f3ff-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 29,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Superhero",
      b: "1F9B8-200D-2642-FE0F",
      c: "1F9B8-200D-2642",
      k: [43, 24],
      o: 11
    },
    ringed_planet: { a: "Ringed Planet", b: "1FA90", k: [52, 4], o: 12 },
    old_key: {
      a: "Old Key",
      b: "1F5DD-FE0F",
      c: "1F5DD",
      j: ["lock", "door", "password"],
      k: [30, 22],
      o: 2
    },
    congratulations: {
      a: "Circled Ideograph Congratulation",
      b: "3297-FE0F",
      c: "3297",
      j: ["chinese", "kanji", "japanese", "red-circle"],
      k: [55, 46],
      o: 2
    },
    "flag-no": { a: "Norway Flag", b: "1F1F3-1F1F4", k: [3, 32], o: 2 },
    star: {
      a: "White Medium Star",
      b: "2B50",
      j: ["night", "yellow"],
      k: [55, 42],
      o: 2
    },
    secret: {
      a: "Circled Ideograph Secret",
      b: "3299-FE0F",
      c: "3299",
      j: ["privacy", "chinese", "sshh", "kanji", "red-circle"],
      k: [55, 47],
      o: 2
    },
    "flag-np": { a: "Nepal Flag", b: "1F1F3-1F1F5", k: [3, 33], o: 2 },
    female_superhero: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B8-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9B8-1F3FB-200D-2640",
          image: "1f9b8-1f3fb-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 19,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B8-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9B8-1F3FC-200D-2640",
          image: "1f9b8-1f3fc-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 20,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B8-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9B8-1F3FD-200D-2640",
          image: "1f9b8-1f3fd-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 21,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B8-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9B8-1F3FE-200D-2640",
          image: "1f9b8-1f3fe-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 22,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B8-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9B8-1F3FF-200D-2640",
          image: "1f9b8-1f3ff-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 23,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Superhero",
      b: "1F9B8-200D-2640-FE0F",
      c: "1F9B8-200D-2640",
      k: [43, 18],
      o: 11
    },
    hammer: {
      a: "Hammer",
      b: "1F528",
      j: ["tools", "build", "create"],
      k: [28, 11],
      o: 2
    },
    star2: {
      a: "Glowing Star",
      b: "1F31F",
      j: ["night", "sparkle", "awesome", "good", "magic"],
      k: [5, 50],
      o: 2
    },
    "flag-nr": { a: "Nauru Flag", b: "1F1F3-1F1F7", k: [3, 34], o: 2 },
    axe: { a: "Axe", b: "1FA93", k: [52, 7], o: 12 },
    u55b6: {
      a: "Squared Cjk Unified Ideograph-55b6",
      b: "1F23A",
      j: ["japanese", "opening hours", "orange-square"],
      k: [5, 16],
      o: 2
    },
    supervillain: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B9-1F3FB",
          non_qualified: null,
          image: "1f9b9-1f3fb.png",
          sheet_x: 43,
          sheet_y: 49,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B9-1F3FC",
          non_qualified: null,
          image: "1f9b9-1f3fc.png",
          sheet_x: 43,
          sheet_y: 50,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B9-1F3FD",
          non_qualified: null,
          image: "1f9b9-1f3fd.png",
          sheet_x: 43,
          sheet_y: 51,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B9-1F3FE",
          non_qualified: null,
          image: "1f9b9-1f3fe.png",
          sheet_x: 43,
          sheet_y: 52,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B9-1F3FF",
          non_qualified: null,
          image: "1f9b9-1f3ff.png",
          sheet_x: 43,
          sheet_y: 53,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Supervillain",
      b: "1F9B9",
      k: [43, 48],
      o: 11
    },
    stars: {
      a: "Shooting Star",
      b: "1F320",
      j: ["night", "photo"],
      k: [5, 51],
      o: 2
    },
    u6e80: {
      a: "Squared Cjk Unified Ideograph-6e80",
      b: "1F235",
      j: ["full", "chinese", "japanese", "red-square", "kanji"],
      k: [5, 11],
      o: 2
    },
    "flag-nu": { a: "Niue Flag", b: "1F1F3-1F1FA", k: [3, 35], o: 2 },
    pick: {
      a: "Pick",
      b: "26CF-FE0F",
      c: "26CF",
      j: ["tools", "dig"],
      k: [54, 5],
      o: 2
    },
    male_supervillain: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B9-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9B9-1F3FB-200D-2642",
          image: "1f9b9-1f3fb-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 43,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B9-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9B9-1F3FC-200D-2642",
          image: "1f9b9-1f3fc-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 44,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B9-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9B9-1F3FD-200D-2642",
          image: "1f9b9-1f3fd-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 45,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B9-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9B9-1F3FE-200D-2642",
          image: "1f9b9-1f3fe-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 46,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B9-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9B9-1F3FF-200D-2642",
          image: "1f9b9-1f3ff-200d-2642-fe0f.png",
          sheet_x: 43,
          sheet_y: 47,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Supervillain",
      b: "1F9B9-200D-2642-FE0F",
      c: "1F9B9-200D-2642",
      k: [43, 42],
      o: 11
    },
    female_supervillain: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9B9-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9B9-1F3FB-200D-2640",
          image: "1f9b9-1f3fb-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 37,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9B9-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9B9-1F3FC-200D-2640",
          image: "1f9b9-1f3fc-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 38,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9B9-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9B9-1F3FD-200D-2640",
          image: "1f9b9-1f3fd-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 39,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9B9-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9B9-1F3FE-200D-2640",
          image: "1f9b9-1f3fe-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 40,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9B9-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9B9-1F3FF-200D-2640",
          image: "1f9b9-1f3ff-200d-2640-fe0f.png",
          sheet_x: 43,
          sheet_y: 41,
          added_in: "11.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Supervillain",
      b: "1F9B9-200D-2640-FE0F",
      c: "1F9B9-200D-2640",
      k: [43, 36],
      o: 11
    },
    hammer_and_pick: {
      a: "Hammer and Pick",
      b: "2692-FE0F",
      c: "2692",
      j: ["tools", "build", "create"],
      k: [53, 41],
      o: 2
    },
    milky_way: {
      a: "Milky Way",
      b: "1F30C",
      j: ["photo", "space", "stars"],
      k: [5, 31],
      o: 2
    },
    red_circle: {
      a: "Large Red Circle",
      b: "1F534",
      j: ["shape", "error", "danger"],
      k: [28, 23],
      o: 2
    },
    "flag-nz": { a: "New Zealand Flag", b: "1F1F3-1F1FF", k: [3, 36], o: 2 },
    large_orange_circle: {
      a: "Large Orange Circle",
      b: "1F7E0",
      k: [37, 3],
      o: 12
    },
    hammer_and_wrench: {
      a: "Hammer and Wrench",
      b: "1F6E0-FE0F",
      c: "1F6E0",
      j: ["tools", "build", "create"],
      k: [36, 42],
      o: 2
    },
    "flag-om": { a: "Oman Flag", b: "1F1F4-1F1F2", k: [3, 37], o: 2 },
    cloud: {
      a: "Cloud",
      b: "2601-FE0F",
      c: "2601",
      j: ["weather", "sky"],
      k: [52, 50],
      o: 2
    },
    mage: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D9-1F3FB",
          non_qualified: null,
          image: "1f9d9-1f3fb.png",
          sheet_x: 49,
          sheet_y: 50,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D9-1F3FB-200D-2640-FE0F"
        },
        "1F3FC": {
          unified: "1F9D9-1F3FC",
          non_qualified: null,
          image: "1f9d9-1f3fc.png",
          sheet_x: 49,
          sheet_y: 51,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D9-1F3FC-200D-2640-FE0F"
        },
        "1F3FD": {
          unified: "1F9D9-1F3FD",
          non_qualified: null,
          image: "1f9d9-1f3fd.png",
          sheet_x: 49,
          sheet_y: 52,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D9-1F3FD-200D-2640-FE0F"
        },
        "1F3FE": {
          unified: "1F9D9-1F3FE",
          non_qualified: null,
          image: "1f9d9-1f3fe.png",
          sheet_x: 49,
          sheet_y: 53,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D9-1F3FE-200D-2640-FE0F"
        },
        "1F3FF": {
          unified: "1F9D9-1F3FF",
          non_qualified: null,
          image: "1f9d9-1f3ff.png",
          sheet_x: 49,
          sheet_y: 54,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D9-1F3FF-200D-2640-FE0F"
        }
      },
      obsoleted_by: "1F9D9-200D-2640-FE0F",
      a: "Mage",
      b: "1F9D9",
      k: [49, 49],
      o: 5
    },
    dagger_knife: {
      a: "Dagger Knife",
      b: "1F5E1-FE0F",
      c: "1F5E1",
      k: [30, 24],
      o: 2
    },
    partly_sunny: {
      a: "Sun Behind Cloud",
      b: "26C5",
      j: ["weather", "nature", "cloudy", "morning", "fall", "spring"],
      k: [54, 2],
      o: 2
    },
    large_yellow_circle: {
      a: "Large Yellow Circle",
      b: "1F7E1",
      k: [37, 4],
      o: 12
    },
    male_mage: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D9-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9D9-1F3FB-200D-2642",
          image: "1f9d9-1f3fb-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 44,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D9-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9D9-1F3FC-200D-2642",
          image: "1f9d9-1f3fc-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 45,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D9-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9D9-1F3FD-200D-2642",
          image: "1f9d9-1f3fd-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 46,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D9-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9D9-1F3FE-200D-2642",
          image: "1f9d9-1f3fe-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 47,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D9-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9D9-1F3FF-200D-2642",
          image: "1f9d9-1f3ff-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 48,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Mage",
      b: "1F9D9-200D-2642-FE0F",
      c: "1F9D9-200D-2642",
      k: [49, 43],
      o: 5
    },
    "flag-pa": { a: "Panama Flag", b: "1F1F5-1F1E6", k: [3, 38], o: 2 },
    thunder_cloud_and_rain: {
      a: "Thunder Cloud and Rain",
      b: "26C8-FE0F",
      c: "26C8",
      k: [54, 3],
      o: 2
    },
    large_green_circle: {
      a: "Large Green Circle",
      b: "1F7E2",
      k: [37, 5],
      o: 12
    },
    female_mage: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D9-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9D9-1F3FB-200D-2640",
          image: "1f9d9-1f3fb-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 38,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D9-1F3FB"
        },
        "1F3FC": {
          unified: "1F9D9-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9D9-1F3FC-200D-2640",
          image: "1f9d9-1f3fc-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 39,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D9-1F3FC"
        },
        "1F3FD": {
          unified: "1F9D9-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9D9-1F3FD-200D-2640",
          image: "1f9d9-1f3fd-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 40,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D9-1F3FD"
        },
        "1F3FE": {
          unified: "1F9D9-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9D9-1F3FE-200D-2640",
          image: "1f9d9-1f3fe-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 41,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D9-1F3FE"
        },
        "1F3FF": {
          unified: "1F9D9-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9D9-1F3FF-200D-2640",
          image: "1f9d9-1f3ff-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 42,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D9-1F3FF"
        }
      },
      obsoletes: "1F9D9",
      a: "Female Mage",
      b: "1F9D9-200D-2640-FE0F",
      c: "1F9D9-200D-2640",
      k: [49, 37],
      o: 5
    },
    crossed_swords: {
      a: "Crossed Swords",
      b: "2694-FE0F",
      c: "2694",
      j: ["weapon"],
      k: [53, 43],
      o: 2
    },
    "flag-pe": { a: "Peru Flag", b: "1F1F5-1F1EA", k: [3, 39], o: 2 },
    gun: {
      a: "Pistol",
      b: "1F52B",
      j: ["violence", "weapon", "pistol", "revolver"],
      k: [28, 14],
      o: 2
    },
    mostly_sunny: {
      a: "Mostly Sunny",
      b: "1F324-FE0F",
      c: "1F324",
      k: [5, 53],
      n: ["sun_small_cloud"],
      o: 2
    },
    fairy: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DA-1F3FB",
          non_qualified: null,
          image: "1f9da-1f3fb.png",
          sheet_x: 50,
          sheet_y: 11,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoleted_by: "1F9DA-1F3FB-200D-2640-FE0F"
        },
        "1F3FC": {
          unified: "1F9DA-1F3FC",
          non_qualified: null,
          image: "1f9da-1f3fc.png",
          sheet_x: 50,
          sheet_y: 12,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoleted_by: "1F9DA-1F3FC-200D-2640-FE0F"
        },
        "1F3FD": {
          unified: "1F9DA-1F3FD",
          non_qualified: null,
          image: "1f9da-1f3fd.png",
          sheet_x: 50,
          sheet_y: 13,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoleted_by: "1F9DA-1F3FD-200D-2640-FE0F"
        },
        "1F3FE": {
          unified: "1F9DA-1F3FE",
          non_qualified: null,
          image: "1f9da-1f3fe.png",
          sheet_x: 50,
          sheet_y: 14,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoleted_by: "1F9DA-1F3FE-200D-2640-FE0F"
        },
        "1F3FF": {
          unified: "1F9DA-1F3FF",
          non_qualified: null,
          image: "1f9da-1f3ff.png",
          sheet_x: 50,
          sheet_y: 15,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoleted_by: "1F9DA-1F3FF-200D-2640-FE0F"
        }
      },
      obsoleted_by: "1F9DA-200D-2640-FE0F",
      a: "Fairy",
      b: "1F9DA",
      k: [50, 10],
      o: 5
    },
    "flag-pf": {
      a: "French Polynesia Flag",
      b: "1F1F5-1F1EB",
      k: [3, 40],
      o: 2
    },
    large_blue_circle: {
      a: "Large Blue Circle",
      b: "1F535",
      j: ["shape", "icon", "button"],
      k: [28, 24],
      o: 2
    },
    large_purple_circle: {
      a: "Large Purple Circle",
      b: "1F7E3",
      k: [37, 6],
      o: 12
    },
    bow_and_arrow: {
      a: "Bow and Arrow",
      b: "1F3F9",
      j: ["sports"],
      k: [11, 21],
      o: 2
    },
    male_fairy: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DA-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9DA-1F3FB-200D-2642",
          image: "1f9da-1f3fb-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 5,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9DA-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9DA-1F3FC-200D-2642",
          image: "1f9da-1f3fc-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 6,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9DA-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9DA-1F3FD-200D-2642",
          image: "1f9da-1f3fd-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 7,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9DA-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9DA-1F3FE-200D-2642",
          image: "1f9da-1f3fe-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 8,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9DA-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9DA-1F3FF-200D-2642",
          image: "1f9da-1f3ff-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 9,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      a: "Male Fairy",
      b: "1F9DA-200D-2642-FE0F",
      c: "1F9DA-200D-2642",
      k: [50, 4],
      o: 5
    },
    barely_sunny: {
      a: "Barely Sunny",
      b: "1F325-FE0F",
      c: "1F325",
      k: [5, 54],
      n: ["sun_behind_cloud"],
      o: 2
    },
    "flag-pg": {
      a: "Papua New Guinea Flag",
      b: "1F1F5-1F1EC",
      k: [3, 41],
      o: 2
    },
    shield: {
      a: "Shield",
      b: "1F6E1-FE0F",
      c: "1F6E1",
      j: ["protection", "security"],
      k: [36, 43],
      o: 2
    },
    partly_sunny_rain: {
      a: "Partly Sunny Rain",
      b: "1F326-FE0F",
      c: "1F326",
      k: [5, 55],
      n: ["sun_behind_rain_cloud"],
      o: 2
    },
    large_brown_circle: {
      a: "Large Brown Circle",
      b: "1F7E4",
      k: [37, 7],
      o: 12
    },
    female_fairy: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DA-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9DA-1F3FB-200D-2640",
          image: "1f9da-1f3fb-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 56,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoletes: "1F9DA-1F3FB"
        },
        "1F3FC": {
          unified: "1F9DA-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9DA-1F3FC-200D-2640",
          image: "1f9da-1f3fc-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 0,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoletes: "1F9DA-1F3FC"
        },
        "1F3FD": {
          unified: "1F9DA-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9DA-1F3FD-200D-2640",
          image: "1f9da-1f3fd-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 1,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoletes: "1F9DA-1F3FD"
        },
        "1F3FE": {
          unified: "1F9DA-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9DA-1F3FE-200D-2640",
          image: "1f9da-1f3fe-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 2,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoletes: "1F9DA-1F3FE"
        },
        "1F3FF": {
          unified: "1F9DA-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9DA-1F3FF-200D-2640",
          image: "1f9da-1f3ff-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 3,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false,
          obsoletes: "1F9DA-1F3FF"
        }
      },
      obsoletes: "1F9DA",
      a: "Female Fairy",
      b: "1F9DA-200D-2640-FE0F",
      c: "1F9DA-200D-2640",
      k: [49, 55],
      o: 5
    },
    "flag-ph": { a: "Philippines Flag", b: "1F1F5-1F1ED", k: [3, 42], o: 2 },
    "flag-pk": { a: "Pakistan Flag", b: "1F1F5-1F1F0", k: [3, 43], o: 2 },
    black_circle: {
      a: "Medium Black Circle",
      b: "26AB",
      j: ["shape", "button", "round"],
      k: [53, 53],
      o: 2
    },
    wrench: {
      a: "Wrench",
      b: "1F527",
      j: ["tools", "diy", "ikea", "fix", "maintainer"],
      k: [28, 10],
      o: 2
    },
    vampire: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DB-1F3FB",
          non_qualified: null,
          image: "1f9db-1f3fb.png",
          sheet_x: 50,
          sheet_y: 29,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DB-1F3FB-200D-2640-FE0F"
        },
        "1F3FC": {
          unified: "1F9DB-1F3FC",
          non_qualified: null,
          image: "1f9db-1f3fc.png",
          sheet_x: 50,
          sheet_y: 30,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DB-1F3FC-200D-2640-FE0F"
        },
        "1F3FD": {
          unified: "1F9DB-1F3FD",
          non_qualified: null,
          image: "1f9db-1f3fd.png",
          sheet_x: 50,
          sheet_y: 31,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DB-1F3FD-200D-2640-FE0F"
        },
        "1F3FE": {
          unified: "1F9DB-1F3FE",
          non_qualified: null,
          image: "1f9db-1f3fe.png",
          sheet_x: 50,
          sheet_y: 32,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DB-1F3FE-200D-2640-FE0F"
        },
        "1F3FF": {
          unified: "1F9DB-1F3FF",
          non_qualified: null,
          image: "1f9db-1f3ff.png",
          sheet_x: 50,
          sheet_y: 33,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DB-1F3FF-200D-2640-FE0F"
        }
      },
      obsoleted_by: "1F9DB-200D-2640-FE0F",
      a: "Vampire",
      b: "1F9DB",
      k: [50, 28],
      o: 5
    },
    rain_cloud: {
      a: "Rain Cloud",
      b: "1F327-FE0F",
      c: "1F327",
      k: [5, 56],
      o: 2
    },
    snow_cloud: {
      a: "Snow Cloud",
      b: "1F328-FE0F",
      c: "1F328",
      k: [6, 0],
      o: 2
    },
    "flag-pl": { a: "Poland Flag", b: "1F1F5-1F1F1", k: [3, 44], o: 2 },
    male_vampire: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DB-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9DB-1F3FB-200D-2642",
          image: "1f9db-1f3fb-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 23,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9DB-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9DB-1F3FC-200D-2642",
          image: "1f9db-1f3fc-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 24,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9DB-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9DB-1F3FD-200D-2642",
          image: "1f9db-1f3fd-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 25,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9DB-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9DB-1F3FE-200D-2642",
          image: "1f9db-1f3fe-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 26,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9DB-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9DB-1F3FF-200D-2642",
          image: "1f9db-1f3ff-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 27,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Male Vampire",
      b: "1F9DB-200D-2642-FE0F",
      c: "1F9DB-200D-2642",
      k: [50, 22],
      o: 5
    },
    nut_and_bolt: {
      a: "Nut and Bolt",
      b: "1F529",
      j: ["handy", "tools", "fix"],
      k: [28, 12],
      o: 2
    },
    white_circle: {
      a: "Medium White Circle",
      b: "26AA",
      j: ["shape", "round"],
      k: [53, 52],
      o: 2
    },
    female_vampire: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DB-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9DB-1F3FB-200D-2640",
          image: "1f9db-1f3fb-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 17,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DB-1F3FB"
        },
        "1F3FC": {
          unified: "1F9DB-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9DB-1F3FC-200D-2640",
          image: "1f9db-1f3fc-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 18,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DB-1F3FC"
        },
        "1F3FD": {
          unified: "1F9DB-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9DB-1F3FD-200D-2640",
          image: "1f9db-1f3fd-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 19,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DB-1F3FD"
        },
        "1F3FE": {
          unified: "1F9DB-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9DB-1F3FE-200D-2640",
          image: "1f9db-1f3fe-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 20,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DB-1F3FE"
        },
        "1F3FF": {
          unified: "1F9DB-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9DB-1F3FF-200D-2640",
          image: "1f9db-1f3ff-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 21,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DB-1F3FF"
        }
      },
      obsoletes: "1F9DB",
      a: "Female Vampire",
      b: "1F9DB-200D-2640-FE0F",
      c: "1F9DB-200D-2640",
      k: [50, 16],
      o: 5
    },
    "flag-pm": {
      a: "St. Pierre & Miquelon Flag",
      b: "1F1F5-1F1F2",
      k: [3, 45],
      o: 2
    },
    large_red_square: { a: "Large Red Square", b: "1F7E5", k: [37, 8], o: 12 },
    lightning: {
      a: "Lightning",
      b: "1F329-FE0F",
      c: "1F329",
      k: [6, 1],
      n: ["lightning_cloud"],
      o: 2
    },
    gear: {
      a: "Gear",
      b: "2699-FE0F",
      c: "2699",
      j: ["cog"],
      k: [53, 47],
      o: 2
    },
    merperson: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DC-1F3FB",
          non_qualified: null,
          image: "1f9dc-1f3fb.png",
          sheet_x: 50,
          sheet_y: 47,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DC-1F3FB-200D-2642-FE0F"
        },
        "1F3FC": {
          unified: "1F9DC-1F3FC",
          non_qualified: null,
          image: "1f9dc-1f3fc.png",
          sheet_x: 50,
          sheet_y: 48,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DC-1F3FC-200D-2642-FE0F"
        },
        "1F3FD": {
          unified: "1F9DC-1F3FD",
          non_qualified: null,
          image: "1f9dc-1f3fd.png",
          sheet_x: 50,
          sheet_y: 49,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DC-1F3FD-200D-2642-FE0F"
        },
        "1F3FE": {
          unified: "1F9DC-1F3FE",
          non_qualified: null,
          image: "1f9dc-1f3fe.png",
          sheet_x: 50,
          sheet_y: 50,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DC-1F3FE-200D-2642-FE0F"
        },
        "1F3FF": {
          unified: "1F9DC-1F3FF",
          non_qualified: null,
          image: "1f9dc-1f3ff.png",
          sheet_x: 50,
          sheet_y: 51,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DC-1F3FF-200D-2642-FE0F"
        }
      },
      obsoleted_by: "1F9DC-200D-2642-FE0F",
      a: "Merperson",
      b: "1F9DC",
      k: [50, 46],
      o: 5
    },
    tornado: {
      a: "Tornado",
      b: "1F32A-FE0F",
      c: "1F32A",
      j: ["weather", "cyclone", "twister"],
      k: [6, 2],
      n: ["tornado_cloud"],
      o: 2
    },
    large_orange_square: {
      a: "Large Orange Square",
      b: "1F7E7",
      k: [37, 10],
      o: 12
    },
    "flag-pn": {
      a: "Pitcairn Islands Flag",
      b: "1F1F5-1F1F3",
      k: [3, 46],
      o: 2
    },
    compression: {
      a: "Compression",
      b: "1F5DC-FE0F",
      c: "1F5DC",
      k: [30, 21],
      o: 2
    },
    merman: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DC-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9DC-1F3FB-200D-2642",
          image: "1f9dc-1f3fb-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 41,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DC-1F3FB"
        },
        "1F3FC": {
          unified: "1F9DC-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9DC-1F3FC-200D-2642",
          image: "1f9dc-1f3fc-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 42,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DC-1F3FC"
        },
        "1F3FD": {
          unified: "1F9DC-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9DC-1F3FD-200D-2642",
          image: "1f9dc-1f3fd-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 43,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DC-1F3FD"
        },
        "1F3FE": {
          unified: "1F9DC-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9DC-1F3FE-200D-2642",
          image: "1f9dc-1f3fe-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 44,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DC-1F3FE"
        },
        "1F3FF": {
          unified: "1F9DC-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9DC-1F3FF-200D-2642",
          image: "1f9dc-1f3ff-200d-2642-fe0f.png",
          sheet_x: 50,
          sheet_y: 45,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DC-1F3FF"
        }
      },
      obsoletes: "1F9DC",
      a: "Merman",
      b: "1F9DC-200D-2642-FE0F",
      c: "1F9DC-200D-2642",
      k: [50, 40],
      o: 5
    },
    large_yellow_square: {
      a: "Large Yellow Square",
      b: "1F7E8",
      k: [37, 11],
      o: 12
    },
    fog: {
      a: "Fog",
      b: "1F32B-FE0F",
      c: "1F32B",
      j: ["weather"],
      k: [6, 3],
      o: 2
    },
    scales: { a: "Scales", b: "2696-FE0F", c: "2696", k: [53, 45], o: 2 },
    "flag-pr": { a: "Puerto Rico Flag", b: "1F1F5-1F1F7", k: [3, 47], o: 2 },
    wind_blowing_face: {
      a: "Wind Blowing Face",
      b: "1F32C-FE0F",
      c: "1F32C",
      k: [6, 4],
      o: 2
    },
    "flag-ps": {
      a: "Palestinian Territories Flag",
      b: "1F1F5-1F1F8",
      k: [3, 48],
      o: 2
    },
    mermaid: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DC-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9DC-1F3FB-200D-2640",
          image: "1f9dc-1f3fb-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 35,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9DC-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9DC-1F3FC-200D-2640",
          image: "1f9dc-1f3fc-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 36,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9DC-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9DC-1F3FD-200D-2640",
          image: "1f9dc-1f3fd-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 37,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9DC-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9DC-1F3FE-200D-2640",
          image: "1f9dc-1f3fe-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 38,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9DC-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9DC-1F3FF-200D-2640",
          image: "1f9dc-1f3ff-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 39,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Mermaid",
      b: "1F9DC-200D-2640-FE0F",
      c: "1F9DC-200D-2640",
      k: [50, 34],
      o: 5
    },
    probing_cane: { a: "Probing Cane", b: "1F9AF", k: [43, 3], o: 12 },
    large_green_square: {
      a: "Large Green Square",
      b: "1F7E9",
      k: [37, 12],
      o: 12
    },
    "flag-pt": { a: "Portugal Flag", b: "1F1F5-1F1F9", k: [3, 49], o: 2 },
    link: {
      a: "Link Symbol",
      b: "1F517",
      j: ["rings", "url"],
      k: [27, 51],
      o: 2
    },
    large_blue_square: {
      a: "Large Blue Square",
      b: "1F7E6",
      k: [37, 9],
      o: 12
    },
    elf: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DD-1F3FB",
          non_qualified: null,
          image: "1f9dd-1f3fb.png",
          sheet_x: 51,
          sheet_y: 8,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DD-1F3FB-200D-2642-FE0F"
        },
        "1F3FC": {
          unified: "1F9DD-1F3FC",
          non_qualified: null,
          image: "1f9dd-1f3fc.png",
          sheet_x: 51,
          sheet_y: 9,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DD-1F3FC-200D-2642-FE0F"
        },
        "1F3FD": {
          unified: "1F9DD-1F3FD",
          non_qualified: null,
          image: "1f9dd-1f3fd.png",
          sheet_x: 51,
          sheet_y: 10,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DD-1F3FD-200D-2642-FE0F"
        },
        "1F3FE": {
          unified: "1F9DD-1F3FE",
          non_qualified: null,
          image: "1f9dd-1f3fe.png",
          sheet_x: 51,
          sheet_y: 11,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DD-1F3FE-200D-2642-FE0F"
        },
        "1F3FF": {
          unified: "1F9DD-1F3FF",
          non_qualified: null,
          image: "1f9dd-1f3ff.png",
          sheet_x: 51,
          sheet_y: 12,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9DD-1F3FF-200D-2642-FE0F"
        }
      },
      obsoleted_by: "1F9DD-200D-2642-FE0F",
      a: "Elf",
      b: "1F9DD",
      k: [51, 7],
      o: 5
    },
    cyclone: {
      a: "Cyclone",
      b: "1F300",
      j: [
        "weather",
        "swirl",
        "blue",
        "cloud",
        "vortex",
        "spiral",
        "whirlpool",
        "spin",
        "tornado",
        "hurricane",
        "typhoon"
      ],
      k: [5, 19],
      o: 2
    },
    rainbow: {
      a: "Rainbow",
      b: "1F308",
      j: ["nature", "happy", "unicorn_face", "photo", "sky", "spring"],
      k: [5, 27],
      o: 2
    },
    male_elf: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DD-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9DD-1F3FB-200D-2642",
          image: "1f9dd-1f3fb-200d-2642-fe0f.png",
          sheet_x: 51,
          sheet_y: 2,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DD-1F3FB"
        },
        "1F3FC": {
          unified: "1F9DD-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9DD-1F3FC-200D-2642",
          image: "1f9dd-1f3fc-200d-2642-fe0f.png",
          sheet_x: 51,
          sheet_y: 3,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DD-1F3FC"
        },
        "1F3FD": {
          unified: "1F9DD-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9DD-1F3FD-200D-2642",
          image: "1f9dd-1f3fd-200d-2642-fe0f.png",
          sheet_x: 51,
          sheet_y: 4,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DD-1F3FD"
        },
        "1F3FE": {
          unified: "1F9DD-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9DD-1F3FE-200D-2642",
          image: "1f9dd-1f3fe-200d-2642-fe0f.png",
          sheet_x: 51,
          sheet_y: 5,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DD-1F3FE"
        },
        "1F3FF": {
          unified: "1F9DD-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9DD-1F3FF-200D-2642",
          image: "1f9dd-1f3ff-200d-2642-fe0f.png",
          sheet_x: 51,
          sheet_y: 6,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9DD-1F3FF"
        }
      },
      obsoletes: "1F9DD",
      a: "Male Elf",
      b: "1F9DD-200D-2642-FE0F",
      c: "1F9DD-200D-2642",
      k: [51, 1],
      o: 5
    },
    "flag-pw": { a: "Palau Flag", b: "1F1F5-1F1FC", k: [3, 50], o: 2 },
    chains: {
      a: "Chains",
      b: "26D3-FE0F",
      c: "26D3",
      j: ["lock", "arrest"],
      k: [54, 7],
      o: 2
    },
    large_purple_square: {
      a: "Large Purple Square",
      b: "1F7EA",
      k: [37, 13],
      o: 12
    },
    female_elf: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9DD-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9DD-1F3FB-200D-2640",
          image: "1f9dd-1f3fb-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 53,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9DD-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9DD-1F3FC-200D-2640",
          image: "1f9dd-1f3fc-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 54,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9DD-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9DD-1F3FD-200D-2640",
          image: "1f9dd-1f3fd-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 55,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9DD-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9DD-1F3FE-200D-2640",
          image: "1f9dd-1f3fe-200d-2640-fe0f.png",
          sheet_x: 50,
          sheet_y: 56,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9DD-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9DD-1F3FF-200D-2640",
          image: "1f9dd-1f3ff-200d-2640-fe0f.png",
          sheet_x: 51,
          sheet_y: 0,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Female Elf",
      b: "1F9DD-200D-2640-FE0F",
      c: "1F9DD-200D-2640",
      k: [50, 52],
      o: 5
    },
    "flag-py": { a: "Paraguay Flag", b: "1F1F5-1F1FE", k: [3, 51], o: 2 },
    closed_umbrella: {
      a: "Closed Umbrella",
      b: "1F302",
      j: ["weather", "rain", "drizzle"],
      k: [5, 21],
      o: 2
    },
    toolbox: { a: "Toolbox", b: "1F9F0", k: [51, 35], o: 11 },
    large_brown_square: {
      a: "Large Brown Square",
      b: "1F7EB",
      k: [37, 14],
      o: 12
    },
    magnet: { a: "Magnet", b: "1F9F2", k: [51, 37], o: 11 },
    genie: {
      obsoleted_by: "1F9DE-200D-2642-FE0F",
      a: "Genie",
      b: "1F9DE",
      k: [51, 15],
      o: 5
    },
    "flag-qa": { a: "Qatar Flag", b: "1F1F6-1F1E6", k: [3, 52], o: 2 },
    umbrella: {
      a: "Umbrella",
      b: "2602-FE0F",
      c: "2602",
      j: ["rainy", "weather", "spring"],
      k: [52, 51],
      o: 2
    },
    black_large_square: {
      a: "Black Large Square",
      b: "2B1B",
      j: ["shape", "icon", "button"],
      k: [55, 40],
      o: 2
    },
    male_genie: {
      obsoletes: "1F9DE",
      a: "Male Genie",
      b: "1F9DE-200D-2642-FE0F",
      c: "1F9DE-200D-2642",
      k: [51, 14],
      o: 5
    },
    umbrella_with_rain_drops: {
      a: "Umbrella with Rain Drops",
      b: "2614",
      k: [52, 56],
      o: 2
    },
    "flag-re": { a: "R\xE9union Flag", b: "1F1F7-1F1EA", k: [3, 53], o: 2 },
    white_large_square: {
      a: "White Large Square",
      b: "2B1C",
      j: ["shape", "icon", "stone", "button"],
      k: [55, 41],
      o: 2
    },
    alembic: {
      a: "Alembic",
      b: "2697-FE0F",
      c: "2697",
      j: ["distilling", "science", "experiment", "chemistry"],
      k: [53, 46],
      o: 2
    },
    black_medium_square: {
      a: "Black Medium Square",
      b: "25FC-FE0F",
      c: "25FC",
      j: ["shape", "button", "icon"],
      k: [52, 46],
      o: 2
    },
    test_tube: { a: "Test Tube", b: "1F9EA", k: [51, 29], o: 11 },
    "flag-ro": { a: "Romania Flag", b: "1F1F7-1F1F4", k: [3, 54], o: 2 },
    female_genie: {
      a: "Female Genie",
      b: "1F9DE-200D-2640-FE0F",
      c: "1F9DE-200D-2640",
      k: [51, 13],
      o: 5
    },
    umbrella_on_ground: {
      a: "Umbrella on Ground",
      b: "26F1-FE0F",
      c: "26F1",
      k: [54, 12],
      o: 2
    },
    zombie: {
      obsoleted_by: "1F9DF-200D-2642-FE0F",
      a: "Zombie",
      b: "1F9DF",
      k: [51, 18],
      o: 5
    },
    zap: {
      a: "High Voltage Sign",
      b: "26A1",
      j: ["thunder", "weather", "lightning bolt", "fast"],
      k: [53, 51],
      o: 2
    },
    white_medium_square: {
      a: "White Medium Square",
      b: "25FB-FE0F",
      c: "25FB",
      j: ["shape", "stone", "icon"],
      k: [52, 45],
      o: 2
    },
    "flag-rs": { a: "Serbia Flag", b: "1F1F7-1F1F8", k: [3, 55], o: 2 },
    petri_dish: { a: "Petri Dish", b: "1F9EB", k: [51, 30], o: 11 },
    snowflake: {
      a: "Snowflake",
      b: "2744-FE0F",
      c: "2744",
      j: ["winter", "season", "cold", "weather", "christmas", "xmas"],
      k: [55, 19],
      o: 2
    },
    dna: { a: "Dna Double Helix", b: "1F9EC", k: [51, 31], o: 11 },
    male_zombie: {
      obsoletes: "1F9DF",
      a: "Male Zombie",
      b: "1F9DF-200D-2642-FE0F",
      c: "1F9DF-200D-2642",
      k: [51, 17],
      o: 5
    },
    black_medium_small_square: {
      a: "Black Medium Small Square",
      b: "25FE",
      j: ["icon", "shape", "button"],
      k: [52, 48],
      o: 2
    },
    ru: {
      a: "Russia Flag",
      b: "1F1F7-1F1FA",
      j: ["russian", "federation", "flag", "nation", "country", "banner"],
      k: [3, 56],
      n: ["flag-ru"],
      o: 2
    },
    female_zombie: {
      a: "Female Zombie",
      b: "1F9DF-200D-2640-FE0F",
      c: "1F9DF-200D-2640",
      k: [51, 16],
      o: 5
    },
    "flag-rw": { a: "Rwanda Flag", b: "1F1F7-1F1FC", k: [4, 0], o: 2 },
    snowman: {
      a: "Snowman",
      b: "2603-FE0F",
      c: "2603",
      j: [
        "winter",
        "season",
        "cold",
        "weather",
        "christmas",
        "xmas",
        "frozen",
        "without_snow"
      ],
      k: [52, 52],
      o: 2
    },
    white_medium_small_square: {
      a: "White Medium Small Square",
      b: "25FD",
      j: ["shape", "stone", "icon", "button"],
      k: [52, 47],
      o: 2
    },
    microscope: {
      a: "Microscope",
      b: "1F52C",
      j: ["laboratory", "experiment", "zoomin", "science", "study"],
      k: [28, 15],
      o: 2
    },
    snowman_without_snow: {
      a: "Snowman Without Snow",
      b: "26C4",
      k: [54, 1],
      o: 2
    },
    telescope: {
      a: "Telescope",
      b: "1F52D",
      j: ["stars", "space", "zoom", "science", "astronomy"],
      k: [28, 16],
      o: 2
    },
    massage: {
      skin_variations: {
        "1F3FB": {
          unified: "1F486-1F3FB",
          non_qualified: null,
          image: "1f486-1f3fb.png",
          sheet_x: 24,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F486-1F3FC",
          non_qualified: null,
          image: "1f486-1f3fc.png",
          sheet_x: 24,
          sheet_y: 53,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F486-1F3FD",
          non_qualified: null,
          image: "1f486-1f3fd.png",
          sheet_x: 24,
          sheet_y: 54,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F486-1F3FE",
          non_qualified: null,
          image: "1f486-1f3fe.png",
          sheet_x: 24,
          sheet_y: 55,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F486-1F3FF",
          non_qualified: null,
          image: "1f486-1f3ff.png",
          sheet_x: 24,
          sheet_y: 56,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F486-200D-2640-FE0F",
      a: "Face Massage",
      b: "1F486",
      k: [24, 51],
      o: 2
    },
    black_small_square: {
      a: "Black Small Square",
      b: "25AA-FE0F",
      c: "25AA",
      j: ["shape", "icon"],
      k: [52, 41],
      o: 2
    },
    "flag-sa": { a: "Saudi Arabia Flag", b: "1F1F8-1F1E6", k: [4, 1], o: 2 },
    "man-getting-massage": {
      skin_variations: {
        "1F3FB": {
          unified: "1F486-1F3FB-200D-2642-FE0F",
          non_qualified: "1F486-1F3FB-200D-2642",
          image: "1f486-1f3fb-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F486-1F3FC-200D-2642-FE0F",
          non_qualified: "1F486-1F3FC-200D-2642",
          image: "1f486-1f3fc-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F486-1F3FD-200D-2642-FE0F",
          non_qualified: "1F486-1F3FD-200D-2642",
          image: "1f486-1f3fd-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F486-1F3FE-200D-2642-FE0F",
          non_qualified: "1F486-1F3FE-200D-2642",
          image: "1f486-1f3fe-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F486-1F3FF-200D-2642-FE0F",
          non_qualified: "1F486-1F3FF-200D-2642",
          image: "1f486-1f3ff-200d-2642-fe0f.png",
          sheet_x: 24,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Getting Massage",
      b: "1F486-200D-2642-FE0F",
      c: "1F486-200D-2642",
      k: [24, 45],
      o: 4
    },
    comet: {
      a: "Comet",
      b: "2604-FE0F",
      c: "2604",
      j: ["space"],
      k: [52, 53],
      o: 2
    },
    white_small_square: {
      a: "White Small Square",
      b: "25AB-FE0F",
      c: "25AB",
      j: ["shape", "icon"],
      k: [52, 42],
      o: 2
    },
    "flag-sb": { a: "Solomon Islands Flag", b: "1F1F8-1F1E7", k: [4, 2], o: 2 },
    satellite_antenna: {
      a: "Satellite Antenna",
      b: "1F4E1",
      k: [26, 55],
      o: 2
    },
    large_orange_diamond: {
      a: "Large Orange Diamond",
      b: "1F536",
      j: ["shape", "jewel", "gem"],
      k: [28, 25],
      o: 2
    },
    "woman-getting-massage": {
      skin_variations: {
        "1F3FB": {
          unified: "1F486-1F3FB-200D-2640-FE0F",
          non_qualified: "1F486-1F3FB-200D-2640",
          image: "1f486-1f3fb-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F486-1F3FC-200D-2640-FE0F",
          non_qualified: "1F486-1F3FC-200D-2640",
          image: "1f486-1f3fc-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F486-1F3FD-200D-2640-FE0F",
          non_qualified: "1F486-1F3FD-200D-2640",
          image: "1f486-1f3fd-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F486-1F3FE-200D-2640-FE0F",
          non_qualified: "1F486-1F3FE-200D-2640",
          image: "1f486-1f3fe-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F486-1F3FF-200D-2640-FE0F",
          non_qualified: "1F486-1F3FF-200D-2640",
          image: "1f486-1f3ff-200d-2640-fe0f.png",
          sheet_x: 24,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F486",
      a: "Woman Getting Massage",
      b: "1F486-200D-2640-FE0F",
      c: "1F486-200D-2640",
      k: [24, 39],
      o: 4
    },
    fire: {
      a: "Fire",
      b: "1F525",
      j: ["hot", "cook", "flame"],
      k: [28, 8],
      o: 2
    },
    syringe: {
      a: "Syringe",
      b: "1F489",
      j: [
        "health",
        "hospital",
        "drugs",
        "blood",
        "medicine",
        "needle",
        "doctor",
        "nurse"
      ],
      k: [25, 19],
      o: 2
    },
    "flag-sc": { a: "Seychelles Flag", b: "1F1F8-1F1E8", k: [4, 3], o: 2 },
    large_blue_diamond: {
      a: "Large Blue Diamond",
      b: "1F537",
      j: ["shape", "jewel", "gem"],
      k: [28, 26],
      o: 2
    },
    "flag-sd": { a: "Sudan Flag", b: "1F1F8-1F1E9", k: [4, 4], o: 2 },
    droplet: {
      a: "Droplet",
      b: "1F4A7",
      j: ["water", "drip", "faucet", "spring"],
      k: [25, 49],
      o: 2
    },
    drop_of_blood: { a: "Drop of Blood", b: "1FA78", k: [51, 55], o: 12 },
    haircut: {
      skin_variations: {
        "1F3FB": {
          unified: "1F487-1F3FB",
          non_qualified: null,
          image: "1f487-1f3fb.png",
          sheet_x: 25,
          sheet_y: 13,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F487-1F3FC",
          non_qualified: null,
          image: "1f487-1f3fc.png",
          sheet_x: 25,
          sheet_y: 14,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F487-1F3FD",
          non_qualified: null,
          image: "1f487-1f3fd.png",
          sheet_x: 25,
          sheet_y: 15,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F487-1F3FE",
          non_qualified: null,
          image: "1f487-1f3fe.png",
          sheet_x: 25,
          sheet_y: 16,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F487-1F3FF",
          non_qualified: null,
          image: "1f487-1f3ff.png",
          sheet_x: 25,
          sheet_y: 17,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F487-200D-2640-FE0F",
      a: "Haircut",
      b: "1F487",
      k: [25, 12],
      o: 2
    },
    ocean: {
      a: "Water Wave",
      b: "1F30A",
      j: ["sea", "water", "wave", "nature", "tsunami", "disaster"],
      k: [5, 29],
      o: 2
    },
    "flag-se": { a: "Sweden Flag", b: "1F1F8-1F1EA", k: [4, 5], o: 2 },
    "man-getting-haircut": {
      skin_variations: {
        "1F3FB": {
          unified: "1F487-1F3FB-200D-2642-FE0F",
          non_qualified: "1F487-1F3FB-200D-2642",
          image: "1f487-1f3fb-200d-2642-fe0f.png",
          sheet_x: 25,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F487-1F3FC-200D-2642-FE0F",
          non_qualified: "1F487-1F3FC-200D-2642",
          image: "1f487-1f3fc-200d-2642-fe0f.png",
          sheet_x: 25,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F487-1F3FD-200D-2642-FE0F",
          non_qualified: "1F487-1F3FD-200D-2642",
          image: "1f487-1f3fd-200d-2642-fe0f.png",
          sheet_x: 25,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F487-1F3FE-200D-2642-FE0F",
          non_qualified: "1F487-1F3FE-200D-2642",
          image: "1f487-1f3fe-200d-2642-fe0f.png",
          sheet_x: 25,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F487-1F3FF-200D-2642-FE0F",
          non_qualified: "1F487-1F3FF-200D-2642",
          image: "1f487-1f3ff-200d-2642-fe0f.png",
          sheet_x: 25,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Getting Haircut",
      b: "1F487-200D-2642-FE0F",
      c: "1F487-200D-2642",
      k: [25, 6],
      o: 4
    },
    small_orange_diamond: {
      a: "Small Orange Diamond",
      b: "1F538",
      j: ["shape", "jewel", "gem"],
      k: [28, 27],
      o: 2
    },
    pill: {
      a: "Pill",
      b: "1F48A",
      j: ["health", "medicine", "doctor", "pharmacy", "drug"],
      k: [25, 20],
      o: 2
    },
    "woman-getting-haircut": {
      skin_variations: {
        "1F3FB": {
          unified: "1F487-1F3FB-200D-2640-FE0F",
          non_qualified: "1F487-1F3FB-200D-2640",
          image: "1f487-1f3fb-200d-2640-fe0f.png",
          sheet_x: 25,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F487-1F3FC-200D-2640-FE0F",
          non_qualified: "1F487-1F3FC-200D-2640",
          image: "1f487-1f3fc-200d-2640-fe0f.png",
          sheet_x: 25,
          sheet_y: 2,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F487-1F3FD-200D-2640-FE0F",
          non_qualified: "1F487-1F3FD-200D-2640",
          image: "1f487-1f3fd-200d-2640-fe0f.png",
          sheet_x: 25,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F487-1F3FE-200D-2640-FE0F",
          non_qualified: "1F487-1F3FE-200D-2640",
          image: "1f487-1f3fe-200d-2640-fe0f.png",
          sheet_x: 25,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F487-1F3FF-200D-2640-FE0F",
          non_qualified: "1F487-1F3FF-200D-2640",
          image: "1f487-1f3ff-200d-2640-fe0f.png",
          sheet_x: 25,
          sheet_y: 5,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F487",
      a: "Woman Getting Haircut",
      b: "1F487-200D-2640-FE0F",
      c: "1F487-200D-2640",
      k: [25, 0],
      o: 4
    },
    small_blue_diamond: {
      a: "Small Blue Diamond",
      b: "1F539",
      j: ["shape", "jewel", "gem"],
      k: [28, 28],
      o: 2
    },
    "flag-sg": { a: "Singapore Flag", b: "1F1F8-1F1EC", k: [4, 6], o: 2 },
    adhesive_bandage: { a: "Adhesive Bandage", b: "1FA79", k: [51, 56], o: 12 },
    walking: {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B6-1F3FB",
          non_qualified: null,
          image: "1f6b6-1f3fb.png",
          sheet_x: 36,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F6B6-1F3FC",
          non_qualified: null,
          image: "1f6b6-1f3fc.png",
          sheet_x: 36,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F6B6-1F3FD",
          non_qualified: null,
          image: "1f6b6-1f3fd.png",
          sheet_x: 36,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F6B6-1F3FE",
          non_qualified: null,
          image: "1f6b6-1f3fe.png",
          sheet_x: 36,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F6B6-1F3FF",
          non_qualified: null,
          image: "1f6b6-1f3ff.png",
          sheet_x: 36,
          sheet_y: 7,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F6B6-200D-2642-FE0F",
      a: "Pedestrian",
      b: "1F6B6",
      k: [36, 2],
      o: 2
    },
    small_red_triangle: {
      a: "Up-Pointing Red Triangle",
      b: "1F53A",
      j: ["shape", "direction", "up", "top"],
      k: [28, 29],
      o: 2
    },
    "flag-sh": { a: "St. Helena Flag", b: "1F1F8-1F1ED", k: [4, 7], o: 2 },
    stethoscope: { a: "Stethoscope", b: "1FA7A", k: [52, 0], o: 12 },
    "man-walking": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B6-1F3FB-200D-2642-FE0F",
          non_qualified: "1F6B6-1F3FB-200D-2642",
          image: "1f6b6-1f3fb-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6B6-1F3FC-200D-2642-FE0F",
          non_qualified: "1F6B6-1F3FC-200D-2642",
          image: "1f6b6-1f3fc-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6B6-1F3FD-200D-2642-FE0F",
          non_qualified: "1F6B6-1F3FD-200D-2642",
          image: "1f6b6-1f3fd-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6B6-1F3FE-200D-2642-FE0F",
          non_qualified: "1F6B6-1F3FE-200D-2642",
          image: "1f6b6-1f3fe-200d-2642-fe0f.png",
          sheet_x: 36,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6B6-1F3FF-200D-2642-FE0F",
          non_qualified: "1F6B6-1F3FF-200D-2642",
          image: "1f6b6-1f3ff-200d-2642-fe0f.png",
          sheet_x: 36,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F6B6",
      a: "Man Walking",
      b: "1F6B6-200D-2642-FE0F",
      c: "1F6B6-200D-2642",
      k: [35, 53],
      o: 4
    },
    "flag-si": { a: "Slovenia Flag", b: "1F1F8-1F1EE", k: [4, 8], o: 2 },
    door: {
      a: "Door",
      b: "1F6AA",
      j: ["house", "entry", "exit"],
      k: [35, 1],
      o: 2
    },
    small_red_triangle_down: {
      a: "Down-Pointing Red Triangle",
      b: "1F53B",
      j: ["shape", "direction", "bottom"],
      k: [28, 30],
      o: 2
    },
    "flag-sj": {
      a: "Svalbard & Jan Mayen Flag",
      b: "1F1F8-1F1EF",
      k: [4, 9],
      o: 2
    },
    diamond_shape_with_a_dot_inside: {
      a: "Diamond Shape with a Dot Inside",
      b: "1F4A0",
      j: ["jewel", "blue", "gem", "crystal", "fancy"],
      k: [25, 42],
      o: 2
    },
    "woman-walking": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B6-1F3FB-200D-2640-FE0F",
          non_qualified: "1F6B6-1F3FB-200D-2640",
          image: "1f6b6-1f3fb-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6B6-1F3FC-200D-2640-FE0F",
          non_qualified: "1F6B6-1F3FC-200D-2640",
          image: "1f6b6-1f3fc-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6B6-1F3FD-200D-2640-FE0F",
          non_qualified: "1F6B6-1F3FD-200D-2640",
          image: "1f6b6-1f3fd-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6B6-1F3FE-200D-2640-FE0F",
          non_qualified: "1F6B6-1F3FE-200D-2640",
          image: "1f6b6-1f3fe-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6B6-1F3FF-200D-2640-FE0F",
          non_qualified: "1F6B6-1F3FF-200D-2640",
          image: "1f6b6-1f3ff-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Walking",
      b: "1F6B6-200D-2640-FE0F",
      c: "1F6B6-200D-2640",
      k: [35, 47],
      o: 4
    },
    bed: {
      a: "Bed",
      b: "1F6CF-FE0F",
      c: "1F6CF",
      j: ["sleep", "rest"],
      k: [36, 37],
      o: 2
    },
    radio_button: {
      a: "Radio Button",
      b: "1F518",
      j: ["input", "old", "music", "circle"],
      k: [27, 52],
      o: 2
    },
    "flag-sk": { a: "Slovakia Flag", b: "1F1F8-1F1F0", k: [4, 10], o: 2 },
    standing_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CD-1F3FB",
          non_qualified: null,
          image: "1f9cd-1f3fb.png",
          sheet_x: 44,
          sheet_y: 32,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CD-1F3FC",
          non_qualified: null,
          image: "1f9cd-1f3fc.png",
          sheet_x: 44,
          sheet_y: 33,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CD-1F3FD",
          non_qualified: null,
          image: "1f9cd-1f3fd.png",
          sheet_x: 44,
          sheet_y: 34,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CD-1F3FE",
          non_qualified: null,
          image: "1f9cd-1f3fe.png",
          sheet_x: 44,
          sheet_y: 35,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CD-1F3FF",
          non_qualified: null,
          image: "1f9cd-1f3ff.png",
          sheet_x: 44,
          sheet_y: 36,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Standing Person",
      b: "1F9CD",
      k: [44, 31],
      o: 12
    },
    couch_and_lamp: {
      a: "Couch and Lamp",
      b: "1F6CB-FE0F",
      c: "1F6CB",
      j: ["read", "chill"],
      k: [36, 28],
      o: 2
    },
    man_standing: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CD-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9CD-1F3FB-200D-2642",
          image: "1f9cd-1f3fb-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 26,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CD-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9CD-1F3FC-200D-2642",
          image: "1f9cd-1f3fc-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 27,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CD-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9CD-1F3FD-200D-2642",
          image: "1f9cd-1f3fd-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 28,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CD-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9CD-1F3FE-200D-2642",
          image: "1f9cd-1f3fe-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 29,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CD-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9CD-1F3FF-200D-2642",
          image: "1f9cd-1f3ff-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 30,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Standing",
      b: "1F9CD-200D-2642-FE0F",
      c: "1F9CD-200D-2642",
      k: [44, 25],
      o: 12
    },
    white_square_button: {
      a: "White Square Button",
      b: "1F533",
      j: ["shape", "input"],
      k: [28, 22],
      o: 2
    },
    "flag-sl": { a: "Sierra Leone Flag", b: "1F1F8-1F1F1", k: [4, 11], o: 2 },
    chair: { a: "Chair", b: "1FA91", k: [52, 5], o: 12 },
    toilet: {
      a: "Toilet",
      b: "1F6BD",
      j: ["restroom", "wc", "washroom", "bathroom", "potty"],
      k: [36, 14],
      o: 2
    },
    black_square_button: {
      a: "Black Square Button",
      b: "1F532",
      j: ["shape", "input", "frame"],
      k: [28, 21],
      o: 2
    },
    "flag-sm": { a: "San Marino Flag", b: "1F1F8-1F1F2", k: [4, 12], o: 2 },
    woman_standing: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CD-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9CD-1F3FB-200D-2640",
          image: "1f9cd-1f3fb-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 20,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CD-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9CD-1F3FC-200D-2640",
          image: "1f9cd-1f3fc-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CD-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9CD-1F3FD-200D-2640",
          image: "1f9cd-1f3fd-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CD-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9CD-1F3FE-200D-2640",
          image: "1f9cd-1f3fe-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 23,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CD-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9CD-1F3FF-200D-2640",
          image: "1f9cd-1f3ff-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 24,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Standing",
      b: "1F9CD-200D-2640-FE0F",
      c: "1F9CD-200D-2640",
      k: [44, 19],
      o: 12
    },
    kneeling_person: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CE-1F3FB",
          non_qualified: null,
          image: "1f9ce-1f3fb.png",
          sheet_x: 44,
          sheet_y: 50,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CE-1F3FC",
          non_qualified: null,
          image: "1f9ce-1f3fc.png",
          sheet_x: 44,
          sheet_y: 51,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CE-1F3FD",
          non_qualified: null,
          image: "1f9ce-1f3fd.png",
          sheet_x: 44,
          sheet_y: 52,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CE-1F3FE",
          non_qualified: null,
          image: "1f9ce-1f3fe.png",
          sheet_x: 44,
          sheet_y: 53,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CE-1F3FF",
          non_qualified: null,
          image: "1f9ce-1f3ff.png",
          sheet_x: 44,
          sheet_y: 54,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Kneeling Person",
      b: "1F9CE",
      k: [44, 49],
      o: 12
    },
    shower: {
      a: "Shower",
      b: "1F6BF",
      j: ["clean", "water", "bathroom"],
      k: [36, 16],
      o: 2
    },
    "flag-sn": { a: "Senegal Flag", b: "1F1F8-1F1F3", k: [4, 13], o: 2 },
    bathtub: {
      a: "Bathtub",
      b: "1F6C1",
      j: ["clean", "shower", "bathroom"],
      k: [36, 23],
      o: 2
    },
    "flag-so": { a: "Somalia Flag", b: "1F1F8-1F1F4", k: [4, 14], o: 2 },
    man_kneeling: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CE-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9CE-1F3FB-200D-2642",
          image: "1f9ce-1f3fb-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 44,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CE-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9CE-1F3FC-200D-2642",
          image: "1f9ce-1f3fc-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 45,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CE-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9CE-1F3FD-200D-2642",
          image: "1f9ce-1f3fd-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 46,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CE-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9CE-1F3FE-200D-2642",
          image: "1f9ce-1f3fe-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 47,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CE-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9CE-1F3FF-200D-2642",
          image: "1f9ce-1f3ff-200d-2642-fe0f.png",
          sheet_x: 44,
          sheet_y: 48,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Kneeling",
      b: "1F9CE-200D-2642-FE0F",
      c: "1F9CE-200D-2642",
      k: [44, 43],
      o: 12
    },
    "flag-sr": { a: "Suriname Flag", b: "1F1F8-1F1F7", k: [4, 15], o: 2 },
    woman_kneeling: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9CE-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9CE-1F3FB-200D-2640",
          image: "1f9ce-1f3fb-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 38,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9CE-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9CE-1F3FC-200D-2640",
          image: "1f9ce-1f3fc-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 39,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9CE-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9CE-1F3FD-200D-2640",
          image: "1f9ce-1f3fd-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 40,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9CE-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9CE-1F3FE-200D-2640",
          image: "1f9ce-1f3fe-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 41,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9CE-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9CE-1F3FF-200D-2640",
          image: "1f9ce-1f3ff-200d-2640-fe0f.png",
          sheet_x: 44,
          sheet_y: 42,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Kneeling",
      b: "1F9CE-200D-2640-FE0F",
      c: "1F9CE-200D-2640",
      k: [44, 37],
      o: 12
    },
    razor: { a: "Razor", b: "1FA92", k: [52, 6], o: 12 },
    person_with_probing_cane: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F9AF",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f9af.png",
          sheet_x: 47,
          sheet_y: 8,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F9AF",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f9af.png",
          sheet_x: 47,
          sheet_y: 9,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F9AF",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f9af.png",
          sheet_x: 47,
          sheet_y: 10,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F9AF",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f9af.png",
          sheet_x: 47,
          sheet_y: 11,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F9AF",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f9af.png",
          sheet_x: 47,
          sheet_y: 12,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Person with Probing Cane",
      b: "1F9D1-200D-1F9AF",
      k: [47, 7],
      o: 12
    },
    "flag-ss": { a: "South Sudan Flag", b: "1F1F8-1F1F8", k: [4, 16], o: 2 },
    lotion_bottle: { a: "Lotion Bottle", b: "1F9F4", k: [51, 39], o: 11 },
    "flag-st": {
      a: "S\xE3o Tom\xE9 & Pr\xEDncipe Flag",
      b: "1F1F8-1F1F9",
      k: [4, 17],
      o: 2
    },
    safety_pin: { a: "Safety Pin", b: "1F9F7", k: [51, 42], o: 11 },
    man_with_probing_cane: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F9AF",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f9af.png",
          sheet_x: 16,
          sheet_y: 18,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F9AF",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f9af.png",
          sheet_x: 16,
          sheet_y: 19,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F9AF",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f9af.png",
          sheet_x: 16,
          sheet_y: 20,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F9AF",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f9af.png",
          sheet_x: 16,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F9AF",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f9af.png",
          sheet_x: 16,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man with Probing Cane",
      b: "1F468-200D-1F9AF",
      k: [16, 17],
      o: 12
    },
    broom: { a: "Broom", b: "1F9F9", k: [51, 44], o: 11 },
    woman_with_probing_cane: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F9AF",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f9af.png",
          sheet_x: 19,
          sheet_y: 3,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F9AF",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f9af.png",
          sheet_x: 19,
          sheet_y: 4,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F9AF",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f9af.png",
          sheet_x: 19,
          sheet_y: 5,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F9AF",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f9af.png",
          sheet_x: 19,
          sheet_y: 6,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F9AF",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f9af.png",
          sheet_x: 19,
          sheet_y: 7,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman with Probing Cane",
      b: "1F469-200D-1F9AF",
      k: [19, 2],
      o: 12
    },
    "flag-sv": { a: "El Salvador Flag", b: "1F1F8-1F1FB", k: [4, 18], o: 2 },
    "flag-sx": { a: "Sint Maarten Flag", b: "1F1F8-1F1FD", k: [4, 19], o: 2 },
    basket: { a: "Basket", b: "1F9FA", k: [51, 45], o: 11 },
    person_in_motorized_wheelchair: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F9BC",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f9bc.png",
          sheet_x: 47,
          sheet_y: 38,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F9BC",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f9bc.png",
          sheet_x: 47,
          sheet_y: 39,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F9BC",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f9bc.png",
          sheet_x: 47,
          sheet_y: 40,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F9BC",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f9bc.png",
          sheet_x: 47,
          sheet_y: 41,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F9BC",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f9bc.png",
          sheet_x: 47,
          sheet_y: 42,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Person in Motorized Wheelchair",
      b: "1F9D1-200D-1F9BC",
      k: [47, 37],
      o: 12
    },
    man_in_motorized_wheelchair: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F9BC",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f9bc.png",
          sheet_x: 16,
          sheet_y: 48,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F9BC",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f9bc.png",
          sheet_x: 16,
          sheet_y: 49,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F9BC",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f9bc.png",
          sheet_x: 16,
          sheet_y: 50,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F9BC",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f9bc.png",
          sheet_x: 16,
          sheet_y: 51,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F9BC",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f9bc.png",
          sheet_x: 16,
          sheet_y: 52,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man in Motorized Wheelchair",
      b: "1F468-200D-1F9BC",
      k: [16, 47],
      o: 12
    },
    "flag-sy": { a: "Syria Flag", b: "1F1F8-1F1FE", k: [4, 20], o: 2 },
    roll_of_paper: { a: "Roll of Paper", b: "1F9FB", k: [51, 46], o: 11 },
    woman_in_motorized_wheelchair: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F9BC",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f9bc.png",
          sheet_x: 19,
          sheet_y: 33,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F9BC",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f9bc.png",
          sheet_x: 19,
          sheet_y: 34,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F9BC",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f9bc.png",
          sheet_x: 19,
          sheet_y: 35,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F9BC",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f9bc.png",
          sheet_x: 19,
          sheet_y: 36,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F9BC",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f9bc.png",
          sheet_x: 19,
          sheet_y: 37,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman in Motorized Wheelchair",
      b: "1F469-200D-1F9BC",
      k: [19, 32],
      o: 12
    },
    "flag-sz": { a: "Eswatini Flag", b: "1F1F8-1F1FF", k: [4, 21], o: 2 },
    soap: { a: "Bar of Soap", b: "1F9FC", k: [51, 47], o: 11 },
    "flag-ta": {
      a: "Tristan Da Cunha Flag",
      b: "1F1F9-1F1E6",
      k: [4, 22],
      o: 2
    },
    sponge: { a: "Sponge", b: "1F9FD", k: [51, 48], o: 11 },
    person_in_manual_wheelchair: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F9BD",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f9bd.png",
          sheet_x: 47,
          sheet_y: 44,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F9BD",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f9bd.png",
          sheet_x: 47,
          sheet_y: 45,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F9BD",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f9bd.png",
          sheet_x: 47,
          sheet_y: 46,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F9BD",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f9bd.png",
          sheet_x: 47,
          sheet_y: 47,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F9BD",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f9bd.png",
          sheet_x: 47,
          sheet_y: 48,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: false,
          has_img_facebook: false
        }
      },
      a: "Person in Manual Wheelchair",
      b: "1F9D1-200D-1F9BD",
      k: [47, 43],
      o: 12
    },
    fire_extinguisher: {
      a: "Fire Extinguisher",
      b: "1F9EF",
      k: [51, 34],
      o: 11
    },
    man_in_manual_wheelchair: {
      skin_variations: {
        "1F3FB": {
          unified: "1F468-1F3FB-200D-1F9BD",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f9bd.png",
          sheet_x: 16,
          sheet_y: 54,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F468-1F3FC-200D-1F9BD",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f9bd.png",
          sheet_x: 16,
          sheet_y: 55,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F468-1F3FD-200D-1F9BD",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f9bd.png",
          sheet_x: 16,
          sheet_y: 56,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F468-1F3FE-200D-1F9BD",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f9bd.png",
          sheet_x: 17,
          sheet_y: 0,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F468-1F3FF-200D-1F9BD",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f9bd.png",
          sheet_x: 17,
          sheet_y: 1,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man in Manual Wheelchair",
      b: "1F468-200D-1F9BD",
      k: [16, 53],
      o: 12
    },
    "flag-tc": {
      a: "Turks & Caicos Islands Flag",
      b: "1F1F9-1F1E8",
      k: [4, 23],
      o: 2
    },
    woman_in_manual_wheelchair: {
      skin_variations: {
        "1F3FB": {
          unified: "1F469-1F3FB-200D-1F9BD",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f9bd.png",
          sheet_x: 19,
          sheet_y: 39,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F469-1F3FC-200D-1F9BD",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f9bd.png",
          sheet_x: 19,
          sheet_y: 40,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F469-1F3FD-200D-1F9BD",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f9bd.png",
          sheet_x: 19,
          sheet_y: 41,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F469-1F3FE-200D-1F9BD",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f9bd.png",
          sheet_x: 19,
          sheet_y: 42,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F469-1F3FF-200D-1F9BD",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f9bd.png",
          sheet_x: 19,
          sheet_y: 43,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman in Manual Wheelchair",
      b: "1F469-200D-1F9BD",
      k: [19, 38],
      o: 12
    },
    "flag-td": { a: "Chad Flag", b: "1F1F9-1F1E9", k: [4, 24], o: 2 },
    shopping_trolley: { a: "Shopping Trolley", b: "1F6D2", k: [36, 40], o: 4 },
    runner: {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C3-1F3FB",
          non_qualified: null,
          image: "1f3c3-1f3fb.png",
          sheet_x: 9,
          sheet_y: 2,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F3C3-1F3FC",
          non_qualified: null,
          image: "1f3c3-1f3fc.png",
          sheet_x: 9,
          sheet_y: 3,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F3C3-1F3FD",
          non_qualified: null,
          image: "1f3c3-1f3fd.png",
          sheet_x: 9,
          sheet_y: 4,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F3C3-1F3FE",
          non_qualified: null,
          image: "1f3c3-1f3fe.png",
          sheet_x: 9,
          sheet_y: 5,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F3C3-1F3FF",
          non_qualified: null,
          image: "1f3c3-1f3ff.png",
          sheet_x: 9,
          sheet_y: 6,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F3C3-200D-2642-FE0F",
      a: "Runner",
      b: "1F3C3",
      k: [9, 1],
      n: ["running"],
      o: 2
    },
    "flag-tf": {
      a: "French Southern Territories Flag",
      b: "1F1F9-1F1EB",
      k: [4, 25],
      o: 2
    },
    smoking: {
      a: "Smoking Symbol",
      b: "1F6AC",
      j: ["kills", "tobacco", "cigarette", "joint", "smoke"],
      k: [35, 3],
      o: 2
    },
    coffin: {
      a: "Coffin",
      b: "26B0-FE0F",
      c: "26B0",
      j: [
        "vampire",
        "dead",
        "die",
        "death",
        "rip",
        "graveyard",
        "cemetery",
        "casket",
        "funeral",
        "box"
      ],
      k: [53, 54],
      o: 2
    },
    "man-running": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C3-1F3FB-200D-2642-FE0F",
          non_qualified: "1F3C3-1F3FB-200D-2642",
          image: "1f3c3-1f3fb-200d-2642-fe0f.png",
          sheet_x: 8,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3C3-1F3FC-200D-2642-FE0F",
          non_qualified: "1F3C3-1F3FC-200D-2642",
          image: "1f3c3-1f3fc-200d-2642-fe0f.png",
          sheet_x: 8,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3C3-1F3FD-200D-2642-FE0F",
          non_qualified: "1F3C3-1F3FD-200D-2642",
          image: "1f3c3-1f3fd-200d-2642-fe0f.png",
          sheet_x: 8,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3C3-1F3FE-200D-2642-FE0F",
          non_qualified: "1F3C3-1F3FE-200D-2642",
          image: "1f3c3-1f3fe-200d-2642-fe0f.png",
          sheet_x: 8,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3C3-1F3FF-200D-2642-FE0F",
          non_qualified: "1F3C3-1F3FF-200D-2642",
          image: "1f3c3-1f3ff-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F3C3",
      a: "Man Running",
      b: "1F3C3-200D-2642-FE0F",
      c: "1F3C3-200D-2642",
      k: [8, 52],
      o: 4
    },
    "flag-tg": { a: "Togo Flag", b: "1F1F9-1F1EC", k: [4, 26], o: 2 },
    "woman-running": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C3-1F3FB-200D-2640-FE0F",
          non_qualified: "1F3C3-1F3FB-200D-2640",
          image: "1f3c3-1f3fb-200d-2640-fe0f.png",
          sheet_x: 8,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3C3-1F3FC-200D-2640-FE0F",
          non_qualified: "1F3C3-1F3FC-200D-2640",
          image: "1f3c3-1f3fc-200d-2640-fe0f.png",
          sheet_x: 8,
          sheet_y: 48,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3C3-1F3FD-200D-2640-FE0F",
          non_qualified: "1F3C3-1F3FD-200D-2640",
          image: "1f3c3-1f3fd-200d-2640-fe0f.png",
          sheet_x: 8,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3C3-1F3FE-200D-2640-FE0F",
          non_qualified: "1F3C3-1F3FE-200D-2640",
          image: "1f3c3-1f3fe-200d-2640-fe0f.png",
          sheet_x: 8,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3C3-1F3FF-200D-2640-FE0F",
          non_qualified: "1F3C3-1F3FF-200D-2640",
          image: "1f3c3-1f3ff-200d-2640-fe0f.png",
          sheet_x: 8,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Running",
      b: "1F3C3-200D-2640-FE0F",
      c: "1F3C3-200D-2640",
      k: [8, 46],
      o: 4
    },
    funeral_urn: {
      a: "Funeral Urn",
      b: "26B1-FE0F",
      c: "26B1",
      j: ["dead", "die", "death", "rip", "ashes"],
      k: [53, 55],
      o: 2
    },
    "flag-th": { a: "Thailand Flag", b: "1F1F9-1F1ED", k: [4, 27], o: 2 },
    moyai: {
      a: "Moyai",
      b: "1F5FF",
      j: ["rock", "easter island", "moai"],
      k: [30, 34],
      o: 2
    },
    "flag-tj": { a: "Tajikistan Flag", b: "1F1F9-1F1EF", k: [4, 28], o: 2 },
    dancer: {
      skin_variations: {
        "1F3FB": {
          unified: "1F483-1F3FB",
          non_qualified: null,
          image: "1f483-1f3fb.png",
          sheet_x: 24,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F483-1F3FC",
          non_qualified: null,
          image: "1f483-1f3fc.png",
          sheet_x: 24,
          sheet_y: 28,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F483-1F3FD",
          non_qualified: null,
          image: "1f483-1f3fd.png",
          sheet_x: 24,
          sheet_y: 29,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F483-1F3FE",
          non_qualified: null,
          image: "1f483-1f3fe.png",
          sheet_x: 24,
          sheet_y: 30,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F483-1F3FF",
          non_qualified: null,
          image: "1f483-1f3ff.png",
          sheet_x: 24,
          sheet_y: 31,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Dancer",
      b: "1F483",
      j: ["female", "girl", "woman", "fun"],
      k: [24, 26],
      o: 2
    },
    "flag-tk": { a: "Tokelau Flag", b: "1F1F9-1F1F0", k: [4, 29], o: 2 },
    man_dancing: {
      skin_variations: {
        "1F3FB": {
          unified: "1F57A-1F3FB",
          non_qualified: null,
          image: "1f57a-1f3fb.png",
          sheet_x: 29,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F57A-1F3FC",
          non_qualified: null,
          image: "1f57a-1f3fc.png",
          sheet_x: 29,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F57A-1F3FD",
          non_qualified: null,
          image: "1f57a-1f3fd.png",
          sheet_x: 29,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F57A-1F3FE",
          non_qualified: null,
          image: "1f57a-1f3fe.png",
          sheet_x: 29,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F57A-1F3FF",
          non_qualified: null,
          image: "1f57a-1f3ff.png",
          sheet_x: 29,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Dancing",
      b: "1F57A",
      j: ["male", "boy", "fun", "dancer"],
      k: [29, 37],
      o: 4
    },
    "flag-tl": { a: "Timor-Leste Flag", b: "1F1F9-1F1F1", k: [4, 30], o: 2 },
    man_in_business_suit_levitating: {
      skin_variations: {
        "1F3FB": {
          unified: "1F574-1F3FB",
          non_qualified: null,
          image: "1f574-1f3fb.png",
          sheet_x: 29,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F574-1F3FC",
          non_qualified: null,
          image: "1f574-1f3fc.png",
          sheet_x: 29,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F574-1F3FD",
          non_qualified: null,
          image: "1f574-1f3fd.png",
          sheet_x: 29,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F574-1F3FE",
          non_qualified: null,
          image: "1f574-1f3fe.png",
          sheet_x: 29,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F574-1F3FF",
          non_qualified: null,
          image: "1f574-1f3ff.png",
          sheet_x: 29,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man in Business Suit Levitating",
      b: "1F574-FE0F",
      c: "1F574",
      k: [29, 9],
      o: 2
    },
    "flag-tm": { a: "Turkmenistan Flag", b: "1F1F9-1F1F2", k: [4, 31], o: 2 },
    dancers: {
      obsoleted_by: "1F46F-200D-2640-FE0F",
      a: "Woman with Bunny Ears",
      b: "1F46F",
      k: [22, 0],
      o: 2
    },
    "man-with-bunny-ears-partying": {
      a: "Man with Bunny Ears Partying",
      b: "1F46F-200D-2642-FE0F",
      c: "1F46F-200D-2642",
      k: [21, 56],
      o: 4
    },
    "flag-tn": { a: "Tunisia Flag", b: "1F1F9-1F1F3", k: [4, 32], o: 2 },
    "flag-to": { a: "Tonga Flag", b: "1F1F9-1F1F4", k: [4, 33], o: 2 },
    "woman-with-bunny-ears-partying": {
      obsoletes: "1F46F",
      a: "Woman with Bunny Ears Partying",
      b: "1F46F-200D-2640-FE0F",
      c: "1F46F-200D-2640",
      k: [21, 55],
      o: 4
    },
    "flag-tr": { a: "Turkey Flag", b: "1F1F9-1F1F7", k: [4, 34], o: 2 },
    person_in_steamy_room: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D6-1F3FB",
          non_qualified: null,
          image: "1f9d6-1f3fb.png",
          sheet_x: 48,
          sheet_y: 53,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D6-1F3FB-200D-2642-FE0F"
        },
        "1F3FC": {
          unified: "1F9D6-1F3FC",
          non_qualified: null,
          image: "1f9d6-1f3fc.png",
          sheet_x: 48,
          sheet_y: 54,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D6-1F3FC-200D-2642-FE0F"
        },
        "1F3FD": {
          unified: "1F9D6-1F3FD",
          non_qualified: null,
          image: "1f9d6-1f3fd.png",
          sheet_x: 48,
          sheet_y: 55,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D6-1F3FD-200D-2642-FE0F"
        },
        "1F3FE": {
          unified: "1F9D6-1F3FE",
          non_qualified: null,
          image: "1f9d6-1f3fe.png",
          sheet_x: 48,
          sheet_y: 56,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D6-1F3FE-200D-2642-FE0F"
        },
        "1F3FF": {
          unified: "1F9D6-1F3FF",
          non_qualified: null,
          image: "1f9d6-1f3ff.png",
          sheet_x: 49,
          sheet_y: 0,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D6-1F3FF-200D-2642-FE0F"
        }
      },
      obsoleted_by: "1F9D6-200D-2642-FE0F",
      a: "Person in Steamy Room",
      b: "1F9D6",
      k: [48, 52],
      o: 5
    },
    man_in_steamy_room: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D6-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9D6-1F3FB-200D-2642",
          image: "1f9d6-1f3fb-200d-2642-fe0f.png",
          sheet_x: 48,
          sheet_y: 47,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D6-1F3FB"
        },
        "1F3FC": {
          unified: "1F9D6-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9D6-1F3FC-200D-2642",
          image: "1f9d6-1f3fc-200d-2642-fe0f.png",
          sheet_x: 48,
          sheet_y: 48,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D6-1F3FC"
        },
        "1F3FD": {
          unified: "1F9D6-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9D6-1F3FD-200D-2642",
          image: "1f9d6-1f3fd-200d-2642-fe0f.png",
          sheet_x: 48,
          sheet_y: 49,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D6-1F3FD"
        },
        "1F3FE": {
          unified: "1F9D6-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9D6-1F3FE-200D-2642",
          image: "1f9d6-1f3fe-200d-2642-fe0f.png",
          sheet_x: 48,
          sheet_y: 50,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D6-1F3FE"
        },
        "1F3FF": {
          unified: "1F9D6-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9D6-1F3FF-200D-2642",
          image: "1f9d6-1f3ff-200d-2642-fe0f.png",
          sheet_x: 48,
          sheet_y: 51,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D6-1F3FF"
        }
      },
      obsoletes: "1F9D6",
      a: "Man in Steamy Room",
      b: "1F9D6-200D-2642-FE0F",
      c: "1F9D6-200D-2642",
      k: [48, 46],
      o: 5
    },
    "flag-tt": {
      a: "Trinidad & Tobago Flag",
      b: "1F1F9-1F1F9",
      k: [4, 35],
      o: 2
    },
    woman_in_steamy_room: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D6-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9D6-1F3FB-200D-2640",
          image: "1f9d6-1f3fb-200d-2640-fe0f.png",
          sheet_x: 48,
          sheet_y: 41,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D6-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9D6-1F3FC-200D-2640",
          image: "1f9d6-1f3fc-200d-2640-fe0f.png",
          sheet_x: 48,
          sheet_y: 42,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D6-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9D6-1F3FD-200D-2640",
          image: "1f9d6-1f3fd-200d-2640-fe0f.png",
          sheet_x: 48,
          sheet_y: 43,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D6-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9D6-1F3FE-200D-2640",
          image: "1f9d6-1f3fe-200d-2640-fe0f.png",
          sheet_x: 48,
          sheet_y: 44,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D6-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9D6-1F3FF-200D-2640",
          image: "1f9d6-1f3ff-200d-2640-fe0f.png",
          sheet_x: 48,
          sheet_y: 45,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman in Steamy Room",
      b: "1F9D6-200D-2640-FE0F",
      c: "1F9D6-200D-2640",
      k: [48, 40],
      o: 5
    },
    "flag-tv": { a: "Tuvalu Flag", b: "1F1F9-1F1FB", k: [4, 36], o: 2 },
    "flag-tw": { a: "Taiwan Flag", b: "1F1F9-1F1FC", k: [4, 37], o: 2 },
    person_climbing: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D7-1F3FB",
          non_qualified: null,
          image: "1f9d7-1f3fb.png",
          sheet_x: 49,
          sheet_y: 14,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D7-1F3FB-200D-2640-FE0F"
        },
        "1F3FC": {
          unified: "1F9D7-1F3FC",
          non_qualified: null,
          image: "1f9d7-1f3fc.png",
          sheet_x: 49,
          sheet_y: 15,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D7-1F3FC-200D-2640-FE0F"
        },
        "1F3FD": {
          unified: "1F9D7-1F3FD",
          non_qualified: null,
          image: "1f9d7-1f3fd.png",
          sheet_x: 49,
          sheet_y: 16,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D7-1F3FD-200D-2640-FE0F"
        },
        "1F3FE": {
          unified: "1F9D7-1F3FE",
          non_qualified: null,
          image: "1f9d7-1f3fe.png",
          sheet_x: 49,
          sheet_y: 17,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D7-1F3FE-200D-2640-FE0F"
        },
        "1F3FF": {
          unified: "1F9D7-1F3FF",
          non_qualified: null,
          image: "1f9d7-1f3ff.png",
          sheet_x: 49,
          sheet_y: 18,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D7-1F3FF-200D-2640-FE0F"
        }
      },
      obsoleted_by: "1F9D7-200D-2640-FE0F",
      a: "Person Climbing",
      b: "1F9D7",
      k: [49, 13],
      o: 5
    },
    man_climbing: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D7-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9D7-1F3FB-200D-2642",
          image: "1f9d7-1f3fb-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 8,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D7-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9D7-1F3FC-200D-2642",
          image: "1f9d7-1f3fc-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 9,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D7-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9D7-1F3FD-200D-2642",
          image: "1f9d7-1f3fd-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 10,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D7-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9D7-1F3FE-200D-2642",
          image: "1f9d7-1f3fe-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 11,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D7-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9D7-1F3FF-200D-2642",
          image: "1f9d7-1f3ff-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 12,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Climbing",
      b: "1F9D7-200D-2642-FE0F",
      c: "1F9D7-200D-2642",
      k: [49, 7],
      o: 5
    },
    "flag-tz": { a: "Tanzania Flag", b: "1F1F9-1F1FF", k: [4, 38], o: 2 },
    "flag-ua": { a: "Ukraine Flag", b: "1F1FA-1F1E6", k: [4, 39], o: 2 },
    woman_climbing: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D7-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9D7-1F3FB-200D-2640",
          image: "1f9d7-1f3fb-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 2,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D7-1F3FB"
        },
        "1F3FC": {
          unified: "1F9D7-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9D7-1F3FC-200D-2640",
          image: "1f9d7-1f3fc-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 3,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D7-1F3FC"
        },
        "1F3FD": {
          unified: "1F9D7-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9D7-1F3FD-200D-2640",
          image: "1f9d7-1f3fd-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 4,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D7-1F3FD"
        },
        "1F3FE": {
          unified: "1F9D7-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9D7-1F3FE-200D-2640",
          image: "1f9d7-1f3fe-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 5,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D7-1F3FE"
        },
        "1F3FF": {
          unified: "1F9D7-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9D7-1F3FF-200D-2640",
          image: "1f9d7-1f3ff-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 6,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D7-1F3FF"
        }
      },
      obsoletes: "1F9D7",
      a: "Woman Climbing",
      b: "1F9D7-200D-2640-FE0F",
      c: "1F9D7-200D-2640",
      k: [49, 1],
      o: 5
    },
    "flag-ug": { a: "Uganda Flag", b: "1F1FA-1F1EC", k: [4, 40], o: 2 },
    fencer: { a: "Fencer", b: "1F93A", k: [40, 32], o: 4 },
    "flag-um": {
      a: "U.s. Outlying Islands Flag",
      b: "1F1FA-1F1F2",
      k: [4, 41],
      o: 2
    },
    horse_racing: {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C7-1F3FB",
          non_qualified: null,
          image: "1f3c7-1f3fb.png",
          sheet_x: 9,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3C7-1F3FC",
          non_qualified: null,
          image: "1f3c7-1f3fc.png",
          sheet_x: 9,
          sheet_y: 29,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3C7-1F3FD",
          non_qualified: null,
          image: "1f3c7-1f3fd.png",
          sheet_x: 9,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3C7-1F3FE",
          non_qualified: null,
          image: "1f3c7-1f3fe.png",
          sheet_x: 9,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3C7-1F3FF",
          non_qualified: null,
          image: "1f3c7-1f3ff.png",
          sheet_x: 9,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Horse Racing",
      b: "1F3C7",
      j: ["animal", "betting", "competition", "gambling", "luck"],
      k: [9, 27],
      o: 2
    },
    skier: {
      a: "Skier",
      b: "26F7-FE0F",
      c: "26F7",
      j: ["sports", "winter", "snow"],
      k: [54, 17],
      o: 2
    },
    "flag-un": { a: "United Nations Flag", b: "1F1FA-1F1F3", k: [4, 42], o: 4 },
    us: {
      a: "United States Flag",
      b: "1F1FA-1F1F8",
      j: ["united", "states", "america", "flag", "nation", "country", "banner"],
      k: [4, 43],
      n: ["flag-us"],
      o: 2
    },
    snowboarder: {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C2-1F3FB",
          non_qualified: null,
          image: "1f3c2-1f3fb.png",
          sheet_x: 8,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3C2-1F3FC",
          non_qualified: null,
          image: "1f3c2-1f3fc.png",
          sheet_x: 8,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3C2-1F3FD",
          non_qualified: null,
          image: "1f3c2-1f3fd.png",
          sheet_x: 8,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3C2-1F3FE",
          non_qualified: null,
          image: "1f3c2-1f3fe.png",
          sheet_x: 8,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3C2-1F3FF",
          non_qualified: null,
          image: "1f3c2-1f3ff.png",
          sheet_x: 8,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Snowboarder",
      b: "1F3C2",
      j: ["sports", "winter"],
      k: [8, 40],
      o: 2
    },
    golfer: {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CC-1F3FB",
          non_qualified: null,
          image: "1f3cc-1f3fb.png",
          sheet_x: 10,
          sheet_y: 27,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F3CC-1F3FC",
          non_qualified: null,
          image: "1f3cc-1f3fc.png",
          sheet_x: 10,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F3CC-1F3FD",
          non_qualified: null,
          image: "1f3cc-1f3fd.png",
          sheet_x: 10,
          sheet_y: 29,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F3CC-1F3FE",
          non_qualified: null,
          image: "1f3cc-1f3fe.png",
          sheet_x: 10,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F3CC-1F3FF",
          non_qualified: null,
          image: "1f3cc-1f3ff.png",
          sheet_x: 10,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F3CC-FE0F-200D-2642-FE0F",
      a: "Golfer",
      b: "1F3CC-FE0F",
      c: "1F3CC",
      k: [10, 26],
      o: 2
    },
    "flag-uy": { a: "Uruguay Flag", b: "1F1FA-1F1FE", k: [4, 44], o: 2 },
    "flag-uz": { a: "Uzbekistan Flag", b: "1F1FA-1F1FF", k: [4, 45], o: 2 },
    "man-golfing": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CC-1F3FB-200D-2642-FE0F",
          non_qualified: "1F3CC-1F3FB-200D-2642",
          image: "1f3cc-1f3fb-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3CC-1F3FC-200D-2642-FE0F",
          non_qualified: "1F3CC-1F3FC-200D-2642",
          image: "1f3cc-1f3fc-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3CC-1F3FD-200D-2642-FE0F",
          non_qualified: "1F3CC-1F3FD-200D-2642",
          image: "1f3cc-1f3fd-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 23,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3CC-1F3FE-200D-2642-FE0F",
          non_qualified: "1F3CC-1F3FE-200D-2642",
          image: "1f3cc-1f3fe-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3CC-1F3FF-200D-2642-FE0F",
          non_qualified: "1F3CC-1F3FF-200D-2642",
          image: "1f3cc-1f3ff-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 25,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F3CC-FE0F",
      a: "Man Golfing",
      b: "1F3CC-FE0F-200D-2642-FE0F",
      k: [10, 20],
      o: 4
    },
    "flag-va": { a: "Vatican City Flag", b: "1F1FB-1F1E6", k: [4, 46], o: 2 },
    "woman-golfing": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CC-1F3FB-200D-2640-FE0F",
          non_qualified: "1F3CC-1F3FB-200D-2640",
          image: "1f3cc-1f3fb-200d-2640-fe0f.png",
          sheet_x: 10,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3CC-1F3FC-200D-2640-FE0F",
          non_qualified: "1F3CC-1F3FC-200D-2640",
          image: "1f3cc-1f3fc-200d-2640-fe0f.png",
          sheet_x: 10,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3CC-1F3FD-200D-2640-FE0F",
          non_qualified: "1F3CC-1F3FD-200D-2640",
          image: "1f3cc-1f3fd-200d-2640-fe0f.png",
          sheet_x: 10,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3CC-1F3FE-200D-2640-FE0F",
          non_qualified: "1F3CC-1F3FE-200D-2640",
          image: "1f3cc-1f3fe-200d-2640-fe0f.png",
          sheet_x: 10,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3CC-1F3FF-200D-2640-FE0F",
          non_qualified: "1F3CC-1F3FF-200D-2640",
          image: "1f3cc-1f3ff-200d-2640-fe0f.png",
          sheet_x: 10,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Golfing",
      b: "1F3CC-FE0F-200D-2640-FE0F",
      k: [10, 14],
      o: 4
    },
    "flag-vc": {
      a: "St. Vincent & Grenadines Flag",
      b: "1F1FB-1F1E8",
      k: [4, 47],
      o: 2
    },
    surfer: {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C4-1F3FB",
          non_qualified: null,
          image: "1f3c4-1f3fb.png",
          sheet_x: 9,
          sheet_y: 20,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F3C4-1F3FC",
          non_qualified: null,
          image: "1f3c4-1f3fc.png",
          sheet_x: 9,
          sheet_y: 21,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F3C4-1F3FD",
          non_qualified: null,
          image: "1f3c4-1f3fd.png",
          sheet_x: 9,
          sheet_y: 22,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F3C4-1F3FE",
          non_qualified: null,
          image: "1f3c4-1f3fe.png",
          sheet_x: 9,
          sheet_y: 23,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F3C4-1F3FF",
          non_qualified: null,
          image: "1f3c4-1f3ff.png",
          sheet_x: 9,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F3C4-200D-2642-FE0F",
      a: "Surfer",
      b: "1F3C4",
      k: [9, 19],
      o: 2
    },
    "man-surfing": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C4-1F3FB-200D-2642-FE0F",
          non_qualified: "1F3C4-1F3FB-200D-2642",
          image: "1f3c4-1f3fb-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3C4-1F3FC-200D-2642-FE0F",
          non_qualified: "1F3C4-1F3FC-200D-2642",
          image: "1f3c4-1f3fc-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3C4-1F3FD-200D-2642-FE0F",
          non_qualified: "1F3C4-1F3FD-200D-2642",
          image: "1f3c4-1f3fd-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3C4-1F3FE-200D-2642-FE0F",
          non_qualified: "1F3C4-1F3FE-200D-2642",
          image: "1f3c4-1f3fe-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3C4-1F3FF-200D-2642-FE0F",
          non_qualified: "1F3C4-1F3FF-200D-2642",
          image: "1f3c4-1f3ff-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F3C4",
      a: "Man Surfing",
      b: "1F3C4-200D-2642-FE0F",
      c: "1F3C4-200D-2642",
      k: [9, 13],
      o: 4
    },
    "flag-ve": { a: "Venezuela Flag", b: "1F1FB-1F1EA", k: [4, 48], o: 2 },
    "flag-vg": {
      a: "British Virgin Islands Flag",
      b: "1F1FB-1F1EC",
      k: [4, 49],
      o: 2
    },
    "woman-surfing": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3C4-1F3FB-200D-2640-FE0F",
          non_qualified: "1F3C4-1F3FB-200D-2640",
          image: "1f3c4-1f3fb-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3C4-1F3FC-200D-2640-FE0F",
          non_qualified: "1F3C4-1F3FC-200D-2640",
          image: "1f3c4-1f3fc-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3C4-1F3FD-200D-2640-FE0F",
          non_qualified: "1F3C4-1F3FD-200D-2640",
          image: "1f3c4-1f3fd-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3C4-1F3FE-200D-2640-FE0F",
          non_qualified: "1F3C4-1F3FE-200D-2640",
          image: "1f3c4-1f3fe-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3C4-1F3FF-200D-2640-FE0F",
          non_qualified: "1F3C4-1F3FF-200D-2640",
          image: "1f3c4-1f3ff-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Surfing",
      b: "1F3C4-200D-2640-FE0F",
      c: "1F3C4-200D-2640",
      k: [9, 7],
      o: 4
    },
    rowboat: {
      skin_variations: {
        "1F3FB": {
          unified: "1F6A3-1F3FB",
          non_qualified: null,
          image: "1f6a3-1f3fb.png",
          sheet_x: 34,
          sheet_y: 47,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F6A3-1F3FC",
          non_qualified: null,
          image: "1f6a3-1f3fc.png",
          sheet_x: 34,
          sheet_y: 48,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F6A3-1F3FD",
          non_qualified: null,
          image: "1f6a3-1f3fd.png",
          sheet_x: 34,
          sheet_y: 49,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F6A3-1F3FE",
          non_qualified: null,
          image: "1f6a3-1f3fe.png",
          sheet_x: 34,
          sheet_y: 50,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F6A3-1F3FF",
          non_qualified: null,
          image: "1f6a3-1f3ff.png",
          sheet_x: 34,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F6A3-200D-2642-FE0F",
      a: "Rowboat",
      b: "1F6A3",
      k: [34, 46],
      o: 2
    },
    "flag-vi": {
      a: "U.s. Virgin Islands Flag",
      b: "1F1FB-1F1EE",
      k: [4, 50],
      o: 2
    },
    "man-rowing-boat": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6A3-1F3FB-200D-2642-FE0F",
          non_qualified: "1F6A3-1F3FB-200D-2642",
          image: "1f6a3-1f3fb-200d-2642-fe0f.png",
          sheet_x: 34,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6A3-1F3FC-200D-2642-FE0F",
          non_qualified: "1F6A3-1F3FC-200D-2642",
          image: "1f6a3-1f3fc-200d-2642-fe0f.png",
          sheet_x: 34,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6A3-1F3FD-200D-2642-FE0F",
          non_qualified: "1F6A3-1F3FD-200D-2642",
          image: "1f6a3-1f3fd-200d-2642-fe0f.png",
          sheet_x: 34,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6A3-1F3FE-200D-2642-FE0F",
          non_qualified: "1F6A3-1F3FE-200D-2642",
          image: "1f6a3-1f3fe-200d-2642-fe0f.png",
          sheet_x: 34,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6A3-1F3FF-200D-2642-FE0F",
          non_qualified: "1F6A3-1F3FF-200D-2642",
          image: "1f6a3-1f3ff-200d-2642-fe0f.png",
          sheet_x: 34,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F6A3",
      a: "Man Rowing Boat",
      b: "1F6A3-200D-2642-FE0F",
      c: "1F6A3-200D-2642",
      k: [34, 40],
      o: 4
    },
    "flag-vn": { a: "Vietnam Flag", b: "1F1FB-1F1F3", k: [4, 51], o: 2 },
    "flag-vu": { a: "Vanuatu Flag", b: "1F1FB-1F1FA", k: [4, 52], o: 2 },
    "woman-rowing-boat": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6A3-1F3FB-200D-2640-FE0F",
          non_qualified: "1F6A3-1F3FB-200D-2640",
          image: "1f6a3-1f3fb-200d-2640-fe0f.png",
          sheet_x: 34,
          sheet_y: 35,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6A3-1F3FC-200D-2640-FE0F",
          non_qualified: "1F6A3-1F3FC-200D-2640",
          image: "1f6a3-1f3fc-200d-2640-fe0f.png",
          sheet_x: 34,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6A3-1F3FD-200D-2640-FE0F",
          non_qualified: "1F6A3-1F3FD-200D-2640",
          image: "1f6a3-1f3fd-200d-2640-fe0f.png",
          sheet_x: 34,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6A3-1F3FE-200D-2640-FE0F",
          non_qualified: "1F6A3-1F3FE-200D-2640",
          image: "1f6a3-1f3fe-200d-2640-fe0f.png",
          sheet_x: 34,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6A3-1F3FF-200D-2640-FE0F",
          non_qualified: "1F6A3-1F3FF-200D-2640",
          image: "1f6a3-1f3ff-200d-2640-fe0f.png",
          sheet_x: 34,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Rowing Boat",
      b: "1F6A3-200D-2640-FE0F",
      c: "1F6A3-200D-2640",
      k: [34, 34],
      o: 4
    },
    swimmer: {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CA-1F3FB",
          non_qualified: null,
          image: "1f3ca-1f3fb.png",
          sheet_x: 9,
          sheet_y: 48,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F3CA-1F3FC",
          non_qualified: null,
          image: "1f3ca-1f3fc.png",
          sheet_x: 9,
          sheet_y: 49,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F3CA-1F3FD",
          non_qualified: null,
          image: "1f3ca-1f3fd.png",
          sheet_x: 9,
          sheet_y: 50,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F3CA-1F3FE",
          non_qualified: null,
          image: "1f3ca-1f3fe.png",
          sheet_x: 9,
          sheet_y: 51,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F3CA-1F3FF",
          non_qualified: null,
          image: "1f3ca-1f3ff.png",
          sheet_x: 9,
          sheet_y: 52,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F3CA-200D-2642-FE0F",
      a: "Swimmer",
      b: "1F3CA",
      k: [9, 47],
      o: 2
    },
    "flag-wf": {
      a: "Wallis & Futuna Flag",
      b: "1F1FC-1F1EB",
      k: [4, 53],
      o: 2
    },
    "man-swimming": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CA-1F3FB-200D-2642-FE0F",
          non_qualified: "1F3CA-1F3FB-200D-2642",
          image: "1f3ca-1f3fb-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 42,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3CA-1F3FC-200D-2642-FE0F",
          non_qualified: "1F3CA-1F3FC-200D-2642",
          image: "1f3ca-1f3fc-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3CA-1F3FD-200D-2642-FE0F",
          non_qualified: "1F3CA-1F3FD-200D-2642",
          image: "1f3ca-1f3fd-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3CA-1F3FE-200D-2642-FE0F",
          non_qualified: "1F3CA-1F3FE-200D-2642",
          image: "1f3ca-1f3fe-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3CA-1F3FF-200D-2642-FE0F",
          non_qualified: "1F3CA-1F3FF-200D-2642",
          image: "1f3ca-1f3ff-200d-2642-fe0f.png",
          sheet_x: 9,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F3CA",
      a: "Man Swimming",
      b: "1F3CA-200D-2642-FE0F",
      c: "1F3CA-200D-2642",
      k: [9, 41],
      o: 4
    },
    "flag-ws": { a: "Samoa Flag", b: "1F1FC-1F1F8", k: [4, 54], o: 2 },
    "woman-swimming": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CA-1F3FB-200D-2640-FE0F",
          non_qualified: "1F3CA-1F3FB-200D-2640",
          image: "1f3ca-1f3fb-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3CA-1F3FC-200D-2640-FE0F",
          non_qualified: "1F3CA-1F3FC-200D-2640",
          image: "1f3ca-1f3fc-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3CA-1F3FD-200D-2640-FE0F",
          non_qualified: "1F3CA-1F3FD-200D-2640",
          image: "1f3ca-1f3fd-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3CA-1F3FE-200D-2640-FE0F",
          non_qualified: "1F3CA-1F3FE-200D-2640",
          image: "1f3ca-1f3fe-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3CA-1F3FF-200D-2640-FE0F",
          non_qualified: "1F3CA-1F3FF-200D-2640",
          image: "1f3ca-1f3ff-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Swimming",
      b: "1F3CA-200D-2640-FE0F",
      c: "1F3CA-200D-2640",
      k: [9, 35],
      o: 4
    },
    "flag-xk": { a: "Kosovo Flag", b: "1F1FD-1F1F0", k: [4, 55], o: 2 },
    person_with_ball: {
      skin_variations: {
        "1F3FB": {
          unified: "26F9-1F3FB",
          non_qualified: null,
          image: "26f9-1f3fb.png",
          sheet_x: 54,
          sheet_y: 32,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "26F9-1F3FC",
          non_qualified: null,
          image: "26f9-1f3fc.png",
          sheet_x: 54,
          sheet_y: 33,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "26F9-1F3FD",
          non_qualified: null,
          image: "26f9-1f3fd.png",
          sheet_x: 54,
          sheet_y: 34,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "26F9-1F3FE",
          non_qualified: null,
          image: "26f9-1f3fe.png",
          sheet_x: 54,
          sheet_y: 35,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "26F9-1F3FF",
          non_qualified: null,
          image: "26f9-1f3ff.png",
          sheet_x: 54,
          sheet_y: 36,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "26F9-FE0F-200D-2642-FE0F",
      a: "Person with Ball",
      b: "26F9-FE0F",
      c: "26F9",
      k: [54, 31],
      o: 2
    },
    "flag-ye": { a: "Yemen Flag", b: "1F1FE-1F1EA", k: [4, 56], o: 2 },
    "man-bouncing-ball": {
      skin_variations: {
        "1F3FB": {
          unified: "26F9-1F3FB-200D-2642-FE0F",
          non_qualified: "26F9-1F3FB-200D-2642",
          image: "26f9-1f3fb-200d-2642-fe0f.png",
          sheet_x: 54,
          sheet_y: 26,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "26F9-1F3FC-200D-2642-FE0F",
          non_qualified: "26F9-1F3FC-200D-2642",
          image: "26f9-1f3fc-200d-2642-fe0f.png",
          sheet_x: 54,
          sheet_y: 27,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "26F9-1F3FD-200D-2642-FE0F",
          non_qualified: "26F9-1F3FD-200D-2642",
          image: "26f9-1f3fd-200d-2642-fe0f.png",
          sheet_x: 54,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "26F9-1F3FE-200D-2642-FE0F",
          non_qualified: "26F9-1F3FE-200D-2642",
          image: "26f9-1f3fe-200d-2642-fe0f.png",
          sheet_x: 54,
          sheet_y: 29,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "26F9-1F3FF-200D-2642-FE0F",
          non_qualified: "26F9-1F3FF-200D-2642",
          image: "26f9-1f3ff-200d-2642-fe0f.png",
          sheet_x: 54,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "26F9-FE0F",
      a: "Man Bouncing Ball",
      b: "26F9-FE0F-200D-2642-FE0F",
      k: [54, 25],
      o: 4
    },
    "flag-yt": { a: "Mayotte Flag", b: "1F1FE-1F1F9", k: [5, 0], o: 2 },
    "woman-bouncing-ball": {
      skin_variations: {
        "1F3FB": {
          unified: "26F9-1F3FB-200D-2640-FE0F",
          non_qualified: "26F9-1F3FB-200D-2640",
          image: "26f9-1f3fb-200d-2640-fe0f.png",
          sheet_x: 54,
          sheet_y: 20,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "26F9-1F3FC-200D-2640-FE0F",
          non_qualified: "26F9-1F3FC-200D-2640",
          image: "26f9-1f3fc-200d-2640-fe0f.png",
          sheet_x: 54,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "26F9-1F3FD-200D-2640-FE0F",
          non_qualified: "26F9-1F3FD-200D-2640",
          image: "26f9-1f3fd-200d-2640-fe0f.png",
          sheet_x: 54,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "26F9-1F3FE-200D-2640-FE0F",
          non_qualified: "26F9-1F3FE-200D-2640",
          image: "26f9-1f3fe-200d-2640-fe0f.png",
          sheet_x: 54,
          sheet_y: 23,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "26F9-1F3FF-200D-2640-FE0F",
          non_qualified: "26F9-1F3FF-200D-2640",
          image: "26f9-1f3ff-200d-2640-fe0f.png",
          sheet_x: 54,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Bouncing Ball",
      b: "26F9-FE0F-200D-2640-FE0F",
      k: [54, 19],
      o: 4
    },
    "flag-za": { a: "South Africa Flag", b: "1F1FF-1F1E6", k: [5, 1], o: 2 },
    "flag-zm": { a: "Zambia Flag", b: "1F1FF-1F1F2", k: [5, 2], o: 2 },
    weight_lifter: {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CB-1F3FB",
          non_qualified: null,
          image: "1f3cb-1f3fb.png",
          sheet_x: 10,
          sheet_y: 9,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F3CB-1F3FC",
          non_qualified: null,
          image: "1f3cb-1f3fc.png",
          sheet_x: 10,
          sheet_y: 10,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F3CB-1F3FD",
          non_qualified: null,
          image: "1f3cb-1f3fd.png",
          sheet_x: 10,
          sheet_y: 11,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F3CB-1F3FE",
          non_qualified: null,
          image: "1f3cb-1f3fe.png",
          sheet_x: 10,
          sheet_y: 12,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F3CB-1F3FF",
          non_qualified: null,
          image: "1f3cb-1f3ff.png",
          sheet_x: 10,
          sheet_y: 13,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F3CB-FE0F-200D-2642-FE0F",
      a: "Weight Lifter",
      b: "1F3CB-FE0F",
      c: "1F3CB",
      k: [10, 8],
      o: 2
    },
    "man-lifting-weights": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CB-1F3FB-200D-2642-FE0F",
          non_qualified: "1F3CB-1F3FB-200D-2642",
          image: "1f3cb-1f3fb-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3CB-1F3FC-200D-2642-FE0F",
          non_qualified: "1F3CB-1F3FC-200D-2642",
          image: "1f3cb-1f3fc-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3CB-1F3FD-200D-2642-FE0F",
          non_qualified: "1F3CB-1F3FD-200D-2642",
          image: "1f3cb-1f3fd-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 5,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3CB-1F3FE-200D-2642-FE0F",
          non_qualified: "1F3CB-1F3FE-200D-2642",
          image: "1f3cb-1f3fe-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3CB-1F3FF-200D-2642-FE0F",
          non_qualified: "1F3CB-1F3FF-200D-2642",
          image: "1f3cb-1f3ff-200d-2642-fe0f.png",
          sheet_x: 10,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F3CB-FE0F",
      a: "Man Lifting Weights",
      b: "1F3CB-FE0F-200D-2642-FE0F",
      k: [10, 2],
      o: 4
    },
    "flag-zw": { a: "Zimbabwe Flag", b: "1F1FF-1F1FC", k: [5, 3], o: 2 },
    "woman-lifting-weights": {
      skin_variations: {
        "1F3FB": {
          unified: "1F3CB-1F3FB-200D-2640-FE0F",
          non_qualified: "1F3CB-1F3FB-200D-2640",
          image: "1f3cb-1f3fb-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F3CB-1F3FC-200D-2640-FE0F",
          non_qualified: "1F3CB-1F3FC-200D-2640",
          image: "1f3cb-1f3fc-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F3CB-1F3FD-200D-2640-FE0F",
          non_qualified: "1F3CB-1F3FD-200D-2640",
          image: "1f3cb-1f3fd-200d-2640-fe0f.png",
          sheet_x: 9,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F3CB-1F3FE-200D-2640-FE0F",
          non_qualified: "1F3CB-1F3FE-200D-2640",
          image: "1f3cb-1f3fe-200d-2640-fe0f.png",
          sheet_x: 10,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F3CB-1F3FF-200D-2640-FE0F",
          non_qualified: "1F3CB-1F3FF-200D-2640",
          image: "1f3cb-1f3ff-200d-2640-fe0f.png",
          sheet_x: 10,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Lifting Weights",
      b: "1F3CB-FE0F-200D-2640-FE0F",
      k: [9, 53],
      o: 4
    },
    "flag-england": {
      a: "England Flag",
      b: "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
      k: [11, 14],
      o: 5
    },
    bicyclist: {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B4-1F3FB",
          non_qualified: null,
          image: "1f6b4-1f3fb.png",
          sheet_x: 35,
          sheet_y: 24,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F6B4-1F3FC",
          non_qualified: null,
          image: "1f6b4-1f3fc.png",
          sheet_x: 35,
          sheet_y: 25,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F6B4-1F3FD",
          non_qualified: null,
          image: "1f6b4-1f3fd.png",
          sheet_x: 35,
          sheet_y: 26,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F6B4-1F3FE",
          non_qualified: null,
          image: "1f6b4-1f3fe.png",
          sheet_x: 35,
          sheet_y: 27,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F6B4-1F3FF",
          non_qualified: null,
          image: "1f6b4-1f3ff.png",
          sheet_x: 35,
          sheet_y: 28,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F6B4-200D-2642-FE0F",
      a: "Bicyclist",
      b: "1F6B4",
      k: [35, 23],
      o: 2
    },
    "flag-scotland": {
      a: "Scotland Flag",
      b: "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
      k: [11, 15],
      o: 5
    },
    "flag-wales": {
      a: "Wales Flag",
      b: "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
      k: [11, 16],
      o: 5
    },
    "man-biking": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B4-1F3FB-200D-2642-FE0F",
          non_qualified: "1F6B4-1F3FB-200D-2642",
          image: "1f6b4-1f3fb-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6B4-1F3FC-200D-2642-FE0F",
          non_qualified: "1F6B4-1F3FC-200D-2642",
          image: "1f6b4-1f3fc-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6B4-1F3FD-200D-2642-FE0F",
          non_qualified: "1F6B4-1F3FD-200D-2642",
          image: "1f6b4-1f3fd-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 20,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6B4-1F3FE-200D-2642-FE0F",
          non_qualified: "1F6B4-1F3FE-200D-2642",
          image: "1f6b4-1f3fe-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6B4-1F3FF-200D-2642-FE0F",
          non_qualified: "1F6B4-1F3FF-200D-2642",
          image: "1f6b4-1f3ff-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F6B4",
      a: "Man Biking",
      b: "1F6B4-200D-2642-FE0F",
      c: "1F6B4-200D-2642",
      k: [35, 17],
      o: 4
    },
    "woman-biking": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B4-1F3FB-200D-2640-FE0F",
          non_qualified: "1F6B4-1F3FB-200D-2640",
          image: "1f6b4-1f3fb-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6B4-1F3FC-200D-2640-FE0F",
          non_qualified: "1F6B4-1F3FC-200D-2640",
          image: "1f6b4-1f3fc-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6B4-1F3FD-200D-2640-FE0F",
          non_qualified: "1F6B4-1F3FD-200D-2640",
          image: "1f6b4-1f3fd-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6B4-1F3FE-200D-2640-FE0F",
          non_qualified: "1F6B4-1F3FE-200D-2640",
          image: "1f6b4-1f3fe-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6B4-1F3FF-200D-2640-FE0F",
          non_qualified: "1F6B4-1F3FF-200D-2640",
          image: "1f6b4-1f3ff-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Biking",
      b: "1F6B4-200D-2640-FE0F",
      c: "1F6B4-200D-2640",
      k: [35, 11],
      o: 4
    },
    mountain_bicyclist: {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B5-1F3FB",
          non_qualified: null,
          image: "1f6b5-1f3fb.png",
          sheet_x: 35,
          sheet_y: 42,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F6B5-1F3FC",
          non_qualified: null,
          image: "1f6b5-1f3fc.png",
          sheet_x: 35,
          sheet_y: 43,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F6B5-1F3FD",
          non_qualified: null,
          image: "1f6b5-1f3fd.png",
          sheet_x: 35,
          sheet_y: 44,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F6B5-1F3FE",
          non_qualified: null,
          image: "1f6b5-1f3fe.png",
          sheet_x: 35,
          sheet_y: 45,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F6B5-1F3FF",
          non_qualified: null,
          image: "1f6b5-1f3ff.png",
          sheet_x: 35,
          sheet_y: 46,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      obsoleted_by: "1F6B5-200D-2642-FE0F",
      a: "Mountain Bicyclist",
      b: "1F6B5",
      k: [35, 41],
      o: 2
    },
    "man-mountain-biking": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B5-1F3FB-200D-2642-FE0F",
          non_qualified: "1F6B5-1F3FB-200D-2642",
          image: "1f6b5-1f3fb-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 36,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6B5-1F3FC-200D-2642-FE0F",
          non_qualified: "1F6B5-1F3FC-200D-2642",
          image: "1f6b5-1f3fc-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6B5-1F3FD-200D-2642-FE0F",
          non_qualified: "1F6B5-1F3FD-200D-2642",
          image: "1f6b5-1f3fd-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6B5-1F3FE-200D-2642-FE0F",
          non_qualified: "1F6B5-1F3FE-200D-2642",
          image: "1f6b5-1f3fe-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6B5-1F3FF-200D-2642-FE0F",
          non_qualified: "1F6B5-1F3FF-200D-2642",
          image: "1f6b5-1f3ff-200d-2642-fe0f.png",
          sheet_x: 35,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      obsoletes: "1F6B5",
      a: "Man Mountain Biking",
      b: "1F6B5-200D-2642-FE0F",
      c: "1F6B5-200D-2642",
      k: [35, 35],
      o: 4
    },
    "woman-mountain-biking": {
      skin_variations: {
        "1F3FB": {
          unified: "1F6B5-1F3FB-200D-2640-FE0F",
          non_qualified: "1F6B5-1F3FB-200D-2640",
          image: "1f6b5-1f3fb-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6B5-1F3FC-200D-2640-FE0F",
          non_qualified: "1F6B5-1F3FC-200D-2640",
          image: "1f6b5-1f3fc-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6B5-1F3FD-200D-2640-FE0F",
          non_qualified: "1F6B5-1F3FD-200D-2640",
          image: "1f6b5-1f3fd-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6B5-1F3FE-200D-2640-FE0F",
          non_qualified: "1F6B5-1F3FE-200D-2640",
          image: "1f6b5-1f3fe-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6B5-1F3FF-200D-2640-FE0F",
          non_qualified: "1F6B5-1F3FF-200D-2640",
          image: "1f6b5-1f3ff-200d-2640-fe0f.png",
          sheet_x: 35,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Mountain Biking",
      b: "1F6B5-200D-2640-FE0F",
      c: "1F6B5-200D-2640",
      k: [35, 29],
      o: 4
    },
    person_doing_cartwheel: {
      skin_variations: {
        "1F3FB": {
          unified: "1F938-1F3FB",
          non_qualified: null,
          image: "1f938-1f3fb.png",
          sheet_x: 40,
          sheet_y: 9,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F938-1F3FC",
          non_qualified: null,
          image: "1f938-1f3fc.png",
          sheet_x: 40,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F938-1F3FD",
          non_qualified: null,
          image: "1f938-1f3fd.png",
          sheet_x: 40,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F938-1F3FE",
          non_qualified: null,
          image: "1f938-1f3fe.png",
          sheet_x: 40,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F938-1F3FF",
          non_qualified: null,
          image: "1f938-1f3ff.png",
          sheet_x: 40,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      a: "Person Doing Cartwheel",
      b: "1F938",
      k: [40, 8],
      o: 4
    },
    "man-cartwheeling": {
      skin_variations: {
        "1F3FB": {
          unified: "1F938-1F3FB-200D-2642-FE0F",
          non_qualified: "1F938-1F3FB-200D-2642",
          image: "1f938-1f3fb-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 3,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F938-1F3FC-200D-2642-FE0F",
          non_qualified: "1F938-1F3FC-200D-2642",
          image: "1f938-1f3fc-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F938-1F3FD-200D-2642-FE0F",
          non_qualified: "1F938-1F3FD-200D-2642",
          image: "1f938-1f3fd-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 5,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F938-1F3FE-200D-2642-FE0F",
          non_qualified: "1F938-1F3FE-200D-2642",
          image: "1f938-1f3fe-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F938-1F3FF-200D-2642-FE0F",
          non_qualified: "1F938-1F3FF-200D-2642",
          image: "1f938-1f3ff-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Cartwheeling",
      b: "1F938-200D-2642-FE0F",
      c: "1F938-200D-2642",
      k: [40, 2],
      o: 4
    },
    "woman-cartwheeling": {
      skin_variations: {
        "1F3FB": {
          unified: "1F938-1F3FB-200D-2640-FE0F",
          non_qualified: "1F938-1F3FB-200D-2640",
          image: "1f938-1f3fb-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 54,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F938-1F3FC-200D-2640-FE0F",
          non_qualified: "1F938-1F3FC-200D-2640",
          image: "1f938-1f3fc-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F938-1F3FD-200D-2640-FE0F",
          non_qualified: "1F938-1F3FD-200D-2640",
          image: "1f938-1f3fd-200d-2640-fe0f.png",
          sheet_x: 39,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F938-1F3FE-200D-2640-FE0F",
          non_qualified: "1F938-1F3FE-200D-2640",
          image: "1f938-1f3fe-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F938-1F3FF-200D-2640-FE0F",
          non_qualified: "1F938-1F3FF-200D-2640",
          image: "1f938-1f3ff-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Cartwheeling",
      b: "1F938-200D-2640-FE0F",
      c: "1F938-200D-2640",
      k: [39, 53],
      o: 4
    },
    wrestlers: { a: "Wrestlers", b: "1F93C", k: [40, 35], o: 4 },
    "man-wrestling": {
      a: "Man Wrestling",
      b: "1F93C-200D-2642-FE0F",
      c: "1F93C-200D-2642",
      k: [40, 34],
      o: 4
    },
    "woman-wrestling": {
      a: "Woman Wrestling",
      b: "1F93C-200D-2640-FE0F",
      c: "1F93C-200D-2640",
      k: [40, 33],
      o: 4
    },
    water_polo: {
      skin_variations: {
        "1F3FB": {
          unified: "1F93D-1F3FB",
          non_qualified: null,
          image: "1f93d-1f3fb.png",
          sheet_x: 40,
          sheet_y: 49,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F93D-1F3FC",
          non_qualified: null,
          image: "1f93d-1f3fc.png",
          sheet_x: 40,
          sheet_y: 50,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F93D-1F3FD",
          non_qualified: null,
          image: "1f93d-1f3fd.png",
          sheet_x: 40,
          sheet_y: 51,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F93D-1F3FE",
          non_qualified: null,
          image: "1f93d-1f3fe.png",
          sheet_x: 40,
          sheet_y: 52,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F93D-1F3FF",
          non_qualified: null,
          image: "1f93d-1f3ff.png",
          sheet_x: 40,
          sheet_y: 53,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      a: "Water Polo",
      b: "1F93D",
      k: [40, 48],
      o: 4
    },
    "man-playing-water-polo": {
      skin_variations: {
        "1F3FB": {
          unified: "1F93D-1F3FB-200D-2642-FE0F",
          non_qualified: "1F93D-1F3FB-200D-2642",
          image: "1f93d-1f3fb-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 43,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F93D-1F3FC-200D-2642-FE0F",
          non_qualified: "1F93D-1F3FC-200D-2642",
          image: "1f93d-1f3fc-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 44,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F93D-1F3FD-200D-2642-FE0F",
          non_qualified: "1F93D-1F3FD-200D-2642",
          image: "1f93d-1f3fd-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 45,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F93D-1F3FE-200D-2642-FE0F",
          non_qualified: "1F93D-1F3FE-200D-2642",
          image: "1f93d-1f3fe-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 46,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F93D-1F3FF-200D-2642-FE0F",
          non_qualified: "1F93D-1F3FF-200D-2642",
          image: "1f93d-1f3ff-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 47,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Playing Water Polo",
      b: "1F93D-200D-2642-FE0F",
      c: "1F93D-200D-2642",
      k: [40, 42],
      o: 4
    },
    "woman-playing-water-polo": {
      skin_variations: {
        "1F3FB": {
          unified: "1F93D-1F3FB-200D-2640-FE0F",
          non_qualified: "1F93D-1F3FB-200D-2640",
          image: "1f93d-1f3fb-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 37,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F93D-1F3FC-200D-2640-FE0F",
          non_qualified: "1F93D-1F3FC-200D-2640",
          image: "1f93d-1f3fc-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 38,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F93D-1F3FD-200D-2640-FE0F",
          non_qualified: "1F93D-1F3FD-200D-2640",
          image: "1f93d-1f3fd-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 39,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F93D-1F3FE-200D-2640-FE0F",
          non_qualified: "1F93D-1F3FE-200D-2640",
          image: "1f93d-1f3fe-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 40,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F93D-1F3FF-200D-2640-FE0F",
          non_qualified: "1F93D-1F3FF-200D-2640",
          image: "1f93d-1f3ff-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 41,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Playing Water Polo",
      b: "1F93D-200D-2640-FE0F",
      c: "1F93D-200D-2640",
      k: [40, 36],
      o: 4
    },
    handball: {
      skin_variations: {
        "1F3FB": {
          unified: "1F93E-1F3FB",
          non_qualified: null,
          image: "1f93e-1f3fb.png",
          sheet_x: 41,
          sheet_y: 10,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC": {
          unified: "1F93E-1F3FC",
          non_qualified: null,
          image: "1f93e-1f3fc.png",
          sheet_x: 41,
          sheet_y: 11,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD": {
          unified: "1F93E-1F3FD",
          non_qualified: null,
          image: "1f93e-1f3fd.png",
          sheet_x: 41,
          sheet_y: 12,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE": {
          unified: "1F93E-1F3FE",
          non_qualified: null,
          image: "1f93e-1f3fe.png",
          sheet_x: 41,
          sheet_y: 13,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF": {
          unified: "1F93E-1F3FF",
          non_qualified: null,
          image: "1f93e-1f3ff.png",
          sheet_x: 41,
          sheet_y: 14,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: false
        }
      },
      a: "Handball",
      b: "1F93E",
      k: [41, 9],
      o: 4
    },
    "man-playing-handball": {
      skin_variations: {
        "1F3FB": {
          unified: "1F93E-1F3FB-200D-2642-FE0F",
          non_qualified: "1F93E-1F3FB-200D-2642",
          image: "1f93e-1f3fb-200d-2642-fe0f.png",
          sheet_x: 41,
          sheet_y: 4,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F93E-1F3FC-200D-2642-FE0F",
          non_qualified: "1F93E-1F3FC-200D-2642",
          image: "1f93e-1f3fc-200d-2642-fe0f.png",
          sheet_x: 41,
          sheet_y: 5,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F93E-1F3FD-200D-2642-FE0F",
          non_qualified: "1F93E-1F3FD-200D-2642",
          image: "1f93e-1f3fd-200d-2642-fe0f.png",
          sheet_x: 41,
          sheet_y: 6,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F93E-1F3FE-200D-2642-FE0F",
          non_qualified: "1F93E-1F3FE-200D-2642",
          image: "1f93e-1f3fe-200d-2642-fe0f.png",
          sheet_x: 41,
          sheet_y: 7,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F93E-1F3FF-200D-2642-FE0F",
          non_qualified: "1F93E-1F3FF-200D-2642",
          image: "1f93e-1f3ff-200d-2642-fe0f.png",
          sheet_x: 41,
          sheet_y: 8,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Playing Handball",
      b: "1F93E-200D-2642-FE0F",
      c: "1F93E-200D-2642",
      k: [41, 3],
      o: 4
    },
    "woman-playing-handball": {
      skin_variations: {
        "1F3FB": {
          unified: "1F93E-1F3FB-200D-2640-FE0F",
          non_qualified: "1F93E-1F3FB-200D-2640",
          image: "1f93e-1f3fb-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 55,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F93E-1F3FC-200D-2640-FE0F",
          non_qualified: "1F93E-1F3FC-200D-2640",
          image: "1f93e-1f3fc-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 56,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F93E-1F3FD-200D-2640-FE0F",
          non_qualified: "1F93E-1F3FD-200D-2640",
          image: "1f93e-1f3fd-200d-2640-fe0f.png",
          sheet_x: 41,
          sheet_y: 0,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F93E-1F3FE-200D-2640-FE0F",
          non_qualified: "1F93E-1F3FE-200D-2640",
          image: "1f93e-1f3fe-200d-2640-fe0f.png",
          sheet_x: 41,
          sheet_y: 1,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F93E-1F3FF-200D-2640-FE0F",
          non_qualified: "1F93E-1F3FF-200D-2640",
          image: "1f93e-1f3ff-200d-2640-fe0f.png",
          sheet_x: 41,
          sheet_y: 2,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Playing Handball",
      b: "1F93E-200D-2640-FE0F",
      c: "1F93E-200D-2640",
      k: [40, 54],
      o: 4
    },
    juggling: {
      skin_variations: {
        "1F3FB": {
          unified: "1F939-1F3FB",
          non_qualified: null,
          image: "1f939-1f3fb.png",
          sheet_x: 40,
          sheet_y: 27,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F939-1F3FC",
          non_qualified: null,
          image: "1f939-1f3fc.png",
          sheet_x: 40,
          sheet_y: 28,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F939-1F3FD",
          non_qualified: null,
          image: "1f939-1f3fd.png",
          sheet_x: 40,
          sheet_y: 29,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F939-1F3FE",
          non_qualified: null,
          image: "1f939-1f3fe.png",
          sheet_x: 40,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F939-1F3FF",
          non_qualified: null,
          image: "1f939-1f3ff.png",
          sheet_x: 40,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Juggling",
      b: "1F939",
      k: [40, 26],
      o: 4
    },
    "man-juggling": {
      skin_variations: {
        "1F3FB": {
          unified: "1F939-1F3FB-200D-2642-FE0F",
          non_qualified: "1F939-1F3FB-200D-2642",
          image: "1f939-1f3fb-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 21,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F939-1F3FC-200D-2642-FE0F",
          non_qualified: "1F939-1F3FC-200D-2642",
          image: "1f939-1f3fc-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 22,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F939-1F3FD-200D-2642-FE0F",
          non_qualified: "1F939-1F3FD-200D-2642",
          image: "1f939-1f3fd-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 23,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F939-1F3FE-200D-2642-FE0F",
          non_qualified: "1F939-1F3FE-200D-2642",
          image: "1f939-1f3fe-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 24,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F939-1F3FF-200D-2642-FE0F",
          non_qualified: "1F939-1F3FF-200D-2642",
          image: "1f939-1f3ff-200d-2642-fe0f.png",
          sheet_x: 40,
          sheet_y: 25,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man Juggling",
      b: "1F939-200D-2642-FE0F",
      c: "1F939-200D-2642",
      k: [40, 20],
      o: 4
    },
    "woman-juggling": {
      skin_variations: {
        "1F3FB": {
          unified: "1F939-1F3FB-200D-2640-FE0F",
          non_qualified: "1F939-1F3FB-200D-2640",
          image: "1f939-1f3fb-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 15,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F939-1F3FC-200D-2640-FE0F",
          non_qualified: "1F939-1F3FC-200D-2640",
          image: "1f939-1f3fc-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 16,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F939-1F3FD-200D-2640-FE0F",
          non_qualified: "1F939-1F3FD-200D-2640",
          image: "1f939-1f3fd-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 17,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F939-1F3FE-200D-2640-FE0F",
          non_qualified: "1F939-1F3FE-200D-2640",
          image: "1f939-1f3fe-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 18,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F939-1F3FF-200D-2640-FE0F",
          non_qualified: "1F939-1F3FF-200D-2640",
          image: "1f939-1f3ff-200d-2640-fe0f.png",
          sheet_x: 40,
          sheet_y: 19,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Woman Juggling",
      b: "1F939-200D-2640-FE0F",
      c: "1F939-200D-2640",
      k: [40, 14],
      o: 4
    },
    person_in_lotus_position: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D8-1F3FB",
          non_qualified: null,
          image: "1f9d8-1f3fb.png",
          sheet_x: 49,
          sheet_y: 32,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D8-1F3FB-200D-2640-FE0F"
        },
        "1F3FC": {
          unified: "1F9D8-1F3FC",
          non_qualified: null,
          image: "1f9d8-1f3fc.png",
          sheet_x: 49,
          sheet_y: 33,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D8-1F3FC-200D-2640-FE0F"
        },
        "1F3FD": {
          unified: "1F9D8-1F3FD",
          non_qualified: null,
          image: "1f9d8-1f3fd.png",
          sheet_x: 49,
          sheet_y: 34,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D8-1F3FD-200D-2640-FE0F"
        },
        "1F3FE": {
          unified: "1F9D8-1F3FE",
          non_qualified: null,
          image: "1f9d8-1f3fe.png",
          sheet_x: 49,
          sheet_y: 35,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D8-1F3FE-200D-2640-FE0F"
        },
        "1F3FF": {
          unified: "1F9D8-1F3FF",
          non_qualified: null,
          image: "1f9d8-1f3ff.png",
          sheet_x: 49,
          sheet_y: 36,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoleted_by: "1F9D8-1F3FF-200D-2640-FE0F"
        }
      },
      obsoleted_by: "1F9D8-200D-2640-FE0F",
      a: "Person in Lotus Position",
      b: "1F9D8",
      k: [49, 31],
      o: 5
    },
    man_in_lotus_position: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D8-1F3FB-200D-2642-FE0F",
          non_qualified: "1F9D8-1F3FB-200D-2642",
          image: "1f9d8-1f3fb-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 26,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F9D8-1F3FC-200D-2642-FE0F",
          non_qualified: "1F9D8-1F3FC-200D-2642",
          image: "1f9d8-1f3fc-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 27,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F9D8-1F3FD-200D-2642-FE0F",
          non_qualified: "1F9D8-1F3FD-200D-2642",
          image: "1f9d8-1f3fd-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 28,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F9D8-1F3FE-200D-2642-FE0F",
          non_qualified: "1F9D8-1F3FE-200D-2642",
          image: "1f9d8-1f3fe-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 29,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F9D8-1F3FF-200D-2642-FE0F",
          non_qualified: "1F9D8-1F3FF-200D-2642",
          image: "1f9d8-1f3ff-200d-2642-fe0f.png",
          sheet_x: 49,
          sheet_y: 30,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man in Lotus Position",
      b: "1F9D8-200D-2642-FE0F",
      c: "1F9D8-200D-2642",
      k: [49, 25],
      o: 5
    },
    woman_in_lotus_position: {
      skin_variations: {
        "1F3FB": {
          unified: "1F9D8-1F3FB-200D-2640-FE0F",
          non_qualified: "1F9D8-1F3FB-200D-2640",
          image: "1f9d8-1f3fb-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 20,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D8-1F3FB"
        },
        "1F3FC": {
          unified: "1F9D8-1F3FC-200D-2640-FE0F",
          non_qualified: "1F9D8-1F3FC-200D-2640",
          image: "1f9d8-1f3fc-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 21,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D8-1F3FC"
        },
        "1F3FD": {
          unified: "1F9D8-1F3FD-200D-2640-FE0F",
          non_qualified: "1F9D8-1F3FD-200D-2640",
          image: "1f9d8-1f3fd-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 22,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D8-1F3FD"
        },
        "1F3FE": {
          unified: "1F9D8-1F3FE-200D-2640-FE0F",
          non_qualified: "1F9D8-1F3FE-200D-2640",
          image: "1f9d8-1f3fe-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 23,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D8-1F3FE"
        },
        "1F3FF": {
          unified: "1F9D8-1F3FF-200D-2640-FE0F",
          non_qualified: "1F9D8-1F3FF-200D-2640",
          image: "1f9d8-1f3ff-200d-2640-fe0f.png",
          sheet_x: 49,
          sheet_y: 24,
          added_in: "5.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true,
          obsoletes: "1F9D8-1F3FF"
        }
      },
      obsoletes: "1F9D8",
      a: "Woman in Lotus Position",
      b: "1F9D8-200D-2640-FE0F",
      c: "1F9D8-200D-2640",
      k: [49, 19],
      o: 5
    },
    bath: {
      skin_variations: {
        "1F3FB": {
          unified: "1F6C0-1F3FB",
          non_qualified: null,
          image: "1f6c0-1f3fb.png",
          sheet_x: 36,
          sheet_y: 18,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6C0-1F3FC",
          non_qualified: null,
          image: "1f6c0-1f3fc.png",
          sheet_x: 36,
          sheet_y: 19,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6C0-1F3FD",
          non_qualified: null,
          image: "1f6c0-1f3fd.png",
          sheet_x: 36,
          sheet_y: 20,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6C0-1F3FE",
          non_qualified: null,
          image: "1f6c0-1f3fe.png",
          sheet_x: 36,
          sheet_y: 21,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6C0-1F3FF",
          non_qualified: null,
          image: "1f6c0-1f3ff.png",
          sheet_x: 36,
          sheet_y: 22,
          added_in: "2.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Bath",
      b: "1F6C0",
      j: ["clean", "shower", "bathroom"],
      k: [36, 17],
      o: 2
    },
    sleeping_accommodation: {
      skin_variations: {
        "1F3FB": {
          unified: "1F6CC-1F3FB",
          non_qualified: null,
          image: "1f6cc-1f3fb.png",
          sheet_x: 36,
          sheet_y: 30,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F6CC-1F3FC",
          non_qualified: null,
          image: "1f6cc-1f3fc.png",
          sheet_x: 36,
          sheet_y: 31,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F6CC-1F3FD",
          non_qualified: null,
          image: "1f6cc-1f3fd.png",
          sheet_x: 36,
          sheet_y: 32,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F6CC-1F3FE",
          non_qualified: null,
          image: "1f6cc-1f3fe.png",
          sheet_x: 36,
          sheet_y: 33,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F6CC-1F3FF",
          non_qualified: null,
          image: "1f6cc-1f3ff.png",
          sheet_x: 36,
          sheet_y: 34,
          added_in: "4.0",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Sleeping Accommodation",
      b: "1F6CC",
      k: [36, 29],
      o: 2
    },
    people_holding_hands: {
      skin_variations: {
        "1F3FB-1F3FB": {
          unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png",
          sheet_x: 46,
          sheet_y: 39,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FB-1F3FC": {
          unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png",
          sheet_x: 46,
          sheet_y: 40,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FD": {
          unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png",
          sheet_x: 46,
          sheet_y: 41,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FE": {
          unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png",
          sheet_x: 46,
          sheet_y: 42,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FF": {
          unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF",
          non_qualified: null,
          image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png",
          sheet_x: 46,
          sheet_y: 43,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FB": {
          unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png",
          sheet_x: 46,
          sheet_y: 44,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FC": {
          unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png",
          sheet_x: 46,
          sheet_y: 45,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FD": {
          unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png",
          sheet_x: 46,
          sheet_y: 46,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FE": {
          unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png",
          sheet_x: 46,
          sheet_y: 47,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FF": {
          unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF",
          non_qualified: null,
          image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png",
          sheet_x: 46,
          sheet_y: 48,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD-1F3FB": {
          unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png",
          sheet_x: 46,
          sheet_y: 49,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FC": {
          unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png",
          sheet_x: 46,
          sheet_y: 50,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FD": {
          unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png",
          sheet_x: 46,
          sheet_y: 51,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FE": {
          unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png",
          sheet_x: 46,
          sheet_y: 52,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD-1F3FF": {
          unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF",
          non_qualified: null,
          image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png",
          sheet_x: 46,
          sheet_y: 53,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE-1F3FB": {
          unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png",
          sheet_x: 46,
          sheet_y: 54,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FC": {
          unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png",
          sheet_x: 46,
          sheet_y: 55,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FD": {
          unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png",
          sheet_x: 46,
          sheet_y: 56,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FE": {
          unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png",
          sheet_x: 47,
          sheet_y: 0,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FF": {
          unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF",
          non_qualified: null,
          image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png",
          sheet_x: 47,
          sheet_y: 1,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF-1F3FB": {
          unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png",
          sheet_x: 47,
          sheet_y: 2,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FC": {
          unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png",
          sheet_x: 47,
          sheet_y: 3,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FD": {
          unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png",
          sheet_x: 47,
          sheet_y: 4,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FE": {
          unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png",
          sheet_x: 47,
          sheet_y: 5,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FF": {
          unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF",
          non_qualified: null,
          image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png",
          sheet_x: 47,
          sheet_y: 6,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "People Holding Hands",
      b: "1F9D1-200D-1F91D-200D-1F9D1",
      k: [46, 38],
      o: 12
    },
    two_women_holding_hands: {
      skin_variations: {
        "1F3FB": {
          unified: "1F46D-1F3FB",
          non_qualified: null,
          image: "1f46d-1f3fb.png",
          sheet_x: 21,
          sheet_y: 12,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F46D-1F3FC",
          non_qualified: null,
          image: "1f46d-1f3fc.png",
          sheet_x: 21,
          sheet_y: 13,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F46D-1F3FD",
          non_qualified: null,
          image: "1f46d-1f3fd.png",
          sheet_x: 21,
          sheet_y: 14,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F46D-1F3FE",
          non_qualified: null,
          image: "1f46d-1f3fe.png",
          sheet_x: 21,
          sheet_y: 15,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F46D-1F3FF",
          non_qualified: null,
          image: "1f46d-1f3ff.png",
          sheet_x: 21,
          sheet_y: 16,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FB-1F3FC": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png",
          sheet_x: 21,
          sheet_y: 17,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FD": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png",
          sheet_x: 21,
          sheet_y: 18,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FE": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png",
          sheet_x: 21,
          sheet_y: 19,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FF": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png",
          sheet_x: 21,
          sheet_y: 20,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FB": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png",
          sheet_x: 21,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FD": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png",
          sheet_x: 21,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FE": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png",
          sheet_x: 21,
          sheet_y: 23,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FF": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png",
          sheet_x: 21,
          sheet_y: 24,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD-1F3FB": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png",
          sheet_x: 21,
          sheet_y: 25,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FC": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png",
          sheet_x: 21,
          sheet_y: 26,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FE": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png",
          sheet_x: 21,
          sheet_y: 27,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD-1F3FF": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png",
          sheet_x: 21,
          sheet_y: 28,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE-1F3FB": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png",
          sheet_x: 21,
          sheet_y: 29,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FC": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png",
          sheet_x: 21,
          sheet_y: 30,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FD": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png",
          sheet_x: 21,
          sheet_y: 31,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FF": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png",
          sheet_x: 21,
          sheet_y: 32,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF-1F3FB": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png",
          sheet_x: 21,
          sheet_y: 33,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FC": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png",
          sheet_x: 21,
          sheet_y: 34,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FD": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png",
          sheet_x: 21,
          sheet_y: 35,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FE": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png",
          sheet_x: 21,
          sheet_y: 36,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Two Women Holding Hands",
      b: "1F46D",
      j: [
        "pair",
        "friendship",
        "couple",
        "love",
        "like",
        "female",
        "people",
        "human"
      ],
      k: [21, 11],
      n: ["women_holding_hands"],
      o: 2
    },
    couple: {
      skin_variations: {
        "1F3FB": {
          unified: "1F46B-1F3FB",
          non_qualified: null,
          image: "1f46b-1f3fb.png",
          sheet_x: 20,
          sheet_y: 17,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F46B-1F3FC",
          non_qualified: null,
          image: "1f46b-1f3fc.png",
          sheet_x: 20,
          sheet_y: 18,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F46B-1F3FD",
          non_qualified: null,
          image: "1f46b-1f3fd.png",
          sheet_x: 20,
          sheet_y: 19,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F46B-1F3FE",
          non_qualified: null,
          image: "1f46b-1f3fe.png",
          sheet_x: 20,
          sheet_y: 20,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F46B-1F3FF",
          non_qualified: null,
          image: "1f46b-1f3ff.png",
          sheet_x: 20,
          sheet_y: 21,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FB-1F3FC": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 20,
          sheet_y: 22,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FB-1F3FD": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 20,
          sheet_y: 23,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FB-1F3FE": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 20,
          sheet_y: 24,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FB-1F3FF": {
          unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 20,
          sheet_y: 25,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FB": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 20,
          sheet_y: 26,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FD": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 20,
          sheet_y: 27,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FE": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 20,
          sheet_y: 28,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FF": {
          unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 20,
          sheet_y: 29,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FB": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 20,
          sheet_y: 30,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FC": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 20,
          sheet_y: 31,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FE": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 20,
          sheet_y: 32,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FF": {
          unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 20,
          sheet_y: 33,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FB": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 20,
          sheet_y: 34,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FC": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 20,
          sheet_y: 35,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FD": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 20,
          sheet_y: 36,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FF": {
          unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 20,
          sheet_y: 37,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FB": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 20,
          sheet_y: 38,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FC": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 20,
          sheet_y: 39,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FD": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 20,
          sheet_y: 40,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FE": {
          unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 20,
          sheet_y: 41,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Man and Woman Holding Hands",
      b: "1F46B",
      j: [
        "pair",
        "people",
        "human",
        "love",
        "date",
        "dating",
        "like",
        "affection",
        "valentines",
        "marriage"
      ],
      k: [20, 16],
      n: ["man_and_woman_holding_hands", "woman_and_man_holding_hands"],
      o: 2
    },
    two_men_holding_hands: {
      skin_variations: {
        "1F3FB": {
          unified: "1F46C-1F3FB",
          non_qualified: null,
          image: "1f46c-1f3fb.png",
          sheet_x: 20,
          sheet_y: 43,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC": {
          unified: "1F46C-1F3FC",
          non_qualified: null,
          image: "1f46c-1f3fc.png",
          sheet_x: 20,
          sheet_y: 44,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD": {
          unified: "1F46C-1F3FD",
          non_qualified: null,
          image: "1f46c-1f3fd.png",
          sheet_x: 20,
          sheet_y: 45,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE": {
          unified: "1F46C-1F3FE",
          non_qualified: null,
          image: "1f46c-1f3fe.png",
          sheet_x: 20,
          sheet_y: 46,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF": {
          unified: "1F46C-1F3FF",
          non_qualified: null,
          image: "1f46c-1f3ff.png",
          sheet_x: 20,
          sheet_y: 47,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FB-1F3FC": {
          unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 20,
          sheet_y: 48,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FD": {
          unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 20,
          sheet_y: 49,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FE": {
          unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 20,
          sheet_y: 50,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FB-1F3FF": {
          unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 20,
          sheet_y: 51,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FB": {
          unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 20,
          sheet_y: 52,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FC-1F3FD": {
          unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 20,
          sheet_y: 53,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FE": {
          unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 20,
          sheet_y: 54,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FC-1F3FF": {
          unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 20,
          sheet_y: 55,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD-1F3FB": {
          unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 20,
          sheet_y: 56,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FC": {
          unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 21,
          sheet_y: 0,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FD-1F3FE": {
          unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 21,
          sheet_y: 1,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FD-1F3FF": {
          unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 21,
          sheet_y: 2,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FE-1F3FB": {
          unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 21,
          sheet_y: 3,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FC": {
          unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 21,
          sheet_y: 4,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FD": {
          unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 21,
          sheet_y: 5,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FE-1F3FF": {
          unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF",
          non_qualified: null,
          image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
          sheet_x: 21,
          sheet_y: 6,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: false,
          has_img_twitter: true,
          has_img_facebook: false
        },
        "1F3FF-1F3FB": {
          unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
          sheet_x: 21,
          sheet_y: 7,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FC": {
          unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
          sheet_x: 21,
          sheet_y: 8,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FD": {
          unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
          sheet_x: 21,
          sheet_y: 9,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        },
        "1F3FF-1F3FE": {
          unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE",
          non_qualified: null,
          image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
          sheet_x: 21,
          sheet_y: 10,
          added_in: "12.1",
          has_img_apple: true,
          has_img_google: true,
          has_img_twitter: true,
          has_img_facebook: true
        }
      },
      a: "Two Men Holding Hands",
      b: "1F46C",
      j: [
        "pair",
        "couple",
        "love",
        "like",
        "bromance",
        "friendship",
        "people",
        "human"
      ],
      k: [20, 42],
      n: ["men_holding_hands"],
      o: 2
    },
    couplekiss: {
      obsoleted_by: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
      a: "Kiss",
      b: "1F48F",
      k: [25, 25],
      o: 2
    },
    "woman-kiss-man": {
      obsoletes: "1F48F",
      a: "Woman Kiss Man",
      b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
      c: "1F469-200D-2764-200D-1F48B-200D-1F468",
      k: [20, 7],
      o: 2
    },
    "man-kiss-man": {
      a: "Man Kiss Man",
      b: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
      c: "1F468-200D-2764-200D-1F48B-200D-1F468",
      k: [17, 21],
      o: 2
    },
    "woman-kiss-woman": {
      a: "Woman Kiss Woman",
      b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
      c: "1F469-200D-2764-200D-1F48B-200D-1F469",
      k: [20, 8],
      o: 2
    },
    couple_with_heart: {
      obsoleted_by: "1F469-200D-2764-FE0F-200D-1F468",
      a: "Couple with Heart",
      b: "1F491",
      k: [25, 27],
      o: 2
    },
    "woman-heart-man": {
      obsoletes: "1F491",
      a: "Woman Heart Man",
      b: "1F469-200D-2764-FE0F-200D-1F468",
      c: "1F469-200D-2764-200D-1F468",
      k: [20, 5],
      o: 2
    },
    "man-heart-man": {
      a: "Man Heart Man",
      b: "1F468-200D-2764-FE0F-200D-1F468",
      c: "1F468-200D-2764-200D-1F468",
      k: [17, 20],
      o: 2
    },
    "woman-heart-woman": {
      a: "Woman Heart Woman",
      b: "1F469-200D-2764-FE0F-200D-1F469",
      c: "1F469-200D-2764-200D-1F469",
      k: [20, 6],
      o: 2
    },
    family: {
      obsoleted_by: "1F468-200D-1F469-200D-1F466",
      a: "Family",
      b: "1F46A",
      k: [20, 15],
      n: ["man-woman-boy"],
      o: 2
    },
    "man-woman-boy": {
      obsoletes: "1F46A",
      a: "Man Woman Boy",
      b: "1F468-200D-1F469-200D-1F466",
      k: [15, 33],
      n: ["family"],
      o: 2
    },
    "man-woman-girl": {
      a: "Man Woman Girl",
      b: "1F468-200D-1F469-200D-1F467",
      k: [15, 35],
      o: 2
    },
    "man-woman-girl-boy": {
      a: "Man Woman Girl Boy",
      b: "1F468-200D-1F469-200D-1F467-200D-1F466",
      k: [15, 36],
      o: 2
    },
    "man-woman-boy-boy": {
      a: "Man Woman Boy Boy",
      b: "1F468-200D-1F469-200D-1F466-200D-1F466",
      k: [15, 34],
      o: 2
    },
    "man-woman-girl-girl": {
      a: "Man Woman Girl Girl",
      b: "1F468-200D-1F469-200D-1F467-200D-1F467",
      k: [15, 37],
      o: 2
    },
    "man-man-boy": {
      a: "Man Man Boy",
      b: "1F468-200D-1F468-200D-1F466",
      k: [15, 28],
      o: 2
    },
    "man-man-girl": {
      a: "Man Man Girl",
      b: "1F468-200D-1F468-200D-1F467",
      k: [15, 30],
      o: 2
    },
    "man-man-girl-boy": {
      a: "Man Man Girl Boy",
      b: "1F468-200D-1F468-200D-1F467-200D-1F466",
      k: [15, 31],
      o: 2
    },
    "man-man-boy-boy": {
      a: "Man Man Boy Boy",
      b: "1F468-200D-1F468-200D-1F466-200D-1F466",
      k: [15, 29],
      o: 2
    },
    "man-man-girl-girl": {
      a: "Man Man Girl Girl",
      b: "1F468-200D-1F468-200D-1F467-200D-1F467",
      k: [15, 32],
      o: 2
    },
    "woman-woman-boy": {
      a: "Woman Woman Boy",
      b: "1F469-200D-1F469-200D-1F466",
      k: [18, 18],
      o: 2
    },
    "woman-woman-girl": {
      a: "Woman Woman Girl",
      b: "1F469-200D-1F469-200D-1F467",
      k: [18, 20],
      o: 2
    },
    "woman-woman-girl-boy": {
      a: "Woman Woman Girl Boy",
      b: "1F469-200D-1F469-200D-1F467-200D-1F466",
      k: [18, 21],
      o: 2
    },
    "woman-woman-boy-boy": {
      a: "Woman Woman Boy Boy",
      b: "1F469-200D-1F469-200D-1F466-200D-1F466",
      k: [18, 19],
      o: 2
    },
    "woman-woman-girl-girl": {
      a: "Woman Woman Girl Girl",
      b: "1F469-200D-1F469-200D-1F467-200D-1F467",
      k: [18, 22],
      o: 2
    },
    "man-boy": { a: "Man Boy", b: "1F468-200D-1F466", k: [15, 24], o: 4 },
    "man-boy-boy": {
      a: "Man Boy Boy",
      b: "1F468-200D-1F466-200D-1F466",
      k: [15, 23],
      o: 4
    },
    "man-girl": { a: "Man Girl", b: "1F468-200D-1F467", k: [15, 27], o: 4 },
    "man-girl-boy": {
      a: "Man Girl Boy",
      b: "1F468-200D-1F467-200D-1F466",
      k: [15, 25],
      o: 4
    },
    "man-girl-girl": {
      a: "Man Girl Girl",
      b: "1F468-200D-1F467-200D-1F467",
      k: [15, 26],
      o: 4
    },
    "woman-boy": { a: "Woman Boy", b: "1F469-200D-1F466", k: [18, 14], o: 4 },
    "woman-boy-boy": {
      a: "Woman Boy Boy",
      b: "1F469-200D-1F466-200D-1F466",
      k: [18, 13],
      o: 4
    },
    "woman-girl": { a: "Woman Girl", b: "1F469-200D-1F467", k: [18, 17], o: 4 },
    "woman-girl-boy": {
      a: "Woman Girl Boy",
      b: "1F469-200D-1F467-200D-1F466",
      k: [18, 15],
      o: 4
    },
    "woman-girl-girl": {
      a: "Woman Girl Girl",
      b: "1F469-200D-1F467-200D-1F467",
      k: [18, 16],
      o: 4
    },
    speaking_head_in_silhouette: {
      a: "Speaking Head in Silhouette",
      b: "1F5E3-FE0F",
      c: "1F5E3",
      k: [30, 25],
      o: 2
    },
    bust_in_silhouette: {
      a: "Bust in Silhouette",
      b: "1F464",
      j: ["user", "person", "human"],
      k: [14, 24],
      o: 2
    },
    busts_in_silhouette: {
      a: "Busts in Silhouette",
      b: "1F465",
      j: ["user", "person", "human", "group", "team"],
      k: [14, 25],
      o: 2
    },
    footprints: {
      a: "Footprints",
      b: "1F463",
      j: ["feet", "tracking", "walking", "beach"],
      k: [14, 23],
      o: 2
    }
  },
  aliases: {
    raised_hand: "hand",
    satisfied: "laughing",
    tshirt: "shirt",
    hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
    sign_of_the_horns: "the_horns",
    grinning_face_with_star_eyes: "star-struck",
    reversed_hand_with_middle_finger_extended: "middle_finger",
    thumbsup: "+1",
    thumbsdown: "-1",
    punch: "facepunch",
    grinning_face_with_one_large_and_one_small_eye: "zany_face",
    shoe: "mans_shoe",
    smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
    face_with_finger_covering_closed_lips: "shushing_face",
    face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
    face_with_open_mouth_vomiting: "face_vomiting",
    cooking: "fried_egg",
    "flag-cn": "cn",
    shocked_face_with_exploding_head: "exploding_head",
    paw_prints: "feet",
    "flag-de": "de",
    telephone: "phone",
    "flag-es": "es",
    red_car: "car",
    flipper: "dolphin",
    "flag-fr": "fr",
    uk: "gb",
    "flag-gb": "gb",
    serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
    poop: "hankey",
    shit: "hankey",
    honeybee: "bee",
    lantern: "izakaya_lantern",
    open_book: "book",
    sailboat: "boat",
    knife: "hocho",
    "flag-it": "it",
    heavy_exclamation_mark: "exclamation",
    "flag-jp": "jp",
    envelope: "email",
    "flag-kr": "kr",
    collision: "boom",
    pencil: "memo",
    waxing_gibbous_moon: "moon",
    mother_christmas: "mrs_claus",
    sun_small_cloud: "mostly_sunny",
    sun_behind_cloud: "barely_sunny",
    sun_behind_rain_cloud: "partly_sunny_rain",
    lightning_cloud: "lightning",
    tornado_cloud: "tornado",
    "flag-ru": "ru",
    running: "runner",
    "flag-us": "us",
    women_holding_hands: "two_women_holding_hands",
    man_and_woman_holding_hands: "couple",
    woman_and_man_holding_hands: "couple",
    men_holding_hands: "two_men_holding_hands",
    "man-woman-boy": "family",
    family: "man-woman-boy"
  }
};
const StyledContainer = styled(Box)(({ theme: theme2 }) => ({
  width: "430px",
  minHeight: "40px",
  maxHeight: "50vh",
  background: `${alpha(theme2.palette.background.default, 0.7)}`,
  backdropFilter: "blur(16px)",
  padding: "10px 10px 0px 10px",
  borderRadius: "4px",
  overflowY: "scroll",
  scrollPaddingTop: "5px",
  scrollSnapType: "y mandatory",
  borderRight: "5px solid rgba(28, 29, 33, 0)",
  "&::-webkit-scrollbar": {
    width: "4px"
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent"
  },
  "&::-webkit-scrollbar-thumb": {
    padding: "10px 0",
    margin: "10px 0",
    background: theme2.palette.common.black,
    borderBox: "padding-box",
    fontSize: "16px",
    borderRadius: "8px",
    opacity: 0
  }
}));
const StyledLabel = styled(Box)(({ theme: { palette } }) => ({
  fontSize: "12px",
  color: palette.text.primary,
  marginBottom: "5px",
  scrollSnapAlign: "start",
  textTransform: "uppercase"
}));
const StyledCategory = styled(Box)(() => ({
  marginBottom: "10px"
}));
const StyledEmoji = styled(Box)(({ theme: { palette } }) => ({
  fontSize: "24px",
  boxSizing: "border-box",
  width: "34px",
  height: "34px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  padding: "5px",
  backgroundColor: "transparent",
  transition: "backgroundColor 0.3s",
  cursor: "pointer",
  "&:hover, &.active": {
    backgroundColor: palette.grey["300"]
  }
}));
const ELEMENT_PER_ROW = 12;
const useNavigation = (searchResults, emojiRefs, editor, range) => {
  const [isNavigating, setIsNavigating] = React__default.useState(true);
  const [selected, setSelected] = React__default.useState({
    category: 0,
    emoji: 0
  });
  const selectItem = React__default.useCallback(() => {
    var _a;
    if (!range)
      return;
    editor.chain().focus().deleteRange(range).insertContent(
      (_a = searchResults[selected.category]) == null ? void 0 : _a.emojis[selected.emoji].native
    ).run();
  }, [editor, range, searchResults, selected]);
  const handleArrowUp = React__default.useCallback(() => {
    var _a;
    const notFirstRow = (_a = searchResults[selected.category]) == null ? void 0 : _a.emojis[selected.emoji - ELEMENT_PER_ROW];
    if (notFirstRow) {
      return {
        category: selected.category,
        emoji: selected.emoji - ELEMENT_PER_ROW
      };
    } else if (searchResults[selected.category - 1]) {
      const numberOfRow = Math.ceil(
        searchResults[selected.category - 1].emojis.length / ELEMENT_PER_ROW
      ) - 1;
      let lastRowEmojiPosition = selected.emoji + numberOfRow * ELEMENT_PER_ROW;
      if (lastRowEmojiPosition > searchResults[selected.category - 1].emojis.length)
        lastRowEmojiPosition -= ELEMENT_PER_ROW;
      if (searchResults[selected.category - 1].emojis[lastRowEmojiPosition])
        return {
          category: selected.category - 1,
          emoji: lastRowEmojiPosition
        };
      else
        return {
          category: selected.category - 1,
          emoji: searchResults[selected.category - 1].emojis.length - 1
        };
    }
    return {};
  }, [searchResults, selected]);
  const handleArrowRight = React__default.useCallback(() => {
    var _a;
    if ((_a = searchResults[selected.category]) == null ? void 0 : _a.emojis[selected.emoji + 1]) {
      return {
        emoji: selected.emoji + 1
      };
    } else if (searchResults[selected.category + 1]) {
      return { category: selected.category + 1, emoji: 0 };
    }
    return {};
  }, [searchResults, selected]);
  const handleArrowDown = React__default.useCallback(() => {
    var _a;
    if ((_a = searchResults[selected.category]) == null ? void 0 : _a.emojis[selected.emoji + ELEMENT_PER_ROW])
      return {
        emoji: selected.emoji + ELEMENT_PER_ROW
      };
    else if (searchResults[selected.category + 1]) {
      if (searchResults[selected.category + 1].emojis[selected.emoji])
        return {
          category: selected.category + 1
        };
      else {
        if (searchResults[selected.category + 1].emojis[selected.emoji % ELEMENT_PER_ROW])
          return {
            category: selected.category + 1,
            emoji: selected.emoji % ELEMENT_PER_ROW
          };
        else if (searchResults[selected.category + 1])
          return {
            category: selected.category + 1,
            emoji: searchResults[selected.category + 1].emojis.length - 1
          };
      }
    }
    return {};
  }, [searchResults, selected]);
  const handleArrowLeft = React__default.useCallback(() => {
    if (selected.emoji > 0 && !_.isEqual(selected, { category: 0, emoji: 0 }))
      return {
        emoji: selected.emoji - 1
      };
    else if (searchResults[selected.category - 1])
      return {
        category: selected.category - 1,
        emoji: searchResults[selected.category - 1].emojis.length - 1
      };
    return {};
  }, [searchResults, selected]);
  const scrollTo = React__default.useCallback(
    (selection) => {
      var _a, _b, _c;
      const emoji = (_c = (_b = (_a = emojiRefs.current) == null ? void 0 : _a[selection.category]) == null ? void 0 : _b[selection.emoji]) == null ? void 0 : _c.current;
      if (emoji) {
        const parent = document.getElementById("EmojiPanel");
        parent == null ? void 0 : parent.scrollTo({
          top: emoji.offsetTop - emoji.offsetHeight,
          behavior: "smooth"
        });
      }
    },
    [emojiRefs]
  );
  const handleKeyboardNavigation = React__default.useCallback(
    (e) => {
      var _a;
      if ([
        "Enter",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Escape"
      ].includes(e.key) && isNavigating === true) {
        e.preventDefault();
        e.stopPropagation();
      }
      const navigation = {
        ArrowUp: handleArrowUp,
        ArrowRight: handleArrowRight,
        ArrowDown: handleArrowDown,
        ArrowLeft: handleArrowLeft
      };
      switch (e.key) {
        case "Enter":
          selectItem();
          break;
        case "Escape":
          setIsNavigating(false);
          return;
      }
      const key = e.key;
      const newSelection = (_a = navigation[key]) == null ? void 0 : _a.call(navigation);
      if (newSelection) {
        const selection = { ...selected, ...newSelection };
        setSelected(selection);
        scrollTo(selection);
      }
    },
    [
      isNavigating,
      handleArrowUp,
      handleArrowRight,
      handleArrowDown,
      handleArrowLeft,
      selectItem,
      selected,
      scrollTo
    ]
  );
  React__default.useEffect(() => {
    document.addEventListener("keydown", handleKeyboardNavigation, {
      capture: true
    });
    return () => {
      document.removeEventListener("keydown", handleKeyboardNavigation, {
        capture: true
      });
    };
  }, [handleKeyboardNavigation]);
  return { selected, setSelected, selectItem };
};
const EmojiPanel = React__default.forwardRef(
  ({
    editor,
    range,
    items
  }, _ref) => {
    const [hasResults, setHasResults] = React__default.useState(false);
    const emojiRefs = React__default.useRef([]);
    const categories = apple.categories;
    const searchResults = React__default.useMemo(() => {
      setHasResults(items.length > 0);
      let categoriesWithEmojis = [];
      categories.forEach((category, categoryIndex) => {
        const concernedEmojis = [];
        emojiRefs.current.push([]);
        items.forEach((emoji) => {
          emojiRefs.current[categoryIndex].push(React__default.createRef());
          if (category.emojis.includes(emoji.id || ""))
            concernedEmojis.push(emoji);
        });
        categoriesWithEmojis.push({
          name: category.name,
          emojis: concernedEmojis
        });
      });
      return _.filter(
        categoriesWithEmojis,
        (category) => category.emojis.length > 0
      );
    }, [categories, items]);
    const { selected, setSelected, selectItem } = useNavigation(
      searchResults,
      emojiRefs,
      editor,
      range
    );
    return /* @__PURE__ */ React__default.createElement(StyledContainer, {
      id: "EmojiPanel"
    }, hasResults ? searchResults.map(
      (category, categoryIndex) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(StyledLabel, {
        key: category.name
      }, category.name), /* @__PURE__ */ React__default.createElement(StyledCategory, {
        key: categoryIndex,
        className: "flex flex_wrap"
      }, category.emojis.map(
        (emoji, emojiIndex) => /* @__PURE__ */ React__default.createElement(StyledEmoji, {
          key: emoji.name,
          className: `cursor flex align_center justify_center ${selected.category === categoryIndex && selected.emoji === emojiIndex ? "active" : ""}`,
          onClick: () => selectItem(),
          title: emoji.name,
          onMouseMove: () => setSelected({
            category: categoryIndex,
            emoji: emojiIndex
          }),
          ref: emojiRefs.current[categoryIndex][emojiIndex]
        }, emoji.native)
      )))
    ) : /* @__PURE__ */ React__default.createElement(Box, {
      sx: { color: "text.primary" }
    }, "No results"));
  }
);
const EmojiRenderer = () => {
  let reactRenderer;
  let popup;
  return {
    onStart: (props) => {
      reactRenderer = new PluginViewRenderer(EmojiPanel, {
        editor: props.editor,
        props
      });
      popup = tippy("body", {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: reactRenderer.element,
        showOnCreate: false,
        interactive: true,
        trigger: "manual",
        placement: "bottom-start"
      });
    },
    onUpdate(props) {
      popup == null ? void 0 : popup[0].show();
      reactRenderer == null ? void 0 : reactRenderer.updateProps(props);
      popup == null ? void 0 : popup[0].setProps({
        getReferenceClientRect: props.clientRect
      });
    },
    onKeyDown(props) {
      var _a;
      if (props.event.key === "Escape") {
        popup == null ? void 0 : popup[0].destroy();
      }
      return (_a = reactRenderer == null ? void 0 : reactRenderer.ref) == null ? void 0 : _a.onKeyPress(props);
    },
    onExit(_2) {
      popup == null ? void 0 : popup[0].destroy();
      reactRenderer == null ? void 0 : reactRenderer.destroy();
    }
  };
};
const EmojiExtension = Extension$1.create({
  name: "EmojiExtension",
  addOptions() {
    return {
      suggestion: {
        char: ":",
        items: searchEmojis,
        render: EmojiRenderer,
        startOfLine: false,
        command: ({ editor, range, props }) => {
          props.query(props.query);
          props.command({ editor, range });
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion$2({
        ...this.options.suggestion,
        pluginKey: new PluginKey("emoji"),
        editor: this.editor
      })
    ];
  }
});
const ExtendedMentionNode = (options2) => MentionNode(options2).extend({
  addNodeView() {
    var _a;
    return ReactNodeViewRenderer((_a = options2 == null ? void 0 : options2.mentions) == null ? void 0 : _a.MentionView);
  }
});
const style = ({
  isSpaceBefore
}) => ({
  display: "inline-block",
  marginLeft: isSpaceBefore ? "5px" : "0",
  "& .MuiAutocomplete-inputRoot.MuiInputBase-sizeSmall input.MuiAutocomplete-input": {
    padding: 0,
    fontSize: "1em"
  },
  "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
    width: "168px",
    padding: 0,
    border: "0.5px solid #545454",
    background: "rgba(0, 0, 0, 0.16)",
    borderRadius: "100px",
    fontSize: "1em",
    color: "text.primary",
    pl: "3px"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    display: "none"
  },
  "& .MuiAutocomplete-endAdornment": { display: "none" }
});
const sxPaper = {
  fontSize: "16px",
  color: "rgba(255, 255, 255, 0.9)",
  borderRadius: 2,
  background: "rgba(28, 29, 33, 0.72)",
  backdropFilter: "blur(10px)",
  border: "0.5px solid rgba(255, 255, 255, 0.24)",
  width: "245px!important",
  overflow: "hidden auto",
  boxShadow: "0px 1px 18px #0000001f, 0px 6px 10px #00000024, 0px 3px 5px -1px #00000033",
  "& .MuiAutocomplete-listbox": {
    p: "6px",
    borderRight: "5px solid rgba(28, 29, 33, 0.72)",
    "&::-webkit-scrollbar": {
      width: "4px"
    },
    "::-webkit-scrollbar-track": {
      background: "transparent"
    },
    "::-webkit-scrollbar-thumb": {
      padding: "10px 0",
      margin: "10px 0",
      background: theme.palette.common.black,
      borderBox: "padding-box",
      fontSize: "16px",
      borderRadius: "8px",
      opacity: 0
    },
    "& .MuiAutocomplete-option": {
      p: 0,
      mx: 0,
      width: "100%",
      position: "relative",
      display: "flex",
      alignItems: "center",
      lineHeight: "120%",
      userSelect: "none",
      minHeight: "28px",
      maxHeight: "28px",
      fontSize: "12px",
      cursor: "pointer",
      paddingRight: "3px",
      backgroundColor: "inherit",
      color: "grey.100",
      border: `0.5px solid transparent`,
      "& .list_enter": { display: "none" },
      "&.Mui-focused": {
        color: "grey.50",
        bgcolor: "none",
        border: `0.5px solid #545454`,
        borderRadius: 1.5,
        "&:before": {
          left: -7
        },
        "&>div:first-of-type": {
          minWidth: "90.5%",
          maxWidth: "90.5%"
        },
        "& .list_enter": { display: "flex" }
      },
      "&:last-of-type": { mb: 0 }
    },
    "& .MuiListSubheader-root:not(:empty)": {
      margin: "0",
      color: "#797979ff",
      position: "inherit",
      fontFamily: "Inter-SemiBold",
      fontSize: "0.625rem",
      fontWeight: "600",
      lineHeight: "1rem",
      fontStyle: "inherit",
      letterSpacing: "0.800000011920929px",
      textTransform: "uppercase",
      fontFeatureSettings: "'tnum' on,'lnum' on",
      backgroundColor: "transparent",
      my: 0.5,
      pl: 0.5
    },
    "& li:not(:first-of-type) .MuiListSubheader-root:empty": {
      height: "0.5px",
      background: "rgba(0, 0, 0, 0.4)",
      boxShadow: "0px 0.5px 0px rgba(255, 255, 255, 0.2)",
      my: 1
    }
  }
};
const PADDING_RIGHT_ON_INPUT = 4;
const MINIMUM_LENGTH_FOR_INPUT_WIDTH = 10;
const MENTION_PLACEHOLDER_INPUT_ID = "autocomplete_placeholder_mention";
const getWidth = (length) => {
  return `${length < MINIMUM_LENGTH_FOR_INPUT_WIDTH ? MINIMUM_LENGTH_FOR_INPUT_WIDTH : length / 2 + PADDING_RIGHT_ON_INPUT}em`;
};
const MentionPlaceholderManager = ({ injectedProps, ...props }) => {
  var _a;
  const list = (_a = injectedProps.getList) == null ? void 0 : _a.call(injectedProps);
  if (!list)
    return null;
  return /* @__PURE__ */ React__default.createElement(MentionPlaceholder, {
    ...props,
    injectedProps,
    list
  });
};
const MentionPlaceholder = ({
  node,
  editor,
  getPos,
  injectedProps,
  list
}) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(
    getWidth(node.attrs["placeholder"].length)
  );
  const [value, setValue] = useState(node.attrs.originalValue);
  const isSpaceBefore = node.attrs.char.startsWith(" ");
  const [height, setHeight] = useState(24);
  const measuredRef = useCallback((node2) => {
    setTimeout(() => {
      if (node2 !== null) {
        setHeight(node2.offsetHeight);
      }
    });
  }, []);
  useEffect(function focusTextField() {
    setTimeout(() => {
      var _a;
      (_a = ref.current) == null ? void 0 : _a.focus();
      editor.commands.setMeta(PREVENT_EDITOR_INPUT_PLUGIN, false);
    });
  }, []);
  const handleQuit = useCallback(
    (props) => {
      var _a, _b;
      const pos = getPos();
      if (!pos)
        return;
      editor.chain().focus().deleteRange({ from: pos, to: pos + 1 }).insertContentAt(pos, (_a = props == null ? void 0 : props.valueToInsertInstead) != null ? _a : `${value}`).focus((_b = props == null ? void 0 : props.pos) != null ? _b : pos).run();
    },
    [editor, getPos, value]
  );
  const onKeyDown = useCallback(
    (event) => {
      var _a, _b;
      if (event.key === "Backspace" && !value) {
        event.preventDefault();
        event.stopPropagation();
        handleQuit({
          valueToInsertInstead: node.attrs["char"],
          pos: getPos() + `${node.attrs["char"]}${value}`.length
        });
      } else if (event.key === "ArrowRight" && event.target.selectionStart === value.length) {
        event.preventDefault();
        event.stopPropagation();
        handleQuit({
          pos: getPos() + ((_a = event.target.selectionStart) != null ? _a : 0)
        });
      } else if (event.key === "ArrowLeft" && event.target.selectionStart === 0) {
        event.preventDefault();
        event.stopPropagation();
        handleQuit({ pos: getPos() });
      } else if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        handleQuit({
          pos: getPos() + ((_b = event.target.selectionStart) != null ? _b : 0)
        });
      } else if (event.key === "z" && event.metaKey && (value === void 0 || value === node.attrs.originalValue)) {
        event.preventDefault();
        event.stopPropagation();
        editor.chain().focus().undo().run();
      }
    },
    [editor, getPos, handleQuit, node.attrs, value]
  );
  const handleFieldWidth = useCallback(
    (event, newValue) => {
      var _a;
      if (!event)
        return;
      if (newValue)
        setWidth(getWidth(newValue.length));
      else
        setWidth(getWidth((_a = node.attrs.placeholder) == null ? void 0 : _a.length));
      setValue(newValue);
    },
    [node.attrs.placeholder]
  );
  const handleFilterOption = useCallback(
    (options2, params) => {
      var _a;
      const filter = createFilterOptions({
        stringify: (option) => option[injectedProps.searchField],
        limit: 5
      });
      const filtered = filter(options2, params).map((c) => {
        if (c.type !== "note" && c.type !== "task" && c.type !== "day")
          return c;
        return { ...c, groupBy: "cards" };
      });
      const { inputValue } = params;
      if (inputValue !== "") {
        return [
          ...filtered,
          {
            inputValue,
            [injectedProps.searchField]: inputValue,
            cardUuid: (_a = injectedProps.generateNewMentionId) == null ? void 0 : _a.call(injectedProps),
            groupeBy: ""
          }
        ];
      }
      return filtered;
    },
    [injectedProps]
  );
  const handleOnChange = useCallback(
    (_2, _value) => {
      var _a, _b;
      const chain = editor.chain();
      const pos = getPos();
      chain.focus().deleteRange({
        from: pos,
        to: pos + 1
      });
      if (isSpaceBefore)
        chain.insertContent(" ");
      if (_value.cardUuid)
        chain.setMeta(
          ANALYTICS_META,
          "Create new note from bidirectional link"
        );
      chain.focus(isSpaceBefore ? pos + 1 : pos).insertMention({
        id: _value[injectedProps.fieldMentionId],
        cardUuid: (_a = _value.cardUuid) != null ? _a : _value[injectedProps.fieldMentionId],
        value: (_b = _value.inputValue) != null ? _b : _value.title,
        char: injectedProps.char
      }).run();
    },
    [
      editor,
      getPos,
      injectedProps.char,
      injectedProps.fieldMentionId,
      isSpaceBefore
    ]
  );
  const handleClickAway = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      const keepChar = node.attrs["char"] !== "[[";
      handleQuit({
        valueToInsertInstead: `${keepChar ? node.attrs["char"] : ""}${value}`,
        pos: getPos() + node.attrs["char"].length + event.target.selectionStart
      });
    },
    [getPos, handleQuit, node.attrs, value]
  );
  const ItemList = injectedProps.MentionItemListComponent;
  return /* @__PURE__ */ React__default.createElement(NodeViewWrapper, {
    style: {
      display: "inline-block",
      marginRight: "5px",
      maxWidth: "100%",
      width
    },
    ref: measuredRef,
    "data-value": value
  }, /* @__PURE__ */ React__default.createElement(ClickAwayListener, {
    onClickAway: handleClickAway
  }, /* @__PURE__ */ React__default.createElement(Autocomplete, {
    id: MENTION_PLACEHOLDER_INPUT_ID,
    sx: style({ isSpaceBefore, height }),
    fullWidth: true,
    openOnFocus: true,
    freeSolo: true,
    onInputChange: handleFieldWidth,
    inputValue: value,
    onKeyDown,
    clearIcon: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null),
    autoHighlight: true,
    onChange: handleOnChange,
    color: "action",
    groupBy: (option) => option.groupBy,
    options: list,
    componentsProps: {
      paper: { sx: sxPaper }
    },
    open: true,
    noOptionsText: injectedProps.noOptionsText,
    filterOptions: handleFilterOption,
    renderOption: (props, option) => {
      var _a;
      return /* @__PURE__ */ React__default.createElement(ListItemButton, {
        ...props,
        component: "li",
        key: (_a = option[injectedProps.fieldMentionId]) != null ? _a : option.cardUuid,
        variant: "menu"
      }, ItemList ? /* @__PURE__ */ React__default.createElement(ItemList, {
        item: option
      }) : /* @__PURE__ */ React__default.createElement("p", null, option.title), /* @__PURE__ */ React__default.createElement(Shortcut, {
        keys: "\u21B5",
        className: "list_enter"
      }));
    },
    getOptionLabel: (option) => option.key || "",
    renderInput: (params) => /* @__PURE__ */ React__default.createElement(TextField, {
      inputRef: ref,
      ...params,
      fullWidth: true,
      autoFocus: true,
      placeholder: node.attrs["placeholder"],
      size: "small",
      InputProps: {
        ...params.InputProps,
        startAdornment: /* @__PURE__ */ React__default.createElement(Icon, {
          icon: Icons[injectedProps.icon],
          color: "text.primary"
        })
      }
    })
  })));
};
const WrapperMentionRenderer = (injectedProps) => (props) => {
  return /* @__PURE__ */ React__default.createElement(MentionPlaceholderManager, {
    injectedProps,
    ...props
  });
};
const ExtendedMentionPlaceholderNodes = (options2) => MentionPlaceholderNodes(options2).map(
  (node) => node.extend({
    addNodeView() {
      return ReactNodeViewRenderer(WrapperMentionRenderer(node.options));
    }
  })
);
const ConvertLinkMenuPluginKey = new PluginKey("ConvertLinkMenuPlugin");
const closeConvertLinkMenu = () => ({ dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(closeConvertLinkMenuTransaction(tr));
  return true;
};
const closeConvertLinkMenuTransaction = (tr) => {
  return tr.setMeta(ConvertLinkMenuPluginKey, { isOpen: false });
};
const openConvertLinkMenu = () => ({ dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(openConvertLinkMenuTransaction(tr));
  return true;
};
const openConvertLinkMenuTransaction = (tr) => {
  return tr.setMeta(ConvertLinkMenuPluginKey, { isOpen: true });
};
const useConvertLinkMenuItems = ({
  editor
}) => {
  return useMemo(
    () => [
      {
        text: "Dismiss",
        onAction: (e) => {
          e.preventDefault();
          e.stopPropagation();
          editor.commands.closeConvertLinkMenu();
        }
      },
      {
        text: "Clip content",
        shouldBeHidden: () => {
          const linkPos = editor.state.selection.$anchor.pos - 1;
          const link = getLinkAttributes(editor.state, linkPos);
          return (link == null ? void 0 : link.href) && isUrlOfType("youtube", link.href);
        },
        onAction: (e) => {
          e.preventDefault();
          e.stopPropagation();
          const linkPos = editor.state.selection.$anchor.pos - 1;
          const link = getLinkAttributes(editor.state, linkPos);
          if (!(link == null ? void 0 : link.href))
            return;
          editor.chain().closeConvertLinkMenu().focus(linkPos).extendMarkRange(MarkTypes.LINK).deleteSelection().insertClip({ href: link.href, content: "", contextUuid: "" }).focus().run();
        }
      },
      {
        text: "Convert to YouTube preview",
        shouldBeHidden: () => {
          const linkPos = editor.state.selection.$anchor.pos - 1;
          const link = getLinkAttributes(editor.state, linkPos);
          if (!(link == null ? void 0 : link.href) || !isUrlOfType("youtube", link.href))
            return true;
          else
            return false;
        },
        onAction: (e) => {
          e.preventDefault();
          e.stopPropagation();
          const linkPos = editor.state.selection.$anchor.pos - 1;
          const link = getLinkAttributes(editor.state, linkPos);
          if (!(link == null ? void 0 : link.href))
            return;
          editor.chain().closeConvertLinkMenu().focus(linkPos).extendMarkRange(MarkTypes.LINK).deleteSelection().setIframe({ src: urlMediaParser(link.href) }).focus().run();
        }
      }
    ].filter((item) => {
      var _a;
      return !((_a = item == null ? void 0 : item.shouldBeHidden) == null ? void 0 : _a.call(item));
    }),
    [editor]
  );
};
const StyledMenu = styled(Menu)(({ height = "400px" }) => ({
  "&.MuiPopover-root": {
    height: `${height}px`
  }
}));
const CONVERT_LINK_MENU_ID = "convert-link-menu";
const ConvertLinkMenuContent = ({
  items,
  anchorPosition,
  onClose
}) => {
  const shownItems = items.filter((item) => {
    var _a;
    return !((_a = item.shouldBeHidden) == null ? void 0 : _a.call(item));
  });
  const height = shownItems.length * 30 + 44;
  return /* @__PURE__ */ React__default.createElement(StyledMenu, {
    id: CONVERT_LINK_MENU_ID,
    open: !!anchorPosition,
    anchorReference: "anchorPosition",
    anchorPosition: { top: anchorPosition.y, left: anchorPosition.x },
    height
  }, shownItems.map((item) => /* @__PURE__ */ React__default.createElement(MenuItem, {
    key: item.text,
    onMouseDown: (e) => item.onAction(e),
    onKeyDown: (e) => {
      if (e.key === "Enter")
        return item.onAction(e);
      if (e.key === "ArrowUp")
        return;
      if (e.key === "ArrowDown")
        return;
      onClose();
    }
  }, item.text)));
};
const ConvertLinkMenu = forwardRef(({ editor }, _2) => {
  var _a;
  const { state, view } = editor;
  const href = (_a = getLinkAttributes(state, state.selection.$anchor.pos - 1)) == null ? void 0 : _a.href;
  const items = useConvertLinkMenuItems({ editor });
  const onClose = useCallback(() => {
    editor.commands.closeConvertLinkMenu();
  }, [editor]);
  const getRect = useCallback(() => {
    const { ranges } = state.selection;
    const { from, to } = getFromNToFromRange$1(ranges);
    return posToDOMRect(view, from, to);
  }, [state, view]);
  if (!href)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Tippy, {
    trigger: "manual",
    placement: "right-start",
    showOnCreate: true,
    interactive: true,
    onClickOutside: onClose,
    getReferenceClientRect: getRect,
    appendTo: () => document.getElementById(EDITOR_CONTENT_DOM_ID) || document.body,
    content: /* @__PURE__ */ React__default.createElement(ConvertLinkMenuContent, {
      items,
      onClose,
      anchorPosition: getRect()
    })
  }));
});
const convertLinkMenuRenderer = () => {
  let reactRenderer;
  return {
    onStart: ({ editor, ...props }) => {
      reactRenderer = new PluginViewRenderer(ConvertLinkMenu, {
        editor,
        props: { editor, ...props }
      });
    },
    onUpdate({ editor, ...props }) {
      reactRenderer == null ? void 0 : reactRenderer.updateProps(props);
    },
    onExit() {
      const oldRenderer = reactRenderer;
      setTimeout(() => {
        oldRenderer == null ? void 0 : oldRenderer.destroy();
      }, 0);
      reactRenderer = void 0;
    }
  };
};
const convertLinkMenuPlugin = (editor) => {
  const render = convertLinkMenuRenderer();
  return new Plugin({
    key: ConvertLinkMenuPluginKey,
    state: {
      init() {
        return { isOpen: false };
      },
      apply(tr, pluginState) {
        const action = tr.getMeta(ConvertLinkMenuPluginKey);
        return action != null ? action : pluginState;
      }
    },
    view() {
      return {
        update: (view, prevState) => {
          var _a, _b, _c, _d;
          const prev = (_a = this.key) == null ? void 0 : _a.getState(prevState);
          const next = (_b = this.key) == null ? void 0 : _b.getState(view.state);
          const createRender = !(prev == null ? void 0 : prev.isOpen) && (next == null ? void 0 : next.isOpen);
          const destroyRender = (prev == null ? void 0 : prev.isOpen) && !(next == null ? void 0 : next.isOpen);
          if (createRender)
            (_c = render == null ? void 0 : render.onStart) == null ? void 0 : _c.call(render, { editor });
          if (destroyRender)
            (_d = render == null ? void 0 : render.onExit) == null ? void 0 : _d.call(render);
        }
      };
    }
  });
};
const convertLinkMenuCommands = {
  openConvertLinkMenu,
  closeConvertLinkMenu
};
const convertLinkMenu = {
  plugin: convertLinkMenuPlugin,
  commands: convertLinkMenuCommands
};
const closeEditLinkMenu = () => ({ dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(closeEditLinkMenuTransaction(tr));
  return true;
};
const closeEditLinkMenuTransaction = (tr) => {
  return tr.setMeta(EditLinkMenuPluginKey, { isOpen: false });
};
const openEditLinkMenu = () => ({ dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(openEditLinkMenuTransaction(tr));
  return true;
};
const openEditLinkMenuTransaction = (tr, options2 = {}) => {
  return tr.setMeta(EditLinkMenuPluginKey, { isOpen: true, ...options2 });
};
const toggleEditLinkMenu = () => ({ dispatch, tr, state }) => {
  dispatch == null ? void 0 : dispatch(toggleEditLinkMenuTransaction(state, tr));
  return true;
};
const toggleEditLinkMenuTransaction = (state, tr) => {
  var _a;
  const isOpen = (_a = EditLinkMenuPluginKey.getState(state)) == null ? void 0 : _a.isOpen;
  return tr.setMeta(EditLinkMenuPluginKey, { isOpen: !isOpen });
};
const selectionBgColor = "rgba(0, 0, 0, 0.6)";
const seshatBlock = css`
  --padding-vertical-seshat-block: 3px;
  --padding-horizontal-seshat-block: 2px;
  caret-color: rgba(255, 255, 255, 0.9);

  /** Base style (padding etc.) */
  .${SeshatCssClass.BLOCK} {
    position: relative;

    &:not([type='blockquote']):not([type='highlight']):not([type='highlightNote']):not([type='clipContent']):not([type='clipContentTitle']):not([nodeviewtype='clipBook']):not([nodeviewtype='clipBookmark']):not([type='codeBlock']) {
      margin-top: 1px;
      margin-bottom: 1px;
      padding-top: 1px;
      padding-bottom: 1px;
    }

    .${SeshatCssClass.BLOCK_CONTENT}
      ~ .${SeshatCssClass.BLOCK}:not([type='blockquote']):not([type='highlight']):not([type='highlightNote']):not([type='clipContent']):not([type='codeBlock']):last-child {
      margin-bottom: 0;
    }

    .${SeshatCssClass.BLOCK_CONTENT}
      ~ .${SeshatCssClass.BLOCK}:not([type='blockquote']):not([type='highlight']):not([type='highlightNote']):not([type='clipContent']):not([type='codeBlock']) {
      margin-top: 2px;
    }

    .${SeshatCssClass.CONTENT}, .${SeshatCssClass.CONTENT_NODE_VIEW} {
      width: 100%;
      white-space: pre-wrap;
      word-break: break-word;
      font-size: 1em;
      line-height: 1.6em;
    }

    &[contenteditable='false'] {
      cursor: default;
    }
  }

  /** PARAGRAPH */
  .${SeshatCssClass.BLOCK}[type='paragraph'] {
    padding-top: 1px;
    padding-bottom: 1px;
  }
  /** HEADING */
  .${SeshatCssClass.BLOCK}[type^='heading'] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK_CONTENT} > .${SeshatCssClass.CONTENT} {
    font-weight: 700;
    line-height: 1.3;
    color: inherit;
    fill: inherit;
  }
  .${SeshatCssClass.BLOCK}[type='heading1'] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK_CONTENT} {
    margin-top: 2em;
    & .${SeshatCssClass.CONTENT} {
      font-size: 1.875em;
    }
  }
  .${SeshatCssClass.BLOCK}[type='heading2'] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK_CONTENT} {
    margin-top: 1.4em;
    & .${SeshatCssClass.CONTENT} {
      font-size: 1.5em;
    }
  }
  .${SeshatCssClass.BLOCK}[type='heading3'] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK_CONTENT} {
    margin-top: 1em;
    & .${SeshatCssClass.CONTENT} {
      font-size: 1.25em;
    }
  }
  .${SeshatCssClass.BLOCK}[type='heading4'] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK_CONTENT} > .${SeshatCssClass.CONTENT} {
    font-size: 1em;
  }

  /**
     *  1.
     */
  .${SeshatCssClass.BLOCK} ~ .${SeshatCssClass.BLOCK} {
    &:not([type='numberedList']) {
      counter-reset: orderedListCount;
    }
  }

  .${SeshatCssClass.BLOCK}[type='numberedList'] {
    &:before {
      content: counter(orderedListCount) '.';
    }
    counter-increment: orderedListCount;
  }

  /**
     *  1. > a.
     */
  .${SeshatCssClass.BLOCK}[type='numberedList'] {
    .${SeshatCssClass.BLOCK} ~ .${SeshatCssClass.BLOCK} {
      &:not([type='numberedList']) {
        counter-reset: orderedListCount1;
      }
    }

    .${SeshatCssClass.BLOCK}[type='numberedList'] {
      &:nth-of-type(2) {
        counter-reset: orderedListCount1;
      }
      &:before {
        content: counter(orderedListCount1, lower-alpha) '.';
      }
      counter-increment: orderedListCount1;
    }
  }

  /**
     *  1. > a. > i
     */
  .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList'] {
    .${SeshatCssClass.BLOCK} ~ .${SeshatCssClass.BLOCK} {
      &:not([type='numberedList']) {
        counter-reset: orderedListCount2;
      }
    }

    .${SeshatCssClass.BLOCK}[type='numberedList'] {
      &:nth-of-type(2) {
        counter-reset: orderedListCount2;
      }
      &:before {
        content: counter(orderedListCount2, lower-roman) '.';
      }
      counter-increment: orderedListCount2;
    }
  }

  /**
     *  1. > a. > i. > 1.
     */
  .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList'] {
    .${SeshatCssClass.BLOCK} ~ .${SeshatCssClass.BLOCK} {
      &:not([type='numberedList']) {
        counter-reset: orderedListCount3;
      }
    }

    .${SeshatCssClass.BLOCK}[type='numberedList'] {
      &:nth-of-type(2) {
        counter-reset: orderedListCount3;
      }
      &:before {
        content: counter(orderedListCount3) '.';
      }
      counter-increment: orderedListCount3;
    }
  }

  /**
     *  1. > a. > i. > 1. > a.
     */
  .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList'] {
    .${SeshatCssClass.BLOCK} ~ .${SeshatCssClass.BLOCK} {
      &:not([type='numberedList']) {
        counter-reset: orderedListCount4;
      }
    }

    .${SeshatCssClass.BLOCK}[type='numberedList'] {
      &:nth-of-type(2) {
        counter-reset: orderedListCount4;
      }
      &:before {
        content: counter(orderedListCount4, lower-alpha) '.';
      }
      counter-increment: orderedListCount4;
    }
  }

  /**
     *  1. > a. > i. > 1. > a. > i.
     */
  .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList'] {
    .${SeshatCssClass.BLOCK} ~ .${SeshatCssClass.BLOCK} {
      &:not([type='numberedList']) {
        counter-reset: orderedListCount5;
      }
    }

    .${SeshatCssClass.BLOCK}[type='numberedList'] {
      &:nth-of-type(2) {
        counter-reset: orderedListCount5;
      }
      &:before {
        content: counter(orderedListCount5, lower-roman) '.';
      }
      counter-increment: orderedListCount5;
    }
  }

  /**
     *  1. > a. > i. > 1. > a. > i. > 1.
     */
  .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList']
    .${SeshatCssClass.BLOCK}[type='numberedList'] {
    .${SeshatCssClass.BLOCK} ~ .${SeshatCssClass.BLOCK} {
      &:not([type='numberedList']) {
        counter-reset: orderedListCount6;
      }
    }

    .${SeshatCssClass.BLOCK}[type='numberedList'] {
      &:nth-of-type(2) {
        counter-reset: orderedListCount6;
      }
      &:before {
        content: counter(orderedListCount6) '.';
      }
      counter-increment: orderedListCount6;
    }
  }

  .${SeshatCssClass.BLOCK}[type='numberedList'],
    .${SeshatCssClass.BLOCK}[type='bulletedList'] {
    position: relative;
    padding-left: 20px;
  }
  .${SeshatCssClass.BLOCK}[type='numberedList']
    > .${SeshatCssClass.BLOCK_WRAPPER}
    > .${SeshatCssClass.BLOCK}, .${SeshatCssClass.BLOCK}[type='bulletedList']
    > .${SeshatCssClass.BLOCK_WRAPPER}
    > .${SeshatCssClass.BLOCK} {
    margin-left: 0;
  }
  .${SeshatCssClass.BLOCK}[type='numberedList']:before,
    .${SeshatCssClass.BLOCK}[type='bulletedList']:before {
    vertical-align: top;
    left: 0;
    position: absolute;
    font-size: 1em;
    line-height: 1.5em;
    font-family: -apple-system, system-ui, 'Segoe UI', Helvetica,
      'Apple Color Emoji', Arial, sans-serif, 'Segoe UI Emoji',
      'Segoe UI Symbol';
  }

  .${SeshatCssClass.BLOCK}[type='bulletedList']::before {
    content: '';
    height: 6px;
    display: block;
    padding: 0;
    width: 6px;
    background: currentColor;
    border-radius: 100%;
    top: calc(1.5em / 2 + 3px);
    transform: translateY(-50%);
    left: 5px;
  }
  /** INDENT */
  .${SeshatCssClass.BLOCK}
    > .${SeshatCssClass.BLOCK_WRAPPER}
    > .${SeshatCssClass.BLOCK} {
    margin-left: 1.2em;
  }
  .${SeshatCssClass.BLOCK}[type="clipContent"]
    > .${SeshatCssClass.BLOCK_WRAPPER}
    > .${SeshatCssClass.BLOCK} {
    margin-left: 0;
  }
  .${SeshatCssClass.BLOCK}[type="highlightNote"]
    > .${SeshatCssClass.BLOCK_WRAPPER}
    > .${SeshatCssClass.BLOCK} {
    margin-left: 1.5em;
  }

  .${SeshatCssClass.BLOCK} > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}[type="seshatCardContent"] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK} {
    margin-left: 4em;
    &:last-child {
      margin-bottom: 18px;
    }
  }

  .ProseMirror > .${SeshatCssClass.BLOCK}[type='${BlockTypes.CARD_CONTENT}'] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK} {
    margin-left: 0;
  }

  /** ALIGNMENT */
  .${SeshatCssClass.BLOCK} {
    &[textalign='left'] {
      text-align: left;
    }

    &[textalign='right'] {
      text-align: right;
    }

    &[textalign='center'] {
      text-align: center;
    }

    &[textalign='justify'] {
      text-align: justify;
    }
  }

  /** CODE BLOCK */
  .${SeshatCssClass.BLOCK}[type=${BlockTypes.CODE}] {
    margin: 10px 0px;
    padding: 1em;
    color: #353535;
    background: #1a1b1f;
    border-radius: 2px;
    text-align: left;
    direction: ltr;
    tab-size: 4;
    white-space: pre-wrap;
    font-style: normal;
    min-width: 200px;
    .${SeshatCssClass.CONTENT} {
      font-family: Menlo, -apple-system;
      font-size: 13px;
      color: white;
    }
  }

  /** CLIPS **/
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT}'], .${NodeViewTypes.CLIP_BOOK}, .${NodeViewTypes.CLIP_BOOKMARK} {
    background: linear-gradient(#1f2024, #1f2024) padding-box,
      linear-gradient(
          90deg,
          rgba(217, 217, 217, 0) 0%,
          rgba(217, 217, 217, 36%) 50%,
          rgba(217, 217, 217, 0) 100%
        )
        border-box;
    border: 1px solid transparent;
    filter: drop-shadow(0px 1px 2px rgba(4, 4, 7, 0.25));
    border-radius: 4px;
    padding: 16px 60px 16px 60px;
    box-shadow: 0px 1px 2px rgb(4 4 7 / 25%);
    margin-bottom: 10px;
    overflow: hidden;
    transition: max-height 1s;
    margin-top: 10px;
    margin-bottom: 10px;

    &:hover {
      background: linear-gradient(#1f2024, #1f2024) padding-box,
        linear-gradient(
            90deg,
            rgba(217, 217, 217, 0) 0%,
            rgba(217, 217, 217, 100%) 50%,
            rgba(217, 217, 217, 0) 100%
          )
          border-box;
    }

    &[contenteditable='false']:not([video]) {
      caret-color: transparent;
      cursor: pointer;
      &.selected {
        background: rgba(114, 114, 115, 0.6);
        box-shadow: 0px 0px 3px #ffffff;
        animation: none !important;
      }

      & > .${SeshatCssClass.BLOCK_WRAPPER} {
        max-height: 293px;
        overflow: hidden;
      }

      & > .${SeshatCssClass.BLOCK_WRAPPER} {
        &:after {
          width: 100%;
          height: 100%;
          transition: max-height 1s;
          position: fixed;
          left: 0;
          top: 20px;
          content: '';
          background: linear-gradient(to top, #1f2024, #ffffff00 60%);
          color: #000;
          border-radius: 4px;
          transition: background 0.3s, max-height 0.3s;
        }
      }
    }

    & > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK} {
      &:first-of-type .${SeshatCssClass.BLOCK_CONTENT} {
        margin-top: 0;
      }
    }
  }

  .${NodeViewTypes.CLIP_BOOK}, .${NodeViewTypes.CLIP_BOOKMARK} {
    padding: 10px 26px 10px 26px; // Reset indented style for book clips
  }

  .${SeshatCssClass.BLOCK}.${SeshatCssClass.SELECTED_BLOCK}[type='clipContent'],
  .${SeshatCssClass.BLOCK}.${SeshatCssClass.SELECTED_BLOCK} .${NodeViewTypes.CLIP_BOOK},
  .${SeshatCssClass.BLOCK}.${SeshatCssClass.SELECTED_BLOCK} .${NodeViewTypes.CLIP_BOOKMARK} {
    border: 1px solid rgba(255, 255, 255, 0.48);
  }

  #${LAUNCHER_EDITOR_ID} .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT_TITLE}'] .${SeshatCssClass.CONTENT} {
    font-family: inherit;
    font-weight: 700;
    line-height: 1.3;
    font-size: 1em;
    margin-top: 4px;
    margin-bottom: 8px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 30px);
  }

  .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT}']:not([contenteditable='false']) .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT_TITLE}'] .${SeshatCssClass.CONTENT} {
    font-family: inherit;
    font-weight: 700;
    line-height: 1.3;
    font-size: 1.25em;
    margin-top: 0px;
    margin-bottom: 8px;
    text-align: left;
    max-width: calc(100% - 30px);
  }

  #${LAUNCHER_EDITOR_ID} .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT_TITLE}'] .${SeshatCssClass.CONTENT} .clipContentTitle_author,
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT}']:not([contenteditable='false']) .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT_TITLE}'] .clipContentTitle_author {
    display: none;
  }

  .ProseMirror:not(#${LAUNCHER_EDITOR_ID}) .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT}'][contenteditable='false']:not([video]):not([twitter]) {
    min-height: 280px;
    position: relative;
    > .${SeshatCssClass.BLOCK_WRAPPER} {
      position: absolute;
      top: 0;
      left: 0;
      padding: 32px 60px 16px 60px;
    }
    .${SeshatCssClass.BLOCK}[type="clipContentTitle"]:first-of-type {
      margin-top: 30px !important;
      margin-bottom: 20px;
    }
  }

  .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT}'][contenteditable='false']:not([video]) .${SeshatCssClass.BLOCK}[type='${BlockTypes.CLIP_CONTENT_TITLE}'] .${SeshatCssClass.CONTENT} {
    font-family: GT Super Text;
    font-style: normal;
    font-weight: normal;
    text-align: center;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 40px;
  }

  /** BLOCKQUOTE **/
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCKQUOTE}'] {
    margin: 0 auto;
    > .${SeshatCssClass.BLOCK_WRAPPER}:not(:empty) {
      margin-top: 10px;
      margin-bottom: 10px;
      margin-left: 0.65rem;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        width: 3px;
        height: 100%;
        background: linear-gradient(
          179.99deg,
          #c4c4c4 0%,
          rgba(196, 196, 196, 0) 115.46%
        );
        border-radius: 5rem;
      }

      > .${SeshatCssClass.BLOCK} {
        margin-left: 0;
        &:first-of-type {
          margin-top: 10px;
        }

        &:last-child {
          margin-bottom: 5px;
        }
      }
    }
  }
  /** TOGGLE BLOCKS */
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.TOGGLE_LIST}'], .${SeshatCssClass.BLOCK}[type='${BlockTypes.HIGHLIGHTS}'] {
    &:not(.${SeshatCssClass.BLOCK}[type='${BlockTypes.HIGHLIGHTS}']) {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;

      > :first-of-type {
        margin-right: 10px;
        margin-top: 5px;
      }
    }
    > .${SeshatCssClass.BLOCK_WRAPPER} {
      flex: 1;

      > .${SeshatCssClass.BLOCK} {
        padding-left: 0;
        margin-left: 0;
      }
    }
    &[collapsed='true'] {
      > .${SeshatCssClass.BLOCK_WRAPPER} {
        > .${SeshatCssClass.BLOCK} {
          display: none;
        }
      }
    }

    .${SeshatCssClass.BLOCK}[type^='heading'] > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK_CONTENT} {
      margin-top: 0;
    }
  }

  /** Special rule for launcher where the highlights block decoration should be hidden */
  #${LAUNCHER_EDITOR_ID} .${SeshatCssClass.BLOCK}[type='${BlockTypes.HIGHLIGHTS}'] div[data-highlights-decoration] {
    display: none;
  }

  .${SeshatCssClass.CONTENT} > code {
    border-radius: 2px;
    padding: 0.15em;
    font-family: Menlo;
    font-size: 14px;
    color: rgb(253, 220, 152);
    background: rgb(72, 69, 78);
  }

  /** SESHAT_HIGHLIGHT */
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.HIGHLIGHT}'] {
    margin-bottom: 0.4em;
    > button[data-add-highlight-note] {
      opacity: 0;
      visibility: hidden;
      transition: opacity 175ms ease-out;

      &:hover {
        background-color: rgba(184, 184, 184, 0.1);
      }
    }

    &:hover > button[data-add-highlight-note] {
      opacity: 1;
      visibility: visible;
    }

    > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCKQUOTE}'] {
      padding-left: 0;
      margin-left: 0;
      padding-right: 1.5rem;
    }

    /** For timestamp highlights, the blockquote wrapper is empty. To be able to have a visual block selection nonetheless, we
      * add a fixed height for empty blockquotes and move the timestamp into this height (not ideal, but works). */

    > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCKQUOTE}'] > .${SeshatCssClass.BLOCK_WRAPPER}:empty {
      height: 26px;
    }

    > .highlight_timestamp {
      margin-bottom: -23px;
      & ~ .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCKQUOTE}'] > .${SeshatCssClass.BLOCK_WRAPPER} {
        &:not(:empty) {
          margin-top: 30px;
        }
      }
    }

    > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCKQUOTE}'] > .block_placeholder {
      display: none;
    }

    > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}[type='${BlockTypes.HIGHLIGHT_NOTE}'] {
      padding-left: 0;
      margin-left: 0;
    }
  }

  /** SESHAT_HIGHLIGHT_NOTE */
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.HIGHLIGHT_NOTE}'] {
    &::before {
      content: '';
      position: absolute;
      top: 8px;
      left: 0;
      width: 14px;
      height: 12px;
      background-image: url("data:image/svg+xml, %3Csvg width='14' height='12' viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M7.91499 4.18516L8.85577 3.24032L13.1075 7.47381L8.87406 11.7256L7.92922 10.7848L10.4469 8.25625L3.57648 8.27106C2.10373 8.27424 0.907249 7.08291 0.904072 5.61015L0.892573 0.276832L2.2259 0.273957L2.2374 5.60728C2.23899 6.34366 2.83723 6.93932 3.57361 6.93773L10.6641 6.92245L7.91499 4.18516Z' fill='%23727273' /%3E%3C/svg%3E");
    }
    & > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCKQUOTE}'] {
      margin-left: 1.5em;
    }
  }

  /** SESHAT_CAPTURE */
  [type='${BlockTypes.CAPTURE}'] {
    > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK} {
      margin-left: 0;
    }
  }

  /** SESHAT_CARD_CONTENT */
  [type='${BlockTypes.CARD_CONTENT}'] {
    &:first-of-type:not([cardtype='task']) {
      > .${SeshatCssClass.BLOCK_WRAPPER} {
        > .${SeshatCssClass.BLOCK_CONTENT} > * {
        }
      }
    }

    > :first-of-type {
      float: left;
    }

    &[collapsed='true'] {
      > .${SeshatCssClass.BLOCK_WRAPPER} {
        > .${SeshatCssClass.BLOCK} {
          display: none;
        }
      }
    }

    > .${SeshatCssClass.BLOCK_WRAPPER} {
      > .${SeshatCssClass.BLOCK} {
        clear: both;
      }
    }
  }

  /** SESHAT_FILE */
  .${SeshatCssClass.CONTENT_NODE_VIEW}
    > .node-${NodeViewTypes.FILE}
    .${PreviewFile.IMAGE} {
    width: fit-content;
  }

  /** SESHAT BLOCK LINE */
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCK_LINE}'] {
    > .${SeshatCssClass.BLOCK_WRAPPER} {
      display: flex;
      justify-content: space-between;
    }
    > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK} {
      margin-left: 0;
    }
  }

  /** SESHAT HORIZONTAL RULE */
  .horizontal_rule {
    height: 12px;
    display: flex;
    align-items: center;
    & > div {
      width: 100%;
      height: 1px;
      visibility: visible;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      border-bottom-color: rgba(255, 255, 255, 0.07);
    }
  }

  /** SELECTED SESHAT BLOCKS */
  .${SeshatCssClass.BLOCK}.${SeshatCssClass.SELECTED_BLOCK}:not([nodeviewtype='clipBookmark']):not([nodeviewtype='clipBook']):not([type='clipContent']):not([type='seshatNodeViewContent']),
    .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCK_COLUMN}'].${SeshatCssClass.SELECTED_BLOCK}, .${SeshatCssClass.SELECTED_BLOCK} .${SeshatCssClass.CONTENT_NODE_VIEW} > .horizontal_rule {
    background-color: rgba(0, 0, 0, 1);
    animation: selectionfadein 150ms ease-in;
  }

  .${SeshatCssClass.SELECTED_BLOCK}
    .${SeshatCssClass.CONTENT_NODE_VIEW}
    > .node-${NodeViewTypes.FILE} {
    * .image-wrapper {
      border-radius: 4px;
      border: 1px solid rgba(255, 255, 255, 0.48);

      img {
        border-radius: 4px;
      }
    }
  }

  @keyframes selectionfadein {
    from {
      background-color: transparent;
    }
    to {
      background-color: rgba(0, 0, 0, 1);
    }
  }

  /** Task Editable **/
  .${SeshatCssClass.BLOCK}[type='${BlockTypes.TASK_EDITABLE}'] {
    display: flex;
    align-items: center;

    .${SeshatCssClass.CONTENT} {
      min-width: 1px;
    }
  }
`;
const simulateTextSelectionBackground = (state) => {
  const { $from, $to } = state.selection;
  return DecorationSet.create(state.doc, [
    Decoration.inline($from.pos, $to.pos, {
      style: `background-color: ${selectionBgColor}; padding: 3px 0`
    })
  ]);
};
const useEventHandlers = ({
  editor,
  onRemove,
  onUpdate,
  onCopy
}) => {
  const useMouseHandler = (callback) => useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      callback();
    },
    [callback]
  );
  const useKeyHandler = (callback) => useCallback(
    (e) => {
      const key = keyboardEventToString(e).toLocaleLowerCase();
      if (key === "escape")
        editor.chain().closeEditLinkMenu().focus().run();
      if (key === "enter")
        callback();
    },
    [callback]
  );
  return {
    onMouseRemove: useMouseHandler(onRemove),
    onKeyRemove: useKeyHandler(onRemove),
    onMouseUpdate: useMouseHandler(onUpdate),
    onKeyUpdate: useKeyHandler(onUpdate),
    onMouseCopy: useMouseHandler(onCopy),
    onKeyCopy: useKeyHandler(onCopy)
  };
};
const EditLinkMenuItem = (props) => {
  return /* @__PURE__ */ React__default.createElement(ListItemButton, {
    sx: {
      fontSize: "12px",
      lineHeight: "18px",
      color: "grey.200",
      px: 0.5,
      py: 0,
      minHeight: 28,
      borderRadius: 2,
      border: "1px solid transparent",
      "&:hover": {
        color: "white",
        border: ({ palette }) => `1px solid ${palette.grey["200"]}`,
        bgcolor: ({ palette }) => alpha(palette.background.default, 0.7)
      },
      "&.Mui-focusVisible": {
        color: "white",
        border: ({ palette }) => `1px solid ${palette.grey["200"]}`,
        bgcolor: ({ palette }) => alpha(palette.background.default, 0.7)
      }
    },
    ...props
  }, props.children);
};
const EditLinkMenuContent = ({
  editor,
  autoFocus,
  url,
  setUrl
}) => {
  const handlers = useEventHandlers({
    editor,
    onRemove: () => {
      editor.chain().unsetLink().closeEditLinkMenu().focus().run();
    },
    onUpdate: () => {
      if (url)
        editor.chain().updateLink(url).closeEditLinkMenu().focus().run();
      else
        editor.chain().unsetLink().closeEditLinkMenu().focus().run();
    },
    onCopy: () => {
      if (url)
        ClipboardInterface.copy({ content: url }).finally(() => {
          editor.chain().closeEditLinkMenu().focus().run();
        });
    }
  });
  return /* @__PURE__ */ React__default.createElement(Box, {
    id: "editLinkMenu",
    sx: {
      position: "relative",
      p: "4px",
      borderRadius: "8px",
      backdropFilter: `blur(10px)`,
      background: ({ palette }) => alpha(palette.background.default, 0.7)
    }
  }, /* @__PURE__ */ React__default.createElement(TextField, {
    type: "url",
    autoFocus: autoFocus != null ? autoFocus : true,
    value: url,
    onChange: ({ target }) => setUrl(target.value),
    onKeyDown: handlers.onKeyUpdate,
    placeholder: "Link",
    sx: {
      ".MuiOutlinedInput-root": {
        ".MuiOutlinedInput-input": {
          color: "text.primary",
          height: "28px",
          border: ({ palette }) => `0.5px solid ${palette.grey["300"]}`,
          borderRadius: "4px",
          px: "5px",
          py: "2px"
        },
        "&.Mui-focusVisible, &.Mui-focused fieldset, &:hover fieldset, & fieldset": {
          outline: "none",
          border: ({ palette }) => `0.5px solid ${palette.grey["300"]}`
        }
      }
    }
  }), /* @__PURE__ */ React__default.createElement(List, {
    sx: { pb: 0, pt: "2px", fontSize: "14px" }
  }, url ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(EditLinkMenuItem, {
    onMouseDown: handlers.onMouseRemove,
    onKeyDown: handlers.onKeyRemove
  }, /* @__PURE__ */ React__default.createElement(Typography, null, "Remove link")), /* @__PURE__ */ React__default.createElement(EditLinkMenuItem, {
    onMouseUp: handlers.onMouseCopy,
    onKeyDown: handlers.onKeyCopy
  }, /* @__PURE__ */ React__default.createElement(Typography, null, "Copy link"))) : void 0));
};
const EditLinkMenu = ({
  editor,
  autoFocus
}) => {
  var _a;
  const href = (_a = getLinkAttributes(editor.state)) == null ? void 0 : _a.href;
  const [url, setUrl] = useState(href != null ? href : "");
  useEffect(() => {
    setUrl(href != null ? href : "");
  }, [href]);
  const onClickOutsideTippy = useCallback(
    (_2, e) => {
      const defaultChain = url ? editor.chain().updateLink(url) : editor.chain().unsetLink();
      const style2 = textStylesValues.find((style22) => style22.label === "Link");
      const selector = `[value="${style2 == null ? void 0 : style2.value}"]`;
      const isClickOnBalloonToggle = !!e.target.closest(selector);
      if (isClickOnBalloonToggle)
        defaultChain.run();
      else
        defaultChain.closeEditLinkMenu().run();
    },
    [editor, url]
  );
  const getRect = useCallback(() => {
    const { ranges } = editor.state.selection;
    const { from, to } = getFromNToFromRange$1(ranges);
    return posToDOMRect(editor.view, from, to);
  }, [editor]);
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Tippy, {
    interactive: true,
    showOnCreate: true,
    trigger: "manual",
    placement: "bottom",
    getReferenceClientRect: getRect,
    onClickOutside: onClickOutsideTippy,
    appendTo: document.body,
    content: /* @__PURE__ */ React__default.createElement(EditLinkMenuContent, {
      editor,
      autoFocus,
      url,
      setUrl
    })
  }));
};
const editLinkMenuRenderer = () => {
  let reactRenderer;
  return {
    onStart: ({ editor, ...props }) => {
      reactRenderer = new PluginViewRenderer(EditLinkMenu, {
        editor,
        props: { editor, ...props }
      });
    },
    onUpdate({ editor, ...props }) {
      reactRenderer == null ? void 0 : reactRenderer.updateProps({ editor, ...props });
    },
    onExit() {
      const oldRenderer = reactRenderer;
      setTimeout(() => {
        oldRenderer == null ? void 0 : oldRenderer.destroy();
      }, 0);
      reactRenderer = void 0;
    }
  };
};
const isNextPositionInLink = (state, e) => {
  var _a;
  if (isRangeTextSelected(state))
    return false;
  const pressedKey = keyboardEventToString(e);
  if (pressedKey !== "ArrowLeft" && pressedKey !== "ArrowRight")
    return false;
  const { selection, doc } = state;
  let pos = selection.$from.pos;
  if (pos > 0 && pressedKey === "ArrowLeft")
    pos--;
  if (pos < doc.nodeSize && pressedKey === "ArrowRight")
    pos++;
  const link = getLinkAttributes(state, pos);
  const isOpen = (_a = EditLinkMenuPluginKey.getState(state)) == null ? void 0 : _a.isOpen;
  return !isOpen && (link == null ? void 0 : link.href);
};
const isNextPositionOutsideLink = (state, e) => {
  var _a;
  if (isRangeTextSelected(state))
    return false;
  const pressedKey = keyboardEventToString(e);
  if (pressedKey !== "ArrowLeft" && pressedKey !== "ArrowRight")
    return true;
  const { selection, doc } = state;
  let pos = selection.$from.pos;
  if (pos > 0 && pressedKey === "ArrowLeft")
    pos--;
  if (pos < doc.nodeSize && pressedKey === "ArrowRight")
    pos++;
  const link = getLinkAttributes(state, pos);
  const isOpen = (_a = EditLinkMenuPluginKey.getState(state)) == null ? void 0 : _a.isOpen;
  return isOpen && !(link == null ? void 0 : link.href);
};
const editLinkMenuPlugin = (editor) => {
  const render = editLinkMenuRenderer();
  return new Plugin({
    key: EditLinkMenuPluginKey,
    state: {
      init() {
        return { isOpen: false, autoFocus: void 0 };
      },
      apply(tr, pluginState) {
        var _a;
        const action = tr.getMeta(EditLinkMenuPluginKey);
        return action ? { isOpen: action.isOpen, autoFocus: (_a = action.autoFocus) != null ? _a : void 0 } : pluginState;
      }
    },
    props: {
      handleDOMEvents: {
        keydown({ state, dispatch }, e) {
          if (!(e instanceof KeyboardEvent))
            return false;
          if (isNextPositionInLink(state, e)) {
            const options2 = { autoFocus: false };
            dispatch == null ? void 0 : dispatch(openEditLinkMenuTransaction(state.tr, options2));
          }
          if (isNextPositionOutsideLink(state, e))
            dispatch == null ? void 0 : dispatch(closeEditLinkMenuTransaction(state.tr));
          const isRange = isRangeTextSelected(state);
          const pressedKey = keyboardEventToString(e).toLocaleLowerCase();
          const shortcut = shortcutConfig.link.toLocaleLowerCase();
          if (!isRange || shortcut !== pressedKey)
            return false;
          e.stopPropagation();
          e.preventDefault();
          dispatch == null ? void 0 : dispatch(openEditLinkMenuTransaction(state.tr));
          return true;
        }
      },
      decorations(state) {
        if (!EditLinkMenuPluginKey.getState(state).isOpen)
          return;
        return simulateTextSelectionBackground(state);
      }
    },
    view() {
      return {
        update: ({ state }, prevState) => {
          var _a, _b, _c, _d, _e;
          const prev = (_a = this.key) == null ? void 0 : _a.getState(prevState);
          const next = (_b = this.key) == null ? void 0 : _b.getState(state);
          const createRender = !(prev == null ? void 0 : prev.isOpen) && (next == null ? void 0 : next.isOpen);
          const updateRender = (prev == null ? void 0 : prev.isOpen) && (next == null ? void 0 : next.isOpen);
          const destroyRender = (prev == null ? void 0 : prev.isOpen) && !(next == null ? void 0 : next.isOpen);
          const autoFocus = next == null ? void 0 : next.autoFocus;
          if (createRender)
            (_c = render == null ? void 0 : render.onStart) == null ? void 0 : _c.call(render, { editor, autoFocus });
          if (updateRender)
            (_d = render == null ? void 0 : render.onUpdate) == null ? void 0 : _d.call(render, { editor, autoFocus });
          if (destroyRender)
            (_e = render == null ? void 0 : render.onExit) == null ? void 0 : _e.call(render);
        }
      };
    }
  });
};
const editLinkMenuCommands = {
  closeEditLinkMenu,
  openEditLinkMenu,
  toggleEditLinkMenu
};
const editLinkMenu = {
  plugin: editLinkMenuPlugin,
  commands: editLinkMenuCommands
};
const handleClickedLinkPlugin = () => {
  return new Plugin({
    key: new PluginKey("handleClickedLinkPlugin"),
    props: {
      handleClickOn(view, pos) {
        const link = getLinkAttributes(view.state, pos);
        if (!link)
          return false;
        window.open(link.href, link.target);
        return true;
      }
    }
  });
};
const handlePastedLinkPlugin = (editor) => {
  return new Plugin({
    key: new PluginKey("handlePastedLinkPlugin"),
    props: {
      handlePaste: (view, _event, slice) => {
        var _a;
        const { state } = view;
        const { selection } = state;
        const textContent = buildTextContent(slice);
        if (!textContent)
          return false;
        const href = (_a = findLinkInTextContent(textContent)) == null ? void 0 : _a.href;
        if (!href)
          return false;
        if (!selection.empty || selection.from !== selection.to)
          return editor.chain().setLink({ href }).focus(selection.to).run();
        editor.chain().insertContent(textContent, { updateSelection: true }).setTextSelection({
          from: selection.from,
          to: selection.from + textContent.length
        }).setLink({ href }).focus(selection.from + textContent.length).run();
        asyncOpenConvertLinkMenu(editor);
        const stopPropagatePasteEvent = true;
        return stopPropagatePasteEvent;
      }
    }
  });
};
const buildTextContent = (slice) => {
  let textContent = "";
  slice.content.forEach((node) => {
    textContent += node.textContent;
  });
  return textContent;
};
const findLinkInTextContent = (textContent) => {
  return find(textContent).find(
    (item) => item.isLink && item.value === textContent
  );
};
const asyncOpenConvertLinkMenu = (editor) => {
  setTimeout(() => {
    editor.commands.openConvertLinkMenu();
  }, 0);
};
const HoverLinkMenuPluginKey = new PluginKey("HoverLinkMenuPlugin");
const closeHoverLinkMenu = () => ({ dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(closeHoverLinkMenuTransaction(tr));
  return true;
};
const closeHoverLinkMenuTransaction = (tr) => {
  return tr.setMeta(HoverLinkMenuPluginKey, { isOpen: false, pos: void 0 });
};
const openHoverLinkMenu = ({ pos }) => ({
  dispatch,
  tr
}) => {
  dispatch == null ? void 0 : dispatch(openHoverLinkMenuTransaction(tr, { pos }));
  return true;
};
const openHoverLinkMenuTransaction = (tr, { pos }) => {
  return tr.setMeta(HoverLinkMenuPluginKey, { isOpen: true, pos });
};
const HoverLinkMenuContent = ({
  editor,
  href,
  pos
}) => {
  const onEditClick = useCallback(() => {
    editor.chain().closeHoverLinkMenu().focus(pos).extendMarkRange(MarkTypes.LINK).openEditLinkMenu().run();
  }, [editor, pos]);
  const displayedHref = useMemo(() => {
    return href.length > 20 ? href.substring(0, 20) + "..." : href;
  }, [href]);
  return /* @__PURE__ */ React__default.createElement(PopOverContainer, {
    height: 24,
    sx: {
      width: "182px !important",
      borderRadius: "4px",
      ".popover-container": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: "100%",
        padding: "1px 4px"
      }
    }
  }, /* @__PURE__ */ React__default.createElement(Typography, {
    sx: { fontSize: "12px", lineHeight: "14px" }
  }, displayedHref), /* @__PURE__ */ React__default.createElement(Box, {
    component: "button",
    onClick: onEditClick,
    sx: {
      fontSize: "12px",
      lineHeight: "14px",
      color: "grey.200",
      px: "6px",
      py: "2px",
      borderRadius: "4px",
      border: "1px solid transparent",
      cursor: "pointer",
      bgcolor: ({ palette }) => alpha(palette.background.default, 0.9),
      "&:hover": {
        color: "white",
        border: ({ palette }) => `1px solid ${palette.grey["200"]}`,
        bgcolor: ({ palette }) => alpha(palette.background.default, 0.7)
      },
      "&.Mui-focusVisible": {
        color: "white",
        border: ({ palette }) => `1px solid ${palette.grey["200"]}`,
        bgcolor: ({ palette }) => alpha(palette.background.default, 0.7)
      }
    }
  }, "Edit"));
};
const HoverLinkMenu = ({ editor }) => {
  const { state, view } = editor;
  const { pos } = getPluginStateValue(
    state,
    HoverLinkMenuPluginKey
  );
  const link = getLinkAttributes(state, pos);
  if (!link || !pos)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(Tippy, {
    trigger: "manual",
    placement: "bottom",
    showOnCreate: true,
    interactive: true,
    delay: 1e3,
    getReferenceClientRect: () => posToDOMRect(view, pos, pos),
    offset: [0, 5],
    appendTo: document.body,
    content: /* @__PURE__ */ React__default.createElement(HoverLinkMenuContent, {
      editor,
      pos,
      href: link.href
    })
  }));
};
const hoverLinkMenuRenderer = () => {
  let reactRenderer;
  return {
    onStart: ({ editor, ...props }) => {
      reactRenderer = new PluginViewRenderer(HoverLinkMenu, {
        editor,
        props: { editor, ...props }
      });
    },
    onUpdate({ editor, ...props }) {
      reactRenderer == null ? void 0 : reactRenderer.updateProps(props);
    },
    onExit() {
      const oldRenderer = reactRenderer;
      setTimeout(() => {
        oldRenderer == null ? void 0 : oldRenderer.destroy();
      }, 0);
      reactRenderer = void 0;
    }
  };
};
const hoverLinkMenuPlugin = (editor) => {
  const render = hoverLinkMenuRenderer();
  return new Plugin({
    key: HoverLinkMenuPluginKey,
    state: {
      init() {
        return { isOpen: false, pos: void 0 };
      },
      apply(tr, pluginState) {
        const action = tr.getMeta(HoverLinkMenuPluginKey);
        return action != null ? action : pluginState;
      }
    },
    props: {
      handleDOMEvents: {
        mouseover(view, event) {
          if (!(event instanceof MouseEvent))
            return false;
          const { clientX, clientY } = event;
          const target = view.posAtCoords({ left: clientX, top: clientY });
          if (!target)
            return false;
          const { pos } = target;
          const { state, dispatch } = view;
          const node = view.state.doc.nodeAt(pos);
          const pluginState = HoverLinkMenuPluginKey.getState(state);
          if (!hasLinkMark(node) && pluginState.isOpen)
            dispatch == null ? void 0 : dispatch(closeHoverLinkMenuTransaction(state.tr));
          if (!hasLinkMark(node))
            return false;
          dispatch == null ? void 0 : dispatch(openHoverLinkMenuTransaction(state.tr, { pos }));
          return true;
        }
      }
    },
    view() {
      return {
        update: (view, prevState) => {
          var _a, _b, _c, _d;
          const prev = (_a = this.key) == null ? void 0 : _a.getState(prevState);
          const next = (_b = this.key) == null ? void 0 : _b.getState(view.state);
          const createRender = !(prev == null ? void 0 : prev.isOpen) && (next == null ? void 0 : next.isOpen);
          const destroyRender = (prev == null ? void 0 : prev.isOpen) && !(next == null ? void 0 : next.isOpen);
          if (createRender)
            (_c = render == null ? void 0 : render.onStart) == null ? void 0 : _c.call(render, { editor });
          if (destroyRender)
            (_d = render == null ? void 0 : render.onExit) == null ? void 0 : _d.call(render);
        }
      };
    }
  });
};
const hoverLinkMenuCommands = {
  openHoverLinkMenu,
  closeHoverLinkMenu
};
const hoverLinkMenu = {
  plugin: hoverLinkMenuPlugin,
  commands: hoverLinkMenuCommands
};
const hasLinkMark = (node) => !!node && node.marks.some((mark) => mark.type.name === "link");
const ExtendedLinkMark = LinkMark.extend({
  addCommands() {
    var _a;
    return {
      ...(_a = this.parent) == null ? void 0 : _a.call(this),
      ...convertLinkMenu.commands,
      ...editLinkMenu.commands,
      ...hoverLinkMenu.commands
    };
  },
  addProseMirrorPlugins() {
    return [
      editLinkMenu.plugin(this.editor),
      convertLinkMenu.plugin(this.editor),
      hoverLinkMenu.plugin(this.editor),
      handlePastedLinkPlugin(this.editor),
      handleClickedLinkPlugin()
    ];
  }
});
const SelectHighlightPluginKey = new PluginKey("SelectHighlightPlugin");
const SelectHighlightPlugin = new Plugin({
  key: SelectHighlightPluginKey,
  props: {
    handleClickOn(view, pos) {
      if (!view.state.selection.empty)
        return false;
      const highlight = getHighlightAtPos({
        doc: view.state.doc,
        pos
      });
      if (!highlight || highlight.mark.attrs.color === "inherit")
        return false;
      const tr = view.state.tr;
      const selection = highlight.start === highlight.end ? NodeSelection.create(tr.doc, highlight.start) : TextSelection.create(tr.doc, highlight.start, highlight.end);
      tr.setSelection(selection);
      view.dispatch(openBalloonMenuTransaction(tr));
      return true;
    }
  }
});
const getHighlightAtPos = ({
  doc,
  pos
}) => {
  const $pos = doc.resolve(pos);
  const mark = $pos.marks().find(isHighlightMark);
  if (!mark)
    return void 0;
  const highlightId = mark.attrs[MarkAttrsParams.HIGHLIGHT_UUID];
  const highlightNodes = findChildren$1(
    doc,
    (node) => hasHighlightId(node.marks, highlightId)
  );
  if (!highlightNodes.length)
    return void 0;
  const start = highlightNodes == null ? void 0 : highlightNodes[0].pos;
  const lastNode = highlightNodes == null ? void 0 : highlightNodes[highlightNodes.length - 1];
  const end = lastNode.pos + lastNode.node.nodeSize;
  return { mark, start, end };
};
const hasHighlightId = (marks, id) => {
  var _a, _b;
  return marks && ((_b = (_a = marks.filter(isHighlightMark)) == null ? void 0 : _a[0]) == null ? void 0 : _b.attrs[MarkAttrsParams.HIGHLIGHT_UUID]) === id;
};
const ExtendedHighlightMark = (options2) => HighlightMark.extend({
  addProseMirrorPlugins() {
    return (options2 == null ? void 0 : options2.extensionVersion) === "read_later_view" ? [SelectHighlightPlugin] : [];
  },
  addKeyboardShortcuts() {
    return {
      [shortcutConfig.toggleHighlight]: ({ editor }) => {
        var _a, _b, _c;
        const lastUsedBackgroundColor = SessionStorageInterface.get(
          "lastUsedBackgroundColor"
        );
        const lastColor = (lastUsedBackgroundColor == null ? void 0 : lastUsedBackgroundColor.color) === "inherit" ? void 0 : lastUsedBackgroundColor;
        const color = (_c = (_b = lastColor == null ? void 0 : lastColor.color) != null ? _b : (_a = GroupHighlightColors.find((item) => item.title === "Yellow")) == null ? void 0 : _a.color) != null ? _c : YELLOW;
        return editor.chain().focus().setHighlight({ color }).focus(editor.state.selection.to).run();
      }
    };
  }
});
const editorNodeConfig = {
  ...editorNodeConfig$1,
  [ClipBookBlock.name]: {
    ...editorNodeConfig$1[ClipBookBlock.name],
    extension: ExtendedClipBookBlock
  },
  [ClipBookmarkBlock.name]: {
    ...editorNodeConfig$1[ClipBookmarkBlock.name],
    extension: ExtendedClipBookmarkBlock
  },
  [FileBlock.name]: {
    ...editorNodeConfig$1[FileBlock.name],
    extension: ExtendedFileBlock
  },
  [IFrameBlock.name]: {
    ...editorNodeConfig$1[IFrameBlock.name],
    extension: ExtendedIFrameBlock
  },
  [CardLinkBlock.name]: {
    ...editorNodeConfig$1[CardLinkBlock.name],
    extension: ExtendedCardLinkBlock
  },
  [MentionNode.name]: {
    ...editorNodeConfig$1[MentionNode.name],
    extension: ExtendedMentionNode
  },
  [MentionPlaceholderNodes.name]: {
    ...editorNodeConfig$1[MentionPlaceholderNodes.name],
    extension: ExtendedMentionPlaceholderNodes
  },
  [TableOfContentsBlock.name]: {
    ...editorNodeConfig$1[TableOfContentsBlock.name],
    extension: ExtendedTableOfContentsBlock
  },
  [SeshatBlockNode.name]: {
    ...editorNodeConfig$1[SeshatBlockNode.name],
    extension: ExtendedSeshatBlockNode
  },
  [SeshatWrappingBlockNode.name]: {
    ...editorNodeConfig$1[SeshatWrappingBlockNode.name],
    extension: ExtendedSeshatWrappingBlockNode
  }
};
const editorMarkConfig = {
  ...editorMarkConfig$1,
  [HighlightMark.name]: {
    ...editorMarkConfig$1[HighlightMark.name],
    extension: ExtendedHighlightMark
  },
  [LinkMark.name]: {
    ...editorMarkConfig$1[LinkMark.name],
    extension: ExtendedLinkMark
  }
};
const editorExtensionConfig = {
  ...editorExtensionConfig$1,
  [BalloonMenuExtension.name]: {
    extension: BalloonMenuExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [BlockHandlesExtension.name]: {
    extension: BlockHandlesExtension,
    targetedEditorVersions: ["main"]
  },
  [EmojiExtension.name]: {
    extension: EmojiExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [TrailingMenuExtension.name]: {
    extension: TrailingMenuExtension,
    targetedEditorVersions: ["main"]
  },
  [FontColorExtension.name]: {
    ...editorExtensionConfig$1[FontColorExtension.name],
    extension: ExtendedFontColorExtension
  }
};
const allEditorExtensionConfigs = {
  ...editorNodeConfig,
  ...editorMarkConfig,
  ...editorExtensionConfig
};
const useEditorExtensions = (extensionOptions) => {
  return React__default.useMemo(() => {
    return getEditorExtensions({
      extensionConfigs: allEditorExtensionConfigs,
      extensionOptions: {
        ...extensionOptions,
        wrapperComponentOverrides: getWrapperComponentOverrides(
          extensionOptions
        )
      }
    });
  }, [extensionOptions]);
};
const useEditorConfiguration = ({
  editorId,
  content,
  options: options2
}) => {
  var _a, _b, _c, _d, _e, _f;
  const extensions = useEditorExtensions(options2 == null ? void 0 : options2.extensionConfiguration);
  const onUpdate = debounce(
    (_b = (_a = options2 == null ? void 0 : options2.editorConfiguration) == null ? void 0 : _a.onUpdate) == null ? void 0 : _b.fn,
    (_d = (_c = options2 == null ? void 0 : options2.editorConfiguration) == null ? void 0 : _c.onUpdate) == null ? void 0 : _d.debounceTimeOut
  );
  const updateNode = (_f = (_e = options2 == null ? void 0 : options2.editorConfiguration) == null ? void 0 : _e.onUpdate) == null ? void 0 : _f.updateNodeFn;
  const formattedContent = React__default.useMemo(() => {
    if (typeof content === "string")
      return content;
    return {
      type: "doc",
      content: formatContentCorruptContent(content)
    };
  }, [content]);
  return React__default.useMemo(
    () => {
      var _a2, _b2;
      return {
        extensions,
        autofocus: (_a2 = options2 == null ? void 0 : options2.editorConfiguration) == null ? void 0 : _a2.autofocus,
        useFlushSync: (_b2 = options2 == null ? void 0 : options2.editorConfiguration) == null ? void 0 : _b2.useFlushSync,
        editorProps: {
          attributes: {
            id: editorId
          }
        },
        onUpdate({ editor, transaction }) {
          onUpdate(editor);
          if (!updateNode)
            return;
          const prevDoc = transaction.docs.shift();
          if (!prevDoc)
            return;
          const prevContent = prevDoc == null ? void 0 : prevDoc.toJSON();
          const content2 = editor.state.doc.toJSON();
          const diff = _.differenceWith(
            content2.content[0].content,
            prevContent == null ? void 0 : prevContent.content[0].content,
            _.isEqual
          );
          updateNode(diff);
        },
        onBlur: ({ editor, event }) => {
          var _a3, _b3;
          (_b3 = (_a3 = options2 == null ? void 0 : options2.editorConfiguration) == null ? void 0 : _a3.onBlur) == null ? void 0 : _b3.call(_a3, {
            editor,
            event
          });
        },
        onFocus: ({ editor, event }) => {
          var _a3, _b3;
          (_b3 = (_a3 = options2 == null ? void 0 : options2.editorConfiguration) == null ? void 0 : _a3.onFocus) == null ? void 0 : _b3.call(_a3, {
            editor,
            event
          });
        },
        injectCSS: false,
        onCreate() {
        },
        content: formattedContent
      };
    },
    [
      extensions,
      options2 == null ? void 0 : options2.editorConfiguration,
      editorId,
      formattedContent,
      onUpdate,
      updateNode
    ]
  );
};
const useEditorEventBus = ({
  editorId,
  options: options2
}) => {
  const EventBus = options2 == null ? void 0 : options2.extensionConfiguration.EditorEventBus;
  const handleUpdateContent = useCallback(
    ({
      editor,
      content
    }) => {
      try {
        debug("seshat:seshatEditor")({ type: "update content", content });
        editor.commands.replaceContent({
          emitUpdate: true,
          content: Array.isArray(content) ? formatContentCorruptContent(content) : content
        });
      } catch (e) {
        debug("seshat:seshatEditor")(e);
      }
    },
    []
  );
  const handleUpdateAttrs = useCallback(
    ({ editor, attrs }) => {
      try {
        debug("seshat:seshatEditor")({ type: "update attrs", attrs });
        editor.commands.updateBlockAttributesAt({ pos: 0, attrs });
      } catch (e) {
        debug("seshat:seshatEditor")(e);
      }
    },
    []
  );
  useEffect(
    function connectEventBusOnMount() {
      if (!EventBus)
        return;
      const unsubscribeUpdateContent = EventBus.updateContent.on(
        editorId,
        ({ content }) => {
          const editor = getEditorApi(editorId);
          if (editor)
            handleUpdateContent({ editor, content });
        }
      );
      const unsubscribeUpdateAttrs = EventBus.updateAttrs.on(
        editorId,
        ({ attrs }) => {
          const editor = getEditorApi(editorId);
          if (editor)
            handleUpdateAttrs({ editor, attrs });
        }
      );
      return () => {
        unsubscribeUpdateContent();
        unsubscribeUpdateAttrs();
      };
    },
    [editorId]
  );
};
const styleLauncher = (theme2) => ({
  [`&#${EDITOR_CONTENT_DOM_ID} .${SeshatCssClass.BLOCK}[type="${BlockTypes.CLIP_CONTENT}"]`]: {
    maxHeight: 99,
    [`&:last-of-type`]: {
      marginBottom: 0
    },
    "&[video]": {
      "div:hover .thumbnail": { display: "inherit" }
    },
    [`&[href*="https://twitter.com"]`]: {
      paddingTop: "8px!important",
      paddingBottom: "18px!important",
      background: "linear-gradient(#18181B, #18181B) padding-box,  linear-gradient(90deg, rgba(217, 217, 217, 0) 0%, rgba(217, 217, 217, 36%) 50%,rgba(217, 217, 217, 0) 100%) border-box",
      maxHeight: 166,
      [`& > .${SeshatCssClass.BLOCK_WRAPPER}:before`]: {
        content: "' '",
        width: "474px",
        boxShadow: "0px 2px 4px rgb(4 4 7 / 25%), 0px 8px 24px rgb(4 4 7 / 40%)",
        position: "absolute",
        zIndex: "2",
        bottom: "19px",
        top: "7px",
        borderRadius: "8px"
      },
      "& div.twitterClipButton.no_seshat_propagation": {
        right: "10px"
      },
      [`& .${SeshatCssClass.BLOCK_WRAPPER}:after`]: { display: "none" },
      [`.${SeshatCssClass.BLOCK}[type="${BlockTypes.TWEET}"]`]: {
        borderRadius: "8px",
        background: `linear-gradient(${theme2.palette.grey["500"]}, ${theme2.palette.grey["500"]}) padding-box, linear-gradient(180deg, #B8B8B8 -76.62%, #111213 131.05%) border-box`,
        border: "0.5px solid transparent",
        maxHeight: "115px",
        width: "474.5px",
        margin: "auto",
        display: "none",
        overflow: "hidden",
        fontSize: "14px",
        color: "text.primary",
        padding: "6px 13px!important",
        boxSizing: "border-box",
        "&:nth-of-type(2), &:nth-of-type(3)": {
          position: "absolute!important",
          height: "30px",
          "& > div": { opacity: 0 }
        },
        "&:first-of-type, &:nth-of-type(2), &:nth-of-type(3)": {
          display: "block"
        },
        "&:first-of-type": {
          zIndex: 3,
          paddingTop: "31px!important",
          position: "relative",
          "&:after": {
            content: "' '",
            position: "absolute",
            bottom: "0",
            height: "30%",
            width: "100%",
            left: "0",
            background: "linear-gradient(0deg, " + theme2.palette.grey[500] + ", transparent)"
          }
        },
        "&:nth-of-type(2)": {
          bottom: "12px",
          marginTop: "10px!important",
          marginLeft: "10px!important",
          boxShadow: "0px 2px 4px rgba(4, 4, 7, 0.25), 0px 8px 24px rgba(4, 4, 7, 0.4)",
          width: "455px",
          zIndex: 1,
          opacity: 0.9
        },
        "&:nth-of-type(3)": {
          bottom: "7px",
          marginTop: "20px!important",
          marginLeft: "20px!important",
          width: "435px",
          opacity: 0.5
        },
        [`& > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}`]: {
          marginLeft: 0
        },
        [`& > .${SeshatCssClass.BLOCK_WRAPPER} .${SeshatCssClass.BLOCK}`]: {
          fontSize: "1em"
        }
      }
    }
  }
});
const styleMain = () => ({
  [`& .${SeshatCssClass.BLOCK}[type="${BlockTypes.CLIP_CONTENT}"][href*="https://twitter.com"]`]: {
    background: "red",
    "& .clipContent_twitterUsername, & .clipContent_buttonTwitter": {
      display: "none"
    },
    [`& .${SeshatCssClass.BLOCK}[type="${BlockTypes.TWEET}"]`]: {
      mb: "16px!important",
      [`& > .${SeshatCssClass.BLOCK_WRAPPER} > .${SeshatCssClass.BLOCK}`]: {
        marginLeft: "0!important"
      }
    }
  },
  [`&#seshat_container .${SeshatCssClass.BLOCK}[type="${BlockTypes.CLIP_CONTENT}"][contenteditable='false']`]: {
    fontSize: "14px",
    "&:not([video])": {
      padding: "16px 100px",
      maxHeight: 230
    },
    "&[twitter]": {
      minHeight: 80,
      paddingTop: "60px"
    },
    "&[video]": {
      maxHeight: "inherit",
      [`&>.${SeshatCssClass.BLOCK_WRAPPER}`]: {
        maxHeight: "inherit",
        [`&>div.${SeshatCssClass.BLOCK}[type="${BlockTypes.CLIP_CONTENT_TITLE}"]:first-of-type`]: {
          [`& .clipContentTitle_author`]: {
            display: "none"
          },
          [`& .${SeshatCssClass.CONTENT}`]: {
            fontWeight: "700",
            fontSize: "1.25em",
            lineHeight: "1.75em"
          }
        }
      },
      '&[status="later"]': {
        paddingTop: "50px",
        "iframe, .youtube_player": {
          display: "none"
        },
        "div:hover .thumbnail": { display: "inherit" },
        [`& .${SeshatCssClass.BLOCK}[type="${BlockTypes.CLIP_CONTENT_TITLE}"]:first-of-type`]: {
          marginTop: "10px"
        }
      }
    }
  }
});
const STYLE_FOR_VERSION = {
  launcher: styleLauncher,
  main: styleMain,
  read_later_view: () => ({}),
  inline_editor: () => ({})
};
const sxSeshatCommon = (theme2) => ({
  [`.${SeshatCssClass.CONTENT} a`]: {
    color: "text.secondary",
    borderBottom: `1px solid`,
    borderColor: "text.secondary",
    textDecoration: "none",
    position: "relative",
    cursor: "pointer",
    "&:hover": {
      color: "common.white",
      borderColor: "common.white"
    }
  },
  [`.${SeshatCssClass.CONTENT} img[src*="https://a.slack-edge.com/production-standard-emoji-assets"], .${SeshatCssClass.CONTENT} img[src*="twimg.com/emoji"]`]: {
    maxHeight: "1rem"
  },
  [`&#seshat_container .${SeshatCssClass.BLOCK}[type='${BlockTypes.BLOCKQUOTE}'] >.${SeshatCssClass.BLOCK_WRAPPER} >.${SeshatCssClass.BLOCK}:first-of-type>.${SeshatCssClass.BLOCK_WRAPPER}  > .${SeshatCssClass.BLOCK_CONTENT}`]: {
    marginTop: 0
  },
  "& * ::selection": {
    backgroundColor: alpha$1(theme2.palette.grey[900], 0.6)
  },
  ...sxCodeBlock
});
const sxSeshatEditor = (editorVersion) => (theme2) => {
  if (!editorVersion || !STYLE_FOR_VERSION[editorVersion])
    return sxSeshatCommon(theme2);
  return {
    ...sxSeshatCommon(theme2),
    ...STYLE_FOR_VERSION[editorVersion](theme2)
  };
};
const caretStyle = css`
  .${SeshatCssClass.DROPCURSOR} {
    position: absolute;
    z-index: 50;
    pointer-events: none;
    background: #b5b6ba;
    box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.16),
      0px 0px 4px rgba(255, 255, 255, 0.48),
      inset 0px 0px 8px rgba(255, 255, 255, 0.16),
      inset 0px 0px 4px rgba(255, 255, 255, 0.48);
    border-radius: 100px;
  }
  .ProseMirror-gapcursor {
    display: none;
    pointer-events: none;
    position: absolute;
  }
  .ProseMirror-gapcursor:after {
    content: '';
    display: block;
    position: absolute;
    top: -2px;
    width: 20px;
    border-top: 1px solid black;
    animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
  }
  @keyframes ProseMirror-cursor-blink {
    to {
      visibility: hidden;
    }
  }
  .ProseMirror-hideselection {
    user-select: none !important;
  }
  .ProseMirror-hideselection:not(.ProseMirror) *::selection {
    background: transparent !important;
  }
  .ProseMirror-hideselection:not(.ProseMirror) *::-moz-selection {
    background: transparent !important;
  }
  .ProseMirror-hideselection:not(.ProseMirror) * {
    caret-color: transparent !important;
  }
  .ProseMirror-focused .ProseMirror-gapcursor {
    display: block;
  }
`;
const suggestionStyle = css`
  .items,
  .mention_popover {
    position: relative;
    border-radius: 0.25rem;
    background: var(--elements-borders);
    color: var(--content-light);
    overflow: hidden;
    font-size: 0.9rem;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.1);
  }

  .item {
    display: block;
    width: 100%;
    text-align: left;
    background: transparent;
    border: none;
    padding: 0.2rem 0.5rem;
    &.is-selected,
    &:hover {
      color: var(--content-light);
      background: var(--background-secondary-hover);
    }
  }
`;
const extensionsInsideEditorStyle = css`
  #seshat_container {
    ${seshatBlock};
    ${blockColumnStyle}
  }
`;
const extensionsOutsideEditorStyle = css`
  ${caretStyle};
  ${suggestionStyle};
`;
const globalEditorStyle = css`
  .ProseMirror {
    outline: none;
    color: white;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    white-space: pre-wrap;
  }
  .ProseMirror-selectednode .${SeshatCssClass.BLOCK_CONTENT} {
    background: #6868689f;
    border-radius: 0.25rem;
  }
`;
const GlobalStyle = () => GlobalStyles({
  styles: css`
      // Main Editor style
      ${globalEditorStyle}
      // Extensions
    ${extensionsInsideEditorStyle}
    ${extensionsOutsideEditorStyle};
    `
});
const SeshatStyles = ({
  extensionVersion,
  children,
  editorRef,
  ...props
}) => {
  const sxStyle = useMemo(() => sxSeshatEditor(extensionVersion), [
    extensionVersion
  ]);
  return /* @__PURE__ */ React__default.createElement(Box, {
    id: EDITOR_CONTENT_DOM_ID,
    ...props,
    sx: sxStyle,
    ref: editorRef
  }, children);
};
const getContentForRefresh = ({
  content,
  editorId,
  editorIdFromRefresh,
  contentFromRefresh
}) => {
  if (contentFromRefresh && editorIdFromRefresh && editorIdFromRefresh === editorId)
    return { content: contentFromRefresh, emitUpdate: false };
  return {
    emitUpdate: true,
    content: Array.isArray(content) ? formatContentCorruptContent(content) : content
  };
};
const SeshatEditor = forwardRef(
  ({ content, editorId, options: options2 }, ref) => {
    var _a;
    const editorConfig = useEditorConfiguration({ content, editorId, options: options2 });
    const editor = useEditor(editorConfig, [editorId]);
    useEditorEventBus({ editorId, options: options2 });
    React__default.useImperativeHandle(ref, () => ({
      extensionVersion: options2 == null ? void 0 : options2.extensionConfiguration.extensionVersion,
      refreshEditor: (props) => {
        if (!editor)
          return;
        debug("seshat:seshatEditor")({
          type: "force refresh",
          props,
          content,
          editorId
        });
        const { content: contentFromRefresh, editorId: editorIdFromRefresh } = props != null ? props : {};
        try {
          editor.commands.replaceContent(
            getContentForRefresh({
              contentFromRefresh,
              editorIdFromRefresh,
              content,
              editorId
            })
          );
        } catch (e) {
          debug("seshat:seshatEditor")(e);
        }
      }
    }));
    const editorRef = useRef(null);
    const onFocusEditor = useCallback(
      () => {
        var _a2, _b;
        return (_b = (_a2 = editorRef.current) == null ? void 0 : _a2.querySelector(".ProseMirror")) == null ? void 0 : _b.classList.add("mousetrap");
      },
      [editorRef]
    );
    return /* @__PURE__ */ React__default.createElement(SeshatStyles, {
      editorRef,
      onFocus: onFocusEditor,
      extensionVersion: (_a = options2 == null ? void 0 : options2.extensionConfiguration) == null ? void 0 : _a.extensionVersion
    }, /* @__PURE__ */ React__default.createElement("div", {
      id: "placeholder_container",
      style: { pointerEvents: "none" }
    }), /* @__PURE__ */ React__default.createElement(EditorContent, {
      editor
    }));
  }
);
const wrappingContent = (text) => [
  {
    type: SeshatNodes.WRAPPING_BLOCK,
    attrs: {
      type: BlockTypes.CAPTURE,
      [BlockAttrsParams.BLOCK_UUID]: "112100"
    },
    content: [
      {
        type: SeshatNodes.BLOCK,
        attrs: {
          [BlockAttrsParams.BLOCK_UUID]: "712312",
          type: BlockTypes.PARAGRAPH
        },
        content: [
          {
            type: SeshatNodes.BLOCK_CONTENT,
            content: [
              {
                type: SeshatNodes.CONTENT,
                attrs: {
                  [BlockAttrsParams.BLOCK_UUID]: "3"
                },
                content: text
              }
            ]
          }
        ]
      }
    ]
  }
];
const SeshatInlineEditor = ({ options: options2, editable, content }) => {
  var _a;
  const extensions = useEditorExtensions({
    ...options2.extensionConfiguration,
    extensionVersion: "inline_editor"
  });
  const editor = useEditor({
    extensions,
    editable,
    content: {
      type: "doc",
      content: formatContentCorruptContent(content)
    }
  });
  return /* @__PURE__ */ React__default.createElement(SeshatStyles, {
    extensionVersion: (_a = options2 == null ? void 0 : options2.extensionConfiguration) == null ? void 0 : _a.extensionVersion
  }, /* @__PURE__ */ React__default.createElement(EditorContent, {
    editor
  }));
};
const SeshatInlineEditorInterface = ({ text, content, ...props }) => {
  if (!text && !content)
    return null;
  const finalContent = text ? wrappingContent(text) : content;
  return /* @__PURE__ */ React__default.createElement(SeshatInlineEditor, {
    ...props,
    content: finalContent
  });
};
const useEditorApi = (editorNodeID) => {
  const [editorApi, setEditorApi] = React__default.useState(
    void 0
  );
  React__default.useEffect(() => {
    const api = getEditorApi(editorNodeID);
    if (api) {
      setEditorApi(api);
    } else {
      observe({
        editorNodeID,
        setEditorApi,
        nodeToObserve: document.body
      });
    }
  }, [editorNodeID]);
  return editorApi;
};
const observe = ({ nodeToObserve, editorNodeID, setEditorApi }) => {
  let observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (!mutation.addedNodes)
        return;
      const editorNodeCreated = Array.from(mutation.addedNodes).find(
        (node) => {
          return (node == null ? void 0 : node.id) === editorNodeID;
        }
      );
      if (editorNodeCreated) {
        setEditorApi(editorNodeCreated.editor);
        observer.disconnect();
      }
    });
  });
  observer.observe(nodeToObserve, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
  setTimeout(() => {
    observer.disconnect();
  }, 2e4);
};
export { BalloonMenuExtension, BlockColumn, BlockHandlesExtension, Blockquote, CONVERT_LINK_MENU_ID, CardTitleRender, ClipContentLauncher, ClipContentMainApp, ClipContentTitle, ClipEditableIcon, ClipReadIcon, ClipReadLaterIcon, CodeBlock, DRAG_HANDLE_SELECTOR, EmojiExtension, ExtendedCardLinkBlock, ExtendedClipBookBlock, ExtendedClipBookmarkBlock, ExtendedFileBlock, ExtendedFontColorExtension, ExtendedHighlightMark, ExtendedIFrameBlock, ExtendedLinkMark, ExtendedMentionNode, ExtendedMentionPlaceholderNodes, ExtendedTableOfContentsBlock, Highlight, HighlightCount, HighlightCountButton, HighlightCountButtonClip, Highlights, MENTION_PLACEHOLDER_INPUT_ID, PLACEHOLDER_PLUGIN_KEY, PlaceholderBallon, PlaceholderBallonPlugin, PlaceholderBallonView, PreventDraggingPlugin, ReadLaterButton, ReadLaterButtonWithMenu, ReadLaterMenu, SeshatEditor, GlobalStyle as SeshatGlobalStyle, SeshatInlineEditorInterface as SeshatInlineEditor, SeshatStyles, TrailingMenuExtension, TrailingMenuPluginKey, allEditorExtensionConfigs, blockColumnStyle, editorExtensionConfig, editorMarkConfig, editorNodeConfig, getMin, getWrapperComponentOverrides, registerSuggestion, seshatBlockComponents, seshatWrappingBlockComponents, sxCodeBlock, useEditorApi, useEditorConfiguration, useEditorExtensions, useHighlightsBlockSyncOnMount };
